/**
* plotly.js (hifi - minified) v2.5.1
* Copyright 2012-2021, Plotly, Inc.
* All rights reserved.
* Licensed under the MIT license
*/
!function (e) {
  if ("object" == typeof exports && "undefined" != typeof module) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
    ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).Plotly = e();
  }
}(function () {
  return function e(t, r, n) {
    function a(o, l) {
      if (!r[o]) {
        if (!t[o]) {
          var s = "function" == typeof require && require;
          if (!l && s) return s(o, !0);
          if (i) return i(o, !0);
          var c = new Error("Cannot find module '" + o + "'");
          throw c.code = "MODULE_NOT_FOUND", c;
        }
        var u = r[o] = {
          exports: {}
        };
        t[o][0].call(u.exports, function (e) {
          return a(t[o][1][e] || e);
        }, u, u.exports, e, t, r, n);
      }
      return r[o].exports;
    }
    for (var i = "function" == typeof require && require, o = 0; o < n.length; o++) a(n[o]);
    return a;
  }({
    1: [function (e, t, r) {
      "use strict";

      var n = e("../src/lib"),
        a = {
          "X,X div": 'direction:ltr;font-family:"Open Sans",verdana,arial,sans-serif;margin:0;padding:0;',
          "X input,X button": 'font-family:"Open Sans",verdana,arial,sans-serif;',
          "X input:focus,X button:focus": "outline:none;",
          "X a": "text-decoration:none;",
          "X a:hover": "text-decoration:none;",
          "X .crisp": "shape-rendering:crispEdges;",
          "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
          "X svg": "overflow:hidden;",
          "X svg a": "fill:#447adb;",
          "X svg a:hover": "fill:#3c6dc5;",
          "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
          "X .main-svg .draglayer": "pointer-events:all;",
          "X .cursor-default": "cursor:default;",
          "X .cursor-pointer": "cursor:pointer;",
          "X .cursor-crosshair": "cursor:crosshair;",
          "X .cursor-move": "cursor:move;",
          "X .cursor-col-resize": "cursor:col-resize;",
          "X .cursor-row-resize": "cursor:row-resize;",
          "X .cursor-ns-resize": "cursor:ns-resize;",
          "X .cursor-ew-resize": "cursor:ew-resize;",
          "X .cursor-sw-resize": "cursor:sw-resize;",
          "X .cursor-s-resize": "cursor:s-resize;",
          "X .cursor-se-resize": "cursor:se-resize;",
          "X .cursor-w-resize": "cursor:w-resize;",
          "X .cursor-e-resize": "cursor:e-resize;",
          "X .cursor-nw-resize": "cursor:nw-resize;",
          "X .cursor-n-resize": "cursor:n-resize;",
          "X .cursor-ne-resize": "cursor:ne-resize;",
          "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
          "X .modebar": "position:absolute;top:2px;right:2px;",
          "X .ease-bg": "-webkit-transition:background-color .3s ease 0s;-moz-transition:background-color .3s ease 0s;-ms-transition:background-color .3s ease 0s;-o-transition:background-color .3s ease 0s;transition:background-color .3s ease 0s;",
          "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity .3s ease 0s;-moz-transition:opacity .3s ease 0s;-ms-transition:opacity .3s ease 0s;-o-transition:opacity .3s ease 0s;transition:opacity .3s ease 0s;",
          "X:hover .modebar--hover .modebar-group": "opacity:1;",
          "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
          "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
          "X .modebar-btn svg": "position:relative;top:2px;",
          "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
          "X .modebar.vertical svg": "top:-1px;",
          "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
          "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
          "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
          "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
          "X [data-title]:before": 'content:"";position:absolute;background:transparent;border:6px solid transparent;z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;',
          "X [data-title]:after": "content:attr(data-title);background:#69738a;color:#fff;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
          "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
          "X .vertical [data-title]:before": "border:6px solid transparent;border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
          "X .select-outline": "fill:none;stroke-width:1;shape-rendering:crispEdges;",
          "X .select-outline-1": "stroke:#fff;",
          "X .select-outline-2": "stroke:#000;stroke-dasharray:2px 2px;",
          Y: 'font-family:"Open Sans",verdana,arial,sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;',
          "Y p": "margin:0;",
          "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
          "Y .notifier-close": "color:#fff;opacity:.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
          "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
        };
      for (var i in a) {
        var o = i.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier");
        n.addStyleRule(o, a[i]);
      }
    }, {
      "../src/lib": 225
    }],
    2: [function (e, t, r) {
      "use strict";

      t.exports = e("../src/components/calendars");
    }, {
      "../src/components/calendars": 94
    }],
    3: [function (e, t, r) {
      "use strict";

      t.exports = e("../src/core");
    }, {
      "../src/core": 207
    }],
    4: [function (e, t, r) {
      "use strict";

      t.exports = e("../src/traces/heatmap");
    }, {
      "../src/traces/heatmap": 327
    }],
    5: [function (e, t, r) {
      "use strict";

      var n = e("./core");
      n.register([e("./heatmap"), e("./calendars")]), t.exports = n;
    }, {
      "./calendars": 2,
      "./core": 3,
      "./heatmap": 4
    }],
    6: [function (e, t, r) {
      (function () {
        var e = {
            version: "3.8.0"
          },
          r = [].slice,
          n = function n(e) {
            return r.call(e);
          },
          a = self.document;
        function i(e) {
          return e && (e.ownerDocument || e.document || e).documentElement;
        }
        function o(e) {
          return e && (e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView);
        }
        if (a) try {
          n(a.documentElement.childNodes)[0].nodeType;
        } catch (e) {
          n = function n(e) {
            for (var t = e.length, r = new Array(t); t--;) r[t] = e[t];
            return r;
          };
        }
        if (Date.now || (Date.now = function () {
          return +new Date();
        }), a) try {
          a.createElement("DIV").style.setProperty("opacity", 0, "");
        } catch (e) {
          var l = this.Element.prototype,
            s = l.setAttribute,
            c = l.setAttributeNS,
            u = this.CSSStyleDeclaration.prototype,
            d = u.setProperty;
          l.setAttribute = function (e, t) {
            s.call(this, e, t + "");
          }, l.setAttributeNS = function (e, t, r) {
            c.call(this, e, t, r + "");
          }, u.setProperty = function (e, t, r) {
            d.call(this, e, t + "", r);
          };
        }
        function f(e, t) {
          return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
        }
        function h(e) {
          return null === e ? NaN : +e;
        }
        function p(e) {
          return !isNaN(e);
        }
        function g(e) {
          return {
            left: function left(t, r, n, a) {
              for (arguments.length < 3 && (n = 0), arguments.length < 4 && (a = t.length); n < a;) {
                var i = n + a >>> 1;
                e(t[i], r) < 0 ? n = i + 1 : a = i;
              }
              return n;
            },
            right: function right(t, r, n, a) {
              for (arguments.length < 3 && (n = 0), arguments.length < 4 && (a = t.length); n < a;) {
                var i = n + a >>> 1;
                e(t[i], r) > 0 ? a = i : n = i + 1;
              }
              return n;
            }
          };
        }
        e.ascending = f, e.descending = function (e, t) {
          return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
        }, e.min = function (e, t) {
          var r,
            n,
            a = -1,
            i = e.length;
          if (1 === arguments.length) {
            for (; ++a < i;) if (null != (n = e[a]) && n >= n) {
              r = n;
              break;
            }
            for (; ++a < i;) null != (n = e[a]) && r > n && (r = n);
          } else {
            for (; ++a < i;) if (null != (n = t.call(e, e[a], a)) && n >= n) {
              r = n;
              break;
            }
            for (; ++a < i;) null != (n = t.call(e, e[a], a)) && r > n && (r = n);
          }
          return r;
        }, e.max = function (e, t) {
          var r,
            n,
            a = -1,
            i = e.length;
          if (1 === arguments.length) {
            for (; ++a < i;) if (null != (n = e[a]) && n >= n) {
              r = n;
              break;
            }
            for (; ++a < i;) null != (n = e[a]) && n > r && (r = n);
          } else {
            for (; ++a < i;) if (null != (n = t.call(e, e[a], a)) && n >= n) {
              r = n;
              break;
            }
            for (; ++a < i;) null != (n = t.call(e, e[a], a)) && n > r && (r = n);
          }
          return r;
        }, e.extent = function (e, t) {
          var r,
            n,
            a,
            i = -1,
            o = e.length;
          if (1 === arguments.length) {
            for (; ++i < o;) if (null != (n = e[i]) && n >= n) {
              r = a = n;
              break;
            }
            for (; ++i < o;) null != (n = e[i]) && (r > n && (r = n), a < n && (a = n));
          } else {
            for (; ++i < o;) if (null != (n = t.call(e, e[i], i)) && n >= n) {
              r = a = n;
              break;
            }
            for (; ++i < o;) null != (n = t.call(e, e[i], i)) && (r > n && (r = n), a < n && (a = n));
          }
          return [r, a];
        }, e.sum = function (e, t) {
          var r,
            n = 0,
            a = e.length,
            i = -1;
          if (1 === arguments.length) for (; ++i < a;) p(r = +e[i]) && (n += r);else for (; ++i < a;) p(r = +t.call(e, e[i], i)) && (n += r);
          return n;
        }, e.mean = function (e, t) {
          var r,
            n = 0,
            a = e.length,
            i = -1,
            o = a;
          if (1 === arguments.length) for (; ++i < a;) p(r = h(e[i])) ? n += r : --o;else for (; ++i < a;) p(r = h(t.call(e, e[i], i))) ? n += r : --o;
          if (o) return n / o;
        }, e.quantile = function (e, t) {
          var r = (e.length - 1) * t + 1,
            n = Math.floor(r),
            a = +e[n - 1],
            i = r - n;
          return i ? a + i * (e[n] - a) : a;
        }, e.median = function (t, r) {
          var n,
            a = [],
            i = t.length,
            o = -1;
          if (1 === arguments.length) for (; ++o < i;) p(n = h(t[o])) && a.push(n);else for (; ++o < i;) p(n = h(r.call(t, t[o], o))) && a.push(n);
          if (a.length) return e.quantile(a.sort(f), .5);
        }, e.variance = function (e, t) {
          var r,
            n,
            a = e.length,
            i = 0,
            o = 0,
            l = -1,
            s = 0;
          if (1 === arguments.length) for (; ++l < a;) p(r = h(e[l])) && (o += (n = r - i) * (r - (i += n / ++s)));else for (; ++l < a;) p(r = h(t.call(e, e[l], l))) && (o += (n = r - i) * (r - (i += n / ++s)));
          if (s > 1) return o / (s - 1);
        }, e.deviation = function () {
          var t = e.variance.apply(this, arguments);
          return t ? Math.sqrt(t) : t;
        };
        var m = g(f);
        function y(e) {
          return e.length;
        }
        e.bisectLeft = m.left, e.bisect = e.bisectRight = m.right, e.bisector = function (e) {
          return g(1 === e.length ? function (t, r) {
            return f(e(t), r);
          } : e);
        }, e.shuffle = function (e, t, r) {
          (i = arguments.length) < 3 && (r = e.length, i < 2 && (t = 0));
          for (var n, a, i = r - t; i;) a = Math.random() * i-- | 0, n = e[i + t], e[i + t] = e[a + t], e[a + t] = n;
          return e;
        }, e.permute = function (e, t) {
          for (var r = t.length, n = new Array(r); r--;) n[r] = e[t[r]];
          return n;
        }, e.pairs = function (e) {
          for (var t = 0, r = e.length - 1, n = e[0], a = new Array(r < 0 ? 0 : r); t < r;) a[t] = [n, n = e[++t]];
          return a;
        }, e.transpose = function (t) {
          if (!(i = t.length)) return [];
          for (var r = -1, n = e.min(t, y), a = new Array(n); ++r < n;) for (var i, o = -1, l = a[r] = new Array(i); ++o < i;) l[o] = t[o][r];
          return a;
        }, e.zip = function () {
          return e.transpose(arguments);
        }, e.keys = function (e) {
          var t = [];
          for (var r in e) t.push(r);
          return t;
        }, e.values = function (e) {
          var t = [];
          for (var r in e) t.push(e[r]);
          return t;
        }, e.entries = function (e) {
          var t = [];
          for (var r in e) t.push({
            key: r,
            value: e[r]
          });
          return t;
        }, e.merge = function (e) {
          for (var t, r, n, a = e.length, i = -1, o = 0; ++i < a;) o += e[i].length;
          for (r = new Array(o); --a >= 0;) for (t = (n = e[a]).length; --t >= 0;) r[--o] = n[t];
          return r;
        };
        var v = Math.abs;
        function x(e) {
          for (var t = 1; e * t % 1;) t *= 10;
          return t;
        }
        function b(e, t) {
          for (var r in t) Object.defineProperty(e.prototype, r, {
            value: t[r],
            enumerable: !1
          });
        }
        function _() {
          this._ = Object.create(null);
        }
        e.range = function (e, t, r) {
          if (arguments.length < 3 && (r = 1, arguments.length < 2 && (t = e, e = 0)), (t - e) / r == 1 / 0) throw new Error("infinite range");
          var n,
            a = [],
            i = x(v(r)),
            o = -1;
          if (e *= i, t *= i, (r *= i) < 0) for (; (n = e + r * ++o) > t;) a.push(n / i);else for (; (n = e + r * ++o) < t;) a.push(n / i);
          return a;
        }, e.map = function (e, t) {
          var r = new _();
          if (e instanceof _) e.forEach(function (e, t) {
            r.set(e, t);
          });else if (Array.isArray(e)) {
            var n,
              a = -1,
              i = e.length;
            if (1 === arguments.length) for (; ++a < i;) r.set(a, e[a]);else for (; ++a < i;) r.set(t.call(e, n = e[a], a), n);
          } else for (var o in e) r.set(o, e[o]);
          return r;
        };
        function w(e) {
          return "__proto__" == (e += "") || "\0" === e[0] ? "\0" + e : e;
        }
        function M(e) {
          return "\0" === (e += "")[0] ? e.slice(1) : e;
        }
        function T(e) {
          return w(e) in this._;
        }
        function k(e) {
          return (e = w(e)) in this._ && delete this._[e];
        }
        function A() {
          var e = [];
          for (var t in this._) e.push(M(t));
          return e;
        }
        function L() {
          var e = 0;
          for (var t in this._) ++e;
          return e;
        }
        function D() {
          for (var e in this._) return !1;
          return !0;
        }
        function S() {
          this._ = Object.create(null);
        }
        function C(e) {
          return e;
        }
        function O(e, t, r) {
          return function () {
            var n = r.apply(t, arguments);
            return n === t ? e : n;
          };
        }
        function P(e, t) {
          if (t in e) return t;
          t = t.charAt(0).toUpperCase() + t.slice(1);
          for (var r = 0, n = I.length; r < n; ++r) {
            var a = I[r] + t;
            if (a in e) return a;
          }
        }
        b(_, {
          has: T,
          get: function get(e) {
            return this._[w(e)];
          },
          set: function set(e, t) {
            return this._[w(e)] = t;
          },
          remove: k,
          keys: A,
          values: function values() {
            var e = [];
            for (var t in this._) e.push(this._[t]);
            return e;
          },
          entries: function entries() {
            var e = [];
            for (var t in this._) e.push({
              key: M(t),
              value: this._[t]
            });
            return e;
          },
          size: L,
          empty: D,
          forEach: function forEach(e) {
            for (var t in this._) e.call(this, M(t), this._[t]);
          }
        }), e.nest = function () {
          var t,
            r,
            n = {},
            a = [],
            i = [];
          function o(e, i, l) {
            if (l >= a.length) return r ? r.call(n, i) : t ? i.sort(t) : i;
            for (var s, c, u, d, f = -1, h = i.length, p = a[l++], g = new _(); ++f < h;) (d = g.get(s = p(c = i[f]))) ? d.push(c) : g.set(s, [c]);
            return e ? (c = e(), u = function u(t, r) {
              c.set(t, o(e, r, l));
            }) : (c = {}, u = function u(t, r) {
              c[t] = o(e, r, l);
            }), g.forEach(u), c;
          }
          return n.map = function (e, t) {
            return o(t, e, 0);
          }, n.entries = function (t) {
            return function e(t, r) {
              if (r >= a.length) return t;
              var n = [],
                o = i[r++];
              return t.forEach(function (t, a) {
                n.push({
                  key: t,
                  values: e(a, r)
                });
              }), o ? n.sort(function (e, t) {
                return o(e.key, t.key);
              }) : n;
            }(o(e.map, t, 0), 0);
          }, n.key = function (e) {
            return a.push(e), n;
          }, n.sortKeys = function (e) {
            return i[a.length - 1] = e, n;
          }, n.sortValues = function (e) {
            return t = e, n;
          }, n.rollup = function (e) {
            return r = e, n;
          }, n;
        }, e.set = function (e) {
          var t = new S();
          if (e) for (var r = 0, n = e.length; r < n; ++r) t.add(e[r]);
          return t;
        }, b(S, {
          has: T,
          add: function add(e) {
            return this._[w(e += "")] = !0, e;
          },
          remove: k,
          values: A,
          size: L,
          empty: D,
          forEach: function forEach(e) {
            for (var t in this._) e.call(this, M(t));
          }
        }), e.behavior = {}, e.rebind = function (e, t) {
          for (var r, n = 1, a = arguments.length; ++n < a;) e[r = arguments[n]] = O(e, t, t[r]);
          return e;
        };
        var I = ["webkit", "ms", "moz", "Moz", "o", "O"];
        function z() {}
        function R() {}
        function N(e) {
          var t = [],
            r = new _();
          function n() {
            for (var r, n = t, a = -1, i = n.length; ++a < i;) (r = n[a].on) && r.apply(this, arguments);
            return e;
          }
          return n.on = function (n, a) {
            var i,
              o = r.get(n);
            return arguments.length < 2 ? o && o.on : (o && (o.on = null, t = t.slice(0, i = t.indexOf(o)).concat(t.slice(i + 1)), r.remove(n)), a && t.push(r.set(n, {
              on: a
            })), e);
          }, n;
        }
        function F() {
          e.event.preventDefault();
        }
        function E() {
          for (var t, r = e.event; t = r.sourceEvent;) r = t;
          return r;
        }
        function j(t) {
          for (var r = new R(), n = 0, a = arguments.length; ++n < a;) r[arguments[n]] = N(r);
          return r.of = function (n, a) {
            return function (i) {
              try {
                var o = i.sourceEvent = e.event;
                i.target = t, e.event = i, r[i.type].apply(n, a);
              } finally {
                e.event = o;
              }
            };
          }, r;
        }
        e.dispatch = function () {
          for (var e = new R(), t = -1, r = arguments.length; ++t < r;) e[arguments[t]] = N(e);
          return e;
        }, R.prototype.on = function (e, t) {
          var r = e.indexOf("."),
            n = "";
          if (r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), e) return arguments.length < 2 ? this[e].on(n) : this[e].on(n, t);
          if (2 === arguments.length) {
            if (null == t) for (e in this) this.hasOwnProperty(e) && this[e].on(n, null);
            return this;
          }
        }, e.event = null, e.requote = function (e) {
          return e.replace(H, "\\$&");
        };
        var H = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g,
          B = {}.__proto__ ? function (e, t) {
            e.__proto__ = t;
          } : function (e, t) {
            for (var r in t) e[r] = t[r];
          };
        function Y(e) {
          return B(e, G), e;
        }
        var U = function U(e, t) {
            return t.querySelector(e);
          },
          V = function V(e, t) {
            return t.querySelectorAll(e);
          },
          _q = function q(e, t) {
            var r = e.matches || e[P(e, "matchesSelector")];
            return (_q = function q(e, t) {
              return r.call(e, t);
            })(e, t);
          };
        "function" == typeof Sizzle && (U = function U(e, t) {
          return Sizzle(e, t)[0] || null;
        }, V = Sizzle, _q = Sizzle.matchesSelector), e.selection = function () {
          return e.select(a.documentElement);
        };
        var G = e.selection.prototype = [];
        function Z(e) {
          return "function" == typeof e ? e : function () {
            return U(e, this);
          };
        }
        function W(e) {
          return "function" == typeof e ? e : function () {
            return V(e, this);
          };
        }
        G.select = function (e) {
          var t,
            r,
            n,
            a,
            i = [];
          e = Z(e);
          for (var o = -1, l = this.length; ++o < l;) {
            i.push(t = []), t.parentNode = (n = this[o]).parentNode;
            for (var s = -1, c = n.length; ++s < c;) (a = n[s]) ? (t.push(r = e.call(a, a.__data__, s, o)), r && "__data__" in a && (r.__data__ = a.__data__)) : t.push(null);
          }
          return Y(i);
        }, G.selectAll = function (e) {
          var t,
            r,
            a = [];
          e = W(e);
          for (var i = -1, o = this.length; ++i < o;) for (var l = this[i], s = -1, c = l.length; ++s < c;) (r = l[s]) && (a.push(t = n(e.call(r, r.__data__, s, i))), t.parentNode = r);
          return Y(a);
        };
        var J = "http://www.w3.org/1999/xhtml",
          X = {
            svg: "http://www.w3.org/2000/svg",
            xhtml: J,
            xlink: "http://www.w3.org/1999/xlink",
            xml: "http://www.w3.org/XML/1998/namespace",
            xmlns: "http://www.w3.org/2000/xmlns/"
          };
        function Q(t, r) {
          return t = e.ns.qualify(t), null == r ? t.local ? function () {
            this.removeAttributeNS(t.space, t.local);
          } : function () {
            this.removeAttribute(t);
          } : "function" == typeof r ? t.local ? function () {
            var e = r.apply(this, arguments);
            null == e ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, e);
          } : function () {
            var e = r.apply(this, arguments);
            null == e ? this.removeAttribute(t) : this.setAttribute(t, e);
          } : t.local ? function () {
            this.setAttributeNS(t.space, t.local, r);
          } : function () {
            this.setAttribute(t, r);
          };
        }
        function K(e) {
          return e.trim().replace(/\s+/g, " ");
        }
        function $(t) {
          return new RegExp("(?:^|\\s+)" + e.requote(t) + "(?:\\s+|$)", "g");
        }
        function ee(e) {
          return (e + "").trim().split(/^|\s+/);
        }
        function te(e, t) {
          var r = (e = ee(e).map(re)).length;
          return "function" == typeof t ? function () {
            for (var n = -1, a = t.apply(this, arguments); ++n < r;) e[n](this, a);
          } : function () {
            for (var n = -1; ++n < r;) e[n](this, t);
          };
        }
        function re(e) {
          var t = $(e);
          return function (r, n) {
            if (a = r.classList) return n ? a.add(e) : a.remove(e);
            var a = r.getAttribute("class") || "";
            n ? (t.lastIndex = 0, t.test(a) || r.setAttribute("class", K(a + " " + e))) : r.setAttribute("class", K(a.replace(t, " ")));
          };
        }
        function ne(e, t, r) {
          return null == t ? function () {
            this.style.removeProperty(e);
          } : "function" == typeof t ? function () {
            var n = t.apply(this, arguments);
            null == n ? this.style.removeProperty(e) : this.style.setProperty(e, n, r);
          } : function () {
            this.style.setProperty(e, t, r);
          };
        }
        function ae(e, t) {
          return null == t ? function () {
            delete this[e];
          } : "function" == typeof t ? function () {
            var r = t.apply(this, arguments);
            null == r ? delete this[e] : this[e] = r;
          } : function () {
            this[e] = t;
          };
        }
        function ie(t) {
          return "function" == typeof t ? t : (t = e.ns.qualify(t)).local ? function () {
            return this.ownerDocument.createElementNS(t.space, t.local);
          } : function () {
            var e = this.ownerDocument,
              r = this.namespaceURI;
            return r === J && e.documentElement.namespaceURI === J ? e.createElement(t) : e.createElementNS(r, t);
          };
        }
        function oe() {
          var e = this.parentNode;
          e && e.removeChild(this);
        }
        function le(e) {
          return {
            __data__: e
          };
        }
        function se(e) {
          return function () {
            return _q(this, e);
          };
        }
        function ce(e) {
          return arguments.length || (e = f), function (t, r) {
            return t && r ? e(t.__data__, r.__data__) : !t - !r;
          };
        }
        function ue(e, t) {
          for (var r = 0, n = e.length; r < n; r++) for (var a, i = e[r], o = 0, l = i.length; o < l; o++) (a = i[o]) && t(a, o, r);
          return e;
        }
        function de(e) {
          return B(e, fe), e;
        }
        e.ns = {
          prefix: X,
          qualify: function qualify(e) {
            var t = e.indexOf(":"),
              r = e;
            return t >= 0 && "xmlns" !== (r = e.slice(0, t)) && (e = e.slice(t + 1)), X.hasOwnProperty(r) ? {
              space: X[r],
              local: e
            } : e;
          }
        }, G.attr = function (t, r) {
          if (arguments.length < 2) {
            if ("string" == typeof t) {
              var n = this.node();
              return (t = e.ns.qualify(t)).local ? n.getAttributeNS(t.space, t.local) : n.getAttribute(t);
            }
            for (r in t) this.each(Q(r, t[r]));
            return this;
          }
          return this.each(Q(t, r));
        }, G.classed = function (e, t) {
          if (arguments.length < 2) {
            if ("string" == typeof e) {
              var r = this.node(),
                n = (e = ee(e)).length,
                a = -1;
              if (t = r.classList) {
                for (; ++a < n;) if (!t.contains(e[a])) return !1;
              } else for (t = r.getAttribute("class"); ++a < n;) if (!$(e[a]).test(t)) return !1;
              return !0;
            }
            for (t in e) this.each(te(t, e[t]));
            return this;
          }
          return this.each(te(e, t));
        }, G.style = function (e, t, r) {
          var n = arguments.length;
          if (n < 3) {
            if ("string" != typeof e) {
              for (r in n < 2 && (t = ""), e) this.each(ne(r, e[r], t));
              return this;
            }
            if (n < 2) {
              var a = this.node();
              return o(a).getComputedStyle(a, null).getPropertyValue(e);
            }
            r = "";
          }
          return this.each(ne(e, t, r));
        }, G.property = function (e, t) {
          if (arguments.length < 2) {
            if ("string" == typeof e) return this.node()[e];
            for (t in e) this.each(ae(t, e[t]));
            return this;
          }
          return this.each(ae(e, t));
        }, G.text = function (e) {
          return arguments.length ? this.each("function" == typeof e ? function () {
            var t = e.apply(this, arguments);
            this.textContent = null == t ? "" : t;
          } : null == e ? function () {
            this.textContent = "";
          } : function () {
            this.textContent = e;
          }) : this.node().textContent;
        }, G.html = function (e) {
          return arguments.length ? this.each("function" == typeof e ? function () {
            var t = e.apply(this, arguments);
            this.innerHTML = null == t ? "" : t;
          } : null == e ? function () {
            this.innerHTML = "";
          } : function () {
            this.innerHTML = e;
          }) : this.node().innerHTML;
        }, G.append = function (e) {
          return e = ie(e), this.select(function () {
            return this.appendChild(e.apply(this, arguments));
          });
        }, G.insert = function (e, t) {
          return e = ie(e), t = Z(t), this.select(function () {
            return this.insertBefore(e.apply(this, arguments), t.apply(this, arguments) || null);
          });
        }, G.remove = function () {
          return this.each(oe);
        }, G.data = function (e, t) {
          var r,
            n,
            a = -1,
            i = this.length;
          if (!arguments.length) {
            for (e = new Array(i = (r = this[0]).length); ++a < i;) (n = r[a]) && (e[a] = n.__data__);
            return e;
          }
          function o(e, r) {
            var n,
              a,
              i,
              o = e.length,
              u = r.length,
              d = Math.min(o, u),
              f = new Array(u),
              h = new Array(u),
              p = new Array(o);
            if (t) {
              var g,
                m = new _(),
                y = new Array(o);
              for (n = -1; ++n < o;) (a = e[n]) && (m.has(g = t.call(a, a.__data__, n)) ? p[n] = a : m.set(g, a), y[n] = g);
              for (n = -1; ++n < u;) (a = m.get(g = t.call(r, i = r[n], n))) ? !0 !== a && (f[n] = a, a.__data__ = i) : h[n] = le(i), m.set(g, !0);
              for (n = -1; ++n < o;) n in y && !0 !== m.get(y[n]) && (p[n] = e[n]);
            } else {
              for (n = -1; ++n < d;) a = e[n], i = r[n], a ? (a.__data__ = i, f[n] = a) : h[n] = le(i);
              for (; n < u; ++n) h[n] = le(r[n]);
              for (; n < o; ++n) p[n] = e[n];
            }
            h.update = f, h.parentNode = f.parentNode = p.parentNode = e.parentNode, l.push(h), s.push(f), c.push(p);
          }
          var l = de([]),
            s = Y([]),
            c = Y([]);
          if ("function" == typeof e) for (; ++a < i;) o(r = this[a], e.call(r, r.parentNode.__data__, a));else for (; ++a < i;) o(r = this[a], e);
          return s.enter = function () {
            return l;
          }, s.exit = function () {
            return c;
          }, s;
        }, G.datum = function (e) {
          return arguments.length ? this.property("__data__", e) : this.property("__data__");
        }, G.filter = function (e) {
          var t,
            r,
            n,
            a = [];
          "function" != typeof e && (e = se(e));
          for (var i = 0, o = this.length; i < o; i++) {
            a.push(t = []), t.parentNode = (r = this[i]).parentNode;
            for (var l = 0, s = r.length; l < s; l++) (n = r[l]) && e.call(n, n.__data__, l, i) && t.push(n);
          }
          return Y(a);
        }, G.order = function () {
          for (var e = -1, t = this.length; ++e < t;) for (var r, n = this[e], a = n.length - 1, i = n[a]; --a >= 0;) (r = n[a]) && (i && i !== r.nextSibling && i.parentNode.insertBefore(r, i), i = r);
          return this;
        }, G.sort = function (e) {
          e = ce.apply(this, arguments);
          for (var t = -1, r = this.length; ++t < r;) this[t].sort(e);
          return this.order();
        }, G.each = function (e) {
          return ue(this, function (t, r, n) {
            e.call(t, t.__data__, r, n);
          });
        }, G.call = function (e) {
          var t = n(arguments);
          return e.apply(t[0] = this, t), this;
        }, G.empty = function () {
          return !this.node();
        }, G.node = function () {
          for (var e = 0, t = this.length; e < t; e++) for (var r = this[e], n = 0, a = r.length; n < a; n++) {
            var i = r[n];
            if (i) return i;
          }
          return null;
        }, G.size = function () {
          var e = 0;
          return ue(this, function () {
            ++e;
          }), e;
        };
        var fe = [];
        function he(e) {
          var t, r;
          return function (n, a, i) {
            var o,
              l = e[i].update,
              s = l.length;
            for (i != r && (r = i, t = 0), a >= t && (t = a + 1); !(o = l[t]) && ++t < s;);
            return o;
          };
        }
        function pe(t, r, a) {
          var i = "__on" + t,
            o = t.indexOf("."),
            l = me;
          o > 0 && (t = t.slice(0, o));
          var s = ge.get(t);
          function c() {
            var e = this[i];
            e && (this.removeEventListener(t, e, e.$), delete this[i]);
          }
          return s && (t = s, l = ye), o ? r ? function () {
            var e = l(r, n(arguments));
            c.call(this), this.addEventListener(t, this[i] = e, e.$ = a), e._ = r;
          } : c : r ? z : function () {
            var r,
              n = new RegExp("^__on([^.]+)" + e.requote(t) + "$");
            for (var a in this) if (r = a.match(n)) {
              var i = this[a];
              this.removeEventListener(r[1], i, i.$), delete this[a];
            }
          };
        }
        e.selection.enter = de, e.selection.enter.prototype = fe, fe.append = G.append, fe.empty = G.empty, fe.node = G.node, fe.call = G.call, fe.size = G.size, fe.select = function (e) {
          for (var t, r, n, a, i, o = [], l = -1, s = this.length; ++l < s;) {
            n = (a = this[l]).update, o.push(t = []), t.parentNode = a.parentNode;
            for (var c = -1, u = a.length; ++c < u;) (i = a[c]) ? (t.push(n[c] = r = e.call(a.parentNode, i.__data__, c, l)), r.__data__ = i.__data__) : t.push(null);
          }
          return Y(o);
        }, fe.insert = function (e, t) {
          return arguments.length < 2 && (t = he(this)), G.insert.call(this, e, t);
        }, e.select = function (e) {
          var t;
          return "string" == typeof e ? (t = [U(e, a)]).parentNode = a.documentElement : (t = [e]).parentNode = i(e), Y([t]);
        }, e.selectAll = function (e) {
          var t;
          return "string" == typeof e ? (t = n(V(e, a))).parentNode = a.documentElement : (t = n(e)).parentNode = null, Y([t]);
        }, G.on = function (e, t, r) {
          var n = arguments.length;
          if (n < 3) {
            if ("string" != typeof e) {
              for (r in n < 2 && (t = !1), e) this.each(pe(r, e[r], t));
              return this;
            }
            if (n < 2) return (n = this.node()["__on" + e]) && n._;
            r = !1;
          }
          return this.each(pe(e, t, r));
        };
        var ge = e.map({
          mouseenter: "mouseover",
          mouseleave: "mouseout"
        });
        function me(t, r) {
          return function (n) {
            var a = e.event;
            e.event = n, r[0] = this.__data__;
            try {
              t.apply(this, r);
            } finally {
              e.event = a;
            }
          };
        }
        function ye(e, t) {
          var r = me(e, t);
          return function (e) {
            var t = e.relatedTarget;
            t && (t === this || 8 & t.compareDocumentPosition(this)) || r.call(this, e);
          };
        }
        a && ge.forEach(function (e) {
          "on" + e in a && ge.remove(e);
        });
        var ve,
          xe = 0;
        function be(t) {
          var r = ".dragsuppress-" + ++xe,
            n = "click" + r,
            a = e.select(o(t)).on("touchmove" + r, F).on("dragstart" + r, F).on("selectstart" + r, F);
          if (null == ve && (ve = !("onselectstart" in t) && P(t.style, "userSelect")), ve) {
            var l = i(t).style,
              s = l[ve];
            l[ve] = "none";
          }
          return function (e) {
            if (a.on(r, null), ve && (l[ve] = s), e) {
              var t = function t() {
                a.on(n, null);
              };
              a.on(n, function () {
                F(), t();
              }, !0), setTimeout(t, 0);
            }
          };
        }
        e.mouse = function (e) {
          return we(e, E());
        };
        var _e = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
        function we(t, r) {
          r.changedTouches && (r = r.changedTouches[0]);
          var n = t.ownerSVGElement || t;
          if (n.createSVGPoint) {
            var a = n.createSVGPoint();
            if (_e < 0) {
              var i = o(t);
              if (i.scrollX || i.scrollY) {
                var l = (n = e.select("body").append("svg").style({
                  position: "absolute",
                  top: 0,
                  left: 0,
                  margin: 0,
                  padding: 0,
                  border: "none"
                }, "important"))[0][0].getScreenCTM();
                _e = !(l.f || l.e), n.remove();
              }
            }
            return _e ? (a.x = r.pageX, a.y = r.pageY) : (a.x = r.clientX, a.y = r.clientY), [(a = a.matrixTransform(t.getScreenCTM().inverse())).x, a.y];
          }
          var s = t.getBoundingClientRect();
          return [r.clientX - s.left - t.clientLeft, r.clientY - s.top - t.clientTop];
        }
        function Me() {
          return e.event.changedTouches[0].identifier;
        }
        e.touch = function (e, t, r) {
          if (arguments.length < 3 && (r = t, t = E().changedTouches), t) for (var n, a = 0, i = t.length; a < i; ++a) if ((n = t[a]).identifier === r) return we(e, n);
        }, e.behavior.drag = function () {
          var t = j(i, "drag", "dragstart", "dragend"),
            r = null,
            n = l(z, e.mouse, o, "mousemove", "mouseup"),
            a = l(Me, e.touch, C, "touchmove", "touchend");
          function i() {
            this.on("mousedown.drag", n).on("touchstart.drag", a);
          }
          function l(n, a, i, o, l) {
            return function () {
              var s,
                c = this,
                u = e.event.target.correspondingElement || e.event.target,
                d = c.parentNode,
                f = t.of(c, arguments),
                h = 0,
                p = n(),
                g = ".drag" + (null == p ? "" : "-" + p),
                m = e.select(i(u)).on(o + g, x).on(l + g, b),
                y = be(u),
                v = a(d, p);
              function x() {
                var e,
                  t,
                  r = a(d, p);
                r && (e = r[0] - v[0], t = r[1] - v[1], h |= e | t, v = r, f({
                  type: "drag",
                  x: r[0] + s[0],
                  y: r[1] + s[1],
                  dx: e,
                  dy: t
                }));
              }
              function b() {
                a(d, p) && (m.on(o + g, null).on(l + g, null), y(h), f({
                  type: "dragend"
                }));
              }
              s = r ? [(s = r.apply(c, arguments)).x - v[0], s.y - v[1]] : [0, 0], f({
                type: "dragstart"
              });
            };
          }
          return i.origin = function (e) {
            return arguments.length ? (r = e, i) : r;
          }, e.rebind(i, t, "on");
        }, e.touches = function (e, t) {
          return arguments.length < 2 && (t = E().touches), t ? n(t).map(function (t) {
            var r = we(e, t);
            return r.identifier = t.identifier, r;
          }) : [];
        };
        var Te = 1e-6,
          ke = Math.PI,
          Ae = 2 * ke,
          Le = Ae - Te,
          De = ke / 2,
          Se = ke / 180,
          Ce = 180 / ke;
        function Oe(e) {
          return e > 1 ? De : e < -1 ? -De : Math.asin(e);
        }
        function Pe(e) {
          return ((e = Math.exp(e)) + 1 / e) / 2;
        }
        var Ie = Math.SQRT2;
        e.interpolateZoom = function (e, t) {
          var r,
            n,
            a = e[0],
            i = e[1],
            o = e[2],
            l = t[0],
            s = t[1],
            c = t[2],
            u = l - a,
            d = s - i,
            f = u * u + d * d;
          if (f < 1e-12) n = Math.log(c / o) / Ie, r = function r(e) {
            return [a + e * u, i + e * d, o * Math.exp(Ie * e * n)];
          };else {
            var h = Math.sqrt(f),
              p = (c * c - o * o + 4 * f) / (2 * o * 2 * h),
              g = (c * c - o * o - 4 * f) / (2 * c * 2 * h),
              m = Math.log(Math.sqrt(p * p + 1) - p),
              y = Math.log(Math.sqrt(g * g + 1) - g);
            n = (y - m) / Ie, r = function r(e) {
              var t,
                r = e * n,
                l = Pe(m),
                s = o / (2 * h) * (l * (t = Ie * r + m, ((t = Math.exp(2 * t)) - 1) / (t + 1)) - function (e) {
                  return ((e = Math.exp(e)) - 1 / e) / 2;
                }(m));
              return [a + s * u, i + s * d, o * l / Pe(Ie * r + m)];
            };
          }
          return r.duration = 1e3 * n, r;
        }, e.behavior.zoom = function () {
          var t,
            r,
            n,
            i,
            l,
            s,
            c,
            u,
            d,
            f = {
              x: 0,
              y: 0,
              k: 1
            },
            h = [960, 500],
            p = Ne,
            g = 250,
            m = 0,
            y = "mousedown.zoom",
            v = "mousemove.zoom",
            x = "mouseup.zoom",
            b = "touchstart.zoom",
            _ = j(w, "zoomstart", "zoom", "zoomend");
          function w(e) {
            e.on(y, O).on(Re + ".zoom", I).on("dblclick.zoom", z).on(b, P);
          }
          function M(e) {
            return [(e[0] - f.x) / f.k, (e[1] - f.y) / f.k];
          }
          function T(e) {
            f.k = Math.max(p[0], Math.min(p[1], e));
          }
          function k(e, t) {
            t = function (e) {
              return [e[0] * f.k + f.x, e[1] * f.k + f.y];
            }(t), f.x += e[0] - t[0], f.y += e[1] - t[1];
          }
          function A(t, n, a, i) {
            t.__chart__ = {
              x: f.x,
              y: f.y,
              k: f.k
            }, T(Math.pow(2, i)), k(r = n, a), t = e.select(t), g > 0 && (t = t.transition().duration(g)), t.call(w.event);
          }
          function L() {
            c && c.domain(s.range().map(function (e) {
              return (e - f.x) / f.k;
            }).map(s.invert)), d && d.domain(u.range().map(function (e) {
              return (e - f.y) / f.k;
            }).map(u.invert));
          }
          function D(e) {
            m++ || e({
              type: "zoomstart"
            });
          }
          function S(e) {
            L(), e({
              type: "zoom",
              scale: f.k,
              translate: [f.x, f.y]
            });
          }
          function C(e) {
            --m || (e({
              type: "zoomend"
            }), r = null);
          }
          function O() {
            var t = this,
              r = _.of(t, arguments),
              n = 0,
              a = e.select(o(t)).on(v, s).on(x, c),
              i = M(e.mouse(t)),
              l = be(t);
            function s() {
              n = 1, k(e.mouse(t), i), S(r);
            }
            function c() {
              a.on(v, null).on(x, null), l(n), C(r);
            }
            Ra.call(t), D(r);
          }
          function P() {
            var t,
              r = this,
              n = _.of(r, arguments),
              a = {},
              i = 0,
              o = ".zoom-" + e.event.changedTouches[0].identifier,
              s = "touchmove" + o,
              c = "touchend" + o,
              u = [],
              d = e.select(r),
              h = be(r);
            function p() {
              var n = e.touches(r);
              return t = f.k, n.forEach(function (e) {
                e.identifier in a && (a[e.identifier] = M(e));
              }), n;
            }
            function g() {
              var t = e.event.target;
              e.select(t).on(s, m).on(c, v), u.push(t);
              for (var n = e.event.changedTouches, o = 0, d = n.length; o < d; ++o) a[n[o].identifier] = null;
              var h = p(),
                g = Date.now();
              if (1 === h.length) {
                if (g - l < 500) {
                  var y = h[0];
                  A(r, y, a[y.identifier], Math.floor(Math.log(f.k) / Math.LN2) + 1), F();
                }
                l = g;
              } else if (h.length > 1) {
                y = h[0];
                var x = h[1],
                  b = y[0] - x[0],
                  _ = y[1] - x[1];
                i = b * b + _ * _;
              }
            }
            function m() {
              var o,
                s,
                c,
                u,
                d = e.touches(r);
              Ra.call(r);
              for (var f = 0, h = d.length; f < h; ++f, u = null) if (c = d[f], u = a[c.identifier]) {
                if (s) break;
                o = c, s = u;
              }
              if (u) {
                var p = (p = c[0] - o[0]) * p + (p = c[1] - o[1]) * p,
                  g = i && Math.sqrt(p / i);
                o = [(o[0] + c[0]) / 2, (o[1] + c[1]) / 2], s = [(s[0] + u[0]) / 2, (s[1] + u[1]) / 2], T(g * t);
              }
              l = null, k(o, s), S(n);
            }
            function v() {
              if (e.event.touches.length) {
                for (var t = e.event.changedTouches, r = 0, i = t.length; r < i; ++r) delete a[t[r].identifier];
                for (var l in a) return void p();
              }
              e.selectAll(u).on(o, null), d.on(y, O).on(b, P), h(), C(n);
            }
            g(), D(n), d.on(y, null).on(b, g);
          }
          function I() {
            var a = _.of(this, arguments);
            i ? clearTimeout(i) : (Ra.call(this), t = M(r = n || e.mouse(this)), D(a)), i = setTimeout(function () {
              i = null, C(a);
            }, 50), F(), T(Math.pow(2, .002 * ze()) * f.k), k(r, t), S(a);
          }
          function z() {
            var t = e.mouse(this),
              r = Math.log(f.k) / Math.LN2;
            A(this, t, M(t), e.event.shiftKey ? Math.ceil(r) - 1 : Math.floor(r) + 1);
          }
          return Re || (Re = "onwheel" in a ? (ze = function ze() {
            return -e.event.deltaY * (e.event.deltaMode ? 120 : 1);
          }, "wheel") : "onmousewheel" in a ? (ze = function ze() {
            return e.event.wheelDelta;
          }, "mousewheel") : (ze = function ze() {
            return -e.event.detail;
          }, "MozMousePixelScroll")), w.event = function (t) {
            t.each(function () {
              var t = _.of(this, arguments),
                n = f;
              Ea ? e.select(this).transition().each("start.zoom", function () {
                f = this.__chart__ || {
                  x: 0,
                  y: 0,
                  k: 1
                }, D(t);
              }).tween("zoom:zoom", function () {
                var a = h[0],
                  i = h[1],
                  o = r ? r[0] : a / 2,
                  l = r ? r[1] : i / 2,
                  s = e.interpolateZoom([(o - f.x) / f.k, (l - f.y) / f.k, a / f.k], [(o - n.x) / n.k, (l - n.y) / n.k, a / n.k]);
                return function (e) {
                  var r = s(e),
                    n = a / r[2];
                  this.__chart__ = f = {
                    x: o - r[0] * n,
                    y: l - r[1] * n,
                    k: n
                  }, S(t);
                };
              }).each("interrupt.zoom", function () {
                C(t);
              }).each("end.zoom", function () {
                C(t);
              }) : (this.__chart__ = f, D(t), S(t), C(t));
            });
          }, w.translate = function (e) {
            return arguments.length ? (f = {
              x: +e[0],
              y: +e[1],
              k: f.k
            }, L(), w) : [f.x, f.y];
          }, w.scale = function (e) {
            return arguments.length ? (f = {
              x: f.x,
              y: f.y,
              k: null
            }, T(+e), L(), w) : f.k;
          }, w.scaleExtent = function (e) {
            return arguments.length ? (p = null == e ? Ne : [+e[0], +e[1]], w) : p;
          }, w.center = function (e) {
            return arguments.length ? (n = e && [+e[0], +e[1]], w) : n;
          }, w.size = function (e) {
            return arguments.length ? (h = e && [+e[0], +e[1]], w) : h;
          }, w.duration = function (e) {
            return arguments.length ? (g = +e, w) : g;
          }, w.x = function (e) {
            return arguments.length ? (c = e, s = e.copy(), f = {
              x: 0,
              y: 0,
              k: 1
            }, w) : c;
          }, w.y = function (e) {
            return arguments.length ? (d = e, u = e.copy(), f = {
              x: 0,
              y: 0,
              k: 1
            }, w) : d;
          }, e.rebind(w, _, "on");
        };
        var ze,
          Re,
          Ne = [0, 1 / 0];
        function Fe() {}
        function Ee(e, t, r) {
          return this instanceof Ee ? (this.h = +e, this.s = +t, void (this.l = +r)) : arguments.length < 2 ? e instanceof Ee ? new Ee(e.h, e.s, e.l) : nt("" + e, at, Ee) : new Ee(e, t, r);
        }
        e.color = Fe, Fe.prototype.toString = function () {
          return this.rgb() + "";
        }, e.hsl = Ee;
        var je = Ee.prototype = new Fe();
        function He(e, t, r) {
          var n, a;
          function i(e) {
            return Math.round(255 * function (e) {
              return e > 360 ? e -= 360 : e < 0 && (e += 360), e < 60 ? n + (a - n) * e / 60 : e < 180 ? a : e < 240 ? n + (a - n) * (240 - e) / 60 : n;
            }(e));
          }
          return e = isNaN(e) ? 0 : (e %= 360) < 0 ? e + 360 : e, t = isNaN(t) || t < 0 ? 0 : t > 1 ? 1 : t, n = 2 * (r = r < 0 ? 0 : r > 1 ? 1 : r) - (a = r <= .5 ? r * (1 + t) : r + t - r * t), new Ke(i(e + 120), i(e), i(e - 120));
        }
        function Be(t, r, n) {
          return this instanceof Be ? (this.h = +t, this.c = +r, void (this.l = +n)) : arguments.length < 2 ? t instanceof Be ? new Be(t.h, t.c, t.l) : We(t instanceof Ve ? t.l : (t = it((t = e.rgb(t)).r, t.g, t.b)).l, t.a, t.b) : new Be(t, r, n);
        }
        je.brighter = function (e) {
          return e = Math.pow(.7, arguments.length ? e : 1), new Ee(this.h, this.s, this.l / e);
        }, je.darker = function (e) {
          return e = Math.pow(.7, arguments.length ? e : 1), new Ee(this.h, this.s, e * this.l);
        }, je.rgb = function () {
          return He(this.h, this.s, this.l);
        }, e.hcl = Be;
        var Ye = Be.prototype = new Fe();
        function Ue(e, t, r) {
          return isNaN(e) && (e = 0), isNaN(t) && (t = 0), new Ve(r, Math.cos(e *= Se) * t, Math.sin(e) * t);
        }
        function Ve(e, t, r) {
          return this instanceof Ve ? (this.l = +e, this.a = +t, void (this.b = +r)) : arguments.length < 2 ? e instanceof Ve ? new Ve(e.l, e.a, e.b) : e instanceof Be ? Ue(e.h, e.c, e.l) : it((e = Ke(e)).r, e.g, e.b) : new Ve(e, t, r);
        }
        Ye.brighter = function (e) {
          return new Be(this.h, this.c, Math.min(100, this.l + qe * (arguments.length ? e : 1)));
        }, Ye.darker = function (e) {
          return new Be(this.h, this.c, Math.max(0, this.l - qe * (arguments.length ? e : 1)));
        }, Ye.rgb = function () {
          return Ue(this.h, this.c, this.l).rgb();
        }, e.lab = Ve;
        var qe = 18,
          Ge = Ve.prototype = new Fe();
        function Ze(e, t, r) {
          var n = (e + 16) / 116,
            a = n + t / 500,
            i = n - r / 200;
          return new Ke(Qe(3.2404542 * (a = .95047 * Je(a)) - 1.5371385 * (n = 1 * Je(n)) - .4985314 * (i = 1.08883 * Je(i))), Qe(-.969266 * a + 1.8760108 * n + .041556 * i), Qe(.0556434 * a - .2040259 * n + 1.0572252 * i));
        }
        function We(e, t, r) {
          return e > 0 ? new Be(Math.atan2(r, t) * Ce, Math.sqrt(t * t + r * r), e) : new Be(NaN, NaN, e);
        }
        function Je(e) {
          return e > .206893034 ? e * e * e : (e - 4 / 29) / 7.787037;
        }
        function Xe(e) {
          return e > .008856 ? Math.pow(e, 1 / 3) : 7.787037 * e + 4 / 29;
        }
        function Qe(e) {
          return Math.round(255 * (e <= .00304 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055));
        }
        function Ke(e, t, r) {
          return this instanceof Ke ? (this.r = ~~e, this.g = ~~t, void (this.b = ~~r)) : arguments.length < 2 ? e instanceof Ke ? new Ke(e.r, e.g, e.b) : nt("" + e, Ke, He) : new Ke(e, t, r);
        }
        function $e(e) {
          return new Ke(e >> 16, e >> 8 & 255, 255 & e);
        }
        function et(e) {
          return $e(e) + "";
        }
        Ge.brighter = function (e) {
          return new Ve(Math.min(100, this.l + qe * (arguments.length ? e : 1)), this.a, this.b);
        }, Ge.darker = function (e) {
          return new Ve(Math.max(0, this.l - qe * (arguments.length ? e : 1)), this.a, this.b);
        }, Ge.rgb = function () {
          return Ze(this.l, this.a, this.b);
        }, e.rgb = Ke;
        var tt = Ke.prototype = new Fe();
        function rt(e) {
          return e < 16 ? "0" + Math.max(0, e).toString(16) : Math.min(255, e).toString(16);
        }
        function nt(e, t, r) {
          var n,
            a,
            i,
            o = 0,
            l = 0,
            s = 0;
          if (n = /([a-z]+)\((.*)\)/.exec(e = e.toLowerCase())) switch (a = n[2].split(","), n[1]) {
            case "hsl":
              return r(parseFloat(a[0]), parseFloat(a[1]) / 100, parseFloat(a[2]) / 100);
            case "rgb":
              return t(lt(a[0]), lt(a[1]), lt(a[2]));
          }
          return (i = st.get(e)) ? t(i.r, i.g, i.b) : (null == e || "#" !== e.charAt(0) || isNaN(i = parseInt(e.slice(1), 16)) || (4 === e.length ? (o = (3840 & i) >> 4, o |= o >> 4, l = 240 & i, l |= l >> 4, s = 15 & i, s |= s << 4) : 7 === e.length && (o = (16711680 & i) >> 16, l = (65280 & i) >> 8, s = 255 & i)), t(o, l, s));
        }
        function at(e, t, r) {
          var n,
            a,
            i = Math.min(e /= 255, t /= 255, r /= 255),
            o = Math.max(e, t, r),
            l = o - i,
            s = (o + i) / 2;
          return l ? (a = s < .5 ? l / (o + i) : l / (2 - o - i), n = e == o ? (t - r) / l + (t < r ? 6 : 0) : t == o ? (r - e) / l + 2 : (e - t) / l + 4, n *= 60) : (n = NaN, a = s > 0 && s < 1 ? 0 : n), new Ee(n, a, s);
        }
        function it(e, t, r) {
          var n = Xe((.4124564 * (e = ot(e)) + .3575761 * (t = ot(t)) + .1804375 * (r = ot(r))) / .95047),
            a = Xe((.2126729 * e + .7151522 * t + .072175 * r) / 1);
          return Ve(116 * a - 16, 500 * (n - a), 200 * (a - Xe((.0193339 * e + .119192 * t + .9503041 * r) / 1.08883)));
        }
        function ot(e) {
          return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
        }
        function lt(e) {
          var t = parseFloat(e);
          return "%" === e.charAt(e.length - 1) ? Math.round(2.55 * t) : t;
        }
        tt.brighter = function (e) {
          e = Math.pow(.7, arguments.length ? e : 1);
          var t = this.r,
            r = this.g,
            n = this.b,
            a = 30;
          return t || r || n ? (t && t < a && (t = a), r && r < a && (r = a), n && n < a && (n = a), new Ke(Math.min(255, t / e), Math.min(255, r / e), Math.min(255, n / e))) : new Ke(a, a, a);
        }, tt.darker = function (e) {
          return new Ke((e = Math.pow(.7, arguments.length ? e : 1)) * this.r, e * this.g, e * this.b);
        }, tt.hsl = function () {
          return at(this.r, this.g, this.b);
        }, tt.toString = function () {
          return "#" + rt(this.r) + rt(this.g) + rt(this.b);
        };
        var st = e.map({
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074
        });
        function ct(e) {
          return "function" == typeof e ? e : function () {
            return e;
          };
        }
        function ut(e) {
          return function (t, r, n) {
            return 2 === arguments.length && "function" == typeof r && (n = r, r = null), dt(t, r, e, n);
          };
        }
        function dt(t, r, a, i) {
          var o = {},
            l = e.dispatch("beforesend", "progress", "load", "error"),
            s = {},
            c = new XMLHttpRequest(),
            u = null;
          function d() {
            var e,
              t = c.status;
            if (!t && function (e) {
              var t = e.responseType;
              return t && "text" !== t ? e.response : e.responseText;
            }(c) || t >= 200 && t < 300 || 304 === t) {
              try {
                e = a.call(o, c);
              } catch (e) {
                return void l.error.call(o, e);
              }
              l.load.call(o, e);
            } else l.error.call(o, c);
          }
          return self.XDomainRequest && !("withCredentials" in c) && /^(http(s)?:)?\/\//.test(t) && (c = new XDomainRequest()), "onload" in c ? c.onload = c.onerror = d : c.onreadystatechange = function () {
            c.readyState > 3 && d();
          }, c.onprogress = function (t) {
            var r = e.event;
            e.event = t;
            try {
              l.progress.call(o, c);
            } finally {
              e.event = r;
            }
          }, o.header = function (e, t) {
            return e = (e + "").toLowerCase(), arguments.length < 2 ? s[e] : (null == t ? delete s[e] : s[e] = t + "", o);
          }, o.mimeType = function (e) {
            return arguments.length ? (r = null == e ? null : e + "", o) : r;
          }, o.responseType = function (e) {
            return arguments.length ? (u = e, o) : u;
          }, o.response = function (e) {
            return a = e, o;
          }, ["get", "post"].forEach(function (e) {
            o[e] = function () {
              return o.send.apply(o, [e].concat(n(arguments)));
            };
          }), o.send = function (e, n, a) {
            if (2 === arguments.length && "function" == typeof n && (a = n, n = null), c.open(e, t, !0), null == r || "accept" in s || (s.accept = r + ",*/*"), c.setRequestHeader) for (var i in s) c.setRequestHeader(i, s[i]);
            return null != r && c.overrideMimeType && c.overrideMimeType(r), null != u && (c.responseType = u), null != a && o.on("error", a).on("load", function (e) {
              a(null, e);
            }), l.beforesend.call(o, c), c.send(null == n ? null : n), o;
          }, o.abort = function () {
            return c.abort(), o;
          }, e.rebind(o, l, "on"), null == i ? o : o.get(function (e) {
            return 1 === e.length ? function (t, r) {
              e(null == t ? r : null);
            } : e;
          }(i));
        }
        st.forEach(function (e, t) {
          st.set(e, $e(t));
        }), e.functor = ct, e.xhr = ut(C), e.dsv = function (e, t) {
          var r = new RegExp('["' + e + "\n]"),
            n = e.charCodeAt(0);
          function a(e, r, n) {
            arguments.length < 3 && (n = r, r = null);
            var a = dt(e, t, null == r ? i : o(r), n);
            return a.row = function (e) {
              return arguments.length ? a.response(null == (r = e) ? i : o(e)) : r;
            }, a;
          }
          function i(e) {
            return a.parse(e.responseText);
          }
          function o(e) {
            return function (t) {
              return a.parse(t.responseText, e);
            };
          }
          function l(t) {
            return t.map(s).join(e);
          }
          function s(e) {
            return r.test(e) ? '"' + e.replace(/\"/g, '""') + '"' : e;
          }
          return a.parse = function (e, t) {
            var r;
            return a.parseRows(e, function (e, n) {
              if (r) return r(e, n - 1);
              var a = function a(t) {
                for (var r = {}, n = e.length, a = 0; a < n; ++a) r[e[a]] = t[a];
                return r;
              };
              r = t ? function (e, r) {
                return t(a(e), r);
              } : a;
            });
          }, a.parseRows = function (e, t) {
            var r,
              a,
              i = {},
              o = {},
              l = [],
              s = e.length,
              c = 0,
              u = 0;
            function d() {
              if (c >= s) return o;
              if (a) return a = !1, i;
              var t = c;
              if (34 === e.charCodeAt(t)) {
                for (var r = t; r++ < s;) if (34 === e.charCodeAt(r)) {
                  if (34 !== e.charCodeAt(r + 1)) break;
                  ++r;
                }
                return c = r + 2, 13 === (l = e.charCodeAt(r + 1)) ? (a = !0, 10 === e.charCodeAt(r + 2) && ++c) : 10 === l && (a = !0), e.slice(t + 1, r).replace(/""/g, '"');
              }
              for (; c < s;) {
                var l,
                  u = 1;
                if (10 === (l = e.charCodeAt(c++))) a = !0;else if (13 === l) a = !0, 10 === e.charCodeAt(c) && (++c, ++u);else if (l !== n) continue;
                return e.slice(t, c - u);
              }
              return e.slice(t);
            }
            for (; (r = d()) !== o;) {
              for (var f = []; r !== i && r !== o;) f.push(r), r = d();
              t && null == (f = t(f, u++)) || l.push(f);
            }
            return l;
          }, a.format = function (t) {
            if (Array.isArray(t[0])) return a.formatRows(t);
            var r = new S(),
              n = [];
            return t.forEach(function (e) {
              for (var t in e) r.has(t) || n.push(r.add(t));
            }), [n.map(s).join(e)].concat(t.map(function (t) {
              return n.map(function (e) {
                return s(t[e]);
              }).join(e);
            })).join("\n");
          }, a.formatRows = function (e) {
            return e.map(l).join("\n");
          }, a;
        }, e.csv = e.dsv(",", "text/csv"), e.tsv = e.dsv("\t", "text/tab-separated-values");
        var ft,
          ht,
          pt,
          gt,
          mt = this[P(this, "requestAnimationFrame")] || function (e) {
            setTimeout(e, 17);
          };
        function yt(e, t, r) {
          var n = arguments.length;
          n < 2 && (t = 0), n < 3 && (r = Date.now());
          var a = r + t,
            i = {
              c: e,
              t: a,
              n: null
            };
          return ht ? ht.n = i : ft = i, ht = i, pt || (gt = clearTimeout(gt), pt = 1, mt(vt)), i;
        }
        function vt() {
          var e = xt(),
            t = bt() - e;
          t > 24 ? (isFinite(t) && (clearTimeout(gt), gt = setTimeout(vt, t)), pt = 0) : (pt = 1, mt(vt));
        }
        function xt() {
          for (var e = Date.now(), t = ft; t;) e >= t.t && t.c(e - t.t) && (t.c = null), t = t.n;
          return e;
        }
        function bt() {
          for (var e, t = ft, r = 1 / 0; t;) t.c ? (t.t < r && (r = t.t), t = (e = t).n) : t = e ? e.n = t.n : ft = t.n;
          return ht = e, r;
        }
        function _t(e) {
          return e[0];
        }
        function wt(e) {
          return e[1];
        }
        function Mt(e) {
          for (var t, r, n, a = e.length, i = [0, 1], o = 2, l = 2; l < a; l++) {
            for (; o > 1 && (t = e[i[o - 2]], r = e[i[o - 1]], n = e[l], (r[0] - t[0]) * (n[1] - t[1]) - (r[1] - t[1]) * (n[0] - t[0]) <= 0);) --o;
            i[o++] = l;
          }
          return i.slice(0, o);
        }
        function Tt(e, t) {
          return e[0] - t[0] || e[1] - t[1];
        }
        e.timer = function () {
          yt.apply(this, arguments);
        }, e.timer.flush = function () {
          xt(), bt();
        }, e.round = function (e, t) {
          return t ? Math.round(e * (t = Math.pow(10, t))) / t : Math.round(e);
        }, e.geom = {}, e.geom.hull = function (e) {
          var t = _t,
            r = wt;
          if (arguments.length) return n(e);
          function n(e) {
            if (e.length < 3) return [];
            var n,
              a = ct(t),
              i = ct(r),
              o = e.length,
              l = [],
              s = [];
            for (n = 0; n < o; n++) l.push([+a.call(this, e[n], n), +i.call(this, e[n], n), n]);
            for (l.sort(Tt), n = 0; n < o; n++) s.push([l[n][0], -l[n][1]]);
            var c = Mt(l),
              u = Mt(s),
              d = u[0] === c[0],
              f = u[u.length - 1] === c[c.length - 1],
              h = [];
            for (n = c.length - 1; n >= 0; --n) h.push(e[l[c[n]][2]]);
            for (n = +d; n < u.length - f; ++n) h.push(e[l[u[n]][2]]);
            return h;
          }
          return n.x = function (e) {
            return arguments.length ? (t = e, n) : t;
          }, n.y = function (e) {
            return arguments.length ? (r = e, n) : r;
          }, n;
        }, e.geom.polygon = function (e) {
          return B(e, kt), e;
        };
        var kt = e.geom.polygon.prototype = [];
        function At(e, t, r) {
          return (r[0] - t[0]) * (e[1] - t[1]) < (r[1] - t[1]) * (e[0] - t[0]);
        }
        function Lt(e, t, r, n) {
          var a = e[0],
            i = r[0],
            o = t[0] - a,
            l = n[0] - i,
            s = e[1],
            c = r[1],
            u = t[1] - s,
            d = n[1] - c,
            f = (l * (s - c) - d * (a - i)) / (d * o - l * u);
          return [a + f * o, s + f * u];
        }
        function Dt(e) {
          var t = e[0],
            r = e[e.length - 1];
          return !(t[0] - r[0] || t[1] - r[1]);
        }
        kt.area = function () {
          for (var e, t = -1, r = this.length, n = this[r - 1], a = 0; ++t < r;) e = n, n = this[t], a += e[1] * n[0] - e[0] * n[1];
          return .5 * a;
        }, kt.centroid = function (e) {
          var t,
            r,
            n = -1,
            a = this.length,
            i = 0,
            o = 0,
            l = this[a - 1];
          for (arguments.length || (e = -1 / (6 * this.area())); ++n < a;) t = l, l = this[n], r = t[0] * l[1] - l[0] * t[1], i += (t[0] + l[0]) * r, o += (t[1] + l[1]) * r;
          return [i * e, o * e];
        }, kt.clip = function (e) {
          for (var t, r, n, a, i, o, l = Dt(e), s = -1, c = this.length - Dt(this), u = this[c - 1]; ++s < c;) {
            for (t = e.slice(), e.length = 0, a = this[s], i = t[(n = t.length - l) - 1], r = -1; ++r < n;) At(o = t[r], u, a) ? (At(i, u, a) || e.push(Lt(i, o, u, a)), e.push(o)) : At(i, u, a) && e.push(Lt(i, o, u, a)), i = o;
            l && e.push(e[0]), u = a;
          }
          return e;
        };
        var St,
          Ct,
          Ot,
          Pt,
          It,
          zt = [],
          Rt = [];
        function Nt() {
          tr(this), this.edge = this.site = this.circle = null;
        }
        function Ft(e) {
          var t = zt.pop() || new Nt();
          return t.site = e, t;
        }
        function Et(e) {
          Zt(e), Ot.remove(e), zt.push(e), tr(e);
        }
        function jt(e) {
          var t = e.circle,
            r = t.x,
            n = t.cy,
            a = {
              x: r,
              y: n
            },
            i = e.P,
            o = e.N,
            l = [e];
          Et(e);
          for (var s = i; s.circle && v(r - s.circle.x) < Te && v(n - s.circle.cy) < Te;) i = s.P, l.unshift(s), Et(s), s = i;
          l.unshift(s), Zt(s);
          for (var c = o; c.circle && v(r - c.circle.x) < Te && v(n - c.circle.cy) < Te;) o = c.N, l.push(c), Et(c), c = o;
          l.push(c), Zt(c);
          var u,
            d = l.length;
          for (u = 1; u < d; ++u) c = l[u], s = l[u - 1], Kt(c.edge, s.site, c.site, a);
          s = l[0], (c = l[d - 1]).edge = Xt(s.site, c.site, null, a), Gt(s), Gt(c);
        }
        function Ht(e) {
          for (var t, r, n, a, i = e.x, o = e.y, l = Ot._; l;) if ((n = Bt(l, o) - i) > Te) l = l.L;else {
            if (!((a = i - Yt(l, o)) > Te)) {
              n > -Te ? (t = l.P, r = l) : a > -Te ? (t = l, r = l.N) : t = r = l;
              break;
            }
            if (!l.R) {
              t = l;
              break;
            }
            l = l.R;
          }
          var s = Ft(e);
          if (Ot.insert(t, s), t || r) {
            if (t === r) return Zt(t), r = Ft(t.site), Ot.insert(s, r), s.edge = r.edge = Xt(t.site, s.site), Gt(t), void Gt(r);
            if (r) {
              Zt(t), Zt(r);
              var c = t.site,
                u = c.x,
                d = c.y,
                f = e.x - u,
                h = e.y - d,
                p = r.site,
                g = p.x - u,
                m = p.y - d,
                y = 2 * (f * m - h * g),
                v = f * f + h * h,
                x = g * g + m * m,
                b = {
                  x: (m * v - h * x) / y + u,
                  y: (f * x - g * v) / y + d
                };
              Kt(r.edge, c, p, b), s.edge = Xt(c, e, null, b), r.edge = Xt(e, p, null, b), Gt(t), Gt(r);
            } else s.edge = Xt(t.site, s.site);
          }
        }
        function Bt(e, t) {
          var r = e.site,
            n = r.x,
            a = r.y,
            i = a - t;
          if (!i) return n;
          var o = e.P;
          if (!o) return -1 / 0;
          var l = (r = o.site).x,
            s = r.y,
            c = s - t;
          if (!c) return l;
          var u = l - n,
            d = 1 / i - 1 / c,
            f = u / c;
          return d ? (-f + Math.sqrt(f * f - 2 * d * (u * u / (-2 * c) - s + c / 2 + a - i / 2))) / d + n : (n + l) / 2;
        }
        function Yt(e, t) {
          var r = e.N;
          if (r) return Bt(r, t);
          var n = e.site;
          return n.y === t ? n.x : 1 / 0;
        }
        function Ut(e) {
          this.site = e, this.edges = [];
        }
        function Vt(e, t) {
          return t.angle - e.angle;
        }
        function qt() {
          tr(this), this.x = this.y = this.arc = this.site = this.cy = null;
        }
        function Gt(e) {
          var t = e.P,
            r = e.N;
          if (t && r) {
            var n = t.site,
              a = e.site,
              i = r.site;
            if (n !== i) {
              var o = a.x,
                l = a.y,
                s = n.x - o,
                c = n.y - l,
                u = i.x - o,
                d = 2 * (s * (m = i.y - l) - c * u);
              if (!(d >= -1e-12)) {
                var f = s * s + c * c,
                  h = u * u + m * m,
                  p = (m * f - c * h) / d,
                  g = (s * h - u * f) / d,
                  m = g + l,
                  y = Rt.pop() || new qt();
                y.arc = e, y.site = a, y.x = p + o, y.y = m + Math.sqrt(p * p + g * g), y.cy = m, e.circle = y;
                for (var v = null, x = It._; x;) if (y.y < x.y || y.y === x.y && y.x <= x.x) {
                  if (!x.L) {
                    v = x.P;
                    break;
                  }
                  x = x.L;
                } else {
                  if (!x.R) {
                    v = x;
                    break;
                  }
                  x = x.R;
                }
                It.insert(v, y), v || (Pt = y);
              }
            }
          }
        }
        function Zt(e) {
          var t = e.circle;
          t && (t.P || (Pt = t.N), It.remove(t), Rt.push(t), tr(t), e.circle = null);
        }
        function Wt(e, t) {
          var r = e.b;
          if (r) return !0;
          var n,
            a,
            i = e.a,
            o = t[0][0],
            l = t[1][0],
            s = t[0][1],
            c = t[1][1],
            u = e.l,
            d = e.r,
            f = u.x,
            h = u.y,
            p = d.x,
            g = d.y,
            m = (f + p) / 2,
            y = (h + g) / 2;
          if (g === h) {
            if (m < o || m >= l) return;
            if (f > p) {
              if (i) {
                if (i.y >= c) return;
              } else i = {
                x: m,
                y: s
              };
              r = {
                x: m,
                y: c
              };
            } else {
              if (i) {
                if (i.y < s) return;
              } else i = {
                x: m,
                y: c
              };
              r = {
                x: m,
                y: s
              };
            }
          } else if (a = y - (n = (f - p) / (g - h)) * m, n < -1 || n > 1) {
            if (f > p) {
              if (i) {
                if (i.y >= c) return;
              } else i = {
                x: (s - a) / n,
                y: s
              };
              r = {
                x: (c - a) / n,
                y: c
              };
            } else {
              if (i) {
                if (i.y < s) return;
              } else i = {
                x: (c - a) / n,
                y: c
              };
              r = {
                x: (s - a) / n,
                y: s
              };
            }
          } else if (h < g) {
            if (i) {
              if (i.x >= l) return;
            } else i = {
              x: o,
              y: n * o + a
            };
            r = {
              x: l,
              y: n * l + a
            };
          } else {
            if (i) {
              if (i.x < o) return;
            } else i = {
              x: l,
              y: n * l + a
            };
            r = {
              x: o,
              y: n * o + a
            };
          }
          return e.a = i, e.b = r, !0;
        }
        function Jt(e, t) {
          this.l = e, this.r = t, this.a = this.b = null;
        }
        function Xt(e, t, r, n) {
          var a = new Jt(e, t);
          return St.push(a), r && Kt(a, e, t, r), n && Kt(a, t, e, n), Ct[e.i].edges.push(new $t(a, e, t)), Ct[t.i].edges.push(new $t(a, t, e)), a;
        }
        function Qt(e, t, r) {
          var n = new Jt(e, null);
          return n.a = t, n.b = r, St.push(n), n;
        }
        function Kt(e, t, r, n) {
          e.a || e.b ? e.l === r ? e.b = n : e.a = n : (e.a = n, e.l = t, e.r = r);
        }
        function $t(e, t, r) {
          var n = e.a,
            a = e.b;
          this.edge = e, this.site = t, this.angle = r ? Math.atan2(r.y - t.y, r.x - t.x) : e.l === t ? Math.atan2(a.x - n.x, n.y - a.y) : Math.atan2(n.x - a.x, a.y - n.y);
        }
        function er() {
          this._ = null;
        }
        function tr(e) {
          e.U = e.C = e.L = e.R = e.P = e.N = null;
        }
        function rr(e, t) {
          var r = t,
            n = t.R,
            a = r.U;
          a ? a.L === r ? a.L = n : a.R = n : e._ = n, n.U = a, r.U = n, r.R = n.L, r.R && (r.R.U = r), n.L = r;
        }
        function nr(e, t) {
          var r = t,
            n = t.L,
            a = r.U;
          a ? a.L === r ? a.L = n : a.R = n : e._ = n, n.U = a, r.U = n, r.L = n.R, r.L && (r.L.U = r), n.R = r;
        }
        function ar(e) {
          for (; e.L;) e = e.L;
          return e;
        }
        function ir(e, t) {
          var r,
            n,
            a,
            i = e.sort(or).pop();
          for (St = [], Ct = new Array(e.length), Ot = new er(), It = new er();;) if (a = Pt, i && (!a || i.y < a.y || i.y === a.y && i.x < a.x)) i.x === r && i.y === n || (Ct[i.i] = new Ut(i), Ht(i), r = i.x, n = i.y), i = e.pop();else {
            if (!a) break;
            jt(a.arc);
          }
          t && (function (e) {
            for (var t, r, n, a, i, o = St, l = (r = e[0][0], n = e[0][1], a = e[1][0], i = e[1][1], function (e) {
                var t,
                  o = e.a,
                  l = e.b,
                  s = o.x,
                  c = o.y,
                  u = 0,
                  d = 1,
                  f = l.x - s,
                  h = l.y - c;
                if (t = r - s, f || !(t > 0)) {
                  if (t /= f, f < 0) {
                    if (t < u) return;
                    t < d && (d = t);
                  } else if (f > 0) {
                    if (t > d) return;
                    t > u && (u = t);
                  }
                  if (t = a - s, f || !(t < 0)) {
                    if (t /= f, f < 0) {
                      if (t > d) return;
                      t > u && (u = t);
                    } else if (f > 0) {
                      if (t < u) return;
                      t < d && (d = t);
                    }
                    if (t = n - c, h || !(t > 0)) {
                      if (t /= h, h < 0) {
                        if (t < u) return;
                        t < d && (d = t);
                      } else if (h > 0) {
                        if (t > d) return;
                        t > u && (u = t);
                      }
                      if (t = i - c, h || !(t < 0)) {
                        if (t /= h, h < 0) {
                          if (t > d) return;
                          t > u && (u = t);
                        } else if (h > 0) {
                          if (t < u) return;
                          t < d && (d = t);
                        }
                        return u > 0 && (e.a = {
                          x: s + u * f,
                          y: c + u * h
                        }), d < 1 && (e.b = {
                          x: s + d * f,
                          y: c + d * h
                        }), e;
                      }
                    }
                  }
                }
              }), s = o.length; s--;) (!Wt(t = o[s], e) || !l(t) || v(t.a.x - t.b.x) < Te && v(t.a.y - t.b.y) < Te) && (t.a = t.b = null, o.splice(s, 1));
          }(t), function (e) {
            for (var t, r, n, a, i, o, l, s, c, u, d = e[0][0], f = e[1][0], h = e[0][1], p = e[1][1], g = Ct, m = g.length; m--;) if ((i = g[m]) && i.prepare()) for (s = (l = i.edges).length, o = 0; o < s;) n = (u = l[o].end()).x, a = u.y, t = (c = l[++o % s].start()).x, r = c.y, (v(n - t) > Te || v(a - r) > Te) && (l.splice(o, 0, new $t(Qt(i.site, u, v(n - d) < Te && p - a > Te ? {
              x: d,
              y: v(t - d) < Te ? r : p
            } : v(a - p) < Te && f - n > Te ? {
              x: v(r - p) < Te ? t : f,
              y: p
            } : v(n - f) < Te && a - h > Te ? {
              x: f,
              y: v(t - f) < Te ? r : h
            } : v(a - h) < Te && n - d > Te ? {
              x: v(r - h) < Te ? t : d,
              y: h
            } : null), i.site, null)), ++s);
          }(t));
          var o = {
            cells: Ct,
            edges: St
          };
          return Ot = It = St = Ct = null, o;
        }
        function or(e, t) {
          return t.y - e.y || t.x - e.x;
        }
        Ut.prototype.prepare = function () {
          for (var e, t = this.edges, r = t.length; r--;) (e = t[r].edge).b && e.a || t.splice(r, 1);
          return t.sort(Vt), t.length;
        }, $t.prototype = {
          start: function start() {
            return this.edge.l === this.site ? this.edge.a : this.edge.b;
          },
          end: function end() {
            return this.edge.l === this.site ? this.edge.b : this.edge.a;
          }
        }, er.prototype = {
          insert: function insert(e, t) {
            var r, n, a;
            if (e) {
              if (t.P = e, t.N = e.N, e.N && (e.N.P = t), e.N = t, e.R) {
                for (e = e.R; e.L;) e = e.L;
                e.L = t;
              } else e.R = t;
              r = e;
            } else this._ ? (e = ar(this._), t.P = null, t.N = e, e.P = e.L = t, r = e) : (t.P = t.N = null, this._ = t, r = null);
            for (t.L = t.R = null, t.U = r, t.C = !0, e = t; r && r.C;) r === (n = r.U).L ? (a = n.R) && a.C ? (r.C = a.C = !1, n.C = !0, e = n) : (e === r.R && (rr(this, r), r = (e = r).U), r.C = !1, n.C = !0, nr(this, n)) : (a = n.L) && a.C ? (r.C = a.C = !1, n.C = !0, e = n) : (e === r.L && (nr(this, r), r = (e = r).U), r.C = !1, n.C = !0, rr(this, n)), r = e.U;
            this._.C = !1;
          },
          remove: function remove(e) {
            e.N && (e.N.P = e.P), e.P && (e.P.N = e.N), e.N = e.P = null;
            var t,
              r,
              n,
              a = e.U,
              i = e.L,
              o = e.R;
            if (r = i ? o ? ar(o) : i : o, a ? a.L === e ? a.L = r : a.R = r : this._ = r, i && o ? (n = r.C, r.C = e.C, r.L = i, i.U = r, r !== o ? (a = r.U, r.U = e.U, e = r.R, a.L = e, r.R = o, o.U = r) : (r.U = a, a = r, e = r.R)) : (n = e.C, e = r), e && (e.U = a), !n) if (e && e.C) e.C = !1;else {
              do {
                if (e === this._) break;
                if (e === a.L) {
                  if ((t = a.R).C && (t.C = !1, a.C = !0, rr(this, a), t = a.R), t.L && t.L.C || t.R && t.R.C) {
                    t.R && t.R.C || (t.L.C = !1, t.C = !0, nr(this, t), t = a.R), t.C = a.C, a.C = t.R.C = !1, rr(this, a), e = this._;
                    break;
                  }
                } else if ((t = a.L).C && (t.C = !1, a.C = !0, nr(this, a), t = a.L), t.L && t.L.C || t.R && t.R.C) {
                  t.L && t.L.C || (t.R.C = !1, t.C = !0, rr(this, t), t = a.L), t.C = a.C, a.C = t.L.C = !1, nr(this, a), e = this._;
                  break;
                }
                t.C = !0, e = a, a = a.U;
              } while (!e.C);
              e && (e.C = !1);
            }
          }
        }, e.geom.voronoi = function (e) {
          var t = _t,
            r = wt,
            n = t,
            a = r,
            i = lr;
          if (e) return o(e);
          function o(e) {
            var t = new Array(e.length),
              r = i[0][0],
              n = i[0][1],
              a = i[1][0],
              o = i[1][1];
            return ir(l(e), i).cells.forEach(function (i, l) {
              var s = i.edges,
                c = i.site;
              (t[l] = s.length ? s.map(function (e) {
                var t = e.start();
                return [t.x, t.y];
              }) : c.x >= r && c.x <= a && c.y >= n && c.y <= o ? [[r, o], [a, o], [a, n], [r, n]] : []).point = e[l];
            }), t;
          }
          function l(e) {
            return e.map(function (e, t) {
              return {
                x: Math.round(n(e, t) / Te) * Te,
                y: Math.round(a(e, t) / Te) * Te,
                i: t
              };
            });
          }
          return o.links = function (e) {
            return ir(l(e)).edges.filter(function (e) {
              return e.l && e.r;
            }).map(function (t) {
              return {
                source: e[t.l.i],
                target: e[t.r.i]
              };
            });
          }, o.triangles = function (e) {
            var t = [];
            return ir(l(e)).cells.forEach(function (r, n) {
              for (var a, i, o, l, s = r.site, c = r.edges.sort(Vt), u = -1, d = c.length, f = c[d - 1].edge, h = f.l === s ? f.r : f.l; ++u < d;) f, a = h, h = (f = c[u].edge).l === s ? f.r : f.l, n < a.i && n < h.i && (o = a, l = h, ((i = s).x - l.x) * (o.y - i.y) - (i.x - o.x) * (l.y - i.y) < 0) && t.push([e[n], e[a.i], e[h.i]]);
            }), t;
          }, o.x = function (e) {
            return arguments.length ? (n = ct(t = e), o) : t;
          }, o.y = function (e) {
            return arguments.length ? (a = ct(r = e), o) : r;
          }, o.clipExtent = function (e) {
            return arguments.length ? (i = null == e ? lr : e, o) : i === lr ? null : i;
          }, o.size = function (e) {
            return arguments.length ? o.clipExtent(e && [[0, 0], e]) : i === lr ? null : i && i[1];
          }, o;
        };
        var lr = [[-1e6, -1e6], [1e6, 1e6]];
        function sr(e) {
          return e.x;
        }
        function cr(e) {
          return e.y;
        }
        function ur(e, t, r, n, a, i) {
          if (!e(t, r, n, a, i)) {
            var o = .5 * (r + a),
              l = .5 * (n + i),
              s = t.nodes;
            s[0] && ur(e, s[0], r, n, o, l), s[1] && ur(e, s[1], o, n, a, l), s[2] && ur(e, s[2], r, l, o, i), s[3] && ur(e, s[3], o, l, a, i);
          }
        }
        function dr(e, t, r, n, a, i, o) {
          var l,
            s = 1 / 0;
          return function e(c, u, d, f, h) {
            if (!(u > i || d > o || f < n || h < a)) {
              if (p = c.point) {
                var p,
                  g = t - c.x,
                  m = r - c.y,
                  y = g * g + m * m;
                if (y < s) {
                  var v = Math.sqrt(s = y);
                  n = t - v, a = r - v, i = t + v, o = r + v, l = p;
                }
              }
              for (var x = c.nodes, b = .5 * (u + f), _ = .5 * (d + h), w = (r >= _) << 1 | t >= b, M = w + 4; w < M; ++w) if (c = x[3 & w]) switch (3 & w) {
                case 0:
                  e(c, u, d, b, _);
                  break;
                case 1:
                  e(c, b, d, f, _);
                  break;
                case 2:
                  e(c, u, _, b, h);
                  break;
                case 3:
                  e(c, b, _, f, h);
              }
            }
          }(e, n, a, i, o), l;
        }
        function fr(t, r) {
          t = e.rgb(t), r = e.rgb(r);
          var n = t.r,
            a = t.g,
            i = t.b,
            o = r.r - n,
            l = r.g - a,
            s = r.b - i;
          return function (e) {
            return "#" + rt(Math.round(n + o * e)) + rt(Math.round(a + l * e)) + rt(Math.round(i + s * e));
          };
        }
        function hr(e, t) {
          var r,
            n = {},
            a = {};
          for (r in e) r in t ? n[r] = vr(e[r], t[r]) : a[r] = e[r];
          for (r in t) r in e || (a[r] = t[r]);
          return function (e) {
            for (r in n) a[r] = n[r](e);
            return a;
          };
        }
        function pr(e, t) {
          return e = +e, t = +t, function (r) {
            return e * (1 - r) + t * r;
          };
        }
        function gr(e, t) {
          var r,
            n,
            a,
            i = mr.lastIndex = yr.lastIndex = 0,
            o = -1,
            l = [],
            s = [];
          for (e += "", t += ""; (r = mr.exec(e)) && (n = yr.exec(t));) (a = n.index) > i && (a = t.slice(i, a), l[o] ? l[o] += a : l[++o] = a), (r = r[0]) === (n = n[0]) ? l[o] ? l[o] += n : l[++o] = n : (l[++o] = null, s.push({
            i: o,
            x: pr(r, n)
          })), i = yr.lastIndex;
          return i < t.length && (a = t.slice(i), l[o] ? l[o] += a : l[++o] = a), l.length < 2 ? s[0] ? (t = s[0].x, function (e) {
            return t(e) + "";
          }) : function () {
            return t;
          } : (t = s.length, function (e) {
            for (var r, n = 0; n < t; ++n) l[(r = s[n]).i] = r.x(e);
            return l.join("");
          });
        }
        e.geom.delaunay = function (t) {
          return e.geom.voronoi().triangles(t);
        }, e.geom.quadtree = function (e, t, r, n, a) {
          var i,
            o = _t,
            l = wt;
          if (i = arguments.length) return o = sr, l = cr, 3 === i && (a = r, n = t, r = t = 0), s(e);
          function s(e) {
            var s,
              c,
              u,
              d,
              f,
              h,
              p,
              g,
              m,
              y = ct(o),
              x = ct(l);
            if (null != t) h = t, p = r, g = n, m = a;else if (g = m = -(h = p = 1 / 0), c = [], u = [], f = e.length, i) for (d = 0; d < f; ++d) (s = e[d]).x < h && (h = s.x), s.y < p && (p = s.y), s.x > g && (g = s.x), s.y > m && (m = s.y), c.push(s.x), u.push(s.y);else for (d = 0; d < f; ++d) {
              var b = +y(s = e[d], d),
                _ = +x(s, d);
              b < h && (h = b), _ < p && (p = _), b > g && (g = b), _ > m && (m = _), c.push(b), u.push(_);
            }
            var w = g - h,
              M = m - p;
            function T(e, t, r, n, a, i, o, l) {
              if (!isNaN(r) && !isNaN(n)) if (e.leaf) {
                var s = e.x,
                  c = e.y;
                if (null != s) {
                  if (v(s - r) + v(c - n) < .01) k(e, t, r, n, a, i, o, l);else {
                    var u = e.point;
                    e.x = e.y = e.point = null, k(e, u, s, c, a, i, o, l), k(e, t, r, n, a, i, o, l);
                  }
                } else e.x = r, e.y = n, e.point = t;
              } else k(e, t, r, n, a, i, o, l);
            }
            function k(e, t, r, n, a, i, o, l) {
              var s = .5 * (a + o),
                c = .5 * (i + l),
                u = r >= s,
                d = n >= c,
                f = d << 1 | u;
              e.leaf = !1, u ? a = s : o = s, d ? i = c : l = c, T(e = e.nodes[f] || (e.nodes[f] = {
                leaf: !0,
                nodes: [],
                point: null,
                x: null,
                y: null
              }), t, r, n, a, i, o, l);
            }
            w > M ? m = p + w : g = h + M;
            var A = {
              leaf: !0,
              nodes: [],
              point: null,
              x: null,
              y: null,
              add: function add(e) {
                T(A, e, +y(e, ++d), +x(e, d), h, p, g, m);
              },
              visit: function visit(e) {
                ur(e, A, h, p, g, m);
              },
              find: function find(e) {
                return dr(A, e[0], e[1], h, p, g, m);
              }
            };
            if (d = -1, null == t) {
              for (; ++d < f;) T(A, e[d], c[d], u[d], h, p, g, m);
              --d;
            } else e.forEach(A.add);
            return c = u = e = s = null, A;
          }
          return s.x = function (e) {
            return arguments.length ? (o = e, s) : o;
          }, s.y = function (e) {
            return arguments.length ? (l = e, s) : l;
          }, s.extent = function (e) {
            return arguments.length ? (null == e ? t = r = n = a = null : (t = +e[0][0], r = +e[0][1], n = +e[1][0], a = +e[1][1]), s) : null == t ? null : [[t, r], [n, a]];
          }, s.size = function (e) {
            return arguments.length ? (null == e ? t = r = n = a = null : (t = r = 0, n = +e[0], a = +e[1]), s) : null == t ? null : [n - t, a - r];
          }, s;
        }, e.interpolateRgb = fr, e.interpolateObject = hr, e.interpolateNumber = pr, e.interpolateString = gr;
        var mr = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
          yr = new RegExp(mr.source, "g");
        function vr(t, r) {
          for (var n, a = e.interpolators.length; --a >= 0 && !(n = e.interpolators[a](t, r)););
          return n;
        }
        function xr(e, t) {
          var r,
            n = [],
            a = [],
            i = e.length,
            o = t.length,
            l = Math.min(e.length, t.length);
          for (r = 0; r < l; ++r) n.push(vr(e[r], t[r]));
          for (; r < i; ++r) a[r] = e[r];
          for (; r < o; ++r) a[r] = t[r];
          return function (e) {
            for (r = 0; r < l; ++r) a[r] = n[r](e);
            return a;
          };
        }
        e.interpolate = vr, e.interpolators = [function (e, t) {
          var r = typeof t;
          return ("string" === r ? st.has(t.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(t) ? fr : gr : t instanceof Fe ? fr : Array.isArray(t) ? xr : "object" === r && isNaN(t) ? hr : pr)(e, t);
        }], e.interpolateArray = xr;
        var br = function br() {
            return C;
          },
          _r = e.map({
            linear: br,
            poly: function poly(e) {
              return function (t) {
                return Math.pow(t, e);
              };
            },
            quad: function quad() {
              return Ar;
            },
            cubic: function cubic() {
              return Lr;
            },
            sin: function sin() {
              return Sr;
            },
            exp: function exp() {
              return Cr;
            },
            circle: function circle() {
              return Or;
            },
            elastic: function elastic(e, t) {
              var r;
              arguments.length < 2 && (t = .45);
              arguments.length ? r = t / Ae * Math.asin(1 / e) : (e = 1, r = t / 4);
              return function (n) {
                return 1 + e * Math.pow(2, -10 * n) * Math.sin((n - r) * Ae / t);
              };
            },
            back: function back(e) {
              e || (e = 1.70158);
              return function (t) {
                return t * t * ((e + 1) * t - e);
              };
            },
            bounce: function bounce() {
              return Pr;
            }
          }),
          wr = e.map({
            in: C,
            out: Tr,
            "in-out": kr,
            "out-in": function outIn(e) {
              return kr(Tr(e));
            }
          });
        function Mr(e) {
          return function (t) {
            return t <= 0 ? 0 : t >= 1 ? 1 : e(t);
          };
        }
        function Tr(e) {
          return function (t) {
            return 1 - e(1 - t);
          };
        }
        function kr(e) {
          return function (t) {
            return .5 * (t < .5 ? e(2 * t) : 2 - e(2 - 2 * t));
          };
        }
        function Ar(e) {
          return e * e;
        }
        function Lr(e) {
          return e * e * e;
        }
        function Dr(e) {
          if (e <= 0) return 0;
          if (e >= 1) return 1;
          var t = e * e,
            r = t * e;
          return 4 * (e < .5 ? r : 3 * (e - t) + r - .75);
        }
        function Sr(e) {
          return 1 - Math.cos(e * De);
        }
        function Cr(e) {
          return Math.pow(2, 10 * (e - 1));
        }
        function Or(e) {
          return 1 - Math.sqrt(1 - e * e);
        }
        function Pr(e) {
          return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + .75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + .9375 : 7.5625 * (e -= 2.625 / 2.75) * e + .984375;
        }
        function Ir(e, t) {
          return t -= e, function (r) {
            return Math.round(e + t * r);
          };
        }
        function zr(e) {
          var t,
            r,
            n,
            a = [e.a, e.b],
            i = [e.c, e.d],
            o = Nr(a),
            l = Rr(a, i),
            s = Nr(((t = i)[0] += (n = -l) * (r = a)[0], t[1] += n * r[1], t)) || 0;
          a[0] * i[1] < i[0] * a[1] && (a[0] *= -1, a[1] *= -1, o *= -1, l *= -1), this.rotate = (o ? Math.atan2(a[1], a[0]) : Math.atan2(-i[0], i[1])) * Ce, this.translate = [e.e, e.f], this.scale = [o, s], this.skew = s ? Math.atan2(l, s) * Ce : 0;
        }
        function Rr(e, t) {
          return e[0] * t[0] + e[1] * t[1];
        }
        function Nr(e) {
          var t = Math.sqrt(Rr(e, e));
          return t && (e[0] /= t, e[1] /= t), t;
        }
        e.ease = function (e) {
          var t = e.indexOf("-"),
            n = t >= 0 ? e.slice(0, t) : e,
            a = t >= 0 ? e.slice(t + 1) : "in";
          return n = _r.get(n) || br, Mr((a = wr.get(a) || C)(n.apply(null, r.call(arguments, 1))));
        }, e.interpolateHcl = function (t, r) {
          t = e.hcl(t), r = e.hcl(r);
          var n = t.h,
            a = t.c,
            i = t.l,
            o = r.h - n,
            l = r.c - a,
            s = r.l - i;
          isNaN(l) && (l = 0, a = isNaN(a) ? r.c : a);
          isNaN(o) ? (o = 0, n = isNaN(n) ? r.h : n) : o > 180 ? o -= 360 : o < -180 && (o += 360);
          return function (e) {
            return Ue(n + o * e, a + l * e, i + s * e) + "";
          };
        }, e.interpolateHsl = function (t, r) {
          t = e.hsl(t), r = e.hsl(r);
          var n = t.h,
            a = t.s,
            i = t.l,
            o = r.h - n,
            l = r.s - a,
            s = r.l - i;
          isNaN(l) && (l = 0, a = isNaN(a) ? r.s : a);
          isNaN(o) ? (o = 0, n = isNaN(n) ? r.h : n) : o > 180 ? o -= 360 : o < -180 && (o += 360);
          return function (e) {
            return He(n + o * e, a + l * e, i + s * e) + "";
          };
        }, e.interpolateLab = function (t, r) {
          t = e.lab(t), r = e.lab(r);
          var n = t.l,
            a = t.a,
            i = t.b,
            o = r.l - n,
            l = r.a - a,
            s = r.b - i;
          return function (e) {
            return Ze(n + o * e, a + l * e, i + s * e) + "";
          };
        }, e.interpolateRound = Ir, e.transform = function (t) {
          var r = a.createElementNS(e.ns.prefix.svg, "g");
          return (e.transform = function (e) {
            if (null != e) {
              r.setAttribute("transform", e);
              var t = r.transform.baseVal.consolidate();
            }
            return new zr(t ? t.matrix : Fr);
          })(t);
        }, zr.prototype.toString = function () {
          return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
        };
        var Fr = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: 0,
          f: 0
        };
        function Er(e) {
          return e.length ? e.pop() + "," : "";
        }
        function jr(t, r) {
          var n = [],
            a = [];
          return t = e.transform(t), r = e.transform(r), function (e, t, r, n) {
            if (e[0] !== t[0] || e[1] !== t[1]) {
              var a = r.push("translate(", null, ",", null, ")");
              n.push({
                i: a - 4,
                x: pr(e[0], t[0])
              }, {
                i: a - 2,
                x: pr(e[1], t[1])
              });
            } else (t[0] || t[1]) && r.push("translate(" + t + ")");
          }(t.translate, r.translate, n, a), function (e, t, r, n) {
            e !== t ? (e - t > 180 ? t += 360 : t - e > 180 && (e += 360), n.push({
              i: r.push(Er(r) + "rotate(", null, ")") - 2,
              x: pr(e, t)
            })) : t && r.push(Er(r) + "rotate(" + t + ")");
          }(t.rotate, r.rotate, n, a), function (e, t, r, n) {
            e !== t ? n.push({
              i: r.push(Er(r) + "skewX(", null, ")") - 2,
              x: pr(e, t)
            }) : t && r.push(Er(r) + "skewX(" + t + ")");
          }(t.skew, r.skew, n, a), function (e, t, r, n) {
            if (e[0] !== t[0] || e[1] !== t[1]) {
              var a = r.push(Er(r) + "scale(", null, ",", null, ")");
              n.push({
                i: a - 4,
                x: pr(e[0], t[0])
              }, {
                i: a - 2,
                x: pr(e[1], t[1])
              });
            } else 1 === t[0] && 1 === t[1] || r.push(Er(r) + "scale(" + t + ")");
          }(t.scale, r.scale, n, a), t = r = null, function (e) {
            for (var t, r = -1, i = a.length; ++r < i;) n[(t = a[r]).i] = t.x(e);
            return n.join("");
          };
        }
        function Hr(e, t) {
          return t = (t -= e = +e) || 1 / t, function (r) {
            return (r - e) / t;
          };
        }
        function Br(e, t) {
          return t = (t -= e = +e) || 1 / t, function (r) {
            return Math.max(0, Math.min(1, (r - e) / t));
          };
        }
        function Yr(e) {
          for (var t = e.source, r = e.target, n = function (e, t) {
              if (e === t) return e;
              var r = Ur(e),
                n = Ur(t),
                a = r.pop(),
                i = n.pop(),
                o = null;
              for (; a === i;) o = a, a = r.pop(), i = n.pop();
              return o;
            }(t, r), a = [t]; t !== n;) t = t.parent, a.push(t);
          for (var i = a.length; r !== n;) a.splice(i, 0, r), r = r.parent;
          return a;
        }
        function Ur(e) {
          for (var t = [], r = e.parent; null != r;) t.push(e), e = r, r = r.parent;
          return t.push(e), t;
        }
        function Vr(e) {
          e.fixed |= 2;
        }
        function qr(e) {
          e.fixed &= -7;
        }
        function Gr(e) {
          e.fixed |= 4, e.px = e.x, e.py = e.y;
        }
        function Zr(e) {
          e.fixed &= -5;
        }
        e.interpolateTransform = jr, e.layout = {}, e.layout.bundle = function () {
          return function (e) {
            for (var t = [], r = -1, n = e.length; ++r < n;) t.push(Yr(e[r]));
            return t;
          };
        }, e.layout.chord = function () {
          var t,
            r,
            n,
            a,
            i,
            o,
            l,
            s = {},
            c = 0;
          function u() {
            var s,
              u,
              f,
              h,
              p,
              g = {},
              m = [],
              y = e.range(a),
              v = [];
            for (t = [], r = [], s = 0, h = -1; ++h < a;) {
              for (u = 0, p = -1; ++p < a;) u += n[h][p];
              m.push(u), v.push(e.range(a)), s += u;
            }
            for (i && y.sort(function (e, t) {
              return i(m[e], m[t]);
            }), o && v.forEach(function (e, t) {
              e.sort(function (e, r) {
                return o(n[t][e], n[t][r]);
              });
            }), s = (Ae - c * a) / s, u = 0, h = -1; ++h < a;) {
              for (f = u, p = -1; ++p < a;) {
                var x = y[h],
                  b = v[x][p],
                  _ = n[x][b],
                  w = u,
                  M = u += _ * s;
                g[x + "-" + b] = {
                  index: x,
                  subindex: b,
                  startAngle: w,
                  endAngle: M,
                  value: _
                };
              }
              r[x] = {
                index: x,
                startAngle: f,
                endAngle: u,
                value: m[x]
              }, u += c;
            }
            for (h = -1; ++h < a;) for (p = h - 1; ++p < a;) {
              var T = g[h + "-" + p],
                k = g[p + "-" + h];
              (T.value || k.value) && t.push(T.value < k.value ? {
                source: k,
                target: T
              } : {
                source: T,
                target: k
              });
            }
            l && d();
          }
          function d() {
            t.sort(function (e, t) {
              return l((e.source.value + e.target.value) / 2, (t.source.value + t.target.value) / 2);
            });
          }
          return s.matrix = function (e) {
            return arguments.length ? (a = (n = e) && n.length, t = r = null, s) : n;
          }, s.padding = function (e) {
            return arguments.length ? (c = e, t = r = null, s) : c;
          }, s.sortGroups = function (e) {
            return arguments.length ? (i = e, t = r = null, s) : i;
          }, s.sortSubgroups = function (e) {
            return arguments.length ? (o = e, t = null, s) : o;
          }, s.sortChords = function (e) {
            return arguments.length ? (l = e, t && d(), s) : l;
          }, s.chords = function () {
            return t || u(), t;
          }, s.groups = function () {
            return r || u(), r;
          }, s;
        }, e.layout.force = function () {
          var t,
            r,
            n,
            a,
            i,
            o,
            l = {},
            s = e.dispatch("start", "tick", "end"),
            c = [1, 1],
            u = .9,
            d = Wr,
            f = Jr,
            h = -30,
            p = Xr,
            g = .1,
            m = .64,
            y = [],
            v = [];
          function x(e) {
            return function (t, r, n, a) {
              if (t.point !== e) {
                var i = t.cx - e.x,
                  o = t.cy - e.y,
                  l = a - r,
                  s = i * i + o * o;
                if (l * l / m < s) {
                  if (s < p) {
                    var c = t.charge / s;
                    e.px -= i * c, e.py -= o * c;
                  }
                  return !0;
                }
                if (t.point && s && s < p) {
                  c = t.pointCharge / s;
                  e.px -= i * c, e.py -= o * c;
                }
              }
              return !t.charge;
            };
          }
          function b(t) {
            t.px = e.event.x, t.py = e.event.y, l.resume();
          }
          return l.tick = function () {
            if ((n *= .99) < .005) return t = null, s.end({
              type: "end",
              alpha: n = 0
            }), !0;
            var r,
              l,
              d,
              f,
              p,
              m,
              b,
              _,
              w,
              M = y.length,
              T = v.length;
            for (l = 0; l < T; ++l) f = (d = v[l]).source, (m = (_ = (p = d.target).x - f.x) * _ + (w = p.y - f.y) * w) && (_ *= m = n * i[l] * ((m = Math.sqrt(m)) - a[l]) / m, w *= m, p.x -= _ * (b = f.weight + p.weight ? f.weight / (f.weight + p.weight) : .5), p.y -= w * b, f.x += _ * (b = 1 - b), f.y += w * b);
            if ((b = n * g) && (_ = c[0] / 2, w = c[1] / 2, l = -1, b)) for (; ++l < M;) (d = y[l]).x += (_ - d.x) * b, d.y += (w - d.y) * b;
            if (h) for (!function e(t, r, n) {
              var a = 0,
                i = 0;
              if (t.charge = 0, !t.leaf) for (var o, l = t.nodes, s = l.length, c = -1; ++c < s;) null != (o = l[c]) && (e(o, r, n), t.charge += o.charge, a += o.charge * o.cx, i += o.charge * o.cy);
              if (t.point) {
                t.leaf || (t.point.x += Math.random() - .5, t.point.y += Math.random() - .5);
                var u = r * n[t.point.index];
                t.charge += t.pointCharge = u, a += u * t.point.x, i += u * t.point.y;
              }
              t.cx = a / t.charge, t.cy = i / t.charge;
            }(r = e.geom.quadtree(y), n, o), l = -1; ++l < M;) (d = y[l]).fixed || r.visit(x(d));
            for (l = -1; ++l < M;) (d = y[l]).fixed ? (d.x = d.px, d.y = d.py) : (d.x -= (d.px - (d.px = d.x)) * u, d.y -= (d.py - (d.py = d.y)) * u);
            s.tick({
              type: "tick",
              alpha: n
            });
          }, l.nodes = function (e) {
            return arguments.length ? (y = e, l) : y;
          }, l.links = function (e) {
            return arguments.length ? (v = e, l) : v;
          }, l.size = function (e) {
            return arguments.length ? (c = e, l) : c;
          }, l.linkDistance = function (e) {
            return arguments.length ? (d = "function" == typeof e ? e : +e, l) : d;
          }, l.distance = l.linkDistance, l.linkStrength = function (e) {
            return arguments.length ? (f = "function" == typeof e ? e : +e, l) : f;
          }, l.friction = function (e) {
            return arguments.length ? (u = +e, l) : u;
          }, l.charge = function (e) {
            return arguments.length ? (h = "function" == typeof e ? e : +e, l) : h;
          }, l.chargeDistance = function (e) {
            return arguments.length ? (p = e * e, l) : Math.sqrt(p);
          }, l.gravity = function (e) {
            return arguments.length ? (g = +e, l) : g;
          }, l.theta = function (e) {
            return arguments.length ? (m = e * e, l) : Math.sqrt(m);
          }, l.alpha = function (e) {
            return arguments.length ? (e = +e, n ? e > 0 ? n = e : (t.c = null, t.t = NaN, t = null, s.end({
              type: "end",
              alpha: n = 0
            })) : e > 0 && (s.start({
              type: "start",
              alpha: n = e
            }), t = yt(l.tick)), l) : n;
          }, l.start = function () {
            var e,
              t,
              r,
              n = y.length,
              s = v.length,
              u = c[0],
              p = c[1];
            for (e = 0; e < n; ++e) (r = y[e]).index = e, r.weight = 0;
            for (e = 0; e < s; ++e) "number" == typeof (r = v[e]).source && (r.source = y[r.source]), "number" == typeof r.target && (r.target = y[r.target]), ++r.source.weight, ++r.target.weight;
            for (e = 0; e < n; ++e) r = y[e], isNaN(r.x) && (r.x = g("x", u)), isNaN(r.y) && (r.y = g("y", p)), isNaN(r.px) && (r.px = r.x), isNaN(r.py) && (r.py = r.y);
            if (a = [], "function" == typeof d) for (e = 0; e < s; ++e) a[e] = +d.call(this, v[e], e);else for (e = 0; e < s; ++e) a[e] = d;
            if (i = [], "function" == typeof f) for (e = 0; e < s; ++e) i[e] = +f.call(this, v[e], e);else for (e = 0; e < s; ++e) i[e] = f;
            if (o = [], "function" == typeof h) for (e = 0; e < n; ++e) o[e] = +h.call(this, y[e], e);else for (e = 0; e < n; ++e) o[e] = h;
            function g(r, a) {
              if (!t) {
                for (t = new Array(n), c = 0; c < n; ++c) t[c] = [];
                for (c = 0; c < s; ++c) {
                  var i = v[c];
                  t[i.source.index].push(i.target), t[i.target.index].push(i.source);
                }
              }
              for (var o, l = t[e], c = -1, u = l.length; ++c < u;) if (!isNaN(o = l[c][r])) return o;
              return Math.random() * a;
            }
            return l.resume();
          }, l.resume = function () {
            return l.alpha(.1);
          }, l.stop = function () {
            return l.alpha(0);
          }, l.drag = function () {
            if (r || (r = e.behavior.drag().origin(C).on("dragstart.force", Vr).on("drag.force", b).on("dragend.force", qr)), !arguments.length) return r;
            this.on("mouseover.force", Gr).on("mouseout.force", Zr).call(r);
          }, e.rebind(l, s, "on");
        };
        var Wr = 20,
          Jr = 1,
          Xr = 1 / 0;
        function Qr(t, r) {
          return e.rebind(t, r, "sort", "children", "value"), t.nodes = t, t.links = nn, t;
        }
        function Kr(e, t) {
          for (var r = [e]; null != (e = r.pop());) if (t(e), (a = e.children) && (n = a.length)) for (var n, a; --n >= 0;) r.push(a[n]);
        }
        function $r(e, t) {
          for (var r = [e], n = []; null != (e = r.pop());) if (n.push(e), (i = e.children) && (a = i.length)) for (var a, i, o = -1; ++o < a;) r.push(i[o]);
          for (; null != (e = n.pop());) t(e);
        }
        function en(e) {
          return e.children;
        }
        function tn(e) {
          return e.value;
        }
        function rn(e, t) {
          return t.value - e.value;
        }
        function nn(t) {
          return e.merge(t.map(function (e) {
            return (e.children || []).map(function (t) {
              return {
                source: e,
                target: t
              };
            });
          }));
        }
        e.layout.hierarchy = function () {
          var e = rn,
            t = en,
            r = tn;
          function n(a) {
            var i,
              o = [a],
              l = [];
            for (a.depth = 0; null != (i = o.pop());) if (l.push(i), (c = t.call(n, i, i.depth)) && (s = c.length)) {
              for (var s, c, u; --s >= 0;) o.push(u = c[s]), u.parent = i, u.depth = i.depth + 1;
              r && (i.value = 0), i.children = c;
            } else r && (i.value = +r.call(n, i, i.depth) || 0), delete i.children;
            return $r(a, function (t) {
              var n, a;
              e && (n = t.children) && n.sort(e), r && (a = t.parent) && (a.value += t.value);
            }), l;
          }
          return n.sort = function (t) {
            return arguments.length ? (e = t, n) : e;
          }, n.children = function (e) {
            return arguments.length ? (t = e, n) : t;
          }, n.value = function (e) {
            return arguments.length ? (r = e, n) : r;
          }, n.revalue = function (e) {
            return r && (Kr(e, function (e) {
              e.children && (e.value = 0);
            }), $r(e, function (e) {
              var t;
              e.children || (e.value = +r.call(n, e, e.depth) || 0), (t = e.parent) && (t.value += e.value);
            })), e;
          }, n;
        }, e.layout.partition = function () {
          var t = e.layout.hierarchy(),
            r = [1, 1];
          function n(e, n) {
            var a = t.call(this, e, n);
            return function e(t, r, n, a) {
              var i = t.children;
              if (t.x = r, t.y = t.depth * a, t.dx = n, t.dy = a, i && (o = i.length)) {
                var o,
                  l,
                  s,
                  c = -1;
                for (n = t.value ? n / t.value : 0; ++c < o;) e(l = i[c], r, s = l.value * n, a), r += s;
              }
            }(a[0], 0, r[0], r[1] / function e(t) {
              var r = t.children,
                n = 0;
              if (r && (a = r.length)) for (var a, i = -1; ++i < a;) n = Math.max(n, e(r[i]));
              return 1 + n;
            }(a[0])), a;
          }
          return n.size = function (e) {
            return arguments.length ? (r = e, n) : r;
          }, Qr(n, t);
        }, e.layout.pie = function () {
          var t = Number,
            r = an,
            n = 0,
            a = Ae,
            i = 0;
          function o(l) {
            var s,
              c = l.length,
              u = l.map(function (e, r) {
                return +t.call(o, e, r);
              }),
              d = +("function" == typeof n ? n.apply(this, arguments) : n),
              f = ("function" == typeof a ? a.apply(this, arguments) : a) - d,
              h = Math.min(Math.abs(f) / c, +("function" == typeof i ? i.apply(this, arguments) : i)),
              p = h * (f < 0 ? -1 : 1),
              g = e.sum(u),
              m = g ? (f - c * p) / g : 0,
              y = e.range(c),
              v = [];
            return null != r && y.sort(r === an ? function (e, t) {
              return u[t] - u[e];
            } : function (e, t) {
              return r(l[e], l[t]);
            }), y.forEach(function (e) {
              v[e] = {
                data: l[e],
                value: s = u[e],
                startAngle: d,
                endAngle: d += s * m + p,
                padAngle: h
              };
            }), v;
          }
          return o.value = function (e) {
            return arguments.length ? (t = e, o) : t;
          }, o.sort = function (e) {
            return arguments.length ? (r = e, o) : r;
          }, o.startAngle = function (e) {
            return arguments.length ? (n = e, o) : n;
          }, o.endAngle = function (e) {
            return arguments.length ? (a = e, o) : a;
          }, o.padAngle = function (e) {
            return arguments.length ? (i = e, o) : i;
          }, o;
        };
        var an = {};
        function on(e) {
          return e.x;
        }
        function ln(e) {
          return e.y;
        }
        function sn(e, t, r) {
          e.y0 = t, e.y = r;
        }
        e.layout.stack = function () {
          var t = C,
            r = dn,
            n = fn,
            a = sn,
            i = on,
            o = ln;
          function l(s, c) {
            if (!(h = s.length)) return s;
            var u = s.map(function (e, r) {
                return t.call(l, e, r);
              }),
              d = u.map(function (e) {
                return e.map(function (e, t) {
                  return [i.call(l, e, t), o.call(l, e, t)];
                });
              }),
              f = r.call(l, d, c);
            u = e.permute(u, f), d = e.permute(d, f);
            var h,
              p,
              g,
              m,
              y = n.call(l, d, c),
              v = u[0].length;
            for (g = 0; g < v; ++g) for (a.call(l, u[0][g], m = y[g], d[0][g][1]), p = 1; p < h; ++p) a.call(l, u[p][g], m += d[p - 1][g][1], d[p][g][1]);
            return s;
          }
          return l.values = function (e) {
            return arguments.length ? (t = e, l) : t;
          }, l.order = function (e) {
            return arguments.length ? (r = "function" == typeof e ? e : cn.get(e) || dn, l) : r;
          }, l.offset = function (e) {
            return arguments.length ? (n = "function" == typeof e ? e : un.get(e) || fn, l) : n;
          }, l.x = function (e) {
            return arguments.length ? (i = e, l) : i;
          }, l.y = function (e) {
            return arguments.length ? (o = e, l) : o;
          }, l.out = function (e) {
            return arguments.length ? (a = e, l) : a;
          }, l;
        };
        var cn = e.map({
            "inside-out": function insideOut(t) {
              var r,
                n,
                a = t.length,
                i = t.map(hn),
                o = t.map(pn),
                l = e.range(a).sort(function (e, t) {
                  return i[e] - i[t];
                }),
                s = 0,
                c = 0,
                u = [],
                d = [];
              for (r = 0; r < a; ++r) n = l[r], s < c ? (s += o[n], u.push(n)) : (c += o[n], d.push(n));
              return d.reverse().concat(u);
            },
            reverse: function reverse(t) {
              return e.range(t.length).reverse();
            },
            default: dn
          }),
          un = e.map({
            silhouette: function silhouette(e) {
              var t,
                r,
                n,
                a = e.length,
                i = e[0].length,
                o = [],
                l = 0,
                s = [];
              for (r = 0; r < i; ++r) {
                for (t = 0, n = 0; t < a; t++) n += e[t][r][1];
                n > l && (l = n), o.push(n);
              }
              for (r = 0; r < i; ++r) s[r] = (l - o[r]) / 2;
              return s;
            },
            wiggle: function wiggle(e) {
              var t,
                r,
                n,
                a,
                i,
                o,
                l,
                s,
                c,
                u = e.length,
                d = e[0],
                f = d.length,
                h = [];
              for (h[0] = s = c = 0, r = 1; r < f; ++r) {
                for (t = 0, a = 0; t < u; ++t) a += e[t][r][1];
                for (t = 0, i = 0, l = d[r][0] - d[r - 1][0]; t < u; ++t) {
                  for (n = 0, o = (e[t][r][1] - e[t][r - 1][1]) / (2 * l); n < t; ++n) o += (e[n][r][1] - e[n][r - 1][1]) / l;
                  i += o * e[t][r][1];
                }
                h[r] = s -= a ? i / a * l : 0, s < c && (c = s);
              }
              for (r = 0; r < f; ++r) h[r] -= c;
              return h;
            },
            expand: function expand(e) {
              var t,
                r,
                n,
                a = e.length,
                i = e[0].length,
                o = 1 / a,
                l = [];
              for (r = 0; r < i; ++r) {
                for (t = 0, n = 0; t < a; t++) n += e[t][r][1];
                if (n) for (t = 0; t < a; t++) e[t][r][1] /= n;else for (t = 0; t < a; t++) e[t][r][1] = o;
              }
              for (r = 0; r < i; ++r) l[r] = 0;
              return l;
            },
            zero: fn
          });
        function dn(t) {
          return e.range(t.length);
        }
        function fn(e) {
          for (var t = -1, r = e[0].length, n = []; ++t < r;) n[t] = 0;
          return n;
        }
        function hn(e) {
          for (var t, r = 1, n = 0, a = e[0][1], i = e.length; r < i; ++r) (t = e[r][1]) > a && (n = r, a = t);
          return n;
        }
        function pn(e) {
          return e.reduce(gn, 0);
        }
        function gn(e, t) {
          return e + t[1];
        }
        function mn(e, t) {
          return yn(e, Math.ceil(Math.log(t.length) / Math.LN2 + 1));
        }
        function yn(e, t) {
          for (var r = -1, n = +e[0], a = (e[1] - n) / t, i = []; ++r <= t;) i[r] = a * r + n;
          return i;
        }
        function vn(t) {
          return [e.min(t), e.max(t)];
        }
        function xn(e, t) {
          return e.value - t.value;
        }
        function bn(e, t) {
          var r = e._pack_next;
          e._pack_next = t, t._pack_prev = e, t._pack_next = r, r._pack_prev = t;
        }
        function _n(e, t) {
          e._pack_next = t, t._pack_prev = e;
        }
        function wn(e, t) {
          var r = t.x - e.x,
            n = t.y - e.y,
            a = e.r + t.r;
          return .999 * a * a > r * r + n * n;
        }
        function Mn(e) {
          if ((t = e.children) && (s = t.length)) {
            var t,
              r,
              n,
              a,
              i,
              o,
              l,
              s,
              c = 1 / 0,
              u = -1 / 0,
              d = 1 / 0,
              f = -1 / 0;
            if (t.forEach(Tn), (r = t[0]).x = -r.r, r.y = 0, x(r), s > 1 && ((n = t[1]).x = n.r, n.y = 0, x(n), s > 2)) for (An(r, n, a = t[2]), x(a), bn(r, a), r._pack_prev = a, bn(a, n), n = r._pack_next, i = 3; i < s; i++) {
              An(r, n, a = t[i]);
              var h = 0,
                p = 1,
                g = 1;
              for (o = n._pack_next; o !== n; o = o._pack_next, p++) if (wn(o, a)) {
                h = 1;
                break;
              }
              if (1 == h) for (l = r._pack_prev; l !== o._pack_prev && !wn(l, a); l = l._pack_prev, g++);
              h ? (p < g || p == g && n.r < r.r ? _n(r, n = o) : _n(r = l, n), i--) : (bn(r, a), n = a, x(a));
            }
            var m = (c + u) / 2,
              y = (d + f) / 2,
              v = 0;
            for (i = 0; i < s; i++) (a = t[i]).x -= m, a.y -= y, v = Math.max(v, a.r + Math.sqrt(a.x * a.x + a.y * a.y));
            e.r = v, t.forEach(kn);
          }
          function x(e) {
            c = Math.min(e.x - e.r, c), u = Math.max(e.x + e.r, u), d = Math.min(e.y - e.r, d), f = Math.max(e.y + e.r, f);
          }
        }
        function Tn(e) {
          e._pack_next = e._pack_prev = e;
        }
        function kn(e) {
          delete e._pack_next, delete e._pack_prev;
        }
        function An(e, t, r) {
          var n = e.r + r.r,
            a = t.x - e.x,
            i = t.y - e.y;
          if (n && (a || i)) {
            var o = t.r + r.r,
              l = a * a + i * i,
              s = .5 + ((n *= n) - (o *= o)) / (2 * l),
              c = Math.sqrt(Math.max(0, 2 * o * (n + l) - (n -= l) * n - o * o)) / (2 * l);
            r.x = e.x + s * a + c * i, r.y = e.y + s * i - c * a;
          } else r.x = e.x + n, r.y = e.y;
        }
        function Ln(e, t) {
          return e.parent == t.parent ? 1 : 2;
        }
        function Dn(e) {
          var t = e.children;
          return t.length ? t[0] : e.t;
        }
        function Sn(e) {
          var t,
            r = e.children;
          return (t = r.length) ? r[t - 1] : e.t;
        }
        function Cn(e, t, r) {
          var n = r / (t.i - e.i);
          t.c -= n, t.s += r, e.c += n, t.z += r, t.m += r;
        }
        function On(e, t, r) {
          return e.a.parent === t.parent ? e.a : r;
        }
        function Pn(e) {
          return {
            x: e.x,
            y: e.y,
            dx: e.dx,
            dy: e.dy
          };
        }
        function In(e, t) {
          var r = e.x + t[3],
            n = e.y + t[0],
            a = e.dx - t[1] - t[3],
            i = e.dy - t[0] - t[2];
          return a < 0 && (r += a / 2, a = 0), i < 0 && (n += i / 2, i = 0), {
            x: r,
            y: n,
            dx: a,
            dy: i
          };
        }
        function zn(e) {
          var t = e[0],
            r = e[e.length - 1];
          return t < r ? [t, r] : [r, t];
        }
        function Rn(e) {
          return e.rangeExtent ? e.rangeExtent() : zn(e.range());
        }
        function Nn(e, t, r, n) {
          var a = r(e[0], e[1]),
            i = n(t[0], t[1]);
          return function (e) {
            return i(a(e));
          };
        }
        function Fn(e, t) {
          var r,
            n = 0,
            a = e.length - 1,
            i = e[n],
            o = e[a];
          return o < i && (r = n, n = a, a = r, r = i, i = o, o = r), e[n] = t.floor(i), e[a] = t.ceil(o), e;
        }
        function En(e) {
          return e ? {
            floor: function floor(t) {
              return Math.floor(t / e) * e;
            },
            ceil: function ceil(t) {
              return Math.ceil(t / e) * e;
            }
          } : jn;
        }
        e.layout.histogram = function () {
          var t = !0,
            r = Number,
            n = vn,
            a = mn;
          function i(i, o) {
            for (var l, s, c = [], u = i.map(r, this), d = n.call(this, u, o), f = a.call(this, d, u, o), h = (o = -1, u.length), p = f.length - 1, g = t ? 1 : 1 / h; ++o < p;) (l = c[o] = []).dx = f[o + 1] - (l.x = f[o]), l.y = 0;
            if (p > 0) for (o = -1; ++o < h;) (s = u[o]) >= d[0] && s <= d[1] && ((l = c[e.bisect(f, s, 1, p) - 1]).y += g, l.push(i[o]));
            return c;
          }
          return i.value = function (e) {
            return arguments.length ? (r = e, i) : r;
          }, i.range = function (e) {
            return arguments.length ? (n = ct(e), i) : n;
          }, i.bins = function (e) {
            return arguments.length ? (a = "number" == typeof e ? function (t) {
              return yn(t, e);
            } : ct(e), i) : a;
          }, i.frequency = function (e) {
            return arguments.length ? (t = !!e, i) : t;
          }, i;
        }, e.layout.pack = function () {
          var t,
            r = e.layout.hierarchy().sort(xn),
            n = 0,
            a = [1, 1];
          function i(e, i) {
            var o = r.call(this, e, i),
              l = o[0],
              s = a[0],
              c = a[1],
              u = null == t ? Math.sqrt : "function" == typeof t ? t : function () {
                return t;
              };
            if (l.x = l.y = 0, $r(l, function (e) {
              e.r = +u(e.value);
            }), $r(l, Mn), n) {
              var d = n * (t ? 1 : Math.max(2 * l.r / s, 2 * l.r / c)) / 2;
              $r(l, function (e) {
                e.r += d;
              }), $r(l, Mn), $r(l, function (e) {
                e.r -= d;
              });
            }
            return function e(t, r, n, a) {
              var i = t.children;
              if (t.x = r += a * t.x, t.y = n += a * t.y, t.r *= a, i) for (var o = -1, l = i.length; ++o < l;) e(i[o], r, n, a);
            }(l, s / 2, c / 2, t ? 1 : 1 / Math.max(2 * l.r / s, 2 * l.r / c)), o;
          }
          return i.size = function (e) {
            return arguments.length ? (a = e, i) : a;
          }, i.radius = function (e) {
            return arguments.length ? (t = null == e || "function" == typeof e ? e : +e, i) : t;
          }, i.padding = function (e) {
            return arguments.length ? (n = +e, i) : n;
          }, Qr(i, r);
        }, e.layout.tree = function () {
          var t = e.layout.hierarchy().sort(null).value(null),
            r = Ln,
            n = [1, 1],
            a = null;
          function i(e, i) {
            var c = t.call(this, e, i),
              u = c[0],
              d = function (e) {
                var t,
                  r = {
                    A: null,
                    children: [e]
                  },
                  n = [r];
                for (; null != (t = n.pop());) for (var a, i = t.children, o = 0, l = i.length; o < l; ++o) n.push((i[o] = a = {
                  _: i[o],
                  parent: t,
                  children: (a = i[o].children) && a.slice() || [],
                  A: null,
                  a: null,
                  z: 0,
                  m: 0,
                  c: 0,
                  s: 0,
                  t: null,
                  i: o
                }).a = a);
                return r.children[0];
              }(u);
            if ($r(d, o), d.parent.m = -d.z, Kr(d, l), a) Kr(u, s);else {
              var f = u,
                h = u,
                p = u;
              Kr(u, function (e) {
                e.x < f.x && (f = e), e.x > h.x && (h = e), e.depth > p.depth && (p = e);
              });
              var g = r(f, h) / 2 - f.x,
                m = n[0] / (h.x + r(h, f) / 2 + g),
                y = n[1] / (p.depth || 1);
              Kr(u, function (e) {
                e.x = (e.x + g) * m, e.y = e.depth * y;
              });
            }
            return c;
          }
          function o(e) {
            var t = e.children,
              n = e.parent.children,
              a = e.i ? n[e.i - 1] : null;
            if (t.length) {
              !function (e) {
                var t,
                  r = 0,
                  n = 0,
                  a = e.children,
                  i = a.length;
                for (; --i >= 0;) (t = a[i]).z += r, t.m += r, r += t.s + (n += t.c);
              }(e);
              var i = (t[0].z + t[t.length - 1].z) / 2;
              a ? (e.z = a.z + r(e._, a._), e.m = e.z - i) : e.z = i;
            } else a && (e.z = a.z + r(e._, a._));
            e.parent.A = function (e, t, n) {
              if (t) {
                for (var a, i = e, o = e, l = t, s = i.parent.children[0], c = i.m, u = o.m, d = l.m, f = s.m; l = Sn(l), i = Dn(i), l && i;) s = Dn(s), (o = Sn(o)).a = e, (a = l.z + d - i.z - c + r(l._, i._)) > 0 && (Cn(On(l, e, n), e, a), c += a, u += a), d += l.m, c += i.m, f += s.m, u += o.m;
                l && !Sn(o) && (o.t = l, o.m += d - u), i && !Dn(s) && (s.t = i, s.m += c - f, n = e);
              }
              return n;
            }(e, a, e.parent.A || n[0]);
          }
          function l(e) {
            e._.x = e.z + e.parent.m, e.m += e.parent.m;
          }
          function s(e) {
            e.x *= n[0], e.y = e.depth * n[1];
          }
          return i.separation = function (e) {
            return arguments.length ? (r = e, i) : r;
          }, i.size = function (e) {
            return arguments.length ? (a = null == (n = e) ? s : null, i) : a ? null : n;
          }, i.nodeSize = function (e) {
            return arguments.length ? (a = null == (n = e) ? null : s, i) : a ? n : null;
          }, Qr(i, t);
        }, e.layout.cluster = function () {
          var t = e.layout.hierarchy().sort(null).value(null),
            r = Ln,
            n = [1, 1],
            a = !1;
          function i(i, o) {
            var l,
              s = t.call(this, i, o),
              c = s[0],
              u = 0;
            $r(c, function (t) {
              var n = t.children;
              n && n.length ? (t.x = function (e) {
                return e.reduce(function (e, t) {
                  return e + t.x;
                }, 0) / e.length;
              }(n), t.y = function (t) {
                return 1 + e.max(t, function (e) {
                  return e.y;
                });
              }(n)) : (t.x = l ? u += r(t, l) : 0, t.y = 0, l = t);
            });
            var d = function e(t) {
                var r = t.children;
                return r && r.length ? e(r[0]) : t;
              }(c),
              f = function e(t) {
                var r,
                  n = t.children;
                return n && (r = n.length) ? e(n[r - 1]) : t;
              }(c),
              h = d.x - r(d, f) / 2,
              p = f.x + r(f, d) / 2;
            return $r(c, a ? function (e) {
              e.x = (e.x - c.x) * n[0], e.y = (c.y - e.y) * n[1];
            } : function (e) {
              e.x = (e.x - h) / (p - h) * n[0], e.y = (1 - (c.y ? e.y / c.y : 1)) * n[1];
            }), s;
          }
          return i.separation = function (e) {
            return arguments.length ? (r = e, i) : r;
          }, i.size = function (e) {
            return arguments.length ? (a = null == (n = e), i) : a ? null : n;
          }, i.nodeSize = function (e) {
            return arguments.length ? (a = null != (n = e), i) : a ? n : null;
          }, Qr(i, t);
        }, e.layout.treemap = function () {
          var t,
            r = e.layout.hierarchy(),
            n = Math.round,
            a = [1, 1],
            i = null,
            o = Pn,
            l = !1,
            s = "squarify",
            c = .5 * (1 + Math.sqrt(5));
          function u(e, t) {
            for (var r, n, a = -1, i = e.length; ++a < i;) n = (r = e[a]).value * (t < 0 ? 0 : t), r.area = isNaN(n) || n <= 0 ? 0 : n;
          }
          function d(e) {
            var t = e.children;
            if (t && t.length) {
              var r,
                n,
                a,
                i = o(e),
                l = [],
                c = t.slice(),
                f = 1 / 0,
                g = "slice" === s ? i.dx : "dice" === s ? i.dy : "slice-dice" === s ? 1 & e.depth ? i.dy : i.dx : Math.min(i.dx, i.dy);
              for (u(c, i.dx * i.dy / e.value), l.area = 0; (a = c.length) > 0;) l.push(r = c[a - 1]), l.area += r.area, "squarify" !== s || (n = h(l, g)) <= f ? (c.pop(), f = n) : (l.area -= l.pop().area, p(l, g, i, !1), g = Math.min(i.dx, i.dy), l.length = l.area = 0, f = 1 / 0);
              l.length && (p(l, g, i, !0), l.length = l.area = 0), t.forEach(d);
            }
          }
          function f(e) {
            var t = e.children;
            if (t && t.length) {
              var r,
                n = o(e),
                a = t.slice(),
                i = [];
              for (u(a, n.dx * n.dy / e.value), i.area = 0; r = a.pop();) i.push(r), i.area += r.area, null != r.z && (p(i, r.z ? n.dx : n.dy, n, !a.length), i.length = i.area = 0);
              t.forEach(f);
            }
          }
          function h(e, t) {
            for (var r, n = e.area, a = 0, i = 1 / 0, o = -1, l = e.length; ++o < l;) (r = e[o].area) && (r < i && (i = r), r > a && (a = r));
            return t *= t, (n *= n) ? Math.max(t * a * c / n, n / (t * i * c)) : 1 / 0;
          }
          function p(e, t, r, a) {
            var i,
              o = -1,
              l = e.length,
              s = r.x,
              c = r.y,
              u = t ? n(e.area / t) : 0;
            if (t == r.dx) {
              for ((a || u > r.dy) && (u = r.dy); ++o < l;) (i = e[o]).x = s, i.y = c, i.dy = u, s += i.dx = Math.min(r.x + r.dx - s, u ? n(i.area / u) : 0);
              i.z = !0, i.dx += r.x + r.dx - s, r.y += u, r.dy -= u;
            } else {
              for ((a || u > r.dx) && (u = r.dx); ++o < l;) (i = e[o]).x = s, i.y = c, i.dx = u, c += i.dy = Math.min(r.y + r.dy - c, u ? n(i.area / u) : 0);
              i.z = !1, i.dy += r.y + r.dy - c, r.x += u, r.dx -= u;
            }
          }
          function g(e) {
            var n = t || r(e),
              i = n[0];
            return i.x = i.y = 0, i.value ? (i.dx = a[0], i.dy = a[1]) : i.dx = i.dy = 0, t && r.revalue(i), u([i], i.dx * i.dy / i.value), (t ? f : d)(i), l && (t = n), n;
          }
          return g.size = function (e) {
            return arguments.length ? (a = e, g) : a;
          }, g.padding = function (e) {
            if (!arguments.length) return i;
            function t(t) {
              var r = e.call(g, t, t.depth);
              return null == r ? Pn(t) : In(t, "number" == typeof r ? [r, r, r, r] : r);
            }
            function r(t) {
              return In(t, e);
            }
            var n;
            return o = null == (i = e) ? Pn : "function" == (n = typeof e) ? t : "number" === n ? (e = [e, e, e, e], r) : r, g;
          }, g.round = function (e) {
            return arguments.length ? (n = e ? Math.round : Number, g) : n != Number;
          }, g.sticky = function (e) {
            return arguments.length ? (l = e, t = null, g) : l;
          }, g.ratio = function (e) {
            return arguments.length ? (c = e, g) : c;
          }, g.mode = function (e) {
            return arguments.length ? (s = e + "", g) : s;
          }, Qr(g, r);
        }, e.random = {
          normal: function normal(e, t) {
            var r = arguments.length;
            return r < 2 && (t = 1), r < 1 && (e = 0), function () {
              var r, n, a;
              do {
                a = (r = 2 * Math.random() - 1) * r + (n = 2 * Math.random() - 1) * n;
              } while (!a || a > 1);
              return e + t * r * Math.sqrt(-2 * Math.log(a) / a);
            };
          },
          logNormal: function logNormal() {
            var t = e.random.normal.apply(e, arguments);
            return function () {
              return Math.exp(t());
            };
          },
          bates: function bates(t) {
            var r = e.random.irwinHall(t);
            return function () {
              return r() / t;
            };
          },
          irwinHall: function irwinHall(e) {
            return function () {
              for (var t = 0, r = 0; r < e; r++) t += Math.random();
              return t;
            };
          }
        }, e.scale = {};
        var jn = {
          floor: C,
          ceil: C
        };
        function Hn(t, r, n, a) {
          var i = [],
            o = [],
            l = 0,
            s = Math.min(t.length, r.length) - 1;
          for (t[s] < t[0] && (t = t.slice().reverse(), r = r.slice().reverse()); ++l <= s;) i.push(n(t[l - 1], t[l])), o.push(a(r[l - 1], r[l]));
          return function (r) {
            var n = e.bisect(t, r, 1, s) - 1;
            return o[n](i[n](r));
          };
        }
        function Bn(t, r) {
          return e.rebind(t, r, "range", "rangeRound", "interpolate", "clamp");
        }
        function Yn(e, t) {
          return Fn(e, En(Un(e, t)[2])), Fn(e, En(Un(e, t)[2])), e;
        }
        function Un(e, t) {
          null == t && (t = 10);
          var r = zn(e),
            n = r[1] - r[0],
            a = Math.pow(10, Math.floor(Math.log(n / t) / Math.LN10)),
            i = t / n * a;
          return i <= .15 ? a *= 10 : i <= .35 ? a *= 5 : i <= .75 && (a *= 2), r[0] = Math.ceil(r[0] / a) * a, r[1] = Math.floor(r[1] / a) * a + .5 * a, r[2] = a, r;
        }
        function Vn(t, r) {
          return e.range.apply(e, Un(t, r));
        }
        e.scale.linear = function () {
          return function e(t, r, n, a) {
            var i, o;
            function l() {
              var e = Math.min(t.length, r.length) > 2 ? Hn : Nn,
                l = a ? Br : Hr;
              return i = e(t, r, l, n), o = e(r, t, l, vr), s;
            }
            function s(e) {
              return i(e);
            }
            return s.invert = function (e) {
              return o(e);
            }, s.domain = function (e) {
              return arguments.length ? (t = e.map(Number), l()) : t;
            }, s.range = function (e) {
              return arguments.length ? (r = e, l()) : r;
            }, s.rangeRound = function (e) {
              return s.range(e).interpolate(Ir);
            }, s.clamp = function (e) {
              return arguments.length ? (a = e, l()) : a;
            }, s.interpolate = function (e) {
              return arguments.length ? (n = e, l()) : n;
            }, s.ticks = function (e) {
              return Vn(t, e);
            }, s.tickFormat = function (e, r) {
              return d3_scale_linearTickFormat(t, e, r);
            }, s.nice = function (e) {
              return Yn(t, e), l();
            }, s.copy = function () {
              return e(t, r, n, a);
            }, l();
          }([0, 1], [0, 1], vr, !1);
        };
        e.scale.log = function () {
          return function e(t, r, n, a) {
            function i(e) {
              return (n ? Math.log(e < 0 ? 0 : e) : -Math.log(e > 0 ? 0 : -e)) / Math.log(r);
            }
            function o(e) {
              return n ? Math.pow(r, e) : -Math.pow(r, -e);
            }
            function l(e) {
              return t(i(e));
            }
            return l.invert = function (e) {
              return o(t.invert(e));
            }, l.domain = function (e) {
              return arguments.length ? (n = e[0] >= 0, t.domain((a = e.map(Number)).map(i)), l) : a;
            }, l.base = function (e) {
              return arguments.length ? (r = +e, t.domain(a.map(i)), l) : r;
            }, l.nice = function () {
              var e = Fn(a.map(i), n ? Math : qn);
              return t.domain(e), a = e.map(o), l;
            }, l.ticks = function () {
              var e = zn(a),
                t = [],
                l = e[0],
                s = e[1],
                c = Math.floor(i(l)),
                u = Math.ceil(i(s)),
                d = r % 1 ? 2 : r;
              if (isFinite(u - c)) {
                if (n) {
                  for (; c < u; c++) for (var f = 1; f < d; f++) t.push(o(c) * f);
                  t.push(o(c));
                } else for (t.push(o(c)); c++ < u;) for (f = d - 1; f > 0; f--) t.push(o(c) * f);
                for (c = 0; t[c] < l; c++);
                for (u = t.length; t[u - 1] > s; u--);
                t = t.slice(c, u);
              }
              return t;
            }, l.copy = function () {
              return e(t.copy(), r, n, a);
            }, Bn(l, t);
          }(e.scale.linear().domain([0, 1]), 10, !0, [1, 10]);
        };
        var qn = {
          floor: function floor(e) {
            return -Math.ceil(-e);
          },
          ceil: function ceil(e) {
            return -Math.floor(-e);
          }
        };
        function Gn(e) {
          return function (t) {
            return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
          };
        }
        e.scale.pow = function () {
          return function e(t, r, n) {
            var a = Gn(r),
              i = Gn(1 / r);
            function o(e) {
              return t(a(e));
            }
            return o.invert = function (e) {
              return i(t.invert(e));
            }, o.domain = function (e) {
              return arguments.length ? (t.domain((n = e.map(Number)).map(a)), o) : n;
            }, o.ticks = function (e) {
              return Vn(n, e);
            }, o.tickFormat = function (e, t) {
              return d3_scale_linearTickFormat(n, e, t);
            }, o.nice = function (e) {
              return o.domain(Yn(n, e));
            }, o.exponent = function (e) {
              return arguments.length ? (a = Gn(r = e), i = Gn(1 / r), t.domain(n.map(a)), o) : r;
            }, o.copy = function () {
              return e(t.copy(), r, n);
            }, Bn(o, t);
          }(e.scale.linear(), 1, [0, 1]);
        }, e.scale.sqrt = function () {
          return e.scale.pow().exponent(.5);
        }, e.scale.ordinal = function () {
          return function t(r, n) {
            var a, i, o;
            function l(e) {
              return i[((a.get(e) || ("range" === n.t ? a.set(e, r.push(e)) : NaN)) - 1) % i.length];
            }
            function s(t, n) {
              return e.range(r.length).map(function (e) {
                return t + n * e;
              });
            }
            return l.domain = function (e) {
              if (!arguments.length) return r;
              r = [], a = new _();
              for (var t, i = -1, o = e.length; ++i < o;) a.has(t = e[i]) || a.set(t, r.push(t));
              return l[n.t].apply(l, n.a);
            }, l.range = function (e) {
              return arguments.length ? (i = e, o = 0, n = {
                t: "range",
                a: arguments
              }, l) : i;
            }, l.rangePoints = function (e, t) {
              arguments.length < 2 && (t = 0);
              var a = e[0],
                c = e[1],
                u = r.length < 2 ? (a = (a + c) / 2, 0) : (c - a) / (r.length - 1 + t);
              return i = s(a + u * t / 2, u), o = 0, n = {
                t: "rangePoints",
                a: arguments
              }, l;
            }, l.rangeRoundPoints = function (e, t) {
              arguments.length < 2 && (t = 0);
              var a = e[0],
                c = e[1],
                u = r.length < 2 ? (a = c = Math.round((a + c) / 2), 0) : (c - a) / (r.length - 1 + t) | 0;
              return i = s(a + Math.round(u * t / 2 + (c - a - (r.length - 1 + t) * u) / 2), u), o = 0, n = {
                t: "rangeRoundPoints",
                a: arguments
              }, l;
            }, l.rangeBands = function (e, t, a) {
              arguments.length < 2 && (t = 0), arguments.length < 3 && (a = t);
              var c = e[1] < e[0],
                u = e[c - 0],
                d = e[1 - c],
                f = (d - u) / (r.length - t + 2 * a);
              return i = s(u + f * a, f), c && i.reverse(), o = f * (1 - t), n = {
                t: "rangeBands",
                a: arguments
              }, l;
            }, l.rangeRoundBands = function (e, t, a) {
              arguments.length < 2 && (t = 0), arguments.length < 3 && (a = t);
              var c = e[1] < e[0],
                u = e[c - 0],
                d = e[1 - c],
                f = Math.floor((d - u) / (r.length - t + 2 * a));
              return i = s(u + Math.round((d - u - (r.length - t) * f) / 2), f), c && i.reverse(), o = Math.round(f * (1 - t)), n = {
                t: "rangeRoundBands",
                a: arguments
              }, l;
            }, l.rangeBand = function () {
              return o;
            }, l.rangeExtent = function () {
              return zn(n.a[0]);
            }, l.copy = function () {
              return t(r, n);
            }, l.domain(r);
          }([], {
            t: "range",
            a: [[]]
          });
        }, e.scale.category10 = function () {
          return e.scale.ordinal().range(Zn);
        }, e.scale.category20 = function () {
          return e.scale.ordinal().range(Wn);
        }, e.scale.category20b = function () {
          return e.scale.ordinal().range(Jn);
        }, e.scale.category20c = function () {
          return e.scale.ordinal().range(Xn);
        };
        var Zn = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(et),
          Wn = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(et),
          Jn = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(et),
          Xn = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(et);
        function Qn() {
          return 0;
        }
        e.scale.quantile = function () {
          return function t(r, n) {
            var a;
            function i() {
              var t = 0,
                i = n.length;
              for (a = []; ++t < i;) a[t - 1] = e.quantile(r, t / i);
              return o;
            }
            function o(t) {
              if (!isNaN(t = +t)) return n[e.bisect(a, t)];
            }
            return o.domain = function (e) {
              return arguments.length ? (r = e.map(h).filter(p).sort(f), i()) : r;
            }, o.range = function (e) {
              return arguments.length ? (n = e, i()) : n;
            }, o.quantiles = function () {
              return a;
            }, o.invertExtent = function (e) {
              return (e = n.indexOf(e)) < 0 ? [NaN, NaN] : [e > 0 ? a[e - 1] : r[0], e < a.length ? a[e] : r[r.length - 1]];
            }, o.copy = function () {
              return t(r, n);
            }, i();
          }([], []);
        }, e.scale.quantize = function () {
          return function e(t, r, n) {
            var a, i;
            function o(e) {
              return n[Math.max(0, Math.min(i, Math.floor(a * (e - t))))];
            }
            function l() {
              return a = n.length / (r - t), i = n.length - 1, o;
            }
            return o.domain = function (e) {
              return arguments.length ? (t = +e[0], r = +e[e.length - 1], l()) : [t, r];
            }, o.range = function (e) {
              return arguments.length ? (n = e, l()) : n;
            }, o.invertExtent = function (e) {
              return [e = (e = n.indexOf(e)) < 0 ? NaN : e / a + t, e + 1 / a];
            }, o.copy = function () {
              return e(t, r, n);
            }, l();
          }(0, 1, [0, 1]);
        }, e.scale.threshold = function () {
          return function t(r, n) {
            function a(t) {
              if (t <= t) return n[e.bisect(r, t)];
            }
            return a.domain = function (e) {
              return arguments.length ? (r = e, a) : r;
            }, a.range = function (e) {
              return arguments.length ? (n = e, a) : n;
            }, a.invertExtent = function (e) {
              return e = n.indexOf(e), [r[e - 1], r[e]];
            }, a.copy = function () {
              return t(r, n);
            }, a;
          }([.5], [0, 1]);
        }, e.scale.identity = function () {
          return function e(t) {
            function r(e) {
              return +e;
            }
            return r.invert = r, r.domain = r.range = function (e) {
              return arguments.length ? (t = e.map(r), r) : t;
            }, r.ticks = function (e) {
              return Vn(t, e);
            }, r.tickFormat = function (e, r) {
              return d3_scale_linearTickFormat(t, e, r);
            }, r.copy = function () {
              return e(t);
            }, r;
          }([0, 1]);
        }, e.svg = {}, e.svg.arc = function () {
          var e = $n,
            t = ea,
            r = Qn,
            n = Kn,
            a = ta,
            i = ra,
            o = na;
          function l() {
            var l = Math.max(0, +e.apply(this, arguments)),
              c = Math.max(0, +t.apply(this, arguments)),
              u = a.apply(this, arguments) - De,
              d = i.apply(this, arguments) - De,
              f = Math.abs(d - u),
              h = u > d ? 0 : 1;
            if (c < l && (p = c, c = l, l = p), f >= Le) return s(c, h) + (l ? s(l, 1 - h) : "") + "Z";
            var p,
              g,
              m,
              y,
              v,
              x,
              b,
              _,
              w,
              M,
              T,
              k,
              A = 0,
              L = 0,
              D = [];
            if ((y = (+o.apply(this, arguments) || 0) / 2) && (m = n === Kn ? Math.sqrt(l * l + c * c) : +n.apply(this, arguments), h || (L *= -1), c && (L = Oe(m / c * Math.sin(y))), l && (A = Oe(m / l * Math.sin(y)))), c) {
              v = c * Math.cos(u + L), x = c * Math.sin(u + L), b = c * Math.cos(d - L), _ = c * Math.sin(d - L);
              var S = Math.abs(d - u - 2 * L) <= ke ? 0 : 1;
              if (L && aa(v, x, b, _) === h ^ S) {
                var C = (u + d) / 2;
                v = c * Math.cos(C), x = c * Math.sin(C), b = _ = null;
              }
            } else v = x = 0;
            if (l) {
              w = l * Math.cos(d - A), M = l * Math.sin(d - A), T = l * Math.cos(u + A), k = l * Math.sin(u + A);
              var O = Math.abs(u - d + 2 * A) <= ke ? 0 : 1;
              if (A && aa(w, M, T, k) === 1 - h ^ O) {
                var P = (u + d) / 2;
                w = l * Math.cos(P), M = l * Math.sin(P), T = k = null;
              }
            } else w = M = 0;
            if (f > Te && (p = Math.min(Math.abs(c - l) / 2, +r.apply(this, arguments))) > .001) {
              g = l < c ^ h ? 0 : 1;
              var I = p,
                z = p;
              if (f < ke) {
                var R = null == T ? [w, M] : null == b ? [v, x] : Lt([v, x], [T, k], [b, _], [w, M]),
                  N = v - R[0],
                  F = x - R[1],
                  E = b - R[0],
                  j = _ - R[1],
                  H = 1 / Math.sin(Math.acos((N * E + F * j) / (Math.sqrt(N * N + F * F) * Math.sqrt(E * E + j * j))) / 2),
                  B = Math.sqrt(R[0] * R[0] + R[1] * R[1]);
                z = Math.min(p, (l - B) / (H - 1)), I = Math.min(p, (c - B) / (H + 1));
              }
              if (null != b) {
                var Y = ia(null == T ? [w, M] : [T, k], [v, x], c, I, h),
                  U = ia([b, _], [w, M], c, I, h);
                p === I ? D.push("M", Y[0], "A", I, ",", I, " 0 0,", g, " ", Y[1], "A", c, ",", c, " 0 ", 1 - h ^ aa(Y[1][0], Y[1][1], U[1][0], U[1][1]), ",", h, " ", U[1], "A", I, ",", I, " 0 0,", g, " ", U[0]) : D.push("M", Y[0], "A", I, ",", I, " 0 1,", g, " ", U[0]);
              } else D.push("M", v, ",", x);
              if (null != T) {
                var V = ia([v, x], [T, k], l, -z, h),
                  q = ia([w, M], null == b ? [v, x] : [b, _], l, -z, h);
                p === z ? D.push("L", q[0], "A", z, ",", z, " 0 0,", g, " ", q[1], "A", l, ",", l, " 0 ", h ^ aa(q[1][0], q[1][1], V[1][0], V[1][1]), ",", 1 - h, " ", V[1], "A", z, ",", z, " 0 0,", g, " ", V[0]) : D.push("L", q[0], "A", z, ",", z, " 0 0,", g, " ", V[0]);
              } else D.push("L", w, ",", M);
            } else D.push("M", v, ",", x), null != b && D.push("A", c, ",", c, " 0 ", S, ",", h, " ", b, ",", _), D.push("L", w, ",", M), null != T && D.push("A", l, ",", l, " 0 ", O, ",", 1 - h, " ", T, ",", k);
            return D.push("Z"), D.join("");
          }
          function s(e, t) {
            return "M0," + e + "A" + e + "," + e + " 0 1," + t + " 0," + -e + "A" + e + "," + e + " 0 1," + t + " 0," + e;
          }
          return l.innerRadius = function (t) {
            return arguments.length ? (e = ct(t), l) : e;
          }, l.outerRadius = function (e) {
            return arguments.length ? (t = ct(e), l) : t;
          }, l.cornerRadius = function (e) {
            return arguments.length ? (r = ct(e), l) : r;
          }, l.padRadius = function (e) {
            return arguments.length ? (n = e == Kn ? Kn : ct(e), l) : n;
          }, l.startAngle = function (e) {
            return arguments.length ? (a = ct(e), l) : a;
          }, l.endAngle = function (e) {
            return arguments.length ? (i = ct(e), l) : i;
          }, l.padAngle = function (e) {
            return arguments.length ? (o = ct(e), l) : o;
          }, l.centroid = function () {
            var r = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2,
              n = (+a.apply(this, arguments) + +i.apply(this, arguments)) / 2 - De;
            return [Math.cos(n) * r, Math.sin(n) * r];
          }, l;
        };
        var Kn = "auto";
        function $n(e) {
          return e.innerRadius;
        }
        function ea(e) {
          return e.outerRadius;
        }
        function ta(e) {
          return e.startAngle;
        }
        function ra(e) {
          return e.endAngle;
        }
        function na(e) {
          return e && e.padAngle;
        }
        function aa(e, t, r, n) {
          return (e - r) * t - (t - n) * e > 0 ? 0 : 1;
        }
        function ia(e, t, r, n, a) {
          var i = e[0] - t[0],
            o = e[1] - t[1],
            l = (a ? n : -n) / Math.sqrt(i * i + o * o),
            s = l * o,
            c = -l * i,
            u = e[0] + s,
            d = e[1] + c,
            f = t[0] + s,
            h = t[1] + c,
            p = (u + f) / 2,
            g = (d + h) / 2,
            m = f - u,
            y = h - d,
            v = m * m + y * y,
            x = r - n,
            b = u * h - f * d,
            _ = (y < 0 ? -1 : 1) * Math.sqrt(Math.max(0, x * x * v - b * b)),
            w = (b * y - m * _) / v,
            M = (-b * m - y * _) / v,
            T = (b * y + m * _) / v,
            k = (-b * m + y * _) / v,
            A = w - p,
            L = M - g,
            D = T - p,
            S = k - g;
          return A * A + L * L > D * D + S * S && (w = T, M = k), [[w - s, M - c], [w * r / x, M * r / x]];
        }
        function oa() {
          return !0;
        }
        function la(e) {
          var t = _t,
            r = wt,
            n = oa,
            a = ca,
            i = a.key,
            o = .7;
          function l(i) {
            var l,
              s = [],
              c = [],
              u = -1,
              d = i.length,
              f = ct(t),
              h = ct(r);
            function p() {
              s.push("M", a(e(c), o));
            }
            for (; ++u < d;) n.call(this, l = i[u], u) ? c.push([+f.call(this, l, u), +h.call(this, l, u)]) : c.length && (p(), c = []);
            return c.length && p(), s.length ? s.join("") : null;
          }
          return l.x = function (e) {
            return arguments.length ? (t = e, l) : t;
          }, l.y = function (e) {
            return arguments.length ? (r = e, l) : r;
          }, l.defined = function (e) {
            return arguments.length ? (n = e, l) : n;
          }, l.interpolate = function (e) {
            return arguments.length ? (i = "function" == typeof e ? a = e : (a = sa.get(e) || ca).key, l) : i;
          }, l.tension = function (e) {
            return arguments.length ? (o = e, l) : o;
          }, l;
        }
        e.svg.line = function () {
          return la(C);
        };
        var sa = e.map({
          linear: ca,
          "linear-closed": ua,
          step: function step(e) {
            var t = 0,
              r = e.length,
              n = e[0],
              a = [n[0], ",", n[1]];
            for (; ++t < r;) a.push("H", (n[0] + (n = e[t])[0]) / 2, "V", n[1]);
            r > 1 && a.push("H", n[0]);
            return a.join("");
          },
          "step-before": da,
          "step-after": fa,
          basis: ga,
          "basis-open": function basisOpen(e) {
            if (e.length < 4) return ca(e);
            var t,
              r = [],
              n = -1,
              a = e.length,
              i = [0],
              o = [0];
            for (; ++n < 3;) t = e[n], i.push(t[0]), o.push(t[1]);
            r.push(ma(xa, i) + "," + ma(xa, o)), --n;
            for (; ++n < a;) t = e[n], i.shift(), i.push(t[0]), o.shift(), o.push(t[1]), ba(r, i, o);
            return r.join("");
          },
          "basis-closed": function basisClosed(e) {
            var t,
              r,
              n = -1,
              a = e.length,
              i = a + 4,
              o = [],
              l = [];
            for (; ++n < 4;) r = e[n % a], o.push(r[0]), l.push(r[1]);
            t = [ma(xa, o), ",", ma(xa, l)], --n;
            for (; ++n < i;) r = e[n % a], o.shift(), o.push(r[0]), l.shift(), l.push(r[1]), ba(t, o, l);
            return t.join("");
          },
          bundle: function bundle(e, t) {
            var r = e.length - 1;
            if (r) for (var n, a, i = e[0][0], o = e[0][1], l = e[r][0] - i, s = e[r][1] - o, c = -1; ++c <= r;) n = e[c], a = c / r, n[0] = t * n[0] + (1 - t) * (i + a * l), n[1] = t * n[1] + (1 - t) * (o + a * s);
            return ga(e);
          },
          cardinal: function cardinal(e, t) {
            return e.length < 3 ? ca(e) : e[0] + ha(e, pa(e, t));
          },
          "cardinal-open": function cardinalOpen(e, t) {
            return e.length < 4 ? ca(e) : e[1] + ha(e.slice(1, -1), pa(e, t));
          },
          "cardinal-closed": function cardinalClosed(e, t) {
            return e.length < 3 ? ua(e) : e[0] + ha((e.push(e[0]), e), pa([e[e.length - 2]].concat(e, [e[1]]), t));
          },
          monotone: function monotone(e) {
            return e.length < 3 ? ca(e) : e[0] + ha(e, function (e) {
              var t,
                r,
                n,
                a,
                i = [],
                o = function (e) {
                  var t = 0,
                    r = e.length - 1,
                    n = [],
                    a = e[0],
                    i = e[1],
                    o = n[0] = _a(a, i);
                  for (; ++t < r;) n[t] = (o + (o = _a(a = i, i = e[t + 1]))) / 2;
                  return n[t] = o, n;
                }(e),
                l = -1,
                s = e.length - 1;
              for (; ++l < s;) t = _a(e[l], e[l + 1]), v(t) < Te ? o[l] = o[l + 1] = 0 : (r = o[l] / t, n = o[l + 1] / t, (a = r * r + n * n) > 9 && (a = 3 * t / Math.sqrt(a), o[l] = a * r, o[l + 1] = a * n));
              l = -1;
              for (; ++l <= s;) a = (e[Math.min(s, l + 1)][0] - e[Math.max(0, l - 1)][0]) / (6 * (1 + o[l] * o[l])), i.push([a || 0, o[l] * a || 0]);
              return i;
            }(e));
          }
        });
        function ca(e) {
          return e.length > 1 ? e.join("L") : e + "Z";
        }
        function ua(e) {
          return e.join("L") + "Z";
        }
        function da(e) {
          for (var t = 0, r = e.length, n = e[0], a = [n[0], ",", n[1]]; ++t < r;) a.push("V", (n = e[t])[1], "H", n[0]);
          return a.join("");
        }
        function fa(e) {
          for (var t = 0, r = e.length, n = e[0], a = [n[0], ",", n[1]]; ++t < r;) a.push("H", (n = e[t])[0], "V", n[1]);
          return a.join("");
        }
        function ha(e, t) {
          if (t.length < 1 || e.length != t.length && e.length != t.length + 2) return ca(e);
          var r = e.length != t.length,
            n = "",
            a = e[0],
            i = e[1],
            o = t[0],
            l = o,
            s = 1;
          if (r && (n += "Q" + (i[0] - 2 * o[0] / 3) + "," + (i[1] - 2 * o[1] / 3) + "," + i[0] + "," + i[1], a = e[1], s = 2), t.length > 1) {
            l = t[1], i = e[s], s++, n += "C" + (a[0] + o[0]) + "," + (a[1] + o[1]) + "," + (i[0] - l[0]) + "," + (i[1] - l[1]) + "," + i[0] + "," + i[1];
            for (var c = 2; c < t.length; c++, s++) i = e[s], l = t[c], n += "S" + (i[0] - l[0]) + "," + (i[1] - l[1]) + "," + i[0] + "," + i[1];
          }
          if (r) {
            var u = e[s];
            n += "Q" + (i[0] + 2 * l[0] / 3) + "," + (i[1] + 2 * l[1] / 3) + "," + u[0] + "," + u[1];
          }
          return n;
        }
        function pa(e, t) {
          for (var r, n = [], a = (1 - t) / 2, i = e[0], o = e[1], l = 1, s = e.length; ++l < s;) r = i, i = o, o = e[l], n.push([a * (o[0] - r[0]), a * (o[1] - r[1])]);
          return n;
        }
        function ga(e) {
          if (e.length < 3) return ca(e);
          var t = 1,
            r = e.length,
            n = e[0],
            a = n[0],
            i = n[1],
            o = [a, a, a, (n = e[1])[0]],
            l = [i, i, i, n[1]],
            s = [a, ",", i, "L", ma(xa, o), ",", ma(xa, l)];
          for (e.push(e[r - 1]); ++t <= r;) n = e[t], o.shift(), o.push(n[0]), l.shift(), l.push(n[1]), ba(s, o, l);
          return e.pop(), s.push("L", n), s.join("");
        }
        function ma(e, t) {
          return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3] * t[3];
        }
        sa.forEach(function (e, t) {
          t.key = e, t.closed = /-closed$/.test(e);
        });
        var ya = [0, 2 / 3, 1 / 3, 0],
          va = [0, 1 / 3, 2 / 3, 0],
          xa = [0, 1 / 6, 2 / 3, 1 / 6];
        function ba(e, t, r) {
          e.push("C", ma(ya, t), ",", ma(ya, r), ",", ma(va, t), ",", ma(va, r), ",", ma(xa, t), ",", ma(xa, r));
        }
        function _a(e, t) {
          return (t[1] - e[1]) / (t[0] - e[0]);
        }
        function wa(e) {
          for (var t, r, n, a = -1, i = e.length; ++a < i;) r = (t = e[a])[0], n = t[1] - De, t[0] = r * Math.cos(n), t[1] = r * Math.sin(n);
          return e;
        }
        function Ma(e) {
          var t = _t,
            r = _t,
            n = 0,
            a = wt,
            i = oa,
            o = ca,
            l = o.key,
            s = o,
            c = "L",
            u = .7;
          function d(l) {
            var d,
              f,
              h,
              p = [],
              g = [],
              m = [],
              y = -1,
              v = l.length,
              x = ct(t),
              b = ct(n),
              _ = t === r ? function () {
                return f;
              } : ct(r),
              w = n === a ? function () {
                return h;
              } : ct(a);
            function M() {
              p.push("M", o(e(m), u), c, s(e(g.reverse()), u), "Z");
            }
            for (; ++y < v;) i.call(this, d = l[y], y) ? (g.push([f = +x.call(this, d, y), h = +b.call(this, d, y)]), m.push([+_.call(this, d, y), +w.call(this, d, y)])) : g.length && (M(), g = [], m = []);
            return g.length && M(), p.length ? p.join("") : null;
          }
          return d.x = function (e) {
            return arguments.length ? (t = r = e, d) : r;
          }, d.x0 = function (e) {
            return arguments.length ? (t = e, d) : t;
          }, d.x1 = function (e) {
            return arguments.length ? (r = e, d) : r;
          }, d.y = function (e) {
            return arguments.length ? (n = a = e, d) : a;
          }, d.y0 = function (e) {
            return arguments.length ? (n = e, d) : n;
          }, d.y1 = function (e) {
            return arguments.length ? (a = e, d) : a;
          }, d.defined = function (e) {
            return arguments.length ? (i = e, d) : i;
          }, d.interpolate = function (e) {
            return arguments.length ? (l = "function" == typeof e ? o = e : (o = sa.get(e) || ca).key, s = o.reverse || o, c = o.closed ? "M" : "L", d) : l;
          }, d.tension = function (e) {
            return arguments.length ? (u = e, d) : u;
          }, d;
        }
        function Ta(e) {
          return e.source;
        }
        function ka(e) {
          return e.target;
        }
        function Aa(e) {
          return e.radius;
        }
        function La(e) {
          return [e.x, e.y];
        }
        function Da(e) {
          return function () {
            var t = e.apply(this, arguments),
              r = t[0],
              n = t[1] - De;
            return [r * Math.cos(n), r * Math.sin(n)];
          };
        }
        function Sa() {
          return 64;
        }
        function Ca() {
          return "circle";
        }
        function Oa(e) {
          var t = Math.sqrt(e / ke);
          return "M0," + t + "A" + t + "," + t + " 0 1,1 0," + -t + "A" + t + "," + t + " 0 1,1 0," + t + "Z";
        }
        e.svg.line.radial = function () {
          var e = la(wa);
          return e.radius = e.x, delete e.x, e.angle = e.y, delete e.y, e;
        }, da.reverse = fa, fa.reverse = da, e.svg.area = function () {
          return Ma(C);
        }, e.svg.area.radial = function () {
          var e = Ma(wa);
          return e.radius = e.x, delete e.x, e.innerRadius = e.x0, delete e.x0, e.outerRadius = e.x1, delete e.x1, e.angle = e.y, delete e.y, e.startAngle = e.y0, delete e.y0, e.endAngle = e.y1, delete e.y1, e;
        }, e.svg.chord = function () {
          var e = Ta,
            t = ka,
            r = Aa,
            n = ta,
            a = ra;
          function i(r, n) {
            var a,
              i,
              c = o(this, e, r, n),
              u = o(this, t, r, n);
            return "M" + c.p0 + l(c.r, c.p1, c.a1 - c.a0) + (i = u, ((a = c).a0 == i.a0 && a.a1 == i.a1 ? s(c.r, c.p1, c.r, c.p0) : s(c.r, c.p1, u.r, u.p0) + l(u.r, u.p1, u.a1 - u.a0) + s(u.r, u.p1, c.r, c.p0)) + "Z");
          }
          function o(e, t, i, o) {
            var l = t.call(e, i, o),
              s = r.call(e, l, o),
              c = n.call(e, l, o) - De,
              u = a.call(e, l, o) - De;
            return {
              r: s,
              a0: c,
              a1: u,
              p0: [s * Math.cos(c), s * Math.sin(c)],
              p1: [s * Math.cos(u), s * Math.sin(u)]
            };
          }
          function l(e, t, r) {
            return "A" + e + "," + e + " 0 " + +(r > ke) + ",1 " + t;
          }
          function s(e, t, r, n) {
            return "Q 0,0 " + n;
          }
          return i.radius = function (e) {
            return arguments.length ? (r = ct(e), i) : r;
          }, i.source = function (t) {
            return arguments.length ? (e = ct(t), i) : e;
          }, i.target = function (e) {
            return arguments.length ? (t = ct(e), i) : t;
          }, i.startAngle = function (e) {
            return arguments.length ? (n = ct(e), i) : n;
          }, i.endAngle = function (e) {
            return arguments.length ? (a = ct(e), i) : a;
          }, i;
        }, e.svg.diagonal = function () {
          var e = Ta,
            t = ka,
            r = La;
          function n(n, a) {
            var i = e.call(this, n, a),
              o = t.call(this, n, a),
              l = (i.y + o.y) / 2,
              s = [i, {
                x: i.x,
                y: l
              }, {
                x: o.x,
                y: l
              }, o];
            return "M" + (s = s.map(r))[0] + "C" + s[1] + " " + s[2] + " " + s[3];
          }
          return n.source = function (t) {
            return arguments.length ? (e = ct(t), n) : e;
          }, n.target = function (e) {
            return arguments.length ? (t = ct(e), n) : t;
          }, n.projection = function (e) {
            return arguments.length ? (r = e, n) : r;
          }, n;
        }, e.svg.diagonal.radial = function () {
          var t = e.svg.diagonal(),
            r = La,
            n = t.projection;
          return t.projection = function (e) {
            return arguments.length ? n(Da(r = e)) : r;
          }, t;
        }, e.svg.symbol = function () {
          var e = Ca,
            t = Sa;
          function r(r, n) {
            return (Pa.get(e.call(this, r, n)) || Oa)(t.call(this, r, n));
          }
          return r.type = function (t) {
            return arguments.length ? (e = ct(t), r) : e;
          }, r.size = function (e) {
            return arguments.length ? (t = ct(e), r) : t;
          }, r;
        };
        var Pa = e.map({
          circle: Oa,
          cross: function cross(e) {
            var t = Math.sqrt(e / 5) / 2;
            return "M" + -3 * t + "," + -t + "H" + -t + "V" + -3 * t + "H" + t + "V" + -t + "H" + 3 * t + "V" + t + "H" + t + "V" + 3 * t + "H" + -t + "V" + t + "H" + -3 * t + "Z";
          },
          diamond: function diamond(e) {
            var t = Math.sqrt(e / (2 * za)),
              r = t * za;
            return "M0," + -t + "L" + r + ",0 0," + t + " " + -r + ",0Z";
          },
          square: function square(e) {
            var t = Math.sqrt(e) / 2;
            return "M" + -t + "," + -t + "L" + t + "," + -t + " " + t + "," + t + " " + -t + "," + t + "Z";
          },
          "triangle-down": function triangleDown(e) {
            var t = Math.sqrt(e / Ia),
              r = t * Ia / 2;
            return "M0," + r + "L" + t + "," + -r + " " + -t + "," + -r + "Z";
          },
          "triangle-up": function triangleUp(e) {
            var t = Math.sqrt(e / Ia),
              r = t * Ia / 2;
            return "M0," + -r + "L" + t + "," + r + " " + -t + "," + r + "Z";
          }
        });
        e.svg.symbolTypes = Pa.keys();
        var Ia = Math.sqrt(3),
          za = Math.tan(30 * Se);
        G.transition = function (e) {
          for (var t, r, n = Ea || ++Ba, a = Va(e), i = [], o = ja || {
              time: Date.now(),
              ease: Dr,
              delay: 0,
              duration: 250
            }, l = -1, s = this.length; ++l < s;) {
            i.push(t = []);
            for (var c = this[l], u = -1, d = c.length; ++u < d;) (r = c[u]) && qa(r, u, a, n, o), t.push(r);
          }
          return Fa(i, a, n);
        }, G.interrupt = function (e) {
          return this.each(null == e ? Ra : Na(Va(e)));
        };
        var Ra = Na(Va());
        function Na(e) {
          return function () {
            var t, r, n;
            (t = this[e]) && (n = t[r = t.active]) && (n.timer.c = null, n.timer.t = NaN, --t.count ? delete t[r] : delete this[e], t.active += .5, n.event && n.event.interrupt.call(this, this.__data__, n.index));
          };
        }
        function Fa(e, t, r) {
          return B(e, Ha), e.namespace = t, e.id = r, e;
        }
        var Ea,
          ja,
          Ha = [],
          Ba = 0;
        function Ya(e, t, r, n) {
          var a = e.id,
            i = e.namespace;
          return ue(e, "function" == typeof r ? function (e, o, l) {
            e[i][a].tween.set(t, n(r.call(e, e.__data__, o, l)));
          } : (r = n(r), function (e) {
            e[i][a].tween.set(t, r);
          }));
        }
        function Ua(e) {
          return null == e && (e = ""), function () {
            this.textContent = e;
          };
        }
        function Va(e) {
          return null == e ? "__transition__" : "__transition_" + e + "__";
        }
        function qa(e, t, r, n, a) {
          var i,
            o,
            l,
            s,
            c,
            u = e[r] || (e[r] = {
              active: 0,
              count: 0
            }),
            d = u[n];
          function f(r) {
            var a = u.active,
              f = u[a];
            for (var p in f && (f.timer.c = null, f.timer.t = NaN, --u.count, delete u[a], f.event && f.event.interrupt.call(e, e.__data__, f.index)), u) if (+p < n) {
              var g = u[p];
              g.timer.c = null, g.timer.t = NaN, --u.count, delete u[p];
            }
            o.c = h, yt(function () {
              return o.c && h(r || 1) && (o.c = null, o.t = NaN), 1;
            }, 0, i), u.active = n, d.event && d.event.start.call(e, e.__data__, t), c = [], d.tween.forEach(function (r, n) {
              (n = n.call(e, e.__data__, t)) && c.push(n);
            }), s = d.ease, l = d.duration;
          }
          function h(a) {
            for (var i = a / l, o = s(i), f = c.length; f > 0;) c[--f].call(e, o);
            if (i >= 1) return d.event && d.event.end.call(e, e.__data__, t), --u.count ? delete u[n] : delete e[r], 1;
          }
          d || (i = a.time, o = yt(function (e) {
            var t = d.delay;
            if (o.t = t + i, t <= e) return f(e - t);
            o.c = f;
          }, 0, i), d = u[n] = {
            tween: new _(),
            time: i,
            timer: o,
            delay: a.delay,
            duration: a.duration,
            ease: a.ease,
            index: t
          }, a = null, ++u.count);
        }
        Ha.call = G.call, Ha.empty = G.empty, Ha.node = G.node, Ha.size = G.size, e.transition = function (t, r) {
          return t && t.transition ? Ea ? t.transition(r) : t : e.selection().transition(t);
        }, e.transition.prototype = Ha, Ha.select = function (e) {
          var t,
            r,
            n,
            a = this.id,
            i = this.namespace,
            o = [];
          e = Z(e);
          for (var l = -1, s = this.length; ++l < s;) {
            o.push(t = []);
            for (var c = this[l], u = -1, d = c.length; ++u < d;) (n = c[u]) && (r = e.call(n, n.__data__, u, l)) ? ("__data__" in n && (r.__data__ = n.__data__), qa(r, u, i, a, n[i][a]), t.push(r)) : t.push(null);
          }
          return Fa(o, i, a);
        }, Ha.selectAll = function (e) {
          var t,
            r,
            n,
            a,
            i,
            o = this.id,
            l = this.namespace,
            s = [];
          e = W(e);
          for (var c = -1, u = this.length; ++c < u;) for (var d = this[c], f = -1, h = d.length; ++f < h;) if (n = d[f]) {
            i = n[l][o], r = e.call(n, n.__data__, f, c), s.push(t = []);
            for (var p = -1, g = r.length; ++p < g;) (a = r[p]) && qa(a, p, l, o, i), t.push(a);
          }
          return Fa(s, l, o);
        }, Ha.filter = function (e) {
          var t,
            r,
            n = [];
          "function" != typeof e && (e = se(e));
          for (var a = 0, i = this.length; a < i; a++) {
            n.push(t = []);
            for (var o, l = 0, s = (o = this[a]).length; l < s; l++) (r = o[l]) && e.call(r, r.__data__, l, a) && t.push(r);
          }
          return Fa(n, this.namespace, this.id);
        }, Ha.tween = function (e, t) {
          var r = this.id,
            n = this.namespace;
          return arguments.length < 2 ? this.node()[n][r].tween.get(e) : ue(this, null == t ? function (t) {
            t[n][r].tween.remove(e);
          } : function (a) {
            a[n][r].tween.set(e, t);
          });
        }, Ha.attr = function (t, r) {
          if (arguments.length < 2) {
            for (r in t) this.attr(r, t[r]);
            return this;
          }
          var n = "transform" == t ? jr : vr,
            a = e.ns.qualify(t);
          function i() {
            this.removeAttribute(a);
          }
          function o() {
            this.removeAttributeNS(a.space, a.local);
          }
          function l(e) {
            return null == e ? i : (e += "", function () {
              var t,
                r = this.getAttribute(a);
              return r !== e && (t = n(r, e), function (e) {
                this.setAttribute(a, t(e));
              });
            });
          }
          function s(e) {
            return null == e ? o : (e += "", function () {
              var t,
                r = this.getAttributeNS(a.space, a.local);
              return r !== e && (t = n(r, e), function (e) {
                this.setAttributeNS(a.space, a.local, t(e));
              });
            });
          }
          return Ya(this, "attr." + t, r, a.local ? s : l);
        }, Ha.attrTween = function (t, r) {
          var n = e.ns.qualify(t);
          return this.tween("attr." + t, n.local ? function (e, t) {
            var a = r.call(this, e, t, this.getAttributeNS(n.space, n.local));
            return a && function (e) {
              this.setAttributeNS(n.space, n.local, a(e));
            };
          } : function (e, t) {
            var a = r.call(this, e, t, this.getAttribute(n));
            return a && function (e) {
              this.setAttribute(n, a(e));
            };
          });
        }, Ha.style = function (e, t, r) {
          var n = arguments.length;
          if (n < 3) {
            if ("string" != typeof e) {
              for (r in n < 2 && (t = ""), e) this.style(r, e[r], t);
              return this;
            }
            r = "";
          }
          function a() {
            this.style.removeProperty(e);
          }
          function i(t) {
            return null == t ? a : (t += "", function () {
              var n,
                a = o(this).getComputedStyle(this, null).getPropertyValue(e);
              return a !== t && (n = vr(a, t), function (t) {
                this.style.setProperty(e, n(t), r);
              });
            });
          }
          return Ya(this, "style." + e, t, i);
        }, Ha.styleTween = function (e, t, r) {
          function n(n, a) {
            var i = t.call(this, n, a, o(this).getComputedStyle(this, null).getPropertyValue(e));
            return i && function (t) {
              this.style.setProperty(e, i(t), r);
            };
          }
          return arguments.length < 3 && (r = ""), this.tween("style." + e, n);
        }, Ha.text = function (e) {
          return Ya(this, "text", e, Ua);
        }, Ha.remove = function () {
          var e = this.namespace;
          return this.each("end.transition", function () {
            var t;
            this[e].count < 2 && (t = this.parentNode) && t.removeChild(this);
          });
        }, Ha.ease = function (t) {
          var r = this.id,
            n = this.namespace;
          return arguments.length < 1 ? this.node()[n][r].ease : ("function" != typeof t && (t = e.ease.apply(e, arguments)), ue(this, function (e) {
            e[n][r].ease = t;
          }));
        }, Ha.delay = function (e) {
          var t = this.id,
            r = this.namespace;
          return arguments.length < 1 ? this.node()[r][t].delay : ue(this, "function" == typeof e ? function (n, a, i) {
            n[r][t].delay = +e.call(n, n.__data__, a, i);
          } : (e = +e, function (n) {
            n[r][t].delay = e;
          }));
        }, Ha.duration = function (e) {
          var t = this.id,
            r = this.namespace;
          return arguments.length < 1 ? this.node()[r][t].duration : ue(this, "function" == typeof e ? function (n, a, i) {
            n[r][t].duration = Math.max(1, e.call(n, n.__data__, a, i));
          } : (e = Math.max(1, e), function (n) {
            n[r][t].duration = e;
          }));
        }, Ha.each = function (t, r) {
          var n = this.id,
            a = this.namespace;
          if (arguments.length < 2) {
            var i = ja,
              o = Ea;
            try {
              Ea = n, ue(this, function (e, r, i) {
                ja = e[a][n], t.call(e, e.__data__, r, i);
              });
            } finally {
              ja = i, Ea = o;
            }
          } else ue(this, function (i) {
            var o = i[a][n];
            (o.event || (o.event = e.dispatch("start", "end", "interrupt"))).on(t, r);
          });
          return this;
        }, Ha.transition = function () {
          for (var e, t, r, n = this.id, a = ++Ba, i = this.namespace, o = [], l = 0, s = this.length; l < s; l++) {
            o.push(e = []);
            for (var c, u = 0, d = (c = this[l]).length; u < d; u++) (t = c[u]) && qa(t, u, i, a, {
              time: (r = t[i][n]).time,
              ease: r.ease,
              delay: r.delay + r.duration,
              duration: r.duration
            }), e.push(t);
          }
          return Fa(o, i, a);
        }, e.svg.axis = function () {
          var t,
            r = e.scale.linear(),
            a = Ga,
            i = 6,
            o = 6,
            l = 3,
            s = [10],
            c = null;
          function u(n) {
            n.each(function () {
              var n,
                u = e.select(this),
                d = this.__chart__ || r,
                f = this.__chart__ = r.copy(),
                h = null == c ? f.ticks ? f.ticks.apply(f, s) : f.domain() : c,
                p = null == t ? f.tickFormat ? f.tickFormat.apply(f, s) : C : t,
                g = u.selectAll(".tick").data(h, f),
                m = g.enter().insert("g", ".domain").attr("class", "tick").style("opacity", Te),
                y = e.transition(g.exit()).style("opacity", Te).remove(),
                v = e.transition(g.order()).style("opacity", 1),
                x = Math.max(i, 0) + l,
                b = Rn(f),
                _ = u.selectAll(".domain").data([0]),
                w = (_.enter().append("path").attr("class", "domain"), e.transition(_));
              m.append("line"), m.append("text");
              var M,
                T,
                k,
                A,
                L = m.select("line"),
                D = v.select("line"),
                S = g.select("text").text(p),
                O = m.select("text"),
                P = v.select("text"),
                I = "top" === a || "left" === a ? -1 : 1;
              if ("bottom" === a || "top" === a ? (n = Wa, M = "x", k = "y", T = "x2", A = "y2", S.attr("dy", I < 0 ? "0em" : ".71em").style("text-anchor", "middle"), w.attr("d", "M" + b[0] + "," + I * o + "V0H" + b[1] + "V" + I * o)) : (n = Ja, M = "y", k = "x", T = "y2", A = "x2", S.attr("dy", ".32em").style("text-anchor", I < 0 ? "end" : "start"), w.attr("d", "M" + I * o + "," + b[0] + "H0V" + b[1] + "H" + I * o)), L.attr(A, I * i), O.attr(k, I * x), D.attr(T, 0).attr(A, I * i), P.attr(M, 0).attr(k, I * x), f.rangeBand) {
                var z = f,
                  R = z.rangeBand() / 2;
                d = f = function f(e) {
                  return z(e) + R;
                };
              } else d.rangeBand ? d = f : y.call(n, f, d);
              m.call(n, d, f), v.call(n, f, f);
            });
          }
          return u.scale = function (e) {
            return arguments.length ? (r = e, u) : r;
          }, u.orient = function (e) {
            return arguments.length ? (a = e in Za ? e + "" : Ga, u) : a;
          }, u.ticks = function () {
            return arguments.length ? (s = n(arguments), u) : s;
          }, u.tickValues = function (e) {
            return arguments.length ? (c = e, u) : c;
          }, u.tickFormat = function (e) {
            return arguments.length ? (t = e, u) : t;
          }, u.tickSize = function (e) {
            var t = arguments.length;
            return t ? (i = +e, o = +arguments[t - 1], u) : i;
          }, u.innerTickSize = function (e) {
            return arguments.length ? (i = +e, u) : i;
          }, u.outerTickSize = function (e) {
            return arguments.length ? (o = +e, u) : o;
          }, u.tickPadding = function (e) {
            return arguments.length ? (l = +e, u) : l;
          }, u.tickSubdivide = function () {
            return arguments.length && u;
          }, u;
        };
        var Ga = "bottom",
          Za = {
            top: 1,
            right: 1,
            bottom: 1,
            left: 1
          };
        function Wa(e, t, r) {
          e.attr("transform", function (e) {
            var n = t(e);
            return "translate(" + (isFinite(n) ? n : r(e)) + ",0)";
          });
        }
        function Ja(e, t, r) {
          e.attr("transform", function (e) {
            var n = t(e);
            return "translate(0," + (isFinite(n) ? n : r(e)) + ")";
          });
        }
        e.svg.brush = function () {
          var t,
            r,
            n = j(f, "brushstart", "brush", "brushend"),
            a = null,
            i = null,
            l = [0, 0],
            s = [0, 0],
            c = !0,
            u = !0,
            d = Qa[0];
          function f(t) {
            t.each(function () {
              var t = e.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", m).on("touchstart.brush", m),
                r = t.selectAll(".background").data([0]);
              r.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), t.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
              var n = t.selectAll(".resize").data(d, C);
              n.exit().remove(), n.enter().append("g").attr("class", function (e) {
                return "resize " + e;
              }).style("cursor", function (e) {
                return Xa[e];
              }).append("rect").attr("x", function (e) {
                return /[ew]$/.test(e) ? -3 : null;
              }).attr("y", function (e) {
                return /^[ns]/.test(e) ? -3 : null;
              }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), n.style("display", f.empty() ? "none" : null);
              var o,
                l = e.transition(t),
                s = e.transition(r);
              a && (o = Rn(a), s.attr("x", o[0]).attr("width", o[1] - o[0]), p(l)), i && (o = Rn(i), s.attr("y", o[0]).attr("height", o[1] - o[0]), g(l)), h(l);
            });
          }
          function h(e) {
            e.selectAll(".resize").attr("transform", function (e) {
              return "translate(" + l[+/e$/.test(e)] + "," + s[+/^s/.test(e)] + ")";
            });
          }
          function p(e) {
            e.select(".extent").attr("x", l[0]), e.selectAll(".extent,.n>rect,.s>rect").attr("width", l[1] - l[0]);
          }
          function g(e) {
            e.select(".extent").attr("y", s[0]), e.selectAll(".extent,.e>rect,.w>rect").attr("height", s[1] - s[0]);
          }
          function m() {
            var d,
              m,
              y = this,
              v = e.select(e.event.target),
              x = n.of(y, arguments),
              b = e.select(y),
              _ = v.datum(),
              w = !/^(n|s)$/.test(_) && a,
              M = !/^(e|w)$/.test(_) && i,
              T = v.classed("extent"),
              k = be(y),
              A = e.mouse(y),
              L = e.select(o(y)).on("keydown.brush", C).on("keyup.brush", O);
            if (e.event.changedTouches ? L.on("touchmove.brush", P).on("touchend.brush", z) : L.on("mousemove.brush", P).on("mouseup.brush", z), b.interrupt().selectAll("*").interrupt(), T) A[0] = l[0] - A[0], A[1] = s[0] - A[1];else if (_) {
              var D = +/w$/.test(_),
                S = +/^n/.test(_);
              m = [l[1 - D] - A[0], s[1 - S] - A[1]], A[0] = l[D], A[1] = s[S];
            } else e.event.altKey && (d = A.slice());
            function C() {
              32 == e.event.keyCode && (T || (d = null, A[0] -= l[1], A[1] -= s[1], T = 2), F());
            }
            function O() {
              32 == e.event.keyCode && 2 == T && (A[0] += l[1], A[1] += s[1], T = 0, F());
            }
            function P() {
              var t = e.mouse(y),
                r = !1;
              m && (t[0] += m[0], t[1] += m[1]), T || (e.event.altKey ? (d || (d = [(l[0] + l[1]) / 2, (s[0] + s[1]) / 2]), A[0] = l[+(t[0] < d[0])], A[1] = s[+(t[1] < d[1])]) : d = null), w && I(t, a, 0) && (p(b), r = !0), M && I(t, i, 1) && (g(b), r = !0), r && (h(b), x({
                type: "brush",
                mode: T ? "move" : "resize"
              }));
            }
            function I(e, n, a) {
              var i,
                o,
                f = Rn(n),
                h = f[0],
                p = f[1],
                g = A[a],
                m = a ? s : l,
                y = m[1] - m[0];
              if (T && (h -= g, p -= y + g), i = (a ? u : c) ? Math.max(h, Math.min(p, e[a])) : e[a], T ? o = (i += g) + y : (d && (g = Math.max(h, Math.min(p, 2 * d[a] - i))), g < i ? (o = i, i = g) : o = g), m[0] != i || m[1] != o) return a ? r = null : t = null, m[0] = i, m[1] = o, !0;
            }
            function z() {
              P(), b.style("pointer-events", "all").selectAll(".resize").style("display", f.empty() ? "none" : null), e.select("body").style("cursor", null), L.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), k(), x({
                type: "brushend"
              });
            }
            b.style("pointer-events", "none").selectAll(".resize").style("display", null), e.select("body").style("cursor", v.style("cursor")), x({
              type: "brushstart"
            }), P();
          }
          return f.event = function (a) {
            a.each(function () {
              var a = n.of(this, arguments),
                i = {
                  x: l,
                  y: s,
                  i: t,
                  j: r
                },
                o = this.__chart__ || i;
              this.__chart__ = i, Ea ? e.select(this).transition().each("start.brush", function () {
                t = o.i, r = o.j, l = o.x, s = o.y, a({
                  type: "brushstart"
                });
              }).tween("brush:brush", function () {
                var e = xr(l, i.x),
                  n = xr(s, i.y);
                return t = r = null, function (t) {
                  l = i.x = e(t), s = i.y = n(t), a({
                    type: "brush",
                    mode: "resize"
                  });
                };
              }).each("end.brush", function () {
                t = i.i, r = i.j, a({
                  type: "brush",
                  mode: "resize"
                }), a({
                  type: "brushend"
                });
              }) : (a({
                type: "brushstart"
              }), a({
                type: "brush",
                mode: "resize"
              }), a({
                type: "brushend"
              }));
            });
          }, f.x = function (e) {
            return arguments.length ? (d = Qa[!(a = e) << 1 | !i], f) : a;
          }, f.y = function (e) {
            return arguments.length ? (d = Qa[!a << 1 | !(i = e)], f) : i;
          }, f.clamp = function (e) {
            return arguments.length ? (a && i ? (c = !!e[0], u = !!e[1]) : a ? c = !!e : i && (u = !!e), f) : a && i ? [c, u] : a ? c : i ? u : null;
          }, f.extent = function (e) {
            var n, o, c, u, d;
            return arguments.length ? (a && (n = e[0], o = e[1], i && (n = n[0], o = o[0]), t = [n, o], a.invert && (n = a(n), o = a(o)), o < n && (d = n, n = o, o = d), n == l[0] && o == l[1] || (l = [n, o])), i && (c = e[0], u = e[1], a && (c = c[1], u = u[1]), r = [c, u], i.invert && (c = i(c), u = i(u)), u < c && (d = c, c = u, u = d), c == s[0] && u == s[1] || (s = [c, u])), f) : (a && (t ? (n = t[0], o = t[1]) : (n = l[0], o = l[1], a.invert && (n = a.invert(n), o = a.invert(o)), o < n && (d = n, n = o, o = d))), i && (r ? (c = r[0], u = r[1]) : (c = s[0], u = s[1], i.invert && (c = i.invert(c), u = i.invert(u)), u < c && (d = c, c = u, u = d))), a && i ? [[n, c], [o, u]] : a ? [n, o] : i && [c, u]);
          }, f.clear = function () {
            return f.empty() || (l = [0, 0], s = [0, 0], t = r = null), f;
          }, f.empty = function () {
            return !!a && l[0] == l[1] || !!i && s[0] == s[1];
          }, e.rebind(f, n, "on");
        };
        var Xa = {
            n: "ns-resize",
            e: "ew-resize",
            s: "ns-resize",
            w: "ew-resize",
            nw: "nwse-resize",
            ne: "nesw-resize",
            se: "nwse-resize",
            sw: "nesw-resize"
          },
          Qa = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []];
        function Ka(e) {
          return JSON.parse(e.responseText);
        }
        function $a(e) {
          var t = a.createRange();
          return t.selectNode(a.body), t.createContextualFragment(e.responseText);
        }
        e.text = ut(function (e) {
          return e.responseText;
        }), e.json = function (e, t) {
          return dt(e, "application/json", Ka, t);
        }, e.html = function (e, t) {
          return dt(e, "text/html", $a, t);
        }, e.xml = ut(function (e) {
          return e.responseXML;
        }), "object" == typeof t && t.exports ? t.exports = e : this.d3 = e;
      }).apply(self);
    }, {}],
    7: [function (e, t, r) {
      !function (e, n) {
        "object" == typeof r && void 0 !== t ? n(r) : n((e = "undefined" != typeof globalThis ? globalThis : e || self).d3 = e.d3 || {});
      }(this, function (e) {
        "use strict";

        function t(e, t) {
          if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
          var r,
            n = e.slice(0, r);
          return [n.length > 1 ? n[0] + n.slice(2) : n, +e.slice(r + 1)];
        }
        function r(e) {
          return (e = t(Math.abs(e))) ? e[1] : NaN;
        }
        var n,
          a = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
        function i(e) {
          if (!(t = a.exec(e))) throw new Error("invalid format: " + e);
          var t;
          return new o({
            fill: t[1],
            align: t[2],
            sign: t[3],
            symbol: t[4],
            zero: t[5],
            width: t[6],
            comma: t[7],
            precision: t[8] && t[8].slice(1),
            trim: t[9],
            type: t[10]
          });
        }
        function o(e) {
          this.fill = void 0 === e.fill ? " " : e.fill + "", this.align = void 0 === e.align ? ">" : e.align + "", this.sign = void 0 === e.sign ? "-" : e.sign + "", this.symbol = void 0 === e.symbol ? "" : e.symbol + "", this.zero = !!e.zero, this.width = void 0 === e.width ? void 0 : +e.width, this.comma = !!e.comma, this.precision = void 0 === e.precision ? void 0 : +e.precision, this.trim = !!e.trim, this.type = void 0 === e.type ? "" : e.type + "";
        }
        function l(e, r) {
          var n = t(e, r);
          if (!n) return e + "";
          var a = n[0],
            i = n[1];
          return i < 0 ? "0." + new Array(-i).join("0") + a : a.length > i + 1 ? a.slice(0, i + 1) + "." + a.slice(i + 1) : a + new Array(i - a.length + 2).join("0");
        }
        i.prototype = o.prototype, o.prototype.toString = function () {
          return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
        };
        var s = {
          "%": function _(e, t) {
            return (100 * e).toFixed(t);
          },
          b: function b(e) {
            return Math.round(e).toString(2);
          },
          c: function c(e) {
            return e + "";
          },
          d: function d(e) {
            return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
          },
          e: function e(_e2, t) {
            return _e2.toExponential(t);
          },
          f: function f(e, t) {
            return e.toFixed(t);
          },
          g: function g(e, t) {
            return e.toPrecision(t);
          },
          o: function o(e) {
            return Math.round(e).toString(8);
          },
          p: function p(e, t) {
            return l(100 * e, t);
          },
          r: l,
          s: function s(e, r) {
            var a = t(e, r);
            if (!a) return e + "";
            var i = a[0],
              o = a[1],
              l = o - (n = 3 * Math.max(-8, Math.min(8, Math.floor(o / 3)))) + 1,
              s = i.length;
            return l === s ? i : l > s ? i + new Array(l - s + 1).join("0") : l > 0 ? i.slice(0, l) + "." + i.slice(l) : "0." + new Array(1 - l).join("0") + t(e, Math.max(0, r + l - 1))[0];
          },
          X: function X(e) {
            return Math.round(e).toString(16).toUpperCase();
          },
          x: function x(e) {
            return Math.round(e).toString(16);
          }
        };
        function c(e) {
          return e;
        }
        var u,
          d = Array.prototype.map,
          f = ["y", "z", "a", "f", "p", "n", "\xb5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
        function h(e) {
          var t,
            a,
            o = void 0 === e.grouping || void 0 === e.thousands ? c : (t = d.call(e.grouping, Number), a = e.thousands + "", function (e, r) {
              for (var n = e.length, i = [], o = 0, l = t[0], s = 0; n > 0 && l > 0 && (s + l + 1 > r && (l = Math.max(1, r - s)), i.push(e.substring(n -= l, n + l)), !((s += l + 1) > r));) l = t[o = (o + 1) % t.length];
              return i.reverse().join(a);
            }),
            l = void 0 === e.currency ? "" : e.currency[0] + "",
            u = void 0 === e.currency ? "" : e.currency[1] + "",
            h = void 0 === e.decimal ? "." : e.decimal + "",
            p = void 0 === e.numerals ? c : function (e) {
              return function (t) {
                return t.replace(/[0-9]/g, function (t) {
                  return e[+t];
                });
              };
            }(d.call(e.numerals, String)),
            g = void 0 === e.percent ? "%" : e.percent + "",
            m = void 0 === e.minus ? "-" : e.minus + "",
            y = void 0 === e.nan ? "NaN" : e.nan + "";
          function v(e) {
            var t = (e = i(e)).fill,
              r = e.align,
              a = e.sign,
              c = e.symbol,
              d = e.zero,
              v = e.width,
              x = e.comma,
              b = e.precision,
              _ = e.trim,
              w = e.type;
            "n" === w ? (x = !0, w = "g") : s[w] || (void 0 === b && (b = 12), _ = !0, w = "g"), (d || "0" === t && "=" === r) && (d = !0, t = "0", r = "=");
            var M = "$" === c ? l : "#" === c && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "",
              T = "$" === c ? u : /[%p]/.test(w) ? g : "",
              k = s[w],
              A = /[defgprs%]/.test(w);
            function L(e) {
              var i,
                l,
                s,
                c = M,
                u = T;
              if ("c" === w) u = k(e) + u, e = "";else {
                var g = (e = +e) < 0 || 1 / e < 0;
                if (e = isNaN(e) ? y : k(Math.abs(e), b), _ && (e = function (e) {
                  e: for (var t, r = e.length, n = 1, a = -1; n < r; ++n) switch (e[n]) {
                    case ".":
                      a = t = n;
                      break;
                    case "0":
                      0 === a && (a = n), t = n;
                      break;
                    default:
                      if (!+e[n]) break e;
                      a > 0 && (a = 0);
                  }
                  return a > 0 ? e.slice(0, a) + e.slice(t + 1) : e;
                }(e)), g && 0 == +e && "+" !== a && (g = !1), c = (g ? "(" === a ? a : m : "-" === a || "(" === a ? "" : a) + c, u = ("s" === w ? f[8 + n / 3] : "") + u + (g && "(" === a ? ")" : ""), A) for (i = -1, l = e.length; ++i < l;) if (48 > (s = e.charCodeAt(i)) || s > 57) {
                  u = (46 === s ? h + e.slice(i + 1) : e.slice(i)) + u, e = e.slice(0, i);
                  break;
                }
              }
              x && !d && (e = o(e, 1 / 0));
              var L = c.length + e.length + u.length,
                D = L < v ? new Array(v - L + 1).join(t) : "";
              switch (x && d && (e = o(D + e, D.length ? v - u.length : 1 / 0), D = ""), r) {
                case "<":
                  e = c + e + u + D;
                  break;
                case "=":
                  e = c + D + e + u;
                  break;
                case "^":
                  e = D.slice(0, L = D.length >> 1) + c + e + u + D.slice(L);
                  break;
                default:
                  e = D + c + e + u;
              }
              return p(e);
            }
            return b = void 0 === b ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, b)) : Math.max(0, Math.min(20, b)), L.toString = function () {
              return e + "";
            }, L;
          }
          return {
            format: v,
            formatPrefix: function formatPrefix(e, t) {
              var n = v(((e = i(e)).type = "f", e)),
                a = 3 * Math.max(-8, Math.min(8, Math.floor(r(t) / 3))),
                o = Math.pow(10, -a),
                l = f[8 + a / 3];
              return function (e) {
                return n(o * e) + l;
              };
            }
          };
        }
        function p(t) {
          return u = h(t), e.format = u.format, e.formatPrefix = u.formatPrefix, u;
        }
        p({
          decimal: ".",
          thousands: ",",
          grouping: [3],
          currency: ["$", ""],
          minus: "-"
        }), e.FormatSpecifier = o, e.formatDefaultLocale = p, e.formatLocale = h, e.formatSpecifier = i, e.precisionFixed = function (e) {
          return Math.max(0, -r(Math.abs(e)));
        }, e.precisionPrefix = function (e, t) {
          return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(r(t) / 3))) - r(Math.abs(e)));
        }, e.precisionRound = function (e, t) {
          return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, r(t) - r(e)) + 1;
        }, Object.defineProperty(e, "__esModule", {
          value: !0
        });
      });
    }, {}],
    8: [function (e, t, r) {
      !function (n, a) {
        "object" == typeof r && void 0 !== t ? a(r, e("d3-time")) : a((n = n || self).d3 = n.d3 || {}, n.d3);
      }(this, function (e, t) {
        "use strict";

        function r(e) {
          if (0 <= e.y && e.y < 100) {
            var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
            return t.setFullYear(e.y), t;
          }
          return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
        }
        function n(e) {
          if (0 <= e.y && e.y < 100) {
            var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
            return t.setUTCFullYear(e.y), t;
          }
          return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
        }
        function a(e, t, r) {
          return {
            y: e,
            m: t,
            d: r,
            H: 0,
            M: 0,
            S: 0,
            L: 0
          };
        }
        function i(e) {
          var i = e.dateTime,
            o = e.date,
            s = e.time,
            c = e.periods,
            u = e.days,
            d = e.shortDays,
            f = e.months,
            G = e.shortMonths,
            fe = h(c),
            Te = p(c),
            ke = h(u),
            Ae = p(u),
            Le = h(d),
            De = p(d),
            Se = h(f),
            Ce = p(f),
            Oe = h(G),
            Pe = p(G),
            Ie = {
              a: function a(e) {
                return d[e.getDay()];
              },
              A: function A(e) {
                return u[e.getDay()];
              },
              b: function b(e) {
                return G[e.getMonth()];
              },
              B: function B(e) {
                return f[e.getMonth()];
              },
              c: null,
              d: R,
              e: R,
              f: H,
              g: Q,
              G: $,
              H: N,
              I: F,
              j: E,
              L: j,
              m: B,
              M: Y,
              p: function p(e) {
                return c[+(e.getHours() >= 12)];
              },
              q: function q(e) {
                return 1 + ~~(e.getMonth() / 3);
              },
              Q: we,
              s: Me,
              S: U,
              u: V,
              U: q,
              V: Z,
              w: W,
              W: J,
              x: null,
              X: null,
              y: X,
              Y: K,
              Z: ee,
              "%": _e
            },
            ze = {
              a: function a(e) {
                return d[e.getUTCDay()];
              },
              A: function A(e) {
                return u[e.getUTCDay()];
              },
              b: function b(e) {
                return G[e.getUTCMonth()];
              },
              B: function B(e) {
                return f[e.getUTCMonth()];
              },
              c: null,
              d: te,
              e: te,
              f: oe,
              g: ye,
              G: xe,
              H: re,
              I: ne,
              j: ae,
              L: ie,
              m: le,
              M: se,
              p: function p(e) {
                return c[+(e.getUTCHours() >= 12)];
              },
              q: function q(e) {
                return 1 + ~~(e.getUTCMonth() / 3);
              },
              Q: we,
              s: Me,
              S: ce,
              u: ue,
              U: de,
              V: he,
              w: pe,
              W: ge,
              x: null,
              X: null,
              y: me,
              Y: ve,
              Z: be,
              "%": _e
            },
            Re = {
              a: function a(e, t, r) {
                var n = Le.exec(t.slice(r));
                return n ? (e.w = De[n[0].toLowerCase()], r + n[0].length) : -1;
              },
              A: function A(e, t, r) {
                var n = ke.exec(t.slice(r));
                return n ? (e.w = Ae[n[0].toLowerCase()], r + n[0].length) : -1;
              },
              b: function b(e, t, r) {
                var n = Oe.exec(t.slice(r));
                return n ? (e.m = Pe[n[0].toLowerCase()], r + n[0].length) : -1;
              },
              B: function B(e, t, r) {
                var n = Se.exec(t.slice(r));
                return n ? (e.m = Ce[n[0].toLowerCase()], r + n[0].length) : -1;
              },
              c: function c(e, t, r) {
                return Ee(e, i, t, r);
              },
              d: k,
              e: k,
              f: O,
              g: _,
              G: b,
              H: L,
              I: L,
              j: A,
              L: C,
              m: T,
              M: D,
              p: function p(e, t, r) {
                var n = fe.exec(t.slice(r));
                return n ? (e.p = Te[n[0].toLowerCase()], r + n[0].length) : -1;
              },
              q: M,
              Q: I,
              s: z,
              S: S,
              u: m,
              U: y,
              V: v,
              w: g,
              W: x,
              x: function x(e, t, r) {
                return Ee(e, o, t, r);
              },
              X: function X(e, t, r) {
                return Ee(e, s, t, r);
              },
              y: _,
              Y: b,
              Z: w,
              "%": P
            };
          function Ne(e, t) {
            return function (r) {
              var n,
                a,
                i,
                o = [],
                s = -1,
                c = 0,
                u = e.length;
              for (r instanceof Date || (r = new Date(+r)); ++s < u;) 37 === e.charCodeAt(s) && (o.push(e.slice(c, s)), null != (a = l[n = e.charAt(++s)]) ? n = e.charAt(++s) : a = "e" === n ? " " : "0", (i = t[n]) && (n = i(r, a)), o.push(n), c = s + 1);
              return o.push(e.slice(c, s)), o.join("");
            };
          }
          function Fe(e, i) {
            return function (o) {
              var l,
                s,
                c = a(1900, void 0, 1);
              if (Ee(c, e, o += "", 0) != o.length) return null;
              if ("Q" in c) return new Date(c.Q);
              if ("s" in c) return new Date(1e3 * c.s + ("L" in c ? c.L : 0));
              if (i && !("Z" in c) && (c.Z = 0), "p" in c && (c.H = c.H % 12 + 12 * c.p), void 0 === c.m && (c.m = "q" in c ? c.q : 0), "V" in c) {
                if (c.V < 1 || c.V > 53) return null;
                "w" in c || (c.w = 1), "Z" in c ? (s = (l = n(a(c.y, 0, 1))).getUTCDay(), l = s > 4 || 0 === s ? t.utcMonday.ceil(l) : t.utcMonday(l), l = t.utcDay.offset(l, 7 * (c.V - 1)), c.y = l.getUTCFullYear(), c.m = l.getUTCMonth(), c.d = l.getUTCDate() + (c.w + 6) % 7) : (s = (l = r(a(c.y, 0, 1))).getDay(), l = s > 4 || 0 === s ? t.timeMonday.ceil(l) : t.timeMonday(l), l = t.timeDay.offset(l, 7 * (c.V - 1)), c.y = l.getFullYear(), c.m = l.getMonth(), c.d = l.getDate() + (c.w + 6) % 7);
              } else ("W" in c || "U" in c) && ("w" in c || (c.w = "u" in c ? c.u % 7 : "W" in c ? 1 : 0), s = "Z" in c ? n(a(c.y, 0, 1)).getUTCDay() : r(a(c.y, 0, 1)).getDay(), c.m = 0, c.d = "W" in c ? (c.w + 6) % 7 + 7 * c.W - (s + 5) % 7 : c.w + 7 * c.U - (s + 6) % 7);
              return "Z" in c ? (c.H += c.Z / 100 | 0, c.M += c.Z % 100, n(c)) : r(c);
            };
          }
          function Ee(e, t, r, n) {
            for (var a, i, o = 0, s = t.length, c = r.length; o < s;) {
              if (n >= c) return -1;
              if (37 === (a = t.charCodeAt(o++))) {
                if (a = t.charAt(o++), !(i = Re[a in l ? t.charAt(o++) : a]) || (n = i(e, r, n)) < 0) return -1;
              } else if (a != r.charCodeAt(n++)) return -1;
            }
            return n;
          }
          return Ie.x = Ne(o, Ie), Ie.X = Ne(s, Ie), Ie.c = Ne(i, Ie), ze.x = Ne(o, ze), ze.X = Ne(s, ze), ze.c = Ne(i, ze), {
            format: function format(e) {
              var t = Ne(e += "", Ie);
              return t.toString = function () {
                return e;
              }, t;
            },
            parse: function parse(e) {
              var t = Fe(e += "", !1);
              return t.toString = function () {
                return e;
              }, t;
            },
            utcFormat: function utcFormat(e) {
              var t = Ne(e += "", ze);
              return t.toString = function () {
                return e;
              }, t;
            },
            utcParse: function utcParse(e) {
              var t = Fe(e += "", !0);
              return t.toString = function () {
                return e;
              }, t;
            }
          };
        }
        var o,
          l = {
            "-": "",
            _: " ",
            0: "0"
          },
          s = /^\s*\d+/,
          c = /^%/,
          u = /[\\^$*+?|[\]().{}]/g;
        function d(e, t, r) {
          var n = e < 0 ? "-" : "",
            a = (n ? -e : e) + "",
            i = a.length;
          return n + (i < r ? new Array(r - i + 1).join(t) + a : a);
        }
        function f(e) {
          return e.replace(u, "\\$&");
        }
        function h(e) {
          return new RegExp("^(?:" + e.map(f).join("|") + ")", "i");
        }
        function p(e) {
          for (var t = {}, r = -1, n = e.length; ++r < n;) t[e[r].toLowerCase()] = r;
          return t;
        }
        function g(e, t, r) {
          var n = s.exec(t.slice(r, r + 1));
          return n ? (e.w = +n[0], r + n[0].length) : -1;
        }
        function m(e, t, r) {
          var n = s.exec(t.slice(r, r + 1));
          return n ? (e.u = +n[0], r + n[0].length) : -1;
        }
        function y(e, t, r) {
          var n = s.exec(t.slice(r, r + 2));
          return n ? (e.U = +n[0], r + n[0].length) : -1;
        }
        function v(e, t, r) {
          var n = s.exec(t.slice(r, r + 2));
          return n ? (e.V = +n[0], r + n[0].length) : -1;
        }
        function x(e, t, r) {
          var n = s.exec(t.slice(r, r + 2));
          return n ? (e.W = +n[0], r + n[0].length) : -1;
        }
        function b(e, t, r) {
          var n = s.exec(t.slice(r, r + 4));
          return n ? (e.y = +n[0], r + n[0].length) : -1;
        }
        function _(e, t, r) {
          var n = s.exec(t.slice(r, r + 2));
          return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
        }
        function w(e, t, r) {
          var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
          return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
        }
        function M(e, t, r) {
          var n = s.exec(t.slice(r, r + 1));
          return n ? (e.q = 3 * n[0] - 3, r + n[0].length) : -1;
        }
        function T(e, t, r) {
          var n = s.exec(t.slice(r, r + 2));
          return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
        }
        function k(e, t, r) {
          var n = s.exec(t.slice(r, r + 2));
          return n ? (e.d = +n[0], r + n[0].length) : -1;
        }
        function A(e, t, r) {
          var n = s.exec(t.slice(r, r + 3));
          return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
        }
        function L(e, t, r) {
          var n = s.exec(t.slice(r, r + 2));
          return n ? (e.H = +n[0], r + n[0].length) : -1;
        }
        function D(e, t, r) {
          var n = s.exec(t.slice(r, r + 2));
          return n ? (e.M = +n[0], r + n[0].length) : -1;
        }
        function S(e, t, r) {
          var n = s.exec(t.slice(r, r + 2));
          return n ? (e.S = +n[0], r + n[0].length) : -1;
        }
        function C(e, t, r) {
          var n = s.exec(t.slice(r, r + 3));
          return n ? (e.L = +n[0], r + n[0].length) : -1;
        }
        function O(e, t, r) {
          var n = s.exec(t.slice(r, r + 6));
          return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
        }
        function P(e, t, r) {
          var n = c.exec(t.slice(r, r + 1));
          return n ? r + n[0].length : -1;
        }
        function I(e, t, r) {
          var n = s.exec(t.slice(r));
          return n ? (e.Q = +n[0], r + n[0].length) : -1;
        }
        function z(e, t, r) {
          var n = s.exec(t.slice(r));
          return n ? (e.s = +n[0], r + n[0].length) : -1;
        }
        function R(e, t) {
          return d(e.getDate(), t, 2);
        }
        function N(e, t) {
          return d(e.getHours(), t, 2);
        }
        function F(e, t) {
          return d(e.getHours() % 12 || 12, t, 2);
        }
        function E(e, r) {
          return d(1 + t.timeDay.count(t.timeYear(e), e), r, 3);
        }
        function j(e, t) {
          return d(e.getMilliseconds(), t, 3);
        }
        function H(e, t) {
          return j(e, t) + "000";
        }
        function B(e, t) {
          return d(e.getMonth() + 1, t, 2);
        }
        function Y(e, t) {
          return d(e.getMinutes(), t, 2);
        }
        function U(e, t) {
          return d(e.getSeconds(), t, 2);
        }
        function V(e) {
          var t = e.getDay();
          return 0 === t ? 7 : t;
        }
        function q(e, r) {
          return d(t.timeSunday.count(t.timeYear(e) - 1, e), r, 2);
        }
        function G(e) {
          var r = e.getDay();
          return r >= 4 || 0 === r ? t.timeThursday(e) : t.timeThursday.ceil(e);
        }
        function Z(e, r) {
          return e = G(e), d(t.timeThursday.count(t.timeYear(e), e) + (4 === t.timeYear(e).getDay()), r, 2);
        }
        function W(e) {
          return e.getDay();
        }
        function J(e, r) {
          return d(t.timeMonday.count(t.timeYear(e) - 1, e), r, 2);
        }
        function X(e, t) {
          return d(e.getFullYear() % 100, t, 2);
        }
        function Q(e, t) {
          return d((e = G(e)).getFullYear() % 100, t, 2);
        }
        function K(e, t) {
          return d(e.getFullYear() % 1e4, t, 4);
        }
        function $(e, r) {
          var n = e.getDay();
          return d((e = n >= 4 || 0 === n ? t.timeThursday(e) : t.timeThursday.ceil(e)).getFullYear() % 1e4, r, 4);
        }
        function ee(e) {
          var t = e.getTimezoneOffset();
          return (t > 0 ? "-" : (t *= -1, "+")) + d(t / 60 | 0, "0", 2) + d(t % 60, "0", 2);
        }
        function te(e, t) {
          return d(e.getUTCDate(), t, 2);
        }
        function re(e, t) {
          return d(e.getUTCHours(), t, 2);
        }
        function ne(e, t) {
          return d(e.getUTCHours() % 12 || 12, t, 2);
        }
        function ae(e, r) {
          return d(1 + t.utcDay.count(t.utcYear(e), e), r, 3);
        }
        function ie(e, t) {
          return d(e.getUTCMilliseconds(), t, 3);
        }
        function oe(e, t) {
          return ie(e, t) + "000";
        }
        function le(e, t) {
          return d(e.getUTCMonth() + 1, t, 2);
        }
        function se(e, t) {
          return d(e.getUTCMinutes(), t, 2);
        }
        function ce(e, t) {
          return d(e.getUTCSeconds(), t, 2);
        }
        function ue(e) {
          var t = e.getUTCDay();
          return 0 === t ? 7 : t;
        }
        function de(e, r) {
          return d(t.utcSunday.count(t.utcYear(e) - 1, e), r, 2);
        }
        function fe(e) {
          var r = e.getUTCDay();
          return r >= 4 || 0 === r ? t.utcThursday(e) : t.utcThursday.ceil(e);
        }
        function he(e, r) {
          return e = fe(e), d(t.utcThursday.count(t.utcYear(e), e) + (4 === t.utcYear(e).getUTCDay()), r, 2);
        }
        function pe(e) {
          return e.getUTCDay();
        }
        function ge(e, r) {
          return d(t.utcMonday.count(t.utcYear(e) - 1, e), r, 2);
        }
        function me(e, t) {
          return d(e.getUTCFullYear() % 100, t, 2);
        }
        function ye(e, t) {
          return d((e = fe(e)).getUTCFullYear() % 100, t, 2);
        }
        function ve(e, t) {
          return d(e.getUTCFullYear() % 1e4, t, 4);
        }
        function xe(e, r) {
          var n = e.getUTCDay();
          return d((e = n >= 4 || 0 === n ? t.utcThursday(e) : t.utcThursday.ceil(e)).getUTCFullYear() % 1e4, r, 4);
        }
        function be() {
          return "+0000";
        }
        function _e() {
          return "%";
        }
        function we(e) {
          return +e;
        }
        function Me(e) {
          return Math.floor(+e / 1e3);
        }
        function Te(t) {
          return o = i(t), e.timeFormat = o.format, e.timeParse = o.parse, e.utcFormat = o.utcFormat, e.utcParse = o.utcParse, o;
        }
        Te({
          dateTime: "%x, %X",
          date: "%-m/%-d/%Y",
          time: "%-I:%M:%S %p",
          periods: ["AM", "PM"],
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        });
        var ke = Date.prototype.toISOString ? function (e) {
          return e.toISOString();
        } : e.utcFormat("%Y-%m-%dT%H:%M:%S.%LZ");
        var Ae = +new Date("2000-01-01T00:00:00.000Z") ? function (e) {
          var t = new Date(e);
          return isNaN(t) ? null : t;
        } : e.utcParse("%Y-%m-%dT%H:%M:%S.%LZ");
        e.isoFormat = ke, e.isoParse = Ae, e.timeFormatDefaultLocale = Te, e.timeFormatLocale = i, Object.defineProperty(e, "__esModule", {
          value: !0
        });
      });
    }, {
      "d3-time": 9
    }],
    9: [function (e, t, r) {
      !function (e, n) {
        "object" == typeof r && void 0 !== t ? n(r) : n((e = e || self).d3 = e.d3 || {});
      }(this, function (e) {
        "use strict";

        var t = new Date(),
          r = new Date();
        function n(e, a, i, o) {
          function l(t) {
            return e(t = 0 === arguments.length ? new Date() : new Date(+t)), t;
          }
          return l.floor = function (t) {
            return e(t = new Date(+t)), t;
          }, l.ceil = function (t) {
            return e(t = new Date(t - 1)), a(t, 1), e(t), t;
          }, l.round = function (e) {
            var t = l(e),
              r = l.ceil(e);
            return e - t < r - e ? t : r;
          }, l.offset = function (e, t) {
            return a(e = new Date(+e), null == t ? 1 : Math.floor(t)), e;
          }, l.range = function (t, r, n) {
            var i,
              o = [];
            if (t = l.ceil(t), n = null == n ? 1 : Math.floor(n), !(t < r && n > 0)) return o;
            do {
              o.push(i = new Date(+t)), a(t, n), e(t);
            } while (i < t && t < r);
            return o;
          }, l.filter = function (t) {
            return n(function (r) {
              if (r >= r) for (; e(r), !t(r);) r.setTime(r - 1);
            }, function (e, r) {
              if (e >= e) if (r < 0) for (; ++r <= 0;) for (; a(e, -1), !t(e););else for (; --r >= 0;) for (; a(e, 1), !t(e););
            });
          }, i && (l.count = function (n, a) {
            return t.setTime(+n), r.setTime(+a), e(t), e(r), Math.floor(i(t, r));
          }, l.every = function (e) {
            return e = Math.floor(e), isFinite(e) && e > 0 ? e > 1 ? l.filter(o ? function (t) {
              return o(t) % e == 0;
            } : function (t) {
              return l.count(0, t) % e == 0;
            }) : l : null;
          }), l;
        }
        var a = n(function () {}, function (e, t) {
          e.setTime(+e + t);
        }, function (e, t) {
          return t - e;
        });
        a.every = function (e) {
          return e = Math.floor(e), isFinite(e) && e > 0 ? e > 1 ? n(function (t) {
            t.setTime(Math.floor(t / e) * e);
          }, function (t, r) {
            t.setTime(+t + r * e);
          }, function (t, r) {
            return (r - t) / e;
          }) : a : null;
        };
        var i = a.range,
          o = n(function (e) {
            e.setTime(e - e.getMilliseconds());
          }, function (e, t) {
            e.setTime(+e + 1e3 * t);
          }, function (e, t) {
            return (t - e) / 1e3;
          }, function (e) {
            return e.getUTCSeconds();
          }),
          l = o.range,
          s = n(function (e) {
            e.setTime(e - e.getMilliseconds() - 1e3 * e.getSeconds());
          }, function (e, t) {
            e.setTime(+e + 6e4 * t);
          }, function (e, t) {
            return (t - e) / 6e4;
          }, function (e) {
            return e.getMinutes();
          }),
          c = s.range,
          u = n(function (e) {
            e.setTime(e - e.getMilliseconds() - 1e3 * e.getSeconds() - 6e4 * e.getMinutes());
          }, function (e, t) {
            e.setTime(+e + 36e5 * t);
          }, function (e, t) {
            return (t - e) / 36e5;
          }, function (e) {
            return e.getHours();
          }),
          d = u.range,
          f = n(function (e) {
            e.setHours(0, 0, 0, 0);
          }, function (e, t) {
            e.setDate(e.getDate() + t);
          }, function (e, t) {
            return (t - e - 6e4 * (t.getTimezoneOffset() - e.getTimezoneOffset())) / 864e5;
          }, function (e) {
            return e.getDate() - 1;
          }),
          h = f.range;
        function p(e) {
          return n(function (t) {
            t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
          }, function (e, t) {
            e.setDate(e.getDate() + 7 * t);
          }, function (e, t) {
            return (t - e - 6e4 * (t.getTimezoneOffset() - e.getTimezoneOffset())) / 6048e5;
          });
        }
        var g = p(0),
          m = p(1),
          y = p(2),
          v = p(3),
          x = p(4),
          b = p(5),
          _ = p(6),
          w = g.range,
          M = m.range,
          T = y.range,
          k = v.range,
          A = x.range,
          L = b.range,
          D = _.range,
          S = n(function (e) {
            e.setDate(1), e.setHours(0, 0, 0, 0);
          }, function (e, t) {
            e.setMonth(e.getMonth() + t);
          }, function (e, t) {
            return t.getMonth() - e.getMonth() + 12 * (t.getFullYear() - e.getFullYear());
          }, function (e) {
            return e.getMonth();
          }),
          C = S.range,
          O = n(function (e) {
            e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
          }, function (e, t) {
            e.setFullYear(e.getFullYear() + t);
          }, function (e, t) {
            return t.getFullYear() - e.getFullYear();
          }, function (e) {
            return e.getFullYear();
          });
        O.every = function (e) {
          return isFinite(e = Math.floor(e)) && e > 0 ? n(function (t) {
            t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
          }, function (t, r) {
            t.setFullYear(t.getFullYear() + r * e);
          }) : null;
        };
        var P = O.range,
          I = n(function (e) {
            e.setUTCSeconds(0, 0);
          }, function (e, t) {
            e.setTime(+e + 6e4 * t);
          }, function (e, t) {
            return (t - e) / 6e4;
          }, function (e) {
            return e.getUTCMinutes();
          }),
          z = I.range,
          R = n(function (e) {
            e.setUTCMinutes(0, 0, 0);
          }, function (e, t) {
            e.setTime(+e + 36e5 * t);
          }, function (e, t) {
            return (t - e) / 36e5;
          }, function (e) {
            return e.getUTCHours();
          }),
          N = R.range,
          F = n(function (e) {
            e.setUTCHours(0, 0, 0, 0);
          }, function (e, t) {
            e.setUTCDate(e.getUTCDate() + t);
          }, function (e, t) {
            return (t - e) / 864e5;
          }, function (e) {
            return e.getUTCDate() - 1;
          }),
          E = F.range;
        function j(e) {
          return n(function (t) {
            t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
          }, function (e, t) {
            e.setUTCDate(e.getUTCDate() + 7 * t);
          }, function (e, t) {
            return (t - e) / 6048e5;
          });
        }
        var H = j(0),
          B = j(1),
          Y = j(2),
          U = j(3),
          V = j(4),
          q = j(5),
          G = j(6),
          Z = H.range,
          W = B.range,
          J = Y.range,
          X = U.range,
          Q = V.range,
          K = q.range,
          $ = G.range,
          ee = n(function (e) {
            e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
          }, function (e, t) {
            e.setUTCMonth(e.getUTCMonth() + t);
          }, function (e, t) {
            return t.getUTCMonth() - e.getUTCMonth() + 12 * (t.getUTCFullYear() - e.getUTCFullYear());
          }, function (e) {
            return e.getUTCMonth();
          }),
          te = ee.range,
          re = n(function (e) {
            e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
          }, function (e, t) {
            e.setUTCFullYear(e.getUTCFullYear() + t);
          }, function (e, t) {
            return t.getUTCFullYear() - e.getUTCFullYear();
          }, function (e) {
            return e.getUTCFullYear();
          });
        re.every = function (e) {
          return isFinite(e = Math.floor(e)) && e > 0 ? n(function (t) {
            t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
          }, function (t, r) {
            t.setUTCFullYear(t.getUTCFullYear() + r * e);
          }) : null;
        };
        var ne = re.range;
        e.timeDay = f, e.timeDays = h, e.timeFriday = b, e.timeFridays = L, e.timeHour = u, e.timeHours = d, e.timeInterval = n, e.timeMillisecond = a, e.timeMilliseconds = i, e.timeMinute = s, e.timeMinutes = c, e.timeMonday = m, e.timeMondays = M, e.timeMonth = S, e.timeMonths = C, e.timeSaturday = _, e.timeSaturdays = D, e.timeSecond = o, e.timeSeconds = l, e.timeSunday = g, e.timeSundays = w, e.timeThursday = x, e.timeThursdays = A, e.timeTuesday = y, e.timeTuesdays = T, e.timeWednesday = v, e.timeWednesdays = k, e.timeWeek = g, e.timeWeeks = w, e.timeYear = O, e.timeYears = P, e.utcDay = F, e.utcDays = E, e.utcFriday = q, e.utcFridays = K, e.utcHour = R, e.utcHours = N, e.utcMillisecond = a, e.utcMilliseconds = i, e.utcMinute = I, e.utcMinutes = z, e.utcMonday = B, e.utcMondays = W, e.utcMonth = ee, e.utcMonths = te, e.utcSaturday = G, e.utcSaturdays = $, e.utcSecond = o, e.utcSeconds = l, e.utcSunday = H, e.utcSundays = Z, e.utcThursday = V, e.utcThursdays = Q, e.utcTuesday = Y, e.utcTuesdays = J, e.utcWednesday = U, e.utcWednesdays = X, e.utcWeek = H, e.utcWeeks = Z, e.utcYear = re, e.utcYears = ne, Object.defineProperty(e, "__esModule", {
          value: !0
        });
      });
    }, {}],
    10: [function (e, t, r) {
      "use strict";

      var n,
        a = "object" == typeof Reflect ? Reflect : null,
        i = a && "function" == typeof a.apply ? a.apply : function (e, t, r) {
          return Function.prototype.apply.call(e, t, r);
        };
      n = a && "function" == typeof a.ownKeys ? a.ownKeys : Object.getOwnPropertySymbols ? function (e) {
        return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
      } : function (e) {
        return Object.getOwnPropertyNames(e);
      };
      var o = Number.isNaN || function (e) {
        return e != e;
      };
      function l() {
        l.init.call(this);
      }
      t.exports = l, t.exports.once = function (e, t) {
        return new Promise(function (r, n) {
          function a(r) {
            e.removeListener(t, i), n(r);
          }
          function i() {
            "function" == typeof e.removeListener && e.removeListener("error", a), r([].slice.call(arguments));
          }
          y(e, t, i, {
            once: !0
          }), "error" !== t && function (e, t, r) {
            "function" == typeof e.on && y(e, "error", t, r);
          }(e, a, {
            once: !0
          });
        });
      }, l.EventEmitter = l, l.prototype._events = void 0, l.prototype._eventsCount = 0, l.prototype._maxListeners = void 0;
      var s = 10;
      function c(e) {
        if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      }
      function u(e) {
        return void 0 === e._maxListeners ? l.defaultMaxListeners : e._maxListeners;
      }
      function d(e, t, r, n) {
        var a, i, o, l;
        if (c(r), void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), i = e._events), o = i[t]), void 0 === o) o = i[t] = r, ++e._eventsCount;else if ("function" == typeof o ? o = i[t] = n ? [r, o] : [o, r] : n ? o.unshift(r) : o.push(r), (a = u(e)) > 0 && o.length > a && !o.warned) {
          o.warned = !0;
          var s = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = o.length, l = s, console && console.warn && console.warn(l);
        }
        return e;
      }
      function f() {
        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
      }
      function h(e, t, r) {
        var n = {
            fired: !1,
            wrapFn: void 0,
            target: e,
            type: t,
            listener: r
          },
          a = f.bind(n);
        return a.listener = r, n.wrapFn = a, a;
      }
      function p(e, t, r) {
        var n = e._events;
        if (void 0 === n) return [];
        var a = n[t];
        return void 0 === a ? [] : "function" == typeof a ? r ? [a.listener || a] : [a] : r ? function (e) {
          for (var t = new Array(e.length), r = 0; r < t.length; ++r) t[r] = e[r].listener || e[r];
          return t;
        }(a) : m(a, a.length);
      }
      function g(e) {
        var t = this._events;
        if (void 0 !== t) {
          var r = t[e];
          if ("function" == typeof r) return 1;
          if (void 0 !== r) return r.length;
        }
        return 0;
      }
      function m(e, t) {
        for (var r = new Array(t), n = 0; n < t; ++n) r[n] = e[n];
        return r;
      }
      function y(e, t, r, n) {
        if ("function" == typeof e.on) n.once ? e.once(t, r) : e.on(t, r);else {
          if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
          e.addEventListener(t, function a(i) {
            n.once && e.removeEventListener(t, a), r(i);
          });
        }
      }
      Object.defineProperty(l, "defaultMaxListeners", {
        enumerable: !0,
        get: function get() {
          return s;
        },
        set: function set(e) {
          if ("number" != typeof e || e < 0 || o(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
          s = e;
        }
      }), l.init = function () {
        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      }, l.prototype.setMaxListeners = function (e) {
        if ("number" != typeof e || e < 0 || o(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
        return this._maxListeners = e, this;
      }, l.prototype.getMaxListeners = function () {
        return u(this);
      }, l.prototype.emit = function (e) {
        for (var t = [], r = 1; r < arguments.length; r++) t.push(arguments[r]);
        var n = "error" === e,
          a = this._events;
        if (void 0 !== a) n = n && void 0 === a.error;else if (!n) return !1;
        if (n) {
          var o;
          if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
          var l = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
          throw l.context = o, l;
        }
        var s = a[e];
        if (void 0 === s) return !1;
        if ("function" == typeof s) i(s, this, t);else {
          var c = s.length,
            u = m(s, c);
          for (r = 0; r < c; ++r) i(u[r], this, t);
        }
        return !0;
      }, l.prototype.addListener = function (e, t) {
        return d(this, e, t, !1);
      }, l.prototype.on = l.prototype.addListener, l.prototype.prependListener = function (e, t) {
        return d(this, e, t, !0);
      }, l.prototype.once = function (e, t) {
        return c(t), this.on(e, h(this, e, t)), this;
      }, l.prototype.prependOnceListener = function (e, t) {
        return c(t), this.prependListener(e, h(this, e, t)), this;
      }, l.prototype.removeListener = function (e, t) {
        var r, n, a, i, o;
        if (c(t), void 0 === (n = this._events)) return this;
        if (void 0 === (r = n[e])) return this;
        if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));else if ("function" != typeof r) {
          for (a = -1, i = r.length - 1; i >= 0; i--) if (r[i] === t || r[i].listener === t) {
            o = r[i].listener, a = i;
            break;
          }
          if (a < 0) return this;
          0 === a ? r.shift() : function (e, t) {
            for (; t + 1 < e.length; t++) e[t] = e[t + 1];
            e.pop();
          }(r, a), 1 === r.length && (n[e] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", e, o || t);
        }
        return this;
      }, l.prototype.off = l.prototype.removeListener, l.prototype.removeAllListeners = function (e) {
        var t, r, n;
        if (void 0 === (r = this._events)) return this;
        if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;
        if (0 === arguments.length) {
          var a,
            i = Object.keys(r);
          for (n = 0; n < i.length; ++n) "removeListener" !== (a = i[n]) && this.removeAllListeners(a);
          return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
        }
        if ("function" == typeof (t = r[e])) this.removeListener(e, t);else if (void 0 !== t) for (n = t.length - 1; n >= 0; n--) this.removeListener(e, t[n]);
        return this;
      }, l.prototype.listeners = function (e) {
        return p(this, e, !0);
      }, l.prototype.rawListeners = function (e) {
        return p(this, e, !1);
      }, l.listenerCount = function (e, t) {
        return "function" == typeof e.listenerCount ? e.listenerCount(t) : g.call(e, t);
      }, l.prototype.listenerCount = g, l.prototype.eventNames = function () {
        return this._eventsCount > 0 ? n(this._events) : [];
      };
    }, {}],
    11: [function (e, t, r) {
      "use strict";

      var n = e("is-string-blank");
      t.exports = function (e) {
        var t = typeof e;
        if ("string" === t) {
          var r = e;
          if (0 === (e = +e) && n(r)) return !1;
        } else if ("number" !== t) return !1;
        return e - e < 1;
      };
    }, {
      "is-string-blank": 46
    }],
    12: [function (e, t, r) {
      t.exports = function (e, t) {
        var r = t[0],
          n = t[1],
          a = t[2],
          i = t[3],
          o = t[4],
          l = t[5],
          s = t[6],
          c = t[7],
          u = t[8],
          d = t[9],
          f = t[10],
          h = t[11],
          p = t[12],
          g = t[13],
          m = t[14],
          y = t[15];
        return e[0] = l * (f * y - h * m) - d * (s * y - c * m) + g * (s * h - c * f), e[1] = -(n * (f * y - h * m) - d * (a * y - i * m) + g * (a * h - i * f)), e[2] = n * (s * y - c * m) - l * (a * y - i * m) + g * (a * c - i * s), e[3] = -(n * (s * h - c * f) - l * (a * h - i * f) + d * (a * c - i * s)), e[4] = -(o * (f * y - h * m) - u * (s * y - c * m) + p * (s * h - c * f)), e[5] = r * (f * y - h * m) - u * (a * y - i * m) + p * (a * h - i * f), e[6] = -(r * (s * y - c * m) - o * (a * y - i * m) + p * (a * c - i * s)), e[7] = r * (s * h - c * f) - o * (a * h - i * f) + u * (a * c - i * s), e[8] = o * (d * y - h * g) - u * (l * y - c * g) + p * (l * h - c * d), e[9] = -(r * (d * y - h * g) - u * (n * y - i * g) + p * (n * h - i * d)), e[10] = r * (l * y - c * g) - o * (n * y - i * g) + p * (n * c - i * l), e[11] = -(r * (l * h - c * d) - o * (n * h - i * d) + u * (n * c - i * l)), e[12] = -(o * (d * m - f * g) - u * (l * m - s * g) + p * (l * f - s * d)), e[13] = r * (d * m - f * g) - u * (n * m - a * g) + p * (n * f - a * d), e[14] = -(r * (l * m - s * g) - o * (n * m - a * g) + p * (n * s - a * l)), e[15] = r * (l * f - s * d) - o * (n * f - a * d) + u * (n * s - a * l), e;
      };
    }, {}],
    13: [function (e, t, r) {
      t.exports = function (e) {
        var t = new Float32Array(16);
        return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
      };
    }, {}],
    14: [function (e, t, r) {
      t.exports = function (e, t) {
        return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
      };
    }, {}],
    15: [function (e, t, r) {
      t.exports = function () {
        var e = new Float32Array(16);
        return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      };
    }, {}],
    16: [function (e, t, r) {
      t.exports = function (e) {
        var t = e[0],
          r = e[1],
          n = e[2],
          a = e[3],
          i = e[4],
          o = e[5],
          l = e[6],
          s = e[7],
          c = e[8],
          u = e[9],
          d = e[10],
          f = e[11],
          h = e[12],
          p = e[13],
          g = e[14],
          m = e[15];
        return (t * o - r * i) * (d * m - f * g) - (t * l - n * i) * (u * m - f * p) + (t * s - a * i) * (u * g - d * p) + (r * l - n * o) * (c * m - f * h) - (r * s - a * o) * (c * g - d * h) + (n * s - a * l) * (c * p - u * h);
      };
    }, {}],
    17: [function (e, t, r) {
      t.exports = function (e, t) {
        var r = t[0],
          n = t[1],
          a = t[2],
          i = t[3],
          o = r + r,
          l = n + n,
          s = a + a,
          c = r * o,
          u = n * o,
          d = n * l,
          f = a * o,
          h = a * l,
          p = a * s,
          g = i * o,
          m = i * l,
          y = i * s;
        return e[0] = 1 - d - p, e[1] = u + y, e[2] = f - m, e[3] = 0, e[4] = u - y, e[5] = 1 - c - p, e[6] = h + g, e[7] = 0, e[8] = f + m, e[9] = h - g, e[10] = 1 - c - d, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      };
    }, {}],
    18: [function (e, t, r) {
      t.exports = function (e, t, r) {
        var n,
          a,
          i,
          o = r[0],
          l = r[1],
          s = r[2],
          c = Math.sqrt(o * o + l * l + s * s);
        if (Math.abs(c) < 1e-6) return null;
        return o *= c = 1 / c, l *= c, s *= c, n = Math.sin(t), a = Math.cos(t), i = 1 - a, e[0] = o * o * i + a, e[1] = l * o * i + s * n, e[2] = s * o * i - l * n, e[3] = 0, e[4] = o * l * i - s * n, e[5] = l * l * i + a, e[6] = s * l * i + o * n, e[7] = 0, e[8] = o * s * i + l * n, e[9] = l * s * i - o * n, e[10] = s * s * i + a, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      };
    }, {}],
    19: [function (e, t, r) {
      t.exports = function (e, t, r) {
        var n = t[0],
          a = t[1],
          i = t[2],
          o = t[3],
          l = n + n,
          s = a + a,
          c = i + i,
          u = n * l,
          d = n * s,
          f = n * c,
          h = a * s,
          p = a * c,
          g = i * c,
          m = o * l,
          y = o * s,
          v = o * c;
        return e[0] = 1 - (h + g), e[1] = d + v, e[2] = f - y, e[3] = 0, e[4] = d - v, e[5] = 1 - (u + g), e[6] = p + m, e[7] = 0, e[8] = f + y, e[9] = p - m, e[10] = 1 - (u + h), e[11] = 0, e[12] = r[0], e[13] = r[1], e[14] = r[2], e[15] = 1, e;
      };
    }, {}],
    20: [function (e, t, r) {
      t.exports = function (e, t) {
        return e[0] = t[0], e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = t[1], e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = t[2], e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      };
    }, {}],
    21: [function (e, t, r) {
      t.exports = function (e, t) {
        return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = t[0], e[13] = t[1], e[14] = t[2], e[15] = 1, e;
      };
    }, {}],
    22: [function (e, t, r) {
      t.exports = function (e, t) {
        var r = Math.sin(t),
          n = Math.cos(t);
        return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = n, e[6] = r, e[7] = 0, e[8] = 0, e[9] = -r, e[10] = n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      };
    }, {}],
    23: [function (e, t, r) {
      t.exports = function (e, t) {
        var r = Math.sin(t),
          n = Math.cos(t);
        return e[0] = n, e[1] = 0, e[2] = -r, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = r, e[9] = 0, e[10] = n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      };
    }, {}],
    24: [function (e, t, r) {
      t.exports = function (e, t) {
        var r = Math.sin(t),
          n = Math.cos(t);
        return e[0] = n, e[1] = r, e[2] = 0, e[3] = 0, e[4] = -r, e[5] = n, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      };
    }, {}],
    25: [function (e, t, r) {
      t.exports = function (e, t, r, n, a, i, o) {
        var l = 1 / (r - t),
          s = 1 / (a - n),
          c = 1 / (i - o);
        return e[0] = 2 * i * l, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 2 * i * s, e[6] = 0, e[7] = 0, e[8] = (r + t) * l, e[9] = (a + n) * s, e[10] = (o + i) * c, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = o * i * 2 * c, e[15] = 0, e;
      };
    }, {}],
    26: [function (e, t, r) {
      t.exports = function (e) {
        return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
      };
    }, {}],
    27: [function (e, t, r) {
      t.exports = {
        create: e("./create"),
        clone: e("./clone"),
        copy: e("./copy"),
        identity: e("./identity"),
        transpose: e("./transpose"),
        invert: e("./invert"),
        adjoint: e("./adjoint"),
        determinant: e("./determinant"),
        multiply: e("./multiply"),
        translate: e("./translate"),
        scale: e("./scale"),
        rotate: e("./rotate"),
        rotateX: e("./rotateX"),
        rotateY: e("./rotateY"),
        rotateZ: e("./rotateZ"),
        fromRotation: e("./fromRotation"),
        fromRotationTranslation: e("./fromRotationTranslation"),
        fromScaling: e("./fromScaling"),
        fromTranslation: e("./fromTranslation"),
        fromXRotation: e("./fromXRotation"),
        fromYRotation: e("./fromYRotation"),
        fromZRotation: e("./fromZRotation"),
        fromQuat: e("./fromQuat"),
        frustum: e("./frustum"),
        perspective: e("./perspective"),
        perspectiveFromFieldOfView: e("./perspectiveFromFieldOfView"),
        ortho: e("./ortho"),
        lookAt: e("./lookAt"),
        str: e("./str")
      };
    }, {
      "./adjoint": 12,
      "./clone": 13,
      "./copy": 14,
      "./create": 15,
      "./determinant": 16,
      "./fromQuat": 17,
      "./fromRotation": 18,
      "./fromRotationTranslation": 19,
      "./fromScaling": 20,
      "./fromTranslation": 21,
      "./fromXRotation": 22,
      "./fromYRotation": 23,
      "./fromZRotation": 24,
      "./frustum": 25,
      "./identity": 26,
      "./invert": 28,
      "./lookAt": 29,
      "./multiply": 30,
      "./ortho": 31,
      "./perspective": 32,
      "./perspectiveFromFieldOfView": 33,
      "./rotate": 34,
      "./rotateX": 35,
      "./rotateY": 36,
      "./rotateZ": 37,
      "./scale": 38,
      "./str": 39,
      "./translate": 40,
      "./transpose": 41
    }],
    28: [function (e, t, r) {
      t.exports = function (e, t) {
        var r = t[0],
          n = t[1],
          a = t[2],
          i = t[3],
          o = t[4],
          l = t[5],
          s = t[6],
          c = t[7],
          u = t[8],
          d = t[9],
          f = t[10],
          h = t[11],
          p = t[12],
          g = t[13],
          m = t[14],
          y = t[15],
          v = r * l - n * o,
          x = r * s - a * o,
          b = r * c - i * o,
          _ = n * s - a * l,
          w = n * c - i * l,
          M = a * c - i * s,
          T = u * g - d * p,
          k = u * m - f * p,
          A = u * y - h * p,
          L = d * m - f * g,
          D = d * y - h * g,
          S = f * y - h * m,
          C = v * S - x * D + b * L + _ * A - w * k + M * T;
        if (!C) return null;
        return C = 1 / C, e[0] = (l * S - s * D + c * L) * C, e[1] = (a * D - n * S - i * L) * C, e[2] = (g * M - m * w + y * _) * C, e[3] = (f * w - d * M - h * _) * C, e[4] = (s * A - o * S - c * k) * C, e[5] = (r * S - a * A + i * k) * C, e[6] = (m * b - p * M - y * x) * C, e[7] = (u * M - f * b + h * x) * C, e[8] = (o * D - l * A + c * T) * C, e[9] = (n * A - r * D - i * T) * C, e[10] = (p * w - g * b + y * v) * C, e[11] = (d * b - u * w - h * v) * C, e[12] = (l * k - o * L - s * T) * C, e[13] = (r * L - n * k + a * T) * C, e[14] = (g * x - p * _ - m * v) * C, e[15] = (u * _ - d * x + f * v) * C, e;
      };
    }, {}],
    29: [function (e, t, r) {
      var n = e("./identity");
      t.exports = function (e, t, r, a) {
        var i,
          o,
          l,
          s,
          c,
          u,
          d,
          f,
          h,
          p,
          g = t[0],
          m = t[1],
          y = t[2],
          v = a[0],
          x = a[1],
          b = a[2],
          _ = r[0],
          w = r[1],
          M = r[2];
        if (Math.abs(g - _) < 1e-6 && Math.abs(m - w) < 1e-6 && Math.abs(y - M) < 1e-6) return n(e);
        d = g - _, f = m - w, h = y - M, p = 1 / Math.sqrt(d * d + f * f + h * h), i = x * (h *= p) - b * (f *= p), o = b * (d *= p) - v * h, l = v * f - x * d, (p = Math.sqrt(i * i + o * o + l * l)) ? (i *= p = 1 / p, o *= p, l *= p) : (i = 0, o = 0, l = 0);
        s = f * l - h * o, c = h * i - d * l, u = d * o - f * i, (p = Math.sqrt(s * s + c * c + u * u)) ? (s *= p = 1 / p, c *= p, u *= p) : (s = 0, c = 0, u = 0);
        return e[0] = i, e[1] = s, e[2] = d, e[3] = 0, e[4] = o, e[5] = c, e[6] = f, e[7] = 0, e[8] = l, e[9] = u, e[10] = h, e[11] = 0, e[12] = -(i * g + o * m + l * y), e[13] = -(s * g + c * m + u * y), e[14] = -(d * g + f * m + h * y), e[15] = 1, e;
      };
    }, {
      "./identity": 26
    }],
    30: [function (e, t, r) {
      t.exports = function (e, t, r) {
        var n = t[0],
          a = t[1],
          i = t[2],
          o = t[3],
          l = t[4],
          s = t[5],
          c = t[6],
          u = t[7],
          d = t[8],
          f = t[9],
          h = t[10],
          p = t[11],
          g = t[12],
          m = t[13],
          y = t[14],
          v = t[15],
          x = r[0],
          b = r[1],
          _ = r[2],
          w = r[3];
        return e[0] = x * n + b * l + _ * d + w * g, e[1] = x * a + b * s + _ * f + w * m, e[2] = x * i + b * c + _ * h + w * y, e[3] = x * o + b * u + _ * p + w * v, x = r[4], b = r[5], _ = r[6], w = r[7], e[4] = x * n + b * l + _ * d + w * g, e[5] = x * a + b * s + _ * f + w * m, e[6] = x * i + b * c + _ * h + w * y, e[7] = x * o + b * u + _ * p + w * v, x = r[8], b = r[9], _ = r[10], w = r[11], e[8] = x * n + b * l + _ * d + w * g, e[9] = x * a + b * s + _ * f + w * m, e[10] = x * i + b * c + _ * h + w * y, e[11] = x * o + b * u + _ * p + w * v, x = r[12], b = r[13], _ = r[14], w = r[15], e[12] = x * n + b * l + _ * d + w * g, e[13] = x * a + b * s + _ * f + w * m, e[14] = x * i + b * c + _ * h + w * y, e[15] = x * o + b * u + _ * p + w * v, e;
      };
    }, {}],
    31: [function (e, t, r) {
      t.exports = function (e, t, r, n, a, i, o) {
        var l = 1 / (t - r),
          s = 1 / (n - a),
          c = 1 / (i - o);
        return e[0] = -2 * l, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * s, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * c, e[11] = 0, e[12] = (t + r) * l, e[13] = (a + n) * s, e[14] = (o + i) * c, e[15] = 1, e;
      };
    }, {}],
    32: [function (e, t, r) {
      t.exports = function (e, t, r, n, a) {
        var i = 1 / Math.tan(t / 2),
          o = 1 / (n - a);
        return e[0] = i / r, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = i, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = (a + n) * o, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = 2 * a * n * o, e[15] = 0, e;
      };
    }, {}],
    33: [function (e, t, r) {
      t.exports = function (e, t, r, n) {
        var a = Math.tan(t.upDegrees * Math.PI / 180),
          i = Math.tan(t.downDegrees * Math.PI / 180),
          o = Math.tan(t.leftDegrees * Math.PI / 180),
          l = Math.tan(t.rightDegrees * Math.PI / 180),
          s = 2 / (o + l),
          c = 2 / (a + i);
        return e[0] = s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = c, e[6] = 0, e[7] = 0, e[8] = -(o - l) * s * .5, e[9] = (a - i) * c * .5, e[10] = n / (r - n), e[11] = -1, e[12] = 0, e[13] = 0, e[14] = n * r / (r - n), e[15] = 0, e;
      };
    }, {}],
    34: [function (e, t, r) {
      t.exports = function (e, t, r, n) {
        var a,
          i,
          o,
          l,
          s,
          c,
          u,
          d,
          f,
          h,
          p,
          g,
          m,
          y,
          v,
          x,
          b,
          _,
          w,
          M,
          T,
          k,
          A,
          L,
          D = n[0],
          S = n[1],
          C = n[2],
          O = Math.sqrt(D * D + S * S + C * C);
        if (Math.abs(O) < 1e-6) return null;
        D *= O = 1 / O, S *= O, C *= O, a = Math.sin(r), i = Math.cos(r), o = 1 - i, l = t[0], s = t[1], c = t[2], u = t[3], d = t[4], f = t[5], h = t[6], p = t[7], g = t[8], m = t[9], y = t[10], v = t[11], x = D * D * o + i, b = S * D * o + C * a, _ = C * D * o - S * a, w = D * S * o - C * a, M = S * S * o + i, T = C * S * o + D * a, k = D * C * o + S * a, A = S * C * o - D * a, L = C * C * o + i, e[0] = l * x + d * b + g * _, e[1] = s * x + f * b + m * _, e[2] = c * x + h * b + y * _, e[3] = u * x + p * b + v * _, e[4] = l * w + d * M + g * T, e[5] = s * w + f * M + m * T, e[6] = c * w + h * M + y * T, e[7] = u * w + p * M + v * T, e[8] = l * k + d * A + g * L, e[9] = s * k + f * A + m * L, e[10] = c * k + h * A + y * L, e[11] = u * k + p * A + v * L, t !== e && (e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]);
        return e;
      };
    }, {}],
    35: [function (e, t, r) {
      t.exports = function (e, t, r) {
        var n = Math.sin(r),
          a = Math.cos(r),
          i = t[4],
          o = t[5],
          l = t[6],
          s = t[7],
          c = t[8],
          u = t[9],
          d = t[10],
          f = t[11];
        t !== e && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]);
        return e[4] = i * a + c * n, e[5] = o * a + u * n, e[6] = l * a + d * n, e[7] = s * a + f * n, e[8] = c * a - i * n, e[9] = u * a - o * n, e[10] = d * a - l * n, e[11] = f * a - s * n, e;
      };
    }, {}],
    36: [function (e, t, r) {
      t.exports = function (e, t, r) {
        var n = Math.sin(r),
          a = Math.cos(r),
          i = t[0],
          o = t[1],
          l = t[2],
          s = t[3],
          c = t[8],
          u = t[9],
          d = t[10],
          f = t[11];
        t !== e && (e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]);
        return e[0] = i * a - c * n, e[1] = o * a - u * n, e[2] = l * a - d * n, e[3] = s * a - f * n, e[8] = i * n + c * a, e[9] = o * n + u * a, e[10] = l * n + d * a, e[11] = s * n + f * a, e;
      };
    }, {}],
    37: [function (e, t, r) {
      t.exports = function (e, t, r) {
        var n = Math.sin(r),
          a = Math.cos(r),
          i = t[0],
          o = t[1],
          l = t[2],
          s = t[3],
          c = t[4],
          u = t[5],
          d = t[6],
          f = t[7];
        t !== e && (e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]);
        return e[0] = i * a + c * n, e[1] = o * a + u * n, e[2] = l * a + d * n, e[3] = s * a + f * n, e[4] = c * a - i * n, e[5] = u * a - o * n, e[6] = d * a - l * n, e[7] = f * a - s * n, e;
      };
    }, {}],
    38: [function (e, t, r) {
      t.exports = function (e, t, r) {
        var n = r[0],
          a = r[1],
          i = r[2];
        return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e[4] = t[4] * a, e[5] = t[5] * a, e[6] = t[6] * a, e[7] = t[7] * a, e[8] = t[8] * i, e[9] = t[9] * i, e[10] = t[10] * i, e[11] = t[11] * i, e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
      };
    }, {}],
    39: [function (e, t, r) {
      t.exports = function (e) {
        return "mat4(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ", " + e[8] + ", " + e[9] + ", " + e[10] + ", " + e[11] + ", " + e[12] + ", " + e[13] + ", " + e[14] + ", " + e[15] + ")";
      };
    }, {}],
    40: [function (e, t, r) {
      t.exports = function (e, t, r) {
        var n,
          a,
          i,
          o,
          l,
          s,
          c,
          u,
          d,
          f,
          h,
          p,
          g = r[0],
          m = r[1],
          y = r[2];
        t === e ? (e[12] = t[0] * g + t[4] * m + t[8] * y + t[12], e[13] = t[1] * g + t[5] * m + t[9] * y + t[13], e[14] = t[2] * g + t[6] * m + t[10] * y + t[14], e[15] = t[3] * g + t[7] * m + t[11] * y + t[15]) : (n = t[0], a = t[1], i = t[2], o = t[3], l = t[4], s = t[5], c = t[6], u = t[7], d = t[8], f = t[9], h = t[10], p = t[11], e[0] = n, e[1] = a, e[2] = i, e[3] = o, e[4] = l, e[5] = s, e[6] = c, e[7] = u, e[8] = d, e[9] = f, e[10] = h, e[11] = p, e[12] = n * g + l * m + d * y + t[12], e[13] = a * g + s * m + f * y + t[13], e[14] = i * g + c * m + h * y + t[14], e[15] = o * g + u * m + p * y + t[15]);
        return e;
      };
    }, {}],
    41: [function (e, t, r) {
      t.exports = function (e, t) {
        if (e === t) {
          var r = t[1],
            n = t[2],
            a = t[3],
            i = t[6],
            o = t[7],
            l = t[11];
          e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = r, e[6] = t[9], e[7] = t[13], e[8] = n, e[9] = i, e[11] = t[14], e[12] = a, e[13] = o, e[14] = l;
        } else e[0] = t[0], e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = t[1], e[5] = t[5], e[6] = t[9], e[7] = t[13], e[8] = t[2], e[9] = t[6], e[10] = t[10], e[11] = t[14], e[12] = t[3], e[13] = t[7], e[14] = t[11], e[15] = t[15];
        return e;
      };
    }, {}],
    42: [function (e, t, r) {
      (function (r) {
        (function () {
          "use strict";

          var n,
            a = e("is-browser");
          n = "function" == typeof r.matchMedia ? !r.matchMedia("(hover: none)").matches : a, t.exports = n;
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      "is-browser": 44
    }],
    43: [function (e, t, r) {
      "use strict";

      var n = e("is-browser");
      t.exports = n && function () {
        var e = !1;
        try {
          var t = Object.defineProperty({}, "passive", {
            get: function get() {
              e = !0;
            }
          });
          window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
        } catch (t) {
          e = !1;
        }
        return e;
      }();
    }, {
      "is-browser": 44
    }],
    44: [function (e, t, r) {
      t.exports = !0;
    }, {}],
    45: [function (e, t, r) {
      "use strict";

      t.exports = i, t.exports.isMobile = i, t.exports.default = i;
      var n = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
        a = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;
      function i(e) {
        e || (e = {});
        var t = e.ua;
        if (t || "undefined" == typeof navigator || (t = navigator.userAgent), t && t.headers && "string" == typeof t.headers["user-agent"] && (t = t.headers["user-agent"]), "string" != typeof t) return !1;
        var r = e.tablet ? a.test(t) : n.test(t);
        return !r && e.tablet && e.featureDetect && navigator && navigator.maxTouchPoints > 1 && -1 !== t.indexOf("Macintosh") && -1 !== t.indexOf("Safari") && (r = !0), r;
      }
    }, {}],
    46: [function (e, t, r) {
      "use strict";

      t.exports = function (e) {
        for (var t, r = e.length, n = 0; n < r; n++) if (((t = e.charCodeAt(n)) < 9 || t > 13) && 32 !== t && 133 !== t && 160 !== t && 5760 !== t && 6158 !== t && (t < 8192 || t > 8205) && 8232 !== t && 8233 !== t && 8239 !== t && 8287 !== t && 8288 !== t && 12288 !== t && 65279 !== t) return !1;
        return !0;
      };
    }, {}],
    47: [function (e, t, r) {
      var n = {
        left: 0,
        top: 0
      };
      t.exports = function (e, t, r) {
        t = t || e.currentTarget || e.srcElement, Array.isArray(r) || (r = [0, 0]);
        var a = e.clientX || 0,
          i = e.clientY || 0,
          o = (l = t, l === window || l === document || l === document.body ? n : l.getBoundingClientRect());
        var l;
        return r[0] = a - o.left, r[1] = i - o.top, r;
      };
    }, {}],
    48: [function (e, t, r) {
      (function (e, r) {
        (function () {
          /*! Native Promise Only
              v0.8.1 (c) Kyle Simpson
              MIT License: http://getify.mit-license.org
          */
          var n, a, i;
          i = function i() {
            "use strict";

            var e,
              t,
              n,
              a = Object.prototype.toString,
              i = void 0 !== r ? function (e) {
                return r(e);
              } : setTimeout;
            try {
              Object.defineProperty({}, "x", {}), e = function e(_e3, t, r, n) {
                return Object.defineProperty(_e3, t, {
                  value: r,
                  writable: !0,
                  configurable: !1 !== n
                });
              };
            } catch (t) {
              e = function e(_e4, t, r) {
                return _e4[t] = r, _e4;
              };
            }
            function o(e, r) {
              n.add(e, r), t || (t = i(n.drain));
            }
            function l(e) {
              var t,
                r = typeof e;
              return null == e || "object" != r && "function" != r || (t = e.then), "function" == typeof t && t;
            }
            function s() {
              for (var e = 0; e < this.chain.length; e++) c(this, 1 === this.state ? this.chain[e].success : this.chain[e].failure, this.chain[e]);
              this.chain.length = 0;
            }
            function c(e, t, r) {
              var n, a;
              try {
                !1 === t ? r.reject(e.msg) : (n = !0 === t ? e.msg : t.call(void 0, e.msg)) === r.promise ? r.reject(TypeError("Promise-chain cycle")) : (a = l(n)) ? a.call(n, r.resolve, r.reject) : r.resolve(n);
              } catch (e) {
                r.reject(e);
              }
            }
            function u(e) {
              var t,
                r = this;
              if (!r.triggered) {
                r.triggered = !0, r.def && (r = r.def);
                try {
                  (t = l(e)) ? o(function () {
                    var n = new h(r);
                    try {
                      t.call(e, function () {
                        u.apply(n, arguments);
                      }, function () {
                        d.apply(n, arguments);
                      });
                    } catch (e) {
                      d.call(n, e);
                    }
                  }) : (r.msg = e, r.state = 1, r.chain.length > 0 && o(s, r));
                } catch (e) {
                  d.call(new h(r), e);
                }
              }
            }
            function d(e) {
              var t = this;
              t.triggered || (t.triggered = !0, t.def && (t = t.def), t.msg = e, t.state = 2, t.chain.length > 0 && o(s, t));
            }
            function f(e, t, r, n) {
              for (var a = 0; a < t.length; a++) !function (a) {
                e.resolve(t[a]).then(function (e) {
                  r(a, e);
                }, n);
              }(a);
            }
            function h(e) {
              this.def = e, this.triggered = !1;
            }
            function p(e) {
              this.promise = e, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
            }
            function g(e) {
              if ("function" != typeof e) throw TypeError("Not a function");
              if (0 !== this.__NPO__) throw TypeError("Not a promise");
              this.__NPO__ = 1;
              var t = new p(this);
              this.then = function (e, r) {
                var n = {
                  success: "function" != typeof e || e,
                  failure: "function" == typeof r && r
                };
                return n.promise = new this.constructor(function (e, t) {
                  if ("function" != typeof e || "function" != typeof t) throw TypeError("Not a function");
                  n.resolve = e, n.reject = t;
                }), t.chain.push(n), 0 !== t.state && o(s, t), n.promise;
              }, this.catch = function (e) {
                return this.then(void 0, e);
              };
              try {
                e.call(void 0, function (e) {
                  u.call(t, e);
                }, function (e) {
                  d.call(t, e);
                });
              } catch (e) {
                d.call(t, e);
              }
            }
            n = function () {
              var e, r, n;
              function a(e, t) {
                this.fn = e, this.self = t, this.next = void 0;
              }
              return {
                add: function add(t, i) {
                  n = new a(t, i), r ? r.next = n : e = n, r = n, n = void 0;
                },
                drain: function drain() {
                  var n = e;
                  for (e = r = t = void 0; n;) n.fn.call(n.self), n = n.next;
                }
              };
            }();
            var m = e({}, "constructor", g, !1);
            return g.prototype = m, e(m, "__NPO__", 0, !1), e(g, "resolve", function (e) {
              return e && "object" == typeof e && 1 === e.__NPO__ ? e : new this(function (t, r) {
                if ("function" != typeof t || "function" != typeof r) throw TypeError("Not a function");
                t(e);
              });
            }), e(g, "reject", function (e) {
              return new this(function (t, r) {
                if ("function" != typeof t || "function" != typeof r) throw TypeError("Not a function");
                r(e);
              });
            }), e(g, "all", function (e) {
              var t = this;
              return "[object Array]" != a.call(e) ? t.reject(TypeError("Not an array")) : 0 === e.length ? t.resolve([]) : new t(function (r, n) {
                if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                var a = e.length,
                  i = Array(a),
                  o = 0;
                f(t, e, function (e, t) {
                  i[e] = t, ++o === a && r(i);
                }, n);
              });
            }), e(g, "race", function (e) {
              var t = this;
              return "[object Array]" != a.call(e) ? t.reject(TypeError("Not an array")) : new t(function (r, n) {
                if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                f(t, e, function (e, t) {
                  r(t);
                }, n);
              });
            }), g;
          }, (a = void 0 !== e ? e : this)[n = "Promise"] = a[n] || i(), void 0 !== t && t.exports && (t.exports = a[n]);
        }).call(this);
      }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
    }, {
      timers: 60
    }],
    49: [function (e, t, r) {
      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */
      "use strict";

      var n = Object.getOwnPropertySymbols,
        a = Object.prototype.hasOwnProperty,
        i = Object.prototype.propertyIsEnumerable;
      function o(e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }
      t.exports = function () {
        try {
          if (!Object.assign) return !1;
          var e = new String("abc");
          if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
          for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
          if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
            return t[e];
          }).join("")) return !1;
          var n = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (e) {
            n[e] = e;
          }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
        } catch (e) {
          return !1;
        }
      }() ? Object.assign : function (e, t) {
        for (var r, l, s = o(e), c = 1; c < arguments.length; c++) {
          for (var u in r = Object(arguments[c])) a.call(r, u) && (s[u] = r[u]);
          if (n) {
            l = n(r);
            for (var d = 0; d < l.length; d++) i.call(r, l[d]) && (s[l[d]] = r[l[d]]);
          }
        }
        return s;
      };
    }, {}],
    50: [function (e, t, r) {
      t.exports = function (e) {
        var t = [];
        return e.replace(a, function (e, r, a) {
          var o = r.toLowerCase();
          for (a = function (e) {
            var t = e.match(i);
            return t ? t.map(Number) : [];
          }(a), "m" == o && a.length > 2 && (t.push([r].concat(a.splice(0, 2))), o = "l", r = "m" == r ? "l" : "L");;) {
            if (a.length == n[o]) return a.unshift(r), t.push(a);
            if (a.length < n[o]) throw new Error("malformed path data");
            t.push([r].concat(a.splice(0, n[o])));
          }
        }), t;
      };
      var n = {
          a: 7,
          c: 6,
          h: 1,
          l: 2,
          m: 2,
          q: 4,
          s: 4,
          t: 2,
          v: 1,
          z: 0
        },
        a = /([astvzqmhlc])([^astvzqmhlc]*)/gi;
      var i = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
    }, {}],
    51: [function (e, t, r) {
      /*
       * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
       * @license MIT
       * @preserve Project Home: https://github.com/voidqk/polybooljs
       */
      var n,
        a = e("./lib/build-log"),
        i = e("./lib/epsilon"),
        o = e("./lib/intersecter"),
        l = e("./lib/segment-chainer"),
        s = e("./lib/segment-selector"),
        c = e("./lib/geojson"),
        u = !1,
        d = i();
      function f(e, t, r) {
        var a = n.segments(e),
          i = n.segments(t),
          o = r(n.combine(a, i));
        return n.polygon(o);
      }
      n = {
        buildLog: function buildLog(e) {
          return !0 === e ? u = a() : !1 === e && (u = !1), !1 !== u && u.list;
        },
        epsilon: function epsilon(e) {
          return d.epsilon(e);
        },
        segments: function segments(e) {
          var t = o(!0, d, u);
          return e.regions.forEach(t.addRegion), {
            segments: t.calculate(e.inverted),
            inverted: e.inverted
          };
        },
        combine: function combine(e, t) {
          return {
            combined: o(!1, d, u).calculate(e.segments, e.inverted, t.segments, t.inverted),
            inverted1: e.inverted,
            inverted2: t.inverted
          };
        },
        selectUnion: function selectUnion(e) {
          return {
            segments: s.union(e.combined, u),
            inverted: e.inverted1 || e.inverted2
          };
        },
        selectIntersect: function selectIntersect(e) {
          return {
            segments: s.intersect(e.combined, u),
            inverted: e.inverted1 && e.inverted2
          };
        },
        selectDifference: function selectDifference(e) {
          return {
            segments: s.difference(e.combined, u),
            inverted: e.inverted1 && !e.inverted2
          };
        },
        selectDifferenceRev: function selectDifferenceRev(e) {
          return {
            segments: s.differenceRev(e.combined, u),
            inverted: !e.inverted1 && e.inverted2
          };
        },
        selectXor: function selectXor(e) {
          return {
            segments: s.xor(e.combined, u),
            inverted: e.inverted1 !== e.inverted2
          };
        },
        polygon: function polygon(e) {
          return {
            regions: l(e.segments, d, u),
            inverted: e.inverted
          };
        },
        polygonFromGeoJSON: function polygonFromGeoJSON(e) {
          return c.toPolygon(n, e);
        },
        polygonToGeoJSON: function polygonToGeoJSON(e) {
          return c.fromPolygon(n, d, e);
        },
        union: function union(e, t) {
          return f(e, t, n.selectUnion);
        },
        intersect: function intersect(e, t) {
          return f(e, t, n.selectIntersect);
        },
        difference: function difference(e, t) {
          return f(e, t, n.selectDifference);
        },
        differenceRev: function differenceRev(e, t) {
          return f(e, t, n.selectDifferenceRev);
        },
        xor: function xor(e, t) {
          return f(e, t, n.selectXor);
        }
      }, "object" == typeof window && (window.PolyBool = n), t.exports = n;
    }, {
      "./lib/build-log": 52,
      "./lib/epsilon": 53,
      "./lib/geojson": 54,
      "./lib/intersecter": 55,
      "./lib/segment-chainer": 57,
      "./lib/segment-selector": 58
    }],
    52: [function (e, t, r) {
      t.exports = function () {
        var e,
          t = 0,
          r = !1;
        function n(t, r) {
          return e.list.push({
            type: t,
            data: r ? JSON.parse(JSON.stringify(r)) : void 0
          }), e;
        }
        return e = {
          list: [],
          segmentId: function segmentId() {
            return t++;
          },
          checkIntersection: function checkIntersection(e, t) {
            return n("check", {
              seg1: e,
              seg2: t
            });
          },
          segmentChop: function segmentChop(e, t) {
            return n("div_seg", {
              seg: e,
              pt: t
            }), n("chop", {
              seg: e,
              pt: t
            });
          },
          statusRemove: function statusRemove(e) {
            return n("pop_seg", {
              seg: e
            });
          },
          segmentUpdate: function segmentUpdate(e) {
            return n("seg_update", {
              seg: e
            });
          },
          segmentNew: function segmentNew(e, t) {
            return n("new_seg", {
              seg: e,
              primary: t
            });
          },
          segmentRemove: function segmentRemove(e) {
            return n("rem_seg", {
              seg: e
            });
          },
          tempStatus: function tempStatus(e, t, r) {
            return n("temp_status", {
              seg: e,
              above: t,
              below: r
            });
          },
          rewind: function rewind(e) {
            return n("rewind", {
              seg: e
            });
          },
          status: function status(e, t, r) {
            return n("status", {
              seg: e,
              above: t,
              below: r
            });
          },
          vert: function vert(t) {
            return t === r ? e : (r = t, n("vert", {
              x: t
            }));
          },
          log: function log(e) {
            return "string" != typeof e && (e = JSON.stringify(e, !1, "  ")), n("log", {
              txt: e
            });
          },
          reset: function reset() {
            return n("reset");
          },
          selected: function selected(e) {
            return n("selected", {
              segs: e
            });
          },
          chainStart: function chainStart(e) {
            return n("chain_start", {
              seg: e
            });
          },
          chainRemoveHead: function chainRemoveHead(e, t) {
            return n("chain_rem_head", {
              index: e,
              pt: t
            });
          },
          chainRemoveTail: function chainRemoveTail(e, t) {
            return n("chain_rem_tail", {
              index: e,
              pt: t
            });
          },
          chainNew: function chainNew(e, t) {
            return n("chain_new", {
              pt1: e,
              pt2: t
            });
          },
          chainMatch: function chainMatch(e) {
            return n("chain_match", {
              index: e
            });
          },
          chainClose: function chainClose(e) {
            return n("chain_close", {
              index: e
            });
          },
          chainAddHead: function chainAddHead(e, t) {
            return n("chain_add_head", {
              index: e,
              pt: t
            });
          },
          chainAddTail: function chainAddTail(e, t) {
            return n("chain_add_tail", {
              index: e,
              pt: t
            });
          },
          chainConnect: function chainConnect(e, t) {
            return n("chain_con", {
              index1: e,
              index2: t
            });
          },
          chainReverse: function chainReverse(e) {
            return n("chain_rev", {
              index: e
            });
          },
          chainJoin: function chainJoin(e, t) {
            return n("chain_join", {
              index1: e,
              index2: t
            });
          },
          done: function done() {
            return n("done");
          }
        };
      };
    }, {}],
    53: [function (e, t, r) {
      t.exports = function (e) {
        "number" != typeof e && (e = 1e-10);
        var t = {
          epsilon: function epsilon(t) {
            return "number" == typeof t && (e = t), e;
          },
          pointAboveOrOnLine: function pointAboveOrOnLine(t, r, n) {
            var a = r[0],
              i = r[1],
              o = n[0],
              l = n[1],
              s = t[0];
            return (o - a) * (t[1] - i) - (l - i) * (s - a) >= -e;
          },
          pointBetween: function pointBetween(t, r, n) {
            var a = t[1] - r[1],
              i = n[0] - r[0],
              o = t[0] - r[0],
              l = n[1] - r[1],
              s = o * i + a * l;
            return !(s < e) && !(s - (i * i + l * l) > -e);
          },
          pointsSameX: function pointsSameX(t, r) {
            return Math.abs(t[0] - r[0]) < e;
          },
          pointsSameY: function pointsSameY(t, r) {
            return Math.abs(t[1] - r[1]) < e;
          },
          pointsSame: function pointsSame(e, r) {
            return t.pointsSameX(e, r) && t.pointsSameY(e, r);
          },
          pointsCompare: function pointsCompare(e, r) {
            return t.pointsSameX(e, r) ? t.pointsSameY(e, r) ? 0 : e[1] < r[1] ? -1 : 1 : e[0] < r[0] ? -1 : 1;
          },
          pointsCollinear: function pointsCollinear(t, r, n) {
            var a = t[0] - r[0],
              i = t[1] - r[1],
              o = r[0] - n[0],
              l = r[1] - n[1];
            return Math.abs(a * l - o * i) < e;
          },
          linesIntersect: function linesIntersect(t, r, n, a) {
            var i = r[0] - t[0],
              o = r[1] - t[1],
              l = a[0] - n[0],
              s = a[1] - n[1],
              c = i * s - o * l;
            if (Math.abs(c) < e) return !1;
            var u = t[0] - n[0],
              d = t[1] - n[1],
              f = (l * d - s * u) / c,
              h = (i * d - o * u) / c,
              p = {
                alongA: 0,
                alongB: 0,
                pt: [t[0] + f * i, t[1] + f * o]
              };
            return p.alongA = f <= -e ? -2 : f < e ? -1 : f - 1 <= -e ? 0 : f - 1 < e ? 1 : 2, p.alongB = h <= -e ? -2 : h < e ? -1 : h - 1 <= -e ? 0 : h - 1 < e ? 1 : 2, p;
          },
          pointInsideRegion: function pointInsideRegion(t, r) {
            for (var n = t[0], a = t[1], i = r[r.length - 1][0], o = r[r.length - 1][1], l = !1, s = 0; s < r.length; s++) {
              var c = r[s][0],
                u = r[s][1];
              u - a > e != o - a > e && (i - c) * (a - u) / (o - u) + c - n > e && (l = !l), i = c, o = u;
            }
            return l;
          }
        };
        return t;
      };
    }, {}],
    54: [function (e, t, r) {
      var n = {
        toPolygon: function toPolygon(e, t) {
          function r(t) {
            if (t.length <= 0) return e.segments({
              inverted: !1,
              regions: []
            });
            function r(t) {
              var r = t.slice(0, t.length - 1);
              return e.segments({
                inverted: !1,
                regions: [r]
              });
            }
            for (var n = r(t[0]), a = 1; a < t.length; a++) n = e.selectDifference(e.combine(n, r(t[a])));
            return n;
          }
          if ("Polygon" === t.type) return e.polygon(r(t.coordinates));
          if ("MultiPolygon" === t.type) {
            for (var n = e.segments({
                inverted: !1,
                regions: []
              }), a = 0; a < t.coordinates.length; a++) n = e.selectUnion(e.combine(n, r(t.coordinates[a])));
            return e.polygon(n);
          }
          throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
        },
        fromPolygon: function fromPolygon(e, t, r) {
          function n(e, r) {
            return t.pointInsideRegion([.5 * (e[0][0] + e[1][0]), .5 * (e[0][1] + e[1][1])], r);
          }
          function a(e) {
            return {
              region: e,
              children: []
            };
          }
          r = e.polygon(e.segments(r));
          var i = a(null);
          function o(e, t) {
            for (var r = 0; r < e.children.length; r++) {
              if (n(t, (l = e.children[r]).region)) return void o(l, t);
            }
            var i = a(t);
            for (r = 0; r < e.children.length; r++) {
              var l;
              n((l = e.children[r]).region, t) && (i.children.push(l), e.children.splice(r, 1), r--);
            }
            e.children.push(i);
          }
          for (var l = 0; l < r.regions.length; l++) {
            var s = r.regions[l];
            s.length < 3 || o(i, s);
          }
          function c(e, t) {
            for (var r = 0, n = e[e.length - 1][0], a = e[e.length - 1][1], i = [], o = 0; o < e.length; o++) {
              var l = e[o][0],
                s = e[o][1];
              i.push([l, s]), r += s * n - l * a, n = l, a = s;
            }
            return r < 0 !== t && i.reverse(), i.push([i[0][0], i[0][1]]), i;
          }
          var u = [];
          function d(e) {
            var t = [c(e.region, !1)];
            u.push(t);
            for (var r = 0; r < e.children.length; r++) t.push(f(e.children[r]));
          }
          function f(e) {
            for (var t = 0; t < e.children.length; t++) d(e.children[t]);
            return c(e.region, !0);
          }
          for (l = 0; l < i.children.length; l++) d(i.children[l]);
          return u.length <= 0 ? {
            type: "Polygon",
            coordinates: []
          } : 1 == u.length ? {
            type: "Polygon",
            coordinates: u[0]
          } : {
            type: "MultiPolygon",
            coordinates: u
          };
        }
      };
      t.exports = n;
    }, {}],
    55: [function (e, t, r) {
      var n = e("./linked-list");
      t.exports = function (e, t, r) {
        function a(e, t, n) {
          return {
            id: r ? r.segmentId() : -1,
            start: e,
            end: t,
            myFill: {
              above: n.myFill.above,
              below: n.myFill.below
            },
            otherFill: null
          };
        }
        var i = n.create();
        function o(e, r) {
          i.insertBefore(e, function (n) {
            return function (e, r, n, a, i, o) {
              var l = t.pointsCompare(r, i);
              return 0 !== l ? l : t.pointsSame(n, o) ? 0 : e !== a ? e ? 1 : -1 : t.pointAboveOrOnLine(n, a ? i : o, a ? o : i) ? 1 : -1;
            }(e.isStart, e.pt, r, n.isStart, n.pt, n.other.pt) < 0;
          });
        }
        function l(e, t) {
          var r = function (e, t) {
            var r = n.node({
              isStart: !0,
              pt: e.start,
              seg: e,
              primary: t,
              other: null,
              status: null
            });
            return o(r, e.end), r;
          }(e, t);
          return function (e, t, r) {
            var a = n.node({
              isStart: !1,
              pt: t.end,
              seg: t,
              primary: r,
              other: e,
              status: null
            });
            e.other = a, o(a, e.pt);
          }(r, e, t), r;
        }
        function s(e, t) {
          var n = a(t, e.seg.end, e.seg);
          return function (e, t) {
            r && r.segmentChop(e.seg, t), e.other.remove(), e.seg.end = t, e.other.pt = t, o(e.other, e.pt);
          }(e, t), l(n, e.primary);
        }
        function c(a, o) {
          var l = n.create();
          function c(e) {
            return l.findTransition(function (r) {
              var n, a, i, o, l, s;
              return (n = e, a = r.ev, i = n.seg.start, o = n.seg.end, l = a.seg.start, s = a.seg.end, t.pointsCollinear(i, l, s) ? t.pointsCollinear(o, l, s) || t.pointAboveOrOnLine(o, l, s) ? 1 : -1 : t.pointAboveOrOnLine(i, l, s) ? 1 : -1) > 0;
            });
          }
          function u(e, n) {
            var a = e.seg,
              i = n.seg,
              o = a.start,
              l = a.end,
              c = i.start,
              u = i.end;
            r && r.checkIntersection(a, i);
            var d = t.linesIntersect(o, l, c, u);
            if (!1 === d) {
              if (!t.pointsCollinear(o, l, c)) return !1;
              if (t.pointsSame(o, u) || t.pointsSame(l, c)) return !1;
              var f = t.pointsSame(o, c),
                h = t.pointsSame(l, u);
              if (f && h) return n;
              var p = !f && t.pointBetween(o, c, u),
                g = !h && t.pointBetween(l, c, u);
              if (f) return g ? s(n, l) : s(e, u), n;
              p && (h || (g ? s(n, l) : s(e, u)), s(n, o));
            } else 0 === d.alongA && (-1 === d.alongB ? s(e, c) : 0 === d.alongB ? s(e, d.pt) : 1 === d.alongB && s(e, u)), 0 === d.alongB && (-1 === d.alongA ? s(n, o) : 0 === d.alongA ? s(n, d.pt) : 1 === d.alongA && s(n, l));
            return !1;
          }
          var _loop = function _loop() {
              f = i.getHead();
              if (r && r.vert(f.pt[0]), f.isStart) {
                var m = function m() {
                  if (p) {
                    var e = u(f, p);
                    if (e) return e;
                  }
                  return !!g && u(f, g);
                };
                r && r.segmentNew(f.seg, f.primary);
                h = c(f), p = h.before ? h.before.ev : null, g = h.after ? h.after.ev : null;
                r && r.tempStatus(f.seg, !!p && p.seg, !!g && g.seg);
                v = m();
                if (v) {
                  if (e) (x = null === f.seg.myFill.below || f.seg.myFill.above !== f.seg.myFill.below) && (v.seg.myFill.above = !v.seg.myFill.above);else v.seg.otherFill = f.seg.myFill;
                  r && r.segmentUpdate(v.seg), f.other.remove(), f.remove();
                }
                if (i.getHead() !== f) {
                  r && r.rewind(f.seg);
                  return 1; // continue
                }
                if (e) x = null === f.seg.myFill.below || f.seg.myFill.above !== f.seg.myFill.below, f.seg.myFill.below = g ? g.seg.myFill.above : a, f.seg.myFill.above = x ? !f.seg.myFill.below : f.seg.myFill.below;else if (null === f.seg.otherFill) y = g ? f.primary === g.primary ? g.seg.otherFill.above : g.seg.myFill.above : f.primary ? o : a, f.seg.otherFill = {
                  above: y,
                  below: y
                };
                r && r.status(f.seg, !!p && p.seg, !!g && g.seg), f.other.status = h.insert(n.node({
                  ev: f
                }));
              } else {
                b = f.status;
                if (null === b) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
                if (l.exists(b.prev) && l.exists(b.next) && u(b.prev.ev, b.next.ev), r && r.statusRemove(b.ev.seg), b.remove(), !f.primary) {
                  _ = f.seg.myFill;
                  f.seg.myFill = f.seg.otherFill, f.seg.otherFill = _;
                }
                d.push(f.seg);
              }
              i.getHead().remove();
            },
            f,
            h,
            p,
            g,
            y,
            v,
            x,
            b,
            _;
          for (var d = []; !i.isEmpty();) {
            if (_loop()) continue;
          }
          return r && r.done(), d;
        }
        return e ? {
          addRegion: function addRegion(e) {
            for (var n, a, i, o = e[e.length - 1], s = 0; s < e.length; s++) {
              n = o, o = e[s];
              var c = t.pointsCompare(n, o);
              0 !== c && l((a = c < 0 ? n : o, i = c < 0 ? o : n, {
                id: r ? r.segmentId() : -1,
                start: a,
                end: i,
                myFill: {
                  above: null,
                  below: null
                },
                otherFill: null
              }), !0);
            }
          },
          calculate: function calculate(e) {
            return c(e, !1);
          }
        } : {
          calculate: function calculate(e, t, r, n) {
            return e.forEach(function (e) {
              l(a(e.start, e.end, e), !0);
            }), r.forEach(function (e) {
              l(a(e.start, e.end, e), !1);
            }), c(t, n);
          }
        };
      };
    }, {
      "./linked-list": 56
    }],
    56: [function (e, t, r) {
      t.exports = {
        create: function create() {
          var e = {
            root: {
              root: !0,
              next: null
            },
            exists: function exists(t) {
              return null !== t && t !== e.root;
            },
            isEmpty: function isEmpty() {
              return null === e.root.next;
            },
            getHead: function getHead() {
              return e.root.next;
            },
            insertBefore: function insertBefore(t, r) {
              for (var n = e.root, a = e.root.next; null !== a;) {
                if (r(a)) return t.prev = a.prev, t.next = a, a.prev.next = t, void (a.prev = t);
                n = a, a = a.next;
              }
              n.next = t, t.prev = n, t.next = null;
            },
            findTransition: function findTransition(t) {
              for (var r = e.root, n = e.root.next; null !== n && !t(n);) r = n, n = n.next;
              return {
                before: r === e.root ? null : r,
                after: n,
                insert: function insert(e) {
                  return e.prev = r, e.next = n, r.next = e, null !== n && (n.prev = e), e;
                }
              };
            }
          };
          return e;
        },
        node: function node(e) {
          return e.prev = null, e.next = null, e.remove = function () {
            e.prev.next = e.next, e.next && (e.next.prev = e.prev), e.prev = null, e.next = null;
          }, e;
        }
      };
    }, {}],
    57: [function (e, t, r) {
      t.exports = function (e, t, r) {
        var n = [],
          a = [];
        return e.forEach(function (e) {
          var i = e.start,
            o = e.end;
          if (t.pointsSame(i, o)) console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");else {
            r && r.chainStart(e);
            for (var l = {
                index: 0,
                matches_head: !1,
                matches_pt1: !1
              }, s = {
                index: 0,
                matches_head: !1,
                matches_pt1: !1
              }, c = l, u = 0; u < n.length; u++) {
              var d = (m = n[u])[0],
                f = (m[1], m[m.length - 1]);
              m[m.length - 2];
              if (t.pointsSame(d, i)) {
                if (T(u, !0, !0)) break;
              } else if (t.pointsSame(d, o)) {
                if (T(u, !0, !1)) break;
              } else if (t.pointsSame(f, i)) {
                if (T(u, !1, !0)) break;
              } else if (t.pointsSame(f, o) && T(u, !1, !1)) break;
            }
            if (c === l) return n.push([i, o]), void (r && r.chainNew(i, o));
            if (c === s) {
              r && r.chainMatch(l.index);
              var h = l.index,
                p = l.matches_pt1 ? o : i,
                g = l.matches_head,
                m = n[h],
                y = g ? m[0] : m[m.length - 1],
                v = g ? m[1] : m[m.length - 2],
                x = g ? m[m.length - 1] : m[0],
                b = g ? m[m.length - 2] : m[1];
              return t.pointsCollinear(v, y, p) && (g ? (r && r.chainRemoveHead(l.index, p), m.shift()) : (r && r.chainRemoveTail(l.index, p), m.pop()), y = v), t.pointsSame(x, p) ? (n.splice(h, 1), t.pointsCollinear(b, x, y) && (g ? (r && r.chainRemoveTail(l.index, y), m.pop()) : (r && r.chainRemoveHead(l.index, y), m.shift())), r && r.chainClose(l.index), void a.push(m)) : void (g ? (r && r.chainAddHead(l.index, p), m.unshift(p)) : (r && r.chainAddTail(l.index, p), m.push(p)));
            }
            var _ = l.index,
              w = s.index;
            r && r.chainConnect(_, w);
            var M = n[_].length < n[w].length;
            l.matches_head ? s.matches_head ? M ? (k(_), A(_, w)) : (k(w), A(w, _)) : A(w, _) : s.matches_head ? A(_, w) : M ? (k(_), A(w, _)) : (k(w), A(_, w));
          }
          function T(e, t, r) {
            return c.index = e, c.matches_head = t, c.matches_pt1 = r, c === l ? (c = s, !1) : (c = null, !0);
          }
          function k(e) {
            r && r.chainReverse(e), n[e].reverse();
          }
          function A(e, a) {
            var i = n[e],
              o = n[a],
              l = i[i.length - 1],
              s = i[i.length - 2],
              c = o[0],
              u = o[1];
            t.pointsCollinear(s, l, c) && (r && r.chainRemoveTail(e, l), i.pop(), l = s), t.pointsCollinear(l, c, u) && (r && r.chainRemoveHead(a, c), o.shift()), r && r.chainJoin(e, a), n[e] = i.concat(o), n.splice(a, 1);
          }
        }), a;
      };
    }, {}],
    58: [function (e, t, r) {
      function n(e, t, r) {
        var n = [];
        return e.forEach(function (e) {
          var a = (e.myFill.above ? 8 : 0) + (e.myFill.below ? 4 : 0) + (e.otherFill && e.otherFill.above ? 2 : 0) + (e.otherFill && e.otherFill.below ? 1 : 0);
          0 !== t[a] && n.push({
            id: r ? r.segmentId() : -1,
            start: e.start,
            end: e.end,
            myFill: {
              above: 1 === t[a],
              below: 2 === t[a]
            },
            otherFill: null
          });
        }), r && r.selected(n), n;
      }
      var a = {
        union: function union(e, t) {
          return n(e, [0, 2, 1, 0, 2, 2, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0], t);
        },
        intersect: function intersect(e, t) {
          return n(e, [0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 1, 1, 0, 2, 1, 0], t);
        },
        difference: function difference(e, t) {
          return n(e, [0, 0, 0, 0, 2, 0, 2, 0, 1, 1, 0, 0, 0, 1, 2, 0], t);
        },
        differenceRev: function differenceRev(e, t) {
          return n(e, [0, 2, 1, 0, 0, 0, 1, 1, 0, 2, 0, 2, 0, 0, 0, 0], t);
        },
        xor: function xor(e, t) {
          return n(e, [0, 2, 1, 0, 2, 0, 0, 1, 1, 0, 0, 2, 0, 1, 2, 0], t);
        }
      };
      t.exports = a;
    }, {}],
    59: [function (e, t, r) {
      var n,
        a,
        i = t.exports = {};
      function o() {
        throw new Error("setTimeout has not been defined");
      }
      function l() {
        throw new Error("clearTimeout has not been defined");
      }
      function s(e) {
        if (n === setTimeout) return setTimeout(e, 0);
        if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
        try {
          return n(e, 0);
        } catch (t) {
          try {
            return n.call(null, e, 0);
          } catch (t) {
            return n.call(this, e, 0);
          }
        }
      }
      !function () {
        try {
          n = "function" == typeof setTimeout ? setTimeout : o;
        } catch (e) {
          n = o;
        }
        try {
          a = "function" == typeof clearTimeout ? clearTimeout : l;
        } catch (e) {
          a = l;
        }
      }();
      var c,
        u = [],
        d = !1,
        f = -1;
      function h() {
        d && c && (d = !1, c.length ? u = c.concat(u) : f = -1, u.length && p());
      }
      function p() {
        if (!d) {
          var e = s(h);
          d = !0;
          for (var t = u.length; t;) {
            for (c = u, u = []; ++f < t;) c && c[f].run();
            f = -1, t = u.length;
          }
          c = null, d = !1, function (e) {
            if (a === clearTimeout) return clearTimeout(e);
            if ((a === l || !a) && clearTimeout) return a = clearTimeout, clearTimeout(e);
            try {
              a(e);
            } catch (t) {
              try {
                return a.call(null, e);
              } catch (t) {
                return a.call(this, e);
              }
            }
          }(e);
        }
      }
      function g(e, t) {
        this.fun = e, this.array = t;
      }
      function m() {}
      i.nextTick = function (e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
        u.push(new g(e, t)), 1 !== u.length || d || s(p);
      }, g.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = m, i.addListener = m, i.once = m, i.off = m, i.removeListener = m, i.removeAllListeners = m, i.emit = m, i.prependListener = m, i.prependOnceListener = m, i.listeners = function (e) {
        return [];
      }, i.binding = function (e) {
        throw new Error("process.binding is not supported");
      }, i.cwd = function () {
        return "/";
      }, i.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }, i.umask = function () {
        return 0;
      };
    }, {}],
    60: [function (e, t, r) {
      (function (t, n) {
        (function () {
          var a = e("process/browser.js").nextTick,
            i = Function.prototype.apply,
            o = Array.prototype.slice,
            l = {},
            s = 0;
          function c(e, t) {
            this._id = e, this._clearFn = t;
          }
          r.setTimeout = function () {
            return new c(i.call(setTimeout, window, arguments), clearTimeout);
          }, r.setInterval = function () {
            return new c(i.call(setInterval, window, arguments), clearInterval);
          }, r.clearTimeout = r.clearInterval = function (e) {
            e.close();
          }, c.prototype.unref = c.prototype.ref = function () {}, c.prototype.close = function () {
            this._clearFn.call(window, this._id);
          }, r.enroll = function (e, t) {
            clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
          }, r.unenroll = function (e) {
            clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
          }, r._unrefActive = r.active = function (e) {
            clearTimeout(e._idleTimeoutId);
            var t = e._idleTimeout;
            t >= 0 && (e._idleTimeoutId = setTimeout(function () {
              e._onTimeout && e._onTimeout();
            }, t));
          }, r.setImmediate = "function" == typeof t ? t : function (e) {
            var t = s++,
              n = !(arguments.length < 2) && o.call(arguments, 1);
            return l[t] = !0, a(function () {
              l[t] && (n ? e.apply(null, n) : e.call(null), r.clearImmediate(t));
            }), t;
          }, r.clearImmediate = "function" == typeof n ? n : function (e) {
            delete l[e];
          };
        }).call(this);
      }).call(this, e("timers").setImmediate, e("timers").clearImmediate);
    }, {
      "process/browser.js": 59,
      timers: 60
    }],
    61: [function (e, t, r) {
      !function (e) {
        var r = /^\s+/,
          n = /\s+$/,
          a = 0,
          i = e.round,
          o = e.min,
          l = e.max,
          s = e.random;
        function c(t, s) {
          if (s = s || {}, (t = t || "") instanceof c) return t;
          if (!(this instanceof c)) return new c(t, s);
          var u = function (t) {
            var a = {
                r: 0,
                g: 0,
                b: 0
              },
              i = 1,
              s = null,
              c = null,
              u = null,
              d = !1,
              f = !1;
            "string" == typeof t && (t = function (e) {
              e = e.replace(r, "").replace(n, "").toLowerCase();
              var t,
                a = !1;
              if (L[e]) e = L[e], a = !0;else if ("transparent" == e) return {
                r: 0,
                g: 0,
                b: 0,
                a: 0,
                format: "name"
              };
              if (t = H.rgb.exec(e)) return {
                r: t[1],
                g: t[2],
                b: t[3]
              };
              if (t = H.rgba.exec(e)) return {
                r: t[1],
                g: t[2],
                b: t[3],
                a: t[4]
              };
              if (t = H.hsl.exec(e)) return {
                h: t[1],
                s: t[2],
                l: t[3]
              };
              if (t = H.hsla.exec(e)) return {
                h: t[1],
                s: t[2],
                l: t[3],
                a: t[4]
              };
              if (t = H.hsv.exec(e)) return {
                h: t[1],
                s: t[2],
                v: t[3]
              };
              if (t = H.hsva.exec(e)) return {
                h: t[1],
                s: t[2],
                v: t[3],
                a: t[4]
              };
              if (t = H.hex8.exec(e)) return {
                r: P(t[1]),
                g: P(t[2]),
                b: P(t[3]),
                a: N(t[4]),
                format: a ? "name" : "hex8"
              };
              if (t = H.hex6.exec(e)) return {
                r: P(t[1]),
                g: P(t[2]),
                b: P(t[3]),
                format: a ? "name" : "hex"
              };
              if (t = H.hex4.exec(e)) return {
                r: P(t[1] + "" + t[1]),
                g: P(t[2] + "" + t[2]),
                b: P(t[3] + "" + t[3]),
                a: N(t[4] + "" + t[4]),
                format: a ? "name" : "hex8"
              };
              if (t = H.hex3.exec(e)) return {
                r: P(t[1] + "" + t[1]),
                g: P(t[2] + "" + t[2]),
                b: P(t[3] + "" + t[3]),
                format: a ? "name" : "hex"
              };
              return !1;
            }(t));
            "object" == typeof t && (B(t.r) && B(t.g) && B(t.b) ? (h = t.r, p = t.g, g = t.b, a = {
              r: 255 * C(h, 255),
              g: 255 * C(p, 255),
              b: 255 * C(g, 255)
            }, d = !0, f = "%" === String(t.r).substr(-1) ? "prgb" : "rgb") : B(t.h) && B(t.s) && B(t.v) ? (s = z(t.s), c = z(t.v), a = function (t, r, n) {
              t = 6 * C(t, 360), r = C(r, 100), n = C(n, 100);
              var a = e.floor(t),
                i = t - a,
                o = n * (1 - r),
                l = n * (1 - i * r),
                s = n * (1 - (1 - i) * r),
                c = a % 6;
              return {
                r: 255 * [n, l, o, o, s, n][c],
                g: 255 * [s, n, n, l, o, o][c],
                b: 255 * [o, o, s, n, n, l][c]
              };
            }(t.h, s, c), d = !0, f = "hsv") : B(t.h) && B(t.s) && B(t.l) && (s = z(t.s), u = z(t.l), a = function (e, t, r) {
              var n, a, i;
              function o(e, t, r) {
                return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + 6 * (t - e) * r : r < .5 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
              }
              if (e = C(e, 360), t = C(t, 100), r = C(r, 100), 0 === t) n = a = i = r;else {
                var l = r < .5 ? r * (1 + t) : r + t - r * t,
                  s = 2 * r - l;
                n = o(s, l, e + 1 / 3), a = o(s, l, e), i = o(s, l, e - 1 / 3);
              }
              return {
                r: 255 * n,
                g: 255 * a,
                b: 255 * i
              };
            }(t.h, s, u), d = !0, f = "hsl"), t.hasOwnProperty("a") && (i = t.a));
            var h, p, g;
            return i = S(i), {
              ok: d,
              format: t.format || f,
              r: o(255, l(a.r, 0)),
              g: o(255, l(a.g, 0)),
              b: o(255, l(a.b, 0)),
              a: i
            };
          }(t);
          this._originalInput = t, this._r = u.r, this._g = u.g, this._b = u.b, this._a = u.a, this._roundA = i(100 * this._a) / 100, this._format = s.format || u.format, this._gradientType = s.gradientType, this._r < 1 && (this._r = i(this._r)), this._g < 1 && (this._g = i(this._g)), this._b < 1 && (this._b = i(this._b)), this._ok = u.ok, this._tc_id = a++;
        }
        function u(e, t, r) {
          e = C(e, 255), t = C(t, 255), r = C(r, 255);
          var n,
            a,
            i = l(e, t, r),
            s = o(e, t, r),
            c = (i + s) / 2;
          if (i == s) n = a = 0;else {
            var u = i - s;
            switch (a = c > .5 ? u / (2 - i - s) : u / (i + s), i) {
              case e:
                n = (t - r) / u + (t < r ? 6 : 0);
                break;
              case t:
                n = (r - e) / u + 2;
                break;
              case r:
                n = (e - t) / u + 4;
            }
            n /= 6;
          }
          return {
            h: n,
            s: a,
            l: c
          };
        }
        function d(e, t, r) {
          e = C(e, 255), t = C(t, 255), r = C(r, 255);
          var n,
            a,
            i = l(e, t, r),
            s = o(e, t, r),
            c = i,
            u = i - s;
          if (a = 0 === i ? 0 : u / i, i == s) n = 0;else {
            switch (i) {
              case e:
                n = (t - r) / u + (t < r ? 6 : 0);
                break;
              case t:
                n = (r - e) / u + 2;
                break;
              case r:
                n = (e - t) / u + 4;
            }
            n /= 6;
          }
          return {
            h: n,
            s: a,
            v: c
          };
        }
        function f(e, t, r, n) {
          var a = [I(i(e).toString(16)), I(i(t).toString(16)), I(i(r).toString(16))];
          return n && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
        }
        function h(e, t, r, n) {
          return [I(R(n)), I(i(e).toString(16)), I(i(t).toString(16)), I(i(r).toString(16))].join("");
        }
        function p(e, t) {
          t = 0 === t ? 0 : t || 10;
          var r = c(e).toHsl();
          return r.s -= t / 100, r.s = O(r.s), c(r);
        }
        function g(e, t) {
          t = 0 === t ? 0 : t || 10;
          var r = c(e).toHsl();
          return r.s += t / 100, r.s = O(r.s), c(r);
        }
        function m(e) {
          return c(e).desaturate(100);
        }
        function y(e, t) {
          t = 0 === t ? 0 : t || 10;
          var r = c(e).toHsl();
          return r.l += t / 100, r.l = O(r.l), c(r);
        }
        function v(e, t) {
          t = 0 === t ? 0 : t || 10;
          var r = c(e).toRgb();
          return r.r = l(0, o(255, r.r - i(-t / 100 * 255))), r.g = l(0, o(255, r.g - i(-t / 100 * 255))), r.b = l(0, o(255, r.b - i(-t / 100 * 255))), c(r);
        }
        function x(e, t) {
          t = 0 === t ? 0 : t || 10;
          var r = c(e).toHsl();
          return r.l -= t / 100, r.l = O(r.l), c(r);
        }
        function b(e, t) {
          var r = c(e).toHsl(),
            n = (r.h + t) % 360;
          return r.h = n < 0 ? 360 + n : n, c(r);
        }
        function _(e) {
          var t = c(e).toHsl();
          return t.h = (t.h + 180) % 360, c(t);
        }
        function w(e) {
          var t = c(e).toHsl(),
            r = t.h;
          return [c(e), c({
            h: (r + 120) % 360,
            s: t.s,
            l: t.l
          }), c({
            h: (r + 240) % 360,
            s: t.s,
            l: t.l
          })];
        }
        function M(e) {
          var t = c(e).toHsl(),
            r = t.h;
          return [c(e), c({
            h: (r + 90) % 360,
            s: t.s,
            l: t.l
          }), c({
            h: (r + 180) % 360,
            s: t.s,
            l: t.l
          }), c({
            h: (r + 270) % 360,
            s: t.s,
            l: t.l
          })];
        }
        function T(e) {
          var t = c(e).toHsl(),
            r = t.h;
          return [c(e), c({
            h: (r + 72) % 360,
            s: t.s,
            l: t.l
          }), c({
            h: (r + 216) % 360,
            s: t.s,
            l: t.l
          })];
        }
        function k(e, t, r) {
          t = t || 6, r = r || 30;
          var n = c(e).toHsl(),
            a = 360 / r,
            i = [c(e)];
          for (n.h = (n.h - (a * t >> 1) + 720) % 360; --t;) n.h = (n.h + a) % 360, i.push(c(n));
          return i;
        }
        function A(e, t) {
          t = t || 6;
          for (var r = c(e).toHsv(), n = r.h, a = r.s, i = r.v, o = [], l = 1 / t; t--;) o.push(c({
            h: n,
            s: a,
            v: i
          })), i = (i + l) % 1;
          return o;
        }
        c.prototype = {
          isDark: function isDark() {
            return this.getBrightness() < 128;
          },
          isLight: function isLight() {
            return !this.isDark();
          },
          isValid: function isValid() {
            return this._ok;
          },
          getOriginalInput: function getOriginalInput() {
            return this._originalInput;
          },
          getFormat: function getFormat() {
            return this._format;
          },
          getAlpha: function getAlpha() {
            return this._a;
          },
          getBrightness: function getBrightness() {
            var e = this.toRgb();
            return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3;
          },
          getLuminance: function getLuminance() {
            var t,
              r,
              n,
              a = this.toRgb();
            return t = a.r / 255, r = a.g / 255, n = a.b / 255, .2126 * (t <= .03928 ? t / 12.92 : e.pow((t + .055) / 1.055, 2.4)) + .7152 * (r <= .03928 ? r / 12.92 : e.pow((r + .055) / 1.055, 2.4)) + .0722 * (n <= .03928 ? n / 12.92 : e.pow((n + .055) / 1.055, 2.4));
          },
          setAlpha: function setAlpha(e) {
            return this._a = S(e), this._roundA = i(100 * this._a) / 100, this;
          },
          toHsv: function toHsv() {
            var e = d(this._r, this._g, this._b);
            return {
              h: 360 * e.h,
              s: e.s,
              v: e.v,
              a: this._a
            };
          },
          toHsvString: function toHsvString() {
            var e = d(this._r, this._g, this._b),
              t = i(360 * e.h),
              r = i(100 * e.s),
              n = i(100 * e.v);
            return 1 == this._a ? "hsv(" + t + ", " + r + "%, " + n + "%)" : "hsva(" + t + ", " + r + "%, " + n + "%, " + this._roundA + ")";
          },
          toHsl: function toHsl() {
            var e = u(this._r, this._g, this._b);
            return {
              h: 360 * e.h,
              s: e.s,
              l: e.l,
              a: this._a
            };
          },
          toHslString: function toHslString() {
            var e = u(this._r, this._g, this._b),
              t = i(360 * e.h),
              r = i(100 * e.s),
              n = i(100 * e.l);
            return 1 == this._a ? "hsl(" + t + ", " + r + "%, " + n + "%)" : "hsla(" + t + ", " + r + "%, " + n + "%, " + this._roundA + ")";
          },
          toHex: function toHex(e) {
            return f(this._r, this._g, this._b, e);
          },
          toHexString: function toHexString(e) {
            return "#" + this.toHex(e);
          },
          toHex8: function toHex8(e) {
            return function (e, t, r, n, a) {
              var o = [I(i(e).toString(16)), I(i(t).toString(16)), I(i(r).toString(16)), I(R(n))];
              if (a && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) && o[3].charAt(0) == o[3].charAt(1)) return o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0);
              return o.join("");
            }(this._r, this._g, this._b, this._a, e);
          },
          toHex8String: function toHex8String(e) {
            return "#" + this.toHex8(e);
          },
          toRgb: function toRgb() {
            return {
              r: i(this._r),
              g: i(this._g),
              b: i(this._b),
              a: this._a
            };
          },
          toRgbString: function toRgbString() {
            return 1 == this._a ? "rgb(" + i(this._r) + ", " + i(this._g) + ", " + i(this._b) + ")" : "rgba(" + i(this._r) + ", " + i(this._g) + ", " + i(this._b) + ", " + this._roundA + ")";
          },
          toPercentageRgb: function toPercentageRgb() {
            return {
              r: i(100 * C(this._r, 255)) + "%",
              g: i(100 * C(this._g, 255)) + "%",
              b: i(100 * C(this._b, 255)) + "%",
              a: this._a
            };
          },
          toPercentageRgbString: function toPercentageRgbString() {
            return 1 == this._a ? "rgb(" + i(100 * C(this._r, 255)) + "%, " + i(100 * C(this._g, 255)) + "%, " + i(100 * C(this._b, 255)) + "%)" : "rgba(" + i(100 * C(this._r, 255)) + "%, " + i(100 * C(this._g, 255)) + "%, " + i(100 * C(this._b, 255)) + "%, " + this._roundA + ")";
          },
          toName: function toName() {
            return 0 === this._a ? "transparent" : !(this._a < 1) && (D[f(this._r, this._g, this._b, !0)] || !1);
          },
          toFilter: function toFilter(e) {
            var t = "#" + h(this._r, this._g, this._b, this._a),
              r = t,
              n = this._gradientType ? "GradientType = 1, " : "";
            if (e) {
              var a = c(e);
              r = "#" + h(a._r, a._g, a._b, a._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + n + "startColorstr=" + t + ",endColorstr=" + r + ")";
          },
          toString: function toString(e) {
            var t = !!e;
            e = e || this._format;
            var r = !1,
              n = this._a < 1 && this._a >= 0;
            return t || !n || "hex" !== e && "hex6" !== e && "hex3" !== e && "hex4" !== e && "hex8" !== e && "name" !== e ? ("rgb" === e && (r = this.toRgbString()), "prgb" === e && (r = this.toPercentageRgbString()), "hex" !== e && "hex6" !== e || (r = this.toHexString()), "hex3" === e && (r = this.toHexString(!0)), "hex4" === e && (r = this.toHex8String(!0)), "hex8" === e && (r = this.toHex8String()), "name" === e && (r = this.toName()), "hsl" === e && (r = this.toHslString()), "hsv" === e && (r = this.toHsvString()), r || this.toHexString()) : "name" === e && 0 === this._a ? this.toName() : this.toRgbString();
          },
          clone: function clone() {
            return c(this.toString());
          },
          _applyModification: function _applyModification(e, t) {
            var r = e.apply(null, [this].concat([].slice.call(t)));
            return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
          },
          lighten: function lighten() {
            return this._applyModification(y, arguments);
          },
          brighten: function brighten() {
            return this._applyModification(v, arguments);
          },
          darken: function darken() {
            return this._applyModification(x, arguments);
          },
          desaturate: function desaturate() {
            return this._applyModification(p, arguments);
          },
          saturate: function saturate() {
            return this._applyModification(g, arguments);
          },
          greyscale: function greyscale() {
            return this._applyModification(m, arguments);
          },
          spin: function spin() {
            return this._applyModification(b, arguments);
          },
          _applyCombination: function _applyCombination(e, t) {
            return e.apply(null, [this].concat([].slice.call(t)));
          },
          analogous: function analogous() {
            return this._applyCombination(k, arguments);
          },
          complement: function complement() {
            return this._applyCombination(_, arguments);
          },
          monochromatic: function monochromatic() {
            return this._applyCombination(A, arguments);
          },
          splitcomplement: function splitcomplement() {
            return this._applyCombination(T, arguments);
          },
          triad: function triad() {
            return this._applyCombination(w, arguments);
          },
          tetrad: function tetrad() {
            return this._applyCombination(M, arguments);
          }
        }, c.fromRatio = function (e, t) {
          if ("object" == typeof e) {
            var r = {};
            for (var n in e) e.hasOwnProperty(n) && (r[n] = "a" === n ? e[n] : z(e[n]));
            e = r;
          }
          return c(e, t);
        }, c.equals = function (e, t) {
          return !(!e || !t) && c(e).toRgbString() == c(t).toRgbString();
        }, c.random = function () {
          return c.fromRatio({
            r: s(),
            g: s(),
            b: s()
          });
        }, c.mix = function (e, t, r) {
          r = 0 === r ? 0 : r || 50;
          var n = c(e).toRgb(),
            a = c(t).toRgb(),
            i = r / 100;
          return c({
            r: (a.r - n.r) * i + n.r,
            g: (a.g - n.g) * i + n.g,
            b: (a.b - n.b) * i + n.b,
            a: (a.a - n.a) * i + n.a
          });
        }, c.readability = function (t, r) {
          var n = c(t),
            a = c(r);
          return (e.max(n.getLuminance(), a.getLuminance()) + .05) / (e.min(n.getLuminance(), a.getLuminance()) + .05);
        }, c.isReadable = function (e, t, r) {
          var n,
            a,
            i = c.readability(e, t);
          switch (a = !1, (n = function (e) {
            var t, r;
            t = ((e = e || {
              level: "AA",
              size: "small"
            }).level || "AA").toUpperCase(), r = (e.size || "small").toLowerCase(), "AA" !== t && "AAA" !== t && (t = "AA");
            "small" !== r && "large" !== r && (r = "small");
            return {
              level: t,
              size: r
            };
          }(r)).level + n.size) {
            case "AAsmall":
            case "AAAlarge":
              a = i >= 4.5;
              break;
            case "AAlarge":
              a = i >= 3;
              break;
            case "AAAsmall":
              a = i >= 7;
          }
          return a;
        }, c.mostReadable = function (e, t, r) {
          var n,
            a,
            i,
            o,
            l = null,
            s = 0;
          a = (r = r || {}).includeFallbackColors, i = r.level, o = r.size;
          for (var u = 0; u < t.length; u++) (n = c.readability(e, t[u])) > s && (s = n, l = c(t[u]));
          return c.isReadable(e, l, {
            level: i,
            size: o
          }) || !a ? l : (r.includeFallbackColors = !1, c.mostReadable(e, ["#fff", "#000"], r));
        };
        var L = c.names = {
            aliceblue: "f0f8ff",
            antiquewhite: "faebd7",
            aqua: "0ff",
            aquamarine: "7fffd4",
            azure: "f0ffff",
            beige: "f5f5dc",
            bisque: "ffe4c4",
            black: "000",
            blanchedalmond: "ffebcd",
            blue: "00f",
            blueviolet: "8a2be2",
            brown: "a52a2a",
            burlywood: "deb887",
            burntsienna: "ea7e5d",
            cadetblue: "5f9ea0",
            chartreuse: "7fff00",
            chocolate: "d2691e",
            coral: "ff7f50",
            cornflowerblue: "6495ed",
            cornsilk: "fff8dc",
            crimson: "dc143c",
            cyan: "0ff",
            darkblue: "00008b",
            darkcyan: "008b8b",
            darkgoldenrod: "b8860b",
            darkgray: "a9a9a9",
            darkgreen: "006400",
            darkgrey: "a9a9a9",
            darkkhaki: "bdb76b",
            darkmagenta: "8b008b",
            darkolivegreen: "556b2f",
            darkorange: "ff8c00",
            darkorchid: "9932cc",
            darkred: "8b0000",
            darksalmon: "e9967a",
            darkseagreen: "8fbc8f",
            darkslateblue: "483d8b",
            darkslategray: "2f4f4f",
            darkslategrey: "2f4f4f",
            darkturquoise: "00ced1",
            darkviolet: "9400d3",
            deeppink: "ff1493",
            deepskyblue: "00bfff",
            dimgray: "696969",
            dimgrey: "696969",
            dodgerblue: "1e90ff",
            firebrick: "b22222",
            floralwhite: "fffaf0",
            forestgreen: "228b22",
            fuchsia: "f0f",
            gainsboro: "dcdcdc",
            ghostwhite: "f8f8ff",
            gold: "ffd700",
            goldenrod: "daa520",
            gray: "808080",
            green: "008000",
            greenyellow: "adff2f",
            grey: "808080",
            honeydew: "f0fff0",
            hotpink: "ff69b4",
            indianred: "cd5c5c",
            indigo: "4b0082",
            ivory: "fffff0",
            khaki: "f0e68c",
            lavender: "e6e6fa",
            lavenderblush: "fff0f5",
            lawngreen: "7cfc00",
            lemonchiffon: "fffacd",
            lightblue: "add8e6",
            lightcoral: "f08080",
            lightcyan: "e0ffff",
            lightgoldenrodyellow: "fafad2",
            lightgray: "d3d3d3",
            lightgreen: "90ee90",
            lightgrey: "d3d3d3",
            lightpink: "ffb6c1",
            lightsalmon: "ffa07a",
            lightseagreen: "20b2aa",
            lightskyblue: "87cefa",
            lightslategray: "789",
            lightslategrey: "789",
            lightsteelblue: "b0c4de",
            lightyellow: "ffffe0",
            lime: "0f0",
            limegreen: "32cd32",
            linen: "faf0e6",
            magenta: "f0f",
            maroon: "800000",
            mediumaquamarine: "66cdaa",
            mediumblue: "0000cd",
            mediumorchid: "ba55d3",
            mediumpurple: "9370db",
            mediumseagreen: "3cb371",
            mediumslateblue: "7b68ee",
            mediumspringgreen: "00fa9a",
            mediumturquoise: "48d1cc",
            mediumvioletred: "c71585",
            midnightblue: "191970",
            mintcream: "f5fffa",
            mistyrose: "ffe4e1",
            moccasin: "ffe4b5",
            navajowhite: "ffdead",
            navy: "000080",
            oldlace: "fdf5e6",
            olive: "808000",
            olivedrab: "6b8e23",
            orange: "ffa500",
            orangered: "ff4500",
            orchid: "da70d6",
            palegoldenrod: "eee8aa",
            palegreen: "98fb98",
            paleturquoise: "afeeee",
            palevioletred: "db7093",
            papayawhip: "ffefd5",
            peachpuff: "ffdab9",
            peru: "cd853f",
            pink: "ffc0cb",
            plum: "dda0dd",
            powderblue: "b0e0e6",
            purple: "800080",
            rebeccapurple: "663399",
            red: "f00",
            rosybrown: "bc8f8f",
            royalblue: "4169e1",
            saddlebrown: "8b4513",
            salmon: "fa8072",
            sandybrown: "f4a460",
            seagreen: "2e8b57",
            seashell: "fff5ee",
            sienna: "a0522d",
            silver: "c0c0c0",
            skyblue: "87ceeb",
            slateblue: "6a5acd",
            slategray: "708090",
            slategrey: "708090",
            snow: "fffafa",
            springgreen: "00ff7f",
            steelblue: "4682b4",
            tan: "d2b48c",
            teal: "008080",
            thistle: "d8bfd8",
            tomato: "ff6347",
            turquoise: "40e0d0",
            violet: "ee82ee",
            wheat: "f5deb3",
            white: "fff",
            whitesmoke: "f5f5f5",
            yellow: "ff0",
            yellowgreen: "9acd32"
          },
          D = c.hexNames = function (e) {
            var t = {};
            for (var r in e) e.hasOwnProperty(r) && (t[e[r]] = r);
            return t;
          }(L);
        function S(e) {
          return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
        }
        function C(t, r) {
          (function (e) {
            return "string" == typeof e && -1 != e.indexOf(".") && 1 === parseFloat(e);
          })(t) && (t = "100%");
          var n = function (e) {
            return "string" == typeof e && -1 != e.indexOf("%");
          }(t);
          return t = o(r, l(0, parseFloat(t))), n && (t = parseInt(t * r, 10) / 100), e.abs(t - r) < 1e-6 ? 1 : t % r / parseFloat(r);
        }
        function O(e) {
          return o(1, l(0, e));
        }
        function P(e) {
          return parseInt(e, 16);
        }
        function I(e) {
          return 1 == e.length ? "0" + e : "" + e;
        }
        function z(e) {
          return e <= 1 && (e = 100 * e + "%"), e;
        }
        function R(t) {
          return e.round(255 * parseFloat(t)).toString(16);
        }
        function N(e) {
          return P(e) / 255;
        }
        var F,
          E,
          j,
          H = (E = "[\\s|\\(]+(" + (F = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + F + ")[,|\\s]+(" + F + ")\\s*\\)?", j = "[\\s|\\(]+(" + F + ")[,|\\s]+(" + F + ")[,|\\s]+(" + F + ")[,|\\s]+(" + F + ")\\s*\\)?", {
            CSS_UNIT: new RegExp(F),
            rgb: new RegExp("rgb" + E),
            rgba: new RegExp("rgba" + j),
            hsl: new RegExp("hsl" + E),
            hsla: new RegExp("hsla" + j),
            hsv: new RegExp("hsv" + E),
            hsva: new RegExp("hsva" + j),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
          });
        function B(e) {
          return !!H.CSS_UNIT.exec(e);
        }
        void 0 !== t && t.exports ? t.exports = c : window.tinycolor = c;
      }(Math);
    }, {}],
    62: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign"),
        i = n.instance();
      function o(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      o.prototype = new n.baseCalendar(), a(o.prototype, {
        name: "Chinese",
        jdEpoch: 1721425.5,
        hasYearZero: !1,
        minMonth: 0,
        firstMonth: 0,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Chinese",
            epochs: ["BEC", "EC"],
            monthNumbers: function monthNumbers(e, t) {
              if ("string" == typeof e) {
                var r = e.match(s);
                return r ? r[0] : "";
              }
              var n = this._validateYear(e),
                a = e.month(),
                i = "" + this.toChineseMonth(n, a);
              return t && i.length < 2 && (i = "0" + i), this.isIntercalaryMonth(n, a) && (i += "i"), i;
            },
            monthNames: function monthNames(e) {
              if ("string" == typeof e) {
                var t = e.match(c);
                return t ? t[0] : "";
              }
              var r = this._validateYear(e),
                n = e.month(),
                a = ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"][this.toChineseMonth(r, n) - 1];
              return this.isIntercalaryMonth(r, n) && (a = "\u95F0" + a), a;
            },
            monthNamesShort: function monthNamesShort(e) {
              if ("string" == typeof e) {
                var t = e.match(u);
                return t ? t[0] : "";
              }
              var r = this._validateYear(e),
                n = e.month(),
                a = ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"][this.toChineseMonth(r, n) - 1];
              return this.isIntercalaryMonth(r, n) && (a = "\u95F0" + a), a;
            },
            parseMonth: function parseMonth(e, t) {
              e = this._validateYear(e);
              var r,
                n = parseInt(t);
              if (isNaN(n)) "\u95F0" === t[0] && (r = !0, t = t.substring(1)), "\u6708" === t[t.length - 1] && (t = t.substring(0, t.length - 1)), n = 1 + ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"].indexOf(t);else {
                var a = t[t.length - 1];
                r = "i" === a || "I" === a;
              }
              return this.toMonthIndex(e, n, r);
            },
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 1,
            isRTL: !1
          }
        },
        _validateYear: function _validateYear(e, t) {
          if (e.year && (e = e.year()), "number" != typeof e || e < 1888 || e > 2111) throw t.replace(/\{0\}/, this.local.name);
          return e;
        },
        toMonthIndex: function toMonthIndex(e, t, r) {
          var a = this.intercalaryMonth(e);
          if (r && t !== a || t < 1 || t > 12) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
          return a ? !r && t <= a ? t - 1 : t : t - 1;
        },
        toChineseMonth: function toChineseMonth(e, t) {
          e.year && (t = (e = e.year()).month());
          var r = this.intercalaryMonth(e);
          if (t < 0 || t > (r ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
          return r ? t < r ? t + 1 : t : t + 1;
        },
        intercalaryMonth: function intercalaryMonth(e) {
          return e = this._validateYear(e), d[e - d[0]] >> 13;
        },
        isIntercalaryMonth: function isIntercalaryMonth(e, t) {
          e.year && (t = (e = e.year()).month());
          var r = this.intercalaryMonth(e);
          return !!r && r === t;
        },
        leapYear: function leapYear(e) {
          return 0 !== this.intercalaryMonth(e);
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var a,
            o = this._validateYear(e, n.local.invalidyear),
            l = f[o - f[0]],
            s = l >> 9 & 4095,
            c = l >> 5 & 15,
            u = 31 & l;
          (a = i.newDate(s, c, u)).add(4 - (a.dayOfWeek() || 7), "d");
          var d = this.toJD(e, t, r) - a.toJD();
          return 1 + Math.floor(d / 7);
        },
        monthsInYear: function monthsInYear(e) {
          return this.leapYear(e) ? 13 : 12;
        },
        daysInMonth: function daysInMonth(e, t) {
          e.year && (t = e.month(), e = e.year()), e = this._validateYear(e);
          var r = d[e - d[0]];
          if (t > (r >> 13 ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
          return r & 1 << 12 - t ? 30 : 29;
        },
        weekDay: function weekDay(e, t, r) {
          return (this.dayOfWeek(e, t, r) || 7) < 6;
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, l, r, n.local.invalidDate);
          e = this._validateYear(a.year()), t = a.month(), r = a.day();
          var o = this.isIntercalaryMonth(e, t),
            l = this.toChineseMonth(e, t),
            s = function (e, t, r, n, a) {
              var i, o, l;
              if ("object" == typeof e) o = e, i = t || {};else {
                var s;
                if (!("number" == typeof e && e >= 1888 && e <= 2111)) throw new Error("Lunar year outside range 1888-2111");
                if (!("number" == typeof t && t >= 1 && t <= 12)) throw new Error("Lunar month outside range 1 - 12");
                if (!("number" == typeof r && r >= 1 && r <= 30)) throw new Error("Lunar day outside range 1 - 30");
                "object" == typeof n ? (s = !1, i = n) : (s = !!n, i = a || {}), o = {
                  year: e,
                  month: t,
                  day: r,
                  isIntercalary: s
                };
              }
              l = o.day - 1;
              var c,
                u = d[o.year - d[0]],
                h = u >> 13;
              c = h && (o.month > h || o.isIntercalary) ? o.month : o.month - 1;
              for (var p = 0; p < c; p++) {
                l += u & 1 << 12 - p ? 30 : 29;
              }
              var g = f[o.year - f[0]],
                m = new Date(g >> 9 & 4095, (g >> 5 & 15) - 1, (31 & g) + l);
              return i.year = m.getFullYear(), i.month = 1 + m.getMonth(), i.day = m.getDate(), i;
            }(e, l, r, o);
          return i.toJD(s.year, s.month, s.day);
        },
        fromJD: function fromJD(e) {
          var t = i.fromJD(e),
            r = function (e, t, r, n) {
              var a, i;
              if ("object" == typeof e) a = e, i = t || {};else {
                if (!("number" == typeof e && e >= 1888 && e <= 2111)) throw new Error("Solar year outside range 1888-2111");
                if (!("number" == typeof t && t >= 1 && t <= 12)) throw new Error("Solar month outside range 1 - 12");
                if (!("number" == typeof r && r >= 1 && r <= 31)) throw new Error("Solar day outside range 1 - 31");
                a = {
                  year: e,
                  month: t,
                  day: r
                }, i = n || {};
              }
              var o = f[a.year - f[0]],
                l = a.year << 9 | a.month << 5 | a.day;
              i.year = l >= o ? a.year : a.year - 1, o = f[i.year - f[0]];
              var s,
                c = new Date(o >> 9 & 4095, (o >> 5 & 15) - 1, 31 & o),
                u = new Date(a.year, a.month - 1, a.day);
              s = Math.round((u - c) / 864e5);
              var h,
                p = d[i.year - d[0]];
              for (h = 0; h < 13; h++) {
                var g = p & 1 << 12 - h ? 30 : 29;
                if (s < g) break;
                s -= g;
              }
              var m = p >> 13;
              !m || h < m ? (i.isIntercalary = !1, i.month = 1 + h) : h === m ? (i.isIntercalary = !0, i.month = h) : (i.isIntercalary = !1, i.month = h);
              return i.day = 1 + s, i;
            }(t.year(), t.month(), t.day()),
            n = this.toMonthIndex(r.year, r.month, r.isIntercalary);
          return this.newDate(r.year, n, r.day);
        },
        fromString: function fromString(e) {
          var t = e.match(l),
            r = this._validateYear(+t[1]),
            n = +t[2],
            a = !!t[3],
            i = this.toMonthIndex(r, n, a),
            o = +t[4];
          return this.newDate(r, i, o);
        },
        add: function add(e, t, r) {
          var n = e.year(),
            a = e.month(),
            i = this.isIntercalaryMonth(n, a),
            l = this.toChineseMonth(n, a),
            s = Object.getPrototypeOf(o.prototype).add.call(this, e, t, r);
          if ("y" === r) {
            var c = s.year(),
              u = s.month(),
              d = this.isIntercalaryMonth(c, l),
              f = i && d ? this.toMonthIndex(c, l, !0) : this.toMonthIndex(c, l, !1);
            f !== u && s.month(f);
          }
          return s;
        }
      });
      var l = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m,
        s = /^\d?\d[iI]?/m,
        c = /^\u95f0?\u5341?[\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]?\u6708/m,
        u = /^\u95f0?\u5341?[\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]?/m;
      n.calendars.chinese = o;
      var d = [1887, 5780, 5802, 19157, 2742, 50359, 1198, 2646, 46378, 7466, 3412, 30122, 5482, 67949, 2396, 5294, 43597, 6732, 6954, 36181, 2772, 4954, 18781, 2396, 54427, 5274, 6730, 47781, 5800, 6868, 21210, 4790, 59703, 2350, 5270, 46667, 3402, 3496, 38325, 1388, 4782, 18735, 2350, 52374, 6804, 7498, 44457, 2906, 1388, 29294, 4700, 63789, 6442, 6804, 56138, 5802, 2772, 38235, 1210, 4698, 22827, 5418, 63125, 3476, 5802, 43701, 2484, 5302, 27223, 2646, 70954, 7466, 3412, 54698, 5482, 2412, 38062, 5294, 2636, 32038, 6954, 60245, 2772, 4826, 43357, 2394, 5274, 39501, 6730, 72357, 5800, 5844, 53978, 4790, 2358, 38039, 5270, 87627, 3402, 3496, 54708, 5484, 4782, 43311, 2350, 3222, 27978, 7498, 68965, 2904, 5484, 45677, 4700, 6444, 39573, 6804, 6986, 19285, 2772, 62811, 1210, 4698, 47403, 5418, 5780, 38570, 5546, 76469, 2420, 5302, 51799, 2646, 5414, 36501, 3412, 5546, 18869, 2412, 54446, 5276, 6732, 48422, 6822, 2900, 28010, 4826, 92509, 2394, 5274, 55883, 6730, 6820, 47956, 5812, 2778, 18779, 2358, 62615, 5270, 5450, 46757, 3492, 5556, 27318, 4718, 67887, 2350, 3222, 52554, 7498, 3428, 38252, 5468, 4700, 31022, 6444, 64149, 6804, 6986, 43861, 2772, 5338, 35421, 2650, 70955, 5418, 5780, 54954, 5546, 2740, 38074, 5302, 2646, 29991, 3366, 61011, 3412, 5546, 43445, 2412, 5294, 35406, 6732, 72998, 6820, 6996, 52586, 2778, 2396, 38045, 5274, 6698, 23333, 6820, 64338, 5812, 2746, 43355, 2358, 5270, 39499, 5450, 79525, 3492, 5548],
        f = [1887, 966732, 967231, 967733, 968265, 968766, 969297, 969798, 970298, 970829, 971330, 971830, 972362, 972863, 973395, 973896, 974397, 974928, 975428, 975929, 976461, 976962, 977462, 977994, 978494, 979026, 979526, 980026, 980558, 981059, 981559, 982091, 982593, 983124, 983624, 984124, 984656, 985157, 985656, 986189, 986690, 987191, 987722, 988222, 988753, 989254, 989754, 990286, 990788, 991288, 991819, 992319, 992851, 993352, 993851, 994383, 994885, 995385, 995917, 996418, 996918, 997450, 997949, 998481, 998982, 999483, 1000014, 1000515, 1001016, 1001548, 1002047, 1002578, 1003080, 1003580, 1004111, 1004613, 1005113, 1005645, 1006146, 1006645, 1007177, 1007678, 1008209, 1008710, 1009211, 1009743, 1010243, 1010743, 1011275, 1011775, 1012306, 1012807, 1013308, 1013840, 1014341, 1014841, 1015373, 1015874, 1016404, 1016905, 1017405, 1017937, 1018438, 1018939, 1019471, 1019972, 1020471, 1021002, 1021503, 1022035, 1022535, 1023036, 1023568, 1024069, 1024568, 1025100, 1025601, 1026102, 1026633, 1027133, 1027666, 1028167, 1028666, 1029198, 1029699, 1030199, 1030730, 1031231, 1031763, 1032264, 1032764, 1033296, 1033797, 1034297, 1034828, 1035329, 1035830, 1036362, 1036861, 1037393, 1037894, 1038394, 1038925, 1039427, 1039927, 1040459, 1040959, 1041491, 1041992, 1042492, 1043023, 1043524, 1044024, 1044556, 1045057, 1045558, 1046090, 1046590, 1047121, 1047622, 1048122, 1048654, 1049154, 1049655, 1050187, 1050689, 1051219, 1051720, 1052220, 1052751, 1053252, 1053752, 1054284, 1054786, 1055285, 1055817, 1056317, 1056849, 1057349, 1057850, 1058382, 1058883, 1059383, 1059915, 1060415, 1060947, 1061447, 1061947, 1062479, 1062981, 1063480, 1064012, 1064514, 1065014, 1065545, 1066045, 1066577, 1067078, 1067578, 1068110, 1068611, 1069112, 1069642, 1070142, 1070674, 1071175, 1071675, 1072207, 1072709, 1073209, 1073740, 1074241, 1074741, 1075273, 1075773, 1076305, 1076807, 1077308, 1077839, 1078340, 1078840, 1079372, 1079871, 1080403, 1080904];
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    63: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      i.prototype = new n.baseCalendar(), a(i.prototype, {
        name: "Coptic",
        jdEpoch: 1825029.5,
        daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Coptic",
            epochs: ["BAM", "AM"],
            monthNames: ["Thout", "Paopi", "Hathor", "Koiak", "Tobi", "Meshir", "Paremhat", "Paremoude", "Pashons", "Paoni", "Epip", "Mesori", "Pi Kogi Enavot"],
            monthNamesShort: ["Tho", "Pao", "Hath", "Koi", "Tob", "Mesh", "Pat", "Pad", "Pash", "Pao", "Epi", "Meso", "PiK"],
            dayNames: ["Tkyriaka", "Pesnau", "Pshoment", "Peftoou", "Ptiou", "Psoou", "Psabbaton"],
            dayNamesShort: ["Tky", "Pes", "Psh", "Pef", "Pti", "Pso", "Psa"],
            dayNamesMin: ["Tk", "Pes", "Psh", "Pef", "Pt", "Pso", "Psa"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
          return (e = t.year() + (t.year() < 0 ? 1 : 0)) % 4 == 3 || e % 4 == -1;
        },
        monthsInYear: function monthsInYear(e) {
          return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(e, t) {
          var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
          return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(e, t, r) {
          return (this.dayOfWeek(e, t, r) || 7) < 6;
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          return (e = a.year()) < 0 && e++, a.day() + 30 * (a.month() - 1) + 365 * (e - 1) + Math.floor(e / 4) + this.jdEpoch - 1;
        },
        fromJD: function fromJD(e) {
          var t = Math.floor(e) + .5 - this.jdEpoch,
            r = Math.floor((t - Math.floor((t + 366) / 1461)) / 365) + 1;
          r <= 0 && r--, t = Math.floor(e) + .5 - this.newDate(r, 1, 1).toJD();
          var n = Math.floor(t / 30) + 1,
            a = t - 30 * (n - 1) + 1;
          return this.newDate(r, n, a);
        }
      }), n.calendars.coptic = i;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    64: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      i.prototype = new n.baseCalendar(), a(i.prototype, {
        name: "Discworld",
        jdEpoch: 1721425.5,
        daysPerMonth: [16, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Discworld",
            epochs: ["BUC", "UC"],
            monthNames: ["Ick", "Offle", "February", "March", "April", "May", "June", "Grune", "August", "Spune", "Sektober", "Ember", "December"],
            monthNamesShort: ["Ick", "Off", "Feb", "Mar", "Apr", "May", "Jun", "Gru", "Aug", "Spu", "Sek", "Emb", "Dec"],
            dayNames: ["Sunday", "Octeday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Oct", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Oc", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 2,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), !1;
        },
        monthsInYear: function monthsInYear(e) {
          return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 13;
        },
        daysInYear: function daysInYear(e) {
          return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 400;
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 8) + 1;
        },
        daysInMonth: function daysInMonth(e, t) {
          var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
          return this.daysPerMonth[r.month() - 1];
        },
        daysInWeek: function daysInWeek() {
          return 8;
        },
        dayOfWeek: function dayOfWeek(e, t, r) {
          return (this._validate(e, t, r, n.local.invalidDate).day() + 1) % 8;
        },
        weekDay: function weekDay(e, t, r) {
          var n = this.dayOfWeek(e, t, r);
          return n >= 2 && n <= 6;
        },
        extraInfo: function extraInfo(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          return {
            century: o[Math.floor((a.year() - 1) / 100) + 1] || ""
          };
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          return e = a.year() + (a.year() < 0 ? 1 : 0), t = a.month(), (r = a.day()) + (t > 1 ? 16 : 0) + (t > 2 ? 32 * (t - 2) : 0) + 400 * (e - 1) + this.jdEpoch - 1;
        },
        fromJD: function fromJD(e) {
          e = Math.floor(e + .5) - Math.floor(this.jdEpoch) - 1;
          var t = Math.floor(e / 400) + 1;
          e -= 400 * (t - 1), e += e > 15 ? 16 : 0;
          var r = Math.floor(e / 32) + 1,
            n = e - 32 * (r - 1) + 1;
          return this.newDate(t <= 0 ? t - 1 : t, r, n);
        }
      });
      var o = {
        20: "Fruitbat",
        21: "Anchovy"
      };
      n.calendars.discworld = i;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    65: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      i.prototype = new n.baseCalendar(), a(i.prototype, {
        name: "Ethiopian",
        jdEpoch: 1724220.5,
        daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Ethiopian",
            epochs: ["BEE", "EE"],
            monthNames: ["Meskerem", "Tikemet", "Hidar", "Tahesas", "Tir", "Yekatit", "Megabit", "Miazia", "Genbot", "Sene", "Hamle", "Nehase", "Pagume"],
            monthNamesShort: ["Mes", "Tik", "Hid", "Tah", "Tir", "Yek", "Meg", "Mia", "Gen", "Sen", "Ham", "Neh", "Pag"],
            dayNames: ["Ehud", "Segno", "Maksegno", "Irob", "Hamus", "Arb", "Kidame"],
            dayNamesShort: ["Ehu", "Seg", "Mak", "Iro", "Ham", "Arb", "Kid"],
            dayNamesMin: ["Eh", "Se", "Ma", "Ir", "Ha", "Ar", "Ki"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
          return (e = t.year() + (t.year() < 0 ? 1 : 0)) % 4 == 3 || e % 4 == -1;
        },
        monthsInYear: function monthsInYear(e) {
          return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(e, t) {
          var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
          return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(e, t, r) {
          return (this.dayOfWeek(e, t, r) || 7) < 6;
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          return (e = a.year()) < 0 && e++, a.day() + 30 * (a.month() - 1) + 365 * (e - 1) + Math.floor(e / 4) + this.jdEpoch - 1;
        },
        fromJD: function fromJD(e) {
          var t = Math.floor(e) + .5 - this.jdEpoch,
            r = Math.floor((t - Math.floor((t + 366) / 1461)) / 365) + 1;
          r <= 0 && r--, t = Math.floor(e) + .5 - this.newDate(r, 1, 1).toJD();
          var n = Math.floor(t / 30) + 1,
            a = t - 30 * (n - 1) + 1;
          return this.newDate(r, n, a);
        }
      }), n.calendars.ethiopian = i;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    66: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      function o(e, t) {
        return e - t * Math.floor(e / t);
      }
      i.prototype = new n.baseCalendar(), a(i.prototype, {
        name: "Hebrew",
        jdEpoch: 347995.5,
        daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 29],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 7,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Hebrew",
            epochs: ["BAM", "AM"],
            monthNames: ["Nisan", "Iyar", "Sivan", "Tammuz", "Av", "Elul", "Tishrei", "Cheshvan", "Kislev", "Tevet", "Shevat", "Adar", "Adar II"],
            monthNamesShort: ["Nis", "Iya", "Siv", "Tam", "Av", "Elu", "Tis", "Che", "Kis", "Tev", "She", "Ada", "Ad2"],
            dayNames: ["Yom Rishon", "Yom Sheni", "Yom Shlishi", "Yom Revi'i", "Yom Chamishi", "Yom Shishi", "Yom Shabbat"],
            dayNamesShort: ["Ris", "She", "Shl", "Rev", "Cha", "Shi", "Sha"],
            dayNamesMin: ["Ri", "She", "Shl", "Re", "Ch", "Shi", "Sha"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
          return this._leapYear(t.year());
        },
        _leapYear: function _leapYear(e) {
          return o(7 * (e = e < 0 ? e + 1 : e) + 1, 19) < 7;
        },
        monthsInYear: function monthsInYear(e) {
          return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), this._leapYear(e.year ? e.year() : e) ? 13 : 12;
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function daysInYear(e) {
          return e = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year(), this.toJD(-1 === e ? 1 : e + 1, 7, 1) - this.toJD(e, 7, 1);
        },
        daysInMonth: function daysInMonth(e, t) {
          return e.year && (t = e.month(), e = e.year()), this._validate(e, t, this.minDay, n.local.invalidMonth), 12 === t && this.leapYear(e) || 8 === t && 5 === o(this.daysInYear(e), 10) ? 30 : 9 === t && 3 === o(this.daysInYear(e), 10) ? 29 : this.daysPerMonth[t - 1];
        },
        weekDay: function weekDay(e, t, r) {
          return 6 !== this.dayOfWeek(e, t, r);
        },
        extraInfo: function extraInfo(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          return {
            yearType: (this.leapYear(a) ? "embolismic" : "common") + " " + ["deficient", "regular", "complete"][this.daysInYear(a) % 10 - 3]
          };
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          e = a.year(), t = a.month(), r = a.day();
          var i = e <= 0 ? e + 1 : e,
            o = this.jdEpoch + this._delay1(i) + this._delay2(i) + r + 1;
          if (t < 7) {
            for (var l = 7; l <= this.monthsInYear(e); l++) o += this.daysInMonth(e, l);
            for (l = 1; l < t; l++) o += this.daysInMonth(e, l);
          } else for (l = 7; l < t; l++) o += this.daysInMonth(e, l);
          return o;
        },
        _delay1: function _delay1(e) {
          var t = Math.floor((235 * e - 234) / 19),
            r = 12084 + 13753 * t,
            n = 29 * t + Math.floor(r / 25920);
          return o(3 * (n + 1), 7) < 3 && n++, n;
        },
        _delay2: function _delay2(e) {
          var t = this._delay1(e - 1),
            r = this._delay1(e);
          return this._delay1(e + 1) - r == 356 ? 2 : r - t == 382 ? 1 : 0;
        },
        fromJD: function fromJD(e) {
          e = Math.floor(e) + .5;
          for (var t = Math.floor(98496 * (e - this.jdEpoch) / 35975351) - 1; e >= this.toJD(-1 === t ? 1 : t + 1, 7, 1);) t++;
          for (var r = e < this.toJD(t, 1, 1) ? 7 : 1; e > this.toJD(t, r, this.daysInMonth(t, r));) r++;
          var n = e - this.toJD(t, r, 1) + 1;
          return this.newDate(t, r, n);
        }
      }), n.calendars.hebrew = i;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    67: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      i.prototype = new n.baseCalendar(), a(i.prototype, {
        name: "Islamic",
        jdEpoch: 1948439.5,
        daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Islamic",
            epochs: ["BH", "AH"],
            monthNames: ["Muharram", "Safar", "Rabi' al-awwal", "Rabi' al-thani", "Jumada al-awwal", "Jumada al-thani", "Rajab", "Sha'aban", "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"],
            monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"],
            dayNames: ["Yawm al-ahad", "Yawm al-ithnayn", "Yawm ath-thulaathaa'", "Yawm al-arbi'aa'", "Yawm al-kham\u012Bs", "Yawm al-jum'a", "Yawm as-sabt"],
            dayNamesShort: ["Aha", "Ith", "Thu", "Arb", "Kha", "Jum", "Sab"],
            dayNamesMin: ["Ah", "It", "Th", "Ar", "Kh", "Ju", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 6,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          return (11 * this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year() + 14) % 30 < 11;
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function daysInYear(e) {
          return this.leapYear(e) ? 355 : 354;
        },
        daysInMonth: function daysInMonth(e, t) {
          var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
          return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(e, t, r) {
          return 5 !== this.dayOfWeek(e, t, r);
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          return e = a.year(), t = a.month(), e = e <= 0 ? e + 1 : e, (r = a.day()) + Math.ceil(29.5 * (t - 1)) + 354 * (e - 1) + Math.floor((3 + 11 * e) / 30) + this.jdEpoch - 1;
        },
        fromJD: function fromJD(e) {
          e = Math.floor(e) + .5;
          var t = Math.floor((30 * (e - this.jdEpoch) + 10646) / 10631);
          t = t <= 0 ? t - 1 : t;
          var r = Math.min(12, Math.ceil((e - 29 - this.toJD(t, 1, 1)) / 29.5) + 1),
            n = e - this.toJD(t, r, 1) + 1;
          return this.newDate(t, r, n);
        }
      }), n.calendars.islamic = i;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    68: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      i.prototype = new n.baseCalendar(), a(i.prototype, {
        name: "Julian",
        jdEpoch: 1721423.5,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Julian",
            epochs: ["BC", "AD"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "mm/dd/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
          return (e = t.year() < 0 ? t.year() + 1 : t.year()) % 4 == 0;
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(e, t) {
          var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
          return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(e, t, r) {
          return (this.dayOfWeek(e, t, r) || 7) < 6;
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          return e = a.year(), t = a.month(), r = a.day(), e < 0 && e++, t <= 2 && (e--, t += 12), Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (t + 1)) + r - 1524.5;
        },
        fromJD: function fromJD(e) {
          var t = Math.floor(e + .5) + 1524,
            r = Math.floor((t - 122.1) / 365.25),
            n = Math.floor(365.25 * r),
            a = Math.floor((t - n) / 30.6001),
            i = a - Math.floor(a < 14 ? 1 : 13),
            o = r - Math.floor(i > 2 ? 4716 : 4715),
            l = t - n - Math.floor(30.6001 * a);
          return o <= 0 && o--, this.newDate(o, i, l);
        }
      }), n.calendars.julian = i;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    69: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      function o(e, t) {
        return e - t * Math.floor(e / t);
      }
      function l(e, t) {
        return o(e - 1, t) + 1;
      }
      i.prototype = new n.baseCalendar(), a(i.prototype, {
        name: "Mayan",
        jdEpoch: 584282.5,
        hasYearZero: !0,
        minMonth: 0,
        firstMonth: 0,
        minDay: 0,
        regionalOptions: {
          "": {
            name: "Mayan",
            epochs: ["", ""],
            monthNames: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"],
            monthNamesShort: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"],
            dayNames: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
            dayNamesShort: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
            dayNamesMin: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"],
            digits: null,
            dateFormat: "YYYY.m.d",
            firstDay: 0,
            isRTL: !1,
            haabMonths: ["Pop", "Uo", "Zip", "Zotz", "Tzec", "Xul", "Yaxkin", "Mol", "Chen", "Yax", "Zac", "Ceh", "Mac", "Kankin", "Muan", "Pax", "Kayab", "Cumku", "Uayeb"],
            tzolkinMonths: ["Imix", "Ik", "Akbal", "Kan", "Chicchan", "Cimi", "Manik", "Lamat", "Muluc", "Oc", "Chuen", "Eb", "Ben", "Ix", "Men", "Cib", "Caban", "Etznab", "Cauac", "Ahau"]
          }
        },
        leapYear: function leapYear(e) {
          return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), !1;
        },
        formatYear: function formatYear(e) {
          e = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year();
          var t = Math.floor(e / 400);
          return e %= 400, e += e < 0 ? 400 : 0, t + "." + Math.floor(e / 20) + "." + e % 20;
        },
        forYear: function forYear(e) {
          if ((e = e.split(".")).length < 3) throw "Invalid Mayan year";
          for (var t = 0, r = 0; r < e.length; r++) {
            var n = parseInt(e[r], 10);
            if (Math.abs(n) > 19 || r > 0 && n < 0) throw "Invalid Mayan year";
            t = 20 * t + n;
          }
          return t;
        },
        monthsInYear: function monthsInYear(e) {
          return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 18;
        },
        weekOfYear: function weekOfYear(e, t, r) {
          return this._validate(e, t, r, n.local.invalidDate), 0;
        },
        daysInYear: function daysInYear(e) {
          return this._validate(e, this.minMonth, this.minDay, n.local.invalidYear), 360;
        },
        daysInMonth: function daysInMonth(e, t) {
          return this._validate(e, t, this.minDay, n.local.invalidMonth), 20;
        },
        daysInWeek: function daysInWeek() {
          return 5;
        },
        dayOfWeek: function dayOfWeek(e, t, r) {
          return this._validate(e, t, r, n.local.invalidDate).day();
        },
        weekDay: function weekDay(e, t, r) {
          return this._validate(e, t, r, n.local.invalidDate), !0;
        },
        extraInfo: function extraInfo(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate).toJD(),
            i = this._toHaab(a),
            o = this._toTzolkin(a);
          return {
            haabMonthName: this.local.haabMonths[i[0] - 1],
            haabMonth: i[0],
            haabDay: i[1],
            tzolkinDayName: this.local.tzolkinMonths[o[0] - 1],
            tzolkinDay: o[0],
            tzolkinTrecena: o[1]
          };
        },
        _toHaab: function _toHaab(e) {
          var t = o((e -= this.jdEpoch) + 8 + 340, 365);
          return [Math.floor(t / 20) + 1, o(t, 20)];
        },
        _toTzolkin: function _toTzolkin(e) {
          return [l((e -= this.jdEpoch) + 20, 20), l(e + 4, 13)];
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          return a.day() + 20 * a.month() + 360 * a.year() + this.jdEpoch;
        },
        fromJD: function fromJD(e) {
          e = Math.floor(e) + .5 - this.jdEpoch;
          var t = Math.floor(e / 360);
          e %= 360, e += e < 0 ? 360 : 0;
          var r = Math.floor(e / 20),
            n = e % 20;
          return this.newDate(t, r, n);
        }
      }), n.calendars.mayan = i;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    70: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      i.prototype = new n.baseCalendar();
      var o = n.instance("gregorian");
      a(i.prototype, {
        name: "Nanakshahi",
        jdEpoch: 2257673.5,
        daysPerMonth: [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 30, 30],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Nanakshahi",
            epochs: ["BN", "AN"],
            monthNames: ["Chet", "Vaisakh", "Jeth", "Harh", "Sawan", "Bhadon", "Assu", "Katak", "Maghar", "Poh", "Magh", "Phagun"],
            monthNamesShort: ["Che", "Vai", "Jet", "Har", "Saw", "Bha", "Ass", "Kat", "Mgr", "Poh", "Mgh", "Pha"],
            dayNames: ["Somvaar", "Mangalvar", "Budhvaar", "Veervaar", "Shukarvaar", "Sanicharvaar", "Etvaar"],
            dayNamesShort: ["Som", "Mangal", "Budh", "Veer", "Shukar", "Sanichar", "Et"],
            dayNamesMin: ["So", "Ma", "Bu", "Ve", "Sh", "Sa", "Et"],
            digits: null,
            dateFormat: "dd-mm-yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear);
          return o.leapYear(t.year() + (t.year() < 1 ? 1 : 0) + 1469);
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(1 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(e, t) {
          var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
          return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(e, t, r) {
          return (this.dayOfWeek(e, t, r) || 7) < 6;
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidMonth);
          (e = a.year()) < 0 && e++;
          for (var i = a.day(), l = 1; l < a.month(); l++) i += this.daysPerMonth[l - 1];
          return i + o.toJD(e + 1468, 3, 13);
        },
        fromJD: function fromJD(e) {
          e = Math.floor(e + .5);
          for (var t = Math.floor((e - (this.jdEpoch - 1)) / 366); e >= this.toJD(t + 1, 1, 1);) t++;
          for (var r = e - Math.floor(this.toJD(t, 1, 1) + .5) + 1, n = 1; r > this.daysInMonth(t, n);) r -= this.daysInMonth(t, n), n++;
          return this.newDate(t, n, r);
        }
      }), n.calendars.nanakshahi = i;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    71: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      i.prototype = new n.baseCalendar(), a(i.prototype, {
        name: "Nepali",
        jdEpoch: 1700709.5,
        daysPerMonth: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        daysPerYear: 365,
        regionalOptions: {
          "": {
            name: "Nepali",
            epochs: ["BBS", "ABS"],
            monthNames: ["Baisakh", "Jestha", "Ashadh", "Shrawan", "Bhadra", "Ashwin", "Kartik", "Mangsir", "Paush", "Mangh", "Falgun", "Chaitra"],
            monthNamesShort: ["Bai", "Je", "As", "Shra", "Bha", "Ash", "Kar", "Mang", "Pau", "Ma", "Fal", "Chai"],
            dayNames: ["Aaitabaar", "Sombaar", "Manglbaar", "Budhabaar", "Bihibaar", "Shukrabaar", "Shanibaar"],
            dayNamesShort: ["Aaita", "Som", "Mangl", "Budha", "Bihi", "Shukra", "Shani"],
            dayNamesMin: ["Aai", "So", "Man", "Bu", "Bi", "Shu", "Sha"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 1,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          return this.daysInYear(e) !== this.daysPerYear;
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function daysInYear(e) {
          if (e = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear).year(), void 0 === this.NEPALI_CALENDAR_DATA[e]) return this.daysPerYear;
          for (var t = 0, r = this.minMonth; r <= 12; r++) t += this.NEPALI_CALENDAR_DATA[e][r];
          return t;
        },
        daysInMonth: function daysInMonth(e, t) {
          return e.year && (t = e.month(), e = e.year()), this._validate(e, t, this.minDay, n.local.invalidMonth), void 0 === this.NEPALI_CALENDAR_DATA[e] ? this.daysPerMonth[t - 1] : this.NEPALI_CALENDAR_DATA[e][t];
        },
        weekDay: function weekDay(e, t, r) {
          return 6 !== this.dayOfWeek(e, t, r);
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          e = a.year(), t = a.month(), r = a.day();
          var i = n.instance(),
            o = 0,
            l = t,
            s = e;
          this._createMissingCalendarData(e);
          var c = e - (l > 9 || 9 === l && r >= this.NEPALI_CALENDAR_DATA[s][0] ? 56 : 57);
          for (9 !== t && (o = r, l--); 9 !== l;) l <= 0 && (l = 12, s--), o += this.NEPALI_CALENDAR_DATA[s][l], l--;
          return 9 === t ? (o += r - this.NEPALI_CALENDAR_DATA[s][0]) < 0 && (o += i.daysInYear(c)) : o += this.NEPALI_CALENDAR_DATA[s][9] - this.NEPALI_CALENDAR_DATA[s][0], i.newDate(c, 1, 1).add(o, "d").toJD();
        },
        fromJD: function fromJD(e) {
          var t = n.instance().fromJD(e),
            r = t.year(),
            a = t.dayOfYear(),
            i = r + 56;
          this._createMissingCalendarData(i);
          for (var o = 9, l = this.NEPALI_CALENDAR_DATA[i][0], s = this.NEPALI_CALENDAR_DATA[i][o] - l + 1; a > s;) ++o > 12 && (o = 1, i++), s += this.NEPALI_CALENDAR_DATA[i][o];
          var c = this.NEPALI_CALENDAR_DATA[i][o] - (s - a);
          return this.newDate(i, o, c);
        },
        _createMissingCalendarData: function _createMissingCalendarData(e) {
          var t = this.daysPerMonth.slice(0);
          t.unshift(17);
          for (var r = e - 1; r < e + 2; r++) void 0 === this.NEPALI_CALENDAR_DATA[r] && (this.NEPALI_CALENDAR_DATA[r] = t);
        },
        NEPALI_CALENDAR_DATA: {
          1970: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1971: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          1972: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          1973: [19, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1974: [19, 31, 31, 32, 30, 31, 31, 30, 29, 30, 29, 30, 30],
          1975: [18, 31, 31, 32, 32, 30, 31, 30, 29, 30, 29, 30, 30],
          1976: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1977: [18, 31, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
          1978: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1979: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1980: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1981: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          1982: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1983: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1984: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1985: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          1986: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1987: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1988: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1989: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          1990: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1991: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1992: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1993: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          1994: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1995: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          1996: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1997: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1998: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1999: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2e3: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2001: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2002: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2003: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2004: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2005: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2006: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2007: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2008: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2009: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2010: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2011: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2012: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2013: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2014: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2015: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2016: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2017: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2018: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2019: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2020: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2021: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2022: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2023: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2024: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2025: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2026: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2027: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2028: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2029: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          2030: [17, 31, 32, 31, 32, 31, 30, 30, 30, 30, 30, 30, 31],
          2031: [17, 31, 32, 31, 32, 31, 31, 31, 31, 31, 31, 31, 31],
          2032: [17, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
          2033: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2034: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2035: [17, 30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2036: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2037: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2038: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2039: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2040: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2041: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2042: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2043: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2044: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2045: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2046: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2047: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2048: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2049: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2050: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2051: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2052: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2053: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2054: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2055: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 29, 30],
          2056: [17, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          2057: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2058: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2059: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2060: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2061: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2062: [17, 30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
          2063: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2064: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2065: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2066: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2067: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2068: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2069: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2070: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2071: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2072: [17, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2073: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2074: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2075: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2076: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2077: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2078: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2079: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2080: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2081: [17, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2082: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2083: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2084: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2085: [17, 31, 32, 31, 32, 31, 31, 30, 30, 29, 30, 30, 30],
          2086: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2087: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
          2088: [16, 30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
          2089: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2090: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2091: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
          2092: [16, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2093: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2094: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2095: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 30, 30],
          2096: [17, 30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2097: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2098: [17, 31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 30, 31],
          2099: [17, 31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30],
          2100: [17, 31, 32, 31, 32, 30, 31, 30, 29, 30, 29, 30, 30]
        }
      }), n.calendars.nepali = i;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    72: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      function o(e, t) {
        return e - t * Math.floor(e / t);
      }
      i.prototype = new n.baseCalendar(), a(i.prototype, {
        name: "Persian",
        jdEpoch: 1948320.5,
        daysPerMonth: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Persian",
            epochs: ["BP", "AP"],
            monthNames: ["Farvardin", "Ordibehesht", "Khordad", "Tir", "Mordad", "Shahrivar", "Mehr", "Aban", "Azar", "Day", "Bahman", "Esfand"],
            monthNamesShort: ["Far", "Ord", "Kho", "Tir", "Mor", "Sha", "Meh", "Aba", "Aza", "Day", "Bah", "Esf"],
            dayNames: ["Yekshambe", "Doshambe", "Seshambe", "Ch\xe6harshambe", "Panjshambe", "Jom'e", "Shambe"],
            dayNamesShort: ["Yek", "Do", "Se", "Ch\xe6", "Panj", "Jom", "Sha"],
            dayNamesMin: ["Ye", "Do", "Se", "Ch", "Pa", "Jo", "Sh"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 6,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
          return 682 * ((t.year() - (t.year() > 0 ? 474 : 473)) % 2820 + 474 + 38) % 2816 < 682;
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(-(n.dayOfWeek() + 1) % 7, "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(e, t) {
          var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
          return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(e, t, r) {
          return 5 !== this.dayOfWeek(e, t, r);
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          e = a.year(), t = a.month(), r = a.day();
          var i = e - (e >= 0 ? 474 : 473),
            l = 474 + o(i, 2820);
          return r + (t <= 7 ? 31 * (t - 1) : 30 * (t - 1) + 6) + Math.floor((682 * l - 110) / 2816) + 365 * (l - 1) + 1029983 * Math.floor(i / 2820) + this.jdEpoch - 1;
        },
        fromJD: function fromJD(e) {
          var t = (e = Math.floor(e) + .5) - this.toJD(475, 1, 1),
            r = Math.floor(t / 1029983),
            n = o(t, 1029983),
            a = 2820;
          if (1029982 !== n) {
            var i = Math.floor(n / 366),
              l = o(n, 366);
            a = Math.floor((2134 * i + 2816 * l + 2815) / 1028522) + i + 1;
          }
          var s = a + 2820 * r + 474;
          s = s <= 0 ? s - 1 : s;
          var c = e - this.toJD(s, 1, 1) + 1,
            u = c <= 186 ? Math.ceil(c / 31) : Math.ceil((c - 6) / 30),
            d = e - this.toJD(s, u, 1) + 1;
          return this.newDate(s, u, d);
        }
      }), n.calendars.persian = i, n.calendars.jalali = i;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    73: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign"),
        i = n.instance();
      function o(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      o.prototype = new n.baseCalendar(), a(o.prototype, {
        name: "Taiwan",
        jdEpoch: 2419402.5,
        yearsOffset: 1911,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Taiwan",
            epochs: ["BROC", "ROC"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 1,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
          e = this._t2gYear(t.year());
          return i.leapYear(e);
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var a = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
          e = this._t2gYear(a.year());
          return i.weekOfYear(e, a.month(), a.day());
        },
        daysInMonth: function daysInMonth(e, t) {
          var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
          return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(e, t, r) {
          return (this.dayOfWeek(e, t, r) || 7) < 6;
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          e = this._t2gYear(a.year());
          return i.toJD(e, a.month(), a.day());
        },
        fromJD: function fromJD(e) {
          var t = i.fromJD(e),
            r = this._g2tYear(t.year());
          return this.newDate(r, t.month(), t.day());
        },
        _t2gYear: function _t2gYear(e) {
          return e + this.yearsOffset + (e >= -this.yearsOffset && e <= -1 ? 1 : 0);
        },
        _g2tYear: function _g2tYear(e) {
          return e - this.yearsOffset - (e >= 1 && e <= this.yearsOffset ? 1 : 0);
        }
      }), n.calendars.taiwan = o;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    74: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign"),
        i = n.instance();
      function o(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      o.prototype = new n.baseCalendar(), a(o.prototype, {
        name: "Thai",
        jdEpoch: 1523098.5,
        yearsOffset: 543,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Thai",
            epochs: ["BBE", "BE"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "dd/mm/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
          e = this._t2gYear(t.year());
          return i.leapYear(e);
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var a = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
          e = this._t2gYear(a.year());
          return i.weekOfYear(e, a.month(), a.day());
        },
        daysInMonth: function daysInMonth(e, t) {
          var r = this._validate(e, t, this.minDay, n.local.invalidMonth);
          return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(e, t, r) {
          return (this.dayOfWeek(e, t, r) || 7) < 6;
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate);
          e = this._t2gYear(a.year());
          return i.toJD(e, a.month(), a.day());
        },
        fromJD: function fromJD(e) {
          var t = i.fromJD(e),
            r = this._g2tYear(t.year());
          return this.newDate(r, t.month(), t.day());
        },
        _t2gYear: function _t2gYear(e) {
          return e - this.yearsOffset - (e >= 1 && e <= this.yearsOffset ? 1 : 0);
        },
        _g2tYear: function _g2tYear(e) {
          return e + this.yearsOffset + (e >= -this.yearsOffset && e <= -1 ? 1 : 0);
        }
      }), n.calendars.thai = o;
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    75: [function (e, t, r) {
      var n = e("../main"),
        a = e("object-assign");
      function i(e) {
        this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
      }
      i.prototype = new n.baseCalendar(), a(i.prototype, {
        name: "UmmAlQura",
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Umm al-Qura",
            epochs: ["BH", "AH"],
            monthNames: ["Al-Muharram", "Safar", "Rabi' al-awwal", "Rabi' Al-Thani", "Jumada Al-Awwal", "Jumada Al-Thani", "Rajab", "Sha'aban", "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"],
            monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"],
            dayNames: ["Yawm al-Ahad", "Yawm al-Ithnain", "Yawm al-Thal\u0101th\u0101\u2019", "Yawm al-Arba\u2018\u0101\u2019", "Yawm al-Kham\u012Bs", "Yawm al-Jum\u2018a", "Yawm al-Sabt"],
            dayNamesMin: ["Ah", "Ith", "Th", "Ar", "Kh", "Ju", "Sa"],
            digits: null,
            dateFormat: "yyyy/mm/dd",
            firstDay: 6,
            isRTL: !0
          }
        },
        leapYear: function leapYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, n.local.invalidYear);
          return 355 === this.daysInYear(t.year());
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInYear: function daysInYear(e) {
          for (var t = 0, r = 1; r <= 12; r++) t += this.daysInMonth(e, r);
          return t;
        },
        daysInMonth: function daysInMonth(e, t) {
          for (var r = this._validate(e, t, this.minDay, n.local.invalidMonth).toJD() - 24e5 + .5, a = 0, i = 0; i < o.length; i++) {
            if (o[i] > r) return o[a] - o[a - 1];
            a++;
          }
          return 30;
        },
        weekDay: function weekDay(e, t, r) {
          return 5 !== this.dayOfWeek(e, t, r);
        },
        toJD: function toJD(e, t, r) {
          var a = this._validate(e, t, r, n.local.invalidDate),
            i = 12 * (a.year() - 1) + a.month() - 15292;
          return a.day() + o[i - 1] - 1 + 24e5 - .5;
        },
        fromJD: function fromJD(e) {
          for (var t = e - 24e5 + .5, r = 0, n = 0; n < o.length && !(o[n] > t); n++) r++;
          var a = r + 15292,
            i = Math.floor((a - 1) / 12),
            l = i + 1,
            s = a - 12 * i,
            c = t - o[r - 1] + 1;
          return this.newDate(l, s, c);
        },
        isValid: function isValid(e, t, r) {
          var a = n.baseCalendar.prototype.isValid.apply(this, arguments);
          return a && (a = (e = null != e.year ? e.year : e) >= 1276 && e <= 1500), a;
        },
        _validate: function _validate(e, t, r, a) {
          var i = n.baseCalendar.prototype._validate.apply(this, arguments);
          if (i.year < 1276 || i.year > 1500) throw a.replace(/\{0\}/, this.local.name);
          return i;
        }
      }), n.calendars.ummalqura = i;
      var o = [20, 50, 79, 109, 138, 168, 197, 227, 256, 286, 315, 345, 374, 404, 433, 463, 492, 522, 551, 581, 611, 641, 670, 700, 729, 759, 788, 818, 847, 877, 906, 936, 965, 995, 1024, 1054, 1083, 1113, 1142, 1172, 1201, 1231, 1260, 1290, 1320, 1350, 1379, 1409, 1438, 1468, 1497, 1527, 1556, 1586, 1615, 1645, 1674, 1704, 1733, 1763, 1792, 1822, 1851, 1881, 1910, 1940, 1969, 1999, 2028, 2058, 2087, 2117, 2146, 2176, 2205, 2235, 2264, 2294, 2323, 2353, 2383, 2413, 2442, 2472, 2501, 2531, 2560, 2590, 2619, 2649, 2678, 2708, 2737, 2767, 2796, 2826, 2855, 2885, 2914, 2944, 2973, 3003, 3032, 3062, 3091, 3121, 3150, 3180, 3209, 3239, 3268, 3298, 3327, 3357, 3386, 3416, 3446, 3476, 3505, 3535, 3564, 3594, 3623, 3653, 3682, 3712, 3741, 3771, 3800, 3830, 3859, 3889, 3918, 3948, 3977, 4007, 4036, 4066, 4095, 4125, 4155, 4185, 4214, 4244, 4273, 4303, 4332, 4362, 4391, 4421, 4450, 4480, 4509, 4539, 4568, 4598, 4627, 4657, 4686, 4716, 4745, 4775, 4804, 4834, 4863, 4893, 4922, 4952, 4981, 5011, 5040, 5070, 5099, 5129, 5158, 5188, 5218, 5248, 5277, 5307, 5336, 5366, 5395, 5425, 5454, 5484, 5513, 5543, 5572, 5602, 5631, 5661, 5690, 5720, 5749, 5779, 5808, 5838, 5867, 5897, 5926, 5956, 5985, 6015, 6044, 6074, 6103, 6133, 6162, 6192, 6221, 6251, 6281, 6311, 6340, 6370, 6399, 6429, 6458, 6488, 6517, 6547, 6576, 6606, 6635, 6665, 6694, 6724, 6753, 6783, 6812, 6842, 6871, 6901, 6930, 6960, 6989, 7019, 7048, 7078, 7107, 7137, 7166, 7196, 7225, 7255, 7284, 7314, 7344, 7374, 7403, 7433, 7462, 7492, 7521, 7551, 7580, 7610, 7639, 7669, 7698, 7728, 7757, 7787, 7816, 7846, 7875, 7905, 7934, 7964, 7993, 8023, 8053, 8083, 8112, 8142, 8171, 8201, 8230, 8260, 8289, 8319, 8348, 8378, 8407, 8437, 8466, 8496, 8525, 8555, 8584, 8614, 8643, 8673, 8702, 8732, 8761, 8791, 8821, 8850, 8880, 8909, 8938, 8968, 8997, 9027, 9056, 9086, 9115, 9145, 9175, 9205, 9234, 9264, 9293, 9322, 9352, 9381, 9410, 9440, 9470, 9499, 9529, 9559, 9589, 9618, 9648, 9677, 9706, 9736, 9765, 9794, 9824, 9853, 9883, 9913, 9943, 9972, 10002, 10032, 10061, 10090, 10120, 10149, 10178, 10208, 10237, 10267, 10297, 10326, 10356, 10386, 10415, 10445, 10474, 10504, 10533, 10562, 10592, 10621, 10651, 10680, 10710, 10740, 10770, 10799, 10829, 10858, 10888, 10917, 10947, 10976, 11005, 11035, 11064, 11094, 11124, 11153, 11183, 11213, 11242, 11272, 11301, 11331, 11360, 11389, 11419, 11448, 11478, 11507, 11537, 11567, 11596, 11626, 11655, 11685, 11715, 11744, 11774, 11803, 11832, 11862, 11891, 11921, 11950, 11980, 12010, 12039, 12069, 12099, 12128, 12158, 12187, 12216, 12246, 12275, 12304, 12334, 12364, 12393, 12423, 12453, 12483, 12512, 12542, 12571, 12600, 12630, 12659, 12688, 12718, 12747, 12777, 12807, 12837, 12866, 12896, 12926, 12955, 12984, 13014, 13043, 13072, 13102, 13131, 13161, 13191, 13220, 13250, 13280, 13310, 13339, 13368, 13398, 13427, 13456, 13486, 13515, 13545, 13574, 13604, 13634, 13664, 13693, 13723, 13752, 13782, 13811, 13840, 13870, 13899, 13929, 13958, 13988, 14018, 14047, 14077, 14107, 14136, 14166, 14195, 14224, 14254, 14283, 14313, 14342, 14372, 14401, 14431, 14461, 14490, 14520, 14550, 14579, 14609, 14638, 14667, 14697, 14726, 14756, 14785, 14815, 14844, 14874, 14904, 14933, 14963, 14993, 15021, 15051, 15081, 15110, 15140, 15169, 15199, 15228, 15258, 15287, 15317, 15347, 15377, 15406, 15436, 15465, 15494, 15524, 15553, 15582, 15612, 15641, 15671, 15701, 15731, 15760, 15790, 15820, 15849, 15878, 15908, 15937, 15966, 15996, 16025, 16055, 16085, 16114, 16144, 16174, 16204, 16233, 16262, 16292, 16321, 16350, 16380, 16409, 16439, 16468, 16498, 16528, 16558, 16587, 16617, 16646, 16676, 16705, 16734, 16764, 16793, 16823, 16852, 16882, 16912, 16941, 16971, 17001, 17030, 17060, 17089, 17118, 17148, 17177, 17207, 17236, 17266, 17295, 17325, 17355, 17384, 17414, 17444, 17473, 17502, 17532, 17561, 17591, 17620, 17650, 17679, 17709, 17738, 17768, 17798, 17827, 17857, 17886, 17916, 17945, 17975, 18004, 18034, 18063, 18093, 18122, 18152, 18181, 18211, 18241, 18270, 18300, 18330, 18359, 18388, 18418, 18447, 18476, 18506, 18535, 18565, 18595, 18625, 18654, 18684, 18714, 18743, 18772, 18802, 18831, 18860, 18890, 18919, 18949, 18979, 19008, 19038, 19068, 19098, 19127, 19156, 19186, 19215, 19244, 19274, 19303, 19333, 19362, 19392, 19422, 19452, 19481, 19511, 19540, 19570, 19599, 19628, 19658, 19687, 19717, 19746, 19776, 19806, 19836, 19865, 19895, 19924, 19954, 19983, 20012, 20042, 20071, 20101, 20130, 20160, 20190, 20219, 20249, 20279, 20308, 20338, 20367, 20396, 20426, 20455, 20485, 20514, 20544, 20573, 20603, 20633, 20662, 20692, 20721, 20751, 20780, 20810, 20839, 20869, 20898, 20928, 20957, 20987, 21016, 21046, 21076, 21105, 21135, 21164, 21194, 21223, 21253, 21282, 21312, 21341, 21371, 21400, 21430, 21459, 21489, 21519, 21548, 21578, 21607, 21637, 21666, 21696, 21725, 21754, 21784, 21813, 21843, 21873, 21902, 21932, 21962, 21991, 22021, 22050, 22080, 22109, 22138, 22168, 22197, 22227, 22256, 22286, 22316, 22346, 22375, 22405, 22434, 22464, 22493, 22522, 22552, 22581, 22611, 22640, 22670, 22700, 22730, 22759, 22789, 22818, 22848, 22877, 22906, 22936, 22965, 22994, 23024, 23054, 23083, 23113, 23143, 23173, 23202, 23232, 23261, 23290, 23320, 23349, 23379, 23408, 23438, 23467, 23497, 23527, 23556, 23586, 23616, 23645, 23674, 23704, 23733, 23763, 23792, 23822, 23851, 23881, 23910, 23940, 23970, 23999, 24029, 24058, 24088, 24117, 24147, 24176, 24206, 24235, 24265, 24294, 24324, 24353, 24383, 24413, 24442, 24472, 24501, 24531, 24560, 24590, 24619, 24648, 24678, 24707, 24737, 24767, 24796, 24826, 24856, 24885, 24915, 24944, 24974, 25003, 25032, 25062, 25091, 25121, 25150, 25180, 25210, 25240, 25269, 25299, 25328, 25358, 25387, 25416, 25446, 25475, 25505, 25534, 25564, 25594, 25624, 25653, 25683, 25712, 25742, 25771, 25800, 25830, 25859, 25888, 25918, 25948, 25977, 26007, 26037, 26067, 26096, 26126, 26155, 26184, 26214, 26243, 26272, 26302, 26332, 26361, 26391, 26421, 26451, 26480, 26510, 26539, 26568, 26598, 26627, 26656, 26686, 26715, 26745, 26775, 26805, 26834, 26864, 26893, 26923, 26952, 26982, 27011, 27041, 27070, 27099, 27129, 27159, 27188, 27218, 27248, 27277, 27307, 27336, 27366, 27395, 27425, 27454, 27484, 27513, 27542, 27572, 27602, 27631, 27661, 27691, 27720, 27750, 27779, 27809, 27838, 27868, 27897, 27926, 27956, 27985, 28015, 28045, 28074, 28104, 28134, 28163, 28193, 28222, 28252, 28281, 28310, 28340, 28369, 28399, 28428, 28458, 28488, 28517, 28547, 28577, 28607, 28636, 28665, 28695, 28724, 28754, 28783, 28813, 28843, 28872, 28901, 28931, 28960, 28990, 29019, 29049, 29078, 29108, 29137, 29167, 29196, 29226, 29255, 29285, 29315, 29345, 29375, 29404, 29434, 29463, 29492, 29522, 29551, 29580, 29610, 29640, 29669, 29699, 29729, 29759, 29788, 29818, 29847, 29876, 29906, 29935, 29964, 29994, 30023, 30053, 30082, 30112, 30141, 30171, 30200, 30230, 30259, 30289, 30318, 30348, 30378, 30408, 30437, 30467, 30496, 30526, 30555, 30585, 30614, 30644, 30673, 30703, 30732, 30762, 30791, 30821, 30850, 30880, 30909, 30939, 30968, 30998, 31027, 31057, 31086, 31116, 31145, 31175, 31204, 31234, 31263, 31293, 31322, 31352, 31381, 31411, 31441, 31471, 31500, 31530, 31559, 31589, 31618, 31648, 31676, 31706, 31736, 31766, 31795, 31825, 31854, 31884, 31913, 31943, 31972, 32002, 32031, 32061, 32090, 32120, 32150, 32180, 32209, 32239, 32268, 32298, 32327, 32357, 32386, 32416, 32445, 32475, 32504, 32534, 32563, 32593, 32622, 32652, 32681, 32711, 32740, 32770, 32799, 32829, 32858, 32888, 32917, 32947, 32976, 33006, 33035, 33065, 33094, 33124, 33153, 33183, 33213, 33243, 33272, 33302, 33331, 33361, 33390, 33420, 33450, 33479, 33509, 33539, 33568, 33598, 33627, 33657, 33686, 33716, 33745, 33775, 33804, 33834, 33863, 33893, 33922, 33952, 33981, 34011, 34040, 34069, 34099, 34128, 34158, 34187, 34217, 34247, 34277, 34306, 34336, 34365, 34395, 34424, 34454, 34483, 34512, 34542, 34571, 34601, 34631, 34660, 34690, 34719, 34749, 34778, 34808, 34837, 34867, 34896, 34926, 34955, 34985, 35015, 35044, 35074, 35103, 35133, 35162, 35192, 35222, 35251, 35280, 35310, 35340, 35370, 35399, 35429, 35458, 35488, 35517, 35547, 35576, 35605, 35635, 35665, 35694, 35723, 35753, 35782, 35811, 35841, 35871, 35901, 35930, 35960, 35989, 36019, 36048, 36078, 36107, 36136, 36166, 36195, 36225, 36254, 36284, 36314, 36343, 36373, 36403, 36433, 36462, 36492, 36521, 36551, 36580, 36610, 36639, 36669, 36698, 36728, 36757, 36786, 36816, 36845, 36875, 36904, 36934, 36963, 36993, 37022, 37052, 37081, 37111, 37141, 37170, 37200, 37229, 37259, 37288, 37318, 37347, 37377, 37406, 37436, 37465, 37495, 37524, 37554, 37584, 37613, 37643, 37672, 37701, 37731, 37760, 37790, 37819, 37849, 37878, 37908, 37938, 37967, 37997, 38027, 38056, 38085, 38115, 38144, 38174, 38203, 38233, 38262, 38292, 38322, 38351, 38381, 38410, 38440, 38469, 38499, 38528, 38558, 38587, 38617, 38646, 38676, 38705, 38735, 38764, 38794, 38823, 38853, 38882, 38912, 38941, 38971, 39001, 39030, 39059, 39089, 39118, 39148, 39178, 39208, 39237, 39267, 39297, 39326, 39355, 39385, 39414, 39444, 39473, 39503, 39532, 39562, 39592, 39621, 39650, 39680, 39709, 39739, 39768, 39798, 39827, 39857, 39886, 39916, 39946, 39975, 40005, 40035, 40064, 40094, 40123, 40153, 40182, 40212, 40241, 40271, 40300, 40330, 40359, 40389, 40418, 40448, 40477, 40507, 40536, 40566, 40595, 40625, 40655, 40685, 40714, 40744, 40773, 40803, 40832, 40862, 40892, 40921, 40951, 40980, 41009, 41039, 41068, 41098, 41127, 41157, 41186, 41216, 41245, 41275, 41304, 41334, 41364, 41393, 41422, 41452, 41481, 41511, 41540, 41570, 41599, 41629, 41658, 41688, 41718, 41748, 41777, 41807, 41836, 41865, 41894, 41924, 41953, 41983, 42012, 42042, 42072, 42102, 42131, 42161, 42190, 42220, 42249, 42279, 42308, 42337, 42367, 42397, 42426, 42456, 42485, 42515, 42545, 42574, 42604, 42633, 42662, 42692, 42721, 42751, 42780, 42810, 42839, 42869, 42899, 42929, 42958, 42988, 43017, 43046, 43076, 43105, 43135, 43164, 43194, 43223, 43253, 43283, 43312, 43342, 43371, 43401, 43430, 43460, 43489, 43519, 43548, 43578, 43607, 43637, 43666, 43696, 43726, 43755, 43785, 43814, 43844, 43873, 43903, 43932, 43962, 43991, 44021, 44050, 44080, 44109, 44139, 44169, 44198, 44228, 44258, 44287, 44317, 44346, 44375, 44405, 44434, 44464, 44493, 44523, 44553, 44582, 44612, 44641, 44671, 44700, 44730, 44759, 44788, 44818, 44847, 44877, 44906, 44936, 44966, 44996, 45025, 45055, 45084, 45114, 45143, 45172, 45202, 45231, 45261, 45290, 45320, 45350, 45380, 45409, 45439, 45468, 45498, 45527, 45556, 45586, 45615, 45644, 45674, 45704, 45733, 45763, 45793, 45823, 45852, 45882, 45911, 45940, 45970, 45999, 46028, 46058, 46088, 46117, 46147, 46177, 46206, 46236, 46265, 46295, 46324, 46354, 46383, 46413, 46442, 46472, 46501, 46531, 46560, 46590, 46620, 46649, 46679, 46708, 46738, 46767, 46797, 46826, 46856, 46885, 46915, 46944, 46974, 47003, 47033, 47063, 47092, 47122, 47151, 47181, 47210, 47240, 47269, 47298, 47328, 47357, 47387, 47417, 47446, 47476, 47506, 47535, 47565, 47594, 47624, 47653, 47682, 47712, 47741, 47771, 47800, 47830, 47860, 47890, 47919, 47949, 47978, 48008, 48037, 48066, 48096, 48125, 48155, 48184, 48214, 48244, 48273, 48303, 48333, 48362, 48392, 48421, 48450, 48480, 48509, 48538, 48568, 48598, 48627, 48657, 48687, 48717, 48746, 48776, 48805, 48834, 48864, 48893, 48922, 48952, 48982, 49011, 49041, 49071, 49100, 49130, 49160, 49189, 49218, 49248, 49277, 49306, 49336, 49365, 49395, 49425, 49455, 49484, 49514, 49543, 49573, 49602, 49632, 49661, 49690, 49720, 49749, 49779, 49809, 49838, 49868, 49898, 49927, 49957, 49986, 50016, 50045, 50075, 50104, 50133, 50163, 50192, 50222, 50252, 50281, 50311, 50340, 50370, 50400, 50429, 50459, 50488, 50518, 50547, 50576, 50606, 50635, 50665, 50694, 50724, 50754, 50784, 50813, 50843, 50872, 50902, 50931, 50960, 50990, 51019, 51049, 51078, 51108, 51138, 51167, 51197, 51227, 51256, 51286, 51315, 51345, 51374, 51403, 51433, 51462, 51492, 51522, 51552, 51582, 51611, 51641, 51670, 51699, 51729, 51758, 51787, 51816, 51846, 51876, 51906, 51936, 51965, 51995, 52025, 52054, 52083, 52113, 52142, 52171, 52200, 52230, 52260, 52290, 52319, 52349, 52379, 52408, 52438, 52467, 52497, 52526, 52555, 52585, 52614, 52644, 52673, 52703, 52733, 52762, 52792, 52822, 52851, 52881, 52910, 52939, 52969, 52998, 53028, 53057, 53087, 53116, 53146, 53176, 53205, 53235, 53264, 53294, 53324, 53353, 53383, 53412, 53441, 53471, 53500, 53530, 53559, 53589, 53619, 53648, 53678, 53708, 53737, 53767, 53796, 53825, 53855, 53884, 53913, 53943, 53973, 54003, 54032, 54062, 54092, 54121, 54151, 54180, 54209, 54239, 54268, 54297, 54327, 54357, 54387, 54416, 54446, 54476, 54505, 54535, 54564, 54593, 54623, 54652, 54681, 54711, 54741, 54770, 54800, 54830, 54859, 54889, 54919, 54948, 54977, 55007, 55036, 55066, 55095, 55125, 55154, 55184, 55213, 55243, 55273, 55302, 55332, 55361, 55391, 55420, 55450, 55479, 55508, 55538, 55567, 55597, 55627, 55657, 55686, 55716, 55745, 55775, 55804, 55834, 55863, 55892, 55922, 55951, 55981, 56011, 56040, 56070, 56100, 56129, 56159, 56188, 56218, 56247, 56276, 56306, 56335, 56365, 56394, 56424, 56454, 56483, 56513, 56543, 56572, 56601, 56631, 56660, 56690, 56719, 56749, 56778, 56808, 56837, 56867, 56897, 56926, 56956, 56985, 57015, 57044, 57074, 57103, 57133, 57162, 57192, 57221, 57251, 57280, 57310, 57340, 57369, 57399, 57429, 57458, 57487, 57517, 57546, 57576, 57605, 57634, 57664, 57694, 57723, 57753, 57783, 57813, 57842, 57871, 57901, 57930, 57959, 57989, 58018, 58048, 58077, 58107, 58137, 58167, 58196, 58226, 58255, 58285, 58314, 58343, 58373, 58402, 58432, 58461, 58491, 58521, 58551, 58580, 58610, 58639, 58669, 58698, 58727, 58757, 58786, 58816, 58845, 58875, 58905, 58934, 58964, 58994, 59023, 59053, 59082, 59111, 59141, 59170, 59200, 59229, 59259, 59288, 59318, 59348, 59377, 59407, 59436, 59466, 59495, 59525, 59554, 59584, 59613, 59643, 59672, 59702, 59731, 59761, 59791, 59820, 59850, 59879, 59909, 59939, 59968, 59997, 60027, 60056, 60086, 60115, 60145, 60174, 60204, 60234, 60264, 60293, 60323, 60352, 60381, 60411, 60440, 60469, 60499, 60528, 60558, 60588, 60618, 60648, 60677, 60707, 60736, 60765, 60795, 60824, 60853, 60883, 60912, 60942, 60972, 61002, 61031, 61061, 61090, 61120, 61149, 61179, 61208, 61237, 61267, 61296, 61326, 61356, 61385, 61415, 61445, 61474, 61504, 61533, 61563, 61592, 61621, 61651, 61680, 61710, 61739, 61769, 61799, 61828, 61858, 61888, 61917, 61947, 61976, 62006, 62035, 62064, 62094, 62123, 62153, 62182, 62212, 62242, 62271, 62301, 62331, 62360, 62390, 62419, 62448, 62478, 62507, 62537, 62566, 62596, 62625, 62655, 62685, 62715, 62744, 62774, 62803, 62832, 62862, 62891, 62921, 62950, 62980, 63009, 63039, 63069, 63099, 63128, 63157, 63187, 63216, 63246, 63275, 63305, 63334, 63363, 63393, 63423, 63453, 63482, 63512, 63541, 63571, 63600, 63630, 63659, 63689, 63718, 63747, 63777, 63807, 63836, 63866, 63895, 63925, 63955, 63984, 64014, 64043, 64073, 64102, 64131, 64161, 64190, 64220, 64249, 64279, 64309, 64339, 64368, 64398, 64427, 64457, 64486, 64515, 64545, 64574, 64603, 64633, 64663, 64692, 64722, 64752, 64782, 64811, 64841, 64870, 64899, 64929, 64958, 64987, 65017, 65047, 65076, 65106, 65136, 65166, 65195, 65225, 65254, 65283, 65313, 65342, 65371, 65401, 65431, 65460, 65490, 65520, 65549, 65579, 65608, 65638, 65667, 65697, 65726, 65755, 65785, 65815, 65844, 65874, 65903, 65933, 65963, 65992, 66022, 66051, 66081, 66110, 66140, 66169, 66199, 66228, 66258, 66287, 66317, 66346, 66376, 66405, 66435, 66465, 66494, 66524, 66553, 66583, 66612, 66641, 66671, 66700, 66730, 66760, 66789, 66819, 66849, 66878, 66908, 66937, 66967, 66996, 67025, 67055, 67084, 67114, 67143, 67173, 67203, 67233, 67262, 67292, 67321, 67351, 67380, 67409, 67439, 67468, 67497, 67527, 67557, 67587, 67617, 67646, 67676, 67705, 67735, 67764, 67793, 67823, 67852, 67882, 67911, 67941, 67971, 68e3, 68030, 68060, 68089, 68119, 68148, 68177, 68207, 68236, 68266, 68295, 68325, 68354, 68384, 68414, 68443, 68473, 68502, 68532, 68561, 68591, 68620, 68650, 68679, 68708, 68738, 68768, 68797, 68827, 68857, 68886, 68916, 68946, 68975, 69004, 69034, 69063, 69092, 69122, 69152, 69181, 69211, 69240, 69270, 69300, 69330, 69359, 69388, 69418, 69447, 69476, 69506, 69535, 69565, 69595, 69624, 69654, 69684, 69713, 69743, 69772, 69802, 69831, 69861, 69890, 69919, 69949, 69978, 70008, 70038, 70067, 70097, 70126, 70156, 70186, 70215, 70245, 70274, 70303, 70333, 70362, 70392, 70421, 70451, 70481, 70510, 70540, 70570, 70599, 70629, 70658, 70687, 70717, 70746, 70776, 70805, 70835, 70864, 70894, 70924, 70954, 70983, 71013, 71042, 71071, 71101, 71130, 71159, 71189, 71218, 71248, 71278, 71308, 71337, 71367, 71397, 71426, 71455, 71485, 71514, 71543, 71573, 71602, 71632, 71662, 71691, 71721, 71751, 71781, 71810, 71839, 71869, 71898, 71927, 71957, 71986, 72016, 72046, 72075, 72105, 72135, 72164, 72194, 72223, 72253, 72282, 72311, 72341, 72370, 72400, 72429, 72459, 72489, 72518, 72548, 72577, 72607, 72637, 72666, 72695, 72725, 72754, 72784, 72813, 72843, 72872, 72902, 72931, 72961, 72991, 73020, 73050, 73080, 73109, 73139, 73168, 73197, 73227, 73256, 73286, 73315, 73345, 73375, 73404, 73434, 73464, 73493, 73523, 73552, 73581, 73611, 73640, 73669, 73699, 73729, 73758, 73788, 73818, 73848, 73877, 73907, 73936, 73965, 73995, 74024, 74053, 74083, 74113, 74142, 74172, 74202, 74231, 74261, 74291, 74320, 74349, 74379, 74408, 74437, 74467, 74497, 74526, 74556, 74586, 74615, 74645, 74675, 74704, 74733, 74763, 74792, 74822, 74851, 74881, 74910, 74940, 74969, 74999, 75029, 75058, 75088, 75117, 75147, 75176, 75206, 75235, 75264, 75294, 75323, 75353, 75383, 75412, 75442, 75472, 75501, 75531, 75560, 75590, 75619, 75648, 75678, 75707, 75737, 75766, 75796, 75826, 75856, 75885, 75915, 75944, 75974, 76003, 76032, 76062, 76091, 76121, 76150, 76180, 76210, 76239, 76269, 76299, 76328, 76358, 76387, 76416, 76446, 76475, 76505, 76534, 76564, 76593, 76623, 76653, 76682, 76712, 76741, 76771, 76801, 76830, 76859, 76889, 76918, 76948, 76977, 77007, 77036, 77066, 77096, 77125, 77155, 77185, 77214, 77243, 77273, 77302, 77332, 77361, 77390, 77420, 77450, 77479, 77509, 77539, 77569, 77598, 77627, 77657, 77686, 77715, 77745, 77774, 77804, 77833, 77863, 77893, 77923, 77952, 77982, 78011, 78041, 78070, 78099, 78129, 78158, 78188, 78217, 78247, 78277, 78307, 78336, 78366, 78395, 78425, 78454, 78483, 78513, 78542, 78572, 78601, 78631, 78661, 78690, 78720, 78750, 78779, 78808, 78838, 78867, 78897, 78926, 78956, 78985, 79015, 79044, 79074, 79104, 79133, 79163, 79192, 79222, 79251, 79281, 79310, 79340, 79369, 79399, 79428, 79458, 79487, 79517, 79546, 79576, 79606, 79635, 79665, 79695, 79724, 79753, 79783, 79812, 79841, 79871, 79900, 79930, 79960, 79990];
    }, {
      "../main": 76,
      "object-assign": 49
    }],
    76: [function (e, t, r) {
      var n = e("object-assign");
      function a() {
        this.regionalOptions = [], this.regionalOptions[""] = {
          invalidCalendar: "Calendar {0} not found",
          invalidDate: "Invalid {0} date",
          invalidMonth: "Invalid {0} month",
          invalidYear: "Invalid {0} year",
          differentCalendars: "Cannot mix {0} and {1} dates"
        }, this.local = this.regionalOptions[""], this.calendars = {}, this._localCals = {};
      }
      function i(e, t, r, n) {
        if (this._calendar = e, this._year = t, this._month = r, this._day = n, 0 === this._calendar._validateLevel && !this._calendar.isValid(this._year, this._month, this._day)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
      }
      function o(e, t) {
        return "000000".substring(0, t - (e = "" + e).length) + e;
      }
      function l() {
        this.shortYearCutoff = "+10";
      }
      function s(e) {
        this.local = this.regionalOptions[e] || this.regionalOptions[""];
      }
      n(a.prototype, {
        instance: function instance(e, t) {
          e = (e || "gregorian").toLowerCase(), t = t || "";
          var r = this._localCals[e + "-" + t];
          if (!r && this.calendars[e] && (r = new this.calendars[e](t), this._localCals[e + "-" + t] = r), !r) throw (this.local.invalidCalendar || this.regionalOptions[""].invalidCalendar).replace(/\{0\}/, e);
          return r;
        },
        newDate: function newDate(e, t, r, n, a) {
          return (n = (null != e && e.year ? e.calendar() : "string" == typeof n ? this.instance(n, a) : n) || this.instance()).newDate(e, t, r);
        },
        substituteDigits: function substituteDigits(e) {
          return function (t) {
            return (t + "").replace(/[0-9]/g, function (t) {
              return e[t];
            });
          };
        },
        substituteChineseDigits: function substituteChineseDigits(e, t) {
          return function (r) {
            for (var n = "", a = 0; r > 0;) {
              var i = r % 10;
              n = (0 === i ? "" : e[i] + t[a]) + n, a++, r = Math.floor(r / 10);
            }
            return 0 === n.indexOf(e[1] + t[1]) && (n = n.substr(1)), n || e[0];
          };
        }
      }), n(i.prototype, {
        newDate: function newDate(e, t, r) {
          return this._calendar.newDate(null == e ? this : e, t, r);
        },
        year: function year(e) {
          return 0 === arguments.length ? this._year : this.set(e, "y");
        },
        month: function month(e) {
          return 0 === arguments.length ? this._month : this.set(e, "m");
        },
        day: function day(e) {
          return 0 === arguments.length ? this._day : this.set(e, "d");
        },
        date: function date(e, t, r) {
          if (!this._calendar.isValid(e, t, r)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
          return this._year = e, this._month = t, this._day = r, this;
        },
        leapYear: function leapYear() {
          return this._calendar.leapYear(this);
        },
        epoch: function epoch() {
          return this._calendar.epoch(this);
        },
        formatYear: function formatYear() {
          return this._calendar.formatYear(this);
        },
        monthOfYear: function monthOfYear() {
          return this._calendar.monthOfYear(this);
        },
        weekOfYear: function weekOfYear() {
          return this._calendar.weekOfYear(this);
        },
        daysInYear: function daysInYear() {
          return this._calendar.daysInYear(this);
        },
        dayOfYear: function dayOfYear() {
          return this._calendar.dayOfYear(this);
        },
        daysInMonth: function daysInMonth() {
          return this._calendar.daysInMonth(this);
        },
        dayOfWeek: function dayOfWeek() {
          return this._calendar.dayOfWeek(this);
        },
        weekDay: function weekDay() {
          return this._calendar.weekDay(this);
        },
        extraInfo: function extraInfo() {
          return this._calendar.extraInfo(this);
        },
        add: function add(e, t) {
          return this._calendar.add(this, e, t);
        },
        set: function set(e, t) {
          return this._calendar.set(this, e, t);
        },
        compareTo: function compareTo(e) {
          if (this._calendar.name !== e._calendar.name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, e._calendar.local.name);
          var t = this._year !== e._year ? this._year - e._year : this._month !== e._month ? this.monthOfYear() - e.monthOfYear() : this._day - e._day;
          return 0 === t ? 0 : t < 0 ? -1 : 1;
        },
        calendar: function calendar() {
          return this._calendar;
        },
        toJD: function toJD() {
          return this._calendar.toJD(this);
        },
        fromJD: function fromJD(e) {
          return this._calendar.fromJD(e);
        },
        toJSDate: function toJSDate() {
          return this._calendar.toJSDate(this);
        },
        fromJSDate: function fromJSDate(e) {
          return this._calendar.fromJSDate(e);
        },
        toString: function toString() {
          return (this.year() < 0 ? "-" : "") + o(Math.abs(this.year()), 4) + "-" + o(this.month(), 2) + "-" + o(this.day(), 2);
        }
      }), n(l.prototype, {
        _validateLevel: 0,
        newDate: function newDate(e, t, r) {
          return null == e ? this.today() : (e.year && (this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), r = e.day(), t = e.month(), e = e.year()), new i(this, e, t, r));
        },
        today: function today() {
          return this.fromJSDate(new Date());
        },
        epoch: function epoch(e) {
          return this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear).year() < 0 ? this.local.epochs[0] : this.local.epochs[1];
        },
        formatYear: function formatYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
          return (t.year() < 0 ? "-" : "") + o(Math.abs(t.year()), 4);
        },
        monthsInYear: function monthsInYear(e) {
          return this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear), 12;
        },
        monthOfYear: function monthOfYear(e, t) {
          var r = this._validate(e, t, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);
          return (r.month() + this.monthsInYear(r) - this.firstMonth) % this.monthsInYear(r) + this.minMonth;
        },
        fromMonthOfYear: function fromMonthOfYear(e, t) {
          var r = (t + this.firstMonth - 2 * this.minMonth) % this.monthsInYear(e) + this.minMonth;
          return this._validate(e, r, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth), r;
        },
        daysInYear: function daysInYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
          return this.leapYear(t) ? 366 : 365;
        },
        dayOfYear: function dayOfYear(e, t, r) {
          var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
          return n.toJD() - this.newDate(n.year(), this.fromMonthOfYear(n.year(), this.minMonth), this.minDay).toJD() + 1;
        },
        daysInWeek: function daysInWeek() {
          return 7;
        },
        dayOfWeek: function dayOfWeek(e, t, r) {
          var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
          return (Math.floor(this.toJD(n)) + 2) % this.daysInWeek();
        },
        extraInfo: function extraInfo(e, t, r) {
          return this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), {};
        },
        add: function add(e, t, r) {
          return this._validate(e, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate), this._correctAdd(e, this._add(e, t, r), t, r);
        },
        _add: function _add(e, t, r) {
          if (this._validateLevel++, "d" === r || "w" === r) {
            var n = e.toJD() + t * ("w" === r ? this.daysInWeek() : 1),
              a = e.calendar().fromJD(n);
            return this._validateLevel--, [a.year(), a.month(), a.day()];
          }
          try {
            var i = e.year() + ("y" === r ? t : 0),
              o = e.monthOfYear() + ("m" === r ? t : 0);
            a = e.day();
            "y" === r ? (e.month() !== this.fromMonthOfYear(i, o) && (o = this.newDate(i, e.month(), this.minDay).monthOfYear()), o = Math.min(o, this.monthsInYear(i)), a = Math.min(a, this.daysInMonth(i, this.fromMonthOfYear(i, o)))) : "m" === r && (!function (e) {
              for (; o < e.minMonth;) i--, o += e.monthsInYear(i);
              for (var t = e.monthsInYear(i); o > t - 1 + e.minMonth;) i++, o -= t, t = e.monthsInYear(i);
            }(this), a = Math.min(a, this.daysInMonth(i, this.fromMonthOfYear(i, o))));
            var l = [i, this.fromMonthOfYear(i, o), a];
            return this._validateLevel--, l;
          } catch (e) {
            throw this._validateLevel--, e;
          }
        },
        _correctAdd: function _correctAdd(e, t, r, n) {
          if (!(this.hasYearZero || "y" !== n && "m" !== n || 0 !== t[0] && e.year() > 0 == t[0] > 0)) {
            var a = {
                y: [1, 1, "y"],
                m: [1, this.monthsInYear(-1), "m"],
                w: [this.daysInWeek(), this.daysInYear(-1), "d"],
                d: [1, this.daysInYear(-1), "d"]
              }[n],
              i = r < 0 ? -1 : 1;
            t = this._add(e, r * a[0] + i * a[1], a[2]);
          }
          return e.date(t[0], t[1], t[2]);
        },
        set: function set(e, t, r) {
          this._validate(e, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate);
          var n = "y" === r ? t : e.year(),
            a = "m" === r ? t : e.month(),
            i = "d" === r ? t : e.day();
          return "y" !== r && "m" !== r || (i = Math.min(i, this.daysInMonth(n, a))), e.date(n, a, i);
        },
        isValid: function isValid(e, t, r) {
          this._validateLevel++;
          var n = this.hasYearZero || 0 !== e;
          if (n) {
            var a = this.newDate(e, t, this.minDay);
            n = t >= this.minMonth && t - this.minMonth < this.monthsInYear(a) && r >= this.minDay && r - this.minDay < this.daysInMonth(a);
          }
          return this._validateLevel--, n;
        },
        toJSDate: function toJSDate(e, t, r) {
          var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
          return c.instance().fromJD(this.toJD(n)).toJSDate();
        },
        fromJSDate: function fromJSDate(e) {
          return this.fromJD(c.instance().fromJSDate(e).toJD());
        },
        _validate: function _validate(e, t, r, n) {
          if (e.year) {
            if (0 === this._validateLevel && this.name !== e.calendar().name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this.local.name).replace(/\{1\}/, e.calendar().local.name);
            return e;
          }
          try {
            if (this._validateLevel++, 1 === this._validateLevel && !this.isValid(e, t, r)) throw n.replace(/\{0\}/, this.local.name);
            var a = this.newDate(e, t, r);
            return this._validateLevel--, a;
          } catch (e) {
            throw this._validateLevel--, e;
          }
        }
      }), s.prototype = new l(), n(s.prototype, {
        name: "Gregorian",
        jdEpoch: 1721425.5,
        daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        hasYearZero: !1,
        minMonth: 1,
        firstMonth: 1,
        minDay: 1,
        regionalOptions: {
          "": {
            name: "Gregorian",
            epochs: ["BCE", "CE"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            digits: null,
            dateFormat: "mm/dd/yyyy",
            firstDay: 0,
            isRTL: !1
          }
        },
        leapYear: function leapYear(e) {
          var t = this._validate(e, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
          return (e = t.year() + (t.year() < 0 ? 1 : 0)) % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
        },
        weekOfYear: function weekOfYear(e, t, r) {
          var n = this.newDate(e, t, r);
          return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
        },
        daysInMonth: function daysInMonth(e, t) {
          var r = this._validate(e, t, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);
          return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
        },
        weekDay: function weekDay(e, t, r) {
          return (this.dayOfWeek(e, t, r) || 7) < 6;
        },
        toJD: function toJD(e, t, r) {
          var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
          e = n.year(), t = n.month(), r = n.day(), e < 0 && e++, t < 3 && (t += 12, e--);
          var a = Math.floor(e / 100),
            i = 2 - a + Math.floor(a / 4);
          return Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (t + 1)) + r + i - 1524.5;
        },
        fromJD: function fromJD(e) {
          var t = Math.floor(e + .5),
            r = Math.floor((t - 1867216.25) / 36524.25),
            n = (r = t + 1 + r - Math.floor(r / 4)) + 1524,
            a = Math.floor((n - 122.1) / 365.25),
            i = Math.floor(365.25 * a),
            o = Math.floor((n - i) / 30.6001),
            l = n - i - Math.floor(30.6001 * o),
            s = o - (o > 13.5 ? 13 : 1),
            c = a - (s > 2.5 ? 4716 : 4715);
          return c <= 0 && c--, this.newDate(c, s, l);
        },
        toJSDate: function toJSDate(e, t, r) {
          var n = this._validate(e, t, r, c.local.invalidDate || c.regionalOptions[""].invalidDate),
            a = new Date(n.year(), n.month() - 1, n.day());
          return a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0), a.setHours(a.getHours() > 12 ? a.getHours() + 2 : 0), a;
        },
        fromJSDate: function fromJSDate(e) {
          return this.newDate(e.getFullYear(), e.getMonth() + 1, e.getDate());
        }
      });
      var c = t.exports = new a();
      c.cdate = i, c.baseCalendar = l, c.calendars.gregorian = s;
    }, {
      "object-assign": 49
    }],
    77: [function (e, t, r) {
      var n = e("object-assign"),
        a = e("./main");
      n(a.regionalOptions[""], {
        invalidArguments: "Invalid arguments",
        invalidFormat: "Cannot format a date from another calendar",
        missingNumberAt: "Missing number at position {0}",
        unknownNameAt: "Unknown name at position {0}",
        unexpectedLiteralAt: "Unexpected literal at position {0}",
        unexpectedText: "Additional text found at end"
      }), a.local = a.regionalOptions[""], n(a.cdate.prototype, {
        formatDate: function formatDate(e, t) {
          return "string" != typeof e && (t = e, e = ""), this._calendar.formatDate(e || "", this, t);
        }
      }), n(a.baseCalendar.prototype, {
        UNIX_EPOCH: a.instance().newDate(1970, 1, 1).toJD(),
        SECS_PER_DAY: 86400,
        TICKS_EPOCH: a.instance().jdEpoch,
        TICKS_PER_DAY: 864e9,
        ATOM: "yyyy-mm-dd",
        COOKIE: "D, dd M yyyy",
        FULL: "DD, MM d, yyyy",
        ISO_8601: "yyyy-mm-dd",
        JULIAN: "J",
        RFC_822: "D, d M yy",
        RFC_850: "DD, dd-M-yy",
        RFC_1036: "D, d M yy",
        RFC_1123: "D, d M yyyy",
        RFC_2822: "D, d M yyyy",
        RSS: "D, d M yy",
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yyyy-mm-dd",
        formatDate: function formatDate(e, t, r) {
          if ("string" != typeof e && (r = t, t = e, e = ""), !t) return "";
          if (t.calendar() !== this) throw a.local.invalidFormat || a.regionalOptions[""].invalidFormat;
          e = e || this.local.dateFormat;
          for (var n, i, o, l, s = (r = r || {}).dayNamesShort || this.local.dayNamesShort, c = r.dayNames || this.local.dayNames, u = r.monthNumbers || this.local.monthNumbers, d = r.monthNamesShort || this.local.monthNamesShort, f = r.monthNames || this.local.monthNames, h = (r.calculateWeek || this.local.calculateWeek, function (t, r) {
              for (var n = 1; w + n < e.length && e.charAt(w + n) === t;) n++;
              return w += n - 1, Math.floor(n / (r || 1)) > 1;
            }), p = function p(e, t, r, n) {
              var a = "" + t;
              if (h(e, n)) for (; a.length < r;) a = "0" + a;
              return a;
            }, g = this, m = function m(e) {
              return "function" == typeof u ? u.call(g, e, h("m")) : x(p("m", e.month(), 2));
            }, y = function y(e, t) {
              return t ? "function" == typeof f ? f.call(g, e) : f[e.month() - g.minMonth] : "function" == typeof d ? d.call(g, e) : d[e.month() - g.minMonth];
            }, v = this.local.digits, x = function x(e) {
              return r.localNumbers && v ? v(e) : e;
            }, b = "", _ = !1, w = 0; w < e.length; w++) if (_) "'" !== e.charAt(w) || h("'") ? b += e.charAt(w) : _ = !1;else switch (e.charAt(w)) {
            case "d":
              b += x(p("d", t.day(), 2));
              break;
            case "D":
              b += (n = "D", i = t.dayOfWeek(), o = s, l = c, h(n) ? l[i] : o[i]);
              break;
            case "o":
              b += p("o", t.dayOfYear(), 3);
              break;
            case "w":
              b += p("w", t.weekOfYear(), 2);
              break;
            case "m":
              b += m(t);
              break;
            case "M":
              b += y(t, h("M"));
              break;
            case "y":
              b += h("y", 2) ? t.year() : (t.year() % 100 < 10 ? "0" : "") + t.year() % 100;
              break;
            case "Y":
              h("Y", 2), b += t.formatYear();
              break;
            case "J":
              b += t.toJD();
              break;
            case "@":
              b += (t.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY;
              break;
            case "!":
              b += (t.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY;
              break;
            case "'":
              h("'") ? b += "'" : _ = !0;
              break;
            default:
              b += e.charAt(w);
          }
          return b;
        },
        parseDate: function parseDate(e, t, r) {
          if (null == t) throw a.local.invalidArguments || a.regionalOptions[""].invalidArguments;
          if ("" === (t = "object" == typeof t ? t.toString() : t + "")) return null;
          e = e || this.local.dateFormat;
          var n = (r = r || {}).shortYearCutoff || this.shortYearCutoff;
          n = "string" != typeof n ? n : this.today().year() % 100 + parseInt(n, 10);
          for (var i = r.dayNamesShort || this.local.dayNamesShort, o = r.dayNames || this.local.dayNames, l = r.parseMonth || this.local.parseMonth, s = r.monthNumbers || this.local.monthNumbers, c = r.monthNamesShort || this.local.monthNamesShort, u = r.monthNames || this.local.monthNames, d = -1, f = -1, h = -1, p = -1, g = -1, m = !1, y = !1, v = function v(t, r) {
              for (var n = 1; A + n < e.length && e.charAt(A + n) === t;) n++;
              return A += n - 1, Math.floor(n / (r || 1)) > 1;
            }, x = function x(e, r) {
              var n = v(e, r),
                i = [2, 3, n ? 4 : 2, n ? 4 : 2, 10, 11, 20]["oyYJ@!".indexOf(e) + 1],
                o = new RegExp("^-?\\d{1," + i + "}"),
                l = t.substring(k).match(o);
              if (!l) throw (a.local.missingNumberAt || a.regionalOptions[""].missingNumberAt).replace(/\{0\}/, k);
              return k += l[0].length, parseInt(l[0], 10);
            }, b = this, _ = function _() {
              if ("function" == typeof s) {
                v("m");
                var e = s.call(b, t.substring(k));
                return k += e.length, e;
              }
              return x("m");
            }, w = function w(e, r, n, i) {
              for (var o = v(e, i) ? n : r, l = 0; l < o.length; l++) if (t.substr(k, o[l].length).toLowerCase() === o[l].toLowerCase()) return k += o[l].length, l + b.minMonth;
              throw (a.local.unknownNameAt || a.regionalOptions[""].unknownNameAt).replace(/\{0\}/, k);
            }, M = function M() {
              if ("function" == typeof u) {
                var e = v("M") ? u.call(b, t.substring(k)) : c.call(b, t.substring(k));
                return k += e.length, e;
              }
              return w("M", c, u);
            }, T = function T() {
              if (t.charAt(k) !== e.charAt(A)) throw (a.local.unexpectedLiteralAt || a.regionalOptions[""].unexpectedLiteralAt).replace(/\{0\}/, k);
              k++;
            }, k = 0, A = 0; A < e.length; A++) if (y) "'" !== e.charAt(A) || v("'") ? T() : y = !1;else switch (e.charAt(A)) {
            case "d":
              p = x("d");
              break;
            case "D":
              w("D", i, o);
              break;
            case "o":
              g = x("o");
              break;
            case "w":
              x("w");
              break;
            case "m":
              h = _();
              break;
            case "M":
              h = M();
              break;
            case "y":
              var L = A;
              m = !v("y", 2), A = L, f = x("y", 2);
              break;
            case "Y":
              f = x("Y", 2);
              break;
            case "J":
              d = x("J") + .5, "." === t.charAt(k) && (k++, x("J"));
              break;
            case "@":
              d = x("@") / this.SECS_PER_DAY + this.UNIX_EPOCH;
              break;
            case "!":
              d = x("!") / this.TICKS_PER_DAY + this.TICKS_EPOCH;
              break;
            case "*":
              k = t.length;
              break;
            case "'":
              v("'") ? T() : y = !0;
              break;
            default:
              T();
          }
          if (k < t.length) throw a.local.unexpectedText || a.regionalOptions[""].unexpectedText;
          if (-1 === f ? f = this.today().year() : f < 100 && m && (f += -1 === n ? 1900 : this.today().year() - this.today().year() % 100 - (f <= n ? 0 : 100)), "string" == typeof h && (h = l.call(this, f, h)), g > -1) {
            h = 1, p = g;
            for (var D = this.daysInMonth(f, h); p > D; D = this.daysInMonth(f, h)) h++, p -= D;
          }
          return d > -1 ? this.fromJD(d) : this.newDate(f, h, p);
        },
        determineDate: function determineDate(e, t, r, n, a) {
          r && "object" != typeof r && (a = n, n = r, r = null), "string" != typeof n && (a = n, n = "");
          var i = this;
          return t = t ? t.newDate() : null, e = null == e ? t : "string" == typeof e ? function (e) {
            try {
              return i.parseDate(n, e, a);
            } catch (e) {}
            for (var t = ((e = e.toLowerCase()).match(/^c/) && r ? r.newDate() : null) || i.today(), o = /([+-]?[0-9]+)\s*(d|w|m|y)?/g, l = o.exec(e); l;) t.add(parseInt(l[1], 10), l[2] || "d"), l = o.exec(e);
            return t;
          }(e) : "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? t : i.today().add(e, "d") : i.newDate(e);
        }
      });
    }, {
      "./main": 76,
      "object-assign": 49
    }],
    78: [function (e, t, r) {
      "use strict";

      t.exports = [{
        path: "",
        backoff: 0
      }, {
        path: "M-2.4,-3V3L0.6,0Z",
        backoff: .6
      }, {
        path: "M-3.7,-2.5V2.5L1.3,0Z",
        backoff: 1.3
      }, {
        path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z",
        backoff: 1.55
      }, {
        path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z",
        backoff: 1.6
      }, {
        path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z",
        backoff: 2
      }, {
        path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z",
        backoff: 0,
        noRotate: !0
      }, {
        path: "M2,2V-2H-2V2Z",
        backoff: 0,
        noRotate: !0
      }];
    }, {}],
    79: [function (e, t, r) {
      "use strict";

      var n = e("./arrow_paths"),
        a = e("../../plots/font_attributes"),
        i = e("../../plots/cartesian/constants"),
        o = e("../../plot_api/plot_template").templatedArray;
      e("../../constants/axis_placeable_objects");
      t.exports = o("annotation", {
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "calc+arraydraw"
        },
        text: {
          valType: "string",
          editType: "calc+arraydraw"
        },
        textangle: {
          valType: "angle",
          dflt: 0,
          editType: "calc+arraydraw"
        },
        font: a({
          editType: "calc+arraydraw",
          colorEditType: "arraydraw"
        }),
        width: {
          valType: "number",
          min: 1,
          dflt: null,
          editType: "calc+arraydraw"
        },
        height: {
          valType: "number",
          min: 1,
          dflt: null,
          editType: "calc+arraydraw"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "arraydraw"
        },
        align: {
          valType: "enumerated",
          values: ["left", "center", "right"],
          dflt: "center",
          editType: "arraydraw"
        },
        valign: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "middle",
          editType: "arraydraw"
        },
        bgcolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)",
          editType: "arraydraw"
        },
        bordercolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)",
          editType: "arraydraw"
        },
        borderpad: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        showarrow: {
          valType: "boolean",
          dflt: !0,
          editType: "calc+arraydraw"
        },
        arrowcolor: {
          valType: "color",
          editType: "arraydraw"
        },
        arrowhead: {
          valType: "integer",
          min: 0,
          max: n.length,
          dflt: 1,
          editType: "arraydraw"
        },
        startarrowhead: {
          valType: "integer",
          min: 0,
          max: n.length,
          dflt: 1,
          editType: "arraydraw"
        },
        arrowside: {
          valType: "flaglist",
          flags: ["end", "start"],
          extras: ["none"],
          dflt: "end",
          editType: "arraydraw"
        },
        arrowsize: {
          valType: "number",
          min: .3,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        startarrowsize: {
          valType: "number",
          min: .3,
          dflt: 1,
          editType: "calc+arraydraw"
        },
        arrowwidth: {
          valType: "number",
          min: .1,
          editType: "calc+arraydraw"
        },
        standoff: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "calc+arraydraw"
        },
        startstandoff: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "calc+arraydraw"
        },
        ax: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        ay: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        axref: {
          valType: "enumerated",
          dflt: "pixel",
          values: ["pixel", i.idRegex.x.toString()],
          editType: "calc"
        },
        ayref: {
          valType: "enumerated",
          dflt: "pixel",
          values: ["pixel", i.idRegex.y.toString()],
          editType: "calc"
        },
        xref: {
          valType: "enumerated",
          values: ["paper", i.idRegex.x.toString()],
          editType: "calc"
        },
        x: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "auto",
          editType: "calc+arraydraw"
        },
        xshift: {
          valType: "number",
          dflt: 0,
          editType: "calc+arraydraw"
        },
        yref: {
          valType: "enumerated",
          values: ["paper", i.idRegex.y.toString()],
          editType: "calc"
        },
        y: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "auto",
          editType: "calc+arraydraw"
        },
        yshift: {
          valType: "number",
          dflt: 0,
          editType: "calc+arraydraw"
        },
        clicktoshow: {
          valType: "enumerated",
          values: [!1, "onoff", "onout"],
          dflt: !1,
          editType: "arraydraw"
        },
        xclick: {
          valType: "any",
          editType: "arraydraw"
        },
        yclick: {
          valType: "any",
          editType: "arraydraw"
        },
        hovertext: {
          valType: "string",
          editType: "arraydraw"
        },
        hoverlabel: {
          bgcolor: {
            valType: "color",
            editType: "arraydraw"
          },
          bordercolor: {
            valType: "color",
            editType: "arraydraw"
          },
          font: a({
            editType: "arraydraw"
          }),
          editType: "arraydraw"
        },
        captureevents: {
          valType: "boolean",
          editType: "arraydraw"
        },
        editType: "calc",
        _deprecated: {
          ref: {
            valType: "string",
            editType: "calc"
          }
        }
      });
    }, {
      "../../constants/axis_placeable_objects": 202,
      "../../plot_api/plot_template": 261,
      "../../plots/cartesian/constants": 279,
      "../../plots/font_attributes": 301,
      "./arrow_paths": 78
    }],
    80: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plots/cartesian/axes"),
        i = e("./draw").draw;
      function o(e) {
        var t = e._fullLayout;
        n.filterVisible(t.annotations).forEach(function (t) {
          var r = a.getFromId(e, t.xref),
            n = a.getFromId(e, t.yref),
            i = a.getRefType(t.xref),
            o = a.getRefType(t.yref);
          t._extremes = {}, "range" === i && l(t, r), "range" === o && l(t, n);
        });
      }
      function l(e, t) {
        var r,
          n = t._id,
          i = n.charAt(0),
          o = e[i],
          l = e["a" + i],
          s = e[i + "ref"],
          c = e["a" + i + "ref"],
          u = e["_" + i + "padplus"],
          d = e["_" + i + "padminus"],
          f = {
            x: 1,
            y: -1
          }[i] * e[i + "shift"],
          h = 3 * e.arrowsize * e.arrowwidth || 0,
          p = h + f,
          g = h - f,
          m = 3 * e.startarrowsize * e.arrowwidth || 0,
          y = m + f,
          v = m - f;
        if (c === s) {
          var x = a.findExtremes(t, [t.r2c(o)], {
              ppadplus: p,
              ppadminus: g
            }),
            b = a.findExtremes(t, [t.r2c(l)], {
              ppadplus: Math.max(u, y),
              ppadminus: Math.max(d, v)
            });
          r = {
            min: [x.min[0], b.min[0]],
            max: [x.max[0], b.max[0]]
          };
        } else y = l ? y + l : y, v = l ? v - l : v, r = a.findExtremes(t, [t.r2c(o)], {
          ppadplus: Math.max(u, p, y),
          ppadminus: Math.max(d, g, v)
        });
        e._extremes[n] = r;
      }
      t.exports = function (e) {
        var t = e._fullLayout;
        if (n.filterVisible(t.annotations).length && e._fullData.length) return n.syncOrAsync([i, o], e);
      };
    }, {
      "../../lib": 225,
      "../../plots/cartesian/axes": 272,
      "./draw": 85
    }],
    81: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../registry"),
        i = e("../../plot_api/plot_template").arrayEditor;
      function o(e, t) {
        var r,
          n,
          a,
          i,
          o,
          s,
          c,
          u = e._fullLayout.annotations,
          d = [],
          f = [],
          h = [],
          p = (t || []).length;
        for (r = 0; r < u.length; r++) if (i = (a = u[r]).clicktoshow) {
          for (n = 0; n < p; n++) if (s = (o = t[n]).xaxis, c = o.yaxis, s._id === a.xref && c._id === a.yref && s.d2r(o.x) === l(a._xclick, s) && c.d2r(o.y) === l(a._yclick, c)) {
            (a.visible ? "onout" === i ? f : h : d).push(r);
            break;
          }
          n === p && a.visible && "onout" === i && f.push(r);
        }
        return {
          on: d,
          off: f,
          explicitOff: h
        };
      }
      function l(e, t) {
        return "log" === t.type ? t.l2r(e) : t.d2r(e);
      }
      t.exports = {
        hasClickToShow: function hasClickToShow(e, t) {
          var r = o(e, t);
          return r.on.length > 0 || r.explicitOff.length > 0;
        },
        onClick: function onClick(e, t) {
          var r,
            l,
            s = o(e, t),
            c = s.on,
            u = s.off.concat(s.explicitOff),
            d = {},
            f = e._fullLayout.annotations;
          if (!c.length && !u.length) return;
          for (r = 0; r < c.length; r++) (l = i(e.layout, "annotations", f[c[r]])).modifyItem("visible", !0), n.extendFlat(d, l.getUpdateObj());
          for (r = 0; r < u.length; r++) (l = i(e.layout, "annotations", f[u[r]])).modifyItem("visible", !1), n.extendFlat(d, l.getUpdateObj());
          return a.call("update", e, {}, d);
        }
      };
    }, {
      "../../lib": 225,
      "../../plot_api/plot_template": 261,
      "../../registry": 309
    }],
    82: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../color");
      t.exports = function (e, t, r, i) {
        i("opacity");
        var o = i("bgcolor"),
          l = i("bordercolor"),
          s = a.opacity(l);
        i("borderpad");
        var c = i("borderwidth"),
          u = i("showarrow");
        if (i("text", u ? " " : r._dfltTitle.annotation), i("textangle"), n.coerceFont(i, "font", r.font), i("width"), i("align"), i("height") && i("valign"), u) {
          var d,
            f,
            h = i("arrowside");
          -1 !== h.indexOf("end") && (d = i("arrowhead"), f = i("arrowsize")), -1 !== h.indexOf("start") && (i("startarrowhead", d), i("startarrowsize", f)), i("arrowcolor", s ? t.bordercolor : a.defaultLine), i("arrowwidth", 2 * (s && c || 1)), i("standoff"), i("startstandoff");
        }
        var p = i("hovertext"),
          g = r.hoverlabel || {};
        if (p) {
          var m = i("hoverlabel.bgcolor", g.bgcolor || (a.opacity(o) ? a.rgb(o) : a.defaultLine)),
            y = i("hoverlabel.bordercolor", g.bordercolor || a.contrast(m));
          n.coerceFont(i, "hoverlabel.font", {
            family: g.font.family,
            size: g.font.size,
            color: g.font.color || y
          });
        }
        i("captureevents", !!p);
      };
    }, {
      "../../lib": 225,
      "../color": 96
    }],
    83: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib/to_log_range");
      t.exports = function (e, t, r, i) {
        t = t || {};
        var o = "log" === r && "linear" === t.type,
          l = "linear" === r && "log" === t.type;
        if (o || l) for (var s, c, u = e._fullLayout.annotations, d = t._id.charAt(0), f = 0; f < u.length; f++) s = u[f], c = "annotations[" + f + "].", s[d + "ref"] === t._id && h(d), s["a" + d + "ref"] === t._id && h("a" + d);
        function h(e) {
          var r = s[e],
            l = null;
          l = o ? a(r, t.range) : Math.pow(10, r), n(l) || (l = null), i(c + e, l);
        }
      };
    }, {
      "../../lib/to_log_range": 250,
      "fast-isnumeric": 11
    }],
    84: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plots/cartesian/axes"),
        i = e("../../plots/array_container_defaults"),
        o = e("./common_defaults"),
        l = e("./attributes");
      function s(e, t, r) {
        function i(r, a) {
          return n.coerce(e, t, l, r, a);
        }
        var s = i("visible"),
          c = i("clicktoshow");
        if (s || c) {
          o(e, t, r, i);
          for (var u = t.showarrow, d = ["x", "y"], f = [-10, -30], h = {
              _fullLayout: r
            }, p = 0; p < 2; p++) {
            var g = d[p],
              m = a.coerceRef(e, t, h, g, "", "paper");
            if ("paper" !== m) a.getFromId(h, m)._annIndices.push(t._index);
            if (a.coercePosition(t, h, i, m, g, .5), u) {
              var y = "a" + g,
                v = a.coerceRef(e, t, h, y, "pixel", ["pixel", "paper"]);
              "pixel" !== v && v !== m && (v = t[y] = "pixel");
              var x = "pixel" === v ? f[p] : .4;
              a.coercePosition(t, h, i, v, y, x);
            }
            i(g + "anchor"), i(g + "shift");
          }
          if (n.noneOrAll(e, t, ["x", "y"]), u && n.noneOrAll(e, t, ["ax", "ay"]), c) {
            var b = i("xclick"),
              _ = i("yclick");
            t._xclick = void 0 === b ? t.x : a.cleanPosition(b, h, t.xref), t._yclick = void 0 === _ ? t.y : a.cleanPosition(_, h, t.yref);
          }
        }
      }
      t.exports = function (e, t) {
        i(e, t, {
          name: "annotations",
          handleItemDefaults: s
        });
      };
    }, {
      "../../lib": 225,
      "../../plots/array_container_defaults": 267,
      "../../plots/cartesian/axes": 272,
      "./attributes": 79,
      "./common_defaults": 82
    }],
    85: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../registry"),
        i = e("../../plots/plots"),
        o = e("../../lib"),
        l = o.strTranslate,
        s = e("../../plots/cartesian/axes"),
        c = e("../color"),
        u = e("../drawing"),
        d = e("../fx"),
        f = e("../../lib/svg_text_utils"),
        h = e("../../lib/setcursor"),
        p = e("../dragelement"),
        g = e("../../plot_api/plot_template").arrayEditor,
        m = e("./draw_arrow_head");
      function y(e, t) {
        var r = e._fullLayout.annotations[t] || {},
          n = s.getFromId(e, r.xref),
          a = s.getFromId(e, r.yref);
        n && n.setScale(), a && a.setScale(), x(e, r, t, !1, n, a);
      }
      function v(e, t, r, n, a) {
        var i = a[r],
          o = a[r + "ref"],
          l = -1 !== r.indexOf("y"),
          c = "domain" === s.getRefType(o),
          u = l ? n.h : n.w;
        return e ? c ? i + (l ? -t : t) / e._length : e.p2r(e.r2p(i) + t) : i + (l ? -t : t) / u;
      }
      function x(e, t, r, i, y, x) {
        var b,
          _,
          w = e._fullLayout,
          M = e._fullLayout._size,
          T = e._context.edits;
        i ? (b = "annotation-" + i, _ = i + ".annotations") : (b = "annotation", _ = "annotations");
        var k = g(e.layout, _, t),
          A = k.modifyBase,
          L = k.modifyItem,
          D = k.getUpdateObj;
        w._infolayer.selectAll("." + b + '[data-index="' + r + '"]').remove();
        var S = "clip" + w._uid + "_ann" + r;
        if (t._input && !1 !== t.visible) {
          var C = {
              x: {},
              y: {}
            },
            O = +t.textangle || 0,
            P = w._infolayer.append("g").classed(b, !0).attr("data-index", String(r)).style("opacity", t.opacity),
            I = P.append("g").classed("annotation-text-g", !0),
            z = T[t.showarrow ? "annotationTail" : "annotationPosition"],
            R = t.captureevents || T.annotationText || z,
            N = I.append("g").style("pointer-events", R ? "all" : null).call(h, "pointer").on("click", function () {
              e._dragging = !1, e.emit("plotly_clickannotation", G(n.event));
            });
          t.hovertext && N.on("mouseover", function () {
            var r = t.hoverlabel,
              n = r.font,
              a = this.getBoundingClientRect(),
              i = e.getBoundingClientRect();
            d.loneHover({
              x0: a.left - i.left,
              x1: a.right - i.left,
              y: (a.top + a.bottom) / 2 - i.top,
              text: t.hovertext,
              color: r.bgcolor,
              borderColor: r.bordercolor,
              fontFamily: n.family,
              fontSize: n.size,
              fontColor: n.color
            }, {
              container: w._hoverlayer.node(),
              outerContainer: w._paper.node(),
              gd: e
            });
          }).on("mouseout", function () {
            d.loneUnhover(w._hoverlayer.node());
          });
          var F = t.borderwidth,
            E = t.borderpad,
            j = F + E,
            H = N.append("rect").attr("class", "bg").style("stroke-width", F + "px").call(c.stroke, t.bordercolor).call(c.fill, t.bgcolor),
            B = t.width || t.height,
            Y = w._topclips.selectAll("#" + S).data(B ? [0] : []);
          Y.enter().append("clipPath").classed("annclip", !0).attr("id", S).append("rect"), Y.exit().remove();
          var U = t.font,
            V = w._meta ? o.templateString(t.text, w._meta) : t.text,
            q = N.append("text").classed("annotation-text", !0).text(V);
          T.annotationText ? q.call(f.makeEditable, {
            delegate: N,
            gd: e
          }).call(Z).on("edit", function (r) {
            t.text = r, this.call(Z), L("text", r), y && y.autorange && A(y._name + ".autorange", !0), x && x.autorange && A(x._name + ".autorange", !0), a.call("_guiRelayout", e, D());
          }) : q.call(Z);
        } else n.selectAll("#" + S).remove();
        function G(e) {
          var n = {
            index: r,
            annotation: t._input,
            fullAnnotation: t,
            event: e
          };
          return i && (n.subplotId = i), n;
        }
        function Z(r) {
          return r.call(u.font, U).attr({
            "text-anchor": {
              left: "start",
              right: "end"
            }[t.align] || "middle"
          }), f.convertToTspans(r, e, W), r;
        }
        function W() {
          var r = q.selectAll("a");
          1 === r.size() && r.text() === q.text() && N.insert("a", ":first-child").attr({
            "xlink:xlink:href": r.attr("xlink:href"),
            "xlink:xlink:show": r.attr("xlink:show")
          }).style({
            cursor: "pointer"
          }).node().appendChild(H.node());
          var n = N.select(".annotation-text-math-group"),
            d = !n.empty(),
            g = u.bBox((d ? n : q).node()),
            b = g.width,
            _ = g.height,
            k = t.width || b,
            R = t.height || _,
            E = Math.round(k + 2 * j),
            U = Math.round(R + 2 * j);
          function V(e, t) {
            return "auto" === t && (t = e < 1 / 3 ? "left" : e > 2 / 3 ? "right" : "center"), {
              center: 0,
              middle: 0,
              left: .5,
              bottom: -.5,
              right: -.5,
              top: .5
            }[t];
          }
          for (var Z = !1, W = ["x", "y"], J = 0; J < W.length; J++) {
            var X,
              Q,
              K,
              $,
              ee,
              te = W[J],
              re = t[te + "ref"] || te,
              ne = t["a" + te + "ref"],
              ae = {
                x: y,
                y: x
              }[te],
              ie = (O + ("x" === te ? 0 : -90)) * Math.PI / 180,
              oe = E * Math.cos(ie),
              le = U * Math.sin(ie),
              se = Math.abs(oe) + Math.abs(le),
              ce = t[te + "anchor"],
              ue = t[te + "shift"] * ("x" === te ? 1 : -1),
              de = C[te],
              fe = s.getRefType(re);
            if (ae && "domain" !== fe) {
              var he = ae.r2fraction(t[te]);
              (he < 0 || he > 1) && (ne === re ? ((he = ae.r2fraction(t["a" + te])) < 0 || he > 1) && (Z = !0) : Z = !0), X = ae._offset + ae.r2p(t[te]), $ = .5;
            } else {
              var pe = "domain" === fe;
              "x" === te ? (K = t[te], X = pe ? ae._offset + ae._length * K : X = M.l + M.w * K) : (K = 1 - t[te], X = pe ? ae._offset + ae._length * K : X = M.t + M.h * K), $ = t.showarrow ? .5 : K;
            }
            if (t.showarrow) {
              de.head = X;
              var ge = t["a" + te];
              if (ee = oe * V(.5, t.xanchor) - le * V(.5, t.yanchor), ne === re) {
                var me = s.getRefType(ne);
                "domain" === me ? ("y" === te && (ge = 1 - ge), de.tail = ae._offset + ae._length * ge) : "paper" === me ? "y" === te ? (ge = 1 - ge, de.tail = M.t + M.h * ge) : de.tail = M.l + M.w * ge : de.tail = ae._offset + ae.r2p(ge), Q = ee;
              } else de.tail = X + ge, Q = ee + ge;
              de.text = de.tail + ee;
              var ye = w["x" === te ? "width" : "height"];
              if ("paper" === re && (de.head = o.constrain(de.head, 1, ye - 1)), "pixel" === ne) {
                var ve = -Math.max(de.tail - 3, de.text),
                  xe = Math.min(de.tail + 3, de.text) - ye;
                ve > 0 ? (de.tail += ve, de.text += ve) : xe > 0 && (de.tail -= xe, de.text -= xe);
              }
              de.tail += ue, de.head += ue;
            } else Q = ee = se * V($, ce), de.text = X + ee;
            de.text += ue, ee += ue, Q += ue, t["_" + te + "padplus"] = se / 2 + Q, t["_" + te + "padminus"] = se / 2 - Q, t["_" + te + "size"] = se, t["_" + te + "shift"] = ee;
          }
          if (Z) N.remove();else {
            var be = 0,
              _e = 0;
            if ("left" !== t.align && (be = (k - b) * ("center" === t.align ? .5 : 1)), "top" !== t.valign && (_e = (R - _) * ("middle" === t.valign ? .5 : 1)), d) n.select("svg").attr({
              x: j + be - 1,
              y: j + _e
            }).call(u.setClipUrl, B ? S : null, e);else {
              var we = j + _e - g.top,
                Me = j + be - g.left;
              q.call(f.positionText, Me, we).call(u.setClipUrl, B ? S : null, e);
            }
            Y.select("rect").call(u.setRect, j, j, k, R), H.call(u.setRect, F / 2, F / 2, E - F, U - F), N.call(u.setTranslate, Math.round(C.x.text - E / 2), Math.round(C.y.text - U / 2)), I.attr({
              transform: "rotate(" + O + "," + C.x.text + "," + C.y.text + ")"
            });
            var Te,
              ke = function ke(r, n) {
                P.selectAll(".annotation-arrow-g").remove();
                var s = C.x.head,
                  d = C.y.head,
                  f = C.x.tail + r,
                  h = C.y.tail + n,
                  g = C.x.text + r,
                  b = C.y.text + n,
                  _ = o.rotationXYMatrix(O, g, b),
                  w = o.apply2DTransform(_),
                  k = o.apply2DTransform2(_),
                  S = +H.attr("width"),
                  z = +H.attr("height"),
                  R = g - .5 * S,
                  F = R + S,
                  E = b - .5 * z,
                  j = E + z,
                  B = [[R, E, R, j], [R, j, F, j], [F, j, F, E], [F, E, R, E]].map(k);
                if (!B.reduce(function (e, t) {
                  return e ^ !!o.segmentsIntersect(s, d, s + 1e6, d + 1e6, t[0], t[1], t[2], t[3]);
                }, !1)) {
                  B.forEach(function (e) {
                    var t = o.segmentsIntersect(f, h, s, d, e[0], e[1], e[2], e[3]);
                    t && (f = t.x, h = t.y);
                  });
                  var Y = t.arrowwidth,
                    U = t.arrowcolor,
                    V = t.arrowside,
                    q = P.append("g").style({
                      opacity: c.opacity(U)
                    }).classed("annotation-arrow-g", !0),
                    G = q.append("path").attr("d", "M" + f + "," + h + "L" + s + "," + d).style("stroke-width", Y + "px").call(c.stroke, c.rgb(U));
                  if (m(G, V, t), T.annotationPosition && G.node().parentNode && !i) {
                    var Z = s,
                      W = d;
                    if (t.standoff) {
                      var J = Math.sqrt(Math.pow(s - f, 2) + Math.pow(d - h, 2));
                      Z += t.standoff * (f - s) / J, W += t.standoff * (h - d) / J;
                    }
                    var X,
                      Q,
                      K = q.append("path").classed("annotation-arrow", !0).classed("anndrag", !0).classed("cursor-move", !0).attr({
                        d: "M3,3H-3V-3H3ZM0,0L" + (f - Z) + "," + (h - W),
                        transform: l(Z, W)
                      }).style("stroke-width", Y + 6 + "px").call(c.stroke, "rgba(0,0,0,0)").call(c.fill, "rgba(0,0,0,0)");
                    p.init({
                      element: K.node(),
                      gd: e,
                      prepFn: function prepFn() {
                        var e = u.getTranslate(N);
                        X = e.x, Q = e.y, y && y.autorange && A(y._name + ".autorange", !0), x && x.autorange && A(x._name + ".autorange", !0);
                      },
                      moveFn: function moveFn(e, r) {
                        var n = w(X, Q),
                          a = n[0] + e,
                          i = n[1] + r;
                        N.call(u.setTranslate, a, i), L("x", v(y, e, "x", M, t)), L("y", v(x, r, "y", M, t)), t.axref === t.xref && L("ax", v(y, e, "ax", M, t)), t.ayref === t.yref && L("ay", v(x, r, "ay", M, t)), q.attr("transform", l(e, r)), I.attr({
                          transform: "rotate(" + O + "," + a + "," + i + ")"
                        });
                      },
                      doneFn: function doneFn() {
                        a.call("_guiRelayout", e, D());
                        var t = document.querySelector(".js-notes-box-panel");
                        t && t.redraw(t.selectedObj);
                      }
                    });
                  }
                }
              };
            if (t.showarrow && ke(0, 0), z) p.init({
              element: N.node(),
              gd: e,
              prepFn: function prepFn() {
                Te = I.attr("transform");
              },
              moveFn: function moveFn(e, r) {
                var n = "pointer";
                if (t.showarrow) t.axref === t.xref ? L("ax", v(y, e, "ax", M, t)) : L("ax", t.ax + e), t.ayref === t.yref ? L("ay", v(x, r, "ay", M.w, t)) : L("ay", t.ay + r), ke(e, r);else {
                  if (i) return;
                  var a, o;
                  if (y) a = v(y, e, "x", M, t);else {
                    var s = t._xsize / M.w,
                      c = t.x + (t._xshift - t.xshift) / M.w - s / 2;
                    a = p.align(c + e / M.w, s, 0, 1, t.xanchor);
                  }
                  if (x) o = v(x, r, "y", M, t);else {
                    var u = t._ysize / M.h,
                      d = t.y - (t._yshift + t.yshift) / M.h - u / 2;
                    o = p.align(d - r / M.h, u, 0, 1, t.yanchor);
                  }
                  L("x", a), L("y", o), y && x || (n = p.getCursor(y ? .5 : a, x ? .5 : o, t.xanchor, t.yanchor));
                }
                I.attr({
                  transform: l(e, r) + Te
                }), h(N, n);
              },
              clickFn: function clickFn(r, n) {
                t.captureevents && e.emit("plotly_clickannotation", G(n));
              },
              doneFn: function doneFn() {
                h(N), a.call("_guiRelayout", e, D());
                var t = document.querySelector(".js-notes-box-panel");
                t && t.redraw(t.selectedObj);
              }
            });
          }
        }
      }
      t.exports = {
        draw: function draw(e) {
          var t = e._fullLayout;
          t._infolayer.selectAll(".annotation").remove();
          for (var r = 0; r < t.annotations.length; r++) t.annotations[r].visible && y(e, r);
          return i.previousPromises(e);
        },
        drawOne: y,
        drawRaw: x
      };
    }, {
      "../../lib": 225,
      "../../lib/setcursor": 245,
      "../../lib/svg_text_utils": 248,
      "../../plot_api/plot_template": 261,
      "../../plots/cartesian/axes": 272,
      "../../plots/plots": 307,
      "../../registry": 309,
      "../color": 96,
      "../dragelement": 115,
      "../drawing": 118,
      "../fx": 136,
      "./draw_arrow_head": 86,
      "@plotly/d3": 6
    }],
    86: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../color"),
        i = e("./arrow_paths"),
        o = e("../../lib"),
        l = o.strScale,
        s = o.strRotate,
        c = o.strTranslate;
      t.exports = function (e, t, r) {
        var o,
          u,
          d,
          f,
          h = e.node(),
          p = i[r.arrowhead || 0],
          g = i[r.startarrowhead || 0],
          m = (r.arrowwidth || 1) * (r.arrowsize || 1),
          y = (r.arrowwidth || 1) * (r.startarrowsize || 1),
          v = t.indexOf("start") >= 0,
          x = t.indexOf("end") >= 0,
          b = p.backoff * m + r.standoff,
          _ = g.backoff * y + r.startstandoff;
        if ("line" === h.nodeName) {
          o = {
            x: +e.attr("x1"),
            y: +e.attr("y1")
          }, u = {
            x: +e.attr("x2"),
            y: +e.attr("y2")
          };
          var w = o.x - u.x,
            M = o.y - u.y;
          if (f = (d = Math.atan2(M, w)) + Math.PI, b && _ && b + _ > Math.sqrt(w * w + M * M)) return void z();
          if (b) {
            if (b * b > w * w + M * M) return void z();
            var T = b * Math.cos(d),
              k = b * Math.sin(d);
            u.x += T, u.y += k, e.attr({
              x2: u.x,
              y2: u.y
            });
          }
          if (_) {
            if (_ * _ > w * w + M * M) return void z();
            var A = _ * Math.cos(d),
              L = _ * Math.sin(d);
            o.x -= A, o.y -= L, e.attr({
              x1: o.x,
              y1: o.y
            });
          }
        } else if ("path" === h.nodeName) {
          var D = h.getTotalLength(),
            S = "";
          if (D < b + _) return void z();
          var C = h.getPointAtLength(0),
            O = h.getPointAtLength(.1);
          d = Math.atan2(C.y - O.y, C.x - O.x), o = h.getPointAtLength(Math.min(_, D)), S = "0px," + _ + "px,";
          var P = h.getPointAtLength(D),
            I = h.getPointAtLength(D - .1);
          f = Math.atan2(P.y - I.y, P.x - I.x), u = h.getPointAtLength(Math.max(0, D - b)), S += D - (S ? _ + b : b) + "px," + D + "px", e.style("stroke-dasharray", S);
        }
        function z() {
          e.style("stroke-dasharray", "0px,100px");
        }
        function R(t, i, o, u) {
          t.path && (t.noRotate && (o = 0), n.select(h.parentNode).append("path").attr({
            class: e.attr("class"),
            d: t.path,
            transform: c(i.x, i.y) + s(180 * o / Math.PI) + l(u)
          }).style({
            fill: a.rgb(r.arrowcolor),
            "stroke-width": 0
          }));
        }
        v && R(g, o, d, y), x && R(p, u, f, m);
      };
    }, {
      "../../lib": 225,
      "../color": 96,
      "./arrow_paths": 78,
      "@plotly/d3": 6
    }],
    87: [function (e, t, r) {
      "use strict";

      var n = e("./draw"),
        a = e("./click");
      t.exports = {
        moduleType: "component",
        name: "annotations",
        layoutAttributes: e("./attributes"),
        supplyLayoutDefaults: e("./defaults"),
        includeBasePlot: e("../../plots/cartesian/include_components")("annotations"),
        calcAutorange: e("./calc_autorange"),
        draw: n.draw,
        drawOne: n.drawOne,
        drawRaw: n.drawRaw,
        hasClickToShow: a.hasClickToShow,
        onClick: a.onClick,
        convertCoords: e("./convert_coords")
      };
    }, {
      "../../plots/cartesian/include_components": 285,
      "./attributes": 79,
      "./calc_autorange": 80,
      "./click": 81,
      "./convert_coords": 83,
      "./defaults": 84,
      "./draw": 85
    }],
    88: [function (e, t, r) {
      "use strict";

      var n = e("../annotations/attributes"),
        a = e("../../plot_api/edit_types").overrideAll,
        i = e("../../plot_api/plot_template").templatedArray;
      t.exports = a(i("annotation", {
        visible: n.visible,
        x: {
          valType: "any"
        },
        y: {
          valType: "any"
        },
        z: {
          valType: "any"
        },
        ax: {
          valType: "number"
        },
        ay: {
          valType: "number"
        },
        xanchor: n.xanchor,
        xshift: n.xshift,
        yanchor: n.yanchor,
        yshift: n.yshift,
        text: n.text,
        textangle: n.textangle,
        font: n.font,
        width: n.width,
        height: n.height,
        opacity: n.opacity,
        align: n.align,
        valign: n.valign,
        bgcolor: n.bgcolor,
        bordercolor: n.bordercolor,
        borderpad: n.borderpad,
        borderwidth: n.borderwidth,
        showarrow: n.showarrow,
        arrowcolor: n.arrowcolor,
        arrowhead: n.arrowhead,
        startarrowhead: n.startarrowhead,
        arrowside: n.arrowside,
        arrowsize: n.arrowsize,
        startarrowsize: n.startarrowsize,
        arrowwidth: n.arrowwidth,
        standoff: n.standoff,
        startstandoff: n.startstandoff,
        hovertext: n.hovertext,
        hoverlabel: n.hoverlabel,
        captureevents: n.captureevents
      }), "calc", "from-root");
    }, {
      "../../plot_api/edit_types": 254,
      "../../plot_api/plot_template": 261,
      "../annotations/attributes": 79
    }],
    89: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plots/cartesian/axes");
      function i(e, t) {
        var r = t.fullSceneLayout.domain,
          i = t.fullLayout._size,
          o = {
            pdata: null,
            type: "linear",
            autorange: !1,
            range: [-1 / 0, 1 / 0]
          };
        e._xa = {}, n.extendFlat(e._xa, o), a.setConvert(e._xa), e._xa._offset = i.l + r.x[0] * i.w, e._xa.l2p = function () {
          return .5 * (1 + e._pdata[0] / e._pdata[3]) * i.w * (r.x[1] - r.x[0]);
        }, e._ya = {}, n.extendFlat(e._ya, o), a.setConvert(e._ya), e._ya._offset = i.t + (1 - r.y[1]) * i.h, e._ya.l2p = function () {
          return .5 * (1 - e._pdata[1] / e._pdata[3]) * i.h * (r.y[1] - r.y[0]);
        };
      }
      t.exports = function (e) {
        for (var t = e.fullSceneLayout.annotations, r = 0; r < t.length; r++) i(t[r], e);
        e.fullLayout._infolayer.selectAll(".annotation-" + e.id).remove();
      };
    }, {
      "../../lib": 225,
      "../../plots/cartesian/axes": 272
    }],
    90: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plots/cartesian/axes"),
        i = e("../../plots/array_container_defaults"),
        o = e("../annotations/common_defaults"),
        l = e("./attributes");
      function s(e, t, r, i) {
        function s(r, a) {
          return n.coerce(e, t, l, r, a);
        }
        function c(e) {
          var n = e + "axis",
            i = {
              _fullLayout: {}
            };
          return i._fullLayout[n] = r[n], a.coercePosition(t, i, s, e, e, .5);
        }
        s("visible") && (o(e, t, i.fullLayout, s), c("x"), c("y"), c("z"), n.noneOrAll(e, t, ["x", "y", "z"]), t.xref = "x", t.yref = "y", t.zref = "z", s("xanchor"), s("yanchor"), s("xshift"), s("yshift"), t.showarrow && (t.axref = "pixel", t.ayref = "pixel", s("ax", -10), s("ay", -30), n.noneOrAll(e, t, ["ax", "ay"])));
      }
      t.exports = function (e, t, r) {
        i(e, t, {
          name: "annotations",
          handleItemDefaults: s,
          fullLayout: r.fullLayout
        });
      };
    }, {
      "../../lib": 225,
      "../../plots/array_container_defaults": 267,
      "../../plots/cartesian/axes": 272,
      "../annotations/common_defaults": 82,
      "./attributes": 88
    }],
    91: [function (e, t, r) {
      "use strict";

      var n = e("../annotations/draw").drawRaw,
        a = e("../../plots/gl3d/project"),
        i = ["x", "y", "z"];
      t.exports = function (e) {
        for (var t = e.fullSceneLayout, r = e.dataScale, o = t.annotations, l = 0; l < o.length; l++) {
          for (var s = o[l], c = !1, u = 0; u < 3; u++) {
            var d = i[u],
              f = s[d],
              h = t[d + "axis"].r2fraction(f);
            if (h < 0 || h > 1) {
              c = !0;
              break;
            }
          }
          c ? e.fullLayout._infolayer.select(".annotation-" + e.id + '[data-index="' + l + '"]').remove() : (s._pdata = a(e.glplot.cameraParams, [t.xaxis.r2l(s.x) * r[0], t.yaxis.r2l(s.y) * r[1], t.zaxis.r2l(s.z) * r[2]]), n(e.graphDiv, s, l, e.id, s._xa, s._ya));
        }
      };
    }, {
      "../../plots/gl3d/project": 304,
      "../annotations/draw": 85
    }],
    92: [function (e, t, r) {
      "use strict";

      var n = e("../../registry"),
        a = e("../../lib");
      t.exports = {
        moduleType: "component",
        name: "annotations3d",
        schema: {
          subplots: {
            scene: {
              annotations: e("./attributes")
            }
          }
        },
        layoutAttributes: e("./attributes"),
        handleDefaults: e("./defaults"),
        includeBasePlot: function includeBasePlot(e, t) {
          var r = n.subplotsRegistry.gl3d;
          if (!r) return;
          for (var i = r.attrRegex, o = Object.keys(e), l = 0; l < o.length; l++) {
            var s = o[l];
            i.test(s) && (e[s].annotations || []).length && (a.pushUnique(t._basePlotModules, r), a.pushUnique(t._subplots.gl3d, s));
          }
        },
        convert: e("./convert"),
        draw: e("./draw")
      };
    }, {
      "../../lib": 225,
      "../../registry": 309,
      "./attributes": 88,
      "./convert": 89,
      "./defaults": 90,
      "./draw": 91
    }],
    93: [function (e, t, r) {
      "use strict";

      t.exports = e("world-calendars/dist/main"), e("world-calendars/dist/plus"), e("world-calendars/dist/calendars/chinese"), e("world-calendars/dist/calendars/coptic"), e("world-calendars/dist/calendars/discworld"), e("world-calendars/dist/calendars/ethiopian"), e("world-calendars/dist/calendars/hebrew"), e("world-calendars/dist/calendars/islamic"), e("world-calendars/dist/calendars/julian"), e("world-calendars/dist/calendars/mayan"), e("world-calendars/dist/calendars/nanakshahi"), e("world-calendars/dist/calendars/nepali"), e("world-calendars/dist/calendars/persian"), e("world-calendars/dist/calendars/taiwan"), e("world-calendars/dist/calendars/thai"), e("world-calendars/dist/calendars/ummalqura");
    }, {
      "world-calendars/dist/calendars/chinese": 62,
      "world-calendars/dist/calendars/coptic": 63,
      "world-calendars/dist/calendars/discworld": 64,
      "world-calendars/dist/calendars/ethiopian": 65,
      "world-calendars/dist/calendars/hebrew": 66,
      "world-calendars/dist/calendars/islamic": 67,
      "world-calendars/dist/calendars/julian": 68,
      "world-calendars/dist/calendars/mayan": 69,
      "world-calendars/dist/calendars/nanakshahi": 70,
      "world-calendars/dist/calendars/nepali": 71,
      "world-calendars/dist/calendars/persian": 72,
      "world-calendars/dist/calendars/taiwan": 73,
      "world-calendars/dist/calendars/thai": 74,
      "world-calendars/dist/calendars/ummalqura": 75,
      "world-calendars/dist/main": 76,
      "world-calendars/dist/plus": 77
    }],
    94: [function (e, t, r) {
      "use strict";

      var n = e("./calendars"),
        a = e("../../lib"),
        i = e("../../constants/numerical"),
        o = i.EPOCHJD,
        l = i.ONEDAY,
        s = {
          valType: "enumerated",
          values: a.sortObjectKeys(n.calendars),
          editType: "calc",
          dflt: "gregorian"
        },
        c = function c(e, t, r, n) {
          var i = {};
          return i[r] = s, a.coerce(e, t, i, r, n);
        },
        u = {
          d: {
            0: "dd",
            "-": "d"
          },
          e: {
            0: "d",
            "-": "d"
          },
          a: {
            0: "D",
            "-": "D"
          },
          A: {
            0: "DD",
            "-": "DD"
          },
          j: {
            0: "oo",
            "-": "o"
          },
          W: {
            0: "ww",
            "-": "w"
          },
          m: {
            0: "mm",
            "-": "m"
          },
          b: {
            0: "M",
            "-": "M"
          },
          B: {
            0: "MM",
            "-": "MM"
          },
          y: {
            0: "yy",
            "-": "yy"
          },
          Y: {
            0: "yyyy",
            "-": "yyyy"
          },
          U: "##",
          w: "##",
          c: {
            0: "D M d %X yyyy",
            "-": "D M d %X yyyy"
          },
          x: {
            0: "mm/dd/yyyy",
            "-": "mm/dd/yyyy"
          }
        };
      var d = {};
      function f(e) {
        var t = d[e];
        return t || (t = d[e] = n.instance(e));
      }
      function h(e) {
        return a.extendFlat({}, s, {
          description: e
        });
      }
      function p(e) {
        return "Sets the calendar system to use with `" + e + "` date data.";
      }
      var g = {
          xcalendar: h(p("x"))
        },
        m = a.extendFlat({}, g, {
          ycalendar: h(p("y"))
        }),
        y = a.extendFlat({}, m, {
          zcalendar: h(p("z"))
        }),
        v = h(["Sets the calendar system to use for `range` and `tick0`", "if this is a date axis. This does not set the calendar for", "interpreting data on this axis, that's specified in the trace", "or via the global `layout.calendar`"].join(" "));
      t.exports = {
        moduleType: "component",
        name: "calendars",
        schema: {
          traces: {
            scatter: m,
            bar: m,
            box: m,
            heatmap: m,
            contour: m,
            histogram: m,
            histogram2d: m,
            histogram2dcontour: m,
            scatter3d: y,
            surface: y,
            mesh3d: y,
            scattergl: m,
            ohlc: g,
            candlestick: g
          },
          layout: {
            calendar: h(["Sets the default calendar system to use for interpreting and", "displaying dates throughout the plot."].join(" "))
          },
          subplots: {
            xaxis: {
              calendar: v
            },
            yaxis: {
              calendar: v
            },
            scene: {
              xaxis: {
                calendar: v
              },
              yaxis: {
                calendar: v
              },
              zaxis: {
                calendar: v
              }
            },
            polar: {
              radialaxis: {
                calendar: v
              }
            }
          },
          transforms: {
            filter: {
              valuecalendar: h(["WARNING: All transforms are deprecated and may be removed from the API in next major version.", "Sets the calendar system to use for `value`, if it is a date."].join(" ")),
              targetcalendar: h(["WARNING: All transforms are deprecated and may be removed from the API in next major version.", "Sets the calendar system to use for `target`, if it is an", "array of dates. If `target` is a string (eg *x*) we use the", "corresponding trace attribute (eg `xcalendar`) if it exists,", "even if `targetcalendar` is provided."].join(" "))
            }
          }
        },
        layoutAttributes: s,
        handleDefaults: c,
        handleTraceDefaults: function handleTraceDefaults(e, t, r, n) {
          for (var a = 0; a < r.length; a++) c(e, t, r[a] + "calendar", n.calendar);
        },
        CANONICAL_SUNDAY: {
          chinese: "2000-01-02",
          coptic: "2000-01-03",
          discworld: "2000-01-03",
          ethiopian: "2000-01-05",
          hebrew: "5000-01-01",
          islamic: "1000-01-02",
          julian: "2000-01-03",
          mayan: "5000-01-01",
          nanakshahi: "1000-01-05",
          nepali: "2000-01-05",
          persian: "1000-01-01",
          jalali: "1000-01-01",
          taiwan: "1000-01-04",
          thai: "2000-01-04",
          ummalqura: "1400-01-06"
        },
        CANONICAL_TICK: {
          chinese: "2000-01-01",
          coptic: "2000-01-01",
          discworld: "2000-01-01",
          ethiopian: "2000-01-01",
          hebrew: "5000-01-01",
          islamic: "1000-01-01",
          julian: "2000-01-01",
          mayan: "5000-01-01",
          nanakshahi: "1000-01-01",
          nepali: "2000-01-01",
          persian: "1000-01-01",
          jalali: "1000-01-01",
          taiwan: "1000-01-01",
          thai: "2000-01-01",
          ummalqura: "1400-01-01"
        },
        DFLTRANGE: {
          chinese: ["2000-01-01", "2001-01-01"],
          coptic: ["1700-01-01", "1701-01-01"],
          discworld: ["1800-01-01", "1801-01-01"],
          ethiopian: ["2000-01-01", "2001-01-01"],
          hebrew: ["5700-01-01", "5701-01-01"],
          islamic: ["1400-01-01", "1401-01-01"],
          julian: ["2000-01-01", "2001-01-01"],
          mayan: ["5200-01-01", "5201-01-01"],
          nanakshahi: ["0500-01-01", "0501-01-01"],
          nepali: ["2000-01-01", "2001-01-01"],
          persian: ["1400-01-01", "1401-01-01"],
          jalali: ["1400-01-01", "1401-01-01"],
          taiwan: ["0100-01-01", "0101-01-01"],
          thai: ["2500-01-01", "2501-01-01"],
          ummalqura: ["1400-01-01", "1401-01-01"]
        },
        getCal: f,
        worldCalFmt: function worldCalFmt(e, t, r) {
          for (var n, a, i, s, c, d = Math.floor((t + .05) / l) + o, h = f(r).fromJD(d), p = 0; -1 !== (p = e.indexOf("%", p));) "0" === (n = e.charAt(p + 1)) || "-" === n || "_" === n ? (i = 3, a = e.charAt(p + 2), "_" === n && (n = "-")) : (a = n, n = "0", i = 2), (s = u[a]) ? (c = "##" === s ? "##" : h.formatDate(s[n]), e = e.substr(0, p) + c + e.substr(p + i), p += c.length) : p += i;
          return e;
        }
      };
    }, {
      "../../constants/numerical": 205,
      "../../lib": 225,
      "./calendars": 93
    }],
    95: [function (e, t, r) {
      "use strict";

      r.defaults = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"], r.defaultLine = "#444", r.lightLine = "#eee", r.background = "#fff", r.borderLine = "#BEC8D9", r.lightFraction = 1e3 / 11;
    }, {}],
    96: [function (e, t, r) {
      "use strict";

      var n = e("tinycolor2"),
        a = e("fast-isnumeric"),
        i = e("../../lib/array").isTypedArray,
        o = t.exports = {},
        l = e("./attributes");
      o.defaults = l.defaults;
      var s = o.defaultLine = l.defaultLine;
      o.lightLine = l.lightLine;
      var c = o.background = l.background;
      function u(e) {
        if (a(e) || "string" != typeof e) return e;
        var t = e.trim();
        if ("rgb" !== t.substr(0, 3)) return e;
        var r = t.match(/^rgba?\s*\(([^()]*)\)$/);
        if (!r) return e;
        var n = r[1].trim().split(/\s*[\s,]\s*/),
          i = "a" === t.charAt(3) && 4 === n.length;
        if (!i && 3 !== n.length) return e;
        for (var o = 0; o < n.length; o++) {
          if (!n[o].length) return e;
          if (n[o] = Number(n[o]), !(n[o] >= 0)) return e;
          if (3 === o) n[o] > 1 && (n[o] = 1);else if (n[o] >= 1) return e;
        }
        var l = Math.round(255 * n[0]) + ", " + Math.round(255 * n[1]) + ", " + Math.round(255 * n[2]);
        return i ? "rgba(" + l + ", " + n[3] + ")" : "rgb(" + l + ")";
      }
      o.tinyRGB = function (e) {
        var t = e.toRgb();
        return "rgb(" + Math.round(t.r) + ", " + Math.round(t.g) + ", " + Math.round(t.b) + ")";
      }, o.rgb = function (e) {
        return o.tinyRGB(n(e));
      }, o.opacity = function (e) {
        return e ? n(e).getAlpha() : 0;
      }, o.addOpacity = function (e, t) {
        var r = n(e).toRgb();
        return "rgba(" + Math.round(r.r) + ", " + Math.round(r.g) + ", " + Math.round(r.b) + ", " + t + ")";
      }, o.combine = function (e, t) {
        var r = n(e).toRgb();
        if (1 === r.a) return n(e).toRgbString();
        var a = n(t || c).toRgb(),
          i = 1 === a.a ? a : {
            r: 255 * (1 - a.a) + a.r * a.a,
            g: 255 * (1 - a.a) + a.g * a.a,
            b: 255 * (1 - a.a) + a.b * a.a
          },
          o = {
            r: i.r * (1 - r.a) + r.r * r.a,
            g: i.g * (1 - r.a) + r.g * r.a,
            b: i.b * (1 - r.a) + r.b * r.a
          };
        return n(o).toRgbString();
      }, o.contrast = function (e, t, r) {
        var a = n(e);
        return 1 !== a.getAlpha() && (a = n(o.combine(e, c))), (a.isDark() ? t ? a.lighten(t) : c : r ? a.darken(r) : s).toString();
      }, o.stroke = function (e, t) {
        var r = n(t);
        e.style({
          stroke: o.tinyRGB(r),
          "stroke-opacity": r.getAlpha()
        });
      }, o.fill = function (e, t) {
        var r = n(t);
        e.style({
          fill: o.tinyRGB(r),
          "fill-opacity": r.getAlpha()
        });
      }, o.clean = function (e) {
        if (e && "object" == typeof e) {
          var t,
            r,
            n,
            a,
            l = Object.keys(e);
          for (t = 0; t < l.length; t++) if (a = e[n = l[t]], "color" === n.substr(n.length - 5)) {
            if (Array.isArray(a)) for (r = 0; r < a.length; r++) a[r] = u(a[r]);else e[n] = u(a);
          } else if ("colorscale" === n.substr(n.length - 10) && Array.isArray(a)) for (r = 0; r < a.length; r++) Array.isArray(a[r]) && (a[r][1] = u(a[r][1]));else if (Array.isArray(a)) {
            var s = a[0];
            if (!Array.isArray(s) && s && "object" == typeof s) for (r = 0; r < a.length; r++) o.clean(a[r]);
          } else a && "object" == typeof a && !i(a) && o.clean(a);
        }
      };
    }, {
      "../../lib/array": 211,
      "./attributes": 95,
      "fast-isnumeric": 11,
      tinycolor2: 61
    }],
    97: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/cartesian/layout_attributes"),
        a = e("../../plots/font_attributes"),
        i = e("../../lib/extend").extendFlat,
        o = e("../../plot_api/edit_types").overrideAll;
      t.exports = o({
        thicknessmode: {
          valType: "enumerated",
          values: ["fraction", "pixels"],
          dflt: "pixels"
        },
        thickness: {
          valType: "number",
          min: 0,
          dflt: 30
        },
        lenmode: {
          valType: "enumerated",
          values: ["fraction", "pixels"],
          dflt: "fraction"
        },
        len: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        x: {
          valType: "number",
          dflt: 1.02,
          min: -2,
          max: 3
        },
        xanchor: {
          valType: "enumerated",
          values: ["left", "center", "right"],
          dflt: "left"
        },
        xpad: {
          valType: "number",
          min: 0,
          dflt: 10
        },
        y: {
          valType: "number",
          dflt: .5,
          min: -2,
          max: 3
        },
        yanchor: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "middle"
        },
        ypad: {
          valType: "number",
          min: 0,
          dflt: 10
        },
        outlinecolor: n.linecolor,
        outlinewidth: n.linewidth,
        bordercolor: n.linecolor,
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 0
        },
        bgcolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)"
        },
        tickmode: n.tickmode,
        nticks: n.nticks,
        tick0: n.tick0,
        dtick: n.dtick,
        tickvals: n.tickvals,
        ticktext: n.ticktext,
        ticks: i({}, n.ticks, {
          dflt: ""
        }),
        ticklabeloverflow: i({}, n.ticklabeloverflow, {}),
        ticklabelposition: {
          valType: "enumerated",
          values: ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"],
          dflt: "outside"
        },
        ticklen: n.ticklen,
        tickwidth: n.tickwidth,
        tickcolor: n.tickcolor,
        showticklabels: n.showticklabels,
        tickfont: a({}),
        tickangle: n.tickangle,
        tickformat: n.tickformat,
        tickformatstops: n.tickformatstops,
        tickprefix: n.tickprefix,
        showtickprefix: n.showtickprefix,
        ticksuffix: n.ticksuffix,
        showticksuffix: n.showticksuffix,
        separatethousands: n.separatethousands,
        exponentformat: n.exponentformat,
        minexponent: n.minexponent,
        showexponent: n.showexponent,
        title: {
          text: {
            valType: "string"
          },
          font: a({}),
          side: {
            valType: "enumerated",
            values: ["right", "top", "bottom"],
            dflt: "top"
          }
        },
        _deprecated: {
          title: {
            valType: "string"
          },
          titlefont: a({}),
          titleside: {
            valType: "enumerated",
            values: ["right", "top", "bottom"],
            dflt: "top"
          }
        }
      }, "colorbars", "from-root");
    }, {
      "../../lib/extend": 219,
      "../../plot_api/edit_types": 254,
      "../../plots/cartesian/layout_attributes": 287,
      "../../plots/font_attributes": 301
    }],
    98: [function (e, t, r) {
      "use strict";

      t.exports = {
        cn: {
          colorbar: "colorbar",
          cbbg: "cbbg",
          cbfill: "cbfill",
          cbfills: "cbfills",
          cbline: "cbline",
          cblines: "cblines",
          cbaxis: "cbaxis",
          cbtitleunshift: "cbtitleunshift",
          cbtitle: "cbtitle",
          cboutline: "cboutline",
          crisp: "crisp",
          jsPlaceholder: "js-placeholder"
        }
      };
    }, {}],
    99: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plot_api/plot_template"),
        i = e("../../plots/cartesian/tick_value_defaults"),
        o = e("../../plots/cartesian/tick_mark_defaults"),
        l = e("../../plots/cartesian/tick_label_defaults"),
        s = e("./attributes");
      t.exports = function (e, t, r) {
        var c = a.newContainer(t, "colorbar"),
          u = e.colorbar || {};
        function d(e, t) {
          return n.coerce(u, c, s, e, t);
        }
        var f = d("thicknessmode");
        d("thickness", "fraction" === f ? 30 / (r.width - r.margin.l - r.margin.r) : 30);
        var h = d("lenmode");
        d("len", "fraction" === h ? 1 : r.height - r.margin.t - r.margin.b), d("x"), d("xanchor"), d("xpad"), d("y"), d("yanchor"), d("ypad"), n.noneOrAll(u, c, ["x", "y"]), d("outlinecolor"), d("outlinewidth"), d("bordercolor"), d("borderwidth"), d("bgcolor");
        var p = d("ticklabelposition");
        d("ticklabeloverflow", -1 !== p.indexOf("inside") ? "hide past domain" : "hide past div"), i(u, c, d, "linear");
        var g = r.font,
          m = {
            outerTicks: !1,
            font: g
          };
        -1 !== p.indexOf("inside") && (m.bgColor = "black"), l(u, c, d, "linear", m), o(u, c, d, "linear", m), d("title.text", r._dfltTitle.colorbar);
        var y = c.tickfont,
          v = n.extendFlat({}, y, {
            color: g.color,
            size: n.bigFont(y.size)
          });
        n.coerceFont(d, "title.font", v), d("title.side");
      };
    }, {
      "../../lib": 225,
      "../../plot_api/plot_template": 261,
      "../../plots/cartesian/tick_label_defaults": 294,
      "../../plots/cartesian/tick_mark_defaults": 295,
      "../../plots/cartesian/tick_value_defaults": 296,
      "./attributes": 97
    }],
    100: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("tinycolor2"),
        i = e("../../plots/plots"),
        o = e("../../registry"),
        l = e("../../plots/cartesian/axes"),
        s = e("../dragelement"),
        c = e("../../lib"),
        u = c.strTranslate,
        d = e("../../lib/extend").extendFlat,
        f = e("../../lib/setcursor"),
        h = e("../drawing"),
        p = e("../color"),
        g = e("../titles"),
        m = e("../../lib/svg_text_utils"),
        y = e("../colorscale/helpers").flipScale,
        v = e("../../plots/cartesian/axis_defaults"),
        x = e("../../plots/cartesian/position_defaults"),
        b = e("../../plots/cartesian/layout_attributes"),
        _ = e("../../constants/alignment"),
        w = _.LINE_SPACING,
        M = _.FROM_TL,
        T = _.FROM_BR,
        k = e("./constants").cn;
      t.exports = {
        draw: function draw(e) {
          var t = e._fullLayout._infolayer.selectAll("g." + k.colorbar).data(function (e) {
            var t,
              r,
              n,
              a,
              i = e._fullLayout,
              o = e.calcdata,
              l = [];
            function s(e) {
              return d(e, {
                _fillcolor: null,
                _line: {
                  color: null,
                  width: null,
                  dash: null
                },
                _levels: {
                  start: null,
                  end: null,
                  size: null
                },
                _filllevels: null,
                _fillgradient: null,
                _zrange: null
              });
            }
            function c() {
              "function" == typeof a.calc ? a.calc(e, n, t) : (t._fillgradient = r.reversescale ? y(r.colorscale) : r.colorscale, t._zrange = [r[a.min], r[a.max]]);
            }
            for (var u = 0; u < o.length; u++) {
              var f = o[u],
                h = (n = f[0].trace)._module.colorbar;
              if (!0 === n.visible && h) for (var p = Array.isArray(h), g = p ? h : [h], m = 0; m < g.length; m++) {
                var v = (a = g[m]).container;
                (r = v ? n[v] : n) && r.showscale && ((t = s(r.colorbar))._id = "cb" + n.uid + (p && v ? "-" + v : ""), t._traceIndex = n.index, t._propPrefix = (v ? v + "." : "") + "colorbar.", t._meta = n._meta, c(), l.push(t));
              }
            }
            for (var x in i._colorAxes) if ((r = i[x]).showscale) {
              var b = i._colorAxes[x];
              (t = s(r.colorbar))._id = "cb" + x, t._propPrefix = x + ".colorbar.", t._meta = i._meta, a = {
                min: "cmin",
                max: "cmax"
              }, "heatmap" !== b[0] && (n = b[1], a.calc = n._module.colorbar.calc), c(), l.push(t);
            }
            return l;
          }(e), function (e) {
            return e._id;
          });
          t.enter().append("g").attr("class", function (e) {
            return e._id;
          }).classed(k.colorbar, !0), t.each(function (t) {
            var r = n.select(this);
            c.ensureSingle(r, "rect", k.cbbg), c.ensureSingle(r, "g", k.cbfills), c.ensureSingle(r, "g", k.cblines), c.ensureSingle(r, "g", k.cbaxis, function (e) {
              e.classed(k.crisp, !0);
            }), c.ensureSingle(r, "g", k.cbtitleunshift, function (e) {
              e.append("g").classed(k.cbtitle, !0);
            }), c.ensureSingle(r, "rect", k.cboutline);
            var y = function (e, t, r) {
              var o = r._fullLayout,
                s = o._size,
                f = t._fillcolor,
                y = t._line,
                _ = t.title,
                A = _.side,
                L = t._zrange || n.extent(("function" == typeof f ? f : y.color).domain()),
                D = "function" == typeof y.color ? y.color : function () {
                  return y.color;
                },
                S = "function" == typeof f ? f : function () {
                  return f;
                },
                C = t._levels,
                O = function (e, t, r) {
                  var n,
                    a,
                    i = t._levels,
                    o = [],
                    l = [],
                    s = i.end + i.size / 100,
                    c = i.size,
                    u = 1.001 * r[0] - .001 * r[1],
                    d = 1.001 * r[1] - .001 * r[0];
                  for (a = 0; a < 1e5 && (n = i.start + a * c, !(c > 0 ? n >= s : n <= s)); a++) n > u && n < d && o.push(n);
                  if (t._fillgradient) l = [0];else if ("function" == typeof t._fillcolor) {
                    var f = t._filllevels;
                    if (f) for (s = f.end + f.size / 100, c = f.size, a = 0; a < 1e5 && (n = f.start + a * c, !(c > 0 ? n >= s : n <= s)); a++) n > r[0] && n < r[1] && l.push(n);else (l = o.map(function (e) {
                      return e - i.size / 2;
                    })).push(l[l.length - 1] + i.size);
                  } else t._fillcolor && "string" == typeof t._fillcolor && (l = [0]);
                  i.size < 0 && (o.reverse(), l.reverse());
                  return {
                    line: o,
                    fill: l
                  };
                }(0, t, L),
                P = O.fill,
                I = O.line,
                z = Math.round(t.thickness * ("fraction" === t.thicknessmode ? s.w : 1)),
                R = z / s.w,
                N = Math.round(t.len * ("fraction" === t.lenmode ? s.h : 1)),
                F = N / s.h,
                E = t.xpad / s.w,
                j = (t.borderwidth + t.outlinewidth) / 2,
                H = t.ypad / s.h,
                B = Math.round(t.x * s.w + t.xpad),
                Y = t.x - R * ({
                  middle: .5,
                  right: 1
                }[t.xanchor] || 0),
                U = t.y + F * (({
                  top: -.5,
                  bottom: .5
                }[t.yanchor] || 0) - .5),
                V = Math.round(s.h * (1 - U)),
                q = V - N;
              t._lenFrac = F, t._thickFrac = R, t._xLeftFrac = Y, t._yBottomFrac = U;
              var G = t._axis = function (e, t, r) {
                var n = e._fullLayout,
                  a = {
                    type: "linear",
                    range: r,
                    tickmode: t.tickmode,
                    nticks: t.nticks,
                    tick0: t.tick0,
                    dtick: t.dtick,
                    tickvals: t.tickvals,
                    ticktext: t.ticktext,
                    ticks: t.ticks,
                    ticklen: t.ticklen,
                    tickwidth: t.tickwidth,
                    tickcolor: t.tickcolor,
                    showticklabels: t.showticklabels,
                    ticklabelposition: t.ticklabelposition,
                    ticklabeloverflow: t.ticklabeloverflow,
                    tickfont: t.tickfont,
                    tickangle: t.tickangle,
                    tickformat: t.tickformat,
                    exponentformat: t.exponentformat,
                    minexponent: t.minexponent,
                    separatethousands: t.separatethousands,
                    showexponent: t.showexponent,
                    showtickprefix: t.showtickprefix,
                    tickprefix: t.tickprefix,
                    showticksuffix: t.showticksuffix,
                    ticksuffix: t.ticksuffix,
                    title: t.title,
                    showline: !0,
                    anchor: "free",
                    side: "right",
                    position: 1
                  },
                  i = {
                    type: "linear",
                    _id: "y" + t._id
                  },
                  o = {
                    letter: "y",
                    font: n.font,
                    noHover: !0,
                    noTickson: !0,
                    noTicklabelmode: !0,
                    calendar: n.calendar
                  };
                function l(e, t) {
                  return c.coerce(a, i, b, e, t);
                }
                return v(a, i, l, o, n), x(a, i, l, o), i;
              }(r, t, L);
              G.position = t.x + E + R, -1 !== ["top", "bottom"].indexOf(A) && (G.title.side = A, G.titlex = t.x + E, G.titley = U + ("top" === _.side ? F - H : H));
              if (y.color && "auto" === t.tickmode) {
                G.tickmode = "linear", G.tick0 = C.start;
                var Z = C.size,
                  W = c.constrain((V - q) / 50, 4, 15) + 1,
                  J = (L[1] - L[0]) / ((t.nticks || W) * Z);
                if (J > 1) {
                  var X = Math.pow(10, Math.floor(Math.log(J) / Math.LN10));
                  Z *= X * c.roundUp(J / X, [2, 5, 10]), (Math.abs(C.start) / C.size + 1e-6) % 1 < 2e-6 && (G.tick0 = 0);
                }
                G.dtick = Z;
              }
              G.domain = [U + H, U + F - H], G.setScale(), e.attr("transform", u(Math.round(s.l), Math.round(s.t)));
              var Q,
                K = e.select("." + k.cbtitleunshift).attr("transform", u(-Math.round(s.l), -Math.round(s.t))),
                $ = e.select("." + k.cbaxis),
                ee = 0;
              function te(n, a) {
                var i = {
                    propContainer: G,
                    propName: t._propPrefix + "title",
                    traceIndex: t._traceIndex,
                    _meta: t._meta,
                    placeholder: o._dfltTitle.colorbar,
                    containerGroup: e.select("." + k.cbtitle)
                  },
                  l = "h" === n.charAt(0) ? n.substr(1) : "h" + n;
                e.selectAll("." + l + ",." + l + "-math-group").remove(), g.draw(r, n, d(i, a || {}));
              }
              return c.syncOrAsync([i.previousPromises, function () {
                if (-1 !== ["top", "bottom"].indexOf(A)) {
                  var e,
                    r = s.l + (t.x + E) * s.w,
                    n = G.title.font.size;
                  e = "top" === A ? (1 - (U + F - H)) * s.h + s.t + 3 + .75 * n : (1 - (U + H)) * s.h + s.t - 3 - .25 * n, te(G._id + "title", {
                    attributes: {
                      x: r,
                      y: e,
                      "text-anchor": "start"
                    }
                  });
                }
              }, function () {
                if (-1 !== ["top", "bottom"].indexOf(A)) {
                  var i = e.select("." + k.cbtitle),
                    o = i.select("text"),
                    d = [-t.outlinewidth / 2, t.outlinewidth / 2],
                    f = i.select(".h" + G._id + "title-math-group").node(),
                    p = 15.6;
                  if (o.node() && (p = parseInt(o.node().style.fontSize, 10) * w), f ? (ee = h.bBox(f).height) > p && (d[1] -= (ee - p) / 2) : o.node() && !o.classed(k.jsPlaceholder) && (ee = h.bBox(o.node()).height), ee) {
                    if (ee += 5, "top" === A) G.domain[1] -= ee / s.h, d[1] *= -1;else {
                      G.domain[0] += ee / s.h;
                      var g = m.lineCount(o);
                      d[1] += (1 - g) * p;
                    }
                    i.attr("transform", u(d[0], d[1])), G.setScale();
                  }
                }
                e.selectAll("." + k.cbfills + ",." + k.cblines).attr("transform", u(0, Math.round(s.h * (1 - G.domain[1])))), $.attr("transform", u(0, Math.round(-s.t)));
                var v = e.select("." + k.cbfills).selectAll("rect." + k.cbfill).attr("style", "").data(P);
                v.enter().append("rect").classed(k.cbfill, !0).style("stroke", "none"), v.exit().remove();
                var x = L.map(G.c2p).map(Math.round).sort(function (e, t) {
                  return e - t;
                });
                v.each(function (e, i) {
                  var o = [0 === i ? L[0] : (P[i] + P[i - 1]) / 2, i === P.length - 1 ? L[1] : (P[i] + P[i + 1]) / 2].map(G.c2p).map(Math.round);
                  o[1] = c.constrain(o[1] + (o[1] > o[0]) ? 1 : -1, x[0], x[1]);
                  var l = n.select(this).attr({
                    x: B,
                    width: Math.max(z, 2),
                    y: n.min(o),
                    height: Math.max(n.max(o) - n.min(o), 2)
                  });
                  if (t._fillgradient) h.gradient(l, r, t._id, "vertical", t._fillgradient, "fill");else {
                    var s = S(e).replace("e-", "");
                    l.attr("fill", a(s).toHexString());
                  }
                });
                var b = e.select("." + k.cblines).selectAll("path." + k.cbline).data(y.color && y.width ? I : []);
                b.enter().append("path").classed(k.cbline, !0), b.exit().remove(), b.each(function (e) {
                  n.select(this).attr("d", "M" + B + "," + (Math.round(G.c2p(e)) + y.width / 2 % 1) + "h" + z).call(h.lineGroupStyle, y.width, D(e), y.dash);
                }), $.selectAll("g." + G._id + "tick,path").remove();
                var _ = B + z + (t.outlinewidth || 0) / 2 - ("outside" === t.ticks ? 1 : 0),
                  M = l.calcTicks(G),
                  T = l.getTickSigns(G)[2];
                return l.drawTicks(r, G, {
                  vals: "inside" === G.ticks ? l.clipEnds(G, M) : M,
                  layer: $,
                  path: l.makeTickPath(G, _, T),
                  transFn: l.makeTransTickFn(G)
                }), l.drawLabels(r, G, {
                  vals: M,
                  layer: $,
                  transFn: l.makeTransTickLabelFn(G),
                  labelFns: l.makeLabelFns(G, _)
                });
              }, function () {
                if (-1 === ["top", "bottom"].indexOf(A)) {
                  var e = G.title.font.size,
                    t = G._offset + G._length / 2,
                    a = s.l + (G.position || 0) * s.w + ("right" === G.side ? 10 + e * (G.showticklabels ? 1 : .5) : -10 - e * (G.showticklabels ? .5 : 0));
                  te("h" + G._id + "title", {
                    avoid: {
                      selection: n.select(r).selectAll("g." + G._id + "tick"),
                      side: A,
                      offsetLeft: s.l,
                      offsetTop: 0,
                      maxShift: o.width
                    },
                    attributes: {
                      x: a,
                      y: t,
                      "text-anchor": "middle"
                    },
                    transform: {
                      rotate: "-90",
                      offset: 0
                    }
                  });
                }
              }, i.previousPromises, function () {
                var n = z + t.outlinewidth / 2;
                if (-1 === G.ticklabelposition.indexOf("inside") && (n += h.bBox($.node()).width), (Q = K.select("text")).node() && !Q.classed(k.jsPlaceholder)) {
                  var a,
                    o = K.select(".h" + G._id + "title-math-group").node();
                  a = o && -1 !== ["top", "bottom"].indexOf(A) ? h.bBox(o).width : h.bBox(K.node()).right - B - s.l, n = Math.max(n, a);
                }
                var l = 2 * t.xpad + n + t.borderwidth + t.outlinewidth / 2,
                  c = V - q;
                e.select("." + k.cbbg).attr({
                  x: B - t.xpad - (t.borderwidth + t.outlinewidth) / 2,
                  y: q - j,
                  width: Math.max(l, 2),
                  height: Math.max(c + 2 * j, 2)
                }).call(p.fill, t.bgcolor).call(p.stroke, t.bordercolor).style("stroke-width", t.borderwidth), e.selectAll("." + k.cboutline).attr({
                  x: B,
                  y: q + t.ypad + ("top" === A ? ee : 0),
                  width: Math.max(z, 2),
                  height: Math.max(c - 2 * t.ypad - ee, 2)
                }).call(p.stroke, t.outlinecolor).style({
                  fill: "none",
                  "stroke-width": t.outlinewidth
                });
                var d = ({
                  center: .5,
                  right: 1
                }[t.xanchor] || 0) * l;
                e.attr("transform", u(s.l - d, s.t));
                var f = {},
                  g = M[t.yanchor],
                  m = T[t.yanchor];
                "pixels" === t.lenmode ? (f.y = t.y, f.t = c * g, f.b = c * m) : (f.t = f.b = 0, f.yt = t.y + t.len * g, f.yb = t.y - t.len * m);
                var y = M[t.xanchor],
                  v = T[t.xanchor];
                if ("pixels" === t.thicknessmode) f.x = t.x, f.l = l * y, f.r = l * v;else {
                  var x = l - z;
                  f.l = x * y, f.r = x * v, f.xl = t.x - t.thickness * y, f.xr = t.x + t.thickness * v;
                }
                i.autoMargin(r, t._id, f);
              }], r);
            }(r, t, e);
            y && y.then && (e._promises || []).push(y), e._context.edits.colorbarPosition && function (e, t, r) {
              var n,
                a,
                i,
                l = r._fullLayout._size;
              s.init({
                element: e.node(),
                gd: r,
                prepFn: function prepFn() {
                  n = e.attr("transform"), f(e);
                },
                moveFn: function moveFn(r, o) {
                  e.attr("transform", n + u(r, o)), a = s.align(t._xLeftFrac + r / l.w, t._thickFrac, 0, 1, t.xanchor), i = s.align(t._yBottomFrac - o / l.h, t._lenFrac, 0, 1, t.yanchor);
                  var c = s.getCursor(a, i, t.xanchor, t.yanchor);
                  f(e, c);
                },
                doneFn: function doneFn() {
                  if (f(e), void 0 !== a && void 0 !== i) {
                    var n = {};
                    n[t._propPrefix + "x"] = a, n[t._propPrefix + "y"] = i, void 0 !== t._traceIndex ? o.call("_guiRestyle", r, n, t._traceIndex) : o.call("_guiRelayout", r, n);
                  }
                }
              });
            }(r, t, e);
          }), t.exit().each(function (t) {
            i.autoMargin(e, t._id);
          }).remove(), t.order();
        }
      };
    }, {
      "../../constants/alignment": 201,
      "../../lib": 225,
      "../../lib/extend": 219,
      "../../lib/setcursor": 245,
      "../../lib/svg_text_utils": 248,
      "../../plots/cartesian/axes": 272,
      "../../plots/cartesian/axis_defaults": 274,
      "../../plots/cartesian/layout_attributes": 287,
      "../../plots/cartesian/position_defaults": 290,
      "../../plots/plots": 307,
      "../../registry": 309,
      "../color": 96,
      "../colorscale/helpers": 107,
      "../dragelement": 115,
      "../drawing": 118,
      "../titles": 194,
      "./constants": 98,
      "@plotly/d3": 6,
      tinycolor2: 61
    }],
    101: [function (e, t, r) {
      "use strict";

      var n = e("../../lib");
      t.exports = function (e) {
        return n.isPlainObject(e.colorbar);
      };
    }, {
      "../../lib": 225
    }],
    102: [function (e, t, r) {
      "use strict";

      t.exports = {
        moduleType: "component",
        name: "colorbar",
        attributes: e("./attributes"),
        supplyDefaults: e("./defaults"),
        draw: e("./draw").draw,
        hasColorbar: e("./has_colorbar")
      };
    }, {
      "./attributes": 97,
      "./defaults": 99,
      "./draw": 100,
      "./has_colorbar": 101
    }],
    103: [function (e, t, r) {
      "use strict";

      var n = e("../colorbar/attributes"),
        a = e("../../lib/regex").counter,
        i = e("../../lib/sort_object_keys"),
        o = e("./scales.js").scales;
      i(o);
      function l(e) {
        return "`" + e + "`";
      }
      t.exports = function (e, t) {
        e = e || "";
        var r,
          i = (t = t || {}).cLetter || "c",
          s = ("onlyIfNumerical" in t ? t.onlyIfNumerical : Boolean(e), "noScale" in t ? t.noScale : "marker.line" === e),
          c = "showScaleDflt" in t ? t.showScaleDflt : "z" === i,
          u = "string" == typeof t.colorscaleDflt ? o[t.colorscaleDflt] : null,
          d = t.editTypeOverride || "",
          f = e ? e + "." : "";
        "colorAttr" in t ? (r = t.colorAttr, t.colorAttr) : l(f + (r = {
          z: "z",
          c: "color"
        }[i]));
        var h = i + "auto",
          p = i + "min",
          g = i + "max",
          m = i + "mid",
          y = (l(f + h), l(f + p), l(f + g), {});
        y[p] = y[g] = void 0;
        var v = {};
        v[h] = !1;
        var x = {};
        return "color" === r && (x.color = {
          valType: "color",
          arrayOk: !0,
          editType: d || "style"
        }, t.anim && (x.color.anim = !0)), x[h] = {
          valType: "boolean",
          dflt: !0,
          editType: "calc",
          impliedEdits: y
        }, x[p] = {
          valType: "number",
          dflt: null,
          editType: d || "plot",
          impliedEdits: v
        }, x[g] = {
          valType: "number",
          dflt: null,
          editType: d || "plot",
          impliedEdits: v
        }, x[m] = {
          valType: "number",
          dflt: null,
          editType: "calc",
          impliedEdits: y
        }, x.colorscale = {
          valType: "colorscale",
          editType: "calc",
          dflt: u,
          impliedEdits: {
            autocolorscale: !1
          }
        }, x.autocolorscale = {
          valType: "boolean",
          dflt: !1 !== t.autoColorDflt,
          editType: "calc",
          impliedEdits: {
            colorscale: void 0
          }
        }, x.reversescale = {
          valType: "boolean",
          dflt: !1,
          editType: "plot"
        }, s || (x.showscale = {
          valType: "boolean",
          dflt: c,
          editType: "calc"
        }, x.colorbar = n), t.noColorAxis || (x.coloraxis = {
          valType: "subplotid",
          regex: a("coloraxis"),
          dflt: null,
          editType: "calc"
        }), x;
      };
    }, {
      "../../lib/regex": 241,
      "../../lib/sort_object_keys": 246,
      "../colorbar/attributes": 97,
      "./scales.js": 111
    }],
    104: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib"),
        i = e("./helpers").extractOpts;
      t.exports = function (e, t, r) {
        var o,
          l = e._fullLayout,
          s = r.vals,
          c = r.containerStr,
          u = c ? a.nestedProperty(t, c).get() : t,
          d = i(u),
          f = !1 !== d.auto,
          h = d.min,
          p = d.max,
          g = d.mid,
          m = function m() {
            return a.aggNums(Math.min, null, s);
          },
          y = function y() {
            return a.aggNums(Math.max, null, s);
          };
        (void 0 === h ? h = m() : f && (h = u._colorAx && n(h) ? Math.min(h, m()) : m()), void 0 === p ? p = y() : f && (p = u._colorAx && n(p) ? Math.max(p, y()) : y()), f && void 0 !== g && (p - g > g - h ? h = g - (p - g) : p - g < g - h && (p = g + (g - h))), h === p && (h -= .5, p += .5), d._sync("min", h), d._sync("max", p), d.autocolorscale) && (o = h * p < 0 ? l.colorscale.diverging : h >= 0 ? l.colorscale.sequential : l.colorscale.sequentialminus, d._sync("colorscale", o));
      };
    }, {
      "../../lib": 225,
      "./helpers": 107,
      "fast-isnumeric": 11
    }],
    105: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("./helpers").hasColorscale,
        i = e("./helpers").extractOpts;
      t.exports = function (e, t) {
        function r(e, t) {
          var r = e["_" + t];
          void 0 !== r && (e[t] = r);
        }
        function o(e, a) {
          var o = a.container ? n.nestedProperty(e, a.container).get() : e;
          if (o) if (o.coloraxis) o._colorAx = t[o.coloraxis];else {
            var l = i(o),
              s = l.auto;
            (s || void 0 === l.min) && r(o, a.min), (s || void 0 === l.max) && r(o, a.max), l.autocolorscale && r(o, "colorscale");
          }
        }
        for (var l = 0; l < e.length; l++) {
          var s = e[l],
            c = s._module.colorbar;
          if (c) if (Array.isArray(c)) for (var u = 0; u < c.length; u++) o(s, c[u]);else o(s, c);
          a(s, "marker.line") && o(s, {
            container: "marker.line",
            min: "cmin",
            max: "cmax"
          });
        }
        for (var d in t._colorAxes) o(t[d], {
          min: "cmin",
          max: "cmax"
        });
      };
    }, {
      "../../lib": 225,
      "./helpers": 107
    }],
    106: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib"),
        i = e("../colorbar/has_colorbar"),
        o = e("../colorbar/defaults"),
        l = e("./scales").isValid,
        s = e("../../registry").traceIs;
      function c(e, t) {
        var r = t.slice(0, t.length - 1);
        return t ? a.nestedProperty(e, r).get() || {} : e;
      }
      t.exports = function e(t, r, u, d, f) {
        var h = f.prefix,
          p = f.cLetter,
          g = "_module" in r,
          m = c(t, h),
          y = c(r, h),
          v = c(r._template || {}, h) || {},
          x = function x() {
            return delete t.coloraxis, delete r.coloraxis, e(t, r, u, d, f);
          };
        if (g) {
          var b = u._colorAxes || {},
            _ = d(h + "coloraxis");
          if (_) {
            var w = s(r, "contour") && a.nestedProperty(r, "contours.coloring").get() || "heatmap",
              M = b[_];
            return void (M ? (M[2].push(x), M[0] !== w && (M[0] = !1, a.warn(["Ignoring coloraxis:", _, "setting", "as it is linked to incompatible colorscales."].join(" ")))) : b[_] = [w, r, [x]]);
          }
        }
        var T = m[p + "min"],
          k = m[p + "max"],
          A = n(T) && n(k) && T < k;
        d(h + p + "auto", !A) ? d(h + p + "mid") : (d(h + p + "min"), d(h + p + "max"));
        var L,
          D,
          S = m.colorscale,
          C = v.colorscale;
        (void 0 !== S && (L = !l(S)), void 0 !== C && (L = !l(C)), d(h + "autocolorscale", L), d(h + "colorscale"), d(h + "reversescale"), "marker.line." !== h) && (h && g && (D = i(m)), d(h + "showscale", D) && (h && v && (y._template = v), o(m, y, u)));
      };
    }, {
      "../../lib": 225,
      "../../registry": 309,
      "../colorbar/defaults": 99,
      "../colorbar/has_colorbar": 101,
      "./scales": 111,
      "fast-isnumeric": 11
    }],
    107: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("tinycolor2"),
        i = e("fast-isnumeric"),
        o = e("../../lib"),
        l = e("../color"),
        s = e("./scales").isValid;
      var c = ["showscale", "autocolorscale", "colorscale", "reversescale", "colorbar"],
        u = ["min", "max", "mid", "auto"];
      function d(e) {
        var t,
          r,
          n,
          a = e._colorAx,
          i = a || e,
          o = {};
        for (r = 0; r < c.length; r++) o[n = c[r]] = i[n];
        if (a) for (t = "c", r = 0; r < u.length; r++) o[n = u[r]] = i["c" + n];else {
          var l;
          for (r = 0; r < u.length; r++) ((l = "c" + (n = u[r])) in i || (l = "z" + n) in i) && (o[n] = i[l]);
          t = l.charAt(0);
        }
        return o._sync = function (e, r) {
          var n = -1 !== u.indexOf(e) ? t + e : e;
          i[n] = i["_" + n] = r;
        }, o;
      }
      function f(e) {
        for (var t = d(e), r = t.min, n = t.max, a = t.reversescale ? h(t.colorscale) : t.colorscale, i = a.length, o = new Array(i), l = new Array(i), s = 0; s < i; s++) {
          var c = a[s];
          o[s] = r + c[0] * (n - r), l[s] = c[1];
        }
        return {
          domain: o,
          range: l
        };
      }
      function h(e) {
        for (var t = e.length, r = new Array(t), n = t - 1, a = 0; n >= 0; n--, a++) {
          var i = e[n];
          r[a] = [1 - i[0], i[1]];
        }
        return r;
      }
      function p(e, t) {
        t = t || {};
        for (var r = e.domain, o = e.range, s = o.length, c = new Array(s), u = 0; u < s; u++) {
          var d = a(o[u]).toRgb();
          c[u] = [d.r, d.g, d.b, d.a];
        }
        var f,
          h = n.scale.linear().domain(r).range(c).clamp(!0),
          p = t.noNumericCheck,
          m = t.returnArray;
        return (f = p && m ? h : p ? function (e) {
          return g(h(e));
        } : m ? function (e) {
          return i(e) ? h(e) : a(e).isValid() ? e : l.defaultLine;
        } : function (e) {
          return i(e) ? g(h(e)) : a(e).isValid() ? e : l.defaultLine;
        }).domain = h.domain, f.range = function () {
          return o;
        }, f;
      }
      function g(e) {
        var t = {
          r: e[0],
          g: e[1],
          b: e[2],
          a: e[3]
        };
        return a(t).toRgbString();
      }
      t.exports = {
        hasColorscale: function hasColorscale(e, t, r) {
          var n = t ? o.nestedProperty(e, t).get() || {} : e,
            a = n[r || "color"],
            l = !1;
          if (o.isArrayOrTypedArray(a)) for (var c = 0; c < a.length; c++) if (i(a[c])) {
            l = !0;
            break;
          }
          return o.isPlainObject(n) && (l || !0 === n.showscale || i(n.cmin) && i(n.cmax) || s(n.colorscale) || o.isPlainObject(n.colorbar));
        },
        extractOpts: d,
        extractScale: f,
        flipScale: h,
        makeColorScaleFunc: p,
        makeColorScaleFuncFromTrace: function makeColorScaleFuncFromTrace(e, t) {
          return p(f(e), t);
        }
      };
    }, {
      "../../lib": 225,
      "../color": 96,
      "./scales": 111,
      "@plotly/d3": 6,
      "fast-isnumeric": 11,
      tinycolor2: 61
    }],
    108: [function (e, t, r) {
      "use strict";

      var n = e("./scales"),
        a = e("./helpers");
      t.exports = {
        moduleType: "component",
        name: "colorscale",
        attributes: e("./attributes"),
        layoutAttributes: e("./layout_attributes"),
        supplyLayoutDefaults: e("./layout_defaults"),
        handleDefaults: e("./defaults"),
        crossTraceDefaults: e("./cross_trace_defaults"),
        calc: e("./calc"),
        scales: n.scales,
        defaultScale: n.defaultScale,
        getScale: n.get,
        isValidScale: n.isValid,
        hasColorscale: a.hasColorscale,
        extractOpts: a.extractOpts,
        extractScale: a.extractScale,
        flipScale: a.flipScale,
        makeColorScaleFunc: a.makeColorScaleFunc,
        makeColorScaleFuncFromTrace: a.makeColorScaleFuncFromTrace
      };
    }, {
      "./attributes": 103,
      "./calc": 104,
      "./cross_trace_defaults": 105,
      "./defaults": 106,
      "./helpers": 107,
      "./layout_attributes": 109,
      "./layout_defaults": 110,
      "./scales": 111
    }],
    109: [function (e, t, r) {
      "use strict";

      var n = e("../../lib/extend").extendFlat,
        a = e("./attributes"),
        i = e("./scales").scales;
      t.exports = {
        editType: "calc",
        colorscale: {
          editType: "calc",
          sequential: {
            valType: "colorscale",
            dflt: i.Reds,
            editType: "calc"
          },
          sequentialminus: {
            valType: "colorscale",
            dflt: i.Blues,
            editType: "calc"
          },
          diverging: {
            valType: "colorscale",
            dflt: i.RdBu,
            editType: "calc"
          }
        },
        coloraxis: n({
          _isSubplotObj: !0,
          editType: "calc"
        }, a("", {
          colorAttr: "corresponding trace color array(s)",
          noColorAxis: !0,
          showScaleDflt: !0
        }))
      };
    }, {
      "../../lib/extend": 219,
      "./attributes": 103,
      "./scales": 111
    }],
    110: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plot_api/plot_template"),
        i = e("./layout_attributes"),
        o = e("./defaults");
      t.exports = function (e, t) {
        function r(r, a) {
          return n.coerce(e, t, i, r, a);
        }
        r("colorscale.sequential"), r("colorscale.sequentialminus"), r("colorscale.diverging");
        var l,
          s,
          c = t._colorAxes;
        function u(e, t) {
          return n.coerce(l, s, i.coloraxis, e, t);
        }
        for (var d in c) {
          var f = c[d];
          if (f[0]) l = e[d] || {}, (s = a.newContainer(t, d, "coloraxis"))._name = d, o(l, s, t, u, {
            prefix: "",
            cLetter: "c"
          });else {
            for (var h = 0; h < f[2].length; h++) f[2][h]();
            delete t._colorAxes[d];
          }
        }
      };
    }, {
      "../../lib": 225,
      "../../plot_api/plot_template": 261,
      "./defaults": 106,
      "./layout_attributes": 109
    }],
    111: [function (e, t, r) {
      "use strict";

      var n = e("tinycolor2"),
        a = {
          Greys: [[0, "rgb(0,0,0)"], [1, "rgb(255,255,255)"]],
          YlGnBu: [[0, "rgb(8,29,88)"], [.125, "rgb(37,52,148)"], [.25, "rgb(34,94,168)"], [.375, "rgb(29,145,192)"], [.5, "rgb(65,182,196)"], [.625, "rgb(127,205,187)"], [.75, "rgb(199,233,180)"], [.875, "rgb(237,248,217)"], [1, "rgb(255,255,217)"]],
          Greens: [[0, "rgb(0,68,27)"], [.125, "rgb(0,109,44)"], [.25, "rgb(35,139,69)"], [.375, "rgb(65,171,93)"], [.5, "rgb(116,196,118)"], [.625, "rgb(161,217,155)"], [.75, "rgb(199,233,192)"], [.875, "rgb(229,245,224)"], [1, "rgb(247,252,245)"]],
          YlOrRd: [[0, "rgb(128,0,38)"], [.125, "rgb(189,0,38)"], [.25, "rgb(227,26,28)"], [.375, "rgb(252,78,42)"], [.5, "rgb(253,141,60)"], [.625, "rgb(254,178,76)"], [.75, "rgb(254,217,118)"], [.875, "rgb(255,237,160)"], [1, "rgb(255,255,204)"]],
          Bluered: [[0, "rgb(0,0,255)"], [1, "rgb(255,0,0)"]],
          RdBu: [[0, "rgb(5,10,172)"], [.35, "rgb(106,137,247)"], [.5, "rgb(190,190,190)"], [.6, "rgb(220,170,132)"], [.7, "rgb(230,145,90)"], [1, "rgb(178,10,28)"]],
          Reds: [[0, "rgb(220,220,220)"], [.2, "rgb(245,195,157)"], [.4, "rgb(245,160,105)"], [1, "rgb(178,10,28)"]],
          Blues: [[0, "rgb(5,10,172)"], [.35, "rgb(40,60,190)"], [.5, "rgb(70,100,245)"], [.6, "rgb(90,120,245)"], [.7, "rgb(106,137,247)"], [1, "rgb(220,220,220)"]],
          Picnic: [[0, "rgb(0,0,255)"], [.1, "rgb(51,153,255)"], [.2, "rgb(102,204,255)"], [.3, "rgb(153,204,255)"], [.4, "rgb(204,204,255)"], [.5, "rgb(255,255,255)"], [.6, "rgb(255,204,255)"], [.7, "rgb(255,153,255)"], [.8, "rgb(255,102,204)"], [.9, "rgb(255,102,102)"], [1, "rgb(255,0,0)"]],
          Rainbow: [[0, "rgb(150,0,90)"], [.125, "rgb(0,0,200)"], [.25, "rgb(0,25,255)"], [.375, "rgb(0,152,255)"], [.5, "rgb(44,255,150)"], [.625, "rgb(151,255,0)"], [.75, "rgb(255,234,0)"], [.875, "rgb(255,111,0)"], [1, "rgb(255,0,0)"]],
          Portland: [[0, "rgb(12,51,131)"], [.25, "rgb(10,136,186)"], [.5, "rgb(242,211,56)"], [.75, "rgb(242,143,56)"], [1, "rgb(217,30,30)"]],
          Jet: [[0, "rgb(0,0,131)"], [.125, "rgb(0,60,170)"], [.375, "rgb(5,255,255)"], [.625, "rgb(255,255,0)"], [.875, "rgb(250,0,0)"], [1, "rgb(128,0,0)"]],
          Hot: [[0, "rgb(0,0,0)"], [.3, "rgb(230,0,0)"], [.6, "rgb(255,210,0)"], [1, "rgb(255,255,255)"]],
          Blackbody: [[0, "rgb(0,0,0)"], [.2, "rgb(230,0,0)"], [.4, "rgb(230,210,0)"], [.7, "rgb(255,255,255)"], [1, "rgb(160,200,255)"]],
          Earth: [[0, "rgb(0,0,130)"], [.1, "rgb(0,180,180)"], [.2, "rgb(40,210,40)"], [.4, "rgb(230,230,50)"], [.6, "rgb(120,70,20)"], [1, "rgb(255,255,255)"]],
          Electric: [[0, "rgb(0,0,0)"], [.15, "rgb(30,0,100)"], [.4, "rgb(120,0,100)"], [.6, "rgb(160,90,0)"], [.8, "rgb(230,200,0)"], [1, "rgb(255,250,220)"]],
          Viridis: [[0, "#440154"], [.06274509803921569, "#48186a"], [.12549019607843137, "#472d7b"], [.18823529411764706, "#424086"], [.25098039215686274, "#3b528b"], [.3137254901960784, "#33638d"], [.3764705882352941, "#2c728e"], [.4392156862745098, "#26828e"], [.5019607843137255, "#21918c"], [.5647058823529412, "#1fa088"], [.6274509803921569, "#28ae80"], [.6901960784313725, "#3fbc73"], [.7529411764705882, "#5ec962"], [.8156862745098039, "#84d44b"], [.8784313725490196, "#addc30"], [.9411764705882353, "#d8e219"], [1, "#fde725"]],
          Cividis: [[0, "rgb(0,32,76)"], [.058824, "rgb(0,42,102)"], [.117647, "rgb(0,52,110)"], [.176471, "rgb(39,63,108)"], [.235294, "rgb(60,74,107)"], [.294118, "rgb(76,85,107)"], [.352941, "rgb(91,95,109)"], [.411765, "rgb(104,106,112)"], [.470588, "rgb(117,117,117)"], [.529412, "rgb(131,129,120)"], [.588235, "rgb(146,140,120)"], [.647059, "rgb(161,152,118)"], [.705882, "rgb(176,165,114)"], [.764706, "rgb(192,177,109)"], [.823529, "rgb(209,191,102)"], [.882353, "rgb(225,204,92)"], [.941176, "rgb(243,219,79)"], [1, "rgb(255,233,69)"]]
        },
        i = a.RdBu;
      function o(e) {
        var t = 0;
        if (!Array.isArray(e) || e.length < 2) return !1;
        if (!e[0] || !e[e.length - 1]) return !1;
        if (0 != +e[0][0] || 1 != +e[e.length - 1][0]) return !1;
        for (var r = 0; r < e.length; r++) {
          var a = e[r];
          if (2 !== a.length || +a[0] < t || !n(a[1]).isValid()) return !1;
          t = +a[0];
        }
        return !0;
      }
      t.exports = {
        scales: a,
        defaultScale: i,
        get: function get(e, t) {
          if (t || (t = i), !e) return t;
          function r() {
            try {
              e = a[e] || JSON.parse(e);
            } catch (r) {
              e = t;
            }
          }
          return "string" == typeof e && (r(), "string" == typeof e && r()), o(e) ? e : t;
        },
        isValid: function isValid(e) {
          return void 0 !== a[e] || o(e);
        }
      };
    }, {
      tinycolor2: 61
    }],
    112: [function (e, t, r) {
      "use strict";

      t.exports = function (e, t, r, n, a) {
        var i = (e - r) / (n - r),
          o = i + t / (n - r),
          l = (i + o) / 2;
        return "left" === a || "bottom" === a ? i : "center" === a || "middle" === a ? l : "right" === a || "top" === a ? o : i < 2 / 3 - l ? i : o > 4 / 3 - l ? o : l;
      };
    }, {}],
    113: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = [["sw-resize", "s-resize", "se-resize"], ["w-resize", "move", "e-resize"], ["nw-resize", "n-resize", "ne-resize"]];
      t.exports = function (e, t, r, i) {
        return e = "left" === r ? 0 : "center" === r ? 1 : "right" === r ? 2 : n.constrain(Math.floor(3 * e), 0, 2), t = "bottom" === i ? 0 : "middle" === i ? 1 : "top" === i ? 2 : n.constrain(Math.floor(3 * t), 0, 2), a[t][e];
      };
    }, {
      "../../lib": 225
    }],
    114: [function (e, t, r) {
      "use strict";

      r.selectMode = function (e) {
        return "lasso" === e || "select" === e;
      }, r.drawMode = function (e) {
        return "drawclosedpath" === e || "drawopenpath" === e || "drawline" === e || "drawrect" === e || "drawcircle" === e;
      }, r.openMode = function (e) {
        return "drawline" === e || "drawopenpath" === e;
      }, r.rectMode = function (e) {
        return "select" === e || "drawline" === e || "drawrect" === e || "drawcircle" === e;
      }, r.freeMode = function (e) {
        return "lasso" === e || "drawclosedpath" === e || "drawopenpath" === e;
      }, r.selectingOrDrawing = function (e) {
        return r.freeMode(e) || r.rectMode(e);
      };
    }, {}],
    115: [function (e, t, r) {
      "use strict";

      var n = e("mouse-event-offset"),
        a = e("has-hover"),
        i = e("has-passive-events"),
        o = e("../../lib").removeElement,
        l = e("../../plots/cartesian/constants"),
        s = t.exports = {};
      s.align = e("./align"), s.getCursor = e("./cursor");
      var c = e("./unhover");
      function u() {
        var e = document.createElement("div");
        e.className = "dragcover";
        var t = e.style;
        return t.position = "fixed", t.left = 0, t.right = 0, t.top = 0, t.bottom = 0, t.zIndex = 999999999, t.background = "none", document.body.appendChild(e), e;
      }
      function d(e) {
        return n(e.changedTouches ? e.changedTouches[0] : e, document.body);
      }
      s.unhover = c.wrapped, s.unhoverRaw = c.raw, s.init = function (e) {
        var t,
          r,
          n,
          c,
          f,
          h,
          p,
          g,
          m = e.gd,
          y = 1,
          v = m._context.doubleClickDelay,
          x = e.element;
        m._mouseDownTime || (m._mouseDownTime = 0), x.style.pointerEvents = "all", x.onmousedown = _, i ? (x._ontouchstart && x.removeEventListener("touchstart", x._ontouchstart), x._ontouchstart = _, x.addEventListener("touchstart", _, {
          passive: !1
        })) : x.ontouchstart = _;
        var b = e.clampFn || function (e, t, r) {
          return Math.abs(e) < r && (e = 0), Math.abs(t) < r && (t = 0), [e, t];
        };
        function _(i) {
          m._dragged = !1, m._dragging = !0;
          var o = d(i);
          t = o[0], r = o[1], p = i.target, h = i, g = 2 === i.buttons || i.ctrlKey, void 0 === i.clientX && void 0 === i.clientY && (i.clientX = t, i.clientY = r), (n = new Date().getTime()) - m._mouseDownTime < v ? y += 1 : (y = 1, m._mouseDownTime = n), e.prepFn && e.prepFn(i, t, r), a && !g ? (f = u()).style.cursor = window.getComputedStyle(x).cursor : a || (f = document, c = window.getComputedStyle(document.documentElement).cursor, document.documentElement.style.cursor = window.getComputedStyle(x).cursor), document.addEventListener("mouseup", M), document.addEventListener("touchend", M), !1 !== e.dragmode && (i.preventDefault(), document.addEventListener("mousemove", w), document.addEventListener("touchmove", w, {
            passive: !1
          }));
        }
        function w(n) {
          n.preventDefault();
          var a = d(n),
            i = e.minDrag || l.MINDRAG,
            o = b(a[0] - t, a[1] - r, i),
            c = o[0],
            u = o[1];
          (c || u) && (m._dragged = !0, s.unhover(m, n)), m._dragged && e.moveFn && !g && (m._dragdata = {
            element: x,
            dx: c,
            dy: u
          }, e.moveFn(c, u));
        }
        function M(t) {
          if (delete m._dragdata, !1 !== e.dragmode && (t.preventDefault(), document.removeEventListener("mousemove", w), document.removeEventListener("touchmove", w)), document.removeEventListener("mouseup", M), document.removeEventListener("touchend", M), a ? o(f) : c && (f.documentElement.style.cursor = c, c = null), m._dragging) {
            if (m._dragging = !1, new Date().getTime() - m._mouseDownTime > v && (y = Math.max(y - 1, 1)), m._dragged) e.doneFn && e.doneFn();else if (e.clickFn && e.clickFn(y, h), !g) {
              var r;
              try {
                r = new MouseEvent("click", t);
              } catch (e) {
                var n = d(t);
                (r = document.createEvent("MouseEvents")).initMouseEvent("click", t.bubbles, t.cancelable, t.view, t.detail, t.screenX, t.screenY, n[0], n[1], t.ctrlKey, t.altKey, t.shiftKey, t.metaKey, t.button, t.relatedTarget);
              }
              p.dispatchEvent(r);
            }
            m._dragging = !1, m._dragged = !1;
          } else m._dragged = !1;
        }
      }, s.coverSlip = u;
    }, {
      "../../lib": 225,
      "../../plots/cartesian/constants": 279,
      "./align": 112,
      "./cursor": 113,
      "./unhover": 116,
      "has-hover": 42,
      "has-passive-events": 43,
      "mouse-event-offset": 47
    }],
    116: [function (e, t, r) {
      "use strict";

      var n = e("../../lib/events"),
        a = e("../../lib/throttle"),
        i = e("../../lib/dom").getGraphDiv,
        o = e("../fx/constants"),
        l = t.exports = {};
      l.wrapped = function (e, t, r) {
        (e = i(e))._fullLayout && a.clear(e._fullLayout._uid + o.HOVERID), l.raw(e, t, r);
      }, l.raw = function (e, t) {
        var r = e._fullLayout,
          a = e._hoverdata;
        t || (t = {}), t.target && !e._dragged && !1 === n.triggerHandler(e, "plotly_beforehover", t) || (r._hoverlayer.selectAll("g").remove(), r._hoverlayer.selectAll("line").remove(), r._hoverlayer.selectAll("circle").remove(), e._hoverdata = void 0, t.target && a && e.emit("plotly_unhover", {
          event: t,
          points: a
        }));
      };
    }, {
      "../../lib/dom": 217,
      "../../lib/events": 218,
      "../../lib/throttle": 249,
      "../fx/constants": 130
    }],
    117: [function (e, t, r) {
      "use strict";

      r.dash = {
        valType: "string",
        values: ["solid", "dot", "dash", "longdash", "dashdot", "longdashdot"],
        dflt: "solid",
        editType: "style"
      }, r.pattern = {
        shape: {
          valType: "enumerated",
          values: ["", "/", "\\", "x", "-", "|", "+", "."],
          dflt: "",
          arrayOk: !0,
          editType: "style"
        },
        fillmode: {
          valType: "enumerated",
          values: ["replace", "overlay"],
          dflt: "replace",
          editType: "style"
        },
        bgcolor: {
          valType: "color",
          arrayOk: !0,
          editType: "style"
        },
        fgcolor: {
          valType: "color",
          arrayOk: !0,
          editType: "style"
        },
        fgopacity: {
          valType: "number",
          editType: "style",
          min: 0,
          max: 1
        },
        size: {
          valType: "number",
          min: 0,
          dflt: 8,
          arrayOk: !0,
          editType: "style"
        },
        solidity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: .3,
          arrayOk: !0,
          editType: "style"
        },
        editType: "style"
      };
    }, {}],
    118: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../lib"),
        i = a.numberFormat,
        o = e("fast-isnumeric"),
        l = e("tinycolor2"),
        s = e("../../registry"),
        c = e("../color"),
        u = e("../colorscale"),
        d = a.strTranslate,
        f = e("../../lib/svg_text_utils"),
        h = e("../../constants/xmlns_namespaces"),
        p = e("../../constants/alignment").LINE_SPACING,
        g = e("../../constants/interactions").DESELECTDIM,
        m = e("../../traces/scatter/subtypes"),
        y = e("../../traces/scatter/make_bubble_size_func"),
        v = e("../../components/fx/helpers").appendArrayPointValue,
        x = t.exports = {};
      x.font = function (e, t, r, n) {
        a.isPlainObject(t) && (n = t.color, r = t.size, t = t.family), t && e.style("font-family", t), r + 1 && e.style("font-size", r + "px"), n && e.call(c.fill, n);
      }, x.setPosition = function (e, t, r) {
        e.attr("x", t).attr("y", r);
      }, x.setSize = function (e, t, r) {
        e.attr("width", t).attr("height", r);
      }, x.setRect = function (e, t, r, n, a) {
        e.call(x.setPosition, t, r).call(x.setSize, n, a);
      }, x.translatePoint = function (e, t, r, n) {
        var a = r.c2p(e.x),
          i = n.c2p(e.y);
        return !!(o(a) && o(i) && t.node()) && ("text" === t.node().nodeName ? t.attr("x", a).attr("y", i) : t.attr("transform", d(a, i)), !0);
      }, x.translatePoints = function (e, t, r) {
        e.each(function (e) {
          var a = n.select(this);
          x.translatePoint(e, a, t, r);
        });
      }, x.hideOutsideRangePoint = function (e, t, r, n, a, i) {
        t.attr("display", r.isPtWithinRange(e, a) && n.isPtWithinRange(e, i) ? null : "none");
      }, x.hideOutsideRangePoints = function (e, t) {
        if (t._hasClipOnAxisFalse) {
          var r = t.xaxis,
            a = t.yaxis;
          e.each(function (t) {
            var i = t[0].trace,
              o = i.xcalendar,
              l = i.ycalendar,
              c = s.traceIs(i, "bar-like") ? ".bartext" : ".point,.textpoint";
            e.selectAll(c).each(function (e) {
              x.hideOutsideRangePoint(e, n.select(this), r, a, o, l);
            });
          });
        }
      }, x.crispRound = function (e, t, r) {
        return t && o(t) ? e._context.staticPlot ? t : t < 1 ? 1 : Math.round(t) : r || 0;
      }, x.singleLineStyle = function (e, t, r, n, a) {
        t.style("fill", "none");
        var i = (((e || [])[0] || {}).trace || {}).line || {},
          o = r || i.width || 0,
          l = a || i.dash || "";
        c.stroke(t, n || i.color), x.dashLine(t, l, o);
      }, x.lineGroupStyle = function (e, t, r, a) {
        e.style("fill", "none").each(function (e) {
          var i = (((e || [])[0] || {}).trace || {}).line || {},
            o = t || i.width || 0,
            l = a || i.dash || "";
          n.select(this).call(c.stroke, r || i.color).call(x.dashLine, l, o);
        });
      }, x.dashLine = function (e, t, r) {
        r = +r || 0, t = x.dashStyle(t, r), e.style({
          "stroke-dasharray": t,
          "stroke-width": r + "px"
        });
      }, x.dashStyle = function (e, t) {
        t = +t || 1;
        var r = Math.max(t, 3);
        return "solid" === e ? e = "" : "dot" === e ? e = r + "px," + r + "px" : "dash" === e ? e = 3 * r + "px," + 3 * r + "px" : "longdash" === e ? e = 5 * r + "px," + 5 * r + "px" : "dashdot" === e ? e = 3 * r + "px," + r + "px," + r + "px," + r + "px" : "longdashdot" === e && (e = 5 * r + "px," + 2 * r + "px," + r + "px," + 2 * r + "px"), e;
      }, x.singleFillStyle = function (e) {
        var t = (((n.select(e.node()).data()[0] || [])[0] || {}).trace || {}).fillcolor;
        t && e.call(c.fill, t);
      }, x.fillGroupStyle = function (e) {
        e.style("stroke-width", 0).each(function (e) {
          var t = n.select(this);
          e[0].trace && t.call(c.fill, e[0].trace.fillcolor);
        });
      };
      var b = e("./symbol_defs");
      x.symbolNames = [], x.symbolFuncs = [], x.symbolNeedLines = {}, x.symbolNoDot = {}, x.symbolNoFill = {}, x.symbolList = [], Object.keys(b).forEach(function (e) {
        var t = b[e],
          r = t.n;
        x.symbolList.push(r, String(r), e, r + 100, String(r + 100), e + "-open"), x.symbolNames[r] = e, x.symbolFuncs[r] = t.f, t.needLine && (x.symbolNeedLines[r] = !0), t.noDot ? x.symbolNoDot[r] = !0 : x.symbolList.push(r + 200, String(r + 200), e + "-dot", r + 300, String(r + 300), e + "-open-dot"), t.noFill && (x.symbolNoFill[r] = !0);
      });
      var _ = x.symbolNames.length;
      function w(e, t) {
        var r = e % 100;
        return x.symbolFuncs[r](t) + (e >= 200 ? "M0,0.5L0.5,0L0,-0.5L-0.5,0Z" : "");
      }
      x.symbolNumber = function (e) {
        if (o(e)) e = +e;else if ("string" == typeof e) {
          var t = 0;
          e.indexOf("-open") > 0 && (t = 100, e = e.replace("-open", "")), e.indexOf("-dot") > 0 && (t += 200, e = e.replace("-dot", "")), (e = x.symbolNames.indexOf(e)) >= 0 && (e += t);
        }
        return e % 100 >= _ || e >= 400 ? 0 : Math.floor(Math.max(e, 0));
      };
      var M = {
          x1: 1,
          x2: 0,
          y1: 0,
          y2: 0
        },
        T = {
          x1: 0,
          x2: 0,
          y1: 1,
          y2: 0
        },
        k = i("~f"),
        A = {
          radial: {
            node: "radialGradient"
          },
          radialreversed: {
            node: "radialGradient",
            reversed: !0
          },
          horizontal: {
            node: "linearGradient",
            attrs: M
          },
          horizontalreversed: {
            node: "linearGradient",
            attrs: M,
            reversed: !0
          },
          vertical: {
            node: "linearGradient",
            attrs: T
          },
          verticalreversed: {
            node: "linearGradient",
            attrs: T,
            reversed: !0
          }
        };
      x.gradient = function (e, t, r, i, o, s) {
        for (var u = o.length, d = A[i], f = new Array(u), h = 0; h < u; h++) d.reversed ? f[u - 1 - h] = [k(100 * (1 - o[h][0])), o[h][1]] : f[h] = [k(100 * o[h][0]), o[h][1]];
        var p = t._fullLayout,
          g = "g" + p._uid + "-" + r,
          m = p._defs.select(".gradients").selectAll("#" + g).data([i + f.join(";")], a.identity);
        m.exit().remove(), m.enter().append(d.node).each(function () {
          var e = n.select(this);
          d.attrs && e.attr(d.attrs), e.attr("id", g);
          var t = e.selectAll("stop").data(f);
          t.exit().remove(), t.enter().append("stop"), t.each(function (e) {
            var t = l(e[1]);
            n.select(this).attr({
              offset: e[0] + "%",
              "stop-color": c.tinyRGB(t),
              "stop-opacity": t.getAlpha()
            });
          });
        }), e.style(s, R(g, t)).style(s + "-opacity", null);
        var y = function y(e) {
            return "." + e.attr("class").replace(/\s/g, ".");
          },
          v = y(n.select(e.node().parentNode)) + ">" + y(e);
        p._gradientUrlQueryParts[v] = 1;
      }, x.pattern = function (e, t, r, i, o, l, s, u, d, f, h, p) {
        var g = "legend" === t;
        u && ("overlay" === d ? (f = u, h = c.contrast(f)) : (f = void 0, h = u));
        var m,
          y,
          v,
          x,
          b,
          _,
          w,
          M,
          T,
          k,
          A,
          L = r._fullLayout,
          D = "p" + L._uid + "-" + i,
          S = {};
        switch (o) {
          case "/":
            m = l * Math.sqrt(2), y = l * Math.sqrt(2), _ = "path", S = {
              d: v = "M-" + m / 4 + "," + y / 4 + "l" + m / 2 + ",-" + y / 2 + "M0," + y + "L" + m + ",0M" + m / 4 * 3 + "," + y / 4 * 5 + "l" + m / 2 + ",-" + y / 2,
              opacity: p,
              stroke: h,
              "stroke-width": (x = s * l) + "px"
            };
            break;
          case "\\":
            m = l * Math.sqrt(2), y = l * Math.sqrt(2), _ = "path", S = {
              d: v = "M" + m / 4 * 3 + ",-" + y / 4 + "l" + m / 2 + "," + y / 2 + "M0,0L" + m + "," + y + "M-" + m / 4 + "," + y / 4 * 3 + "l" + m / 2 + "," + y / 2,
              opacity: p,
              stroke: h,
              "stroke-width": (x = s * l) + "px"
            };
            break;
          case "x":
            m = l * Math.sqrt(2), y = l * Math.sqrt(2), v = "M-" + m / 4 + "," + y / 4 + "l" + m / 2 + ",-" + y / 2 + "M0," + y + "L" + m + ",0M" + m / 4 * 3 + "," + y / 4 * 5 + "l" + m / 2 + ",-" + y / 2 + "M" + m / 4 * 3 + ",-" + y / 4 + "l" + m / 2 + "," + y / 2 + "M0,0L" + m + "," + y + "M-" + m / 4 + "," + y / 4 * 3 + "l" + m / 2 + "," + y / 2, x = l - l * Math.sqrt(1 - s), _ = "path", S = {
              d: v,
              opacity: p,
              stroke: h,
              "stroke-width": x + "px"
            };
            break;
          case "|":
            _ = "path", _ = "path", S = {
              d: v = "M" + (m = l) / 2 + ",0L" + m / 2 + "," + (y = l),
              opacity: p,
              stroke: h,
              "stroke-width": (x = s * l) + "px"
            };
            break;
          case "-":
            _ = "path", _ = "path", S = {
              d: v = "M0," + (y = l) / 2 + "L" + (m = l) + "," + y / 2,
              opacity: p,
              stroke: h,
              "stroke-width": (x = s * l) + "px"
            };
            break;
          case "+":
            _ = "path", v = "M" + (m = l) / 2 + ",0L" + m / 2 + "," + (y = l) + "M0," + y / 2 + "L" + m + "," + y / 2, x = l - l * Math.sqrt(1 - s), _ = "path", S = {
              d: v,
              opacity: p,
              stroke: h,
              "stroke-width": x + "px"
            };
            break;
          case ".":
            m = l, y = l, s < Math.PI / 4 ? b = Math.sqrt(s * l * l / Math.PI) : (w = s, M = Math.PI / 4, T = 1, k = l / 2, A = l / Math.sqrt(2), b = k + (A - k) * (w - M) / (T - M)), _ = "circle", S = {
              cx: m / 2,
              cy: y / 2,
              r: b,
              opacity: p,
              fill: h
            };
        }
        var C = [o || "noSh", f || "noBg", h || "noFg", l, s].join(";"),
          O = L._defs.select(".patterns").selectAll("#" + D).data([C], a.identity);
        O.exit().remove(), O.enter().append("pattern").each(function () {
          var e = n.select(this);
          if (e.attr({
            id: D,
            width: m + "px",
            height: y + "px",
            patternUnits: "userSpaceOnUse",
            patternTransform: g ? "scale(0.8)" : ""
          }), f) {
            var t = e.selectAll("rect").data([0]);
            t.exit().remove(), t.enter().append("rect").attr({
              width: m + "px",
              height: y + "px",
              fill: f
            });
          }
          var r = e.selectAll(_).data([0]);
          r.exit().remove(), r.enter().append(_).attr(S);
        }), e.style("fill", R(D, r)).style("fill-opacity", null), e.classed("pattern_filled", !0);
        var P = "." + n.select(e.node().parentNode).attr("class").replace(/\s/g, ".") + ">.pattern_filled";
        L._patternUrlQueryParts[P] = 1;
      }, x.initGradients = function (e) {
        var t = e._fullLayout;
        a.ensureSingle(t._defs, "g", "gradients").selectAll("linearGradient,radialGradient").remove(), t._gradientUrlQueryParts = {};
      }, x.initPatterns = function (e) {
        var t = e._fullLayout;
        a.ensureSingle(t._defs, "g", "patterns").selectAll("pattern").remove(), t._patternUrlQueryParts = {};
      }, x.getPatternAttr = function (e, t, r) {
        return e && a.isArrayOrTypedArray(e) ? t < e.length ? e[t] : r : e;
      }, x.pointStyle = function (e, t, r) {
        if (e.size()) {
          var a = x.makePointStyleFns(t);
          e.each(function (e) {
            x.singlePointStyle(e, n.select(this), t, a, r);
          });
        }
      }, x.singlePointStyle = function (e, t, r, n, i) {
        var o = r.marker,
          l = o.line;
        if (t.style("opacity", n.selectedOpacityFn ? n.selectedOpacityFn(e) : void 0 === e.mo ? o.opacity : e.mo), n.ms2mrc) {
          var s;
          s = "various" === e.ms || "various" === o.size ? 3 : n.ms2mrc(e.ms), e.mrc = s, n.selectedSizeFn && (s = e.mrc = n.selectedSizeFn(e));
          var u = x.symbolNumber(e.mx || o.symbol) || 0;
          e.om = u % 200 >= 100, t.attr("d", w(u, s));
        }
        var d,
          f,
          h,
          p = !1;
        if (e.so) h = l.outlierwidth, f = l.outliercolor, d = o.outliercolor;else {
          var g = (l || {}).width;
          h = (e.mlw + 1 || g + 1 || (e.trace ? (e.trace.marker.line || {}).width : 0) + 1) - 1 || 0, f = "mlc" in e ? e.mlcc = n.lineScale(e.mlc) : a.isArrayOrTypedArray(l.color) ? c.defaultLine : l.color, a.isArrayOrTypedArray(o.color) && (d = c.defaultLine, p = !0), d = "mc" in e ? e.mcc = n.markerScale(e.mc) : o.color || "rgba(0,0,0,0)", n.selectedColorFn && (d = n.selectedColorFn(e));
        }
        if (e.om) t.call(c.stroke, d).style({
          "stroke-width": (h || 1) + "px",
          fill: "none"
        });else {
          t.style("stroke-width", (e.isBlank ? 0 : h) + "px");
          var m = o.gradient,
            y = e.mgt;
          y ? p = !0 : y = m && m.type, a.isArrayOrTypedArray(y) && (y = y[0], A[y] || (y = 0));
          var v = o.pattern,
            b = v && x.getPatternAttr(v.shape, e.i, "");
          if (y && "none" !== y) {
            var _ = e.mgc;
            _ ? p = !0 : _ = m.color;
            var M = r.uid;
            p && (M += "-" + e.i), x.gradient(t, i, M, y, [[0, _], [1, d]], "fill");
          } else if (b) {
            var T = x.getPatternAttr(v.bgcolor, e.i, null),
              k = x.getPatternAttr(v.fgcolor, e.i, null),
              L = v.fgopacity,
              D = x.getPatternAttr(v.size, e.i, 8),
              S = x.getPatternAttr(v.solidity, e.i, .3),
              C = e.mcc || a.isArrayOrTypedArray(v.shape) || a.isArrayOrTypedArray(v.bgcolor) || a.isArrayOrTypedArray(v.size) || a.isArrayOrTypedArray(v.solidity),
              O = r.uid;
            C && (O += "-" + e.i), x.pattern(t, "point", i, O, b, D, S, e.mcc, v.fillmode, T, k, L);
          } else c.fill(t, d);
          h && c.stroke(t, f);
        }
      }, x.makePointStyleFns = function (e) {
        var t = {},
          r = e.marker;
        return t.markerScale = x.tryColorscale(r, ""), t.lineScale = x.tryColorscale(r, "line"), s.traceIs(e, "symbols") && (t.ms2mrc = m.isBubble(e) ? y(e) : function () {
          return (r.size || 6) / 2;
        }), e.selectedpoints && a.extendFlat(t, x.makeSelectedPointStyleFns(e)), t;
      }, x.makeSelectedPointStyleFns = function (e) {
        var t = {},
          r = e.selected || {},
          n = e.unselected || {},
          i = e.marker || {},
          o = r.marker || {},
          l = n.marker || {},
          c = i.opacity,
          u = o.opacity,
          d = l.opacity,
          f = void 0 !== u,
          h = void 0 !== d;
        (a.isArrayOrTypedArray(c) || f || h) && (t.selectedOpacityFn = function (e) {
          var t = void 0 === e.mo ? i.opacity : e.mo;
          return e.selected ? f ? u : t : h ? d : g * t;
        });
        var p = i.color,
          m = o.color,
          y = l.color;
        (m || y) && (t.selectedColorFn = function (e) {
          var t = e.mcc || p;
          return e.selected ? m || t : y || t;
        });
        var v = i.size,
          x = o.size,
          b = l.size,
          _ = void 0 !== x,
          w = void 0 !== b;
        return s.traceIs(e, "symbols") && (_ || w) && (t.selectedSizeFn = function (e) {
          var t = e.mrc || v / 2;
          return e.selected ? _ ? x / 2 : t : w ? b / 2 : t;
        }), t;
      }, x.makeSelectedTextStyleFns = function (e) {
        var t = {},
          r = e.selected || {},
          n = e.unselected || {},
          a = e.textfont || {},
          i = r.textfont || {},
          o = n.textfont || {},
          l = a.color,
          s = i.color,
          u = o.color;
        return t.selectedTextColorFn = function (e) {
          var t = e.tc || l;
          return e.selected ? s || t : u || (s ? t : c.addOpacity(t, g));
        }, t;
      }, x.selectedPointStyle = function (e, t) {
        if (e.size() && t.selectedpoints) {
          var r = x.makeSelectedPointStyleFns(t),
            a = t.marker || {},
            i = [];
          r.selectedOpacityFn && i.push(function (e, t) {
            e.style("opacity", r.selectedOpacityFn(t));
          }), r.selectedColorFn && i.push(function (e, t) {
            c.fill(e, r.selectedColorFn(t));
          }), r.selectedSizeFn && i.push(function (e, t) {
            var n = t.mx || a.symbol || 0,
              i = r.selectedSizeFn(t);
            e.attr("d", w(x.symbolNumber(n), i)), t.mrc2 = i;
          }), i.length && e.each(function (e) {
            for (var t = n.select(this), r = 0; r < i.length; r++) i[r](t, e);
          });
        }
      }, x.tryColorscale = function (e, t) {
        var r = t ? a.nestedProperty(e, t).get() : e;
        if (r) {
          var n = r.color;
          if ((r.colorscale || r._colorAx) && a.isArrayOrTypedArray(n)) return u.makeColorScaleFuncFromTrace(r);
        }
        return a.identity;
      };
      var L = {
        start: 1,
        end: -1,
        middle: 0,
        bottom: 1,
        top: -1
      };
      function D(e, t, r, a) {
        var i = n.select(e.node().parentNode),
          o = -1 !== t.indexOf("top") ? "top" : -1 !== t.indexOf("bottom") ? "bottom" : "middle",
          l = -1 !== t.indexOf("left") ? "end" : -1 !== t.indexOf("right") ? "start" : "middle",
          s = a ? a / .8 + 1 : 0,
          c = (f.lineCount(e) - 1) * p + 1,
          u = L[l] * s,
          h = .75 * r + L[o] * s + (L[o] - 1) * c * r / 2;
        e.attr("text-anchor", l), i.attr("transform", d(u, h));
      }
      function S(e, t) {
        var r = e.ts || t.textfont.size;
        return o(r) && r > 0 ? r : 0;
      }
      x.textPointStyle = function (e, t, r) {
        if (e.size()) {
          var i;
          if (t.selectedpoints) {
            var o = x.makeSelectedTextStyleFns(t);
            i = o.selectedTextColorFn;
          }
          var l = t.texttemplate,
            s = r._fullLayout;
          e.each(function (e) {
            var o = n.select(this),
              c = l ? a.extractOption(e, t, "txt", "texttemplate") : a.extractOption(e, t, "tx", "text");
            if (c || 0 === c) {
              if (l) {
                var u = t._module.formatLabels,
                  d = u ? u(e, t, s) : {},
                  h = {};
                v(h, t, e.i);
                var p = t._meta || {};
                c = a.texttemplateString(c, d, s._d3locale, h, e, p);
              }
              var g = e.tp || t.textposition,
                m = S(e, t),
                y = i ? i(e) : e.tc || t.textfont.color;
              o.call(x.font, e.tf || t.textfont.family, m, y).text(c).call(f.convertToTspans, r).call(D, g, m, e.mrc);
            } else o.remove();
          });
        }
      }, x.selectedTextStyle = function (e, t) {
        if (e.size() && t.selectedpoints) {
          var r = x.makeSelectedTextStyleFns(t);
          e.each(function (e) {
            var a = n.select(this),
              i = r.selectedTextColorFn(e),
              o = e.tp || t.textposition,
              l = S(e, t);
            c.fill(a, i), D(a, o, l, e.mrc2 || e.mrc);
          });
        }
      };
      function C(e, t, r, a) {
        var i = e[0] - t[0],
          o = e[1] - t[1],
          l = r[0] - t[0],
          s = r[1] - t[1],
          c = Math.pow(i * i + o * o, .25),
          u = Math.pow(l * l + s * s, .25),
          d = (u * u * i - c * c * l) * a,
          f = (u * u * o - c * c * s) * a,
          h = 3 * u * (c + u),
          p = 3 * c * (c + u);
        return [[n.round(t[0] + (h && d / h), 2), n.round(t[1] + (h && f / h), 2)], [n.round(t[0] - (p && d / p), 2), n.round(t[1] - (p && f / p), 2)]];
      }
      x.smoothopen = function (e, t) {
        if (e.length < 3) return "M" + e.join("L");
        var r,
          n = "M" + e[0],
          a = [];
        for (r = 1; r < e.length - 1; r++) a.push(C(e[r - 1], e[r], e[r + 1], t));
        for (n += "Q" + a[0][0] + " " + e[1], r = 2; r < e.length - 1; r++) n += "C" + a[r - 2][1] + " " + a[r - 1][0] + " " + e[r];
        return n += "Q" + a[e.length - 3][1] + " " + e[e.length - 1];
      }, x.smoothclosed = function (e, t) {
        if (e.length < 3) return "M" + e.join("L") + "Z";
        var r,
          n = "M" + e[0],
          a = e.length - 1,
          i = [C(e[a], e[0], e[1], t)];
        for (r = 1; r < a; r++) i.push(C(e[r - 1], e[r], e[r + 1], t));
        for (i.push(C(e[a - 1], e[a], e[0], t)), r = 1; r <= a; r++) n += "C" + i[r - 1][1] + " " + i[r][0] + " " + e[r];
        return n += "C" + i[a][1] + " " + i[0][0] + " " + e[0] + "Z";
      };
      var O = {
          hv: function hv(e, t) {
            return "H" + n.round(t[0], 2) + "V" + n.round(t[1], 2);
          },
          vh: function vh(e, t) {
            return "V" + n.round(t[1], 2) + "H" + n.round(t[0], 2);
          },
          hvh: function hvh(e, t) {
            return "H" + n.round((e[0] + t[0]) / 2, 2) + "V" + n.round(t[1], 2) + "H" + n.round(t[0], 2);
          },
          vhv: function vhv(e, t) {
            return "V" + n.round((e[1] + t[1]) / 2, 2) + "H" + n.round(t[0], 2) + "V" + n.round(t[1], 2);
          }
        },
        P = function P(e, t) {
          return "L" + n.round(t[0], 2) + "," + n.round(t[1], 2);
        };
      x.steps = function (e) {
        var t = O[e] || P;
        return function (e) {
          for (var r = "M" + n.round(e[0][0], 2) + "," + n.round(e[0][1], 2), a = 1; a < e.length; a++) r += t(e[a - 1], e[a]);
          return r;
        };
      }, x.makeTester = function () {
        var e = a.ensureSingleById(n.select("body"), "svg", "js-plotly-tester", function (e) {
            e.attr(h.svgAttrs).style({
              position: "absolute",
              left: "-10000px",
              top: "-10000px",
              width: "9000px",
              height: "9000px",
              "z-index": "1"
            });
          }),
          t = a.ensureSingle(e, "path", "js-reference-point", function (e) {
            e.attr("d", "M0,0H1V1H0Z").style({
              "stroke-width": 0,
              fill: "black"
            });
          });
        x.tester = e, x.testref = t;
      }, x.savedBBoxes = {};
      var I = 0;
      function z(e) {
        var t = e.getAttribute("data-unformatted");
        if (null !== t) return t + e.getAttribute("data-math") + e.getAttribute("text-anchor") + e.getAttribute("style");
      }
      function R(e, t) {
        if (!e) return null;
        var r = t._context,
          n = r._exportedPlot ? "" : r._baseUrl || "";
        return n ? "url('" + n + "#" + e + "')" : "url(#" + e + ")";
      }
      x.bBox = function (e, t, r) {
        var i, o, l;
        if (r || (r = z(e)), r) {
          if (i = x.savedBBoxes[r]) return a.extendFlat({}, i);
        } else if (1 === e.childNodes.length) {
          var s = e.childNodes[0];
          if (r = z(s)) {
            var c = +s.getAttribute("x") || 0,
              u = +s.getAttribute("y") || 0,
              d = s.getAttribute("transform");
            if (!d) {
              var h = x.bBox(s, !1, r);
              return c && (h.left += c, h.right += c), u && (h.top += u, h.bottom += u), h;
            }
            if (r += "~" + c + "~" + u + "~" + d, i = x.savedBBoxes[r]) return a.extendFlat({}, i);
          }
        }
        t ? o = e : (l = x.tester.node(), o = e.cloneNode(!0), l.appendChild(o)), n.select(o).attr("transform", null).call(f.positionText, 0, 0);
        var p = o.getBoundingClientRect(),
          g = x.testref.node().getBoundingClientRect();
        t || l.removeChild(o);
        var m = {
          height: p.height,
          width: p.width,
          left: p.left - g.left,
          top: p.top - g.top,
          right: p.right - g.left,
          bottom: p.bottom - g.top
        };
        return I >= 1e4 && (x.savedBBoxes = {}, I = 0), r && (x.savedBBoxes[r] = m), I++, a.extendFlat({}, m);
      }, x.setClipUrl = function (e, t, r) {
        e.attr("clip-path", R(t, r));
      }, x.getTranslate = function (e) {
        var t = (e[e.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/, function (e, t, r) {
          return [t, r].join(" ");
        }).split(" ");
        return {
          x: +t[0] || 0,
          y: +t[1] || 0
        };
      }, x.setTranslate = function (e, t, r) {
        var n = e.attr ? "attr" : "getAttribute",
          a = e.attr ? "attr" : "setAttribute",
          i = e[n]("transform") || "";
        return t = t || 0, r = r || 0, i = i.replace(/(\btranslate\(.*?\);?)/, "").trim(), i = (i += d(t, r)).trim(), e[a]("transform", i), i;
      }, x.getScale = function (e) {
        var t = (e[e.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/, function (e, t, r) {
          return [t, r].join(" ");
        }).split(" ");
        return {
          x: +t[0] || 1,
          y: +t[1] || 1
        };
      }, x.setScale = function (e, t, r) {
        var n = e.attr ? "attr" : "getAttribute",
          a = e.attr ? "attr" : "setAttribute",
          i = e[n]("transform") || "";
        return t = t || 1, r = r || 1, i = i.replace(/(\bscale\(.*?\);?)/, "").trim(), i = (i += "scale(" + t + "," + r + ")").trim(), e[a]("transform", i), i;
      };
      var N = /\s*sc.*/;
      x.setPointGroupScale = function (e, t, r) {
        if (t = t || 1, r = r || 1, e) {
          var n = 1 === t && 1 === r ? "" : "scale(" + t + "," + r + ")";
          e.each(function () {
            var e = (this.getAttribute("transform") || "").replace(N, "");
            e = (e += n).trim(), this.setAttribute("transform", e);
          });
        }
      };
      var F = /translate\([^)]*\)\s*$/;
      x.setTextPointsScale = function (e, t, r) {
        e && e.each(function () {
          var e,
            a = n.select(this),
            i = a.select("text");
          if (i.node()) {
            var o = parseFloat(i.attr("x") || 0),
              l = parseFloat(i.attr("y") || 0),
              s = (a.attr("transform") || "").match(F);
            e = 1 === t && 1 === r ? [] : [d(o, l), "scale(" + t + "," + r + ")", d(-o, -l)], s && e.push(s), a.attr("transform", e.join(""));
          }
        });
      };
    }, {
      "../../components/fx/helpers": 132,
      "../../constants/alignment": 201,
      "../../constants/interactions": 204,
      "../../constants/xmlns_namespaces": 206,
      "../../lib": 225,
      "../../lib/svg_text_utils": 248,
      "../../registry": 309,
      "../../traces/scatter/make_bubble_size_func": 360,
      "../../traces/scatter/subtypes": 368,
      "../color": 96,
      "../colorscale": 108,
      "./symbol_defs": 119,
      "@plotly/d3": 6,
      "fast-isnumeric": 11,
      tinycolor2: 61
    }],
    119: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3");
      t.exports = {
        circle: {
          n: 0,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M" + t + ",0A" + t + "," + t + " 0 1,1 0,-" + t + "A" + t + "," + t + " 0 0,1 " + t + ",0Z";
          }
        },
        square: {
          n: 1,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M" + t + "," + t + "H-" + t + "V-" + t + "H" + t + "Z";
          }
        },
        diamond: {
          n: 2,
          f: function f(e) {
            var t = n.round(1.3 * e, 2);
            return "M" + t + ",0L0," + t + "L-" + t + ",0L0,-" + t + "Z";
          }
        },
        cross: {
          n: 3,
          f: function f(e) {
            var t = n.round(.4 * e, 2),
              r = n.round(1.2 * e, 2);
            return "M" + r + "," + t + "H" + t + "V" + r + "H-" + t + "V" + t + "H-" + r + "V-" + t + "H-" + t + "V-" + r + "H" + t + "V-" + t + "H" + r + "Z";
          }
        },
        x: {
          n: 4,
          f: function f(e) {
            var t = n.round(.8 * e / Math.sqrt(2), 2),
              r = "l" + t + "," + t,
              a = "l" + t + ",-" + t,
              i = "l-" + t + ",-" + t,
              o = "l-" + t + "," + t;
            return "M0," + t + r + a + i + a + i + o + i + o + r + o + r + "Z";
          }
        },
        "triangle-up": {
          n: 5,
          f: function f(e) {
            var t = n.round(2 * e / Math.sqrt(3), 2);
            return "M-" + t + "," + n.round(e / 2, 2) + "H" + t + "L0,-" + n.round(e, 2) + "Z";
          }
        },
        "triangle-down": {
          n: 6,
          f: function f(e) {
            var t = n.round(2 * e / Math.sqrt(3), 2);
            return "M-" + t + ",-" + n.round(e / 2, 2) + "H" + t + "L0," + n.round(e, 2) + "Z";
          }
        },
        "triangle-left": {
          n: 7,
          f: function f(e) {
            var t = n.round(2 * e / Math.sqrt(3), 2);
            return "M" + n.round(e / 2, 2) + ",-" + t + "V" + t + "L-" + n.round(e, 2) + ",0Z";
          }
        },
        "triangle-right": {
          n: 8,
          f: function f(e) {
            var t = n.round(2 * e / Math.sqrt(3), 2);
            return "M-" + n.round(e / 2, 2) + ",-" + t + "V" + t + "L" + n.round(e, 2) + ",0Z";
          }
        },
        "triangle-ne": {
          n: 9,
          f: function f(e) {
            var t = n.round(.6 * e, 2),
              r = n.round(1.2 * e, 2);
            return "M-" + r + ",-" + t + "H" + t + "V" + r + "Z";
          }
        },
        "triangle-se": {
          n: 10,
          f: function f(e) {
            var t = n.round(.6 * e, 2),
              r = n.round(1.2 * e, 2);
            return "M" + t + ",-" + r + "V" + t + "H-" + r + "Z";
          }
        },
        "triangle-sw": {
          n: 11,
          f: function f(e) {
            var t = n.round(.6 * e, 2),
              r = n.round(1.2 * e, 2);
            return "M" + r + "," + t + "H-" + t + "V-" + r + "Z";
          }
        },
        "triangle-nw": {
          n: 12,
          f: function f(e) {
            var t = n.round(.6 * e, 2),
              r = n.round(1.2 * e, 2);
            return "M-" + t + "," + r + "V-" + t + "H" + r + "Z";
          }
        },
        pentagon: {
          n: 13,
          f: function f(e) {
            var t = n.round(.951 * e, 2),
              r = n.round(.588 * e, 2),
              a = n.round(-e, 2),
              i = n.round(-.309 * e, 2);
            return "M" + t + "," + i + "L" + r + "," + n.round(.809 * e, 2) + "H-" + r + "L-" + t + "," + i + "L0," + a + "Z";
          }
        },
        hexagon: {
          n: 14,
          f: function f(e) {
            var t = n.round(e, 2),
              r = n.round(e / 2, 2),
              a = n.round(e * Math.sqrt(3) / 2, 2);
            return "M" + a + ",-" + r + "V" + r + "L0," + t + "L-" + a + "," + r + "V-" + r + "L0,-" + t + "Z";
          }
        },
        hexagon2: {
          n: 15,
          f: function f(e) {
            var t = n.round(e, 2),
              r = n.round(e / 2, 2),
              a = n.round(e * Math.sqrt(3) / 2, 2);
            return "M-" + r + "," + a + "H" + r + "L" + t + ",0L" + r + ",-" + a + "H-" + r + "L-" + t + ",0Z";
          }
        },
        octagon: {
          n: 16,
          f: function f(e) {
            var t = n.round(.924 * e, 2),
              r = n.round(.383 * e, 2);
            return "M-" + r + ",-" + t + "H" + r + "L" + t + ",-" + r + "V" + r + "L" + r + "," + t + "H-" + r + "L-" + t + "," + r + "V-" + r + "Z";
          }
        },
        star: {
          n: 17,
          f: function f(e) {
            var t = 1.4 * e,
              r = n.round(.225 * t, 2),
              a = n.round(.951 * t, 2),
              i = n.round(.363 * t, 2),
              o = n.round(.588 * t, 2),
              l = n.round(-t, 2),
              s = n.round(-.309 * t, 2),
              c = n.round(.118 * t, 2),
              u = n.round(.809 * t, 2);
            return "M" + r + "," + s + "H" + a + "L" + i + "," + c + "L" + o + "," + u + "L0," + n.round(.382 * t, 2) + "L-" + o + "," + u + "L-" + i + "," + c + "L-" + a + "," + s + "H-" + r + "L0," + l + "Z";
          }
        },
        hexagram: {
          n: 18,
          f: function f(e) {
            var t = n.round(.66 * e, 2),
              r = n.round(.38 * e, 2),
              a = n.round(.76 * e, 2);
            return "M-" + a + ",0l-" + r + ",-" + t + "h" + a + "l" + r + ",-" + t + "l" + r + "," + t + "h" + a + "l-" + r + "," + t + "l" + r + "," + t + "h-" + a + "l-" + r + "," + t + "l-" + r + ",-" + t + "h-" + a + "Z";
          }
        },
        "star-triangle-up": {
          n: 19,
          f: function f(e) {
            var t = n.round(e * Math.sqrt(3) * .8, 2),
              r = n.round(.8 * e, 2),
              a = n.round(1.6 * e, 2),
              i = n.round(4 * e, 2),
              o = "A " + i + "," + i + " 0 0 1 ";
            return "M-" + t + "," + r + o + t + "," + r + o + "0,-" + a + o + "-" + t + "," + r + "Z";
          }
        },
        "star-triangle-down": {
          n: 20,
          f: function f(e) {
            var t = n.round(e * Math.sqrt(3) * .8, 2),
              r = n.round(.8 * e, 2),
              a = n.round(1.6 * e, 2),
              i = n.round(4 * e, 2),
              o = "A " + i + "," + i + " 0 0 1 ";
            return "M" + t + ",-" + r + o + "-" + t + ",-" + r + o + "0," + a + o + t + ",-" + r + "Z";
          }
        },
        "star-square": {
          n: 21,
          f: function f(e) {
            var t = n.round(1.1 * e, 2),
              r = n.round(2 * e, 2),
              a = "A " + r + "," + r + " 0 0 1 ";
            return "M-" + t + ",-" + t + a + "-" + t + "," + t + a + t + "," + t + a + t + ",-" + t + a + "-" + t + ",-" + t + "Z";
          }
        },
        "star-diamond": {
          n: 22,
          f: function f(e) {
            var t = n.round(1.4 * e, 2),
              r = n.round(1.9 * e, 2),
              a = "A " + r + "," + r + " 0 0 1 ";
            return "M-" + t + ",0" + a + "0," + t + a + t + ",0" + a + "0,-" + t + a + "-" + t + ",0Z";
          }
        },
        "diamond-tall": {
          n: 23,
          f: function f(e) {
            var t = n.round(.7 * e, 2),
              r = n.round(1.4 * e, 2);
            return "M0," + r + "L" + t + ",0L0,-" + r + "L-" + t + ",0Z";
          }
        },
        "diamond-wide": {
          n: 24,
          f: function f(e) {
            var t = n.round(1.4 * e, 2),
              r = n.round(.7 * e, 2);
            return "M0," + r + "L" + t + ",0L0,-" + r + "L-" + t + ",0Z";
          }
        },
        hourglass: {
          n: 25,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M" + t + "," + t + "H-" + t + "L" + t + ",-" + t + "H-" + t + "Z";
          },
          noDot: !0
        },
        bowtie: {
          n: 26,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M" + t + "," + t + "V-" + t + "L-" + t + "," + t + "V-" + t + "Z";
          },
          noDot: !0
        },
        "circle-cross": {
          n: 27,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M0," + t + "V-" + t + "M" + t + ",0H-" + t + "M" + t + ",0A" + t + "," + t + " 0 1,1 0,-" + t + "A" + t + "," + t + " 0 0,1 " + t + ",0Z";
          },
          needLine: !0,
          noDot: !0
        },
        "circle-x": {
          n: 28,
          f: function f(e) {
            var t = n.round(e, 2),
              r = n.round(e / Math.sqrt(2), 2);
            return "M" + r + "," + r + "L-" + r + ",-" + r + "M" + r + ",-" + r + "L-" + r + "," + r + "M" + t + ",0A" + t + "," + t + " 0 1,1 0,-" + t + "A" + t + "," + t + " 0 0,1 " + t + ",0Z";
          },
          needLine: !0,
          noDot: !0
        },
        "square-cross": {
          n: 29,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M0," + t + "V-" + t + "M" + t + ",0H-" + t + "M" + t + "," + t + "H-" + t + "V-" + t + "H" + t + "Z";
          },
          needLine: !0,
          noDot: !0
        },
        "square-x": {
          n: 30,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M" + t + "," + t + "L-" + t + ",-" + t + "M" + t + ",-" + t + "L-" + t + "," + t + "M" + t + "," + t + "H-" + t + "V-" + t + "H" + t + "Z";
          },
          needLine: !0,
          noDot: !0
        },
        "diamond-cross": {
          n: 31,
          f: function f(e) {
            var t = n.round(1.3 * e, 2);
            return "M" + t + ",0L0," + t + "L-" + t + ",0L0,-" + t + "ZM0,-" + t + "V" + t + "M-" + t + ",0H" + t;
          },
          needLine: !0,
          noDot: !0
        },
        "diamond-x": {
          n: 32,
          f: function f(e) {
            var t = n.round(1.3 * e, 2),
              r = n.round(.65 * e, 2);
            return "M" + t + ",0L0," + t + "L-" + t + ",0L0,-" + t + "ZM-" + r + ",-" + r + "L" + r + "," + r + "M-" + r + "," + r + "L" + r + ",-" + r;
          },
          needLine: !0,
          noDot: !0
        },
        "cross-thin": {
          n: 33,
          f: function f(e) {
            var t = n.round(1.4 * e, 2);
            return "M0," + t + "V-" + t + "M" + t + ",0H-" + t;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "x-thin": {
          n: 34,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M" + t + "," + t + "L-" + t + ",-" + t + "M" + t + ",-" + t + "L-" + t + "," + t;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        asterisk: {
          n: 35,
          f: function f(e) {
            var t = n.round(1.2 * e, 2),
              r = n.round(.85 * e, 2);
            return "M0," + t + "V-" + t + "M" + t + ",0H-" + t + "M" + r + "," + r + "L-" + r + ",-" + r + "M" + r + ",-" + r + "L-" + r + "," + r;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        hash: {
          n: 36,
          f: function f(e) {
            var t = n.round(e / 2, 2),
              r = n.round(e, 2);
            return "M" + t + "," + r + "V-" + r + "m-" + r + ",0V" + r + "M" + r + "," + t + "H-" + r + "m0,-" + r + "H" + r;
          },
          needLine: !0,
          noFill: !0
        },
        "y-up": {
          n: 37,
          f: function f(e) {
            var t = n.round(1.2 * e, 2),
              r = n.round(1.6 * e, 2),
              a = n.round(.8 * e, 2);
            return "M-" + t + "," + a + "L0,0M" + t + "," + a + "L0,0M0,-" + r + "L0,0";
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "y-down": {
          n: 38,
          f: function f(e) {
            var t = n.round(1.2 * e, 2),
              r = n.round(1.6 * e, 2),
              a = n.round(.8 * e, 2);
            return "M-" + t + ",-" + a + "L0,0M" + t + ",-" + a + "L0,0M0," + r + "L0,0";
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "y-left": {
          n: 39,
          f: function f(e) {
            var t = n.round(1.2 * e, 2),
              r = n.round(1.6 * e, 2),
              a = n.round(.8 * e, 2);
            return "M" + a + "," + t + "L0,0M" + a + ",-" + t + "L0,0M-" + r + ",0L0,0";
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "y-right": {
          n: 40,
          f: function f(e) {
            var t = n.round(1.2 * e, 2),
              r = n.round(1.6 * e, 2),
              a = n.round(.8 * e, 2);
            return "M-" + a + "," + t + "L0,0M-" + a + ",-" + t + "L0,0M" + r + ",0L0,0";
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-ew": {
          n: 41,
          f: function f(e) {
            var t = n.round(1.4 * e, 2);
            return "M" + t + ",0H-" + t;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-ns": {
          n: 42,
          f: function f(e) {
            var t = n.round(1.4 * e, 2);
            return "M0," + t + "V-" + t;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-ne": {
          n: 43,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M" + t + ",-" + t + "L-" + t + "," + t;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "line-nw": {
          n: 44,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M" + t + "," + t + "L-" + t + ",-" + t;
          },
          needLine: !0,
          noDot: !0,
          noFill: !0
        },
        "arrow-up": {
          n: 45,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M0,0L-" + t + "," + n.round(2 * e, 2) + "H" + t + "Z";
          },
          noDot: !0
        },
        "arrow-down": {
          n: 46,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M0,0L-" + t + ",-" + n.round(2 * e, 2) + "H" + t + "Z";
          },
          noDot: !0
        },
        "arrow-left": {
          n: 47,
          f: function f(e) {
            var t = n.round(2 * e, 2),
              r = n.round(e, 2);
            return "M0,0L" + t + ",-" + r + "V" + r + "Z";
          },
          noDot: !0
        },
        "arrow-right": {
          n: 48,
          f: function f(e) {
            var t = n.round(2 * e, 2),
              r = n.round(e, 2);
            return "M0,0L-" + t + ",-" + r + "V" + r + "Z";
          },
          noDot: !0
        },
        "arrow-bar-up": {
          n: 49,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M-" + t + ",0H" + t + "M0,0L-" + t + "," + n.round(2 * e, 2) + "H" + t + "Z";
          },
          needLine: !0,
          noDot: !0
        },
        "arrow-bar-down": {
          n: 50,
          f: function f(e) {
            var t = n.round(e, 2);
            return "M-" + t + ",0H" + t + "M0,0L-" + t + ",-" + n.round(2 * e, 2) + "H" + t + "Z";
          },
          needLine: !0,
          noDot: !0
        },
        "arrow-bar-left": {
          n: 51,
          f: function f(e) {
            var t = n.round(2 * e, 2),
              r = n.round(e, 2);
            return "M0,-" + r + "V" + r + "M0,0L" + t + ",-" + r + "V" + r + "Z";
          },
          needLine: !0,
          noDot: !0
        },
        "arrow-bar-right": {
          n: 52,
          f: function f(e) {
            var t = n.round(2 * e, 2),
              r = n.round(e, 2);
            return "M0,-" + r + "V" + r + "M0,0L-" + t + ",-" + r + "V" + r + "Z";
          },
          needLine: !0,
          noDot: !0
        }
      };
    }, {
      "@plotly/d3": 6
    }],
    120: [function (e, t, r) {
      "use strict";

      t.exports = {
        visible: {
          valType: "boolean",
          editType: "calc"
        },
        type: {
          valType: "enumerated",
          values: ["percent", "constant", "sqrt", "data"],
          editType: "calc"
        },
        symmetric: {
          valType: "boolean",
          editType: "calc"
        },
        array: {
          valType: "data_array",
          editType: "calc"
        },
        arrayminus: {
          valType: "data_array",
          editType: "calc"
        },
        value: {
          valType: "number",
          min: 0,
          dflt: 10,
          editType: "calc"
        },
        valueminus: {
          valType: "number",
          min: 0,
          dflt: 10,
          editType: "calc"
        },
        traceref: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "style"
        },
        tracerefminus: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "style"
        },
        copy_ystyle: {
          valType: "boolean",
          editType: "plot"
        },
        copy_zstyle: {
          valType: "boolean",
          editType: "style"
        },
        color: {
          valType: "color",
          editType: "style"
        },
        thickness: {
          valType: "number",
          min: 0,
          dflt: 2,
          editType: "style"
        },
        width: {
          valType: "number",
          min: 0,
          editType: "plot"
        },
        editType: "calc",
        _deprecated: {
          opacity: {
            valType: "number",
            editType: "style"
          }
        }
      };
    }, {}],
    121: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../registry"),
        i = e("../../plots/cartesian/axes"),
        o = e("../../lib"),
        l = e("./compute_error");
      function s(e, t, r, a) {
        var s = t["error_" + a] || {},
          c = [];
        if (s.visible && -1 !== ["linear", "log"].indexOf(r.type)) {
          for (var u = l(s), d = 0; d < e.length; d++) {
            var f = e[d],
              h = f.i;
            if (void 0 === h) h = d;else if (null === h) continue;
            var p = f[a];
            if (n(r.c2l(p))) {
              var g = u(p, h);
              if (n(g[0]) && n(g[1])) {
                var m = f[a + "s"] = p - g[0],
                  y = f[a + "h"] = p + g[1];
                c.push(m, y);
              }
            }
          }
          var v = r._id,
            x = t._extremes[v],
            b = i.findExtremes(r, c, o.extendFlat({
              tozero: x.opts.tozero
            }, {
              padded: !0
            }));
          x.min = x.min.concat(b.min), x.max = x.max.concat(b.max);
        }
      }
      t.exports = function (e) {
        for (var t = e.calcdata, r = 0; r < t.length; r++) {
          var n = t[r],
            o = n[0].trace;
          if (!0 === o.visible && a.traceIs(o, "errorBarsOK")) {
            var l = i.getFromId(e, o.xaxis),
              c = i.getFromId(e, o.yaxis);
            s(n, o, l, "x"), s(n, o, c, "y");
          }
        }
      };
    }, {
      "../../lib": 225,
      "../../plots/cartesian/axes": 272,
      "../../registry": 309,
      "./compute_error": 122,
      "fast-isnumeric": 11
    }],
    122: [function (e, t, r) {
      "use strict";

      function n(e, t) {
        return "percent" === e ? function (e) {
          return Math.abs(e * t / 100);
        } : "constant" === e ? function () {
          return Math.abs(t);
        } : "sqrt" === e ? function (e) {
          return Math.sqrt(Math.abs(e));
        } : void 0;
      }
      t.exports = function (e) {
        var t = e.type,
          r = e.symmetric;
        if ("data" === t) {
          var a = e.array || [];
          if (r) return function (e, t) {
            var r = +a[t];
            return [r, r];
          };
          var i = e.arrayminus || [];
          return function (e, t) {
            var r = +a[t],
              n = +i[t];
            return isNaN(r) && isNaN(n) ? [NaN, NaN] : [n || 0, r || 0];
          };
        }
        var o = n(t, e.value),
          l = n(t, e.valueminus);
        return r || void 0 === e.valueminus ? function (e) {
          var t = o(e);
          return [t, t];
        } : function (e) {
          return [l(e), o(e)];
        };
      };
    }, {}],
    123: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../registry"),
        i = e("../../lib"),
        o = e("../../plot_api/plot_template"),
        l = e("./attributes");
      t.exports = function (e, t, r, s) {
        var c = "error_" + s.axis,
          u = o.newContainer(t, c),
          d = e[c] || {};
        function f(e, t) {
          return i.coerce(d, u, l, e, t);
        }
        if (!1 !== f("visible", void 0 !== d.array || void 0 !== d.value || "sqrt" === d.type)) {
          var h = f("type", "array" in d ? "data" : "percent"),
            p = !0;
          "sqrt" !== h && (p = f("symmetric", !(("data" === h ? "arrayminus" : "valueminus") in d))), "data" === h ? (f("array"), f("traceref"), p || (f("arrayminus"), f("tracerefminus"))) : "percent" !== h && "constant" !== h || (f("value"), p || f("valueminus"));
          var g = "copy_" + s.inherit + "style";
          if (s.inherit) (t["error_" + s.inherit] || {}).visible && f(g, !(d.color || n(d.thickness) || n(d.width)));
          s.inherit && u[g] || (f("color", r), f("thickness"), f("width", a.traceIs(t, "gl3d") ? 0 : 4));
        }
      };
    }, {
      "../../lib": 225,
      "../../plot_api/plot_template": 261,
      "../../registry": 309,
      "./attributes": 120,
      "fast-isnumeric": 11
    }],
    124: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plot_api/edit_types").overrideAll,
        i = e("./attributes"),
        o = {
          error_x: n.extendFlat({}, i),
          error_y: n.extendFlat({}, i)
        };
      delete o.error_x.copy_zstyle, delete o.error_y.copy_zstyle, delete o.error_y.copy_ystyle;
      var l = {
        error_x: n.extendFlat({}, i),
        error_y: n.extendFlat({}, i),
        error_z: n.extendFlat({}, i)
      };
      delete l.error_x.copy_ystyle, delete l.error_y.copy_ystyle, delete l.error_z.copy_ystyle, delete l.error_z.copy_zstyle, t.exports = {
        moduleType: "component",
        name: "errorbars",
        schema: {
          traces: {
            scatter: o,
            bar: o,
            histogram: o,
            scatter3d: a(l, "calc", "nested"),
            scattergl: a(o, "calc", "nested")
          }
        },
        supplyDefaults: e("./defaults"),
        calc: e("./calc"),
        makeComputeError: e("./compute_error"),
        plot: e("./plot"),
        style: e("./style"),
        hoverInfo: function hoverInfo(e, t, r) {
          (t.error_y || {}).visible && (r.yerr = e.yh - e.y, t.error_y.symmetric || (r.yerrneg = e.y - e.ys));
          (t.error_x || {}).visible && (r.xerr = e.xh - e.x, t.error_x.symmetric || (r.xerrneg = e.x - e.xs));
        }
      };
    }, {
      "../../lib": 225,
      "../../plot_api/edit_types": 254,
      "./attributes": 120,
      "./calc": 121,
      "./compute_error": 122,
      "./defaults": 123,
      "./plot": 125,
      "./style": 126
    }],
    125: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("fast-isnumeric"),
        i = e("../drawing"),
        o = e("../../traces/scatter/subtypes");
      t.exports = function (e, t, r, l) {
        var s = r.xaxis,
          c = r.yaxis,
          u = l && l.duration > 0;
        t.each(function (t) {
          var d,
            f = t[0].trace,
            h = f.error_x || {},
            p = f.error_y || {};
          f.ids && (d = function d(e) {
            return e.id;
          });
          var g = o.hasMarkers(f) && f.marker.maxdisplayed > 0;
          p.visible || h.visible || (t = []);
          var m = n.select(this).selectAll("g.errorbar").data(t, d);
          if (m.exit().remove(), t.length) {
            h.visible || m.selectAll("path.xerror").remove(), p.visible || m.selectAll("path.yerror").remove(), m.style("opacity", 1);
            var y = m.enter().append("g").classed("errorbar", !0);
            u && y.style("opacity", 0).transition().duration(l.duration).style("opacity", 1), i.setClipUrl(m, r.layerClipId, e), m.each(function (e) {
              var t = n.select(this),
                r = function (e, t, r) {
                  var n = {
                    x: t.c2p(e.x),
                    y: r.c2p(e.y)
                  };
                  void 0 !== e.yh && (n.yh = r.c2p(e.yh), n.ys = r.c2p(e.ys), a(n.ys) || (n.noYS = !0, n.ys = r.c2p(e.ys, !0)));
                  void 0 !== e.xh && (n.xh = t.c2p(e.xh), n.xs = t.c2p(e.xs), a(n.xs) || (n.noXS = !0, n.xs = t.c2p(e.xs, !0)));
                  return n;
                }(e, s, c);
              if (!g || e.vis) {
                var i,
                  o = t.select("path.yerror");
                if (p.visible && a(r.x) && a(r.yh) && a(r.ys)) {
                  var d = p.width;
                  i = "M" + (r.x - d) + "," + r.yh + "h" + 2 * d + "m-" + d + ",0V" + r.ys, r.noYS || (i += "m-" + d + ",0h" + 2 * d), !o.size() ? o = t.append("path").style("vector-effect", "non-scaling-stroke").classed("yerror", !0) : u && (o = o.transition().duration(l.duration).ease(l.easing)), o.attr("d", i);
                } else o.remove();
                var f = t.select("path.xerror");
                if (h.visible && a(r.y) && a(r.xh) && a(r.xs)) {
                  var m = (h.copy_ystyle ? p : h).width;
                  i = "M" + r.xh + "," + (r.y - m) + "v" + 2 * m + "m0,-" + m + "H" + r.xs, r.noXS || (i += "m0,-" + m + "v" + 2 * m), !f.size() ? f = t.append("path").style("vector-effect", "non-scaling-stroke").classed("xerror", !0) : u && (f = f.transition().duration(l.duration).ease(l.easing)), f.attr("d", i);
                } else f.remove();
              }
            });
          }
        });
      };
    }, {
      "../../traces/scatter/subtypes": 368,
      "../drawing": 118,
      "@plotly/d3": 6,
      "fast-isnumeric": 11
    }],
    126: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../color");
      t.exports = function (e) {
        e.each(function (e) {
          var t = e[0].trace,
            r = t.error_y || {},
            i = t.error_x || {},
            o = n.select(this);
          o.selectAll("path.yerror").style("stroke-width", r.thickness + "px").call(a.stroke, r.color), i.copy_ystyle && (i = r), o.selectAll("path.xerror").style("stroke-width", i.thickness + "px").call(a.stroke, i.color);
        });
      };
    }, {
      "../color": 96,
      "@plotly/d3": 6
    }],
    127: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/font_attributes"),
        a = e("./layout_attributes").hoverlabel,
        i = e("../../lib/extend").extendFlat;
      t.exports = {
        hoverlabel: {
          bgcolor: i({}, a.bgcolor, {
            arrayOk: !0
          }),
          bordercolor: i({}, a.bordercolor, {
            arrayOk: !0
          }),
          font: n({
            arrayOk: !0,
            editType: "none"
          }),
          align: i({}, a.align, {
            arrayOk: !0
          }),
          namelength: i({}, a.namelength, {
            arrayOk: !0
          }),
          editType: "none"
        }
      };
    }, {
      "../../lib/extend": 219,
      "../../plots/font_attributes": 301,
      "./layout_attributes": 137
    }],
    128: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../registry");
      function i(e, t, r, a) {
        a = a || n.identity, Array.isArray(e) && (t[0][r] = a(e));
      }
      t.exports = function (e) {
        var t = e.calcdata,
          r = e._fullLayout;
        function o(e) {
          return function (t) {
            return n.coerceHoverinfo({
              hoverinfo: t
            }, {
              _module: e._module
            }, r);
          };
        }
        for (var l = 0; l < t.length; l++) {
          var s = t[l],
            c = s[0].trace;
          if (!a.traceIs(c, "pie-like")) {
            var u = a.traceIs(c, "2dMap") ? i : n.fillArray;
            u(c.hoverinfo, s, "hi", o(c)), c.hovertemplate && u(c.hovertemplate, s, "ht"), c.hoverlabel && (u(c.hoverlabel.bgcolor, s, "hbg"), u(c.hoverlabel.bordercolor, s, "hbc"), u(c.hoverlabel.font.size, s, "hts"), u(c.hoverlabel.font.color, s, "htc"), u(c.hoverlabel.font.family, s, "htf"), u(c.hoverlabel.namelength, s, "hnl"), u(c.hoverlabel.align, s, "hta"));
          }
        }
      };
    }, {
      "../../lib": 225,
      "../../registry": 309
    }],
    129: [function (e, t, r) {
      "use strict";

      var n = e("../../registry"),
        a = e("./hover").hover;
      t.exports = function (e, t, r) {
        var i = n.getComponentMethod("annotations", "onClick")(e, e._hoverdata);
        function o() {
          e.emit("plotly_click", {
            points: e._hoverdata,
            event: t
          });
        }
        void 0 !== r && a(e, t, r, !0), e._hoverdata && t && t.target && (i && i.then ? i.then(o) : o(), t.stopImmediatePropagation && t.stopImmediatePropagation());
      };
    }, {
      "../../registry": 309,
      "./hover": 133
    }],
    130: [function (e, t, r) {
      "use strict";

      t.exports = {
        YANGLE: 60,
        HOVERARROWSIZE: 6,
        HOVERTEXTPAD: 3,
        HOVERFONTSIZE: 13,
        HOVERFONT: "Arial, sans-serif",
        HOVERMINTIME: 50,
        HOVERID: "-hover"
      };
    }, {}],
    131: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("./attributes"),
        i = e("./hoverlabel_defaults");
      t.exports = function (e, t, r, o) {
        var l = n.extendFlat({}, o.hoverlabel);
        t.hovertemplate && (l.namelength = -1), i(e, t, function (r, i) {
          return n.coerce(e, t, a, r, i);
        }, l);
      };
    }, {
      "../../lib": 225,
      "./attributes": 127,
      "./hoverlabel_defaults": 134
    }],
    132: [function (e, t, r) {
      "use strict";

      var n = e("../../lib");
      r.getSubplot = function (e) {
        return e.subplot || e.xaxis + e.yaxis || e.geo;
      }, r.isTraceInSubplots = function (e, t) {
        if ("splom" === e.type) {
          for (var n = e.xaxes || [], a = e.yaxes || [], i = 0; i < n.length; i++) for (var o = 0; o < a.length; o++) if (-1 !== t.indexOf(n[i] + a[o])) return !0;
          return !1;
        }
        return -1 !== t.indexOf(r.getSubplot(e));
      }, r.flat = function (e, t) {
        for (var r = new Array(e.length), n = 0; n < e.length; n++) r[n] = t;
        return r;
      }, r.p2c = function (e, t) {
        for (var r = new Array(e.length), n = 0; n < e.length; n++) r[n] = e[n].p2c(t);
        return r;
      }, r.getDistanceFunction = function (e, t, n, a) {
        return "closest" === e ? a || r.quadrature(t, n) : "x" === e.charAt(0) ? t : n;
      }, r.getClosest = function (e, t, r) {
        if (!1 !== r.index) r.index >= 0 && r.index < e.length ? r.distance = 0 : r.index = !1;else for (var n = 0; n < e.length; n++) {
          var a = t(e[n]);
          a <= r.distance && (r.index = n, r.distance = a);
        }
        return r;
      }, r.inbox = function (e, t, r) {
        return e * t < 0 || 0 === e ? r : 1 / 0;
      }, r.quadrature = function (e, t) {
        return function (r) {
          var n = e(r),
            a = t(r);
          return Math.sqrt(n * n + a * a);
        };
      }, r.makeEventData = function (e, t, n) {
        var a = "index" in e ? e.index : e.pointNumber,
          i = {
            data: t._input,
            fullData: t,
            curveNumber: t.index,
            pointNumber: a
          };
        if (t._indexToPoints) {
          var o = t._indexToPoints[a];
          1 === o.length ? i.pointIndex = o[0] : i.pointIndices = o;
        } else i.pointIndex = a;
        return t._module.eventData ? i = t._module.eventData(i, e, t, n, a) : ("xVal" in e ? i.x = e.xVal : "x" in e && (i.x = e.x), "yVal" in e ? i.y = e.yVal : "y" in e && (i.y = e.y), e.xa && (i.xaxis = e.xa), e.ya && (i.yaxis = e.ya), void 0 !== e.zLabelVal && (i.z = e.zLabelVal)), r.appendArrayPointValue(i, t, a), i;
      }, r.appendArrayPointValue = function (e, t, r) {
        var a = t._arrayAttrs;
        if (a) for (var l = 0; l < a.length; l++) {
          var s = a[l],
            c = i(s);
          if (void 0 === e[c]) {
            var u = o(n.nestedProperty(t, s).get(), r);
            void 0 !== u && (e[c] = u);
          }
        }
      }, r.appendArrayMultiPointValues = function (e, t, r) {
        var a = t._arrayAttrs;
        if (a) for (var l = 0; l < a.length; l++) {
          var s = a[l],
            c = i(s);
          if (void 0 === e[c]) {
            for (var u = n.nestedProperty(t, s).get(), d = new Array(r.length), f = 0; f < r.length; f++) d[f] = o(u, r[f]);
            e[c] = d;
          }
        }
      };
      var a = {
        ids: "id",
        locations: "location",
        labels: "label",
        values: "value",
        "marker.colors": "color",
        parents: "parent"
      };
      function i(e) {
        return a[e] || e;
      }
      function o(e, t) {
        return Array.isArray(t) ? Array.isArray(e) && Array.isArray(e[t[0]]) ? e[t[0]][t[1]] : void 0 : e[t];
      }
      var l = {
          x: !0,
          y: !0
        },
        s = {
          "x unified": !0,
          "y unified": !0
        };
      r.isUnifiedHover = function (e) {
        return "string" == typeof e && !!s[e];
      }, r.isXYhover = function (e) {
        return "string" == typeof e && !!l[e];
      };
    }, {
      "../../lib": 225
    }],
    133: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("fast-isnumeric"),
        i = e("tinycolor2"),
        o = e("../../lib"),
        l = o.strTranslate,
        s = o.strRotate,
        c = e("../../lib/events"),
        u = e("../../lib/svg_text_utils"),
        d = e("../../lib/override_cursor"),
        f = e("../drawing"),
        h = e("../color"),
        p = e("../dragelement"),
        g = e("../../plots/cartesian/axes"),
        m = e("../../registry"),
        y = e("./helpers"),
        v = e("./constants"),
        x = e("../legend/defaults"),
        b = e("../legend/draw"),
        _ = v.YANGLE,
        w = Math.PI * _ / 180,
        M = 1 / Math.sin(w),
        T = Math.cos(w),
        k = Math.sin(w),
        A = v.HOVERARROWSIZE,
        L = v.HOVERTEXTPAD,
        D = {
          box: !0,
          ohlc: !0,
          violin: !0,
          candlestick: !0
        },
        S = {
          scatter: !0,
          scattergl: !0,
          splom: !0
        };
      function C(e) {
        return [e.trace.index, e.index, e.x0, e.y0, e.name, e.attr, e.xa ? e.xa._id : "", e.ya ? e.ya._id : ""].join(",");
      }
      r.hover = function (e, t, r, i) {
        e = o.getGraphDiv(e), o.throttle(e._fullLayout._uid + v.HOVERID, v.HOVERMINTIME, function () {
          !function (e, t, r, i) {
            r || (r = "xy");
            var l = Array.isArray(r) ? r : [r],
              s = e._fullLayout,
              u = s._plots || [],
              f = u[r],
              g = s._has("cartesian");
            if (f) {
              var v = f.overlays.map(function (e) {
                return e.id;
              });
              l = l.concat(v);
            }
            for (var x = l.length, b = new Array(x), _ = new Array(x), w = !1, T = 0; T < x; T++) {
              var k = l[T];
              if (u[k]) w = !0, b[T] = u[k].xaxis, _[T] = u[k].yaxis;else {
                if (!s[k] || !s[k]._subplot) return void o.warn("Unrecognized subplot: " + k);
                var A = s[k]._subplot;
                b[T] = A.xaxis, _[T] = A.yaxis;
              }
            }
            var L = t.hovermode || s.hovermode;
            L && !w && (L = "closest");
            if (-1 === ["x", "y", "closest", "x unified", "y unified"].indexOf(L) || !e.calcdata || e.querySelector(".zoombox") || e._dragging) return p.unhoverRaw(e, t);
            var O = s.hoverdistance;
            -1 === O && (O = 1 / 0);
            var I = s.spikedistance;
            -1 === I && (I = 1 / 0);
            var E,
              Y,
              U,
              V,
              q,
              G,
              Z,
              W,
              J,
              X,
              Q,
              K,
              $,
              ee = [],
              te = [],
              re = {
                hLinePoint: null,
                vLinePoint: null
              },
              ne = !1;
            if (Array.isArray(t)) for (L = "array", U = 0; U < t.length; U++) (q = e.calcdata[t[U].curveNumber || 0]) && (G = q[0].trace, "skip" !== q[0].trace.hoverinfo && (te.push(q), "h" === G.orientation && (ne = !0)));else {
              for (V = 0; V < e.calcdata.length; V++) q = e.calcdata[V], "skip" !== (G = q[0].trace).hoverinfo && y.isTraceInSubplots(G, l) && (te.push(q), "h" === G.orientation && (ne = !0));
              var ae, ie;
              if (!t.target) ae = "xpx" in t ? t.xpx : b[0]._length / 2, ie = "ypx" in t ? t.ypx : _[0]._length / 2;else {
                if (!1 === c.triggerHandler(e, "plotly_beforehover", t)) return;
                var oe = t.composedPath && t.composedPath()[0];
                oe || (oe = t.target);
                var le = oe.getBoundingClientRect();
                ae = t.clientX - le.left, ie = t.clientY - le.top, s._calcInverseTransform(e);
                var se = o.apply3DTransform(s._invTransform)(ae, ie);
                if (ae = se[0], ie = se[1], ae < 0 || ae > b[0]._length || ie < 0 || ie > _[0]._length) return p.unhoverRaw(e, t);
              }
              if (t.pointerX = ae + b[0]._offset, t.pointerY = ie + _[0]._offset, E = "xval" in t ? y.flat(l, t.xval) : y.p2c(b, ae), Y = "yval" in t ? y.flat(l, t.yval) : y.p2c(_, ie), !a(E[0]) || !a(Y[0])) return o.warn("Fx.hover failed", t, e), p.unhoverRaw(e, t);
            }
            var ce = 1 / 0;
            function ue(e, r) {
              for (V = 0; V < te.length; V++) if ((q = te[V]) && q[0] && q[0].trace && !0 === (G = q[0].trace).visible && 0 !== G._length && -1 === ["carpet", "contourcarpet"].indexOf(G._module.name)) {
                if ("splom" === G.type ? Z = l[W = 0] : (Z = y.getSubplot(G), W = l.indexOf(Z)), J = L, y.isUnifiedHover(J) && (J = J.charAt(0)), K = {
                  cd: q,
                  trace: G,
                  xa: b[W],
                  ya: _[W],
                  maxHoverDistance: O,
                  maxSpikeDistance: I,
                  index: !1,
                  distance: Math.min(ce, O),
                  spikeDistance: 1 / 0,
                  xSpike: void 0,
                  ySpike: void 0,
                  color: h.defaultLine,
                  name: G.name,
                  x0: void 0,
                  x1: void 0,
                  y0: void 0,
                  y1: void 0,
                  xLabelVal: void 0,
                  yLabelVal: void 0,
                  zLabelVal: void 0,
                  text: void 0
                }, s[Z] && (K.subplot = s[Z]._subplot), s._splomScenes && s._splomScenes[G.uid] && (K.scene = s._splomScenes[G.uid]), $ = ee.length, "array" === J) {
                  var n = t[V];
                  "pointNumber" in n ? (K.index = n.pointNumber, J = "closest") : (J = "", "xval" in n && (X = n.xval, J = "x"), "yval" in n && (Q = n.yval, J = J ? "closest" : "y"));
                } else void 0 !== e && void 0 !== r ? (X = e, Q = r) : (X = E[W], Q = Y[W]);
                if (0 !== O) if (G._module && G._module.hoverPoints) {
                  var i = G._module.hoverPoints(K, X, Q, J, {
                    finiteRange: !0,
                    hoverLayer: s._hoverlayer
                  });
                  if (i) for (var c, u = 0; u < i.length; u++) c = i[u], a(c.x0) && a(c.y0) && ee.push(R(c, L));
                } else o.log("Unrecognized trace type in hover:", G);
                if ("closest" === L && ee.length > $ && (ee.splice(0, $), ce = ee[0].distance), g && 0 !== I && 0 === ee.length) {
                  K.distance = I, K.index = !1;
                  var d = G._module.hoverPoints(K, X, Q, "closest", {
                    hoverLayer: s._hoverlayer
                  });
                  if (d && (d = d.filter(function (e) {
                    return e.spikeDistance <= I;
                  })), d && d.length) {
                    var f,
                      p = d.filter(function (e) {
                        return e.xa.showspikes && "hovered data" !== e.xa.spikesnap;
                      });
                    if (p.length) {
                      var m = p[0];
                      a(m.x0) && a(m.y0) && (f = fe(m), (!re.vLinePoint || re.vLinePoint.spikeDistance > f.spikeDistance) && (re.vLinePoint = f));
                    }
                    var v = d.filter(function (e) {
                      return e.ya.showspikes && "hovered data" !== e.ya.spikesnap;
                    });
                    if (v.length) {
                      var x = v[0];
                      a(x.x0) && a(x.y0) && (f = fe(x), (!re.hLinePoint || re.hLinePoint.spikeDistance > f.spikeDistance) && (re.hLinePoint = f));
                    }
                  }
                }
              }
            }
            function de(e, t, r) {
              for (var n, a = null, i = 1 / 0, o = 0; o < e.length; o++) n = e[o].spikeDistance, r && 0 === o && (n = -1 / 0), n <= i && n <= t && (a = e[o], i = n);
              return a;
            }
            function fe(e) {
              return e ? {
                xa: e.xa,
                ya: e.ya,
                x: void 0 !== e.xSpike ? e.xSpike : (e.x0 + e.x1) / 2,
                y: void 0 !== e.ySpike ? e.ySpike : (e.y0 + e.y1) / 2,
                distance: e.distance,
                spikeDistance: e.spikeDistance,
                curveNumber: e.trace.index,
                color: e.color,
                pointNumber: e.index
              } : null;
            }
            ue();
            var he = {
                fullLayout: s,
                container: s._hoverlayer,
                event: t
              },
              pe = e._spikepoints,
              ge = {
                vLinePoint: re.vLinePoint,
                hLinePoint: re.hLinePoint
              };
            e._spikepoints = ge;
            var me = function me() {
              ee.sort(function (e, t) {
                return e.distance - t.distance;
              }), ee = function (e, t) {
                for (var r = t.charAt(0), n = [], a = [], i = [], o = 0; o < e.length; o++) {
                  var l = e[o];
                  m.traceIs(l.trace, "bar-like") || m.traceIs(l.trace, "box-violin") ? i.push(l) : l.trace[r + "period"] ? a.push(l) : n.push(l);
                }
                return n.concat(a).concat(i);
              }(ee, L);
            };
            me();
            var ye = L.charAt(0),
              ve = ("x" === ye || "y" === ye) && ee[0] && S[ee[0].trace.type];
            if (g && 0 !== I && 0 !== ee.length) {
              var xe = de(ee.filter(function (e) {
                return e.ya.showspikes;
              }), I, ve);
              re.hLinePoint = fe(xe);
              var be = de(ee.filter(function (e) {
                return e.xa.showspikes;
              }), I, ve);
              re.vLinePoint = fe(be);
            }
            if (0 === ee.length) {
              var _e = p.unhoverRaw(e, t);
              return !g || null === re.hLinePoint && null === re.vLinePoint || F(pe) && N(e, re, he), _e;
            }
            g && F(pe) && N(e, re, he);
            if (y.isXYhover(J) && 0 !== ee[0].length && "splom" !== ee[0].trace.type) {
              var we = ee[0],
                Me = (ee = D[we.trace.type] ? ee.filter(function (e) {
                  return e.trace.index === we.trace.index;
                }) : [we]).length,
                Te = j("x", we, s),
                ke = j("y", we, s);
              ue(Te, ke);
              var Ae,
                Le = [],
                De = {},
                Se = 0,
                Ce = function Ce(e) {
                  var t = D[e.trace.type] ? C(e) : e.trace.index;
                  if (De[t]) {
                    var r = De[t] - 1,
                      n = Le[r];
                    r > 0 && Math.abs(e.distance) < Math.abs(n.distance) && (Le[r] = e);
                  } else Se++, De[t] = Se, Le.push(e);
                };
              for (Ae = 0; Ae < Me; Ae++) Ce(ee[Ae]);
              for (Ae = ee.length - 1; Ae > Me - 1; Ae--) Ce(ee[Ae]);
              ee = Le, me();
            }
            var Oe = e._hoverdata,
              Pe = [],
              Ie = H(e),
              ze = B(e);
            for (U = 0; U < ee.length; U++) {
              var Re = ee[U],
                Ne = y.makeEventData(Re, Re.trace, Re.cd);
              if (!1 !== Re.hovertemplate) {
                var Fe = !1;
                Re.cd[Re.index] && Re.cd[Re.index].ht && (Fe = Re.cd[Re.index].ht), Re.hovertemplate = Fe || Re.trace.hovertemplate || !1;
              }
              if (Re.xa && Re.ya) {
                var Ee = Re.x0 + Re.xa._offset,
                  je = Re.x1 + Re.xa._offset,
                  He = Re.y0 + Re.ya._offset,
                  Be = Re.y1 + Re.ya._offset,
                  Ye = Math.min(Ee, je),
                  Ue = Math.max(Ee, je),
                  Ve = Math.min(He, Be),
                  qe = Math.max(He, Be);
                Ne.bbox = {
                  x0: Ye + ze,
                  x1: Ue + ze,
                  y0: Ve + Ie,
                  y1: qe + Ie
                };
              }
              Re.eventData = [Ne], Pe.push(Ne);
            }
            e._hoverdata = Pe;
            var Ge = "y" === L && (te.length > 1 || ee.length > 1) || "closest" === L && ne && ee.length > 1,
              Ze = h.combine(s.plot_bgcolor || h.background, s.paper_bgcolor),
              We = P(ee, {
                gd: e,
                hovermode: L,
                rotateLabels: Ge,
                bgColor: Ze,
                container: s._hoverlayer,
                outerContainer: s._paper.node(),
                commonLabelOpts: s.hoverlabel,
                hoverdistance: s.hoverdistance
              });
            y.isUnifiedHover(L) || (!function (e, t, r) {
              var n,
                a,
                i,
                o,
                l,
                s,
                c,
                u = 0,
                d = 1,
                f = e.size(),
                h = new Array(f),
                p = 0;
              function g(e) {
                var t = e[0],
                  r = e[e.length - 1];
                if (a = t.pmin - t.pos - t.dp + t.size, i = r.pos + r.dp + r.size - t.pmax, a > .01) {
                  for (l = e.length - 1; l >= 0; l--) e[l].dp += a;
                  n = !1;
                }
                if (!(i < .01)) {
                  if (a < -.01) {
                    for (l = e.length - 1; l >= 0; l--) e[l].dp -= i;
                    n = !1;
                  }
                  if (n) {
                    var c = 0;
                    for (o = 0; o < e.length; o++) (s = e[o]).pos + s.dp + s.size > t.pmax && c++;
                    for (o = e.length - 1; o >= 0 && !(c <= 0); o--) (s = e[o]).pos > t.pmax - 1 && (s.del = !0, c--);
                    for (o = 0; o < e.length && !(c <= 0); o++) if ((s = e[o]).pos < t.pmin + 1) for (s.del = !0, c--, i = 2 * s.size, l = e.length - 1; l >= 0; l--) e[l].dp -= i;
                    for (o = e.length - 1; o >= 0 && !(c <= 0); o--) (s = e[o]).pos + s.dp + s.size > t.pmax && (s.del = !0, c--);
                  }
                }
              }
              e.each(function (e) {
                var n = e[t],
                  a = "x" === n._id.charAt(0),
                  i = n.range;
                0 === p && i && i[0] > i[1] !== a && (d = -1), h[p++] = [{
                  datum: e,
                  traceIndex: e.trace.index,
                  dp: 0,
                  pos: e.pos,
                  posref: e.posref,
                  size: e.by * (a ? M : 1) / 2,
                  pmin: 0,
                  pmax: a ? r.width : r.height
                }];
              }), h.sort(function (e, t) {
                return e[0].posref - t[0].posref || d * (t[0].traceIndex - e[0].traceIndex);
              });
              for (; !n && u <= f;) {
                for (u++, n = !0, o = 0; o < h.length - 1;) {
                  var m = h[o],
                    y = h[o + 1],
                    v = m[m.length - 1],
                    x = y[0];
                  if ((a = v.pos + v.dp + v.size - x.pos - x.dp + x.size) > .01 && v.pmin === x.pmin && v.pmax === x.pmax) {
                    for (l = y.length - 1; l >= 0; l--) y[l].dp += a;
                    for (m.push.apply(m, y), h.splice(o + 1, 1), c = 0, l = m.length - 1; l >= 0; l--) c += m[l].dp;
                    for (i = c / m.length, l = m.length - 1; l >= 0; l--) m[l].dp -= i;
                    n = !1;
                  } else o++;
                }
                h.forEach(g);
              }
              for (o = h.length - 1; o >= 0; o--) {
                var b = h[o];
                for (l = b.length - 1; l >= 0; l--) {
                  var _ = b[l],
                    w = _.datum;
                  w.offset = _.dp, w.del = _.del;
                }
              }
            }(We, Ge ? "xa" : "ya", s), z(We, Ge, s._invScaleX, s._invScaleY));
            if (t.target && t.target.tagName) {
              var Je = m.getComponentMethod("annotations", "hasClickToShow")(e, Pe);
              d(n.select(t.target), Je ? "pointer" : "");
            }
            if (!t.target || i || !function (e, t, r) {
              if (!r || r.length !== e._hoverdata.length) return !0;
              for (var n = r.length - 1; n >= 0; n--) {
                var a = r[n],
                  i = e._hoverdata[n];
                if (a.curveNumber !== i.curveNumber || String(a.pointNumber) !== String(i.pointNumber) || String(a.pointNumbers) !== String(i.pointNumbers)) return !0;
              }
              return !1;
            }(e, 0, Oe)) return;
            Oe && e.emit("plotly_unhover", {
              event: t,
              points: Oe
            });
            e.emit("plotly_hover", {
              event: t,
              points: e._hoverdata,
              xaxes: b,
              yaxes: _,
              xvals: E,
              yvals: Y
            });
          }(e, t, r, i);
        });
      }, r.loneHover = function (e, t) {
        var r = !0;
        Array.isArray(e) || (r = !1, e = [e]);
        var a = t.gd,
          i = H(a),
          o = B(a),
          l = P(e.map(function (e) {
            var r = e._x0 || e.x0 || e.x || 0,
              n = e._x1 || e.x1 || e.x || 0,
              l = e._y0 || e.y0 || e.y || 0,
              s = e._y1 || e.y1 || e.y || 0,
              c = e.eventData;
            if (c) {
              var u = Math.min(r, n),
                d = Math.max(r, n),
                f = Math.min(l, s),
                p = Math.max(l, s),
                g = e.trace;
              if (m.traceIs(g, "gl3d")) {
                var y = a._fullLayout[g.scene]._scene.container,
                  v = y.offsetLeft,
                  x = y.offsetTop;
                u += v, d += v, f += x, p += x;
              }
              c.bbox = {
                x0: u + o,
                x1: d + o,
                y0: f + i,
                y1: p + i
              }, t.inOut_bbox && t.inOut_bbox.push(c.bbox);
            } else c = !1;
            return {
              color: e.color || h.defaultLine,
              x0: e.x0 || e.x || 0,
              x1: e.x1 || e.x || 0,
              y0: e.y0 || e.y || 0,
              y1: e.y1 || e.y || 0,
              xLabel: e.xLabel,
              yLabel: e.yLabel,
              zLabel: e.zLabel,
              text: e.text,
              name: e.name,
              idealAlign: e.idealAlign,
              borderColor: e.borderColor,
              fontFamily: e.fontFamily,
              fontSize: e.fontSize,
              fontColor: e.fontColor,
              nameLength: e.nameLength,
              textAlign: e.textAlign,
              trace: e.trace || {
                index: 0,
                hoverinfo: ""
              },
              xa: {
                _offset: 0
              },
              ya: {
                _offset: 0
              },
              index: 0,
              hovertemplate: e.hovertemplate || !1,
              hovertemplateLabels: e.hovertemplateLabels || !1,
              eventData: c
            };
          }), {
            gd: a,
            hovermode: "closest",
            rotateLabels: !1,
            bgColor: t.bgColor || h.background,
            container: n.select(t.container),
            outerContainer: t.outerContainer || t.container
          }),
          s = 0,
          c = 0;
        return l.sort(function (e, t) {
          return e.y0 - t.y0;
        }).each(function (e, r) {
          var n = e.y0 - e.by / 2;
          e.offset = n - 5 < s ? s - n + 5 : 0, s = n + e.by + e.offset, r === t.anchorIndex && (c = e.offset);
        }).each(function (e) {
          e.offset -= c;
        }), z(l, !1, a._fullLayout._invScaleX, a._fullLayout._invScaleY), r ? l : l.node();
      };
      var O = /<extra>([\s\S]*)<\/extra>/;
      function P(e, t) {
        var r = t.gd,
          a = r._fullLayout,
          i = t.hovermode,
          c = t.rotateLabels,
          d = t.bgColor,
          p = t.container,
          g = t.outerContainer,
          w = t.commonLabelOpts || {},
          M = t.fontFamily || v.HOVERFONT,
          T = t.fontSize || v.HOVERFONTSIZE,
          k = e[0],
          D = k.xa,
          S = k.ya,
          O = i.charAt(0),
          P = k[O + "Label"],
          z = Y(r, g),
          R = z.top,
          N = z.width,
          F = z.height,
          E = void 0 !== P && k.distance <= t.hoverdistance && ("x" === i || "y" === i);
        if (E) {
          var j,
            H,
            B = !0;
          for (j = 0; j < e.length; j++) if (B && void 0 === e[j].zLabel && (B = !1), H = e[j].hoverinfo || e[j].trace.hoverinfo) {
            var U = Array.isArray(H) ? H : H.split("+");
            if (-1 === U.indexOf("all") && -1 === U.indexOf(i)) {
              E = !1;
              break;
            }
          }
          B && (E = !1);
        }
        var V = p.selectAll("g.axistext").data(E ? [0] : []);
        if (V.enter().append("g").classed("axistext", !0), V.exit().remove(), V.each(function () {
          var e = n.select(this),
            t = o.ensureSingle(e, "path", "", function (e) {
              e.style({
                "stroke-width": "1px"
              });
            }),
            s = o.ensureSingle(e, "text", "", function (e) {
              e.attr("data-notex", 1);
            }),
            c = w.bgcolor || h.defaultLine,
            d = w.bordercolor || h.contrast(c),
            p = h.contrast(c),
            g = {
              family: w.font.family || M,
              size: w.font.size || T,
              color: w.font.color || p
            };
          t.style({
            fill: c,
            stroke: d
          }), s.text(P).call(f.font, g).call(u.positionText, 0, 0).call(u.convertToTspans, r), e.attr("transform", "");
          var m,
            y,
            v = Y(r, s.node());
          if ("x" === i) {
            var x = "top" === D.side ? "-" : "";
            s.attr("text-anchor", "middle").call(u.positionText, 0, "top" === D.side ? R - v.bottom - A - L : R - v.top + A + L), m = D._offset + (k.x0 + k.x1) / 2, y = S._offset + ("top" === D.side ? 0 : S._length);
            var b = v.width / 2 + L;
            m < b ? (m = b, t.attr("d", "M-" + (b - A) + ",0L-" + (b - 2 * A) + "," + x + A + "H" + (L + v.width / 2) + "v" + x + (2 * L + v.height) + "H-" + b + "V" + x + A + "Z")) : m > a.width - b ? (m = a.width - b, t.attr("d", "M" + (b - A) + ",0L" + b + "," + x + A + "v" + x + (2 * L + v.height) + "H-" + b + "V" + x + A + "H" + (b - 2 * A) + "Z")) : t.attr("d", "M0,0L" + A + "," + x + A + "H" + (L + v.width / 2) + "v" + x + (2 * L + v.height) + "H-" + (L + v.width / 2) + "V" + x + A + "H-" + A + "Z");
          } else {
            var _, C, O;
            "right" === S.side ? (_ = "start", C = 1, O = "", m = D._offset + D._length) : (_ = "end", C = -1, O = "-", m = D._offset), y = S._offset + (k.y0 + k.y1) / 2, s.attr("text-anchor", _), t.attr("d", "M0,0L" + O + A + "," + A + "V" + (L + v.height / 2) + "h" + O + (2 * L + v.width) + "V-" + (L + v.height / 2) + "H" + O + A + "V-" + A + "Z");
            var I,
              z = v.height / 2,
              N = R - v.top - z,
              F = "clip" + a._uid + "commonlabel" + S._id;
            if (m < v.width + 2 * L + A) {
              I = "M-" + (A + L) + "-" + z + "h-" + (v.width - L) + "V" + z + "h" + (v.width - L) + "Z";
              var E = v.width - m + L;
              u.positionText(s, E, N), "end" === _ && s.selectAll("tspan").each(function () {
                var e = n.select(this),
                  t = f.tester.append("text").text(e.text()).call(f.font, g),
                  a = Y(r, t.node());
                Math.round(a.width) < Math.round(v.width) && e.attr("x", E - a.width), t.remove();
              });
            } else u.positionText(s, C * (L + A), N), I = null;
            var j = a._topclips.selectAll("#" + F).data(I ? [0] : []);
            j.enter().append("clipPath").attr("id", F).append("path"), j.exit().remove(), j.select("path").attr("d", I), f.setClipUrl(s, I ? F : null, r);
          }
          e.attr("transform", l(m, y));
        }), y.isUnifiedHover(i)) {
          if (p.selectAll("g.hovertext").remove(), 0 === e.length) return;
          var q = a.hoverlabel,
            G = q.font,
            Z = {
              showlegend: !0,
              legend: {
                title: {
                  text: P,
                  font: G
                },
                font: G,
                bgcolor: q.bgcolor,
                bordercolor: q.bordercolor,
                borderwidth: 1,
                tracegroupgap: 7,
                traceorder: a.legend ? a.legend.traceorder : void 0,
                orientation: "v"
              }
            },
            W = {};
          x(Z, W, r._fullData);
          var J = W.legend;
          J.entries = [];
          for (var X = 0; X < e.length; X++) {
            var Q = I(e[X], !0, i, a, P),
              K = Q[0],
              $ = Q[1],
              ee = e[X];
            ee.name = $, ee.text = "" !== $ ? $ + " : " + K : K;
            var te = ee.cd[ee.index];
            te && (te.mc && (ee.mc = te.mc), te.mcc && (ee.mc = te.mcc), te.mlc && (ee.mlc = te.mlc), te.mlcc && (ee.mlc = te.mlcc), te.mlw && (ee.mlw = te.mlw), te.mrc && (ee.mrc = te.mrc), te.dir && (ee.dir = te.dir)), ee._distinct = !0, J.entries.push([ee]);
          }
          J.entries.sort(function (e, t) {
            return e[0].trace.index - t[0].trace.index;
          }), J.layer = p, J._inHover = !0, J._groupTitleFont = G, b(r, J);
          var re,
            ne,
            ae,
            ie,
            oe = p.select("g.legend"),
            le = Y(r, oe.node()),
            se = le.width + 2 * L,
            ce = le.height + 2 * L,
            ue = e[0],
            de = (ue.x0 + ue.x1) / 2,
            fe = (ue.y0 + ue.y1) / 2,
            he = !(m.traceIs(ue.trace, "bar-like") || m.traceIs(ue.trace, "box-violin"));
          "y" === O ? he ? (ne = fe - L, re = fe + L) : (ne = Math.min.apply(null, e.map(function (e) {
            return Math.min(e.y0, e.y1);
          })), re = Math.max.apply(null, e.map(function (e) {
            return Math.max(e.y0, e.y1);
          }))) : ne = re = o.mean(e.map(function (e) {
            return (e.y0 + e.y1) / 2;
          })) - ce / 2, "x" === O ? he ? (ae = de + L, ie = de - L) : (ae = Math.max.apply(null, e.map(function (e) {
            return Math.max(e.x0, e.x1);
          })), ie = Math.min.apply(null, e.map(function (e) {
            return Math.min(e.x0, e.x1);
          }))) : ae = ie = o.mean(e.map(function (e) {
            return (e.x0 + e.x1) / 2;
          })) - se / 2;
          var pe,
            ge,
            me = D._offset,
            ye = S._offset;
          return ie += me - se, ne += ye - ce, pe = (ae += me) + se < N && ae >= 0 ? ae : ie + se < N && ie >= 0 ? ie : me + se < N ? me : ae - de < de - ie + se ? N - se : 0, pe += L, ge = (re += ye) + ce < F && re >= 0 ? re : ne + ce < F && ne >= 0 ? ne : ye + ce < F ? ye : re - fe < fe - ne + ce ? F - ce : 0, ge += L, oe.attr("transform", l(pe - 1, ge - 1)), oe;
        }
        var ve = p.selectAll("g.hovertext").data(e, function (e) {
          return C(e);
        });
        return ve.enter().append("g").classed("hovertext", !0).each(function () {
          var e = n.select(this);
          e.append("rect").call(h.fill, h.addOpacity(d, .8)), e.append("text").classed("name", !0), e.append("path").style("stroke-width", "1px"), e.append("text").classed("nums", !0).call(f.font, M, T);
        }), ve.exit().remove(), ve.each(function (e) {
          var t = n.select(this).attr("transform", ""),
            o = e.color;
          Array.isArray(o) && (o = o[e.eventData[0].pointNumber]);
          var p = e.bgcolor || o,
            g = h.combine(h.opacity(p) ? p : h.defaultLine, d),
            m = h.combine(h.opacity(o) ? o : h.defaultLine, d),
            y = e.borderColor || h.contrast(g),
            v = I(e, E, i, a, P, t),
            x = v[0],
            b = v[1],
            w = t.select("text.nums").call(f.font, e.fontFamily || M, e.fontSize || T, e.fontColor || y).text(x).attr("data-notex", 1).call(u.positionText, 0, 0).call(u.convertToTspans, r),
            k = t.select("text.name"),
            D = 0,
            S = 0;
          if (b && b !== x) {
            k.call(f.font, e.fontFamily || M, e.fontSize || T, m).text(b).attr("data-notex", 1).call(u.positionText, 0, 0).call(u.convertToTspans, r);
            var C = Y(r, k.node());
            D = C.width + 2 * L, S = C.height + 2 * L;
          } else k.remove(), t.select("rect").remove();
          t.select("path").style({
            fill: g,
            stroke: y
          });
          var O = e.xa._offset + (e.x0 + e.x1) / 2,
            z = e.ya._offset + (e.y0 + e.y1) / 2,
            j = Math.abs(e.x1 - e.x0),
            H = Math.abs(e.y1 - e.y0),
            B = Y(r, w.node()),
            U = B.width / a._invScaleX,
            V = B.height / a._invScaleY;
          e.ty0 = (R - B.top) / a._invScaleY, e.bx = U + 2 * L, e.by = Math.max(V + 2 * L, S), e.anchor = "start", e.txwidth = U, e.tx2width = D, e.offset = 0;
          var q,
            G,
            Z = (U + A + L + D) * a._invScaleX;
          if (c) e.pos = O, q = z + H / 2 + Z <= F, G = z - H / 2 - Z >= 0, "top" !== e.idealAlign && q || !G ? q ? (z += H / 2, e.anchor = "start") : e.anchor = "middle" : (z -= H / 2, e.anchor = "end");else if (e.pos = z, q = O + j / 2 + Z <= N, G = O - j / 2 - Z >= 0, "left" !== e.idealAlign && q || !G) {
            if (q) O += j / 2, e.anchor = "start";else {
              e.anchor = "middle";
              var W = Z / 2,
                J = O + W - N,
                X = O - W;
              J > 0 && (O -= J), X < 0 && (O += -X);
            }
          } else O -= j / 2, e.anchor = "end";
          w.attr("text-anchor", e.anchor), D && k.attr("text-anchor", e.anchor), t.attr("transform", l(O, z) + (c ? s(_) : ""));
        }), ve;
      }
      function I(e, t, r, n, a, i) {
        var l = "",
          s = "";
        void 0 !== e.nameOverride && (e.name = e.nameOverride), e.name && (e.trace._meta && (e.name = o.templateString(e.name, e.trace._meta)), l = E(e.name, e.nameLength));
        var c = r.charAt(0),
          u = "x" === c ? "y" : "x";
        void 0 !== e.zLabel ? (void 0 !== e.xLabel && (s += "x: " + e.xLabel + "<br>"), void 0 !== e.yLabel && (s += "y: " + e.yLabel + "<br>"), "choropleth" !== e.trace.type && "choroplethmapbox" !== e.trace.type && (s += (s ? "z: " : "") + e.zLabel)) : t && e[c + "Label"] === a ? s = e[u + "Label"] || "" : void 0 === e.xLabel ? void 0 !== e.yLabel && "scattercarpet" !== e.trace.type && (s = e.yLabel) : s = void 0 === e.yLabel ? e.xLabel : "(" + e.xLabel + ", " + e.yLabel + ")", !e.text && 0 !== e.text || Array.isArray(e.text) || (s += (s ? "<br>" : "") + e.text), void 0 !== e.extraText && (s += (s ? "<br>" : "") + e.extraText), i && "" === s && !e.hovertemplate && ("" === l && i.remove(), s = l);
        var d = e.hovertemplate || !1;
        if (d) {
          var f = e.hovertemplateLabels || e;
          e[c + "Label"] !== a && (f[c + "other"] = f[c + "Val"], f[c + "otherLabel"] = f[c + "Label"]), s = (s = o.hovertemplateString(d, f, n._d3locale, e.eventData[0] || {}, e.trace._meta)).replace(O, function (t, r) {
            return l = E(r, e.nameLength), "";
          });
        }
        return [s, l];
      }
      function z(e, t, r, a) {
        var i = function i(e) {
            return e * r;
          },
          o = function o(e) {
            return e * a;
          };
        e.each(function (e) {
          var r = n.select(this);
          if (e.del) return r.remove();
          var a = r.select("text.nums"),
            l = e.anchor,
            s = "end" === l ? -1 : 1,
            c = {
              start: 1,
              end: -1,
              middle: 0
            }[l],
            d = c * (A + L),
            h = d + c * (e.txwidth + L),
            p = 0,
            g = e.offset,
            m = "middle" === l;
          m && (d -= e.tx2width / 2, h += e.txwidth / 2 + L), t && (g *= -k, p = e.offset * T), r.select("path").attr("d", m ? "M-" + i(e.bx / 2 + e.tx2width / 2) + "," + o(g - e.by / 2) + "h" + i(e.bx) + "v" + o(e.by) + "h-" + i(e.bx) + "Z" : "M0,0L" + i(s * A + p) + "," + o(A + g) + "v" + o(e.by / 2 - A) + "h" + i(s * e.bx) + "v-" + o(e.by) + "H" + i(s * A + p) + "V" + o(g - A) + "Z");
          var y = p + d,
            v = g + e.ty0 - e.by / 2 + L,
            x = e.textAlign || "auto";
          "auto" !== x && ("left" === x && "start" !== l ? (a.attr("text-anchor", "start"), y = m ? -e.bx / 2 - e.tx2width / 2 + L : -e.bx - L) : "right" === x && "end" !== l && (a.attr("text-anchor", "end"), y = m ? e.bx / 2 - e.tx2width / 2 - L : e.bx + L)), a.call(u.positionText, i(y), o(v)), e.tx2width && (r.select("text.name").call(u.positionText, i(h + c * L + p), o(g + e.ty0 - e.by / 2 + L)), r.select("rect").call(f.setRect, i(h + (c - 1) * e.tx2width / 2 + p), o(g - e.by / 2 - 1), i(e.tx2width), o(e.by + 2)));
        });
      }
      function R(e, t) {
        var r = e.index,
          n = e.trace || {},
          i = e.cd[0],
          l = e.cd[r] || {};
        function s(e) {
          return e || a(e) && 0 === e;
        }
        var c = Array.isArray(r) ? function (e, t) {
          var a = o.castOption(i, r, e);
          return s(a) ? a : o.extractOption({}, n, "", t);
        } : function (e, t) {
          return o.extractOption(l, n, e, t);
        };
        function u(t, r, n) {
          var a = c(r, n);
          s(a) && (e[t] = a);
        }
        if (u("hoverinfo", "hi", "hoverinfo"), u("bgcolor", "hbg", "hoverlabel.bgcolor"), u("borderColor", "hbc", "hoverlabel.bordercolor"), u("fontFamily", "htf", "hoverlabel.font.family"), u("fontSize", "hts", "hoverlabel.font.size"), u("fontColor", "htc", "hoverlabel.font.color"), u("nameLength", "hnl", "hoverlabel.namelength"), u("textAlign", "hta", "hoverlabel.align"), e.posref = "y" === t || "closest" === t && "h" === n.orientation ? e.xa._offset + (e.x0 + e.x1) / 2 : e.ya._offset + (e.y0 + e.y1) / 2, e.x0 = o.constrain(e.x0, 0, e.xa._length), e.x1 = o.constrain(e.x1, 0, e.xa._length), e.y0 = o.constrain(e.y0, 0, e.ya._length), e.y1 = o.constrain(e.y1, 0, e.ya._length), void 0 !== e.xLabelVal && (e.xLabel = "xLabel" in e ? e.xLabel : g.hoverLabelText(e.xa, e.xLabelVal, n.xhoverformat), e.xVal = e.xa.c2d(e.xLabelVal)), void 0 !== e.yLabelVal && (e.yLabel = "yLabel" in e ? e.yLabel : g.hoverLabelText(e.ya, e.yLabelVal, n.yhoverformat), e.yVal = e.ya.c2d(e.yLabelVal)), void 0 !== e.zLabelVal && void 0 === e.zLabel && (e.zLabel = String(e.zLabelVal)), !(isNaN(e.xerr) || "log" === e.xa.type && e.xerr <= 0)) {
          var d = g.tickText(e.xa, e.xa.c2l(e.xerr), "hover").text;
          void 0 !== e.xerrneg ? e.xLabel += " +" + d + " / -" + g.tickText(e.xa, e.xa.c2l(e.xerrneg), "hover").text : e.xLabel += " \xb1 " + d, "x" === t && (e.distance += 1);
        }
        if (!(isNaN(e.yerr) || "log" === e.ya.type && e.yerr <= 0)) {
          var f = g.tickText(e.ya, e.ya.c2l(e.yerr), "hover").text;
          void 0 !== e.yerrneg ? e.yLabel += " +" + f + " / -" + g.tickText(e.ya, e.ya.c2l(e.yerrneg), "hover").text : e.yLabel += " \xb1 " + f, "y" === t && (e.distance += 1);
        }
        var h = e.hoverinfo || e.trace.hoverinfo;
        return h && "all" !== h && (-1 === (h = Array.isArray(h) ? h : h.split("+")).indexOf("x") && (e.xLabel = void 0), -1 === h.indexOf("y") && (e.yLabel = void 0), -1 === h.indexOf("z") && (e.zLabel = void 0), -1 === h.indexOf("text") && (e.text = void 0), -1 === h.indexOf("name") && (e.name = void 0)), e;
      }
      function N(e, t, r) {
        var n,
          a,
          o = r.container,
          l = r.fullLayout,
          s = l._size,
          c = r.event,
          u = !!t.hLinePoint,
          d = !!t.vLinePoint;
        if (o.selectAll(".spikeline").remove(), d || u) {
          var p = h.combine(l.plot_bgcolor, l.paper_bgcolor);
          if (u) {
            var m,
              y,
              v = t.hLinePoint;
            n = v && v.xa, "cursor" === (a = v && v.ya).spikesnap ? (m = c.pointerX, y = c.pointerY) : (m = n._offset + v.x, y = a._offset + v.y);
            var x,
              b,
              _ = i.readability(v.color, p) < 1.5 ? h.contrast(p) : v.color,
              w = a.spikemode,
              M = a.spikethickness,
              T = a.spikecolor || _,
              k = g.getPxPosition(e, a);
            if (-1 !== w.indexOf("toaxis") || -1 !== w.indexOf("across")) {
              if (-1 !== w.indexOf("toaxis") && (x = k, b = m), -1 !== w.indexOf("across")) {
                var A = a._counterDomainMin,
                  L = a._counterDomainMax;
                "free" === a.anchor && (A = Math.min(A, a.position), L = Math.max(L, a.position)), x = s.l + A * s.w, b = s.l + L * s.w;
              }
              o.insert("line", ":first-child").attr({
                x1: x,
                x2: b,
                y1: y,
                y2: y,
                "stroke-width": M,
                stroke: T,
                "stroke-dasharray": f.dashStyle(a.spikedash, M)
              }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                x1: x,
                x2: b,
                y1: y,
                y2: y,
                "stroke-width": M + 2,
                stroke: p
              }).classed("spikeline", !0).classed("crisp", !0);
            }
            -1 !== w.indexOf("marker") && o.insert("circle", ":first-child").attr({
              cx: k + ("right" !== a.side ? M : -M),
              cy: y,
              r: M,
              fill: T
            }).classed("spikeline", !0);
          }
          if (d) {
            var D,
              S,
              C = t.vLinePoint;
            n = C && C.xa, a = C && C.ya, "cursor" === n.spikesnap ? (D = c.pointerX, S = c.pointerY) : (D = n._offset + C.x, S = a._offset + C.y);
            var O,
              P,
              I = i.readability(C.color, p) < 1.5 ? h.contrast(p) : C.color,
              z = n.spikemode,
              R = n.spikethickness,
              N = n.spikecolor || I,
              F = g.getPxPosition(e, n);
            if (-1 !== z.indexOf("toaxis") || -1 !== z.indexOf("across")) {
              if (-1 !== z.indexOf("toaxis") && (O = F, P = S), -1 !== z.indexOf("across")) {
                var E = n._counterDomainMin,
                  j = n._counterDomainMax;
                "free" === n.anchor && (E = Math.min(E, n.position), j = Math.max(j, n.position)), O = s.t + (1 - j) * s.h, P = s.t + (1 - E) * s.h;
              }
              o.insert("line", ":first-child").attr({
                x1: D,
                x2: D,
                y1: O,
                y2: P,
                "stroke-width": R,
                stroke: N,
                "stroke-dasharray": f.dashStyle(n.spikedash, R)
              }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                x1: D,
                x2: D,
                y1: O,
                y2: P,
                "stroke-width": R + 2,
                stroke: p
              }).classed("spikeline", !0).classed("crisp", !0);
            }
            -1 !== z.indexOf("marker") && o.insert("circle", ":first-child").attr({
              cx: D,
              cy: F - ("top" !== n.side ? R : -R),
              r: R,
              fill: N
            }).classed("spikeline", !0);
          }
        }
      }
      function F(e, t) {
        return !t || t.vLinePoint !== e._spikepoints.vLinePoint || t.hLinePoint !== e._spikepoints.hLinePoint;
      }
      function E(e, t) {
        return u.plainText(e || "", {
          len: t,
          allowedTags: ["br", "sub", "sup", "b", "i", "em"]
        });
      }
      function j(e, t, r) {
        var n = t[e + "a"],
          a = t[e + "Val"],
          i = t.cd[0];
        if ("category" === n.type) a = n._categoriesMap[a];else if ("date" === n.type) {
          var o = t.trace[e + "periodalignment"];
          if (o) {
            var l = t.cd[t.index],
              s = l[e + "Start"];
            void 0 === s && (s = l[e]);
            var c = l[e + "End"];
            void 0 === c && (c = l[e]);
            var u = c - s;
            "end" === o ? a += u : "middle" === o && (a += u / 2);
          }
          a = n.d2c(a);
        }
        return i && i.t && i.t.posLetter === n._id && ("group" !== r.boxmode && "group" !== r.violinmode || (a += i.t.dPos)), a;
      }
      function H(e) {
        return e.offsetTop + e.clientTop;
      }
      function B(e) {
        return e.offsetLeft + e.clientLeft;
      }
      function Y(e, t) {
        var r = e._fullLayout,
          n = t.getBoundingClientRect(),
          a = n.x,
          i = n.y,
          l = a + n.width,
          s = i + n.height,
          c = o.apply3DTransform(r._invTransform)(a, i),
          u = o.apply3DTransform(r._invTransform)(l, s),
          d = c[0],
          f = c[1],
          h = u[0],
          p = u[1];
        return {
          x: d,
          y: f,
          width: h - d,
          height: p - f,
          top: Math.min(f, p),
          left: Math.min(d, h),
          right: Math.max(d, h),
          bottom: Math.max(f, p)
        };
      }
    }, {
      "../../lib": 225,
      "../../lib/events": 218,
      "../../lib/override_cursor": 236,
      "../../lib/svg_text_utils": 248,
      "../../plots/cartesian/axes": 272,
      "../../registry": 309,
      "../color": 96,
      "../dragelement": 115,
      "../drawing": 118,
      "../legend/defaults": 148,
      "../legend/draw": 149,
      "./constants": 130,
      "./helpers": 132,
      "@plotly/d3": 6,
      "fast-isnumeric": 11,
      tinycolor2: 61
    }],
    134: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../color"),
        i = e("./helpers").isUnifiedHover;
      t.exports = function (e, t, r, o) {
        function l(e) {
          o.font[e] || (o.font[e] = t.legend ? t.legend.font[e] : t.font[e]);
        }
        o = o || {}, t && i(t.hovermode) && (o.font || (o.font = {}), l("size"), l("family"), l("color"), t.legend ? (o.bgcolor || (o.bgcolor = a.combine(t.legend.bgcolor, t.paper_bgcolor)), o.bordercolor || (o.bordercolor = t.legend.bordercolor)) : o.bgcolor || (o.bgcolor = t.paper_bgcolor)), r("hoverlabel.bgcolor", o.bgcolor), r("hoverlabel.bordercolor", o.bordercolor), r("hoverlabel.namelength", o.namelength), n.coerceFont(r, "hoverlabel.font", o.font), r("hoverlabel.align", o.align);
      };
    }, {
      "../../lib": 225,
      "../color": 96,
      "./helpers": 132
    }],
    135: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("./layout_attributes");
      t.exports = function (e, t) {
        function r(r, i) {
          return void 0 !== t[r] ? t[r] : n.coerce(e, t, a, r, i);
        }
        return r("clickmode"), r("hovermode");
      };
    }, {
      "../../lib": 225,
      "./layout_attributes": 137
    }],
    136: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../lib"),
        i = e("../dragelement"),
        o = e("./helpers"),
        l = e("./layout_attributes"),
        s = e("./hover");
      t.exports = {
        moduleType: "component",
        name: "fx",
        constants: e("./constants"),
        schema: {
          layout: l
        },
        attributes: e("./attributes"),
        layoutAttributes: l,
        supplyLayoutGlobalDefaults: e("./layout_global_defaults"),
        supplyDefaults: e("./defaults"),
        supplyLayoutDefaults: e("./layout_defaults"),
        calc: e("./calc"),
        getDistanceFunction: o.getDistanceFunction,
        getClosest: o.getClosest,
        inbox: o.inbox,
        quadrature: o.quadrature,
        appendArrayPointValue: o.appendArrayPointValue,
        castHoverOption: function castHoverOption(e, t, r) {
          return a.castOption(e, t, "hoverlabel." + r);
        },
        castHoverinfo: function castHoverinfo(e, t, r) {
          return a.castOption(e, r, "hoverinfo", function (r) {
            return a.coerceHoverinfo({
              hoverinfo: r
            }, {
              _module: e._module
            }, t);
          });
        },
        hover: s.hover,
        unhover: i.unhover,
        loneHover: s.loneHover,
        loneUnhover: function loneUnhover(e) {
          var t = a.isD3Selection(e) ? e : n.select(e);
          t.selectAll("g.hovertext").remove(), t.selectAll(".spikeline").remove();
        },
        click: e("./click")
      };
    }, {
      "../../lib": 225,
      "../dragelement": 115,
      "./attributes": 127,
      "./calc": 128,
      "./click": 129,
      "./constants": 130,
      "./defaults": 131,
      "./helpers": 132,
      "./hover": 133,
      "./layout_attributes": 137,
      "./layout_defaults": 138,
      "./layout_global_defaults": 139,
      "@plotly/d3": 6
    }],
    137: [function (e, t, r) {
      "use strict";

      var n = e("./constants"),
        a = e("../../plots/font_attributes")({
          editType: "none"
        });
      a.family.dflt = n.HOVERFONT, a.size.dflt = n.HOVERFONTSIZE, t.exports = {
        clickmode: {
          valType: "flaglist",
          flags: ["event", "select"],
          dflt: "event",
          editType: "plot",
          extras: ["none"]
        },
        dragmode: {
          valType: "enumerated",
          values: ["zoom", "pan", "select", "lasso", "drawclosedpath", "drawopenpath", "drawline", "drawrect", "drawcircle", "orbit", "turntable", !1],
          dflt: "zoom",
          editType: "modebar"
        },
        hovermode: {
          valType: "enumerated",
          values: ["x", "y", "closest", !1, "x unified", "y unified"],
          dflt: "closest",
          editType: "modebar"
        },
        hoverdistance: {
          valType: "integer",
          min: -1,
          dflt: 20,
          editType: "none"
        },
        spikedistance: {
          valType: "integer",
          min: -1,
          dflt: -1,
          editType: "none"
        },
        hoverlabel: {
          bgcolor: {
            valType: "color",
            editType: "none"
          },
          bordercolor: {
            valType: "color",
            editType: "none"
          },
          font: a,
          align: {
            valType: "enumerated",
            values: ["left", "right", "auto"],
            dflt: "auto",
            editType: "none"
          },
          namelength: {
            valType: "integer",
            min: -1,
            dflt: 15,
            editType: "none"
          },
          editType: "none"
        },
        selectdirection: {
          valType: "enumerated",
          values: ["h", "v", "d", "any"],
          dflt: "any",
          editType: "none"
        }
      };
    }, {
      "../../plots/font_attributes": 301,
      "./constants": 130
    }],
    138: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("./layout_attributes"),
        i = e("./hovermode_defaults"),
        o = e("./hoverlabel_defaults");
      t.exports = function (e, t) {
        function r(r, i) {
          return n.coerce(e, t, a, r, i);
        }
        i(e, t) && (r("hoverdistance"), r("spikedistance")), "select" === r("dragmode") && r("selectdirection");
        var l = t._has("mapbox"),
          s = t._has("geo"),
          c = t._basePlotModules.length;
        "zoom" === t.dragmode && ((l || s) && 1 === c || l && s && 2 === c) && (t.dragmode = "pan"), o(e, t, r);
      };
    }, {
      "../../lib": 225,
      "./hoverlabel_defaults": 134,
      "./hovermode_defaults": 135,
      "./layout_attributes": 137
    }],
    139: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("./hoverlabel_defaults"),
        i = e("./layout_attributes");
      t.exports = function (e, t) {
        a(e, t, function (r, a) {
          return n.coerce(e, t, i, r, a);
        });
      };
    }, {
      "../../lib": 225,
      "./hoverlabel_defaults": 134,
      "./layout_attributes": 137
    }],
    140: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../lib/regex").counter,
        i = e("../../plots/domain").attributes,
        o = e("../../plots/cartesian/constants").idRegex,
        l = e("../../plot_api/plot_template"),
        s = {
          rows: {
            valType: "integer",
            min: 1,
            editType: "plot"
          },
          roworder: {
            valType: "enumerated",
            values: ["top to bottom", "bottom to top"],
            dflt: "top to bottom",
            editType: "plot"
          },
          columns: {
            valType: "integer",
            min: 1,
            editType: "plot"
          },
          subplots: {
            valType: "info_array",
            freeLength: !0,
            dimensions: 2,
            items: {
              valType: "enumerated",
              values: [a("xy").toString(), ""],
              editType: "plot"
            },
            editType: "plot"
          },
          xaxes: {
            valType: "info_array",
            freeLength: !0,
            items: {
              valType: "enumerated",
              values: [o.x.toString(), ""],
              editType: "plot"
            },
            editType: "plot"
          },
          yaxes: {
            valType: "info_array",
            freeLength: !0,
            items: {
              valType: "enumerated",
              values: [o.y.toString(), ""],
              editType: "plot"
            },
            editType: "plot"
          },
          pattern: {
            valType: "enumerated",
            values: ["independent", "coupled"],
            dflt: "coupled",
            editType: "plot"
          },
          xgap: {
            valType: "number",
            min: 0,
            max: 1,
            editType: "plot"
          },
          ygap: {
            valType: "number",
            min: 0,
            max: 1,
            editType: "plot"
          },
          domain: i({
            name: "grid",
            editType: "plot",
            noGridCell: !0
          }, {}),
          xside: {
            valType: "enumerated",
            values: ["bottom", "bottom plot", "top plot", "top"],
            dflt: "bottom plot",
            editType: "plot"
          },
          yside: {
            valType: "enumerated",
            values: ["left", "left plot", "right plot", "right"],
            dflt: "left plot",
            editType: "plot"
          },
          editType: "plot"
        };
      function c(e, t, r) {
        var n = t[r + "axes"],
          a = Object.keys((e._splomAxes || {})[r] || {});
        return Array.isArray(n) ? n : a.length ? a : void 0;
      }
      function u(e, t, r, n, a, i) {
        var o = t(e + "gap", r),
          l = t("domain." + e);
        t(e + "side", n);
        for (var s = new Array(a), c = l[0], u = (l[1] - c) / (a - o), d = u * (1 - o), f = 0; f < a; f++) {
          var h = c + u * f;
          s[i ? a - 1 - f : f] = [h, h + d];
        }
        return s;
      }
      function d(e, t, r, n, a) {
        var i,
          o = new Array(r);
        function l(e, r) {
          -1 !== t.indexOf(r) && void 0 === n[r] ? (o[e] = r, n[r] = e) : o[e] = "";
        }
        if (Array.isArray(e)) for (i = 0; i < r; i++) l(i, e[i]);else for (l(0, a), i = 1; i < r; i++) l(i, a + (i + 1));
        return o;
      }
      t.exports = {
        moduleType: "component",
        name: "grid",
        schema: {
          layout: {
            grid: s
          }
        },
        layoutAttributes: s,
        sizeDefaults: function sizeDefaults(e, t) {
          var r = e.grid || {},
            a = c(t, r, "x"),
            i = c(t, r, "y");
          if (e.grid || a || i) {
            var o,
              d,
              f = Array.isArray(r.subplots) && Array.isArray(r.subplots[0]),
              h = Array.isArray(a),
              p = Array.isArray(i),
              g = h && a !== r.xaxes && p && i !== r.yaxes;
            f ? (o = r.subplots.length, d = r.subplots[0].length) : (p && (o = i.length), h && (d = a.length));
            var m = l.newContainer(t, "grid"),
              y = T("rows", o),
              v = T("columns", d);
            if (y * v > 1) {
              if (!f && !h && !p) "independent" === T("pattern") && (f = !0);
              m._hasSubplotGrid = f;
              var x,
                b,
                _ = "top to bottom" === T("roworder"),
                w = f ? .2 : .1,
                M = f ? .3 : .1;
              g && t._splomGridDflt && (x = t._splomGridDflt.xside, b = t._splomGridDflt.yside), m._domains = {
                x: u("x", T, w, x, v),
                y: u("y", T, M, b, y, _)
              };
            } else delete t.grid;
          }
          function T(e, t) {
            return n.coerce(r, m, s, e, t);
          }
        },
        contentDefaults: function contentDefaults(e, t) {
          var r = t.grid;
          if (r && r._domains) {
            var n,
              a,
              i,
              o,
              l,
              s,
              u,
              f = e.grid || {},
              h = t._subplots,
              p = r._hasSubplotGrid,
              g = r.rows,
              m = r.columns,
              y = "independent" === r.pattern,
              v = r._axisMap = {};
            if (p) {
              var x = f.subplots || [];
              s = r.subplots = new Array(g);
              var b = 1;
              for (n = 0; n < g; n++) {
                var _ = s[n] = new Array(m),
                  w = x[n] || [];
                for (a = 0; a < m; a++) if (y ? (l = 1 === b ? "xy" : "x" + b + "y" + b, b++) : l = w[a], _[a] = "", -1 !== h.cartesian.indexOf(l)) {
                  if (u = l.indexOf("y"), i = l.slice(0, u), o = l.slice(u), void 0 !== v[i] && v[i] !== a || void 0 !== v[o] && v[o] !== n) continue;
                  _[a] = l, v[i] = a, v[o] = n;
                }
              }
            } else {
              var M = c(t, f, "x"),
                T = c(t, f, "y");
              r.xaxes = d(M, h.xaxis, m, v, "x"), r.yaxes = d(T, h.yaxis, g, v, "y");
            }
            var k = r._anchors = {},
              A = "top to bottom" === r.roworder;
            for (var L in v) {
              var D,
                S,
                C,
                O = L.charAt(0),
                P = r[O + "side"];
              if (P.length < 8) k[L] = "free";else if ("x" === O) {
                if ("t" === P.charAt(0) === A ? (D = 0, S = 1, C = g) : (D = g - 1, S = -1, C = -1), p) {
                  var I = v[L];
                  for (n = D; n !== C; n += S) if ((l = s[n][I]) && (u = l.indexOf("y"), l.slice(0, u) === L)) {
                    k[L] = l.slice(u);
                    break;
                  }
                } else for (n = D; n !== C; n += S) if (o = r.yaxes[n], -1 !== h.cartesian.indexOf(L + o)) {
                  k[L] = o;
                  break;
                }
              } else if ("l" === P.charAt(0) ? (D = 0, S = 1, C = m) : (D = m - 1, S = -1, C = -1), p) {
                var z = v[L];
                for (n = D; n !== C; n += S) if ((l = s[z][n]) && (u = l.indexOf("y"), l.slice(u) === L)) {
                  k[L] = l.slice(0, u);
                  break;
                }
              } else for (n = D; n !== C; n += S) if (i = r.xaxes[n], -1 !== h.cartesian.indexOf(i + L)) {
                k[L] = i;
                break;
              }
            }
          }
        }
      };
    }, {
      "../../lib": 225,
      "../../lib/regex": 241,
      "../../plot_api/plot_template": 261,
      "../../plots/cartesian/constants": 279,
      "../../plots/domain": 300
    }],
    141: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/cartesian/constants"),
        a = e("../../plot_api/plot_template").templatedArray;
      e("../../constants/axis_placeable_objects");
      t.exports = a("image", {
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "arraydraw"
        },
        source: {
          valType: "string",
          editType: "arraydraw"
        },
        layer: {
          valType: "enumerated",
          values: ["below", "above"],
          dflt: "above",
          editType: "arraydraw"
        },
        sizex: {
          valType: "number",
          dflt: 0,
          editType: "arraydraw"
        },
        sizey: {
          valType: "number",
          dflt: 0,
          editType: "arraydraw"
        },
        sizing: {
          valType: "enumerated",
          values: ["fill", "contain", "stretch"],
          dflt: "contain",
          editType: "arraydraw"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "arraydraw"
        },
        x: {
          valType: "any",
          dflt: 0,
          editType: "arraydraw"
        },
        y: {
          valType: "any",
          dflt: 0,
          editType: "arraydraw"
        },
        xanchor: {
          valType: "enumerated",
          values: ["left", "center", "right"],
          dflt: "left",
          editType: "arraydraw"
        },
        yanchor: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "top",
          editType: "arraydraw"
        },
        xref: {
          valType: "enumerated",
          values: ["paper", n.idRegex.x.toString()],
          dflt: "paper",
          editType: "arraydraw"
        },
        yref: {
          valType: "enumerated",
          values: ["paper", n.idRegex.y.toString()],
          dflt: "paper",
          editType: "arraydraw"
        },
        editType: "arraydraw"
      });
    }, {
      "../../constants/axis_placeable_objects": 202,
      "../../plot_api/plot_template": 261,
      "../../plots/cartesian/constants": 279
    }],
    142: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib/to_log_range");
      t.exports = function (e, t, r, i) {
        t = t || {};
        var o = "log" === r && "linear" === t.type,
          l = "linear" === r && "log" === t.type;
        if (o || l) for (var s, c, u = e._fullLayout.images, d = t._id.charAt(0), f = 0; f < u.length; f++) if (c = "images[" + f + "].", (s = u[f])[d + "ref"] === t._id) {
          var h = s[d],
            p = s["size" + d],
            g = null,
            m = null;
          if (o) {
            g = a(h, t.range);
            var y = p / Math.pow(10, g) / 2;
            m = 2 * Math.log(y + Math.sqrt(1 + y * y)) / Math.LN10;
          } else m = (g = Math.pow(10, h)) * (Math.pow(10, p / 2) - Math.pow(10, -p / 2));
          n(g) ? n(m) || (m = null) : (g = null, m = null), i(c + d, g), i(c + "size" + d, m);
        }
      };
    }, {
      "../../lib/to_log_range": 250,
      "fast-isnumeric": 11
    }],
    143: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plots/cartesian/axes"),
        i = e("../../plots/array_container_defaults"),
        o = e("./attributes");
      function l(e, t, r) {
        function i(r, a) {
          return n.coerce(e, t, o, r, a);
        }
        var l = i("source");
        if (!i("visible", !!l)) return t;
        i("layer"), i("xanchor"), i("yanchor"), i("sizex"), i("sizey"), i("sizing"), i("opacity");
        for (var s = {
            _fullLayout: r
          }, c = ["x", "y"], u = 0; u < 2; u++) {
          var d = c[u],
            f = a.coerceRef(e, t, s, d, "paper", void 0);
          if ("paper" !== f) a.getFromId(s, f)._imgIndices.push(t._index);
          a.coercePosition(t, s, i, f, d, 0);
        }
        return t;
      }
      t.exports = function (e, t) {
        i(e, t, {
          name: "images",
          handleItemDefaults: l
        });
      };
    }, {
      "../../lib": 225,
      "../../plots/array_container_defaults": 267,
      "../../plots/cartesian/axes": 272,
      "./attributes": 141
    }],
    144: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../drawing"),
        i = e("../../plots/cartesian/axes"),
        o = e("../../plots/cartesian/axis_ids"),
        l = e("../../constants/xmlns_namespaces");
      t.exports = function (e) {
        var t,
          r,
          s = e._fullLayout,
          c = [],
          u = {},
          d = [];
        for (r = 0; r < s.images.length; r++) {
          var f = s.images[r];
          if (f.visible) if ("below" === f.layer && "paper" !== f.xref && "paper" !== f.yref) {
            t = o.ref2id(f.xref) + o.ref2id(f.yref);
            var h = s._plots[t];
            if (!h) {
              d.push(f);
              continue;
            }
            h.mainplot && (t = h.mainplot.id), u[t] || (u[t] = []), u[t].push(f);
          } else "above" === f.layer ? c.push(f) : d.push(f);
        }
        var p = {
            left: {
              sizing: "xMin",
              offset: 0
            },
            center: {
              sizing: "xMid",
              offset: -.5
            },
            right: {
              sizing: "xMax",
              offset: -1
            }
          },
          g = {
            top: {
              sizing: "YMin",
              offset: 0
            },
            middle: {
              sizing: "YMid",
              offset: -.5
            },
            bottom: {
              sizing: "YMax",
              offset: -1
            }
          };
        function m(t) {
          var r = n.select(this);
          if (this._imgSrc !== t.source) if (r.attr("xmlns", l.svg), t.source && "data:" === t.source.slice(0, 5)) r.attr("xlink:href", t.source), this._imgSrc = t.source;else {
            var a = new Promise(function (e) {
              var n = new Image();
              function a() {
                r.remove(), e();
              }
              this.img = n, n.setAttribute("crossOrigin", "anonymous"), n.onerror = a, n.onload = function () {
                var t = document.createElement("canvas");
                t.width = this.width, t.height = this.height, t.getContext("2d").drawImage(this, 0, 0);
                var n = t.toDataURL("image/png");
                r.attr("xlink:href", n), e();
              }, r.on("error", a), n.src = t.source, this._imgSrc = t.source;
            }.bind(this));
            e._promises.push(a);
          }
        }
        function y(t) {
          var r,
            o,
            l = n.select(this),
            c = i.getFromId(e, t.xref),
            u = i.getFromId(e, t.yref),
            d = "domain" === i.getRefType(t.xref),
            f = "domain" === i.getRefType(t.yref),
            h = s._size;
          r = void 0 !== c ? "string" == typeof t.xref && d ? c._length * t.sizex : Math.abs(c.l2p(t.sizex) - c.l2p(0)) : t.sizex * h.w, o = void 0 !== u ? "string" == typeof t.yref && f ? u._length * t.sizey : Math.abs(u.l2p(t.sizey) - u.l2p(0)) : t.sizey * h.h;
          var m,
            y,
            v = r * p[t.xanchor].offset,
            x = o * g[t.yanchor].offset,
            b = p[t.xanchor].sizing + g[t.yanchor].sizing;
          switch (m = void 0 !== c ? "string" == typeof t.xref && d ? c._length * t.x + c._offset : c.r2p(t.x) + c._offset : t.x * h.w + h.l, m += v, y = void 0 !== u ? "string" == typeof t.yref && f ? u._length * (1 - t.y) + u._offset : u.r2p(t.y) + u._offset : h.h - t.y * h.h + h.t, y += x, t.sizing) {
            case "fill":
              b += " slice";
              break;
            case "stretch":
              b = "none";
          }
          l.attr({
            x: m,
            y: y,
            width: r,
            height: o,
            preserveAspectRatio: b,
            opacity: t.opacity
          });
          var _ = (c && "domain" !== i.getRefType(t.xref) ? c._id : "") + (u && "domain" !== i.getRefType(t.yref) ? u._id : "");
          a.setClipUrl(l, _ ? "clip" + s._uid + _ : null, e);
        }
        var v = s._imageLowerLayer.selectAll("image").data(d),
          x = s._imageUpperLayer.selectAll("image").data(c);
        v.enter().append("image"), x.enter().append("image"), v.exit().remove(), x.exit().remove(), v.each(function (e) {
          m.bind(this)(e), y.bind(this)(e);
        }), x.each(function (e) {
          m.bind(this)(e), y.bind(this)(e);
        });
        var b = Object.keys(s._plots);
        for (r = 0; r < b.length; r++) {
          t = b[r];
          var _ = s._plots[t];
          if (_.imagelayer) {
            var w = _.imagelayer.selectAll("image").data(u[t] || []);
            w.enter().append("image"), w.exit().remove(), w.each(function (e) {
              m.bind(this)(e), y.bind(this)(e);
            });
          }
        }
      };
    }, {
      "../../constants/xmlns_namespaces": 206,
      "../../plots/cartesian/axes": 272,
      "../../plots/cartesian/axis_ids": 276,
      "../drawing": 118,
      "@plotly/d3": 6
    }],
    145: [function (e, t, r) {
      "use strict";

      t.exports = {
        moduleType: "component",
        name: "images",
        layoutAttributes: e("./attributes"),
        supplyLayoutDefaults: e("./defaults"),
        includeBasePlot: e("../../plots/cartesian/include_components")("images"),
        draw: e("./draw"),
        convertCoords: e("./convert_coords")
      };
    }, {
      "../../plots/cartesian/include_components": 285,
      "./attributes": 141,
      "./convert_coords": 142,
      "./defaults": 143,
      "./draw": 144
    }],
    146: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/font_attributes"),
        a = e("../color/attributes");
      t.exports = {
        bgcolor: {
          valType: "color",
          editType: "legend"
        },
        bordercolor: {
          valType: "color",
          dflt: a.defaultLine,
          editType: "legend"
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "legend"
        },
        font: n({
          editType: "legend"
        }),
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          dflt: "v",
          editType: "legend"
        },
        traceorder: {
          valType: "flaglist",
          flags: ["reversed", "grouped"],
          extras: ["normal"],
          editType: "legend"
        },
        tracegroupgap: {
          valType: "number",
          min: 0,
          dflt: 10,
          editType: "legend"
        },
        itemsizing: {
          valType: "enumerated",
          values: ["trace", "constant"],
          dflt: "trace",
          editType: "legend"
        },
        itemwidth: {
          valType: "number",
          min: 30,
          dflt: 30,
          editType: "legend"
        },
        itemclick: {
          valType: "enumerated",
          values: ["toggle", "toggleothers", !1],
          dflt: "toggle",
          editType: "legend"
        },
        itemdoubleclick: {
          valType: "enumerated",
          values: ["toggle", "toggleothers", !1],
          dflt: "toggleothers",
          editType: "legend"
        },
        groupclick: {
          valType: "enumerated",
          values: ["toggleitem", "togglegroup"],
          dflt: "togglegroup",
          editType: "legend"
        },
        x: {
          valType: "number",
          min: -2,
          max: 3,
          editType: "legend"
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "left",
          editType: "legend"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          editType: "legend"
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          editType: "legend"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        valign: {
          valType: "enumerated",
          values: ["top", "middle", "bottom"],
          dflt: "middle",
          editType: "legend"
        },
        title: {
          text: {
            valType: "string",
            dflt: "",
            editType: "legend"
          },
          font: n({
            editType: "legend"
          }),
          side: {
            valType: "enumerated",
            values: ["top", "left", "top left"],
            editType: "legend"
          },
          editType: "legend"
        },
        editType: "legend"
      };
    }, {
      "../../plots/font_attributes": 301,
      "../color/attributes": 95
    }],
    147: [function (e, t, r) {
      "use strict";

      t.exports = {
        scrollBarWidth: 6,
        scrollBarMinHeight: 20,
        scrollBarColor: "#808BA4",
        scrollBarMargin: 4,
        scrollBarEnterAttrs: {
          rx: 20,
          ry: 3,
          width: 0,
          height: 0
        },
        titlePad: 2,
        itemGap: 5
      };
    }, {}],
    148: [function (e, t, r) {
      "use strict";

      var n = e("../../registry"),
        a = e("../../lib"),
        i = e("../../plot_api/plot_template"),
        o = e("./attributes"),
        l = e("../../plots/layout_attributes"),
        s = e("./helpers");
      t.exports = function (e, t, r) {
        for (var c = e.legend || {}, u = 0, d = !1, f = "normal", h = 0; h < r.length; h++) {
          var p = r[h];
          p.visible && ((p.showlegend || p._dfltShowLegend && !(p._module && p._module.attributes && p._module.attributes.showlegend && !1 === p._module.attributes.showlegend.dflt)) && (u++, p.showlegend && (d = !0, (n.traceIs(p, "pie-like") || !0 === p._input.showlegend) && u++)), (n.traceIs(p, "bar") && "stack" === t.barmode || -1 !== ["tonextx", "tonexty"].indexOf(p.fill)) && (f = s.isGrouped({
            traceorder: f
          }) ? "grouped+reversed" : "reversed"), void 0 !== p.legendgroup && "" !== p.legendgroup && (f = s.isReversed({
            traceorder: f
          }) ? "reversed+grouped" : "grouped"));
        }
        var g = a.coerce(e, t, l, "showlegend", d && u > 1);
        if (!1 !== g || c.uirevision) {
          var m = i.newContainer(t, "legend");
          if (M("uirevision", t.uirevision), !1 !== g) {
            M("bgcolor", t.paper_bgcolor), M("bordercolor"), M("borderwidth");
            var y,
              v,
              x,
              b = a.coerceFont(M, "font", t.font),
              _ = "h" === M("orientation");
            if (_ ? (y = 0, n.getComponentMethod("rangeslider", "isVisible")(e.xaxis) ? (v = 1.1, x = "bottom") : (v = -.1, x = "top")) : (y = 1.02, v = 1, x = "auto"), M("traceorder", f), s.isGrouped(t.legend) && M("tracegroupgap"), M("itemsizing"), M("itemwidth"), M("itemclick"), M("itemdoubleclick"), M("groupclick"), M("x", y), M("xanchor"), M("y", v), M("yanchor", x), M("valign"), a.noneOrAll(c, m, ["x", "y"]), M("title.text")) {
              M("title.side", _ ? "left" : "top");
              var w = a.extendFlat({}, b, {
                size: a.bigFont(b.size)
              });
              a.coerceFont(M, "title.font", w);
            }
          }
        }
        function M(e, t) {
          return a.coerce(c, m, o, e, t);
        }
      };
    }, {
      "../../lib": 225,
      "../../plot_api/plot_template": 261,
      "../../plots/layout_attributes": 305,
      "../../registry": 309,
      "./attributes": 146,
      "./helpers": 152
    }],
    149: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../lib"),
        i = e("../../plots/plots"),
        o = e("../../registry"),
        l = e("../../lib/events"),
        s = e("../dragelement"),
        c = e("../drawing"),
        u = e("../color"),
        d = e("../../lib/svg_text_utils"),
        f = e("./handle_click"),
        h = e("./constants"),
        p = e("../../constants/alignment"),
        g = p.LINE_SPACING,
        m = p.FROM_TL,
        y = p.FROM_BR,
        v = e("./get_legend_data"),
        x = e("./style"),
        b = e("./helpers");
      function _(e, t, r, n, a) {
        var i = r.data()[0][0].trace,
          s = {
            event: a,
            node: r.node(),
            curveNumber: i.index,
            expandedIndex: i._expandedIndex,
            data: e.data,
            layout: e.layout,
            frames: e._transitionData._frames,
            config: e._context,
            fullData: e._fullData,
            fullLayout: e._fullLayout
          };
        if (i._group && (s.group = i._group), o.traceIs(i, "pie-like") && (s.label = r.datum()[0].label), !1 !== l.triggerHandler(e, "plotly_legendclick", s)) if (1 === n) t._clickTimeout = setTimeout(function () {
          e._fullLayout && f(r, e, n);
        }, e._context.doubleClickDelay);else if (2 === n) {
          t._clickTimeout && clearTimeout(t._clickTimeout), e._legendMouseDownTime = 0, !1 !== l.triggerHandler(e, "plotly_legenddoubleclick", s) && f(r, e, n);
        }
      }
      function w(e, t, r) {
        var n,
          i,
          l = e.data()[0][0],
          s = l.trace,
          u = o.traceIs(s, "pie-like"),
          f = !r._inHover && t._context.edits.legendText && !u,
          p = r._maxNameLength;
        l.groupTitle ? (n = l.groupTitle.text, i = l.groupTitle.font) : (i = r.font, r.entries ? n = l.text : (n = u ? l.label : s.name, s._meta && (n = a.templateString(n, s._meta))));
        var g = a.ensureSingle(e, "text", "legendtext");
        g.attr("text-anchor", "start").call(c.font, i).text(f ? M(n, p) : n);
        var m = r.itemwidth + 2 * h.itemGap;
        d.positionText(g, m, 0), f ? g.call(d.makeEditable, {
          gd: t,
          text: n
        }).call(k, e, t, r).on("edit", function (n) {
          this.text(M(n, p)).call(k, e, t, r);
          var i = l.trace._fullInput || {},
            c = {};
          if (o.hasTransform(i, "groupby")) {
            var u = o.getTransformIndices(i, "groupby"),
              d = u[u.length - 1],
              f = a.keyedContainer(i, "transforms[" + d + "].styles", "target", "value.name");
            f.set(l.trace._group, n), c = f.constructUpdate();
          } else c.name = n;
          return o.call("_guiRestyle", t, c, s.index);
        }) : k(g, e, t, r);
      }
      function M(e, t) {
        var r = Math.max(4, t);
        if (e && e.trim().length >= r / 2) return e;
        for (var n = r - (e = e || "").length; n > 0; n--) e += " ";
        return e;
      }
      function T(e, t) {
        var r,
          i = t._context.doubleClickDelay,
          o = 1,
          l = a.ensureSingle(e, "rect", "legendtoggle", function (e) {
            t._context.staticPlot || e.style("cursor", "pointer").attr("pointer-events", "all"), e.call(u.fill, "rgba(0,0,0,0)");
          });
        t._context.staticPlot || (l.on("mousedown", function () {
          (r = new Date().getTime()) - t._legendMouseDownTime < i ? o += 1 : (o = 1, t._legendMouseDownTime = r);
        }), l.on("mouseup", function () {
          if (!t._dragged && !t._editing) {
            var r = t._fullLayout.legend;
            new Date().getTime() - t._legendMouseDownTime > i && (o = Math.max(o - 1, 1)), _(t, r, e, o, n.event);
          }
        }));
      }
      function k(e, t, r, n, a) {
        n._inHover && e.attr("data-notex", !0), d.convertToTspans(e, r, function () {
          !function (e, t, r, n) {
            var a = e.data()[0][0];
            if (!r._inHover && a && !a.trace.showlegend) return void e.remove();
            var i = e.select("g[class*=math-group]"),
              o = i.node();
            r || (r = t._fullLayout.legend);
            var l,
              s = r.borderwidth;
            l = 1 === n ? r.title.font : a.groupTitle ? a.groupTitle.font : r.font;
            var u,
              f,
              p = l.size * g;
            if (o) {
              var m = c.bBox(o);
              u = m.height, f = m.width, 1 === n ? c.setTranslate(i, s, s + .75 * u) : c.setTranslate(i, 0, .25 * u);
            } else {
              var y = e.select(1 === n ? ".legendtitletext" : ".legendtext"),
                v = d.lineCount(y),
                x = y.node();
              if (u = p * v, f = x ? c.bBox(x).width : 0, 1 === n) "left" === r.title.side && (f += 2 * h.itemGap), d.positionText(y, s + h.titlePad, s + p);else {
                var b = 2 * h.itemGap + r.itemwidth;
                a.groupTitle && (b = h.itemGap, f -= r.itemwidth), d.positionText(y, b, -p * ((v - 1) / 2 - .3));
              }
            }
            1 === n ? (r._titleWidth = f, r._titleHeight = u) : (a.lineHeight = p, a.height = Math.max(u, 16) + 3, a.width = f);
          }(t, r, n, a);
        });
      }
      function A(e) {
        return a.isRightAnchor(e) ? "right" : a.isCenterAnchor(e) ? "center" : "left";
      }
      function L(e) {
        return a.isBottomAnchor(e) ? "bottom" : a.isMiddleAnchor(e) ? "middle" : "top";
      }
      t.exports = function (e, t) {
        return t || (t = e._fullLayout.legend || {}), function (e, t) {
          var r,
            l,
            d = e._fullLayout,
            f = "legend" + d._uid,
            p = t._inHover;
          p ? (r = t.layer, f += "-hover") : r = d._infolayer;
          if (!r) return;
          e._legendMouseDownTime || (e._legendMouseDownTime = 0);
          if (p) {
            if (!t.entries) return;
            l = v(t.entries, t);
          } else {
            if (!e.calcdata) return;
            l = d.showlegend && v(e.calcdata, t);
          }
          var g = d.hiddenlabels || [];
          if (!(p || d.showlegend && l.length)) return r.selectAll(".legend").remove(), d._topdefs.select("#" + f).remove(), i.autoMargin(e, "legend");
          var M = a.ensureSingle(r, "g", "legend", function (e) {
              p || e.attr("pointer-events", "all");
            }),
            D = a.ensureSingleById(d._topdefs, "clipPath", f, function (e) {
              e.append("rect");
            }),
            S = a.ensureSingle(M, "rect", "bg", function (e) {
              e.attr("shape-rendering", "crispEdges");
            });
          S.call(u.stroke, t.bordercolor).call(u.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px");
          var C = a.ensureSingle(M, "g", "scrollbox"),
            O = t.title;
          if (t._titleWidth = 0, t._titleHeight = 0, O.text) {
            var P = a.ensureSingle(C, "text", "legendtitletext");
            P.attr("text-anchor", "start").call(c.font, O.font).text(O.text), k(P, C, e, t, 1);
          } else C.selectAll(".legendtitletext").remove();
          var I = a.ensureSingle(M, "rect", "scrollbar", function (e) {
              e.attr(h.scrollBarEnterAttrs).call(u.fill, h.scrollBarColor);
            }),
            z = C.selectAll("g.groups").data(l);
          z.enter().append("g").attr("class", "groups"), z.exit().remove();
          var R = z.selectAll("g.traces").data(a.identity);
          R.enter().append("g").attr("class", "traces"), R.exit().remove(), R.style("opacity", function (e) {
            var t = e[0].trace;
            return o.traceIs(t, "pie-like") ? -1 !== g.indexOf(e[0].label) ? .5 : 1 : "legendonly" === t.visible ? .5 : 1;
          }).each(function () {
            n.select(this).call(w, e, t);
          }).call(x, e, t).each(function () {
            p || n.select(this).call(T, e);
          }), a.syncOrAsync([i.previousPromises, function () {
            return function (e, t, r, a) {
              var i = e._fullLayout;
              a || (a = i.legend);
              var o = i._size,
                l = b.isVertical(a),
                s = b.isGrouped(a),
                u = a.borderwidth,
                d = 2 * u,
                f = h.itemGap,
                p = a.itemwidth + 2 * f,
                g = 2 * (u + f),
                m = L(a),
                y = a.y < 0 || 0 === a.y && "top" === m,
                v = a.y > 1 || 1 === a.y && "bottom" === m,
                x = a.tracegroupgap;
              a._maxHeight = Math.max(y || v ? i.height / 2 : o.h, 30);
              var _ = 0;
              a._width = 0, a._height = 0;
              var w = function (e) {
                var t = 0,
                  r = 0,
                  n = e.title.side;
                n && (-1 !== n.indexOf("left") && (t = e._titleWidth), -1 !== n.indexOf("top") && (r = e._titleHeight));
                return [t, r];
              }(a);
              if (l) r.each(function (e) {
                var t = e[0].height;
                c.setTranslate(this, u + w[0], u + w[1] + a._height + t / 2 + f), a._height += t, a._width = Math.max(a._width, e[0].width);
              }), _ = p + a._width, a._width += f + p + d, a._height += g, s && (t.each(function (e, t) {
                c.setTranslate(this, 0, t * a.tracegroupgap);
              }), a._height += (a._lgroupsLength - 1) * a.tracegroupgap);else {
                var M = A(a),
                  T = a.x < 0 || 0 === a.x && "right" === M,
                  k = a.x > 1 || 1 === a.x && "left" === M,
                  D = v || y,
                  S = i.width / 2;
                a._maxWidth = Math.max(T ? D && "left" === M ? o.l + o.w : S : k ? D && "right" === M ? o.r + o.w : S : o.w, 2 * p);
                var C = 0,
                  O = 0;
                r.each(function (e) {
                  var t = e[0].width + p;
                  C = Math.max(C, t), O += t;
                }), _ = null;
                var P = 0;
                if (s) {
                  var I = 0,
                    z = 0,
                    R = 0;
                  t.each(function () {
                    var e = 0,
                      t = 0;
                    n.select(this).selectAll("g.traces").each(function (r) {
                      var n = r[0].height;
                      c.setTranslate(this, w[0], w[1] + u + f + n / 2 + t), t += n, e = Math.max(e, p + r[0].width);
                    }), I = Math.max(I, t);
                    var r = e + f;
                    r + u + z > a._maxWidth && (P = Math.max(P, z), z = 0, R += I + x, I = t), c.setTranslate(this, z, R), z += r;
                  }), a._width = Math.max(P, z) + u, a._height = R + I + g;
                } else {
                  var N = r.size(),
                    F = O + d + (N - 1) * f < a._maxWidth,
                    E = 0,
                    j = 0,
                    H = 0,
                    B = 0;
                  r.each(function (e) {
                    var t = e[0].height,
                      r = p + e[0].width,
                      n = (F ? r : C) + f;
                    n + u + j - f >= a._maxWidth && (P = Math.max(P, B), j = 0, H += E, a._height += E, E = 0), c.setTranslate(this, w[0] + u + j, w[1] + u + H + t / 2 + f), B = j + r + f, j += n, E = Math.max(E, t);
                  }), F ? (a._width = j + d, a._height = E + g) : (a._width = Math.max(P, B) + d, a._height += E + g);
                }
              }
              a._width = Math.ceil(Math.max(a._width + w[0], a._titleWidth + 2 * (u + h.titlePad))), a._height = Math.ceil(Math.max(a._height + w[1], a._titleHeight + 2 * (u + h.itemGap))), a._effHeight = Math.min(a._height, a._maxHeight);
              var Y = e._context.edits,
                U = Y.legendText || Y.legendPosition;
              r.each(function (e) {
                var t = n.select(this).select(".legendtoggle"),
                  r = e[0].height,
                  a = U ? p : _ || p + e[0].width;
                l || (a += f / 2), c.setRect(t, 0, -r / 2, a, r);
              });
            }(e, z, R, t);
          }, function () {
            if (p || !function (e) {
              var t = e._fullLayout.legend,
                r = A(t),
                n = L(t);
              return i.autoMargin(e, "legend", {
                x: t.x,
                y: t.y,
                l: t._width * m[r],
                r: t._width * y[r],
                b: t._effHeight * y[n],
                t: t._effHeight * m[n]
              });
            }(e)) {
              var l,
                u,
                g,
                v,
                x = d._size,
                b = t.borderwidth,
                w = x.l + x.w * t.x - m[A(t)] * t._width,
                T = x.t + x.h * (1 - t.y) - m[L(t)] * t._effHeight;
              if (!p && d.margin.autoexpand) {
                var k = w,
                  O = T;
                w = a.constrain(w, 0, d.width - t._width), T = a.constrain(T, 0, d.height - t._effHeight), w !== k && a.log("Constrain legend.x to make legend fit inside graph"), T !== O && a.log("Constrain legend.y to make legend fit inside graph");
              }
              if (p || c.setTranslate(M, w, T), I.on(".drag", null), M.on("wheel", null), p || t._height <= t._maxHeight || e._context.staticPlot) {
                var P = t._effHeight;
                p && (P = t._height), S.attr({
                  width: t._width - b,
                  height: P - b,
                  x: b / 2,
                  y: b / 2
                }), c.setTranslate(C, 0, 0), D.select("rect").attr({
                  width: t._width - 2 * b,
                  height: P - 2 * b,
                  x: b,
                  y: b
                }), c.setClipUrl(C, f, e), c.setRect(I, 0, 0, 0, 0), delete t._scrollY;
              } else {
                var z,
                  R,
                  N,
                  F = Math.max(h.scrollBarMinHeight, t._effHeight * t._effHeight / t._height),
                  E = t._effHeight - F - 2 * h.scrollBarMargin,
                  j = t._height - t._effHeight,
                  H = E / j,
                  B = Math.min(t._scrollY || 0, j);
                S.attr({
                  width: t._width - 2 * b + h.scrollBarWidth + h.scrollBarMargin,
                  height: t._effHeight - b,
                  x: b / 2,
                  y: b / 2
                }), D.select("rect").attr({
                  width: t._width - 2 * b + h.scrollBarWidth + h.scrollBarMargin,
                  height: t._effHeight - 2 * b,
                  x: b,
                  y: b + B
                }), c.setClipUrl(C, f, e), V(B, F, H), M.on("wheel", function () {
                  V(B = a.constrain(t._scrollY + n.event.deltaY / E * j, 0, j), F, H), 0 !== B && B !== j && n.event.preventDefault();
                });
                var Y = n.behavior.drag().on("dragstart", function () {
                  var e = n.event.sourceEvent;
                  z = "touchstart" === e.type ? e.changedTouches[0].clientY : e.clientY, N = B;
                }).on("drag", function () {
                  var e = n.event.sourceEvent;
                  2 === e.buttons || e.ctrlKey || (R = "touchmove" === e.type ? e.changedTouches[0].clientY : e.clientY, V(B = function (e, t, r) {
                    var n = (r - t) / H + e;
                    return a.constrain(n, 0, j);
                  }(N, z, R), F, H));
                });
                I.call(Y);
                var U = n.behavior.drag().on("dragstart", function () {
                  var e = n.event.sourceEvent;
                  "touchstart" === e.type && (z = e.changedTouches[0].clientY, N = B);
                }).on("drag", function () {
                  var e = n.event.sourceEvent;
                  "touchmove" === e.type && (R = e.changedTouches[0].clientY, V(B = function (e, t, r) {
                    var n = (t - r) / H + e;
                    return a.constrain(n, 0, j);
                  }(N, z, R), F, H));
                });
                C.call(U);
              }
              if (e._context.edits.legendPosition) M.classed("cursor-move", !0), s.init({
                element: M.node(),
                gd: e,
                prepFn: function prepFn() {
                  var e = c.getTranslate(M);
                  g = e.x, v = e.y;
                },
                moveFn: function moveFn(e, r) {
                  var n = g + e,
                    a = v + r;
                  c.setTranslate(M, n, a), l = s.align(n, 0, x.l, x.l + x.w, t.xanchor), u = s.align(a, 0, x.t + x.h, x.t, t.yanchor);
                },
                doneFn: function doneFn() {
                  void 0 !== l && void 0 !== u && o.call("_guiRelayout", e, {
                    "legend.x": l,
                    "legend.y": u
                  });
                },
                clickFn: function clickFn(t, n) {
                  var a = r.selectAll("g.traces").filter(function () {
                    var e = this.getBoundingClientRect();
                    return n.clientX >= e.left && n.clientX <= e.right && n.clientY >= e.top && n.clientY <= e.bottom;
                  });
                  a.size() > 0 && _(e, M, a, t, n);
                }
              });
            }
            function V(r, n, a) {
              t._scrollY = e._fullLayout.legend._scrollY = r, c.setTranslate(C, 0, -r), c.setRect(I, t._width, h.scrollBarMargin + r * a, h.scrollBarWidth, n), D.select("rect").attr("y", b + r);
            }
          }], e);
        }(e, t);
      };
    }, {
      "../../constants/alignment": 201,
      "../../lib": 225,
      "../../lib/events": 218,
      "../../lib/svg_text_utils": 248,
      "../../plots/plots": 307,
      "../../registry": 309,
      "../color": 96,
      "../dragelement": 115,
      "../drawing": 118,
      "./constants": 147,
      "./get_legend_data": 150,
      "./handle_click": 151,
      "./helpers": 152,
      "./style": 154,
      "@plotly/d3": 6
    }],
    150: [function (e, t, r) {
      "use strict";

      var n = e("../../registry"),
        a = e("./helpers");
      t.exports = function (e, t) {
        var r,
          i,
          o = t._inHover,
          l = a.isGrouped(t),
          s = a.isReversed(t),
          c = {},
          u = [],
          d = !1,
          f = {},
          h = 0,
          p = 0;
        function g(e, r) {
          if ("" !== e && a.isGrouped(t)) -1 === u.indexOf(e) ? (u.push(e), d = !0, c[e] = [r]) : c[e].push(r);else {
            var n = "~~i" + h;
            u.push(n), c[n] = [r], h++;
          }
        }
        for (r = 0; r < e.length; r++) {
          var m = e[r],
            y = m[0],
            v = y.trace,
            x = v.legendgroup;
          if (o || v.visible && v.showlegend) if (n.traceIs(v, "pie-like")) for (f[x] || (f[x] = {}), i = 0; i < m.length; i++) {
            var b = m[i].label;
            f[x][b] || (g(x, {
              label: b,
              color: m[i].color,
              i: m[i].i,
              trace: v,
              pts: m[i].pts
            }), f[x][b] = !0, p = Math.max(p, (b || "").length));
          } else g(x, y), p = Math.max(p, (v.name || "").length);
        }
        if (!u.length) return [];
        var _ = !d || !l,
          w = [];
        for (r = 0; r < u.length; r++) {
          var M = c[u[r]];
          _ ? w.push(M[0]) : w.push(M);
        }
        for (_ && (w = [w]), r = 0; r < w.length; r++) {
          var T = 1 / 0;
          for (i = 0; i < w[r].length; i++) {
            var k = w[r][i].trace.legendrank;
            T > k && (T = k);
          }
          w[r][0]._groupMinRank = T, w[r][0]._preGroupSort = r;
        }
        var A = function A(e, t) {
          return e.trace.legendrank - t.trace.legendrank || e._preSort - t._preSort;
        };
        for (w.forEach(function (e, t) {
          e[0]._preGroupSort = t;
        }), w.sort(function (e, t) {
          return e[0]._groupMinRank - t[0]._groupMinRank || e[0]._preGroupSort - t[0]._preGroupSort;
        }), r = 0; r < w.length; r++) {
          w[r].forEach(function (e, t) {
            e._preSort = t;
          }), w[r].sort(A);
          var L = w[r][0].trace,
            D = null;
          for (i = 0; i < w[r].length; i++) {
            var S = w[r][i].trace.legendgrouptitle;
            if (S && S.text) {
              D = S, o && (S.font = t._groupTitleFont);
              break;
            }
          }
          if (s && w[r].reverse(), D) {
            var C = !1;
            for (i = 0; i < w[r].length; i++) if (n.traceIs(w[r][i].trace, "pie-like")) {
              C = !0;
              break;
            }
            w[r].unshift({
              i: -1,
              groupTitle: D,
              noClick: C,
              trace: {
                showlegend: L.showlegend,
                legendgroup: L.legendgroup,
                visible: "toggleitem" === t.groupclick || L.visible
              }
            });
          }
          for (i = 0; i < w[r].length; i++) w[r][i] = [w[r][i]];
        }
        return t._lgroupsLength = w.length, t._maxNameLength = p, w;
      };
    }, {
      "../../registry": 309,
      "./helpers": 152
    }],
    151: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../registry"),
        i = !0;
      t.exports = function (e, t, r) {
        var o = t._fullLayout;
        if (!t._dragged && !t._editing) {
          var l,
            s = o.legend.itemclick,
            c = o.legend.itemdoubleclick,
            u = o.legend.groupclick;
          if (1 === r && "toggle" === s && "toggleothers" === c && i && t.data && t._context.showTips ? (n.notifier(n._(t, "Double-click on legend to isolate one trace"), "long"), i = !1) : i = !1, 1 === r ? l = s : 2 === r && (l = c), l) {
            var d = "togglegroup" === u,
              f = o.hiddenlabels ? o.hiddenlabels.slice() : [],
              h = e.data()[0][0];
            if (!h.groupTitle || !h.noClick) {
              var p,
                g,
                m,
                y,
                v,
                x = t._fullData,
                b = h.trace,
                _ = b.legendgroup,
                w = {},
                M = [],
                T = [],
                k = [];
              if (a.traceIs(b, "pie-like")) {
                var A = h.label,
                  L = f.indexOf(A);
                "toggle" === l ? -1 === L ? f.push(A) : f.splice(L, 1) : "toggleothers" === l && (f = [], t.calcdata[0].forEach(function (e) {
                  A !== e.label && f.push(e.label);
                }), t._fullLayout.hiddenlabels && t._fullLayout.hiddenlabels.length === f.length && -1 === L && (f = [])), a.call("_guiRelayout", t, "hiddenlabels", f);
              } else {
                var D,
                  S = _ && _.length,
                  C = [];
                if (S) for (p = 0; p < x.length; p++) (D = x[p]).visible && D.legendgroup === _ && C.push(p);
                if ("toggle" === l) {
                  var O;
                  switch (b.visible) {
                    case !0:
                      O = "legendonly";
                      break;
                    case !1:
                      O = !1;
                      break;
                    case "legendonly":
                      O = !0;
                  }
                  if (S) {
                    if (d) for (p = 0; p < x.length; p++) !1 !== x[p].visible && x[p].legendgroup === _ && H(x[p], O);else H(b, O);
                  } else H(b, O);
                } else if ("toggleothers" === l) {
                  var P,
                    I,
                    z,
                    R,
                    N = !0;
                  for (p = 0; p < x.length; p++) if (P = x[p] === b, z = !0 !== x[p].showlegend, !(P || z || (I = S && x[p].legendgroup === _) || !0 !== x[p].visible || a.traceIs(x[p], "notLegendIsolatable"))) {
                    N = !1;
                    break;
                  }
                  for (p = 0; p < x.length; p++) if (!1 !== x[p].visible && !a.traceIs(x[p], "notLegendIsolatable")) switch (b.visible) {
                    case "legendonly":
                      H(x[p], !0);
                      break;
                    case !0:
                      R = !!N || "legendonly", P = x[p] === b, z = !0 !== x[p].showlegend && !x[p].legendgroup, I = P || S && x[p].legendgroup === _, H(x[p], !(!I && !z) || R);
                  }
                }
                for (p = 0; p < T.length; p++) if (m = T[p]) {
                  var F = m.constructUpdate(),
                    E = Object.keys(F);
                  for (g = 0; g < E.length; g++) y = E[g], (w[y] = w[y] || [])[k[p]] = F[y];
                }
                for (v = Object.keys(w), p = 0; p < v.length; p++) for (y = v[p], g = 0; g < M.length; g++) w[y].hasOwnProperty(g) || (w[y][g] = void 0);
                a.call("_guiRestyle", t, w, M);
              }
            }
          }
        }
        function j(e, t, r) {
          var n = M.indexOf(e),
            a = w[t];
          return a || (a = w[t] = []), -1 === M.indexOf(e) && (M.push(e), n = M.length - 1), a[n] = r, n;
        }
        function H(e, t) {
          if (!h.groupTitle || d) {
            var r = e._fullInput;
            if (a.hasTransform(r, "groupby")) {
              var i = T[r.index];
              if (!i) {
                var o = a.getTransformIndices(r, "groupby"),
                  l = o[o.length - 1];
                i = n.keyedContainer(r, "transforms[" + l + "].styles", "target", "value.visible"), T[r.index] = i;
              }
              var s = i.get(e._group);
              void 0 === s && (s = !0), !1 !== s && i.set(e._group, t), k[r.index] = j(r.index, "visible", !1 !== r.visible);
            } else {
              var c = !1 !== r.visible && t;
              j(r.index, "visible", c);
            }
          }
        }
      };
    }, {
      "../../lib": 225,
      "../../registry": 309
    }],
    152: [function (e, t, r) {
      "use strict";

      r.isGrouped = function (e) {
        return -1 !== (e.traceorder || "").indexOf("grouped");
      }, r.isVertical = function (e) {
        return "h" !== e.orientation;
      }, r.isReversed = function (e) {
        return -1 !== (e.traceorder || "").indexOf("reversed");
      };
    }, {}],
    153: [function (e, t, r) {
      "use strict";

      t.exports = {
        moduleType: "component",
        name: "legend",
        layoutAttributes: e("./attributes"),
        supplyLayoutDefaults: e("./defaults"),
        draw: e("./draw"),
        style: e("./style")
      };
    }, {
      "./attributes": 146,
      "./defaults": 148,
      "./draw": 149,
      "./style": 154
    }],
    154: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../registry"),
        i = e("../../lib"),
        o = i.strTranslate,
        l = e("../drawing"),
        s = e("../color"),
        c = e("../colorscale/helpers").extractOpts,
        u = e("../../traces/scatter/subtypes"),
        d = e("../../traces/pie/style_one"),
        f = e("../../traces/pie/helpers").castOption,
        h = e("./constants");
      function p(e, t) {
        return (t ? "radial" : "horizontal") + (e ? "" : "reversed");
      }
      function g(e) {
        var t = e[0].trace,
          r = t.contours,
          n = u.hasLines(t),
          a = u.hasMarkers(t),
          i = t.visible && t.fill && "none" !== t.fill,
          o = !1,
          l = !1;
        if (r) {
          var s = r.coloring;
          "lines" === s ? o = !0 : n = "none" === s || "heatmap" === s || r.showlines, "constraint" === r.type ? i = "=" !== r._operation : "fill" !== s && "heatmap" !== s || (l = !0);
        }
        return {
          showMarker: a,
          showLine: n,
          showFill: i,
          showGradientLine: o,
          showGradientFill: l,
          anyLine: n || o,
          anyFill: i || l
        };
      }
      function m(e, t, r) {
        return e && i.isArrayOrTypedArray(e) ? t : e > r ? r : e;
      }
      t.exports = function (e, t, r) {
        var y = t._fullLayout;
        r || (r = y.legend);
        var v = "constant" === r.itemsizing,
          x = r.itemwidth,
          b = (x + 2 * h.itemGap) / 2,
          _ = o(b, 0),
          w = function w(e, t, r, n) {
            var a;
            if (e + 1) a = e;else {
              if (!(t && t.width > 0)) return 0;
              a = t.width;
            }
            return v ? n : Math.min(a, r);
          };
        function M(e, i, o) {
          var u = e[0].trace,
            d = u.marker || {},
            f = d.line || {},
            h = o ? u.visible && u.type === o : a.traceIs(u, "bar"),
            p = n.select(i).select("g.legendpoints").selectAll("path.legend" + o).data(h ? [e] : []);
          p.enter().append("path").classed("legend" + o, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), p.exit().remove(), p.each(function (e) {
            var a = n.select(this),
              i = e[0],
              o = w(i.mlw, d.line, 5, 2);
            a.style("stroke-width", o + "px");
            var h = i.mcc;
            if (!r._inHover && "mc" in i) {
              var p = c(d),
                g = p.mid;
              void 0 === g && (g = (p.max + p.min) / 2), h = l.tryColorscale(d, "")(g);
            }
            var y = h || i.mc || d.color,
              v = d.pattern,
              x = v && l.getPatternAttr(v.shape, 0, "");
            if (x) {
              var b = l.getPatternAttr(v.bgcolor, 0, null),
                _ = l.getPatternAttr(v.fgcolor, 0, null),
                M = v.fgopacity,
                T = m(v.size, 8, 10),
                k = m(v.solidity, .5, 1),
                A = "legend-" + u.uid;
              a.call(l.pattern, "legend", t, A, x, T, k, h, v.fillmode, b, _, M);
            } else a.call(s.fill, y);
            o && s.stroke(a, i.mlc || f.color);
          });
        }
        function T(e, t, r) {
          var o = e[0],
            l = o.trace,
            s = r ? l.visible && l.type === r : a.traceIs(l, r),
            c = n.select(t).select("g.legendpoints").selectAll("path.legend" + r).data(s ? [e] : []);
          if (c.enter().append("path").classed("legend" + r, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), c.exit().remove(), c.size()) {
            var u = (l.marker || {}).line,
              h = w(f(u.width, o.pts), u, 5, 2),
              p = i.minExtend(l, {
                marker: {
                  line: {
                    width: h
                  }
                }
              });
            p.marker.line.color = u.color;
            var g = i.minExtend(o, {
              trace: p
            });
            d(c, g, p);
          }
        }
        e.each(function (e) {
          var t = n.select(this),
            a = i.ensureSingle(t, "g", "layers");
          a.style("opacity", e[0].trace.opacity);
          var l = r.valign,
            s = e[0].lineHeight,
            c = e[0].height;
          if ("middle" !== l && s && c) {
            var u = {
              top: 1,
              bottom: -1
            }[l] * (.5 * (s - c + 3));
            a.attr("transform", o(0, u));
          } else a.attr("transform", null);
          a.selectAll("g.legendfill").data([e]).enter().append("g").classed("legendfill", !0), a.selectAll("g.legendlines").data([e]).enter().append("g").classed("legendlines", !0);
          var d = a.selectAll("g.legendsymbols").data([e]);
          d.enter().append("g").classed("legendsymbols", !0), d.selectAll("g.legendpoints").data([e]).enter().append("g").classed("legendpoints", !0);
        }).each(function (e) {
          var r,
            a = e[0].trace,
            o = [];
          if (a.visible) switch (a.type) {
            case "histogram2d":
            case "heatmap":
              o = [["M-15,-2V4H15V-2Z"]], r = !0;
              break;
            case "choropleth":
            case "choroplethmapbox":
              o = [["M-6,-6V6H6V-6Z"]], r = !0;
              break;
            case "densitymapbox":
              o = [["M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"]], r = "radial";
              break;
            case "cone":
              o = [["M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"], ["M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"]], r = !1;
              break;
            case "streamtube":
              o = [["M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"], ["M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"]], r = !1;
              break;
            case "surface":
              o = [["M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"], ["M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"]], r = !0;
              break;
            case "mesh3d":
              o = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], r = !1;
              break;
            case "volume":
              o = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], r = !0;
              break;
            case "isosurface":
              o = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"]], r = !1;
          }
          var u = n.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(o);
          u.enter().append("path").classed("legend3dandfriends", !0).attr("transform", _).style("stroke-miterlimit", 1), u.exit().remove(), u.each(function (e, o) {
            var u,
              d = n.select(this),
              f = c(a),
              h = f.colorscale,
              g = f.reversescale;
            if (h) {
              if (!r) {
                var m = h.length;
                u = 0 === o ? h[g ? m - 1 : 0][1] : 1 === o ? h[g ? 0 : m - 1][1] : h[Math.floor((m - 1) / 2)][1];
              }
            } else {
              var y = a.vertexcolor || a.facecolor || a.color;
              u = i.isArrayOrTypedArray(y) ? y[o] || y[0] : y;
            }
            d.attr("d", e[0]), u ? d.call(s.fill, u) : d.call(function (e) {
              if (e.size()) {
                var n = "legendfill-" + a.uid;
                l.gradient(e, t, n, p(g, "radial" === r), h, "fill");
              }
            });
          });
        }).each(function (e) {
          var t = e[0].trace,
            r = "waterfall" === t.type;
          if (e[0]._distinct && r) {
            var a = e[0].trace[e[0].dir].marker;
            return e[0].mc = a.color, e[0].mlw = a.line.width, e[0].mlc = a.line.color, M(e, this, "waterfall");
          }
          var i = [];
          t.visible && r && (i = e[0].hasTotals ? [["increasing", "M-6,-6V6H0Z"], ["totals", "M6,6H0L-6,-6H-0Z"], ["decreasing", "M6,6V-6H0Z"]] : [["increasing", "M-6,-6V6H6Z"], ["decreasing", "M6,6V-6H-6Z"]]);
          var o = n.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data(i);
          o.enter().append("path").classed("legendwaterfall", !0).attr("transform", _).style("stroke-miterlimit", 1), o.exit().remove(), o.each(function (e) {
            var r = n.select(this),
              a = t[e[0]].marker,
              i = w(void 0, a.line, 5, 2);
            r.attr("d", e[1]).style("stroke-width", i + "px").call(s.fill, a.color), i && r.call(s.stroke, a.line.color);
          });
        }).each(function (e) {
          M(e, this, "funnel");
        }).each(function (e) {
          M(e, this);
        }).each(function (e) {
          var r = e[0].trace,
            o = n.select(this).select("g.legendpoints").selectAll("path.legendbox").data(r.visible && a.traceIs(r, "box-violin") ? [e] : []);
          o.enter().append("path").classed("legendbox", !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), o.exit().remove(), o.each(function () {
            var e = n.select(this);
            if ("all" !== r.boxpoints && "all" !== r.points || 0 !== s.opacity(r.fillcolor) || 0 !== s.opacity((r.line || {}).color)) {
              var a = w(void 0, r.line, 5, 2);
              e.style("stroke-width", a + "px").call(s.fill, r.fillcolor), a && s.stroke(e, r.line.color);
            } else {
              var c = i.minExtend(r, {
                marker: {
                  size: v ? 12 : i.constrain(r.marker.size, 2, 16),
                  sizeref: 1,
                  sizemin: 1,
                  sizemode: "diameter"
                }
              });
              o.call(l.pointStyle, c, t);
            }
          });
        }).each(function (e) {
          T(e, this, "funnelarea");
        }).each(function (e) {
          T(e, this, "pie");
        }).each(function (e) {
          var r,
            a,
            o = g(e),
            s = o.showFill,
            d = o.showLine,
            f = o.showGradientLine,
            h = o.showGradientFill,
            m = o.anyFill,
            y = o.anyLine,
            v = e[0],
            b = v.trace,
            _ = c(b),
            M = _.colorscale,
            T = _.reversescale,
            k = u.hasMarkers(b) || !m ? "M5,0" : y ? "M5,-2" : "M5,-3",
            A = n.select(this),
            L = A.select(".legendfill").selectAll("path").data(s || h ? [e] : []);
          if (L.enter().append("path").classed("js-fill", !0), L.exit().remove(), L.attr("d", k + "h" + x + "v6h-" + x + "z").call(s ? l.fillGroupStyle : function (e) {
            if (e.size()) {
              var r = "legendfill-" + b.uid;
              l.gradient(e, t, r, p(T), M, "fill");
            }
          }), d || f) {
            var D = w(void 0, b.line, 10, 5);
            a = i.minExtend(b, {
              line: {
                width: D
              }
            }), r = [i.minExtend(v, {
              trace: a
            })];
          }
          var S = A.select(".legendlines").selectAll("path").data(d || f ? [r] : []);
          S.enter().append("path").classed("js-line", !0), S.exit().remove(), S.attr("d", k + (f ? "l" + x + ",0.0001" : "h" + x)).call(d ? l.lineGroupStyle : function (e) {
            if (e.size()) {
              var r = "legendline-" + b.uid;
              l.lineGroupStyle(e), l.gradient(e, t, r, p(T), M, "stroke");
            }
          });
        }).each(function (e) {
          var r,
            a,
            o = g(e),
            s = o.anyFill,
            c = o.anyLine,
            d = o.showLine,
            f = o.showMarker,
            h = e[0],
            p = h.trace,
            m = !f && !c && !s && u.hasText(p);
          function y(e, t, r, n) {
            var a = i.nestedProperty(p, e).get(),
              o = i.isArrayOrTypedArray(a) && t ? t(a) : a;
            if (v && o && void 0 !== n && (o = n), r) {
              if (o < r[0]) return r[0];
              if (o > r[1]) return r[1];
            }
            return o;
          }
          function x(e) {
            return h._distinct && h.index && e[h.index] ? e[h.index] : e[0];
          }
          if (f || m || d) {
            var b = {},
              w = {};
            if (f) {
              b.mc = y("marker.color", x), b.mx = y("marker.symbol", x), b.mo = y("marker.opacity", i.mean, [.2, 1]), b.mlc = y("marker.line.color", x), b.mlw = y("marker.line.width", i.mean, [0, 5], 2), w.marker = {
                sizeref: 1,
                sizemin: 1,
                sizemode: "diameter"
              };
              var M = y("marker.size", i.mean, [2, 16], 12);
              b.ms = M, w.marker.size = M;
            }
            d && (w.line = {
              width: y("line.width", x, [0, 10], 5)
            }), m && (b.tx = "Aa", b.tp = y("textposition", x), b.ts = 10, b.tc = y("textfont.color", x), b.tf = y("textfont.family", x)), r = [i.minExtend(h, b)], (a = i.minExtend(p, w)).selectedpoints = null, a.texttemplate = null;
          }
          var T = n.select(this).select("g.legendpoints"),
            k = T.selectAll("path.scatterpts").data(f ? r : []);
          k.enter().insert("path", ":first-child").classed("scatterpts", !0).attr("transform", _), k.exit().remove(), k.call(l.pointStyle, a, t), f && (r[0].mrc = 3);
          var A = T.selectAll("g.pointtext").data(m ? r : []);
          A.enter().append("g").classed("pointtext", !0).append("text").attr("transform", _), A.exit().remove(), A.selectAll("text").call(l.textPointStyle, a, t);
        }).each(function (e) {
          var t = e[0].trace,
            r = n.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(t.visible && "candlestick" === t.type ? [e, e] : []);
          r.enter().append("path").classed("legendcandle", !0).attr("d", function (e, t) {
            return t ? "M-15,0H-8M-8,6V-6H8Z" : "M15,0H8M8,-6V6H-8Z";
          }).attr("transform", _).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function (e, r) {
            var a = n.select(this),
              i = t[r ? "increasing" : "decreasing"],
              o = w(void 0, i.line, 5, 2);
            a.style("stroke-width", o + "px").call(s.fill, i.fillcolor), o && s.stroke(a, i.line.color);
          });
        }).each(function (e) {
          var t = e[0].trace,
            r = n.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(t.visible && "ohlc" === t.type ? [e, e] : []);
          r.enter().append("path").classed("legendohlc", !0).attr("d", function (e, t) {
            return t ? "M-15,0H0M-8,-6V0" : "M15,0H0M8,6V0";
          }).attr("transform", _).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function (e, r) {
            var a = n.select(this),
              i = t[r ? "increasing" : "decreasing"],
              o = w(void 0, i.line, 5, 2);
            a.style("fill", "none").call(l.dashLine, i.line.dash, o), o && s.stroke(a, i.line.color);
          });
        });
      };
    }, {
      "../../lib": 225,
      "../../registry": 309,
      "../../traces/pie/helpers": 340,
      "../../traces/pie/style_one": 341,
      "../../traces/scatter/subtypes": 368,
      "../color": 96,
      "../colorscale/helpers": 107,
      "../drawing": 118,
      "./constants": 147,
      "@plotly/d3": 6
    }],
    155: [function (e, t, r) {
      "use strict";

      e("./constants");
      t.exports = {
        editType: "modebar",
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          dflt: "h",
          editType: "modebar"
        },
        bgcolor: {
          valType: "color",
          editType: "modebar"
        },
        color: {
          valType: "color",
          editType: "modebar"
        },
        activecolor: {
          valType: "color",
          editType: "modebar"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        add: {
          valType: "string",
          arrayOk: !0,
          dflt: "",
          editType: "modebar"
        },
        remove: {
          valType: "string",
          arrayOk: !0,
          dflt: "",
          editType: "modebar"
        }
      };
    }, {
      "./constants": 157
    }],
    156: [function (e, t, r) {
      "use strict";

      var n = e("../../registry"),
        a = e("../../plots/plots"),
        i = e("../../plots/cartesian/axis_ids"),
        o = e("../../fonts/ploticon"),
        l = e("../shapes/draw").eraseActiveShape,
        s = e("../../lib"),
        c = s._,
        u = t.exports = {};
      function d(e, t) {
        var r,
          a,
          o = t.currentTarget,
          l = o.getAttribute("data-attr"),
          s = o.getAttribute("data-val") || !0,
          c = e._fullLayout,
          u = {},
          d = i.list(e, null, !0),
          f = c._cartesianSpikesEnabled;
        if ("zoom" === l) {
          var h,
            p = "in" === s ? .5 : 2,
            g = (1 + p) / 2,
            m = (1 - p) / 2;
          for (a = 0; a < d.length; a++) if (!(r = d[a]).fixedrange) if (h = r._name, "auto" === s) u[h + ".autorange"] = !0;else if ("reset" === s) {
            if (void 0 === r._rangeInitial) u[h + ".autorange"] = !0;else {
              var y = r._rangeInitial.slice();
              u[h + ".range[0]"] = y[0], u[h + ".range[1]"] = y[1];
            }
            void 0 !== r._showSpikeInitial && (u[h + ".showspikes"] = r._showSpikeInitial, "on" !== f || r._showSpikeInitial || (f = "off"));
          } else {
            var v = [r.r2l(r.range[0]), r.r2l(r.range[1])],
              x = [g * v[0] + m * v[1], g * v[1] + m * v[0]];
            u[h + ".range[0]"] = r.l2r(x[0]), u[h + ".range[1]"] = r.l2r(x[1]);
          }
        } else "hovermode" !== l || "x" !== s && "y" !== s || (s = c._isHoriz ? "y" : "x", o.setAttribute("data-val", s)), u[l] = s;
        c._cartesianSpikesEnabled = f, n.call("_guiRelayout", e, u);
      }
      function f(e, t) {
        for (var r = t.currentTarget, a = r.getAttribute("data-attr"), i = r.getAttribute("data-val") || !0, o = e._fullLayout._subplots.gl3d || [], l = {}, s = a.split("."), c = 0; c < o.length; c++) l[o[c] + "." + s[1]] = i;
        var u = "pan" === i ? i : "zoom";
        l.dragmode = u, n.call("_guiRelayout", e, l);
      }
      function h(e, t) {
        for (var r = t.currentTarget.getAttribute("data-attr"), a = "resetLastSave" === r, i = "resetDefault" === r, o = e._fullLayout, l = o._subplots.gl3d || [], s = {}, c = 0; c < l.length; c++) {
          var u,
            d = l[c],
            f = d + ".camera",
            h = d + ".aspectratio",
            p = d + ".aspectmode",
            g = o[d]._scene;
          a ? (s[f + ".up"] = g.viewInitial.up, s[f + ".eye"] = g.viewInitial.eye, s[f + ".center"] = g.viewInitial.center, u = !0) : i && (s[f + ".up"] = null, s[f + ".eye"] = null, s[f + ".center"] = null, u = !0), u && (s[h + ".x"] = g.viewInitial.aspectratio.x, s[h + ".y"] = g.viewInitial.aspectratio.y, s[h + ".z"] = g.viewInitial.aspectratio.z, s[p] = g.viewInitial.aspectmode);
        }
        n.call("_guiRelayout", e, s);
      }
      function p(e, t) {
        var r = t.currentTarget,
          n = r._previousVal,
          a = e._fullLayout,
          i = a._subplots.gl3d || [],
          o = ["xaxis", "yaxis", "zaxis"],
          l = {},
          s = {};
        if (n) s = n, r._previousVal = null;else {
          for (var c = 0; c < i.length; c++) {
            var u = i[c],
              d = a[u],
              f = u + ".hovermode";
            l[f] = d.hovermode, s[f] = !1;
            for (var h = 0; h < 3; h++) {
              var p = o[h],
                g = u + "." + p + ".showspikes";
              s[g] = !1, l[g] = d[p].showspikes;
            }
          }
          r._previousVal = l;
        }
        return s;
      }
      function g(e, t) {
        for (var r = t.currentTarget, a = r.getAttribute("data-attr"), i = r.getAttribute("data-val") || !0, o = e._fullLayout, l = o._subplots.geo || [], s = 0; s < l.length; s++) {
          var c = l[s],
            u = o[c];
          if ("zoom" === a) {
            var d = u.projection.scale,
              f = "in" === i ? 2 * d : .5 * d;
            n.call("_guiRelayout", e, c + ".projection.scale", f);
          }
        }
        "reset" === a && x(e, "geo");
      }
      function m(e) {
        var t = e._fullLayout;
        return !t.hovermode && (t._has("cartesian") ? t._isHoriz ? "y" : "x" : "closest");
      }
      function y(e) {
        var t = m(e);
        n.call("_guiRelayout", e, "hovermode", t);
      }
      function v(e, t) {
        for (var r = t.currentTarget.getAttribute("data-val"), a = e._fullLayout, i = a._subplots.mapbox || [], o = {}, l = 0; l < i.length; l++) {
          var s = i[l],
            c = a[s].zoom,
            u = "in" === r ? 1.05 * c : c / 1.05;
          o[s + ".zoom"] = u;
        }
        n.call("_guiRelayout", e, o);
      }
      function x(e, t) {
        for (var r = e._fullLayout, a = r._subplots[t] || [], i = {}, o = 0; o < a.length; o++) for (var l = a[o], s = r[l]._subplot.viewInitial, c = Object.keys(s), u = 0; u < c.length; u++) {
          var d = c[u];
          i[l + "." + d] = s[d];
        }
        n.call("_guiRelayout", e, i);
      }
      u.toImage = {
        name: "toImage",
        title: function title(e) {
          var t = (e._context.toImageButtonOptions || {}).format || "png";
          return c(e, "png" === t ? "Download plot as a png" : "Download plot");
        },
        icon: o.camera,
        click: function click(e) {
          var t = e._context.toImageButtonOptions,
            r = {
              format: t.format || "png"
            };
          s.notifier(c(e, "Taking snapshot - this may take a few seconds"), "long"), "svg" !== r.format && s.isIE() && (s.notifier(c(e, "IE only supports svg.  Changing format to svg."), "long"), r.format = "svg"), ["filename", "width", "height", "scale"].forEach(function (e) {
            e in t && (r[e] = t[e]);
          }), n.call("downloadImage", e, r).then(function (t) {
            s.notifier(c(e, "Snapshot succeeded") + " - " + t, "long");
          }).catch(function () {
            s.notifier(c(e, "Sorry, there was a problem downloading your snapshot!"), "long");
          });
        }
      }, u.sendDataToCloud = {
        name: "sendDataToCloud",
        title: function title(e) {
          return c(e, "Edit in Chart Studio");
        },
        icon: o.disk,
        click: function click(e) {
          a.sendDataToCloud(e);
        }
      }, u.editInChartStudio = {
        name: "editInChartStudio",
        title: function title(e) {
          return c(e, "Edit in Chart Studio");
        },
        icon: o.pencil,
        click: function click(e) {
          a.sendDataToCloud(e);
        }
      }, u.zoom2d = {
        name: "zoom2d",
        _cat: "zoom",
        title: function title(e) {
          return c(e, "Zoom");
        },
        attr: "dragmode",
        val: "zoom",
        icon: o.zoombox,
        click: d
      }, u.pan2d = {
        name: "pan2d",
        _cat: "pan",
        title: function title(e) {
          return c(e, "Pan");
        },
        attr: "dragmode",
        val: "pan",
        icon: o.pan,
        click: d
      }, u.select2d = {
        name: "select2d",
        _cat: "select",
        title: function title(e) {
          return c(e, "Box Select");
        },
        attr: "dragmode",
        val: "select",
        icon: o.selectbox,
        click: d
      }, u.lasso2d = {
        name: "lasso2d",
        _cat: "lasso",
        title: function title(e) {
          return c(e, "Lasso Select");
        },
        attr: "dragmode",
        val: "lasso",
        icon: o.lasso,
        click: d
      }, u.drawclosedpath = {
        name: "drawclosedpath",
        title: function title(e) {
          return c(e, "Draw closed freeform");
        },
        attr: "dragmode",
        val: "drawclosedpath",
        icon: o.drawclosedpath,
        click: d
      }, u.drawopenpath = {
        name: "drawopenpath",
        title: function title(e) {
          return c(e, "Draw open freeform");
        },
        attr: "dragmode",
        val: "drawopenpath",
        icon: o.drawopenpath,
        click: d
      }, u.drawline = {
        name: "drawline",
        title: function title(e) {
          return c(e, "Draw line");
        },
        attr: "dragmode",
        val: "drawline",
        icon: o.drawline,
        click: d
      }, u.drawrect = {
        name: "drawrect",
        title: function title(e) {
          return c(e, "Draw rectangle");
        },
        attr: "dragmode",
        val: "drawrect",
        icon: o.drawrect,
        click: d
      }, u.drawcircle = {
        name: "drawcircle",
        title: function title(e) {
          return c(e, "Draw circle");
        },
        attr: "dragmode",
        val: "drawcircle",
        icon: o.drawcircle,
        click: d
      }, u.eraseshape = {
        name: "eraseshape",
        title: function title(e) {
          return c(e, "Erase active shape");
        },
        icon: o.eraseshape,
        click: l
      }, u.zoomIn2d = {
        name: "zoomIn2d",
        _cat: "zoomin",
        title: function title(e) {
          return c(e, "Zoom in");
        },
        attr: "zoom",
        val: "in",
        icon: o.zoom_plus,
        click: d
      }, u.zoomOut2d = {
        name: "zoomOut2d",
        _cat: "zoomout",
        title: function title(e) {
          return c(e, "Zoom out");
        },
        attr: "zoom",
        val: "out",
        icon: o.zoom_minus,
        click: d
      }, u.autoScale2d = {
        name: "autoScale2d",
        _cat: "autoscale",
        title: function title(e) {
          return c(e, "Autoscale");
        },
        attr: "zoom",
        val: "auto",
        icon: o.autoscale,
        click: d
      }, u.resetScale2d = {
        name: "resetScale2d",
        _cat: "resetscale",
        title: function title(e) {
          return c(e, "Reset axes");
        },
        attr: "zoom",
        val: "reset",
        icon: o.home,
        click: d
      }, u.hoverClosestCartesian = {
        name: "hoverClosestCartesian",
        _cat: "hoverclosest",
        title: function title(e) {
          return c(e, "Show closest data on hover");
        },
        attr: "hovermode",
        val: "closest",
        icon: o.tooltip_basic,
        gravity: "ne",
        click: d
      }, u.hoverCompareCartesian = {
        name: "hoverCompareCartesian",
        _cat: "hoverCompare",
        title: function title(e) {
          return c(e, "Compare data on hover");
        },
        attr: "hovermode",
        val: function val(e) {
          return e._fullLayout._isHoriz ? "y" : "x";
        },
        icon: o.tooltip_compare,
        gravity: "ne",
        click: d
      }, u.zoom3d = {
        name: "zoom3d",
        _cat: "zoom",
        title: function title(e) {
          return c(e, "Zoom");
        },
        attr: "scene.dragmode",
        val: "zoom",
        icon: o.zoombox,
        click: f
      }, u.pan3d = {
        name: "pan3d",
        _cat: "pan",
        title: function title(e) {
          return c(e, "Pan");
        },
        attr: "scene.dragmode",
        val: "pan",
        icon: o.pan,
        click: f
      }, u.orbitRotation = {
        name: "orbitRotation",
        title: function title(e) {
          return c(e, "Orbital rotation");
        },
        attr: "scene.dragmode",
        val: "orbit",
        icon: o["3d_rotate"],
        click: f
      }, u.tableRotation = {
        name: "tableRotation",
        title: function title(e) {
          return c(e, "Turntable rotation");
        },
        attr: "scene.dragmode",
        val: "turntable",
        icon: o["z-axis"],
        click: f
      }, u.resetCameraDefault3d = {
        name: "resetCameraDefault3d",
        _cat: "resetCameraDefault",
        title: function title(e) {
          return c(e, "Reset camera to default");
        },
        attr: "resetDefault",
        icon: o.home,
        click: h
      }, u.resetCameraLastSave3d = {
        name: "resetCameraLastSave3d",
        _cat: "resetCameraLastSave",
        title: function title(e) {
          return c(e, "Reset camera to last save");
        },
        attr: "resetLastSave",
        icon: o.movie,
        click: h
      }, u.hoverClosest3d = {
        name: "hoverClosest3d",
        _cat: "hoverclosest",
        title: function title(e) {
          return c(e, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: o.tooltip_basic,
        gravity: "ne",
        click: function click(e, t) {
          var r = p(e, t);
          n.call("_guiRelayout", e, r);
        }
      }, u.zoomInGeo = {
        name: "zoomInGeo",
        _cat: "zoomin",
        title: function title(e) {
          return c(e, "Zoom in");
        },
        attr: "zoom",
        val: "in",
        icon: o.zoom_plus,
        click: g
      }, u.zoomOutGeo = {
        name: "zoomOutGeo",
        _cat: "zoomout",
        title: function title(e) {
          return c(e, "Zoom out");
        },
        attr: "zoom",
        val: "out",
        icon: o.zoom_minus,
        click: g
      }, u.resetGeo = {
        name: "resetGeo",
        _cat: "reset",
        title: function title(e) {
          return c(e, "Reset");
        },
        attr: "reset",
        val: null,
        icon: o.autoscale,
        click: g
      }, u.hoverClosestGeo = {
        name: "hoverClosestGeo",
        _cat: "hoverclosest",
        title: function title(e) {
          return c(e, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: o.tooltip_basic,
        gravity: "ne",
        click: y
      }, u.hoverClosestGl2d = {
        name: "hoverClosestGl2d",
        _cat: "hoverclosest",
        title: function title(e) {
          return c(e, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: o.tooltip_basic,
        gravity: "ne",
        click: y
      }, u.hoverClosestPie = {
        name: "hoverClosestPie",
        _cat: "hoverclosest",
        title: function title(e) {
          return c(e, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: "closest",
        icon: o.tooltip_basic,
        gravity: "ne",
        click: y
      }, u.resetViewSankey = {
        name: "resetSankeyGroup",
        title: function title(e) {
          return c(e, "Reset view");
        },
        icon: o.home,
        click: function click(e) {
          for (var t = {
              "node.groups": [],
              "node.x": [],
              "node.y": []
            }, r = 0; r < e._fullData.length; r++) {
            var a = e._fullData[r]._viewInitial;
            t["node.groups"].push(a.node.groups.slice()), t["node.x"].push(a.node.x.slice()), t["node.y"].push(a.node.y.slice());
          }
          n.call("restyle", e, t);
        }
      }, u.toggleHover = {
        name: "toggleHover",
        title: function title(e) {
          return c(e, "Toggle show closest data on hover");
        },
        attr: "hovermode",
        val: null,
        toggle: !0,
        icon: o.tooltip_basic,
        gravity: "ne",
        click: function click(e, t) {
          var r = p(e, t);
          r.hovermode = m(e), n.call("_guiRelayout", e, r);
        }
      }, u.resetViews = {
        name: "resetViews",
        title: function title(e) {
          return c(e, "Reset views");
        },
        icon: o.home,
        click: function click(e, t) {
          var r = t.currentTarget;
          r.setAttribute("data-attr", "zoom"), r.setAttribute("data-val", "reset"), d(e, t), r.setAttribute("data-attr", "resetLastSave"), h(e, t), x(e, "geo"), x(e, "mapbox");
        }
      }, u.toggleSpikelines = {
        name: "toggleSpikelines",
        title: function title(e) {
          return c(e, "Toggle Spike Lines");
        },
        icon: o.spikeline,
        attr: "_cartesianSpikesEnabled",
        val: "on",
        click: function click(e) {
          var t = e._fullLayout,
            r = t._cartesianSpikesEnabled;
          t._cartesianSpikesEnabled = "on" === r ? "off" : "on", n.call("_guiRelayout", e, function (e) {
            for (var t = "on" === e._fullLayout._cartesianSpikesEnabled, r = i.list(e, null, !0), n = {}, a = 0; a < r.length; a++) {
              var o = r[a];
              n[o._name + ".showspikes"] = !!t || o._showSpikeInitial;
            }
            return n;
          }(e));
        }
      }, u.resetViewMapbox = {
        name: "resetViewMapbox",
        _cat: "resetView",
        title: function title(e) {
          return c(e, "Reset view");
        },
        attr: "reset",
        icon: o.home,
        click: function click(e) {
          x(e, "mapbox");
        }
      }, u.zoomInMapbox = {
        name: "zoomInMapbox",
        _cat: "zoomin",
        title: function title(e) {
          return c(e, "Zoom in");
        },
        attr: "zoom",
        val: "in",
        icon: o.zoom_plus,
        click: v
      }, u.zoomOutMapbox = {
        name: "zoomOutMapbox",
        _cat: "zoomout",
        title: function title(e) {
          return c(e, "Zoom out");
        },
        attr: "zoom",
        val: "out",
        icon: o.zoom_minus,
        click: v
      };
    }, {
      "../../fonts/ploticon": 208,
      "../../lib": 225,
      "../../plots/cartesian/axis_ids": 276,
      "../../plots/plots": 307,
      "../../registry": 309,
      "../shapes/draw": 180
    }],
    157: [function (e, t, r) {
      "use strict";

      var n = e("./buttons"),
        a = Object.keys(n),
        i = ["drawline", "drawopenpath", "drawclosedpath", "drawcircle", "drawrect", "eraseshape"],
        o = ["v1hovermode", "hoverclosest", "hovercompare", "togglehover", "togglespikelines"].concat(i),
        l = [];
      a.forEach(function (e) {
        !function (e) {
          if (-1 === o.indexOf(e._cat || e.name)) {
            var t = e.name,
              r = (e._cat || e.name).toLowerCase();
            -1 === l.indexOf(t) && l.push(t), -1 === l.indexOf(r) && l.push(r);
          }
        }(n[e]);
      }), l.sort(), t.exports = {
        DRAW_MODES: i,
        backButtons: o,
        foreButtons: l
      };
    }, {
      "./buttons": 156
    }],
    158: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../color"),
        i = e("../../plot_api/plot_template"),
        o = e("./attributes");
      t.exports = function (e, t) {
        var r = e.modebar || {},
          l = i.newContainer(t, "modebar");
        function s(e, t) {
          return n.coerce(r, l, o, e, t);
        }
        s("orientation"), s("bgcolor", a.addOpacity(t.paper_bgcolor, .5));
        var c = a.contrast(a.rgb(t.modebar.bgcolor));
        s("color", a.addOpacity(c, .3)), s("activecolor", a.addOpacity(c, .7)), s("uirevision", t.uirevision), s("add"), s("remove");
      };
    }, {
      "../../lib": 225,
      "../../plot_api/plot_template": 261,
      "../color": 96,
      "./attributes": 155
    }],
    159: [function (e, t, r) {
      "use strict";

      t.exports = {
        moduleType: "component",
        name: "modebar",
        layoutAttributes: e("./attributes"),
        supplyLayoutDefaults: e("./defaults"),
        manage: e("./manage")
      };
    }, {
      "./attributes": 155,
      "./defaults": 158,
      "./manage": 160
    }],
    160: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/cartesian/axis_ids"),
        a = e("../../traces/scatter/subtypes"),
        i = e("../../registry"),
        o = e("../fx/helpers").isUnifiedHover,
        l = e("./modebar"),
        s = e("./buttons"),
        c = e("./constants").DRAW_MODES;
      t.exports = function (e) {
        var t = e._fullLayout,
          r = e._context,
          u = t._modeBar;
        if (r.displayModeBar || r.watermark) {
          if (!Array.isArray(r.modeBarButtonsToRemove)) throw new Error(["*modeBarButtonsToRemove* configuration options", "must be an array."].join(" "));
          if (!Array.isArray(r.modeBarButtonsToAdd)) throw new Error(["*modeBarButtonsToAdd* configuration options", "must be an array."].join(" "));
          var d,
            f = r.modeBarButtons;
          d = Array.isArray(f) && f.length ? function (e) {
            for (var t = 0; t < e.length; t++) for (var r = e[t], n = 0; n < r.length; n++) {
              var a = r[n];
              if ("string" == typeof a) {
                if (void 0 === s[a]) throw new Error(["*modeBarButtons* configuration options", "invalid button name"].join(" "));
                e[t][n] = s[a];
              }
            }
            return e;
          }(f) : !r.displayModeBar && r.watermark ? [] : function (e) {
            var t = e._fullLayout,
              r = e._fullData,
              l = e._context;
            function u(e, t) {
              if ("string" == typeof t) {
                if (t.toLowerCase() === e.toLowerCase()) return !0;
              } else {
                var r = t.name,
                  n = t._cat || t.name;
                if (r === e || n === e.toLowerCase()) return !0;
              }
              return !1;
            }
            var d = t.modebar.add;
            "string" == typeof d && (d = [d]);
            var f = t.modebar.remove;
            "string" == typeof f && (f = [f]);
            var h = l.modeBarButtonsToAdd.concat(d.filter(function (e) {
                for (var t = 0; t < l.modeBarButtonsToRemove.length; t++) if (u(e, l.modeBarButtonsToRemove[t])) return !1;
                return !0;
              })),
              p = l.modeBarButtonsToRemove.concat(f.filter(function (e) {
                for (var t = 0; t < l.modeBarButtonsToAdd.length; t++) if (u(e, l.modeBarButtonsToAdd[t])) return !1;
                return !0;
              })),
              g = t._has("cartesian"),
              m = t._has("gl3d"),
              y = t._has("geo"),
              v = t._has("pie"),
              x = t._has("funnelarea"),
              b = t._has("gl2d"),
              _ = t._has("ternary"),
              w = t._has("mapbox"),
              M = t._has("polar"),
              T = t._has("sankey"),
              k = function (e) {
                for (var t = n.list({
                    _fullLayout: e
                  }, null, !0), r = 0; r < t.length; r++) if (!t[r].fixedrange) return !1;
                return !0;
              }(t),
              A = o(t.hovermode),
              L = [];
            function D(e) {
              if (e.length) {
                for (var t = [], r = 0; r < e.length; r++) {
                  for (var n = e[r], a = s[n], i = a.name.toLowerCase(), o = (a._cat || a.name).toLowerCase(), l = !1, c = 0; c < p.length; c++) {
                    var u = p[c].toLowerCase();
                    if (u === i || u === o) {
                      l = !0;
                      break;
                    }
                  }
                  l || t.push(s[n]);
                }
                L.push(t);
              }
            }
            var S = ["toImage"];
            l.showEditInChartStudio ? S.push("editInChartStudio") : l.showSendToCloud && S.push("sendDataToCloud");
            D(S);
            var C = [],
              O = [],
              P = [],
              I = [];
            (g || b || v || x || _) + y + m + w + M > 1 ? (O = ["toggleHover"], P = ["resetViews"]) : y ? (C = ["zoomInGeo", "zoomOutGeo"], O = ["hoverClosestGeo"], P = ["resetGeo"]) : m ? (O = ["hoverClosest3d"], P = ["resetCameraDefault3d", "resetCameraLastSave3d"]) : w ? (C = ["zoomInMapbox", "zoomOutMapbox"], O = ["toggleHover"], P = ["resetViewMapbox"]) : b ? O = ["hoverClosestGl2d"] : v ? O = ["hoverClosestPie"] : T ? (O = ["hoverClosestCartesian", "hoverCompareCartesian"], P = ["resetViewSankey"]) : O = ["toggleHover"];
            g && (O = ["toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian"]);
            (function (e) {
              for (var t = 0; t < e.length; t++) if (!i.traceIs(e[t], "noHover")) return !1;
              return !0;
            }(r) || A) && (O = []);
            !g && !b || k || (C = ["zoomIn2d", "zoomOut2d", "autoScale2d"], "resetViews" !== P[0] && (P = ["resetScale2d"]));
            m ? I = ["zoom3d", "pan3d", "orbitRotation", "tableRotation"] : (g || b) && !k || _ ? I = ["zoom2d", "pan2d"] : w || y ? I = ["pan2d"] : M && (I = ["zoom2d"]);
            (function (e) {
              for (var t = !1, r = 0; r < e.length && !t; r++) {
                var n = e[r];
                n._module && n._module.selectPoints && (i.traceIs(n, "scatter-like") ? (a.hasMarkers(n) || a.hasText(n)) && (t = !0) : i.traceIs(n, "box-violin") && "all" !== n.boxpoints && "all" !== n.points || (t = !0));
              }
              return t;
            })(r) && I.push("select2d", "lasso2d");
            var z = [],
              R = function R(e) {
                -1 === z.indexOf(e) && -1 !== O.indexOf(e) && z.push(e);
              };
            if (Array.isArray(h)) {
              for (var N = [], F = 0; F < h.length; F++) {
                var E = h[F];
                "string" == typeof E ? (E = E.toLowerCase(), -1 !== c.indexOf(E) ? (t._has("mapbox") || t._has("cartesian")) && I.push(E) : "togglespikelines" === E ? R("toggleSpikelines") : "togglehover" === E ? R("toggleHover") : "hovercompare" === E ? R("hoverCompareCartesian") : "hoverclosest" === E ? (R("hoverClosestCartesian"), R("hoverClosestGeo"), R("hoverClosest3d"), R("hoverClosestGl2d"), R("hoverClosestPie")) : "v1hovermode" === E && (R("toggleHover"), R("hoverClosestCartesian"), R("hoverCompareCartesian"), R("hoverClosestGeo"), R("hoverClosest3d"), R("hoverClosestGl2d"), R("hoverClosestPie"))) : N.push(E);
              }
              h = N;
            }
            return D(I), D(C.concat(P)), D(z), function (e, t) {
              if (t.length) if (Array.isArray(t[0])) for (var r = 0; r < t.length; r++) e.push(t[r]);else e.push(t);
              return e;
            }(L, h);
          }(e), u ? u.update(e, d) : t._modeBar = l(e, d);
        } else u && (u.destroy(), delete t._modeBar);
      };
    }, {
      "../../plots/cartesian/axis_ids": 276,
      "../../registry": 309,
      "../../traces/scatter/subtypes": 368,
      "../fx/helpers": 132,
      "./buttons": 156,
      "./constants": 157,
      "./modebar": 161
    }],
    161: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("fast-isnumeric"),
        i = e("../../lib"),
        o = e("../../fonts/ploticon"),
        l = new DOMParser();
      function s(e) {
        this.container = e.container, this.element = document.createElement("div"), this.update(e.graphInfo, e.buttons), this.container.appendChild(this.element);
      }
      var c = s.prototype;
      c.update = function (e, t) {
        this.graphInfo = e;
        var r = this.graphInfo._context,
          n = this.graphInfo._fullLayout,
          a = "modebar-" + n._uid;
        this.element.setAttribute("id", a), this._uid = a, this.element.className = "modebar", "hover" === r.displayModeBar && (this.element.className += " modebar--hover ease-bg"), "v" === n.modebar.orientation && (this.element.className += " vertical", t = t.reverse());
        var o = n.modebar,
          l = "hover" === r.displayModeBar ? ".js-plotly-plot .plotly:hover " : "";
        i.deleteRelatedStyleRule(a), i.addRelatedStyleRule(a, l + "#" + a + " .modebar-group", "background-color: " + o.bgcolor), i.addRelatedStyleRule(a, "#" + a + " .modebar-btn .icon path", "fill: " + o.color), i.addRelatedStyleRule(a, "#" + a + " .modebar-btn:hover .icon path", "fill: " + o.activecolor), i.addRelatedStyleRule(a, "#" + a + " .modebar-btn.active .icon path", "fill: " + o.activecolor);
        var s = !this.hasButtons(t),
          c = this.hasLogo !== r.displaylogo,
          u = this.locale !== r.locale;
        if (this.locale = r.locale, (s || c || u) && (this.removeAllButtons(), this.updateButtons(t), r.watermark || r.displaylogo)) {
          var d = this.getLogo();
          r.watermark && (d.className = d.className + " watermark"), "v" === n.modebar.orientation ? this.element.insertBefore(d, this.element.childNodes[0]) : this.element.appendChild(d), this.hasLogo = !0;
        }
        this.updateActiveButton();
      }, c.updateButtons = function (e) {
        var t = this;
        this.buttons = e, this.buttonElements = [], this.buttonsNames = [], this.buttons.forEach(function (e) {
          var r = t.createGroup();
          e.forEach(function (e) {
            var n = e.name;
            if (!n) throw new Error("must provide button 'name' in button config");
            if (-1 !== t.buttonsNames.indexOf(n)) throw new Error("button name '" + n + "' is taken");
            t.buttonsNames.push(n);
            var a = t.createButton(e);
            t.buttonElements.push(a), r.appendChild(a);
          }), t.element.appendChild(r);
        });
      }, c.createGroup = function () {
        var e = document.createElement("div");
        return e.className = "modebar-group", e;
      }, c.createButton = function (e) {
        var t = this,
          r = document.createElement("a");
        r.setAttribute("rel", "tooltip"), r.className = "modebar-btn";
        var a = e.title;
        void 0 === a ? a = e.name : "function" == typeof a && (a = a(this.graphInfo)), (a || 0 === a) && r.setAttribute("data-title", a), void 0 !== e.attr && r.setAttribute("data-attr", e.attr);
        var i = e.val;
        if (void 0 !== i && ("function" == typeof i && (i = i(this.graphInfo)), r.setAttribute("data-val", i)), "function" != typeof e.click) throw new Error("must provide button 'click' function in button config");
        r.addEventListener("click", function (r) {
          e.click(t.graphInfo, r), t.updateActiveButton(r.currentTarget);
        }), r.setAttribute("data-toggle", e.toggle || !1), e.toggle && n.select(r).classed("active", !0);
        var l = e.icon;
        return "function" == typeof l ? r.appendChild(l()) : r.appendChild(this.createIcon(l || o.question)), r.setAttribute("data-gravity", e.gravity || "n"), r;
      }, c.createIcon = function (e) {
        var t,
          r = a(e.height) ? Number(e.height) : e.ascent - e.descent,
          n = "http://www.w3.org/2000/svg";
        if (e.path) {
          (t = document.createElementNS(n, "svg")).setAttribute("viewBox", [0, 0, e.width, r].join(" ")), t.setAttribute("class", "icon");
          var i = document.createElementNS(n, "path");
          i.setAttribute("d", e.path), e.transform ? i.setAttribute("transform", e.transform) : void 0 !== e.ascent && i.setAttribute("transform", "matrix(1 0 0 -1 0 " + e.ascent + ")"), t.appendChild(i);
        }
        e.svg && (t = l.parseFromString(e.svg, "application/xml").childNodes[0]);
        return t.setAttribute("height", "1em"), t.setAttribute("width", "1em"), t;
      }, c.updateActiveButton = function (e) {
        var t = this.graphInfo._fullLayout,
          r = void 0 !== e ? e.getAttribute("data-attr") : null;
        this.buttonElements.forEach(function (e) {
          var a = e.getAttribute("data-val") || !0,
            o = e.getAttribute("data-attr"),
            l = "true" === e.getAttribute("data-toggle"),
            s = n.select(e);
          if (l) o === r && s.classed("active", !s.classed("active"));else {
            var c = null === o ? o : i.nestedProperty(t, o).get();
            s.classed("active", c === a);
          }
        });
      }, c.hasButtons = function (e) {
        var t = this.buttons;
        if (!t) return !1;
        if (e.length !== t.length) return !1;
        for (var r = 0; r < e.length; ++r) {
          if (e[r].length !== t[r].length) return !1;
          for (var n = 0; n < e[r].length; n++) if (e[r][n].name !== t[r][n].name) return !1;
        }
        return !0;
      }, c.getLogo = function () {
        var e = this.createGroup(),
          t = document.createElement("a");
        return t.href = "https://plotly.com/", t.target = "_blank", t.setAttribute("data-title", i._(this.graphInfo, "Produced with Plotly")), t.className = "modebar-btn plotlyjsicon modebar-btn--logo", t.appendChild(this.createIcon(o.newplotlylogo)), e.appendChild(t), e;
      }, c.removeAllButtons = function () {
        for (; this.element.firstChild;) this.element.removeChild(this.element.firstChild);
        this.hasLogo = !1;
      }, c.destroy = function () {
        i.removeElement(this.container.querySelector(".modebar")), i.deleteRelatedStyleRule(this._uid);
      }, t.exports = function (e, t) {
        var r = e._fullLayout,
          a = new s({
            graphInfo: e,
            container: r._modebardiv.node(),
            buttons: t
          });
        return r._privateplot && n.select(a.element).append("span").classed("badge-private float--left", !0).text("PRIVATE"), a;
      };
    }, {
      "../../fonts/ploticon": 208,
      "../../lib": 225,
      "@plotly/d3": 6,
      "fast-isnumeric": 11
    }],
    162: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/font_attributes"),
        a = e("../color/attributes"),
        i = (0, e("../../plot_api/plot_template").templatedArray)("button", {
          visible: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          step: {
            valType: "enumerated",
            values: ["month", "year", "day", "hour", "minute", "second", "all"],
            dflt: "month",
            editType: "plot"
          },
          stepmode: {
            valType: "enumerated",
            values: ["backward", "todate"],
            dflt: "backward",
            editType: "plot"
          },
          count: {
            valType: "number",
            min: 0,
            dflt: 1,
            editType: "plot"
          },
          label: {
            valType: "string",
            editType: "plot"
          },
          editType: "plot"
        });
      t.exports = {
        visible: {
          valType: "boolean",
          editType: "plot"
        },
        buttons: i,
        x: {
          valType: "number",
          min: -2,
          max: 3,
          editType: "plot"
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "left",
          editType: "plot"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          editType: "plot"
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "bottom",
          editType: "plot"
        },
        font: n({
          editType: "plot"
        }),
        bgcolor: {
          valType: "color",
          dflt: a.lightLine,
          editType: "plot"
        },
        activecolor: {
          valType: "color",
          editType: "plot"
        },
        bordercolor: {
          valType: "color",
          dflt: a.defaultLine,
          editType: "plot"
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 0,
          editType: "plot"
        },
        editType: "plot"
      };
    }, {
      "../../plot_api/plot_template": 261,
      "../../plots/font_attributes": 301,
      "../color/attributes": 95
    }],
    163: [function (e, t, r) {
      "use strict";

      t.exports = {
        yPad: .02,
        minButtonWidth: 30,
        rx: 3,
        ry: 3,
        lightAmount: 25,
        darkAmount: 10
      };
    }, {}],
    164: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../color"),
        i = e("../../plot_api/plot_template"),
        o = e("../../plots/array_container_defaults"),
        l = e("./attributes"),
        s = e("./constants");
      function c(e, t, r, a) {
        var i = a.calendar;
        function o(r, a) {
          return n.coerce(e, t, l.buttons, r, a);
        }
        if (o("visible")) {
          var s = o("step");
          "all" !== s && (!i || "gregorian" === i || "month" !== s && "year" !== s ? o("stepmode") : t.stepmode = "backward", o("count")), o("label");
        }
      }
      t.exports = function (e, t, r, u, d) {
        var f = e.rangeselector || {},
          h = i.newContainer(t, "rangeselector");
        function p(e, t) {
          return n.coerce(f, h, l, e, t);
        }
        if (p("visible", o(f, h, {
          name: "buttons",
          handleItemDefaults: c,
          calendar: d
        }).length > 0)) {
          var g = function (e, t, r) {
            for (var n = r.filter(function (r) {
                return t[r].anchor === e._id;
              }), a = 0, i = 0; i < n.length; i++) {
              var o = t[n[i]].domain;
              o && (a = Math.max(o[1], a));
            }
            return [e.domain[0], a + s.yPad];
          }(t, r, u);
          p("x", g[0]), p("y", g[1]), n.noneOrAll(e, t, ["x", "y"]), p("xanchor"), p("yanchor"), n.coerceFont(p, "font", r.font);
          var m = p("bgcolor");
          p("activecolor", a.contrast(m, s.lightAmount, s.darkAmount)), p("bordercolor"), p("borderwidth");
        }
      };
    }, {
      "../../lib": 225,
      "../../plot_api/plot_template": 261,
      "../../plots/array_container_defaults": 267,
      "../color": 96,
      "./attributes": 162,
      "./constants": 163
    }],
    165: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../registry"),
        i = e("../../plots/plots"),
        o = e("../color"),
        l = e("../drawing"),
        s = e("../../lib"),
        c = s.strTranslate,
        u = e("../../lib/svg_text_utils"),
        d = e("../../plots/cartesian/axis_ids"),
        f = e("../../constants/alignment"),
        h = f.LINE_SPACING,
        p = f.FROM_TL,
        g = f.FROM_BR,
        m = e("./constants"),
        y = e("./get_update_object");
      function v(e) {
        return e._id;
      }
      function x(e, t, r) {
        var n = s.ensureSingle(e, "rect", "selector-rect", function (e) {
          e.attr("shape-rendering", "crispEdges");
        });
        n.attr({
          rx: m.rx,
          ry: m.ry
        }), n.call(o.stroke, t.bordercolor).call(o.fill, function (e, t) {
          return t._isActive || t._isHovered ? e.activecolor : e.bgcolor;
        }(t, r)).style("stroke-width", t.borderwidth + "px");
      }
      function b(e, t, r, n) {
        s.ensureSingle(e, "text", "selector-text", function (e) {
          e.attr("text-anchor", "middle");
        }).call(l.font, t.font).text(function (e, t) {
          if (e.label) return t ? s.templateString(e.label, t) : e.label;
          return "all" === e.step ? "all" : e.count + e.step.charAt(0);
        }(r, n._fullLayout._meta)).call(function (e) {
          u.convertToTspans(e, n);
        });
      }
      t.exports = function (e) {
        var t = e._fullLayout._infolayer.selectAll(".rangeselector").data(function (e) {
          for (var t = d.list(e, "x", !0), r = [], n = 0; n < t.length; n++) {
            var a = t[n];
            a.rangeselector && a.rangeselector.visible && r.push(a);
          }
          return r;
        }(e), v);
        t.enter().append("g").classed("rangeselector", !0), t.exit().remove(), t.style({
          cursor: "pointer",
          "pointer-events": "all"
        }), t.each(function (t) {
          var r = n.select(this),
            o = t,
            d = o.rangeselector,
            f = r.selectAll("g.button").data(s.filterVisible(d.buttons));
          f.enter().append("g").classed("button", !0), f.exit().remove(), f.each(function (t) {
            var r = n.select(this),
              i = y(o, t);
            t._isActive = function (e, t, r) {
              if ("all" === t.step) return !0 === e.autorange;
              var n = Object.keys(r);
              return e.range[0] === r[n[0]] && e.range[1] === r[n[1]];
            }(o, t, i), r.call(x, d, t), r.call(b, d, t, e), r.on("click", function () {
              e._dragged || a.call("_guiRelayout", e, i);
            }), r.on("mouseover", function () {
              t._isHovered = !0, r.call(x, d, t);
            }), r.on("mouseout", function () {
              t._isHovered = !1, r.call(x, d, t);
            });
          }), function (e, t, r, a, o) {
            var d = 0,
              f = 0,
              y = r.borderwidth;
            t.each(function () {
              var e = n.select(this).select(".selector-text"),
                t = r.font.size * h,
                a = Math.max(t * u.lineCount(e), 16) + 3;
              f = Math.max(f, a);
            }), t.each(function () {
              var e = n.select(this),
                t = e.select(".selector-rect"),
                a = e.select(".selector-text"),
                i = a.node() && l.bBox(a.node()).width,
                o = r.font.size * h,
                s = u.lineCount(a),
                p = Math.max(i + 10, m.minButtonWidth);
              e.attr("transform", c(y + d, y)), t.attr({
                x: 0,
                y: 0,
                width: p,
                height: f
              }), u.positionText(a, p / 2, f / 2 - (s - 1) * o / 2 + 3), d += p + 5;
            });
            var v = e._fullLayout._size,
              x = v.l + v.w * r.x,
              b = v.t + v.h * (1 - r.y),
              _ = "left";
            s.isRightAnchor(r) && (x -= d, _ = "right");
            s.isCenterAnchor(r) && (x -= d / 2, _ = "center");
            var w = "top";
            s.isBottomAnchor(r) && (b -= f, w = "bottom");
            s.isMiddleAnchor(r) && (b -= f / 2, w = "middle");
            d = Math.ceil(d), f = Math.ceil(f), x = Math.round(x), b = Math.round(b), i.autoMargin(e, a + "-range-selector", {
              x: r.x,
              y: r.y,
              l: d * p[_],
              r: d * g[_],
              b: f * g[w],
              t: f * p[w]
            }), o.attr("transform", c(x, b));
          }(e, f, d, o._name, r);
        });
      };
    }, {
      "../../constants/alignment": 201,
      "../../lib": 225,
      "../../lib/svg_text_utils": 248,
      "../../plots/cartesian/axis_ids": 276,
      "../../plots/plots": 307,
      "../../registry": 309,
      "../color": 96,
      "../drawing": 118,
      "./constants": 163,
      "./get_update_object": 166,
      "@plotly/d3": 6
    }],
    166: [function (e, t, r) {
      "use strict";

      var n = e("d3-time"),
        a = e("../../lib").titleCase;
      t.exports = function (e, t) {
        var r = e._name,
          i = {};
        if ("all" === t.step) i[r + ".autorange"] = !0;else {
          var o = function (e, t) {
            var r,
              i = e.range,
              o = new Date(e.r2l(i[1])),
              l = t.step,
              s = n["utc" + a(l)],
              c = t.count;
            switch (t.stepmode) {
              case "backward":
                r = e.l2r(+s.offset(o, -c));
                break;
              case "todate":
                var u = s.offset(o, -c);
                r = e.l2r(+s.ceil(u));
            }
            var d = i[1];
            return [r, d];
          }(e, t);
          i[r + ".range[0]"] = o[0], i[r + ".range[1]"] = o[1];
        }
        return i;
      };
    }, {
      "../../lib": 225,
      "d3-time": 9
    }],
    167: [function (e, t, r) {
      "use strict";

      t.exports = {
        moduleType: "component",
        name: "rangeselector",
        schema: {
          subplots: {
            xaxis: {
              rangeselector: e("./attributes")
            }
          }
        },
        layoutAttributes: e("./attributes"),
        handleDefaults: e("./defaults"),
        draw: e("./draw")
      };
    }, {
      "./attributes": 162,
      "./defaults": 164,
      "./draw": 165
    }],
    168: [function (e, t, r) {
      "use strict";

      var n = e("../color/attributes");
      t.exports = {
        bgcolor: {
          valType: "color",
          dflt: n.background,
          editType: "plot"
        },
        bordercolor: {
          valType: "color",
          dflt: n.defaultLine,
          editType: "plot"
        },
        borderwidth: {
          valType: "integer",
          dflt: 0,
          min: 0,
          editType: "plot"
        },
        autorange: {
          valType: "boolean",
          dflt: !0,
          editType: "calc",
          impliedEdits: {
            "range[0]": void 0,
            "range[1]": void 0
          }
        },
        range: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "calc",
            impliedEdits: {
              "^autorange": !1
            }
          }, {
            valType: "any",
            editType: "calc",
            impliedEdits: {
              "^autorange": !1
            }
          }],
          editType: "calc",
          impliedEdits: {
            autorange: !1
          }
        },
        thickness: {
          valType: "number",
          dflt: .15,
          min: 0,
          max: 1,
          editType: "plot"
        },
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "calc"
        },
        editType: "calc"
      };
    }, {
      "../color/attributes": 95
    }],
    169: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/cartesian/axis_ids").list,
        a = e("../../plots/cartesian/autorange").getAutoRange,
        i = e("./constants");
      t.exports = function (e) {
        for (var t = n(e, "x", !0), r = 0; r < t.length; r++) {
          var o = t[r],
            l = o[i.name];
          l && l.visible && l.autorange && (l._input.autorange = !0, l._input.range = l.range = a(e, o));
        }
      };
    }, {
      "../../plots/cartesian/autorange": 271,
      "../../plots/cartesian/axis_ids": 276,
      "./constants": 170
    }],
    170: [function (e, t, r) {
      "use strict";

      t.exports = {
        name: "rangeslider",
        containerClassName: "rangeslider-container",
        bgClassName: "rangeslider-bg",
        rangePlotClassName: "rangeslider-rangeplot",
        maskMinClassName: "rangeslider-mask-min",
        maskMaxClassName: "rangeslider-mask-max",
        slideBoxClassName: "rangeslider-slidebox",
        grabberMinClassName: "rangeslider-grabber-min",
        grabAreaMinClassName: "rangeslider-grabarea-min",
        handleMinClassName: "rangeslider-handle-min",
        grabberMaxClassName: "rangeslider-grabber-max",
        grabAreaMaxClassName: "rangeslider-grabarea-max",
        handleMaxClassName: "rangeslider-handle-max",
        maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis",
        maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis",
        maskColor: "rgba(0,0,0,0.4)",
        maskOppAxisColor: "rgba(0,0,0,0.2)",
        slideBoxFill: "transparent",
        slideBoxCursor: "ew-resize",
        grabAreaFill: "transparent",
        grabAreaCursor: "col-resize",
        grabAreaWidth: 10,
        handleWidth: 4,
        handleRadius: 1,
        handleStrokeWidth: 1,
        extraPad: 15
      };
    }, {}],
    171: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plot_api/plot_template"),
        i = e("../../plots/cartesian/axis_ids"),
        o = e("./attributes"),
        l = e("./oppaxis_attributes");
      t.exports = function (e, t, r) {
        var s = e[r],
          c = t[r];
        if (s.rangeslider || t._requestRangeslider[c._id]) {
          n.isPlainObject(s.rangeslider) || (s.rangeslider = {});
          var u,
            d,
            f = s.rangeslider,
            h = a.newContainer(c, "rangeslider");
          if (_("visible")) {
            _("bgcolor", t.plot_bgcolor), _("bordercolor"), _("borderwidth"), _("thickness"), _("autorange", !c.isValidRange(f.range)), _("range");
            var p = t._subplots;
            if (p) for (var g = p.cartesian.filter(function (e) {
                return e.substr(0, e.indexOf("y")) === i.name2id(r);
              }).map(function (e) {
                return e.substr(e.indexOf("y"), e.length);
              }), m = n.simpleMap(g, i.id2name), y = 0; y < m.length; y++) {
              var v = m[y];
              u = f[v] || {}, d = a.newContainer(h, v, "yaxis");
              var x,
                b = t[v];
              u.range && b.isValidRange(u.range) && (x = "fixed"), "match" !== w("rangemode", x) && w("range", b.range.slice());
            }
            h._input = f;
          }
        }
        function _(e, t) {
          return n.coerce(f, h, o, e, t);
        }
        function w(e, t) {
          return n.coerce(u, d, l, e, t);
        }
      };
    }, {
      "../../lib": 225,
      "../../plot_api/plot_template": 261,
      "../../plots/cartesian/axis_ids": 276,
      "./attributes": 168,
      "./oppaxis_attributes": 175
    }],
    172: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../registry"),
        i = e("../../plots/plots"),
        o = e("../../lib"),
        l = o.strTranslate,
        s = e("../drawing"),
        c = e("../color"),
        u = e("../titles"),
        d = e("../../plots/cartesian"),
        f = e("../../plots/cartesian/axis_ids"),
        h = e("../dragelement"),
        p = e("../../lib/setcursor"),
        g = e("./constants");
      function m(e, t, r, n) {
        var a = o.ensureSingle(e, "rect", g.bgClassName, function (e) {
            e.attr({
              x: 0,
              y: 0,
              "shape-rendering": "crispEdges"
            });
          }),
          i = n.borderwidth % 2 == 0 ? n.borderwidth : n.borderwidth - 1,
          c = -n._offsetShift,
          u = s.crispRound(t, n.borderwidth);
        a.attr({
          width: n._width + i,
          height: n._height + i,
          transform: l(c, c),
          fill: n.bgcolor,
          stroke: n.bordercolor,
          "stroke-width": u
        });
      }
      function y(e, t, r, n) {
        var a = t._fullLayout;
        o.ensureSingleById(a._topdefs, "clipPath", n._clipId, function (e) {
          e.append("rect").attr({
            x: 0,
            y: 0
          });
        }).select("rect").attr({
          width: n._width,
          height: n._height
        });
      }
      function v(e, t, r, a) {
        var l,
          c = t.calcdata,
          u = e.selectAll("g." + g.rangePlotClassName).data(r._subplotsWith, o.identity);
        u.enter().append("g").attr("class", function (e) {
          return g.rangePlotClassName + " " + e;
        }).call(s.setClipUrl, a._clipId, t), u.order(), u.exit().remove(), u.each(function (e, o) {
          var s = n.select(this),
            u = 0 === o,
            h = f.getFromId(t, e, "y"),
            p = h._name,
            g = a[p],
            m = {
              data: [],
              layout: {
                xaxis: {
                  type: r.type,
                  domain: [0, 1],
                  range: a.range.slice(),
                  calendar: r.calendar
                },
                width: a._width,
                height: a._height,
                margin: {
                  t: 0,
                  b: 0,
                  l: 0,
                  r: 0
                }
              },
              _context: t._context
            };
          r.rangebreaks && (m.layout.xaxis.rangebreaks = r.rangebreaks), m.layout[p] = {
            type: h.type,
            domain: [0, 1],
            range: "match" !== g.rangemode ? g.range.slice() : h.range.slice(),
            calendar: h.calendar
          }, h.rangebreaks && (m.layout[p].rangebreaks = h.rangebreaks), i.supplyDefaults(m);
          var y = m._fullLayout.xaxis,
            v = m._fullLayout[p];
          y.clearCalc(), y.setScale(), v.clearCalc(), v.setScale();
          var x = {
            id: e,
            plotgroup: s,
            xaxis: y,
            yaxis: v,
            isRangePlot: !0
          };
          u ? l = x : (x.mainplot = "xy", x.mainplotinfo = l), d.rangePlot(t, x, function (e, t) {
            for (var r = [], n = 0; n < e.length; n++) {
              var a = e[n],
                i = a[0].trace;
              i.xaxis + i.yaxis === t && r.push(a);
            }
            return r;
          }(c, e));
        });
      }
      function x(e, t, r, n, a) {
        (o.ensureSingle(e, "rect", g.maskMinClassName, function (e) {
          e.attr({
            x: 0,
            y: 0,
            "shape-rendering": "crispEdges"
          });
        }).attr("height", n._height).call(c.fill, g.maskColor), o.ensureSingle(e, "rect", g.maskMaxClassName, function (e) {
          e.attr({
            y: 0,
            "shape-rendering": "crispEdges"
          });
        }).attr("height", n._height).call(c.fill, g.maskColor), "match" !== a.rangemode) && (o.ensureSingle(e, "rect", g.maskMinOppAxisClassName, function (e) {
          e.attr({
            y: 0,
            "shape-rendering": "crispEdges"
          });
        }).attr("width", n._width).call(c.fill, g.maskOppAxisColor), o.ensureSingle(e, "rect", g.maskMaxOppAxisClassName, function (e) {
          e.attr({
            y: 0,
            "shape-rendering": "crispEdges"
          });
        }).attr("width", n._width).style("border-top", g.maskOppBorder).call(c.fill, g.maskOppAxisColor));
      }
      function b(e, t, r, n) {
        t._context.staticPlot || o.ensureSingle(e, "rect", g.slideBoxClassName, function (e) {
          e.attr({
            y: 0,
            cursor: g.slideBoxCursor,
            "shape-rendering": "crispEdges"
          });
        }).attr({
          height: n._height,
          fill: g.slideBoxFill
        });
      }
      function _(e, t, r, n) {
        var a = o.ensureSingle(e, "g", g.grabberMinClassName),
          i = o.ensureSingle(e, "g", g.grabberMaxClassName),
          l = {
            x: 0,
            width: g.handleWidth,
            rx: g.handleRadius,
            fill: c.background,
            stroke: c.defaultLine,
            "stroke-width": g.handleStrokeWidth,
            "shape-rendering": "crispEdges"
          },
          s = {
            y: Math.round(n._height / 4),
            height: Math.round(n._height / 2)
          };
        o.ensureSingle(a, "rect", g.handleMinClassName, function (e) {
          e.attr(l);
        }).attr(s), o.ensureSingle(i, "rect", g.handleMaxClassName, function (e) {
          e.attr(l);
        }).attr(s);
        var u = {
          width: g.grabAreaWidth,
          x: 0,
          y: 0,
          fill: g.grabAreaFill,
          cursor: t._context.staticPlot ? void 0 : g.grabAreaCursor
        };
        o.ensureSingle(a, "rect", g.grabAreaMinClassName, function (e) {
          e.attr(u);
        }).attr("height", n._height), o.ensureSingle(i, "rect", g.grabAreaMaxClassName, function (e) {
          e.attr(u);
        }).attr("height", n._height);
      }
      t.exports = function (e) {
        for (var t = e._fullLayout, r = t._rangeSliderData, i = 0; i < r.length; i++) {
          var s = r[i][g.name];
          s._clipId = s._id + "-" + t._uid;
        }
        var c = t._infolayer.selectAll("g." + g.containerClassName).data(r, function (e) {
          return e._name;
        });
        c.exit().each(function (e) {
          var r = e[g.name];
          t._topdefs.select("#" + r._clipId).remove();
        }).remove(), 0 !== r.length && (c.enter().append("g").classed(g.containerClassName, !0).attr("pointer-events", "all"), c.each(function (r) {
          var i = n.select(this),
            s = r[g.name],
            c = t[f.id2name(r.anchor)],
            d = s[f.id2name(r.anchor)];
          if (s.range) {
            var w,
              M = o.simpleMap(s.range, r.r2l),
              T = o.simpleMap(r.range, r.r2l);
            w = T[0] < T[1] ? [Math.min(M[0], T[0]), Math.max(M[1], T[1])] : [Math.max(M[0], T[0]), Math.min(M[1], T[1])], s.range = s._input.range = o.simpleMap(w, r.l2r);
          }
          r.cleanRange("rangeslider.range");
          var k = t._size,
            A = r.domain;
          s._width = k.w * (A[1] - A[0]);
          var L = Math.round(k.l + k.w * A[0]),
            D = Math.round(k.t + k.h * (1 - r._counterDomainMin) + ("bottom" === r.side ? r._depth : 0) + s._offsetShift + g.extraPad);
          i.attr("transform", l(L, D)), s._rl = o.simpleMap(s.range, r.r2l);
          var S = s._rl[0],
            C = s._rl[1],
            O = C - S;
          if (s.p2d = function (e) {
            return e / s._width * O + S;
          }, s.d2p = function (e) {
            return (e - S) / O * s._width;
          }, r.rangebreaks) {
            var P = r.locateBreaks(S, C);
            if (P.length) {
              var I,
                z,
                R = 0;
              for (I = 0; I < P.length; I++) R += (z = P[I]).max - z.min;
              var N = s._width / (C - S - R),
                F = [-N * S];
              for (I = 0; I < P.length; I++) z = P[I], F.push(F[F.length - 1] - N * (z.max - z.min));
              for (s.d2p = function (e) {
                for (var t = F[0], r = 0; r < P.length; r++) {
                  var n = P[r];
                  if (e >= n.max) t = F[r + 1];else if (e < n.min) break;
                }
                return t + N * e;
              }, I = 0; I < P.length; I++) (z = P[I]).pmin = s.d2p(z.min), z.pmax = s.d2p(z.max);
              s.p2d = function (e) {
                for (var t = F[0], r = 0; r < P.length; r++) {
                  var n = P[r];
                  if (e >= n.pmax) t = F[r + 1];else if (e < n.pmin) break;
                }
                return (e - t) / N;
              };
            }
          }
          if ("match" !== d.rangemode) {
            var E = c.r2l(d.range[0]),
              j = c.r2l(d.range[1]) - E;
            s.d2pOppAxis = function (e) {
              return (e - E) / j * s._height;
            };
          }
          i.call(m, e, r, s).call(y, e, r, s).call(v, e, r, s).call(x, e, r, s, d).call(b, e, r, s).call(_, e, r, s), function (e, t, r, i) {
            if (t._context.staticPlot) return;
            var l = e.select("rect." + g.slideBoxClassName).node(),
              s = e.select("rect." + g.grabAreaMinClassName).node(),
              c = e.select("rect." + g.grabAreaMaxClassName).node();
            function u() {
              var u = n.event,
                d = u.target,
                f = u.clientX || u.touches[0].clientX,
                g = f - e.node().getBoundingClientRect().left,
                m = i.d2p(r._rl[0]),
                y = i.d2p(r._rl[1]),
                v = h.coverSlip();
              function x(e) {
                var u,
                  h,
                  x,
                  b = +(e.clientX || e.touches[0].clientX) - f;
                switch (d) {
                  case l:
                    x = "ew-resize", u = m + b, h = y + b;
                    break;
                  case s:
                    x = "col-resize", u = m + b, h = y;
                    break;
                  case c:
                    x = "col-resize", u = m, h = y + b;
                    break;
                  default:
                    x = "ew-resize", u = g, h = g + b;
                }
                if (h < u) {
                  var _ = h;
                  h = u, u = _;
                }
                i._pixelMin = u, i._pixelMax = h, p(n.select(v), x), function (e, t, r, n) {
                  function i(e) {
                    return r.l2r(o.constrain(e, n._rl[0], n._rl[1]));
                  }
                  var l = i(n.p2d(n._pixelMin)),
                    s = i(n.p2d(n._pixelMax));
                  window.requestAnimationFrame(function () {
                    a.call("_guiRelayout", t, r._name + ".range", [l, s]);
                  });
                }(0, t, r, i);
              }
              function b() {
                v.removeEventListener("mousemove", x), v.removeEventListener("mouseup", b), this.removeEventListener("touchmove", x), this.removeEventListener("touchend", b), o.removeElement(v);
              }
              this.addEventListener("touchmove", x), this.addEventListener("touchend", b), v.addEventListener("mousemove", x), v.addEventListener("mouseup", b);
            }
            e.on("mousedown", u), e.on("touchstart", u);
          }(i, e, r, s), function (e, t, r, n, a, i) {
            var s = g.handleWidth / 2;
            function c(e) {
              return o.constrain(e, 0, n._width);
            }
            function u(e) {
              return o.constrain(e, 0, n._height);
            }
            function d(e) {
              return o.constrain(e, -s, n._width + s);
            }
            var f = c(n.d2p(r._rl[0])),
              h = c(n.d2p(r._rl[1]));
            if (e.select("rect." + g.slideBoxClassName).attr("x", f).attr("width", h - f), e.select("rect." + g.maskMinClassName).attr("width", f), e.select("rect." + g.maskMaxClassName).attr("x", h).attr("width", n._width - h), "match" !== i.rangemode) {
              var p = n._height - u(n.d2pOppAxis(a._rl[1])),
                m = n._height - u(n.d2pOppAxis(a._rl[0]));
              e.select("rect." + g.maskMinOppAxisClassName).attr("x", f).attr("height", p).attr("width", h - f), e.select("rect." + g.maskMaxOppAxisClassName).attr("x", f).attr("y", m).attr("height", n._height - m).attr("width", h - f), e.select("rect." + g.slideBoxClassName).attr("y", p).attr("height", m - p);
            }
            var y = Math.round(d(f - s)) - .5,
              v = Math.round(d(h - s)) + .5;
            e.select("g." + g.grabberMinClassName).attr("transform", l(y, .5)), e.select("g." + g.grabberMaxClassName).attr("transform", l(v, .5));
          }(i, 0, r, s, c, d), "bottom" === r.side && u.draw(e, r._id + "title", {
            propContainer: r,
            propName: r._name + ".title",
            placeholder: t._dfltTitle.x,
            attributes: {
              x: r._offset + r._length / 2,
              y: D + s._height + s._offsetShift + 10 + 1.5 * r.title.font.size,
              "text-anchor": "middle"
            }
          });
        }));
      };
    }, {
      "../../lib": 225,
      "../../lib/setcursor": 245,
      "../../plots/cartesian": 286,
      "../../plots/cartesian/axis_ids": 276,
      "../../plots/plots": 307,
      "../../registry": 309,
      "../color": 96,
      "../dragelement": 115,
      "../drawing": 118,
      "../titles": 194,
      "./constants": 170,
      "@plotly/d3": 6
    }],
    173: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/cartesian/axis_ids"),
        a = e("../../lib/svg_text_utils"),
        i = e("./constants"),
        o = e("../../constants/alignment").LINE_SPACING,
        l = i.name;
      function s(e) {
        var t = e && e[l];
        return t && t.visible;
      }
      r.isVisible = s, r.makeData = function (e) {
        var t = n.list({
            _fullLayout: e
          }, "x", !0),
          r = e.margin,
          a = [];
        if (!e._has("gl2d")) for (var i = 0; i < t.length; i++) {
          var o = t[i];
          if (s(o)) {
            a.push(o);
            var c = o[l];
            c._id = l + o._id, c._height = (e.height - r.b - r.t) * c.thickness, c._offsetShift = Math.floor(c.borderwidth / 2);
          }
        }
        e._rangeSliderData = a;
      }, r.autoMarginOpts = function (e, t) {
        var r = e._fullLayout,
          n = t[l],
          s = t._id.charAt(0),
          c = 0,
          u = 0;
        "bottom" === t.side && (c = t._depth, t.title.text !== r._dfltTitle[s] && (u = 1.5 * t.title.font.size + 10 + n._offsetShift, u += (t.title.text.match(a.BR_TAG_ALL) || []).length * t.title.font.size * o));
        return {
          x: 0,
          y: t._counterDomainMin,
          l: 0,
          r: 0,
          t: 0,
          b: n._height + c + Math.max(r.margin.b, u),
          pad: i.extraPad + 2 * n._offsetShift
        };
      };
    }, {
      "../../constants/alignment": 201,
      "../../lib/svg_text_utils": 248,
      "../../plots/cartesian/axis_ids": 276,
      "./constants": 170
    }],
    174: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("./attributes"),
        i = e("./oppaxis_attributes"),
        o = e("./helpers");
      t.exports = {
        moduleType: "component",
        name: "rangeslider",
        schema: {
          subplots: {
            xaxis: {
              rangeslider: n.extendFlat({}, a, {
                yaxis: i
              })
            }
          }
        },
        layoutAttributes: e("./attributes"),
        handleDefaults: e("./defaults"),
        calcAutorange: e("./calc_autorange"),
        draw: e("./draw"),
        isVisible: o.isVisible,
        makeData: o.makeData,
        autoMarginOpts: o.autoMarginOpts
      };
    }, {
      "../../lib": 225,
      "./attributes": 168,
      "./calc_autorange": 169,
      "./defaults": 171,
      "./draw": 172,
      "./helpers": 173,
      "./oppaxis_attributes": 175
    }],
    175: [function (e, t, r) {
      "use strict";

      t.exports = {
        _isSubplotObj: !0,
        rangemode: {
          valType: "enumerated",
          values: ["auto", "fixed", "match"],
          dflt: "match",
          editType: "calc"
        },
        range: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "plot"
          }, {
            valType: "any",
            editType: "plot"
          }],
          editType: "plot"
        },
        editType: "calc"
      };
    }, {}],
    176: [function (e, t, r) {
      "use strict";

      var n = e("../annotations/attributes"),
        a = e("../../traces/scatter/attributes").line,
        i = e("../drawing/attributes").dash,
        o = e("../../lib/extend").extendFlat,
        l = e("../../plot_api/plot_template").templatedArray;
      e("../../constants/axis_placeable_objects");
      t.exports = l("shape", {
        visible: {
          valType: "boolean",
          dflt: !0,
          editType: "calc+arraydraw"
        },
        type: {
          valType: "enumerated",
          values: ["circle", "rect", "path", "line"],
          editType: "calc+arraydraw"
        },
        layer: {
          valType: "enumerated",
          values: ["below", "above"],
          dflt: "above",
          editType: "arraydraw"
        },
        xref: o({}, n.xref, {}),
        xsizemode: {
          valType: "enumerated",
          values: ["scaled", "pixel"],
          dflt: "scaled",
          editType: "calc+arraydraw"
        },
        xanchor: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        x0: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        x1: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        yref: o({}, n.yref, {}),
        ysizemode: {
          valType: "enumerated",
          values: ["scaled", "pixel"],
          dflt: "scaled",
          editType: "calc+arraydraw"
        },
        yanchor: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        y0: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        y1: {
          valType: "any",
          editType: "calc+arraydraw"
        },
        path: {
          valType: "string",
          editType: "calc+arraydraw"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "arraydraw"
        },
        line: {
          color: o({}, a.color, {
            editType: "arraydraw"
          }),
          width: o({}, a.width, {
            editType: "calc+arraydraw"
          }),
          dash: o({}, i, {
            editType: "arraydraw"
          }),
          editType: "calc+arraydraw"
        },
        fillcolor: {
          valType: "color",
          dflt: "rgba(0,0,0,0)",
          editType: "arraydraw"
        },
        fillrule: {
          valType: "enumerated",
          values: ["evenodd", "nonzero"],
          dflt: "evenodd",
          editType: "arraydraw"
        },
        editable: {
          valType: "boolean",
          dflt: !1,
          editType: "calc+arraydraw"
        },
        editType: "arraydraw"
      });
    }, {
      "../../constants/axis_placeable_objects": 202,
      "../../lib/extend": 219,
      "../../plot_api/plot_template": 261,
      "../../traces/scatter/attributes": 343,
      "../annotations/attributes": 79,
      "../drawing/attributes": 117
    }],
    177: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plots/cartesian/axes"),
        i = e("./constants"),
        o = e("./helpers");
      function l(e) {
        return c(e.line.width, e.xsizemode, e.x0, e.x1, e.path, !1);
      }
      function s(e) {
        return c(e.line.width, e.ysizemode, e.y0, e.y1, e.path, !0);
      }
      function c(e, t, r, a, l, s) {
        var c = e / 2,
          u = s;
        if ("pixel" === t) {
          var d = l ? o.extractPathCoords(l, s ? i.paramIsY : i.paramIsX) : [r, a],
            f = n.aggNums(Math.max, null, d),
            h = n.aggNums(Math.min, null, d),
            p = h < 0 ? Math.abs(h) + c : c,
            g = f > 0 ? f + c : c;
          return {
            ppad: c,
            ppadplus: u ? p : g,
            ppadminus: u ? g : p
          };
        }
        return {
          ppad: c
        };
      }
      function u(e, t, r, n, a) {
        var l = "category" === e.type || "multicategory" === e.type ? e.r2c : e.d2c;
        if (void 0 !== t) return [l(t), l(r)];
        if (n) {
          var s,
            c,
            u,
            d,
            f = 1 / 0,
            h = -1 / 0,
            p = n.match(i.segmentRE);
          for ("date" === e.type && (l = o.decodeDate(l)), s = 0; s < p.length; s++) void 0 !== (c = a[p[s].charAt(0)].drawn) && (!(u = p[s].substr(1).match(i.paramRE)) || u.length < c || ((d = l(u[c])) < f && (f = d), d > h && (h = d)));
          return h >= f ? [f, h] : void 0;
        }
      }
      t.exports = function (e) {
        var t = e._fullLayout,
          r = n.filterVisible(t.shapes);
        if (r.length && e._fullData.length) for (var o = 0; o < r.length; o++) {
          var c,
            d,
            f = r[o];
          f._extremes = {};
          var h = a.getRefType(f.xref),
            p = a.getRefType(f.yref);
          if ("paper" !== f.xref && "domain" !== h) {
            var g = "pixel" === f.xsizemode ? f.xanchor : f.x0,
              m = "pixel" === f.xsizemode ? f.xanchor : f.x1;
            (d = u(c = a.getFromId(e, f.xref), g, m, f.path, i.paramIsX)) && (f._extremes[c._id] = a.findExtremes(c, d, l(f)));
          }
          if ("paper" !== f.yref && "domain" !== p) {
            var y = "pixel" === f.ysizemode ? f.yanchor : f.y0,
              v = "pixel" === f.ysizemode ? f.yanchor : f.y1;
            (d = u(c = a.getFromId(e, f.yref), y, v, f.path, i.paramIsY)) && (f._extremes[c._id] = a.findExtremes(c, d, s(f)));
          }
        }
      };
    }, {
      "../../lib": 225,
      "../../plots/cartesian/axes": 272,
      "./constants": 178,
      "./helpers": 187
    }],
    178: [function (e, t, r) {
      "use strict";

      t.exports = {
        segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
        paramRE: /[^\s,]+/g,
        paramIsX: {
          M: {
            0: !0,
            drawn: 0
          },
          L: {
            0: !0,
            drawn: 0
          },
          H: {
            0: !0,
            drawn: 0
          },
          V: {},
          Q: {
            0: !0,
            2: !0,
            drawn: 2
          },
          C: {
            0: !0,
            2: !0,
            4: !0,
            drawn: 4
          },
          T: {
            0: !0,
            drawn: 0
          },
          S: {
            0: !0,
            2: !0,
            drawn: 2
          },
          Z: {}
        },
        paramIsY: {
          M: {
            1: !0,
            drawn: 1
          },
          L: {
            1: !0,
            drawn: 1
          },
          H: {},
          V: {
            0: !0,
            drawn: 0
          },
          Q: {
            1: !0,
            3: !0,
            drawn: 3
          },
          C: {
            1: !0,
            3: !0,
            5: !0,
            drawn: 5
          },
          T: {
            1: !0,
            drawn: 1
          },
          S: {
            1: !0,
            3: !0,
            drawn: 5
          },
          Z: {}
        },
        numParams: {
          M: 2,
          L: 2,
          H: 1,
          V: 1,
          Q: 4,
          C: 6,
          T: 2,
          S: 4,
          Z: 0
        }
      };
    }, {}],
    179: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plots/cartesian/axes"),
        i = e("../../plots/array_container_defaults"),
        o = e("./attributes"),
        l = e("./helpers");
      function s(e, t, r) {
        function i(r, a) {
          return n.coerce(e, t, o, r, a);
        }
        if (i("visible")) {
          var s = i("path"),
            c = i("type", s ? "path" : "rect");
          "path" !== t.type && delete t.path, i("editable"), i("layer"), i("opacity"), i("fillcolor"), i("fillrule"), i("line.width") && (i("line.color"), i("line.dash"));
          for (var u = i("xsizemode"), d = i("ysizemode"), f = ["x", "y"], h = 0; h < 2; h++) {
            var p,
              g,
              m,
              y = f[h],
              v = y + "anchor",
              x = "x" === y ? u : d,
              b = {
                _fullLayout: r
              },
              _ = a.coerceRef(e, t, b, y, void 0, "paper");
            if ("range" === a.getRefType(_) ? ((p = a.getFromId(b, _))._shapeIndices.push(t._index), m = l.rangeToShapePosition(p), g = l.shapePositionToRange(p)) : g = m = n.identity, "path" !== c) {
              var w = y + "0",
                M = y + "1",
                T = e[w],
                k = e[M];
              e[w] = g(e[w], !0), e[M] = g(e[M], !0), "pixel" === x ? (i(w, 0), i(M, 10)) : (a.coercePosition(t, b, i, _, w, .25), a.coercePosition(t, b, i, _, M, .75)), t[w] = m(t[w]), t[M] = m(t[M]), e[w] = T, e[M] = k;
            }
            if ("pixel" === x) {
              var A = e[v];
              e[v] = g(e[v], !0), a.coercePosition(t, b, i, _, v, .25), t[v] = m(t[v]), e[v] = A;
            }
          }
          "path" === c ? i("path") : n.noneOrAll(e, t, ["x0", "x1", "y0", "y1"]);
        }
      }
      t.exports = function (e, t) {
        i(e, t, {
          name: "shapes",
          handleItemDefaults: s
        });
      };
    }, {
      "../../lib": 225,
      "../../plots/array_container_defaults": 267,
      "../../plots/cartesian/axes": 272,
      "./attributes": 176,
      "./helpers": 187
    }],
    180: [function (e, t, r) {
      "use strict";

      var n = e("../../registry"),
        a = e("../../lib"),
        i = e("../../plots/cartesian/axes"),
        o = e("./draw_newshape/helpers").readPaths,
        l = e("./draw_newshape/display_outlines"),
        s = e("../../plots/cartesian/handle_outline").clearOutlineControllers,
        c = e("../color"),
        u = e("../drawing"),
        d = e("../../plot_api/plot_template").arrayEditor,
        f = e("../dragelement"),
        h = e("../../lib/setcursor"),
        p = e("./constants"),
        g = e("./helpers");
      function m(e) {
        var t = e._fullLayout;
        for (var r in t._shapeUpperLayer.selectAll("path").remove(), t._shapeLowerLayer.selectAll("path").remove(), t._plots) {
          var n = t._plots[r].shapelayer;
          n && n.selectAll("path").remove();
        }
        for (var a = 0; a < t.shapes.length; a++) t.shapes[a].visible && x(e, a);
      }
      function y(e) {
        return !!e._fullLayout._drawing;
      }
      function v(e) {
        return !e._context.edits.shapePosition;
      }
      function x(e, t) {
        e._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + t + '"]').remove();
        var r = g.makeOptionsAndPlotinfo(e, t),
          s = r.options,
          x = r.plotinfo;
        if (s._input && !1 !== s.visible) if ("below" !== s.layer) T(e._fullLayout._shapeUpperLayer);else if ("paper" === s.xref || "paper" === s.yref) T(e._fullLayout._shapeLowerLayer);else {
          if (x._hadPlotinfo) T((x.mainplotinfo || x).shapelayer);else T(e._fullLayout._shapeLowerLayer);
        }
        function T(r) {
          var T = _(e, s),
            k = {
              "data-index": t,
              "fill-rule": s.fillrule,
              d: T
            },
            A = s.opacity,
            L = s.fillcolor,
            D = s.line.width ? s.line.color : "rgba(0,0,0,0)",
            S = s.line.width,
            C = s.line.dash;
          S || !0 !== s.editable || (S = 5, C = "solid");
          var O = "Z" !== T[T.length - 1],
            P = v(e) && s.editable && e._fullLayout._activeShapeIndex === t;
          P && (L = O ? "rgba(0,0,0,0)" : e._fullLayout.activeshape.fillcolor, A = e._fullLayout.activeshape.opacity);
          var I,
            z = r.append("path").attr(k).style("opacity", A).call(c.stroke, D).call(c.fill, L).call(u.dashLine, C, S);
          if (b(z, e, s), (P || e._context.edits.shapePosition) && (I = d(e.layout, "shapes", s)), P) {
            z.style({
              cursor: "move"
            });
            var R = {
                element: z.node(),
                plotinfo: x,
                gd: e,
                editHelpers: I,
                isActiveShape: !0
              },
              N = o(T, e);
            l(N, z, R);
          } else e._context.edits.shapePosition ? function (e, t, r, o, l, s) {
            var c,
              d,
              m,
              v,
              x,
              M,
              T,
              k,
              A,
              L,
              D,
              S,
              C,
              O,
              P,
              I,
              z = "pixel" === r.xsizemode,
              R = "pixel" === r.ysizemode,
              N = "line" === r.type,
              F = "path" === r.type,
              E = s.modifyItem,
              j = i.getFromId(e, r.xref),
              H = i.getRefType(r.xref),
              B = i.getFromId(e, r.yref),
              Y = i.getRefType(r.yref),
              U = g.getDataToPixel(e, j, !1, H),
              V = g.getDataToPixel(e, B, !0, Y),
              q = g.getPixelToData(e, j, !1, H),
              G = g.getPixelToData(e, B, !0, Y),
              Z = N ? function () {
                var e = Math.max(r.line.width, 10),
                  n = l.append("g").attr("data-index", o);
                n.append("path").attr("d", t.attr("d")).style({
                  cursor: "move",
                  "stroke-width": e,
                  "stroke-opacity": "0"
                });
                var a = {
                    "fill-opacity": "0"
                  },
                  i = Math.max(e / 2, 10);
                return n.append("circle").attr({
                  "data-line-point": "start-point",
                  cx: z ? U(r.xanchor) + r.x0 : U(r.x0),
                  cy: R ? V(r.yanchor) - r.y0 : V(r.y0),
                  r: i
                }).style(a).classed("cursor-grab", !0), n.append("circle").attr({
                  "data-line-point": "end-point",
                  cx: z ? U(r.xanchor) + r.x1 : U(r.x1),
                  cy: R ? V(r.yanchor) - r.y1 : V(r.y1),
                  r: i
                }).style(a).classed("cursor-grab", !0), n;
              }() : t,
              W = {
                element: Z.node(),
                gd: e,
                prepFn: function prepFn(n) {
                  if (y(e)) return;
                  z && (x = U(r.xanchor));
                  R && (M = V(r.yanchor));
                  "path" === r.type ? P = r.path : (c = z ? r.x0 : U(r.x0), d = R ? r.y0 : V(r.y0), m = z ? r.x1 : U(r.x1), v = R ? r.y1 : V(r.y1));
                  c < m ? (A = c, C = "x0", L = m, O = "x1") : (A = m, C = "x1", L = c, O = "x0");
                  !R && d < v || R && d > v ? (T = d, D = "y0", k = v, S = "y1") : (T = v, D = "y1", k = d, S = "y0");
                  J(n), K(l, r), function (e, t, r) {
                    var n = t.xref,
                      a = t.yref,
                      o = i.getFromId(r, n),
                      l = i.getFromId(r, a),
                      s = "";
                    "paper" === n || o.autorange || (s += n);
                    "paper" === a || l.autorange || (s += a);
                    u.setClipUrl(e, s ? "clip" + r._fullLayout._uid + s : null, r);
                  }(t, r, e), W.moveFn = "move" === I ? X : Q, W.altKey = n.altKey;
                },
                doneFn: function doneFn() {
                  if (y(e)) return;
                  h(t), $(l), b(t, e, r), n.call("_guiRelayout", e, s.getUpdateObj());
                },
                clickFn: function clickFn() {
                  if (y(e)) return;
                  $(l);
                }
              };
            function J(r) {
              if (y(e)) I = null;else if (N) I = "path" === r.target.tagName ? "move" : "start-point" === r.target.attributes["data-line-point"].value ? "resize-over-start-point" : "resize-over-end-point";else {
                var n = W.element.getBoundingClientRect(),
                  a = n.right - n.left,
                  i = n.bottom - n.top,
                  o = r.clientX - n.left,
                  l = r.clientY - n.top,
                  s = !F && a > 10 && i > 10 && !r.shiftKey ? f.getCursor(o / a, 1 - l / i) : "move";
                h(t, s), I = s.split("-")[0];
              }
            }
            function X(n, a) {
              if ("path" === r.type) {
                var i = function i(e) {
                    return e;
                  },
                  o = i,
                  s = i;
                z ? E("xanchor", r.xanchor = q(x + n)) : (o = function o(e) {
                  return q(U(e) + n);
                }, j && "date" === j.type && (o = g.encodeDate(o))), R ? E("yanchor", r.yanchor = G(M + a)) : (s = function s(e) {
                  return G(V(e) + a);
                }, B && "date" === B.type && (s = g.encodeDate(s))), E("path", r.path = w(P, o, s));
              } else z ? E("xanchor", r.xanchor = q(x + n)) : (E("x0", r.x0 = q(c + n)), E("x1", r.x1 = q(m + n))), R ? E("yanchor", r.yanchor = G(M + a)) : (E("y0", r.y0 = G(d + a)), E("y1", r.y1 = G(v + a)));
              t.attr("d", _(e, r)), K(l, r);
            }
            function Q(n, a) {
              if (F) {
                var i = function i(e) {
                    return e;
                  },
                  o = i,
                  s = i;
                z ? E("xanchor", r.xanchor = q(x + n)) : (o = function o(e) {
                  return q(U(e) + n);
                }, j && "date" === j.type && (o = g.encodeDate(o))), R ? E("yanchor", r.yanchor = G(M + a)) : (s = function s(e) {
                  return G(V(e) + a);
                }, B && "date" === B.type && (s = g.encodeDate(s))), E("path", r.path = w(P, o, s));
              } else if (N) {
                if ("resize-over-start-point" === I) {
                  var u = c + n,
                    f = R ? d - a : d + a;
                  E("x0", r.x0 = z ? u : q(u)), E("y0", r.y0 = R ? f : G(f));
                } else if ("resize-over-end-point" === I) {
                  var h = m + n,
                    p = R ? v - a : v + a;
                  E("x1", r.x1 = z ? h : q(h)), E("y1", r.y1 = R ? p : G(p));
                }
              } else {
                var y = function y(e) {
                    return -1 !== I.indexOf(e);
                  },
                  b = y("n"),
                  H = y("s"),
                  Y = y("w"),
                  Z = y("e"),
                  W = b ? T + a : T,
                  J = H ? k + a : k,
                  X = Y ? A + n : A,
                  Q = Z ? L + n : L;
                R && (b && (W = T - a), H && (J = k - a)), (!R && J - W > 10 || R && W - J > 10) && (E(D, r[D] = R ? W : G(W)), E(S, r[S] = R ? J : G(J))), Q - X > 10 && (E(C, r[C] = z ? X : q(X)), E(O, r[O] = z ? Q : q(Q)));
              }
              t.attr("d", _(e, r)), K(l, r);
            }
            function K(e, t) {
              (z || R) && function () {
                var r = "path" !== t.type,
                  n = e.selectAll(".visual-cue").data([0]);
                n.enter().append("path").attr({
                  fill: "#fff",
                  "fill-rule": "evenodd",
                  stroke: "#000",
                  "stroke-width": 1
                }).classed("visual-cue", !0);
                var i = U(z ? t.xanchor : a.midRange(r ? [t.x0, t.x1] : g.extractPathCoords(t.path, p.paramIsX))),
                  o = V(R ? t.yanchor : a.midRange(r ? [t.y0, t.y1] : g.extractPathCoords(t.path, p.paramIsY)));
                if (i = g.roundPositionForSharpStrokeRendering(i, 1), o = g.roundPositionForSharpStrokeRendering(o, 1), z && R) {
                  var l = "M" + (i - 1 - 1) + "," + (o - 1 - 1) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
                  n.attr("d", l);
                } else if (z) {
                  var s = "M" + (i - 1 - 1) + "," + (o - 9 - 1) + "v18 h2 v-18 Z";
                  n.attr("d", s);
                } else {
                  var c = "M" + (i - 9 - 1) + "," + (o - 1 - 1) + "h18 v2 h-18 Z";
                  n.attr("d", c);
                }
              }();
            }
            function $(e) {
              e.selectAll(".visual-cue").remove();
            }
            f.init(W), Z.node().onmousemove = J;
          }(e, z, s, t, r, I) : !0 === s.editable && z.style("pointer-events", O || c.opacity(L) * A <= .5 ? "stroke" : "all");
          z.node().addEventListener("click", function () {
            return function (e, t) {
              if (!v(e)) return;
              var r = +t.node().getAttribute("data-index");
              if (r >= 0) {
                if (r === e._fullLayout._activeShapeIndex) return void M(e);
                e._fullLayout._activeShapeIndex = r, e._fullLayout._deactivateShape = M, m(e);
              }
            }(e, z);
          });
        }
      }
      function b(e, t, r) {
        var n = (r.xref + r.yref).replace(/paper/g, "").replace(/[xyz][1-9]* *domain/g, "");
        u.setClipUrl(e, n ? "clip" + t._fullLayout._uid + n : null, t);
      }
      function _(e, t) {
        var r,
          n,
          o,
          l,
          s,
          c,
          u,
          d,
          f = t.type,
          h = i.getRefType(t.xref),
          m = i.getRefType(t.yref),
          y = i.getFromId(e, t.xref),
          v = i.getFromId(e, t.yref),
          x = e._fullLayout._size;
        if (y ? "domain" === h ? n = function n(e) {
          return y._offset + y._length * e;
        } : (r = g.shapePositionToRange(y), n = function n(e) {
          return y._offset + y.r2p(r(e, !0));
        }) : n = function n(e) {
          return x.l + x.w * e;
        }, v ? "domain" === m ? l = function l(e) {
          return v._offset + v._length * (1 - e);
        } : (o = g.shapePositionToRange(v), l = function l(e) {
          return v._offset + v.r2p(o(e, !0));
        }) : l = function l(e) {
          return x.t + x.h * (1 - e);
        }, "path" === f) return y && "date" === y.type && (n = g.decodeDate(n)), v && "date" === v.type && (l = g.decodeDate(l)), function (e, t, r) {
          var n = e.path,
            i = e.xsizemode,
            o = e.ysizemode,
            l = e.xanchor,
            s = e.yanchor;
          return n.replace(p.segmentRE, function (e) {
            var n = 0,
              c = e.charAt(0),
              u = p.paramIsX[c],
              d = p.paramIsY[c],
              f = p.numParams[c],
              h = e.substr(1).replace(p.paramRE, function (e) {
                return u[n] ? e = "pixel" === i ? t(l) + Number(e) : t(e) : d[n] && (e = "pixel" === o ? r(s) - Number(e) : r(e)), ++n > f && (e = "X"), e;
              });
            return n > f && (h = h.replace(/[\s,]*X.*/, ""), a.log("Ignoring extra params in segment " + e)), c + h;
          });
        }(t, n, l);
        if ("pixel" === t.xsizemode) {
          var b = n(t.xanchor);
          s = b + t.x0, c = b + t.x1;
        } else s = n(t.x0), c = n(t.x1);
        if ("pixel" === t.ysizemode) {
          var _ = l(t.yanchor);
          u = _ - t.y0, d = _ - t.y1;
        } else u = l(t.y0), d = l(t.y1);
        if ("line" === f) return "M" + s + "," + u + "L" + c + "," + d;
        if ("rect" === f) return "M" + s + "," + u + "H" + c + "V" + d + "H" + s + "Z";
        var w = (s + c) / 2,
          M = (u + d) / 2,
          T = Math.abs(w - s),
          k = Math.abs(M - u),
          A = "A" + T + "," + k,
          L = w + T + "," + M;
        return "M" + L + A + " 0 1,1 " + (w + "," + (M - k)) + A + " 0 0,1 " + L + "Z";
      }
      function w(e, t, r) {
        return e.replace(p.segmentRE, function (e) {
          var n = 0,
            a = e.charAt(0),
            i = p.paramIsX[a],
            o = p.paramIsY[a],
            l = p.numParams[a];
          return a + e.substr(1).replace(p.paramRE, function (e) {
            return n >= l || (i[n] ? e = t(e) : o[n] && (e = r(e)), n++), e;
          });
        });
      }
      function M(e) {
        v(e) && e._fullLayout._activeShapeIndex >= 0 && (s(e), delete e._fullLayout._activeShapeIndex, m(e));
      }
      t.exports = {
        draw: m,
        drawOne: x,
        eraseActiveShape: function eraseActiveShape(e) {
          if (!v(e)) return;
          s(e);
          var t = e._fullLayout._activeShapeIndex,
            r = (e.layout || {}).shapes || [];
          if (t < r.length) {
            for (var a = [], i = 0; i < r.length; i++) i !== t && a.push(r[i]);
            delete e._fullLayout._activeShapeIndex, n.call("_guiRelayout", e, {
              shapes: a
            });
          }
        }
      };
    }, {
      "../../lib": 225,
      "../../lib/setcursor": 245,
      "../../plot_api/plot_template": 261,
      "../../plots/cartesian/axes": 272,
      "../../plots/cartesian/handle_outline": 283,
      "../../registry": 309,
      "../color": 96,
      "../dragelement": 115,
      "../drawing": 118,
      "./constants": 178,
      "./draw_newshape/display_outlines": 184,
      "./draw_newshape/helpers": 185,
      "./helpers": 187
    }],
    181: [function (e, t, r) {
      "use strict";

      var n = e("../../drawing/attributes").dash,
        a = e("../../../lib/extend").extendFlat;
      t.exports = {
        newshape: {
          line: {
            color: {
              valType: "color",
              editType: "none"
            },
            width: {
              valType: "number",
              min: 0,
              dflt: 4,
              editType: "none"
            },
            dash: a({}, n, {
              dflt: "solid",
              editType: "none"
            }),
            editType: "none"
          },
          fillcolor: {
            valType: "color",
            dflt: "rgba(0,0,0,0)",
            editType: "none"
          },
          fillrule: {
            valType: "enumerated",
            values: ["evenodd", "nonzero"],
            dflt: "evenodd",
            editType: "none"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: 1,
            editType: "none"
          },
          layer: {
            valType: "enumerated",
            values: ["below", "above"],
            dflt: "above",
            editType: "none"
          },
          drawdirection: {
            valType: "enumerated",
            values: ["ortho", "horizontal", "vertical", "diagonal"],
            dflt: "diagonal",
            editType: "none"
          },
          editType: "none"
        },
        activeshape: {
          fillcolor: {
            valType: "color",
            dflt: "rgb(255,0,255)",
            editType: "none"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .5,
            editType: "none"
          },
          editType: "none"
        }
      };
    }, {
      "../../../lib/extend": 219,
      "../../drawing/attributes": 117
    }],
    182: [function (e, t, r) {
      "use strict";

      t.exports = {
        CIRCLE_SIDES: 32,
        i000: 0,
        i090: 8,
        i180: 16,
        i270: 24,
        cos45: Math.cos(Math.PI / 4),
        sin45: Math.sin(Math.PI / 4),
        SQRT2: Math.sqrt(2)
      };
    }, {}],
    183: [function (e, t, r) {
      "use strict";

      var n = e("../../color");
      t.exports = function (e, t, r) {
        if (r("newshape.drawdirection"), r("newshape.layer"), r("newshape.fillcolor"), r("newshape.fillrule"), r("newshape.opacity"), r("newshape.line.width")) {
          var a = (e || {}).plot_bgcolor || "#FFF";
          r("newshape.line.color", n.contrast(a)), r("newshape.line.dash");
        }
        r("activeshape.fillcolor"), r("activeshape.opacity");
      };
    }, {
      "../../color": 96
    }],
    184: [function (e, t, r) {
      "use strict";

      var n = e("../../dragelement"),
        a = e("../../dragelement/helpers").drawMode,
        i = e("../../../registry"),
        o = e("./constants"),
        l = o.i000,
        s = o.i090,
        c = o.i180,
        u = o.i270,
        d = e("../../../plots/cartesian/handle_outline").clearOutlineControllers,
        f = e("./helpers"),
        h = f.pointsShapeRectangle,
        p = f.pointsShapeEllipse,
        g = f.writePaths,
        m = e("./newshapes");
      t.exports = function e(t, r, o, f) {
        f || (f = 0);
        var y = o.gd;
        function v() {
          e(t, r, o, f++), p(t[0]) && x({
            redrawing: !0
          });
        }
        function x(e) {
          o.isActiveShape = !1;
          var t = m(r, o);
          Object.keys(t).length && i.call((e || {}).redrawing ? "relayout" : "_guiRelayout", y, t);
        }
        var b,
          _,
          w,
          M,
          T,
          k = o.isActiveShape,
          A = y._fullLayout._zoomlayer,
          L = o.dragmode;
        (a(L) ? y._fullLayout._drawing = !0 : y._fullLayout._activeShapeIndex >= 0 && d(y), r.attr("d", g(t)), k && !f) && (T = function (e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            e[r] = [];
            for (var a = 0; a < n.length; a++) {
              e[r][a] = [];
              for (var i = 0; i < n[a].length; i++) e[r][a][i] = n[a][i];
            }
          }
          return e;
        }([], t), function (e) {
          b = [];
          for (var r = 0; r < t.length; r++) {
            var a = t[r],
              i = !h(a) && p(a);
            b[r] = [];
            for (var o = 0; o < a.length; o++) if ("Z" !== a[o][0] && (!i || o === l || o === s || o === c || o === u)) {
              var d = a[o][1],
                f = a[o][2],
                g = e.append("circle").classed("cursor-grab", !0).attr("data-i", r).attr("data-j", o).attr("cx", d).attr("cy", f).attr("r", 4).style({
                  "mix-blend-mode": "luminosity",
                  fill: "black",
                  stroke: "white",
                  "stroke-width": 1
                });
              b[r][o] = {
                element: g.node(),
                gd: y,
                prepFn: D,
                doneFn: C,
                clickFn: O
              }, n.init(b[r][o]);
            }
          }
        }(A.append("g").attr("class", "outline-controllers")), function () {
          if (_ = [], !t.length) return;
          _[0] = {
            element: r[0][0],
            gd: y,
            prepFn: I,
            doneFn: z
          }, n.init(_[0]);
        }());
        function D(e) {
          w = +e.srcElement.getAttribute("data-i"), M = +e.srcElement.getAttribute("data-j"), b[w][M].moveFn = S;
        }
        function S(e, r) {
          if (t.length) {
            var n = T[w][M][1],
              a = T[w][M][2],
              i = t[w],
              o = i.length;
            if (h(i)) {
              for (var l = 0; l < o; l++) if (l !== M) {
                var s = i[l];
                s[1] === i[M][1] && (s[1] = n + e), s[2] === i[M][2] && (s[2] = a + r);
              }
              if (i[M][1] = n + e, i[M][2] = a + r, !h(i)) for (var c = 0; c < o; c++) for (var u = 0; u < i[c].length; u++) i[c][u] = T[w][c][u];
            } else i[M][1] = n + e, i[M][2] = a + r;
            v();
          }
        }
        function C() {
          x();
        }
        function O(e, r) {
          if (2 === e) {
            w = +r.srcElement.getAttribute("data-i"), M = +r.srcElement.getAttribute("data-j");
            var n = t[w];
            h(n) || p(n) || function () {
              if (t.length && t[w] && t[w].length) {
                for (var e = [], r = 0; r < t[w].length; r++) r !== M && e.push(t[w][r]);
                e.length > 1 && (2 !== e.length || "Z" !== e[1][0]) && (0 === M && (e[0][0] = "M"), t[w] = e, v(), x());
              }
            }();
          }
        }
        function P(e, r) {
          !function (e, r) {
            if (t.length) for (var n = 0; n < t.length; n++) for (var a = 0; a < t[n].length; a++) for (var i = 0; i + 2 < t[n][a].length; i += 2) t[n][a][i + 1] = T[n][a][i + 1] + e, t[n][a][i + 2] = T[n][a][i + 2] + r;
          }(e, r), v();
        }
        function I(e) {
          (w = +e.srcElement.getAttribute("data-i")) || (w = 0), _[w].moveFn = P;
        }
        function z() {
          x();
        }
      };
    }, {
      "../../../plots/cartesian/handle_outline": 283,
      "../../../registry": 309,
      "../../dragelement": 115,
      "../../dragelement/helpers": 114,
      "./constants": 182,
      "./helpers": 185,
      "./newshapes": 186
    }],
    185: [function (e, t, r) {
      "use strict";

      var n = e("parse-svg-path"),
        a = e("./constants"),
        i = a.CIRCLE_SIDES,
        o = a.SQRT2,
        l = e("../../../plots/cartesian/helpers"),
        s = l.p2r,
        c = l.r2p,
        u = [0, 3, 4, 5, 6, 1, 2],
        d = [0, 3, 4, 1, 2];
      function f(e, t) {
        return Math.abs(e - t) <= 1e-6;
      }
      function h(e, t) {
        var r = t[1] - e[1],
          n = t[2] - e[2];
        return Math.sqrt(r * r + n * n);
      }
      r.writePaths = function (e) {
        var t = e.length;
        if (!t) return "M0,0Z";
        for (var r = "", n = 0; n < t; n++) for (var a = e[n].length, i = 0; i < a; i++) {
          var o = e[n][i][0];
          if ("Z" === o) r += "Z";else for (var l = e[n][i].length, s = 0; s < l; s++) {
            var c = s;
            "Q" === o || "S" === o ? c = d[s] : "C" === o && (c = u[s]), r += e[n][i][c], s > 0 && s < l - 1 && (r += ",");
          }
        }
        return r;
      }, r.readPaths = function (e, t, r, a) {
        var o,
          l,
          u,
          d = n(e),
          f = [],
          h = -1,
          p = 0,
          g = 0,
          m = function m() {
            l = p, u = g;
          };
        m();
        for (var y = 0; y < d.length; y++) {
          var v,
            x,
            b,
            _,
            w = [],
            M = d[y][0],
            T = M;
          switch (M) {
            case "M":
              h++, f[h] = [], p = +d[y][1], g = +d[y][2], w.push([T, p, g]), m();
              break;
            case "Q":
            case "S":
              v = +d[y][1], b = +d[y][2], p = +d[y][3], g = +d[y][4], w.push([T, p, g, v, b]);
              break;
            case "C":
              v = +d[y][1], b = +d[y][2], x = +d[y][3], _ = +d[y][4], p = +d[y][5], g = +d[y][6], w.push([T, p, g, v, b, x, _]);
              break;
            case "T":
            case "L":
              p = +d[y][1], g = +d[y][2], w.push([T, p, g]);
              break;
            case "H":
              T = "L", p = +d[y][1], w.push([T, p, g]);
              break;
            case "V":
              T = "L", g = +d[y][1], w.push([T, p, g]);
              break;
            case "A":
              T = "L";
              var k = +d[y][1],
                A = +d[y][2];
              +d[y][4] || (k = -k, A = -A);
              var L = p - k,
                D = g;
              for (o = 1; o <= i / 2; o++) {
                var S = 2 * Math.PI * o / i;
                w.push([T, L + k * Math.cos(S), D + A * Math.sin(S)]);
              }
              break;
            case "Z":
              p === l && g === u || (p = l, g = u, w.push([T, p, g]));
          }
          for (var C = (r || {}).domain, O = t._fullLayout._size, P = r && "pixel" === r.xsizemode, I = r && "pixel" === r.ysizemode, z = !1 === a, R = 0; R < w.length; R++) {
            for (o = 0; o + 2 < 7; o += 2) {
              var N = w[R][o + 1],
                F = w[R][o + 2];
              void 0 !== N && void 0 !== F && (p = N, g = F, r && (r.xaxis && r.xaxis.p2r ? (z && (N -= r.xaxis._offset), N = P ? c(r.xaxis, r.xanchor) + N : s(r.xaxis, N)) : (z && (N -= O.l), C ? N = C.x[0] + N / O.w : N /= O.w), r.yaxis && r.yaxis.p2r ? (z && (F -= r.yaxis._offset), F = I ? c(r.yaxis, r.yanchor) - F : s(r.yaxis, F)) : (z && (F -= O.t), F = C ? C.y[1] - F / O.h : 1 - F / O.h)), w[R][o + 1] = N, w[R][o + 2] = F);
            }
            f[h].push(w[R].slice());
          }
        }
        return f;
      }, r.pointsShapeRectangle = function (e) {
        if (5 !== e.length) return !1;
        for (var t = 1; t < 3; t++) {
          if (!f(e[0][t] - e[1][t], e[3][t] - e[2][t])) return !1;
          if (!f(e[0][t] - e[3][t], e[1][t] - e[2][t])) return !1;
        }
        return !(!f(e[0][1], e[1][1]) && !f(e[0][1], e[3][1])) && !!(h(e[0], e[1]) * h(e[0], e[3]));
      }, r.pointsShapeEllipse = function (e) {
        var t = e.length;
        if (t !== i + 1) return !1;
        t = i;
        for (var r = 0; r < t; r++) {
          var n = (2 * t - r) % t,
            a = (t / 2 + n) % t,
            o = (t / 2 + r) % t;
          if (!f(h(e[r], e[o]), h(e[n], e[a]))) return !1;
        }
        return !0;
      }, r.handleEllipse = function (e, t, n) {
        if (!e) return [t, n];
        var a = r.ellipseOver({
            x0: t[0],
            y0: t[1],
            x1: n[0],
            y1: n[1]
          }),
          l = (a.x1 + a.x0) / 2,
          s = (a.y1 + a.y0) / 2,
          c = (a.x1 - a.x0) / 2,
          u = (a.y1 - a.y0) / 2;
        c || (c = u /= o), u || (u = c /= o);
        for (var d = [], f = 0; f < i; f++) {
          var h = 2 * f * Math.PI / i;
          d.push([l + c * Math.cos(h), s + u * Math.sin(h)]);
        }
        return d;
      }, r.ellipseOver = function (e) {
        var t = e.x0,
          r = e.y0,
          n = e.x1,
          a = e.y1,
          i = n - t,
          l = a - r,
          s = ((t -= i) + n) / 2,
          c = ((r -= l) + a) / 2;
        return {
          x0: s - (i *= o),
          y0: c - (l *= o),
          x1: s + i,
          y1: c + l
        };
      };
    }, {
      "../../../plots/cartesian/helpers": 284,
      "./constants": 182,
      "parse-svg-path": 50
    }],
    186: [function (e, t, r) {
      "use strict";

      var n = e("../../dragelement/helpers"),
        a = n.drawMode,
        i = n.openMode,
        o = e("./constants"),
        l = o.i000,
        s = o.i090,
        c = o.i180,
        u = o.i270,
        d = o.cos45,
        f = o.sin45,
        h = e("../../../plots/cartesian/helpers"),
        p = h.p2r,
        g = h.r2p,
        m = e("../../../plots/cartesian/handle_outline").clearSelect,
        y = e("./helpers"),
        v = y.readPaths,
        x = y.writePaths,
        b = y.ellipseOver;
      t.exports = function (e, t) {
        if (e.length) {
          var r = e[0][0];
          if (r) {
            var n = r.getAttribute("d"),
              o = t.gd,
              h = o._fullLayout.newshape,
              y = t.plotinfo,
              _ = y.xaxis,
              w = y.yaxis,
              M = !!y.domain || !y.xaxis,
              T = !!y.domain || !y.yaxis,
              k = t.isActiveShape,
              A = t.dragmode,
              L = (o.layout || {}).shapes || [];
            if (!a(A) && void 0 !== k) {
              var D = o._fullLayout._activeShapeIndex;
              if (D < L.length) switch (o._fullLayout.shapes[D].type) {
                case "rect":
                  A = "drawrect";
                  break;
                case "circle":
                  A = "drawcircle";
                  break;
                case "line":
                  A = "drawline";
                  break;
                case "path":
                  var S = L[D].path || "";
                  A = "Z" === S[S.length - 1] ? "drawclosedpath" : "drawopenpath";
              }
            }
            var C,
              O = i(A),
              P = v(n, o, y, k),
              I = {
                editable: !0,
                xref: M ? "paper" : _._id,
                yref: T ? "paper" : w._id,
                layer: h.layer,
                opacity: h.opacity,
                line: {
                  color: h.line.color,
                  width: h.line.width,
                  dash: h.line.dash
                }
              };
            if (O || (I.fillcolor = h.fillcolor, I.fillrule = h.fillrule), 1 === P.length && (C = P[0]), C && "drawrect" === A) I.type = "rect", I.x0 = C[0][1], I.y0 = C[0][2], I.x1 = C[2][1], I.y1 = C[2][2];else if (C && "drawline" === A) I.type = "line", I.x0 = C[0][1], I.y0 = C[0][2], I.x1 = C[1][1], I.y1 = C[1][2];else if (C && "drawcircle" === A) {
              I.type = "circle";
              var z = C[l][1],
                R = C[s][1],
                N = C[c][1],
                F = C[u][1],
                E = C[l][2],
                j = C[s][2],
                H = C[c][2],
                B = C[u][2],
                Y = y.xaxis && ("date" === y.xaxis.type || "log" === y.xaxis.type),
                U = y.yaxis && ("date" === y.yaxis.type || "log" === y.yaxis.type);
              Y && (z = g(y.xaxis, z), R = g(y.xaxis, R), N = g(y.xaxis, N), F = g(y.xaxis, F)), U && (E = g(y.yaxis, E), j = g(y.yaxis, j), H = g(y.yaxis, H), B = g(y.yaxis, B));
              var V = (R + F) / 2,
                q = (E + H) / 2,
                G = b({
                  x0: V,
                  y0: q,
                  x1: V + (F - R + N - z) / 2 * d,
                  y1: q + (B - j + H - E) / 2 * f
                });
              Y && (G.x0 = p(y.xaxis, G.x0), G.x1 = p(y.xaxis, G.x1)), U && (G.y0 = p(y.yaxis, G.y0), G.y1 = p(y.yaxis, G.y1)), I.x0 = G.x0, I.y0 = G.y0, I.x1 = G.x1, I.y1 = G.y1;
            } else I.type = "path", _ && w && function (e, t, r) {
              var n = "date" === t.type,
                a = "date" === r.type;
              if (!n && !a) return e;
              for (var i = 0; i < e.length; i++) for (var o = 0; o < e[i].length; o++) for (var l = 0; l + 2 < e[i][o].length; l += 2) n && (e[i][o][l + 1] = e[i][o][l + 1].replace(" ", "_")), a && (e[i][o][l + 2] = e[i][o][l + 2].replace(" ", "_"));
            }(P, _, w), I.path = x(P), C = null;
            m(o);
            for (var Z = t.editHelpers, W = (Z || {}).modifyItem, J = [], X = 0; X < L.length; X++) {
              var Q = o._fullLayout.shapes[X];
              if (J[X] = Q._input, void 0 !== k && X === o._fullLayout._activeShapeIndex) {
                var K = I;
                switch (Q.type) {
                  case "line":
                  case "rect":
                  case "circle":
                    W("x0", K.x0), W("x1", K.x1), W("y0", K.y0), W("y1", K.y1);
                    break;
                  case "path":
                    W("path", K.path);
                }
              }
            }
            return void 0 === k ? (J.push(I), J) : Z ? Z.getUpdateObj() : {};
          }
        }
      };
    }, {
      "../../../plots/cartesian/handle_outline": 283,
      "../../../plots/cartesian/helpers": 284,
      "../../dragelement/helpers": 114,
      "./constants": 182,
      "./helpers": 185
    }],
    187: [function (e, t, r) {
      "use strict";

      var n = e("./constants"),
        a = e("../../lib");
      r.rangeToShapePosition = function (e) {
        return "log" === e.type ? e.r2d : function (e) {
          return e;
        };
      }, r.shapePositionToRange = function (e) {
        return "log" === e.type ? e.d2r : function (e) {
          return e;
        };
      }, r.decodeDate = function (e) {
        return function (t) {
          return t.replace && (t = t.replace("_", " ")), e(t);
        };
      }, r.encodeDate = function (e) {
        return function (t) {
          return e(t).replace(" ", "_");
        };
      }, r.extractPathCoords = function (e, t) {
        var r = [];
        return e.match(n.segmentRE).forEach(function (e) {
          var i = t[e.charAt(0)].drawn;
          if (void 0 !== i) {
            var o = e.substr(1).match(n.paramRE);
            !o || o.length < i || r.push(a.cleanNumber(o[i]));
          }
        }), r;
      }, r.getDataToPixel = function (e, t, n, a) {
        var i,
          o = e._fullLayout._size;
        if (t) {
          if ("domain" === a) i = function i(e) {
            return t._length * (n ? 1 - e : e) + t._offset;
          };else {
            var l = r.shapePositionToRange(t);
            i = function i(e) {
              return t._offset + t.r2p(l(e, !0));
            }, "date" === t.type && (i = r.decodeDate(i));
          }
        } else i = n ? function (e) {
          return o.t + o.h * (1 - e);
        } : function (e) {
          return o.l + o.w * e;
        };
        return i;
      }, r.getPixelToData = function (e, t, n, a) {
        var i,
          o = e._fullLayout._size;
        if (t) {
          if ("domain" === a) i = function i(e) {
            var r = (e - t._offset) / t._length;
            return n ? 1 - r : r;
          };else {
            var l = r.rangeToShapePosition(t);
            i = function i(e) {
              return l(t.p2r(e - t._offset));
            };
          }
        } else i = n ? function (e) {
          return 1 - (e - o.t) / o.h;
        } : function (e) {
          return (e - o.l) / o.w;
        };
        return i;
      }, r.roundPositionForSharpStrokeRendering = function (e, t) {
        var r = 1 === Math.round(t % 2),
          n = Math.round(e);
        return r ? n + .5 : n;
      }, r.makeOptionsAndPlotinfo = function (e, t) {
        var r = e._fullLayout.shapes[t] || {},
          n = e._fullLayout._plots[r.xref + r.yref];
        return !!n ? n._hadPlotinfo = !0 : (n = {}, r.xref && "paper" !== r.xref && (n.xaxis = e._fullLayout[r.xref + "axis"]), r.yref && "paper" !== r.yref && (n.yaxis = e._fullLayout[r.yref + "axis"])), n.xsizemode = r.xsizemode, n.ysizemode = r.ysizemode, n.xanchor = r.xanchor, n.yanchor = r.yanchor, {
          options: r,
          plotinfo: n
        };
      };
    }, {
      "../../lib": 225,
      "./constants": 178
    }],
    188: [function (e, t, r) {
      "use strict";

      var n = e("./draw");
      t.exports = {
        moduleType: "component",
        name: "shapes",
        layoutAttributes: e("./attributes"),
        supplyLayoutDefaults: e("./defaults"),
        supplyDrawNewShapeDefaults: e("./draw_newshape/defaults"),
        includeBasePlot: e("../../plots/cartesian/include_components")("shapes"),
        calcAutorange: e("./calc_autorange"),
        draw: n.draw,
        drawOne: n.drawOne
      };
    }, {
      "../../plots/cartesian/include_components": 285,
      "./attributes": 176,
      "./calc_autorange": 177,
      "./defaults": 179,
      "./draw": 180,
      "./draw_newshape/defaults": 183
    }],
    189: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/font_attributes"),
        a = e("../../plots/pad_attributes"),
        i = e("../../lib/extend").extendDeepAll,
        o = e("../../plot_api/edit_types").overrideAll,
        l = e("../../plots/animation_attributes"),
        s = e("../../plot_api/plot_template").templatedArray,
        c = e("./constants"),
        u = s("step", {
          visible: {
            valType: "boolean",
            dflt: !0
          },
          method: {
            valType: "enumerated",
            values: ["restyle", "relayout", "animate", "update", "skip"],
            dflt: "restyle"
          },
          args: {
            valType: "info_array",
            freeLength: !0,
            items: [{
              valType: "any"
            }, {
              valType: "any"
            }, {
              valType: "any"
            }]
          },
          label: {
            valType: "string"
          },
          value: {
            valType: "string"
          },
          execute: {
            valType: "boolean",
            dflt: !0
          }
        });
      t.exports = o(s("slider", {
        visible: {
          valType: "boolean",
          dflt: !0
        },
        active: {
          valType: "number",
          min: 0,
          dflt: 0
        },
        steps: u,
        lenmode: {
          valType: "enumerated",
          values: ["fraction", "pixels"],
          dflt: "fraction"
        },
        len: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        x: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: 0
        },
        pad: i(a({
          editType: "arraydraw"
        }), {}, {
          t: {
            dflt: 20
          }
        }),
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "left"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: 0
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "top"
        },
        transition: {
          duration: {
            valType: "number",
            min: 0,
            dflt: 150
          },
          easing: {
            valType: "enumerated",
            values: l.transition.easing.values,
            dflt: "cubic-in-out"
          }
        },
        currentvalue: {
          visible: {
            valType: "boolean",
            dflt: !0
          },
          xanchor: {
            valType: "enumerated",
            values: ["left", "center", "right"],
            dflt: "left"
          },
          offset: {
            valType: "number",
            dflt: 10
          },
          prefix: {
            valType: "string"
          },
          suffix: {
            valType: "string"
          },
          font: n({})
        },
        font: n({}),
        activebgcolor: {
          valType: "color",
          dflt: c.gripBgActiveColor
        },
        bgcolor: {
          valType: "color",
          dflt: c.railBgColor
        },
        bordercolor: {
          valType: "color",
          dflt: c.railBorderColor
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: c.railBorderWidth
        },
        ticklen: {
          valType: "number",
          min: 0,
          dflt: c.tickLength
        },
        tickcolor: {
          valType: "color",
          dflt: c.tickColor
        },
        tickwidth: {
          valType: "number",
          min: 0,
          dflt: 1
        },
        minorticklen: {
          valType: "number",
          min: 0,
          dflt: c.minorTickLength
        }
      }), "arraydraw", "from-root");
    }, {
      "../../lib/extend": 219,
      "../../plot_api/edit_types": 254,
      "../../plot_api/plot_template": 261,
      "../../plots/animation_attributes": 266,
      "../../plots/font_attributes": 301,
      "../../plots/pad_attributes": 306,
      "./constants": 190
    }],
    190: [function (e, t, r) {
      "use strict";

      t.exports = {
        name: "sliders",
        containerClassName: "slider-container",
        groupClassName: "slider-group",
        inputAreaClass: "slider-input-area",
        railRectClass: "slider-rail-rect",
        railTouchRectClass: "slider-rail-touch-rect",
        gripRectClass: "slider-grip-rect",
        tickRectClass: "slider-tick-rect",
        inputProxyClass: "slider-input-proxy",
        labelsClass: "slider-labels",
        labelGroupClass: "slider-label-group",
        labelClass: "slider-label",
        currentValueClass: "slider-current-value",
        railHeight: 5,
        menuIndexAttrName: "slider-active-index",
        autoMarginIdRoot: "slider-",
        minWidth: 30,
        minHeight: 30,
        textPadX: 40,
        arrowOffsetX: 4,
        railRadius: 2,
        railWidth: 5,
        railBorder: 4,
        railBorderWidth: 1,
        railBorderColor: "#bec8d9",
        railBgColor: "#f8fafc",
        railInset: 8,
        stepInset: 10,
        gripRadius: 10,
        gripWidth: 20,
        gripHeight: 20,
        gripBorder: 20,
        gripBorderWidth: 1,
        gripBorderColor: "#bec8d9",
        gripBgColor: "#f6f8fa",
        gripBgActiveColor: "#dbdde0",
        labelPadding: 8,
        labelOffset: 0,
        tickWidth: 1,
        tickColor: "#333",
        tickOffset: 25,
        tickLength: 7,
        minorTickOffset: 25,
        minorTickColor: "#333",
        minorTickLength: 4,
        currentValuePadding: 8,
        currentValueInset: 0
      };
    }, {}],
    191: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plots/array_container_defaults"),
        i = e("./attributes"),
        o = e("./constants").name,
        l = i.steps;
      function s(e, t, r) {
        function o(r, a) {
          return n.coerce(e, t, i, r, a);
        }
        for (var l = a(e, t, {
            name: "steps",
            handleItemDefaults: c
          }), s = 0, u = 0; u < l.length; u++) l[u].visible && s++;
        if (s < 2 ? t.visible = !1 : o("visible")) {
          t._stepCount = s;
          var d = t._visibleSteps = n.filterVisible(l);
          (l[o("active")] || {}).visible || (t.active = d[0]._index), o("x"), o("y"), n.noneOrAll(e, t, ["x", "y"]), o("xanchor"), o("yanchor"), o("len"), o("lenmode"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("currentvalue.visible") && (o("currentvalue.xanchor"), o("currentvalue.prefix"), o("currentvalue.suffix"), o("currentvalue.offset"), n.coerceFont(o, "currentvalue.font", t.font)), o("transition.duration"), o("transition.easing"), o("bgcolor"), o("activebgcolor"), o("bordercolor"), o("borderwidth"), o("ticklen"), o("tickwidth"), o("tickcolor"), o("minorticklen");
        }
      }
      function c(e, t) {
        function r(r, a) {
          return n.coerce(e, t, l, r, a);
        }
        if ("skip" === e.method || Array.isArray(e.args) ? r("visible") : t.visible = !1) {
          r("method"), r("args");
          var a = r("label", "step-" + t._index);
          r("value", a), r("execute");
        }
      }
      t.exports = function (e, t) {
        a(e, t, {
          name: o,
          handleItemDefaults: s
        });
      };
    }, {
      "../../lib": 225,
      "../../plots/array_container_defaults": 267,
      "./attributes": 189,
      "./constants": 190
    }],
    192: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../plots/plots"),
        i = e("../color"),
        o = e("../drawing"),
        l = e("../../lib"),
        s = l.strTranslate,
        c = e("../../lib/svg_text_utils"),
        u = e("../../plot_api/plot_template").arrayEditor,
        d = e("./constants"),
        f = e("../../constants/alignment"),
        h = f.LINE_SPACING,
        p = f.FROM_TL,
        g = f.FROM_BR;
      function m(e) {
        return d.autoMarginIdRoot + e._index;
      }
      function y(e) {
        return e._index;
      }
      function v(e, t) {
        var r = o.tester.selectAll("g." + d.labelGroupClass).data(t._visibleSteps);
        r.enter().append("g").classed(d.labelGroupClass, !0);
        var i = 0,
          s = 0;
        r.each(function (e) {
          var r = _(n.select(this), {
            step: e
          }, t).node();
          if (r) {
            var a = o.bBox(r);
            s = Math.max(s, a.height), i = Math.max(i, a.width);
          }
        }), r.remove();
        var u = t._dims = {};
        u.inputAreaWidth = Math.max(d.railWidth, d.gripHeight);
        var f = e._fullLayout._size;
        u.lx = f.l + f.w * t.x, u.ly = f.t + f.h * (1 - t.y), "fraction" === t.lenmode ? u.outerLength = Math.round(f.w * t.len) : u.outerLength = t.len, u.inputAreaStart = 0, u.inputAreaLength = Math.round(u.outerLength - t.pad.l - t.pad.r);
        var h = (u.inputAreaLength - 2 * d.stepInset) / (t._stepCount - 1),
          y = i + d.labelPadding;
        if (u.labelStride = Math.max(1, Math.ceil(y / h)), u.labelHeight = s, u.currentValueMaxWidth = 0, u.currentValueHeight = 0, u.currentValueTotalHeight = 0, u.currentValueMaxLines = 1, t.currentvalue.visible) {
          var v = o.tester.append("g");
          r.each(function (e) {
            var r = x(v, t, e.label),
              n = r.node() && o.bBox(r.node()) || {
                width: 0,
                height: 0
              },
              a = c.lineCount(r);
            u.currentValueMaxWidth = Math.max(u.currentValueMaxWidth, Math.ceil(n.width)), u.currentValueHeight = Math.max(u.currentValueHeight, Math.ceil(n.height)), u.currentValueMaxLines = Math.max(u.currentValueMaxLines, a);
          }), u.currentValueTotalHeight = u.currentValueHeight + t.currentvalue.offset, v.remove();
        }
        u.height = u.currentValueTotalHeight + d.tickOffset + t.ticklen + d.labelOffset + u.labelHeight + t.pad.t + t.pad.b;
        var b = "left";
        l.isRightAnchor(t) && (u.lx -= u.outerLength, b = "right"), l.isCenterAnchor(t) && (u.lx -= u.outerLength / 2, b = "center");
        var w = "top";
        l.isBottomAnchor(t) && (u.ly -= u.height, w = "bottom"), l.isMiddleAnchor(t) && (u.ly -= u.height / 2, w = "middle"), u.outerLength = Math.ceil(u.outerLength), u.height = Math.ceil(u.height), u.lx = Math.round(u.lx), u.ly = Math.round(u.ly);
        var M = {
          y: t.y,
          b: u.height * g[w],
          t: u.height * p[w]
        };
        "fraction" === t.lenmode ? (M.l = 0, M.xl = t.x - t.len * p[b], M.r = 0, M.xr = t.x + t.len * g[b]) : (M.x = t.x, M.l = u.outerLength * p[b], M.r = u.outerLength * g[b]), a.autoMargin(e, m(t), M);
      }
      function x(e, t, r) {
        if (t.currentvalue.visible) {
          var n,
            a,
            i = t._dims;
          switch (t.currentvalue.xanchor) {
            case "right":
              n = i.inputAreaLength - d.currentValueInset - i.currentValueMaxWidth, a = "left";
              break;
            case "center":
              n = .5 * i.inputAreaLength, a = "middle";
              break;
            default:
              n = d.currentValueInset, a = "left";
          }
          var s = l.ensureSingle(e, "text", d.labelClass, function (e) {
              e.attr({
                "text-anchor": a,
                "data-notex": 1
              });
            }),
            u = t.currentvalue.prefix ? t.currentvalue.prefix : "";
          if ("string" == typeof r) u += r;else {
            var f = t.steps[t.active].label,
              p = t._gd._fullLayout._meta;
            p && (f = l.templateString(f, p)), u += f;
          }
          t.currentvalue.suffix && (u += t.currentvalue.suffix), s.call(o.font, t.currentvalue.font).text(u).call(c.convertToTspans, t._gd);
          var g = c.lineCount(s),
            m = (i.currentValueMaxLines + 1 - g) * t.currentvalue.font.size * h;
          return c.positionText(s, n, m), s;
        }
      }
      function b(e, t, r) {
        l.ensureSingle(e, "rect", d.gripRectClass, function (n) {
          n.call(k, t, e, r).style("pointer-events", "all");
        }).attr({
          width: d.gripWidth,
          height: d.gripHeight,
          rx: d.gripRadius,
          ry: d.gripRadius
        }).call(i.stroke, r.bordercolor).call(i.fill, r.bgcolor).style("stroke-width", r.borderwidth + "px");
      }
      function _(e, t, r) {
        var n = l.ensureSingle(e, "text", d.labelClass, function (e) {
            e.attr({
              "text-anchor": "middle",
              "data-notex": 1
            });
          }),
          a = t.step.label,
          i = r._gd._fullLayout._meta;
        return i && (a = l.templateString(a, i)), n.call(o.font, r.font).text(a).call(c.convertToTspans, r._gd), n;
      }
      function w(e, t) {
        var r = l.ensureSingle(e, "g", d.labelsClass),
          a = t._dims,
          i = r.selectAll("g." + d.labelGroupClass).data(a.labelSteps);
        i.enter().append("g").classed(d.labelGroupClass, !0), i.exit().remove(), i.each(function (e) {
          var r = n.select(this);
          r.call(_, e, t), o.setTranslate(r, D(t, e.fraction), d.tickOffset + t.ticklen + t.font.size * h + d.labelOffset + a.currentValueTotalHeight);
        });
      }
      function M(e, t, r, n, a) {
        var i = Math.round(n * (r._stepCount - 1)),
          o = r._visibleSteps[i]._index;
        o !== r.active && T(e, t, r, o, !0, a);
      }
      function T(e, t, r, n, i, o) {
        var l = r.active;
        r.active = n, u(e.layout, d.name, r).applyUpdate("active", n);
        var s = r.steps[r.active];
        t.call(L, r, o), t.call(x, r), e.emit("plotly_sliderchange", {
          slider: r,
          step: r.steps[r.active],
          interaction: i,
          previousActive: l
        }), s && s.method && i && (t._nextMethod ? (t._nextMethod.step = s, t._nextMethod.doCallback = i, t._nextMethod.doTransition = o) : (t._nextMethod = {
          step: s,
          doCallback: i,
          doTransition: o
        }, t._nextMethodRaf = window.requestAnimationFrame(function () {
          var r = t._nextMethod.step;
          r.method && (r.execute && a.executeAPICommand(e, r.method, r.args), t._nextMethod = null, t._nextMethodRaf = null);
        })));
      }
      function k(e, t, r) {
        var a = r.node(),
          o = n.select(t);
        function l() {
          return r.data()[0];
        }
        function s() {
          var e = l();
          t.emit("plotly_sliderstart", {
            slider: e
          });
          var s = r.select("." + d.gripRectClass);
          n.event.stopPropagation(), n.event.preventDefault(), s.call(i.fill, e.activebgcolor);
          var c = S(e, n.mouse(a)[0]);
          function u() {
            var e = l(),
              i = S(e, n.mouse(a)[0]);
            M(t, r, e, i, !1);
          }
          function f() {
            var e = l();
            e._dragging = !1, s.call(i.fill, e.bgcolor), o.on("mouseup", null), o.on("mousemove", null), o.on("touchend", null), o.on("touchmove", null), t.emit("plotly_sliderend", {
              slider: e,
              step: e.steps[e.active]
            });
          }
          M(t, r, e, c, !0), e._dragging = !0, o.on("mousemove", u), o.on("touchmove", u), o.on("mouseup", f), o.on("touchend", f);
        }
        e.on("mousedown", s), e.on("touchstart", s);
      }
      function A(e, t) {
        var r = e.selectAll("rect." + d.tickRectClass).data(t._visibleSteps),
          a = t._dims;
        r.enter().append("rect").classed(d.tickRectClass, !0), r.exit().remove(), r.attr({
          width: t.tickwidth + "px",
          "shape-rendering": "crispEdges"
        }), r.each(function (e, r) {
          var l = r % a.labelStride == 0,
            s = n.select(this);
          s.attr({
            height: l ? t.ticklen : t.minorticklen
          }).call(i.fill, t.tickcolor), o.setTranslate(s, D(t, r / (t._stepCount - 1)) - .5 * t.tickwidth, (l ? d.tickOffset : d.minorTickOffset) + a.currentValueTotalHeight);
        });
      }
      function L(e, t, r) {
        for (var n = e.select("rect." + d.gripRectClass), a = 0, i = 0; i < t._stepCount; i++) if (t._visibleSteps[i]._index === t.active) {
          a = i;
          break;
        }
        var o = D(t, a / (t._stepCount - 1));
        if (!t._invokingCommand) {
          var l = n;
          r && t.transition.duration > 0 && (l = l.transition().duration(t.transition.duration).ease(t.transition.easing)), l.attr("transform", s(o - .5 * d.gripWidth, t._dims.currentValueTotalHeight));
        }
      }
      function D(e, t) {
        var r = e._dims;
        return r.inputAreaStart + d.stepInset + (r.inputAreaLength - 2 * d.stepInset) * Math.min(1, Math.max(0, t));
      }
      function S(e, t) {
        var r = e._dims;
        return Math.min(1, Math.max(0, (t - d.stepInset - r.inputAreaStart) / (r.inputAreaLength - 2 * d.stepInset - 2 * r.inputAreaStart)));
      }
      function C(e, t, r) {
        var n = r._dims,
          a = l.ensureSingle(e, "rect", d.railTouchRectClass, function (n) {
            n.call(k, t, e, r).style("pointer-events", "all");
          });
        a.attr({
          width: n.inputAreaLength,
          height: Math.max(n.inputAreaWidth, d.tickOffset + r.ticklen + n.labelHeight)
        }).call(i.fill, r.bgcolor).attr("opacity", 0), o.setTranslate(a, 0, n.currentValueTotalHeight);
      }
      function O(e, t) {
        var r = t._dims,
          n = r.inputAreaLength - 2 * d.railInset,
          a = l.ensureSingle(e, "rect", d.railRectClass);
        a.attr({
          width: n,
          height: d.railWidth,
          rx: d.railRadius,
          ry: d.railRadius,
          "shape-rendering": "crispEdges"
        }).call(i.stroke, t.bordercolor).call(i.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px"), o.setTranslate(a, d.railInset, .5 * (r.inputAreaWidth - d.railWidth) + r.currentValueTotalHeight);
      }
      t.exports = function (e) {
        var t = e._fullLayout,
          r = function (e, t) {
            for (var r = e[d.name], n = [], a = 0; a < r.length; a++) {
              var i = r[a];
              i.visible && (i._gd = t, n.push(i));
            }
            return n;
          }(t, e),
          i = t._infolayer.selectAll("g." + d.containerClassName).data(r.length > 0 ? [0] : []);
        function l(t) {
          t._commandObserver && (t._commandObserver.remove(), delete t._commandObserver), a.autoMargin(e, m(t));
        }
        if (i.enter().append("g").classed(d.containerClassName, !0).style("cursor", "ew-resize"), i.exit().each(function () {
          n.select(this).selectAll("g." + d.groupClassName).each(l);
        }).remove(), 0 !== r.length) {
          var s = i.selectAll("g." + d.groupClassName).data(r, y);
          s.enter().append("g").classed(d.groupClassName, !0), s.exit().each(l).remove();
          for (var c = 0; c < r.length; c++) {
            var u = r[c];
            v(e, u);
          }
          s.each(function (t) {
            var r = n.select(this);
            !function (e) {
              var t = e._dims;
              t.labelSteps = [];
              for (var r = e._stepCount, n = 0; n < r; n += t.labelStride) t.labelSteps.push({
                fraction: n / (r - 1),
                step: e._visibleSteps[n]
              });
            }(t), a.manageCommandObserver(e, t, t._visibleSteps, function (t) {
              var n = r.data()[0];
              n.active !== t.index && (n._dragging || T(e, r, n, t.index, !1, !0));
            }), function (e, t, r) {
              (r.steps[r.active] || {}).visible || (r.active = r._visibleSteps[0]._index);
              t.call(x, r).call(O, r).call(w, r).call(A, r).call(C, e, r).call(b, e, r);
              var n = r._dims;
              o.setTranslate(t, n.lx + r.pad.l, n.ly + r.pad.t), t.call(L, r, !1), t.call(x, r);
            }(e, n.select(this), t);
          });
        }
      };
    }, {
      "../../constants/alignment": 201,
      "../../lib": 225,
      "../../lib/svg_text_utils": 248,
      "../../plot_api/plot_template": 261,
      "../../plots/plots": 307,
      "../color": 96,
      "../drawing": 118,
      "./constants": 190,
      "@plotly/d3": 6
    }],
    193: [function (e, t, r) {
      "use strict";

      var n = e("./constants");
      t.exports = {
        moduleType: "component",
        name: n.name,
        layoutAttributes: e("./attributes"),
        supplyLayoutDefaults: e("./defaults"),
        draw: e("./draw")
      };
    }, {
      "./attributes": 189,
      "./constants": 190,
      "./defaults": 191,
      "./draw": 192
    }],
    194: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("fast-isnumeric"),
        i = e("../../plots/plots"),
        o = e("../../registry"),
        l = e("../../lib"),
        s = l.strTranslate,
        c = e("../drawing"),
        u = e("../color"),
        d = e("../../lib/svg_text_utils"),
        f = e("../../constants/interactions"),
        h = e("../../constants/alignment").OPPOSITE_SIDE,
        p = / [XY][0-9]* /;
      t.exports = {
        draw: function draw(e, t, r) {
          var g,
            m = r.propContainer,
            y = r.propName,
            v = r.placeholder,
            x = r.traceIndex,
            b = r.avoid || {},
            _ = r.attributes,
            w = r.transform,
            M = r.containerGroup,
            T = e._fullLayout,
            k = 1,
            A = !1,
            L = m.title,
            D = (L && L.text ? L.text : "").trim(),
            S = L && L.font ? L.font : {},
            C = S.family,
            O = S.size,
            P = S.color;
          "title.text" === y ? g = "titleText" : -1 !== y.indexOf("axis") ? g = "axisTitleText" : y.indexOf(!0) && (g = "colorbarTitleText");
          var I = e._context.edits[g];
          "" === D ? k = 0 : D.replace(p, " % ") === v.replace(p, " % ") && (k = .2, A = !0, I || (D = "")), r._meta ? D = l.templateString(D, r._meta) : T._meta && (D = l.templateString(D, T._meta));
          var z = D || I;
          M || (M = l.ensureSingle(T._infolayer, "g", "g-" + t));
          var R = M.selectAll("text").data(z ? [0] : []);
          if (R.enter().append("text"), R.text(D).attr("class", t), R.exit().remove(), !z) return M;
          function N(e) {
            l.syncOrAsync([F, E], e);
          }
          function F(t) {
            var r;
            return w ? (r = "", w.rotate && (r += "rotate(" + [w.rotate, _.x, _.y] + ")"), w.offset && (r += s(0, w.offset))) : r = null, t.attr("transform", r), t.style({
              "font-family": C,
              "font-size": n.round(O, 2) + "px",
              fill: u.rgb(P),
              opacity: k * u.opacity(P),
              "font-weight": i.fontWeight
            }).attr(_).call(d.convertToTspans, e), i.previousPromises(e);
          }
          function E(e) {
            var t = n.select(e.node().parentNode);
            if (b && b.selection && b.side && D) {
              t.attr("transform", null);
              var r = h[b.side],
                i = "left" === b.side || "top" === b.side ? -1 : 1,
                o = a(b.pad) ? b.pad : 2,
                u = c.bBox(t.node()),
                d = {
                  left: 0,
                  top: 0,
                  right: T.width,
                  bottom: T.height
                },
                f = b.maxShift || i * (d[b.side] - u[b.side]),
                p = 0;
              if (f < 0) p = f;else {
                var g = b.offsetLeft || 0,
                  m = b.offsetTop || 0;
                u.left -= g, u.right -= g, u.top -= m, u.bottom -= m, b.selection.each(function () {
                  var e = c.bBox(this);
                  l.bBoxIntersect(u, e, o) && (p = Math.max(p, i * (e[b.side] - u[r]) + o));
                }), p = Math.min(f, p);
              }
              if (p > 0 || f < 0) {
                var y = {
                  left: [-p, 0],
                  right: [p, 0],
                  top: [0, -p],
                  bottom: [0, p]
                }[b.side];
                t.attr("transform", s(y[0], y[1]));
              }
            }
          }
          return R.call(N), I && (D ? R.on(".opacity", null) : (k = 0, A = !0, R.text(v).on("mouseover.opacity", function () {
            n.select(this).transition().duration(f.SHOW_PLACEHOLDER).style("opacity", 1);
          }).on("mouseout.opacity", function () {
            n.select(this).transition().duration(f.HIDE_PLACEHOLDER).style("opacity", 0);
          })), R.call(d.makeEditable, {
            gd: e
          }).on("edit", function (t) {
            void 0 !== x ? o.call("_guiRestyle", e, y, t, x) : o.call("_guiRelayout", e, y, t);
          }).on("cancel", function () {
            this.text(this.attr("data-unformatted")).call(N);
          }).on("input", function (e) {
            this.text(e || " ").call(d.positionText, _.x, _.y);
          })), R.classed("js-placeholder", A), M;
        }
      };
    }, {
      "../../constants/alignment": 201,
      "../../constants/interactions": 204,
      "../../lib": 225,
      "../../lib/svg_text_utils": 248,
      "../../plots/plots": 307,
      "../../registry": 309,
      "../color": 96,
      "../drawing": 118,
      "@plotly/d3": 6,
      "fast-isnumeric": 11
    }],
    195: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/font_attributes"),
        a = e("../color/attributes"),
        i = e("../../lib/extend").extendFlat,
        o = e("../../plot_api/edit_types").overrideAll,
        l = e("../../plots/pad_attributes"),
        s = e("../../plot_api/plot_template").templatedArray,
        c = s("button", {
          visible: {
            valType: "boolean"
          },
          method: {
            valType: "enumerated",
            values: ["restyle", "relayout", "animate", "update", "skip"],
            dflt: "restyle"
          },
          args: {
            valType: "info_array",
            freeLength: !0,
            items: [{
              valType: "any"
            }, {
              valType: "any"
            }, {
              valType: "any"
            }]
          },
          args2: {
            valType: "info_array",
            freeLength: !0,
            items: [{
              valType: "any"
            }, {
              valType: "any"
            }, {
              valType: "any"
            }]
          },
          label: {
            valType: "string",
            dflt: ""
          },
          execute: {
            valType: "boolean",
            dflt: !0
          }
        });
      t.exports = o(s("updatemenu", {
        _arrayAttrRegexps: [/^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/],
        visible: {
          valType: "boolean"
        },
        type: {
          valType: "enumerated",
          values: ["dropdown", "buttons"],
          dflt: "dropdown"
        },
        direction: {
          valType: "enumerated",
          values: ["left", "right", "up", "down"],
          dflt: "down"
        },
        active: {
          valType: "integer",
          min: -1,
          dflt: 0
        },
        showactive: {
          valType: "boolean",
          dflt: !0
        },
        buttons: c,
        x: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: -.05
        },
        xanchor: {
          valType: "enumerated",
          values: ["auto", "left", "center", "right"],
          dflt: "right"
        },
        y: {
          valType: "number",
          min: -2,
          max: 3,
          dflt: 1
        },
        yanchor: {
          valType: "enumerated",
          values: ["auto", "top", "middle", "bottom"],
          dflt: "top"
        },
        pad: i(l({
          editType: "arraydraw"
        }), {}),
        font: n({}),
        bgcolor: {
          valType: "color"
        },
        bordercolor: {
          valType: "color",
          dflt: a.borderLine
        },
        borderwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "arraydraw"
        }
      }), "arraydraw", "from-root");
    }, {
      "../../lib/extend": 219,
      "../../plot_api/edit_types": 254,
      "../../plot_api/plot_template": 261,
      "../../plots/font_attributes": 301,
      "../../plots/pad_attributes": 306,
      "../color/attributes": 95
    }],
    196: [function (e, t, r) {
      "use strict";

      t.exports = {
        name: "updatemenus",
        containerClassName: "updatemenu-container",
        headerGroupClassName: "updatemenu-header-group",
        headerClassName: "updatemenu-header",
        headerArrowClassName: "updatemenu-header-arrow",
        dropdownButtonGroupClassName: "updatemenu-dropdown-button-group",
        dropdownButtonClassName: "updatemenu-dropdown-button",
        buttonClassName: "updatemenu-button",
        itemRectClassName: "updatemenu-item-rect",
        itemTextClassName: "updatemenu-item-text",
        menuIndexAttrName: "updatemenu-active-index",
        autoMarginIdRoot: "updatemenu-",
        blankHeaderOpts: {
          label: "  "
        },
        minWidth: 30,
        minHeight: 30,
        textPadX: 24,
        arrowPadX: 16,
        rx: 2,
        ry: 2,
        textOffsetX: 12,
        textOffsetY: 3,
        arrowOffsetX: 4,
        gapButtonHeader: 5,
        gapButton: 2,
        activeColor: "#F4FAFF",
        hoverColor: "#F4FAFF",
        arrowSymbol: {
          left: "\u25C4",
          right: "\u25BA",
          up: "\u25B2",
          down: "\u25BC"
        }
      };
    }, {}],
    197: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plots/array_container_defaults"),
        i = e("./attributes"),
        o = e("./constants").name,
        l = i.buttons;
      function s(e, t, r) {
        function o(r, a) {
          return n.coerce(e, t, i, r, a);
        }
        o("visible", a(e, t, {
          name: "buttons",
          handleItemDefaults: c
        }).length > 0) && (o("active"), o("direction"), o("type"), o("showactive"), o("x"), o("y"), n.noneOrAll(e, t, ["x", "y"]), o("xanchor"), o("yanchor"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("bgcolor", r.paper_bgcolor), o("bordercolor"), o("borderwidth"));
      }
      function c(e, t) {
        function r(r, a) {
          return n.coerce(e, t, l, r, a);
        }
        r("visible", "skip" === e.method || Array.isArray(e.args)) && (r("method"), r("args"), r("args2"), r("label"), r("execute"));
      }
      t.exports = function (e, t) {
        a(e, t, {
          name: o,
          handleItemDefaults: s
        });
      };
    }, {
      "../../lib": 225,
      "../../plots/array_container_defaults": 267,
      "./attributes": 195,
      "./constants": 196
    }],
    198: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../plots/plots"),
        i = e("../color"),
        o = e("../drawing"),
        l = e("../../lib"),
        s = e("../../lib/svg_text_utils"),
        c = e("../../plot_api/plot_template").arrayEditor,
        u = e("../../constants/alignment").LINE_SPACING,
        d = e("./constants"),
        f = e("./scrollbox");
      function h(e) {
        return e._index;
      }
      function p(e, t) {
        return +e.attr(d.menuIndexAttrName) === t._index;
      }
      function g(e, t, r, n, a, i, o, l) {
        t.active = o, c(e.layout, d.name, t).applyUpdate("active", o), "buttons" === t.type ? y(e, n, null, null, t) : "dropdown" === t.type && (a.attr(d.menuIndexAttrName, "-1"), m(e, n, a, i, t), l || y(e, n, a, i, t));
      }
      function m(e, t, r, n, a) {
        var i = l.ensureSingle(t, "g", d.headerClassName, function (e) {
            e.style("pointer-events", "all");
          }),
          s = a._dims,
          c = a.active,
          u = a.buttons[c] || d.blankHeaderOpts,
          f = {
            y: a.pad.t,
            yPad: 0,
            x: a.pad.l,
            xPad: 0,
            index: 0
          },
          h = {
            width: s.headerWidth,
            height: s.headerHeight
          };
        i.call(v, a, u, e).call(A, a, f, h), l.ensureSingle(t, "text", d.headerArrowClassName, function (e) {
          e.attr("text-anchor", "end").call(o.font, a.font).text(d.arrowSymbol[a.direction]);
        }).attr({
          x: s.headerWidth - d.arrowOffsetX + a.pad.l,
          y: s.headerHeight / 2 + d.textOffsetY + a.pad.t
        }), i.on("click", function () {
          r.call(L, String(p(r, a) ? -1 : a._index)), y(e, t, r, n, a);
        }), i.on("mouseover", function () {
          i.call(w);
        }), i.on("mouseout", function () {
          i.call(M, a);
        }), o.setTranslate(t, s.lx, s.ly);
      }
      function y(e, t, r, i, o) {
        r || (r = t).attr("pointer-events", "all");
        var s = function (e) {
            return -1 == +e.attr(d.menuIndexAttrName);
          }(r) && "buttons" !== o.type ? [] : o.buttons,
          c = "dropdown" === o.type ? d.dropdownButtonClassName : d.buttonClassName,
          u = r.selectAll("g." + c).data(l.filterVisible(s)),
          f = u.enter().append("g").classed(c, !0),
          h = u.exit();
        "dropdown" === o.type ? (f.attr("opacity", "0").transition().attr("opacity", "1"), h.transition().attr("opacity", "0").remove()) : h.remove();
        var p = 0,
          m = 0,
          y = o._dims,
          x = -1 !== ["up", "down"].indexOf(o.direction);
        "dropdown" === o.type && (x ? m = y.headerHeight + d.gapButtonHeader : p = y.headerWidth + d.gapButtonHeader), "dropdown" === o.type && "up" === o.direction && (m = -d.gapButtonHeader + d.gapButton - y.openHeight), "dropdown" === o.type && "left" === o.direction && (p = -d.gapButtonHeader + d.gapButton - y.openWidth);
        var b = {
            x: y.lx + p + o.pad.l,
            y: y.ly + m + o.pad.t,
            yPad: d.gapButton,
            xPad: d.gapButton,
            index: 0
          },
          T = {
            l: b.x + o.borderwidth,
            t: b.y + o.borderwidth
          };
        u.each(function (l, s) {
          var c = n.select(this);
          c.call(v, o, l, e).call(A, o, b), c.on("click", function () {
            n.event.defaultPrevented || (l.execute && (l.args2 && o.active === s ? (g(e, o, 0, t, r, i, -1), a.executeAPICommand(e, l.method, l.args2)) : (g(e, o, 0, t, r, i, s), a.executeAPICommand(e, l.method, l.args))), e.emit("plotly_buttonclicked", {
              menu: o,
              button: l,
              active: o.active
            }));
          }), c.on("mouseover", function () {
            c.call(w);
          }), c.on("mouseout", function () {
            c.call(M, o), u.call(_, o);
          });
        }), u.call(_, o), x ? (T.w = Math.max(y.openWidth, y.headerWidth), T.h = b.y - T.t) : (T.w = b.x - T.l, T.h = Math.max(y.openHeight, y.headerHeight)), T.direction = o.direction, i && (u.size() ? function (e, t, r, n, a, i) {
          var o,
            l,
            s,
            c = a.direction,
            u = "up" === c || "down" === c,
            f = a._dims,
            h = a.active;
          if (u) for (l = 0, s = 0; s < h; s++) l += f.heights[s] + d.gapButton;else for (o = 0, s = 0; s < h; s++) o += f.widths[s] + d.gapButton;
          n.enable(i, o, l), n.hbar && n.hbar.attr("opacity", "0").transition().attr("opacity", "1");
          n.vbar && n.vbar.attr("opacity", "0").transition().attr("opacity", "1");
        }(0, 0, 0, i, o, T) : function (e) {
          var t = !!e.hbar,
            r = !!e.vbar;
          t && e.hbar.transition().attr("opacity", "0").each("end", function () {
            t = !1, r || e.disable();
          });
          r && e.vbar.transition().attr("opacity", "0").each("end", function () {
            r = !1, t || e.disable();
          });
        }(i));
      }
      function v(e, t, r, n) {
        e.call(x, t).call(b, t, r, n);
      }
      function x(e, t) {
        l.ensureSingle(e, "rect", d.itemRectClassName, function (e) {
          e.attr({
            rx: d.rx,
            ry: d.ry,
            "shape-rendering": "crispEdges"
          });
        }).call(i.stroke, t.bordercolor).call(i.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px");
      }
      function b(e, t, r, n) {
        var a = l.ensureSingle(e, "text", d.itemTextClassName, function (e) {
            e.attr({
              "text-anchor": "start",
              "data-notex": 1
            });
          }),
          i = r.label,
          c = n._fullLayout._meta;
        c && (i = l.templateString(i, c)), a.call(o.font, t.font).text(i).call(s.convertToTspans, n);
      }
      function _(e, t) {
        var r = t.active;
        e.each(function (e, a) {
          var o = n.select(this);
          a === r && t.showactive && o.select("rect." + d.itemRectClassName).call(i.fill, d.activeColor);
        });
      }
      function w(e) {
        e.select("rect." + d.itemRectClassName).call(i.fill, d.hoverColor);
      }
      function M(e, t) {
        e.select("rect." + d.itemRectClassName).call(i.fill, t.bgcolor);
      }
      function T(e, t) {
        var r = t._dims = {
            width1: 0,
            height1: 0,
            heights: [],
            widths: [],
            totalWidth: 0,
            totalHeight: 0,
            openWidth: 0,
            openHeight: 0,
            lx: 0,
            ly: 0
          },
          i = o.tester.selectAll("g." + d.dropdownButtonClassName).data(l.filterVisible(t.buttons));
        i.enter().append("g").classed(d.dropdownButtonClassName, !0);
        var c = -1 !== ["up", "down"].indexOf(t.direction);
        i.each(function (a, i) {
          var l = n.select(this);
          l.call(v, t, a, e);
          var f = l.select("." + d.itemTextClassName),
            h = f.node() && o.bBox(f.node()).width,
            p = Math.max(h + d.textPadX, d.minWidth),
            g = t.font.size * u,
            m = s.lineCount(f),
            y = Math.max(g * m, d.minHeight) + d.textOffsetY;
          y = Math.ceil(y), p = Math.ceil(p), r.widths[i] = p, r.heights[i] = y, r.height1 = Math.max(r.height1, y), r.width1 = Math.max(r.width1, p), c ? (r.totalWidth = Math.max(r.totalWidth, p), r.openWidth = r.totalWidth, r.totalHeight += y + d.gapButton, r.openHeight += y + d.gapButton) : (r.totalWidth += p + d.gapButton, r.openWidth += p + d.gapButton, r.totalHeight = Math.max(r.totalHeight, y), r.openHeight = r.totalHeight);
        }), c ? r.totalHeight -= d.gapButton : r.totalWidth -= d.gapButton, r.headerWidth = r.width1 + d.arrowPadX, r.headerHeight = r.height1, "dropdown" === t.type && (c ? (r.width1 += d.arrowPadX, r.totalHeight = r.height1) : r.totalWidth = r.width1, r.totalWidth += d.arrowPadX), i.remove();
        var f = r.totalWidth + t.pad.l + t.pad.r,
          h = r.totalHeight + t.pad.t + t.pad.b,
          p = e._fullLayout._size;
        r.lx = p.l + p.w * t.x, r.ly = p.t + p.h * (1 - t.y);
        var g = "left";
        l.isRightAnchor(t) && (r.lx -= f, g = "right"), l.isCenterAnchor(t) && (r.lx -= f / 2, g = "center");
        var m = "top";
        l.isBottomAnchor(t) && (r.ly -= h, m = "bottom"), l.isMiddleAnchor(t) && (r.ly -= h / 2, m = "middle"), r.totalWidth = Math.ceil(r.totalWidth), r.totalHeight = Math.ceil(r.totalHeight), r.lx = Math.round(r.lx), r.ly = Math.round(r.ly), a.autoMargin(e, k(t), {
          x: t.x,
          y: t.y,
          l: f * ({
            right: 1,
            center: .5
          }[g] || 0),
          r: f * ({
            left: 1,
            center: .5
          }[g] || 0),
          b: h * ({
            top: 1,
            middle: .5
          }[m] || 0),
          t: h * ({
            bottom: 1,
            middle: .5
          }[m] || 0)
        });
      }
      function k(e) {
        return d.autoMarginIdRoot + e._index;
      }
      function A(e, t, r, n) {
        n = n || {};
        var a = e.select("." + d.itemRectClassName),
          i = e.select("." + d.itemTextClassName),
          l = t.borderwidth,
          c = r.index,
          f = t._dims;
        o.setTranslate(e, l + r.x, l + r.y);
        var h = -1 !== ["up", "down"].indexOf(t.direction),
          p = n.height || (h ? f.heights[c] : f.height1);
        a.attr({
          x: 0,
          y: 0,
          width: n.width || (h ? f.width1 : f.widths[c]),
          height: p
        });
        var g = t.font.size * u,
          m = (s.lineCount(i) - 1) * g / 2;
        s.positionText(i, d.textOffsetX, p / 2 - m + d.textOffsetY), h ? r.y += f.heights[c] + r.yPad : r.x += f.widths[c] + r.xPad, r.index++;
      }
      function L(e, t) {
        e.attr(d.menuIndexAttrName, t || "-1").selectAll("g." + d.dropdownButtonClassName).remove();
      }
      t.exports = function (e) {
        var t = e._fullLayout,
          r = l.filterVisible(t[d.name]);
        function i(t) {
          a.autoMargin(e, k(t));
        }
        var o = t._menulayer.selectAll("g." + d.containerClassName).data(r.length > 0 ? [0] : []);
        if (o.enter().append("g").classed(d.containerClassName, !0).style("cursor", "pointer"), o.exit().each(function () {
          n.select(this).selectAll("g." + d.headerGroupClassName).each(i);
        }).remove(), 0 !== r.length) {
          var s = o.selectAll("g." + d.headerGroupClassName).data(r, h);
          s.enter().append("g").classed(d.headerGroupClassName, !0);
          for (var c = l.ensureSingle(o, "g", d.dropdownButtonGroupClassName, function (e) {
              e.style("pointer-events", "all");
            }), u = 0; u < r.length; u++) {
            var v = r[u];
            T(e, v);
          }
          var x = "updatemenus" + t._uid,
            b = new f(e, c, x);
          s.enter().size() && (c.node().parentNode.appendChild(c.node()), c.call(L)), s.exit().each(function (e) {
            c.call(L), i(e);
          }).remove(), s.each(function (t) {
            var r = n.select(this),
              i = "dropdown" === t.type ? c : null;
            a.manageCommandObserver(e, t, t.buttons, function (n) {
              g(e, t, t.buttons[n.index], r, i, b, n.index, !0);
            }), "dropdown" === t.type ? (m(e, r, c, b, t), p(c, t) && y(e, r, c, b, t)) : y(e, r, null, null, t);
          });
        }
      };
    }, {
      "../../constants/alignment": 201,
      "../../lib": 225,
      "../../lib/svg_text_utils": 248,
      "../../plot_api/plot_template": 261,
      "../../plots/plots": 307,
      "../color": 96,
      "../drawing": 118,
      "./constants": 196,
      "./scrollbox": 200,
      "@plotly/d3": 6
    }],
    199: [function (e, t, r) {
      arguments[4][193][0].apply(r, arguments);
    }, {
      "./attributes": 195,
      "./constants": 196,
      "./defaults": 197,
      "./draw": 198,
      dup: 193
    }],
    200: [function (e, t, r) {
      "use strict";

      t.exports = l;
      var n = e("@plotly/d3"),
        a = e("../color"),
        i = e("../drawing"),
        o = e("../../lib");
      function l(e, t, r) {
        this.gd = e, this.container = t, this.id = r, this.position = null, this.translateX = null, this.translateY = null, this.hbar = null, this.vbar = null, this.bg = this.container.selectAll("rect.scrollbox-bg").data([0]), this.bg.exit().on(".drag", null).on("wheel", null).remove(), this.bg.enter().append("rect").classed("scrollbox-bg", !0).style("pointer-events", "all").attr({
          opacity: 0,
          x: 0,
          y: 0,
          width: 0,
          height: 0
        });
      }
      l.barWidth = 2, l.barLength = 20, l.barRadius = 2, l.barPad = 1, l.barColor = "#808BA4", l.prototype.enable = function (e, t, r) {
        var o = this.gd._fullLayout,
          s = o.width,
          c = o.height;
        this.position = e;
        var u,
          d,
          f,
          h,
          p = this.position.l,
          g = this.position.w,
          m = this.position.t,
          y = this.position.h,
          v = this.position.direction,
          x = "down" === v,
          b = "left" === v,
          _ = "up" === v,
          w = g,
          M = y;
        x || b || "right" === v || _ || (this.position.direction = "down", x = !0), x || _ ? (d = (u = p) + w, x ? (f = m, M = (h = Math.min(f + M, c)) - f) : M = (h = m + M) - (f = Math.max(h - M, 0))) : (h = (f = m) + M, b ? w = (d = p + w) - (u = Math.max(d - w, 0)) : (u = p, w = (d = Math.min(u + w, s)) - u)), this._box = {
          l: u,
          t: f,
          w: w,
          h: M
        };
        var T = g > w,
          k = l.barLength + 2 * l.barPad,
          A = l.barWidth + 2 * l.barPad,
          L = p,
          D = m + y;
        D + A > c && (D = c - A);
        var S = this.container.selectAll("rect.scrollbar-horizontal").data(T ? [0] : []);
        S.exit().on(".drag", null).remove(), S.enter().append("rect").classed("scrollbar-horizontal", !0).call(a.fill, l.barColor), T ? (this.hbar = S.attr({
          rx: l.barRadius,
          ry: l.barRadius,
          x: L,
          y: D,
          width: k,
          height: A
        }), this._hbarXMin = L + k / 2, this._hbarTranslateMax = w - k) : (delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax);
        var C = y > M,
          O = l.barWidth + 2 * l.barPad,
          P = l.barLength + 2 * l.barPad,
          I = p + g,
          z = m;
        I + O > s && (I = s - O);
        var R = this.container.selectAll("rect.scrollbar-vertical").data(C ? [0] : []);
        R.exit().on(".drag", null).remove(), R.enter().append("rect").classed("scrollbar-vertical", !0).call(a.fill, l.barColor), C ? (this.vbar = R.attr({
          rx: l.barRadius,
          ry: l.barRadius,
          x: I,
          y: z,
          width: O,
          height: P
        }), this._vbarYMin = z + P / 2, this._vbarTranslateMax = M - P) : (delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
        var N = this.id,
          F = u - .5,
          E = C ? d + O + .5 : d + .5,
          j = f - .5,
          H = T ? h + A + .5 : h + .5,
          B = o._topdefs.selectAll("#" + N).data(T || C ? [0] : []);
        if (B.exit().remove(), B.enter().append("clipPath").attr("id", N).append("rect"), T || C ? (this._clipRect = B.select("rect").attr({
          x: Math.floor(F),
          y: Math.floor(j),
          width: Math.ceil(E) - Math.floor(F),
          height: Math.ceil(H) - Math.floor(j)
        }), this.container.call(i.setClipUrl, N, this.gd), this.bg.attr({
          x: p,
          y: m,
          width: g,
          height: y
        })) : (this.bg.attr({
          width: 0,
          height: 0
        }), this.container.on("wheel", null).on(".drag", null).call(i.setClipUrl, null), delete this._clipRect), T || C) {
          var Y = n.behavior.drag().on("dragstart", function () {
            n.event.sourceEvent.preventDefault();
          }).on("drag", this._onBoxDrag.bind(this));
          this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call(Y);
          var U = n.behavior.drag().on("dragstart", function () {
            n.event.sourceEvent.preventDefault(), n.event.sourceEvent.stopPropagation();
          }).on("drag", this._onBarDrag.bind(this));
          T && this.hbar.on(".drag", null).call(U), C && this.vbar.on(".drag", null).call(U);
        }
        this.setTranslate(t, r);
      }, l.prototype.disable = function () {
        (this.hbar || this.vbar) && (this.bg.attr({
          width: 0,
          height: 0
        }), this.container.on("wheel", null).on(".drag", null).call(i.setClipUrl, null), delete this._clipRect), this.hbar && (this.hbar.on(".drag", null), this.hbar.remove(), delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax), this.vbar && (this.vbar.on(".drag", null), this.vbar.remove(), delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
      }, l.prototype._onBoxDrag = function () {
        var e = this.translateX,
          t = this.translateY;
        this.hbar && (e -= n.event.dx), this.vbar && (t -= n.event.dy), this.setTranslate(e, t);
      }, l.prototype._onBoxWheel = function () {
        var e = this.translateX,
          t = this.translateY;
        this.hbar && (e += n.event.deltaY), this.vbar && (t += n.event.deltaY), this.setTranslate(e, t);
      }, l.prototype._onBarDrag = function () {
        var e = this.translateX,
          t = this.translateY;
        if (this.hbar) {
          var r = e + this._hbarXMin,
            a = r + this._hbarTranslateMax;
          e = (o.constrain(n.event.x, r, a) - r) / (a - r) * (this.position.w - this._box.w);
        }
        if (this.vbar) {
          var i = t + this._vbarYMin,
            l = i + this._vbarTranslateMax;
          t = (o.constrain(n.event.y, i, l) - i) / (l - i) * (this.position.h - this._box.h);
        }
        this.setTranslate(e, t);
      }, l.prototype.setTranslate = function (e, t) {
        var r = this.position.w - this._box.w,
          n = this.position.h - this._box.h;
        if (e = o.constrain(e || 0, 0, r), t = o.constrain(t || 0, 0, n), this.translateX = e, this.translateY = t, this.container.call(i.setTranslate, this._box.l - this.position.l - e, this._box.t - this.position.t - t), this._clipRect && this._clipRect.attr({
          x: Math.floor(this.position.l + e - .5),
          y: Math.floor(this.position.t + t - .5)
        }), this.hbar) {
          var a = e / r;
          this.hbar.call(i.setTranslate, e + a * this._hbarTranslateMax, t);
        }
        if (this.vbar) {
          var l = t / n;
          this.vbar.call(i.setTranslate, e, t + l * this._vbarTranslateMax);
        }
      };
    }, {
      "../../lib": 225,
      "../color": 96,
      "../drawing": 118,
      "@plotly/d3": 6
    }],
    201: [function (e, t, r) {
      "use strict";

      t.exports = {
        FROM_BL: {
          left: 0,
          center: .5,
          right: 1,
          bottom: 0,
          middle: .5,
          top: 1
        },
        FROM_TL: {
          left: 0,
          center: .5,
          right: 1,
          bottom: 1,
          middle: .5,
          top: 0
        },
        FROM_BR: {
          left: 1,
          center: .5,
          right: 0,
          bottom: 0,
          middle: .5,
          top: 1
        },
        LINE_SPACING: 1.3,
        CAP_SHIFT: .7,
        MID_SHIFT: .35,
        OPPOSITE_SIDE: {
          left: "right",
          right: "left",
          top: "bottom",
          bottom: "top"
        }
      };
    }, {}],
    202: [function (e, t, r) {
      "use strict";

      t.exports = {
        axisRefDescription: function axisRefDescription(e, t, r) {
          return ["If set to a", e, "axis id (e.g. *" + e + "* or", "*" + e + "2*), the `" + e + "` position refers to a", e, "coordinate. If set to *paper*, the `" + e + "`", "position refers to the distance from the", t, "of the plotting", "area in normalized coordinates where *0* (*1*) corresponds to the", t, "(" + r + "). If set to a", e, "axis ID followed by", "*domain* (separated by a space), the position behaves like for", "*paper*, but refers to the distance in fractions of the domain", "length from the", t, "of the domain of that axis: e.g.,", "*" + e + "2 domain* refers to the domain of the second", e, " axis and a", e, "position of 0.5 refers to the", "point between the", t, "and the", r, "of the domain of the", "second", e, "axis."].join(" ");
        }
      };
    }, {}],
    203: [function (e, t, r) {
      "use strict";

      t.exports = {
        FORMAT_LINK: "https://github.com/d3/d3-format/tree/v1.4.5#d3-format",
        DATE_FORMAT_LINK: "https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format"
      };
    }, {}],
    204: [function (e, t, r) {
      "use strict";

      t.exports = {
        SHOW_PLACEHOLDER: 100,
        HIDE_PLACEHOLDER: 1e3,
        DESELECTDIM: .2
      };
    }, {}],
    205: [function (e, t, r) {
      "use strict";

      t.exports = {
        BADNUM: void 0,
        FP_SAFE: 1e-4 * Number.MAX_VALUE,
        ONEMAXYEAR: 316224e5,
        ONEAVGYEAR: 315576e5,
        ONEMINYEAR: 31536e6,
        ONEMAXQUARTER: 79488e5,
        ONEAVGQUARTER: 78894e5,
        ONEMINQUARTER: 76896e5,
        ONEMAXMONTH: 26784e5,
        ONEAVGMONTH: 26298e5,
        ONEMINMONTH: 24192e5,
        ONEWEEK: 6048e5,
        ONEDAY: 864e5,
        ONEHOUR: 36e5,
        ONEMIN: 6e4,
        ONESEC: 1e3,
        EPOCHJD: 2440587.5,
        ALMOST_EQUAL: .999999,
        LOG_CLIP: 10,
        MINUS_SIGN: "\u2212"
      };
    }, {}],
    206: [function (e, t, r) {
      "use strict";

      r.xmlns = "http://www.w3.org/2000/xmlns/", r.svg = "http://www.w3.org/2000/svg", r.xlink = "http://www.w3.org/1999/xlink", r.svgAttrs = {
        xmlns: r.svg,
        "xmlns:xlink": r.xlink
      };
    }, {}],
    207: [function (e, t, r) {
      "use strict";

      r.version = e("./version").version, e("native-promise-only"), e("../build/plotcss");
      for (var n = e("./registry"), a = r.register = n.register, i = e("./plot_api"), o = Object.keys(i), l = 0; l < o.length; l++) {
        var s = o[l];
        "_" !== s.charAt(0) && (r[s] = i[s]), a({
          moduleType: "apiMethod",
          name: s,
          fn: i[s]
        });
      }
      a(e("./traces/scatter")), a([e("./components/legend"), e("./components/fx"), e("./components/annotations"), e("./components/annotations3d"), e("./components/shapes"), e("./components/images"), e("./components/updatemenus"), e("./components/sliders"), e("./components/rangeslider"), e("./components/rangeselector"), e("./components/grid"), e("./components/errorbars"), e("./components/colorscale"), e("./components/colorbar"), e("./components/modebar")]), a([e("./locale-en"), e("./locale-en-us")]), window.PlotlyLocales && Array.isArray(window.PlotlyLocales) && (a(window.PlotlyLocales), delete window.PlotlyLocales), r.Icons = e("./fonts/ploticon");
      var c = e("./components/fx"),
        u = e("./plots/plots");
      r.Plots = {
        resize: u.resize,
        graphJson: u.graphJson,
        sendDataToCloud: u.sendDataToCloud
      }, r.Fx = {
        hover: c.hover,
        unhover: c.unhover,
        loneHover: c.loneHover,
        loneUnhover: c.loneUnhover
      }, r.Snapshot = e("./snapshot"), r.PlotSchema = e("./plot_api/plot_schema");
    }, {
      "../build/plotcss": 1,
      "./components/annotations": 87,
      "./components/annotations3d": 92,
      "./components/colorbar": 102,
      "./components/colorscale": 108,
      "./components/errorbars": 124,
      "./components/fx": 136,
      "./components/grid": 140,
      "./components/images": 145,
      "./components/legend": 153,
      "./components/modebar": 159,
      "./components/rangeselector": 167,
      "./components/rangeslider": 174,
      "./components/shapes": 188,
      "./components/sliders": 193,
      "./components/updatemenus": 199,
      "./fonts/ploticon": 208,
      "./locale-en": 252,
      "./locale-en-us": 251,
      "./plot_api": 256,
      "./plot_api/plot_schema": 260,
      "./plots/plots": 307,
      "./registry": 309,
      "./snapshot": 314,
      "./traces/scatter": 355,
      "./version": 371,
      "native-promise-only": 48
    }],
    208: [function (e, t, r) {
      "use strict";

      t.exports = {
        undo: {
          width: 857.1,
          height: 1e3,
          path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        home: {
          width: 928.6,
          height: 1e3,
          path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        "camera-retro": {
          width: 1e3,
          height: 1e3,
          path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        zoombox: {
          width: 1e3,
          height: 1e3,
          path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        pan: {
          width: 1e3,
          height: 1e3,
          path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        zoom_plus: {
          width: 875,
          height: 1e3,
          path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        zoom_minus: {
          width: 875,
          height: 1e3,
          path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        autoscale: {
          width: 1e3,
          height: 1e3,
          path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        tooltip_basic: {
          width: 1500,
          height: 1e3,
          path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        tooltip_compare: {
          width: 1125,
          height: 1e3,
          path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        plotlylogo: {
          width: 1542,
          height: 1e3,
          path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        "z-axis": {
          width: 1e3,
          height: 1e3,
          path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        "3d_rotate": {
          width: 1e3,
          height: 1e3,
          path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        camera: {
          width: 1e3,
          height: 1e3,
          path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        movie: {
          width: 1e3,
          height: 1e3,
          path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        question: {
          width: 857.1,
          height: 1e3,
          path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        disk: {
          width: 857.1,
          height: 1e3,
          path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        drawopenpath: {
          width: 70,
          height: 70,
          path: "M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z",
          transform: "matrix(1 0 0 1 -15 -15)"
        },
        drawclosedpath: {
          width: 90,
          height: 90,
          path: "M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z",
          transform: "matrix(1 0 0 1 -5 -5)"
        },
        lasso: {
          width: 1031,
          height: 1e3,
          path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        selectbox: {
          width: 1e3,
          height: 1e3,
          path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z",
          transform: "matrix(1 0 0 -1 0 850)"
        },
        drawline: {
          width: 70,
          height: 70,
          path: "M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z",
          transform: "matrix(1 0 0 1 -15 -15)"
        },
        drawrect: {
          width: 80,
          height: 80,
          path: "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z",
          transform: "matrix(1 0 0 1 -10 -10)"
        },
        drawcircle: {
          width: 80,
          height: 80,
          path: "M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z",
          transform: "matrix(1 0 0 1 -10 -10)"
        },
        eraseshape: {
          width: 80,
          height: 80,
          path: "M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z",
          transform: "matrix(1 0 0 1 -10 -10)"
        },
        spikeline: {
          width: 1e3,
          height: 1e3,
          path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z",
          transform: "matrix(1.5 0 0 -1.5 0 850)"
        },
        pencil: {
          width: 1792,
          height: 1792,
          path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z",
          transform: "matrix(1 0 0 1 0 1)"
        },
        newplotlylogo: {
          name: "newplotlylogo",
          svg: "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'><defs><style>.cls-1 {fill: #3f4f75;} .cls-2 {fill: #80cfbe;} .cls-3 {fill: #fff;}</style></defs><title>plotly-logomark</title><g id='symbol'><rect class='cls-1' width='132' height='132' rx='6' ry='6'/><circle class='cls-2' cx='78' cy='54' r='6'/><circle class='cls-2' cx='102' cy='30' r='6'/><circle class='cls-2' cx='78' cy='30' r='6'/><circle class='cls-2' cx='54' cy='30' r='6'/><circle class='cls-2' cx='30' cy='30' r='6'/><circle class='cls-2' cx='30' cy='54' r='6'/><path class='cls-3' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/><path class='cls-3' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/><path class='cls-3' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/><path class='cls-3' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/></g></svg>"
        }
      };
    }, {}],
    209: [function (e, t, r) {
      "use strict";

      r.isLeftAnchor = function (e) {
        return "left" === e.xanchor || "auto" === e.xanchor && e.x <= 1 / 3;
      }, r.isCenterAnchor = function (e) {
        return "center" === e.xanchor || "auto" === e.xanchor && e.x > 1 / 3 && e.x < 2 / 3;
      }, r.isRightAnchor = function (e) {
        return "right" === e.xanchor || "auto" === e.xanchor && e.x >= 2 / 3;
      }, r.isTopAnchor = function (e) {
        return "top" === e.yanchor || "auto" === e.yanchor && e.y >= 2 / 3;
      }, r.isMiddleAnchor = function (e) {
        return "middle" === e.yanchor || "auto" === e.yanchor && e.y > 1 / 3 && e.y < 2 / 3;
      }, r.isBottomAnchor = function (e) {
        return "bottom" === e.yanchor || "auto" === e.yanchor && e.y <= 1 / 3;
      };
    }, {}],
    210: [function (e, t, r) {
      "use strict";

      var n = e("./mod"),
        a = n.mod,
        i = n.modHalf,
        o = Math.PI,
        l = 2 * o;
      function s(e) {
        return Math.abs(e[1] - e[0]) > l - 1e-14;
      }
      function c(e, t) {
        return i(t - e, l);
      }
      function u(e, t) {
        if (s(t)) return !0;
        var r, n;
        t[0] < t[1] ? (r = t[0], n = t[1]) : (r = t[1], n = t[0]), (r = a(r, l)) > (n = a(n, l)) && (n += l);
        var i = a(e, l),
          o = i + l;
        return i >= r && i <= n || o >= r && o <= n;
      }
      function d(e, t, r, n, a, i, c) {
        a = a || 0, i = i || 0;
        var u,
          d,
          f,
          h,
          p,
          g = s([r, n]);
        function m(e, t) {
          return [e * Math.cos(t) + a, i - e * Math.sin(t)];
        }
        g ? (u = 0, d = o, f = l) : r < n ? (u = r, f = n) : (u = n, f = r), e < t ? (h = e, p = t) : (h = t, p = e);
        var y,
          v = Math.abs(f - u) <= o ? 0 : 1;
        function x(e, t, r) {
          return "A" + [e, e] + " " + [0, v, r] + " " + m(e, t);
        }
        return g ? y = null === h ? "M" + m(p, u) + x(p, d, 0) + x(p, f, 0) + "Z" : "M" + m(h, u) + x(h, d, 0) + x(h, f, 0) + "ZM" + m(p, u) + x(p, d, 1) + x(p, f, 1) + "Z" : null === h ? (y = "M" + m(p, u) + x(p, f, 0), c && (y += "L0,0Z")) : y = "M" + m(h, u) + "L" + m(p, u) + x(p, f, 0) + "L" + m(h, f) + x(h, u, 1) + "Z", y;
      }
      t.exports = {
        deg2rad: function deg2rad(e) {
          return e / 180 * o;
        },
        rad2deg: function rad2deg(e) {
          return e / o * 180;
        },
        angleDelta: c,
        angleDist: function angleDist(e, t) {
          return Math.abs(c(e, t));
        },
        isFullCircle: s,
        isAngleInsideSector: u,
        isPtInsideSector: function isPtInsideSector(e, t, r, n) {
          return !!u(t, n) && (r[0] < r[1] ? (a = r[0], i = r[1]) : (a = r[1], i = r[0]), e >= a && e <= i);
          var a, i;
        },
        pathArc: function pathArc(e, t, r, n, a) {
          return d(null, e, t, r, n, a, 0);
        },
        pathSector: function pathSector(e, t, r, n, a) {
          return d(null, e, t, r, n, a, 1);
        },
        pathAnnulus: function pathAnnulus(e, t, r, n, a, i) {
          return d(e, t, r, n, a, i, 1);
        }
      };
    }, {
      "./mod": 232
    }],
    211: [function (e, t, r) {
      "use strict";

      var n = Array.isArray,
        a = ArrayBuffer,
        i = DataView;
      function o(e) {
        return a.isView(e) && !(e instanceof i);
      }
      function l(e) {
        return n(e) || o(e);
      }
      function s(e, t, r) {
        if (l(e)) {
          if (l(e[0])) {
            for (var n = r, a = 0; a < e.length; a++) n = t(n, e[a].length);
            return n;
          }
          return e.length;
        }
        return 0;
      }
      r.isTypedArray = o, r.isArrayOrTypedArray = l, r.isArray1D = function (e) {
        return !l(e[0]);
      }, r.ensureArray = function (e, t) {
        return n(e) || (e = []), e.length = t, e;
      }, r.concat = function () {
        var e,
          t,
          r,
          a,
          i,
          o,
          l,
          s,
          c = [],
          u = !0,
          d = 0;
        for (r = 0; r < arguments.length; r++) (o = (a = arguments[r]).length) && (t ? c.push(a) : (t = a, i = o), n(a) ? e = !1 : (u = !1, d ? e !== a.constructor && (e = !1) : e = a.constructor), d += o);
        if (!d) return [];
        if (!c.length) return t;
        if (u) return t.concat.apply(t, c);
        if (e) {
          for ((l = new e(d)).set(t), r = 0; r < c.length; r++) a = c[r], l.set(a, i), i += a.length;
          return l;
        }
        for (l = new Array(d), s = 0; s < t.length; s++) l[s] = t[s];
        for (r = 0; r < c.length; r++) {
          for (a = c[r], s = 0; s < a.length; s++) l[i + s] = a[s];
          i += s;
        }
        return l;
      }, r.maxRowLength = function (e) {
        return s(e, Math.max, 0);
      }, r.minRowLength = function (e) {
        return s(e, Math.min, 1 / 0);
      };
    }, {}],
    212: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../constants/numerical").BADNUM,
        i = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
      t.exports = function (e) {
        return "string" == typeof e && (e = e.replace(i, "")), n(e) ? Number(e) : a;
      };
    }, {
      "../constants/numerical": 205,
      "fast-isnumeric": 11
    }],
    213: [function (e, t, r) {
      "use strict";

      t.exports = function (e) {
        var t = e._fullLayout;
        t._glcanvas && t._glcanvas.size() && t._glcanvas.each(function (e) {
          e.regl && e.regl.clear({
            color: !0,
            depth: !0
          });
        });
      };
    }, {}],
    214: [function (e, t, r) {
      "use strict";

      t.exports = function (e) {
        e._responsiveChartHandler && (window.removeEventListener("resize", e._responsiveChartHandler), delete e._responsiveChartHandler);
      };
    }, {}],
    215: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("tinycolor2"),
        i = e("../plots/attributes"),
        o = e("../components/colorscale/scales"),
        l = e("../components/color"),
        s = e("../constants/interactions").DESELECTDIM,
        c = e("./nested_property"),
        u = e("./regex").counter,
        d = e("./mod").modHalf,
        f = e("./array").isArrayOrTypedArray;
      function h(e, t) {
        var n = r.valObjectMeta[t.valType];
        if (t.arrayOk && f(e)) return !0;
        if (n.validateFunction) return n.validateFunction(e, t);
        var a = {},
          i = a,
          o = {
            set: function set(e) {
              i = e;
            }
          };
        return n.coerceFunction(e, o, a, t), i !== a;
      }
      r.valObjectMeta = {
        data_array: {
          coerceFunction: function coerceFunction(e, t, r) {
            f(e) ? t.set(e) : void 0 !== r && t.set(r);
          }
        },
        enumerated: {
          coerceFunction: function coerceFunction(e, t, r, n) {
            n.coerceNumber && (e = +e), -1 === n.values.indexOf(e) ? t.set(r) : t.set(e);
          },
          validateFunction: function validateFunction(e, t) {
            t.coerceNumber && (e = +e);
            for (var r = t.values, n = 0; n < r.length; n++) {
              var a = String(r[n]);
              if ("/" === a.charAt(0) && "/" === a.charAt(a.length - 1)) {
                if (new RegExp(a.substr(1, a.length - 2)).test(e)) return !0;
              } else if (e === r[n]) return !0;
            }
            return !1;
          }
        },
        boolean: {
          coerceFunction: function coerceFunction(e, t, r) {
            !0 === e || !1 === e ? t.set(e) : t.set(r);
          }
        },
        number: {
          coerceFunction: function coerceFunction(e, t, r, a) {
            !n(e) || void 0 !== a.min && e < a.min || void 0 !== a.max && e > a.max ? t.set(r) : t.set(+e);
          }
        },
        integer: {
          coerceFunction: function coerceFunction(e, t, r, a) {
            e % 1 || !n(e) || void 0 !== a.min && e < a.min || void 0 !== a.max && e > a.max ? t.set(r) : t.set(+e);
          }
        },
        string: {
          coerceFunction: function coerceFunction(e, t, r, n) {
            if ("string" != typeof e) {
              var a = "number" == typeof e;
              !0 !== n.strict && a ? t.set(String(e)) : t.set(r);
            } else n.noBlank && !e ? t.set(r) : t.set(e);
          }
        },
        color: {
          coerceFunction: function coerceFunction(e, t, r) {
            a(e).isValid() ? t.set(e) : t.set(r);
          }
        },
        colorlist: {
          coerceFunction: function coerceFunction(e, t, r) {
            Array.isArray(e) && e.length && e.every(function (e) {
              return a(e).isValid();
            }) ? t.set(e) : t.set(r);
          }
        },
        colorscale: {
          coerceFunction: function coerceFunction(e, t, r) {
            t.set(o.get(e, r));
          }
        },
        angle: {
          coerceFunction: function coerceFunction(e, t, r) {
            "auto" === e ? t.set("auto") : n(e) ? t.set(d(+e, 360)) : t.set(r);
          }
        },
        subplotid: {
          coerceFunction: function coerceFunction(e, t, r, n) {
            var a = n.regex || u(r);
            "string" == typeof e && a.test(e) ? t.set(e) : t.set(r);
          },
          validateFunction: function validateFunction(e, t) {
            var r = t.dflt;
            return e === r || "string" == typeof e && !!u(r).test(e);
          }
        },
        flaglist: {
          coerceFunction: function coerceFunction(e, t, r, n) {
            if ("string" == typeof e) {
              if (-1 === (n.extras || []).indexOf(e)) {
                for (var a = e.split("+"), i = 0; i < a.length;) {
                  var o = a[i];
                  -1 === n.flags.indexOf(o) || a.indexOf(o) < i ? a.splice(i, 1) : i++;
                }
                a.length ? t.set(a.join("+")) : t.set(r);
              } else t.set(e);
            } else t.set(r);
          }
        },
        any: {
          coerceFunction: function coerceFunction(e, t, r) {
            void 0 === e ? t.set(r) : t.set(e);
          }
        },
        info_array: {
          coerceFunction: function coerceFunction(e, t, n, a) {
            function i(e, t, n) {
              var a,
                i = {
                  set: function set(e) {
                    a = e;
                  }
                };
              return void 0 === n && (n = t.dflt), r.valObjectMeta[t.valType].coerceFunction(e, i, n, t), a;
            }
            var o = 2 === a.dimensions || "1-2" === a.dimensions && Array.isArray(e) && Array.isArray(e[0]);
            if (Array.isArray(e)) {
              var l,
                s,
                c,
                u,
                d,
                f,
                h = a.items,
                p = [],
                g = Array.isArray(h),
                m = g && o && Array.isArray(h[0]),
                y = o && g && !m,
                v = g && !y ? h.length : e.length;
              if (n = Array.isArray(n) ? n : [], o) for (l = 0; l < v; l++) for (p[l] = [], c = Array.isArray(e[l]) ? e[l] : [], d = y ? h.length : g ? h[l].length : c.length, s = 0; s < d; s++) u = y ? h[s] : g ? h[l][s] : h, void 0 !== (f = i(c[s], u, (n[l] || [])[s])) && (p[l][s] = f);else for (l = 0; l < v; l++) void 0 !== (f = i(e[l], g ? h[l] : h, n[l])) && (p[l] = f);
              t.set(p);
            } else t.set(n);
          },
          validateFunction: function validateFunction(e, t) {
            if (!Array.isArray(e)) return !1;
            var r = t.items,
              n = Array.isArray(r),
              a = 2 === t.dimensions;
            if (!t.freeLength && e.length !== r.length) return !1;
            for (var i = 0; i < e.length; i++) if (a) {
              if (!Array.isArray(e[i]) || !t.freeLength && e[i].length !== r[i].length) return !1;
              for (var o = 0; o < e[i].length; o++) if (!h(e[i][o], n ? r[i][o] : r)) return !1;
            } else if (!h(e[i], n ? r[i] : r)) return !1;
            return !0;
          }
        }
      }, r.coerce = function (e, t, n, a, i) {
        var o = c(n, a).get(),
          l = c(e, a),
          s = c(t, a),
          u = l.get(),
          d = t._template;
        if (void 0 === u && d && (u = c(d, a).get(), d = 0), void 0 === i && (i = o.dflt), o.arrayOk && f(u)) return s.set(u), u;
        var p = r.valObjectMeta[o.valType].coerceFunction;
        p(u, s, i, o);
        var g = s.get();
        return d && g === i && !h(u, o) && (p(u = c(d, a).get(), s, i, o), g = s.get()), g;
      }, r.coerce2 = function (e, t, n, a, i) {
        var o = c(e, a),
          l = r.coerce(e, t, n, a, i),
          s = o.get();
        return null != s && l;
      }, r.coerceFont = function (e, t, r) {
        var n = {};
        return r = r || {}, n.family = e(t + ".family", r.family), n.size = e(t + ".size", r.size), n.color = e(t + ".color", r.color), n;
      }, r.coercePattern = function (e, t, r, n) {
        if (e(t + ".shape")) {
          e(t + ".solidity"), e(t + ".size");
          var a = "overlay" === e(t + ".fillmode");
          if (!n) {
            var i = e(t + ".bgcolor", a ? r : void 0);
            e(t + ".fgcolor", a ? l.contrast(i) : r);
          }
          e(t + ".fgopacity", a ? .5 : 1);
        }
      }, r.coerceHoverinfo = function (e, t, n) {
        var a,
          o = t._module.attributes,
          l = o.hoverinfo ? o : i,
          s = l.hoverinfo;
        if (1 === n._dataLength) {
          var c = "all" === s.dflt ? s.flags.slice() : s.dflt.split("+");
          c.splice(c.indexOf("name"), 1), a = c.join("+");
        }
        return r.coerce(e, t, l, "hoverinfo", a);
      }, r.coerceSelectionMarkerOpacity = function (e, t) {
        if (e.marker) {
          var r,
            n,
            a = e.marker.opacity;
          if (void 0 !== a) f(a) || e.selected || e.unselected || (r = a, n = s * a), t("selected.marker.opacity", r), t("unselected.marker.opacity", n);
        }
      }, r.validate = h;
    }, {
      "../components/color": 96,
      "../components/colorscale/scales": 111,
      "../constants/interactions": 204,
      "../plots/attributes": 268,
      "./array": 211,
      "./mod": 232,
      "./nested_property": 233,
      "./regex": 241,
      "fast-isnumeric": 11,
      tinycolor2: 61
    }],
    216: [function (e, t, r) {
      "use strict";

      var n,
        a,
        i = e("d3-time-format").timeFormat,
        o = e("fast-isnumeric"),
        l = e("./loggers"),
        s = e("./mod").mod,
        c = e("../constants/numerical"),
        u = c.BADNUM,
        d = c.ONEDAY,
        f = c.ONEHOUR,
        h = c.ONEMIN,
        p = c.ONESEC,
        g = c.EPOCHJD,
        m = e("../registry"),
        y = e("d3-time-format").utcFormat,
        v = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m,
        x = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m,
        b = new Date().getFullYear() - 70;
      function _(e) {
        return e && m.componentsRegistry.calendars && "string" == typeof e && "gregorian" !== e;
      }
      function w(e, t) {
        return String(e + Math.pow(10, t)).substr(1);
      }
      r.dateTick0 = function (e, t) {
        var n = function (e, t) {
          return _(e) ? t ? m.getComponentMethod("calendars", "CANONICAL_SUNDAY")[e] : m.getComponentMethod("calendars", "CANONICAL_TICK")[e] : t ? "2000-01-02" : "2000-01-01";
        }(e, !!t);
        if (t < 2) return n;
        var a = r.dateTime2ms(n, e);
        return a += d * (t - 1), r.ms2DateTime(a, 0, e);
      }, r.dfltRange = function (e) {
        return _(e) ? m.getComponentMethod("calendars", "DFLTRANGE")[e] : ["2000-01-01", "2001-01-01"];
      }, r.isJSDate = function (e) {
        return "object" == typeof e && null !== e && "function" == typeof e.getTime;
      }, r.dateTime2ms = function (e, t) {
        if (r.isJSDate(e)) {
          var i = e.getTimezoneOffset() * h,
            o = (e.getUTCMinutes() - e.getMinutes()) * h + (e.getUTCSeconds() - e.getSeconds()) * p + (e.getUTCMilliseconds() - e.getMilliseconds());
          if (o) {
            var l = 3 * h;
            i = i - l / 2 + s(o - i + l / 2, l);
          }
          return (e = Number(e) - i) >= n && e <= a ? e : u;
        }
        if ("string" != typeof e && "number" != typeof e) return u;
        e = String(e);
        var c = _(t),
          y = e.charAt(0);
        !c || "G" !== y && "g" !== y || (e = e.substr(1), t = "");
        var w = c && "chinese" === t.substr(0, 7),
          M = e.match(w ? x : v);
        if (!M) return u;
        var T = M[1],
          k = M[3] || "1",
          A = Number(M[5] || 1),
          L = Number(M[7] || 0),
          D = Number(M[9] || 0),
          S = Number(M[11] || 0);
        if (c) {
          if (2 === T.length) return u;
          var C;
          T = Number(T);
          try {
            var O = m.getComponentMethod("calendars", "getCal")(t);
            if (w) {
              var P = "i" === k.charAt(k.length - 1);
              k = parseInt(k, 10), C = O.newDate(T, O.toMonthIndex(T, k, P), A);
            } else C = O.newDate(T, Number(k), A);
          } catch (e) {
            return u;
          }
          return C ? (C.toJD() - g) * d + L * f + D * h + S * p : u;
        }
        T = 2 === T.length ? (Number(T) + 2e3 - b) % 100 + b : Number(T), k -= 1;
        var I = new Date(Date.UTC(2e3, k, A, L, D));
        return I.setUTCFullYear(T), I.getUTCMonth() !== k || I.getUTCDate() !== A ? u : I.getTime() + S * p;
      }, n = r.MIN_MS = r.dateTime2ms("-9999"), a = r.MAX_MS = r.dateTime2ms("9999-12-31 23:59:59.9999"), r.isDateTime = function (e, t) {
        return r.dateTime2ms(e, t) !== u;
      };
      var M = 90 * d,
        T = 3 * f,
        k = 5 * h;
      function A(e, t, r, n, a) {
        if ((t || r || n || a) && (e += " " + w(t, 2) + ":" + w(r, 2), (n || a) && (e += ":" + w(n, 2), a))) {
          for (var i = 4; a % 10 == 0;) i -= 1, a /= 10;
          e += "." + w(a, i);
        }
        return e;
      }
      r.ms2DateTime = function (e, t, r) {
        if ("number" != typeof e || !(e >= n && e <= a)) return u;
        t || (t = 0);
        var i,
          o,
          l,
          c,
          v,
          x,
          b = Math.floor(10 * s(e + .05, 1)),
          w = Math.round(e - b / 10);
        if (_(r)) {
          var L = Math.floor(w / d) + g,
            D = Math.floor(s(e, d));
          try {
            i = m.getComponentMethod("calendars", "getCal")(r).fromJD(L).formatDate("yyyy-mm-dd");
          } catch (e) {
            i = y("G%Y-%m-%d")(new Date(w));
          }
          if ("-" === i.charAt(0)) for (; i.length < 11;) i = "-0" + i.substr(1);else for (; i.length < 10;) i = "0" + i;
          o = t < M ? Math.floor(D / f) : 0, l = t < M ? Math.floor(D % f / h) : 0, c = t < T ? Math.floor(D % h / p) : 0, v = t < k ? D % p * 10 + b : 0;
        } else x = new Date(w), i = y("%Y-%m-%d")(x), o = t < M ? x.getUTCHours() : 0, l = t < M ? x.getUTCMinutes() : 0, c = t < T ? x.getUTCSeconds() : 0, v = t < k ? 10 * x.getUTCMilliseconds() + b : 0;
        return A(i, o, l, c, v);
      }, r.ms2DateTimeLocal = function (e) {
        if (!(e >= n + d && e <= a - d)) return u;
        var t = Math.floor(10 * s(e + .05, 1)),
          r = new Date(Math.round(e - t / 10));
        return A(i("%Y-%m-%d")(r), r.getHours(), r.getMinutes(), r.getSeconds(), 10 * r.getUTCMilliseconds() + t);
      }, r.cleanDate = function (e, t, n) {
        if (e === u) return t;
        if (r.isJSDate(e) || "number" == typeof e && isFinite(e)) {
          if (_(n)) return l.error("JS Dates and milliseconds are incompatible with world calendars", e), t;
          if (!(e = r.ms2DateTimeLocal(+e)) && void 0 !== t) return t;
        } else if (!r.isDateTime(e, n)) return l.error("unrecognized date", e), t;
        return e;
      };
      var L = /%\d?f/g,
        D = /%h/g,
        S = {
          1: "1",
          2: "1",
          3: "2",
          4: "2"
        };
      function C(e, t, r, n) {
        e = e.replace(L, function (e) {
          var r = Math.min(+e.charAt(1) || 6, 6);
          return (t / 1e3 % 1 + 2).toFixed(r).substr(2).replace(/0+$/, "") || "0";
        });
        var a = new Date(Math.floor(t + .05));
        if (e = e.replace(D, function () {
          return S[r("%q")(a)];
        }), _(n)) try {
          e = m.getComponentMethod("calendars", "worldCalFmt")(e, t, n);
        } catch (e) {
          return "Invalid";
        }
        return r(e)(a);
      }
      var O = [59, 59.9, 59.99, 59.999, 59.9999];
      r.formatDate = function (e, t, r, n, a, i) {
        if (a = _(a) && a, !t) if ("y" === r) t = i.year;else if ("m" === r) t = i.month;else {
          if ("d" !== r) return function (e, t) {
            var r = s(e + .05, d),
              n = w(Math.floor(r / f), 2) + ":" + w(s(Math.floor(r / h), 60), 2);
            if ("M" !== t) {
              o(t) || (t = 0);
              var a = (100 + Math.min(s(e / p, 60), O[t])).toFixed(t).substr(1);
              t > 0 && (a = a.replace(/0+$/, "").replace(/[\.]$/, "")), n += ":" + a;
            }
            return n;
          }(e, r) + "\n" + C(i.dayMonthYear, e, n, a);
          t = i.dayMonth + "\n" + i.year;
        }
        return C(t, e, n, a);
      };
      var P = 3 * d;
      r.incrementMonth = function (e, t, r) {
        r = _(r) && r;
        var n = s(e, d);
        if (e = Math.round(e - n), r) try {
          var a = Math.round(e / d) + g,
            i = m.getComponentMethod("calendars", "getCal")(r),
            o = i.fromJD(a);
          return t % 12 ? i.add(o, t, "m") : i.add(o, t / 12, "y"), (o.toJD() - g) * d + n;
        } catch (t) {
          l.error("invalid ms " + e + " in calendar " + r);
        }
        var c = new Date(e + P);
        return c.setUTCMonth(c.getUTCMonth() + t) + n - P;
      }, r.findExactDates = function (e, t) {
        for (var r, n, a = 0, i = 0, l = 0, s = 0, c = _(t) && m.getComponentMethod("calendars", "getCal")(t), u = 0; u < e.length; u++) if (n = e[u], o(n)) {
          if (!(n % d)) if (c) try {
            1 === (r = c.fromJD(n / d + g)).day() ? 1 === r.month() ? a++ : i++ : l++;
          } catch (e) {} else 1 === (r = new Date(n)).getUTCDate() ? 0 === r.getUTCMonth() ? a++ : i++ : l++;
        } else s++;
        l += i += a;
        var f = e.length - s;
        return {
          exactYears: a / f,
          exactMonths: i / f,
          exactDays: l / f
        };
      };
    }, {
      "../constants/numerical": 205,
      "../registry": 309,
      "./loggers": 229,
      "./mod": 232,
      "d3-time-format": 8,
      "fast-isnumeric": 11
    }],
    217: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("./loggers"),
        i = e("./matrix"),
        o = e("gl-mat4");
      function l(e) {
        var t = e && e.parentNode;
        t && t.removeChild(e);
      }
      function s(e, t, r) {
        var n = "plotly.js-style-" + e,
          i = document.getElementById(n);
        i || ((i = document.createElement("style")).setAttribute("id", n), i.appendChild(document.createTextNode("")), document.head.appendChild(i));
        var o = i.sheet;
        o.insertRule ? o.insertRule(t + "{" + r + "}", 0) : o.addRule ? o.addRule(t, r, 0) : a.warn("addStyleRule failed");
      }
      function c(e) {
        var t = window.getComputedStyle(e, null),
          r = t.getPropertyValue("-webkit-transform") || t.getPropertyValue("-moz-transform") || t.getPropertyValue("-ms-transform") || t.getPropertyValue("-o-transform") || t.getPropertyValue("transform");
        return "none" === r ? null : r.replace("matrix", "").replace("3d", "").slice(1, -1).split(",").map(function (e) {
          return +e;
        });
      }
      function u(e) {
        for (var t = []; d(e);) t.push(e), e = e.parentNode;
        return t;
      }
      function d(e) {
        return e && (e instanceof Element || e instanceof HTMLElement);
      }
      t.exports = {
        getGraphDiv: function getGraphDiv(e) {
          var t;
          if ("string" == typeof e) {
            if (null === (t = document.getElementById(e))) throw new Error("No DOM element with id '" + e + "' exists on the page.");
            return t;
          }
          if (null == e) throw new Error("DOM element provided is null or undefined");
          return e;
        },
        isPlotDiv: function isPlotDiv(e) {
          var t = n.select(e);
          return t.node() instanceof HTMLElement && t.size() && t.classed("js-plotly-plot");
        },
        removeElement: l,
        addStyleRule: function addStyleRule(e, t) {
          s("global", e, t);
        },
        addRelatedStyleRule: s,
        deleteRelatedStyleRule: function deleteRelatedStyleRule(e) {
          var t = "plotly.js-style-" + e,
            r = document.getElementById(t);
          r && l(r);
        },
        getFullTransformMatrix: function getFullTransformMatrix(e) {
          var t = u(e),
            r = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
          return t.forEach(function (e) {
            var t = c(e);
            if (t) {
              var n = i.convertCssMatrix(t);
              r = o.multiply(r, r, n);
            }
          }), r;
        },
        getElementTransformMatrix: c,
        getElementAndAncestors: u,
        equalDomRects: function equalDomRects(e, t) {
          return e && t && e.x === t.x && e.y === t.y && e.top === t.top && e.left === t.left && e.right === t.right && e.bottom === t.bottom;
        }
      };
    }, {
      "./loggers": 229,
      "./matrix": 231,
      "@plotly/d3": 6,
      "gl-mat4": 27
    }],
    218: [function (e, t, r) {
      "use strict";

      var n = e("events").EventEmitter,
        a = {
          init: function init(e) {
            if (e._ev instanceof n) return e;
            var t = new n(),
              r = new n();
            return e._ev = t, e._internalEv = r, e.on = t.on.bind(t), e.once = t.once.bind(t), e.removeListener = t.removeListener.bind(t), e.removeAllListeners = t.removeAllListeners.bind(t), e._internalOn = r.on.bind(r), e._internalOnce = r.once.bind(r), e._removeInternalListener = r.removeListener.bind(r), e._removeAllInternalListeners = r.removeAllListeners.bind(r), e.emit = function (n, a) {
              "undefined" != typeof jQuery && jQuery(e).trigger(n, a), t.emit(n, a), r.emit(n, a);
            }, e;
          },
          triggerHandler: function triggerHandler(e, t, r) {
            var n, a;
            "undefined" != typeof jQuery && (n = jQuery(e).triggerHandler(t, r));
            var i = e._ev;
            if (!i) return n;
            var o,
              l = i._events[t];
            if (!l) return n;
            function s(e) {
              return e.listener ? (i.removeListener(t, e.listener), e.fired ? void 0 : (e.fired = !0, e.listener.apply(i, [r]))) : e.apply(i, [r]);
            }
            for (l = Array.isArray(l) ? l : [l], o = 0; o < l.length - 1; o++) s(l[o]);
            return a = s(l[o]), void 0 !== n ? n : a;
          },
          purge: function purge(e) {
            return delete e._ev, delete e.on, delete e.once, delete e.removeListener, delete e.removeAllListeners, delete e.emit, delete e._ev, delete e._internalEv, delete e._internalOn, delete e._internalOnce, delete e._removeInternalListener, delete e._removeAllInternalListeners, e;
          }
        };
      t.exports = a;
    }, {
      events: 10
    }],
    219: [function (e, t, r) {
      "use strict";

      var n = e("./is_plain_object.js"),
        a = Array.isArray;
      function i(e, t, r, o) {
        var l,
          s,
          c,
          u,
          d,
          f,
          h = e[0],
          p = e.length;
        if (2 === p && a(h) && a(e[1]) && 0 === h.length) {
          if (function (e, t) {
            var r, n;
            for (r = 0; r < e.length; r++) {
              if (null !== (n = e[r]) && "object" == typeof n) return !1;
              void 0 !== n && (t[r] = n);
            }
            return !0;
          }(e[1], h)) return h;
          h.splice(0, h.length);
        }
        for (var g = 1; g < p; g++) for (s in l = e[g]) c = h[s], u = l[s], o && a(u) ? h[s] = u : t && u && (n(u) || (d = a(u))) ? (d ? (d = !1, f = c && a(c) ? c : []) : f = c && n(c) ? c : {}, h[s] = i([f, u], t, r, o)) : (void 0 !== u || r) && (h[s] = u);
        return h;
      }
      r.extendFlat = function () {
        return i(arguments, !1, !1, !1);
      }, r.extendDeep = function () {
        return i(arguments, !0, !1, !1);
      }, r.extendDeepAll = function () {
        return i(arguments, !0, !0, !1);
      }, r.extendDeepNoArrays = function () {
        return i(arguments, !0, !1, !0);
      };
    }, {
      "./is_plain_object.js": 226
    }],
    220: [function (e, t, r) {
      "use strict";

      t.exports = function (e) {
        for (var t = {}, r = [], n = 0, a = 0; a < e.length; a++) {
          var i = e[a];
          1 !== t[i] && (t[i] = 1, r[n++] = i);
        }
        return r;
      };
    }, {}],
    221: [function (e, t, r) {
      "use strict";

      function n(e) {
        return !0 === e.visible;
      }
      function a(e) {
        var t = e[0].trace;
        return !0 === t.visible && 0 !== t._length;
      }
      t.exports = function (e) {
        for (var t, r = (t = e, Array.isArray(t) && Array.isArray(t[0]) && t[0][0] && t[0][0].trace ? a : n), i = [], o = 0; o < e.length; o++) {
          var l = e[o];
          r(l) && i.push(l);
        }
        return i;
      };
    }, {}],
    222: [function (e, t, r) {
      "use strict";

      var n,
        a,
        i,
        o = e("./mod").mod;
      function l(e, t, r, n, a, i, o, l) {
        var s = r - e,
          c = a - e,
          u = o - a,
          d = n - t,
          f = i - t,
          h = l - i,
          p = s * h - u * d;
        if (0 === p) return null;
        var g = (c * h - u * f) / p,
          m = (c * d - s * f) / p;
        return m < 0 || m > 1 || g < 0 || g > 1 ? null : {
          x: e + s * g,
          y: t + d * g
        };
      }
      function s(e, t, r, n, a) {
        var i = n * e + a * t;
        if (i < 0) return n * n + a * a;
        if (i > r) {
          var o = n - e,
            l = a - t;
          return o * o + l * l;
        }
        var s = n * t - a * e;
        return s * s / r;
      }
      r.segmentsIntersect = l, r.segmentDistance = function (e, t, r, n, a, i, o, c) {
        if (l(e, t, r, n, a, i, o, c)) return 0;
        var u = r - e,
          d = n - t,
          f = o - a,
          h = c - i,
          p = u * u + d * d,
          g = f * f + h * h,
          m = Math.min(s(u, d, p, a - e, i - t), s(u, d, p, o - e, c - t), s(f, h, g, e - a, t - i), s(f, h, g, r - a, n - i));
        return Math.sqrt(m);
      }, r.getTextLocation = function (e, t, r, l) {
        if (e === a && l === i || (n = {}, a = e, i = l), n[r]) return n[r];
        var s = e.getPointAtLength(o(r - l / 2, t)),
          c = e.getPointAtLength(o(r + l / 2, t)),
          u = Math.atan((c.y - s.y) / (c.x - s.x)),
          d = e.getPointAtLength(o(r, t)),
          f = {
            x: (4 * d.x + s.x + c.x) / 6,
            y: (4 * d.y + s.y + c.y) / 6,
            theta: u
          };
        return n[r] = f, f;
      }, r.clearLocationCache = function () {
        a = null;
      }, r.getVisibleSegment = function (e, t, r) {
        var n,
          a,
          i = t.left,
          o = t.right,
          l = t.top,
          s = t.bottom,
          c = 0,
          u = e.getTotalLength(),
          d = u;
        function f(t) {
          var r = e.getPointAtLength(t);
          0 === t ? n = r : t === u && (a = r);
          var c = r.x < i ? i - r.x : r.x > o ? r.x - o : 0,
            d = r.y < l ? l - r.y : r.y > s ? r.y - s : 0;
          return Math.sqrt(c * c + d * d);
        }
        for (var h = f(c); h;) {
          if ((c += h + r) > d) return;
          h = f(c);
        }
        for (h = f(d); h;) {
          if (c > (d -= h + r)) return;
          h = f(d);
        }
        return {
          min: c,
          max: d,
          len: d - c,
          total: u,
          isClosed: 0 === c && d === u && Math.abs(n.x - a.x) < .1 && Math.abs(n.y - a.y) < .1
        };
      }, r.findPointOnPath = function (e, t, r, n) {
        for (var a, i, o, l = (n = n || {}).pathLength || e.getTotalLength(), s = n.tolerance || .001, c = n.iterationLimit || 30, u = e.getPointAtLength(0)[r] > e.getPointAtLength(l)[r] ? -1 : 1, d = 0, f = 0, h = l; d < c;) {
          if (a = (f + h) / 2, o = (i = e.getPointAtLength(a))[r] - t, Math.abs(o) < s) return i;
          u * o > 0 ? h = a : f = a, d++;
        }
        return i;
      };
    }, {
      "./mod": 232
    }],
    223: [function (e, t, r) {
      "use strict";

      t.exports = function (e) {
        return e;
      };
    }, {}],
    224: [function (e, t, r) {
      "use strict";

      t.exports = function (e, t) {
        if (!t) return e;
        var r = 1 / Math.abs(t),
          n = r > 1 ? (r * e + r * t) / r : e + t,
          a = String(n).length;
        if (a > 16) {
          var i = String(t).length;
          if (a >= String(e).length + i) {
            var o = parseFloat(n).toPrecision(12);
            -1 === o.indexOf("e+") && (n = +o);
          }
        }
        return n;
      };
    }, {}],
    225: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("d3-time-format").utcFormat,
        i = e("d3-format").format,
        o = e("fast-isnumeric"),
        l = e("../constants/numerical"),
        s = l.FP_SAFE,
        c = -s,
        u = l.BADNUM,
        d = t.exports = {};
      d.adjustFormat = function (e) {
        return !e || /^\d[.]\df/.test(e) || /[.]\d%/.test(e) ? e : "0.f" === e ? "~f" : /^\d%/.test(e) ? "~%" : /^\ds/.test(e) ? "~s" : !/^[~,.0$]/.test(e) && /[&fps]/.test(e) ? "~" + e : e;
      };
      var f = {};
      d.warnBadFormat = function (e) {
        var t = String(e);
        f[t] || (f[t] = 1, d.warn('encountered bad format: "' + t + '"'));
      }, d.noFormat = function (e) {
        return String(e);
      }, d.numberFormat = function (e) {
        var t;
        try {
          t = i(d.adjustFormat(e));
        } catch (t) {
          return d.warnBadFormat(e), d.noFormat;
        }
        return t;
      }, d.nestedProperty = e("./nested_property"), d.keyedContainer = e("./keyed_container"), d.relativeAttr = e("./relative_attr"), d.isPlainObject = e("./is_plain_object"), d.toLogRange = e("./to_log_range"), d.relinkPrivateKeys = e("./relink_private");
      var h = e("./array");
      d.isTypedArray = h.isTypedArray, d.isArrayOrTypedArray = h.isArrayOrTypedArray, d.isArray1D = h.isArray1D, d.ensureArray = h.ensureArray, d.concat = h.concat, d.maxRowLength = h.maxRowLength, d.minRowLength = h.minRowLength;
      var p = e("./mod");
      d.mod = p.mod, d.modHalf = p.modHalf;
      var g = e("./coerce");
      d.valObjectMeta = g.valObjectMeta, d.coerce = g.coerce, d.coerce2 = g.coerce2, d.coerceFont = g.coerceFont, d.coercePattern = g.coercePattern, d.coerceHoverinfo = g.coerceHoverinfo, d.coerceSelectionMarkerOpacity = g.coerceSelectionMarkerOpacity, d.validate = g.validate;
      var m = e("./dates");
      d.dateTime2ms = m.dateTime2ms, d.isDateTime = m.isDateTime, d.ms2DateTime = m.ms2DateTime, d.ms2DateTimeLocal = m.ms2DateTimeLocal, d.cleanDate = m.cleanDate, d.isJSDate = m.isJSDate, d.formatDate = m.formatDate, d.incrementMonth = m.incrementMonth, d.dateTick0 = m.dateTick0, d.dfltRange = m.dfltRange, d.findExactDates = m.findExactDates, d.MIN_MS = m.MIN_MS, d.MAX_MS = m.MAX_MS;
      var y = e("./search");
      d.findBin = y.findBin, d.sorterAsc = y.sorterAsc, d.sorterDes = y.sorterDes, d.distinctVals = y.distinctVals, d.roundUp = y.roundUp, d.sort = y.sort, d.findIndexOfMin = y.findIndexOfMin, d.sortObjectKeys = e("./sort_object_keys");
      var v = e("./stats");
      d.aggNums = v.aggNums, d.len = v.len, d.mean = v.mean, d.median = v.median, d.midRange = v.midRange, d.variance = v.variance, d.stdev = v.stdev, d.interp = v.interp;
      var x = e("./matrix");
      d.init2dArray = x.init2dArray, d.transposeRagged = x.transposeRagged, d.dot = x.dot, d.translationMatrix = x.translationMatrix, d.rotationMatrix = x.rotationMatrix, d.rotationXYMatrix = x.rotationXYMatrix, d.apply3DTransform = x.apply3DTransform, d.apply2DTransform = x.apply2DTransform, d.apply2DTransform2 = x.apply2DTransform2, d.convertCssMatrix = x.convertCssMatrix, d.inverseTransformMatrix = x.inverseTransformMatrix;
      var b = e("./angles");
      d.deg2rad = b.deg2rad, d.rad2deg = b.rad2deg, d.angleDelta = b.angleDelta, d.angleDist = b.angleDist, d.isFullCircle = b.isFullCircle, d.isAngleInsideSector = b.isAngleInsideSector, d.isPtInsideSector = b.isPtInsideSector, d.pathArc = b.pathArc, d.pathSector = b.pathSector, d.pathAnnulus = b.pathAnnulus;
      var _ = e("./anchor_utils");
      d.isLeftAnchor = _.isLeftAnchor, d.isCenterAnchor = _.isCenterAnchor, d.isRightAnchor = _.isRightAnchor, d.isTopAnchor = _.isTopAnchor, d.isMiddleAnchor = _.isMiddleAnchor, d.isBottomAnchor = _.isBottomAnchor;
      var w = e("./geometry2d");
      d.segmentsIntersect = w.segmentsIntersect, d.segmentDistance = w.segmentDistance, d.getTextLocation = w.getTextLocation, d.clearLocationCache = w.clearLocationCache, d.getVisibleSegment = w.getVisibleSegment, d.findPointOnPath = w.findPointOnPath;
      var M = e("./extend");
      d.extendFlat = M.extendFlat, d.extendDeep = M.extendDeep, d.extendDeepAll = M.extendDeepAll, d.extendDeepNoArrays = M.extendDeepNoArrays;
      var T = e("./loggers");
      d.log = T.log, d.warn = T.warn, d.error = T.error;
      var k = e("./regex");
      d.counterRegex = k.counter;
      var A = e("./throttle");
      d.throttle = A.throttle, d.throttleDone = A.done, d.clearThrottle = A.clear;
      var L = e("./dom");
      function D(e) {
        var t = {};
        for (var r in e) for (var n = e[r], a = 0; a < n.length; a++) t[n[a]] = +r;
        return t;
      }
      d.getGraphDiv = L.getGraphDiv, d.isPlotDiv = L.isPlotDiv, d.removeElement = L.removeElement, d.addStyleRule = L.addStyleRule, d.addRelatedStyleRule = L.addRelatedStyleRule, d.deleteRelatedStyleRule = L.deleteRelatedStyleRule, d.getFullTransformMatrix = L.getFullTransformMatrix, d.getElementTransformMatrix = L.getElementTransformMatrix, d.getElementAndAncestors = L.getElementAndAncestors, d.equalDomRects = L.equalDomRects, d.clearResponsive = e("./clear_responsive"), d.preserveDrawingBuffer = e("./preserve_drawing_buffer"), d.makeTraceGroups = e("./make_trace_groups"), d._ = e("./localize"), d.notifier = e("./notifier"), d.filterUnique = e("./filter_unique"), d.filterVisible = e("./filter_visible"), d.pushUnique = e("./push_unique"), d.increment = e("./increment"), d.cleanNumber = e("./clean_number"), d.ensureNumber = function (e) {
        return o(e) ? (e = Number(e)) > s || e < c ? u : e : u;
      }, d.isIndex = function (e, t) {
        return !(void 0 !== t && e >= t) && o(e) && e >= 0 && e % 1 == 0;
      }, d.noop = e("./noop"), d.identity = e("./identity"), d.repeat = function (e, t) {
        for (var r = new Array(t), n = 0; n < t; n++) r[n] = e;
        return r;
      }, d.swapAttrs = function (e, t, r, n) {
        r || (r = "x"), n || (n = "y");
        for (var a = 0; a < t.length; a++) {
          var i = t[a],
            o = d.nestedProperty(e, i.replace("?", r)),
            l = d.nestedProperty(e, i.replace("?", n)),
            s = o.get();
          o.set(l.get()), l.set(s);
        }
      }, d.raiseToTop = function (e) {
        e.parentNode.appendChild(e);
      }, d.cancelTransition = function (e) {
        return e.transition().duration(0);
      }, d.constrain = function (e, t, r) {
        return t > r ? Math.max(r, Math.min(t, e)) : Math.max(t, Math.min(r, e));
      }, d.bBoxIntersect = function (e, t, r) {
        return r = r || 0, e.left <= t.right + r && t.left <= e.right + r && e.top <= t.bottom + r && t.top <= e.bottom + r;
      }, d.simpleMap = function (e, t, r, n, a) {
        for (var i = e.length, o = new Array(i), l = 0; l < i; l++) o[l] = t(e[l], r, n, a);
        return o;
      }, d.randstr = function e(t, r, n, a) {
        if (n || (n = 16), void 0 === r && (r = 24), r <= 0) return "0";
        var i,
          o,
          l = Math.log(Math.pow(2, r)) / Math.log(n),
          s = "";
        for (i = 2; l === 1 / 0; i *= 2) l = Math.log(Math.pow(2, r / i)) / Math.log(n) * i;
        var c = l - Math.floor(l);
        for (i = 0; i < Math.floor(l); i++) s = Math.floor(Math.random() * n).toString(n) + s;
        c && (o = Math.pow(n, c), s = Math.floor(Math.random() * o).toString(n) + s);
        var u = parseInt(s, n);
        return t && t[s] || u !== 1 / 0 && u >= Math.pow(2, r) ? a > 10 ? (d.warn("randstr failed uniqueness"), s) : e(t, r, n, (a || 0) + 1) : s;
      }, d.OptionControl = function (e, t) {
        e || (e = {}), t || (t = "opt");
        var r = {
          optionList: [],
          _newoption: function _newoption(n) {
            n[t] = e, r[n.name] = n, r.optionList.push(n);
          }
        };
        return r["_" + t] = e, r;
      }, d.smooth = function (e, t) {
        if ((t = Math.round(t) || 0) < 2) return e;
        var r,
          n,
          a,
          i,
          o = e.length,
          l = 2 * o,
          s = 2 * t - 1,
          c = new Array(s),
          u = new Array(o);
        for (r = 0; r < s; r++) c[r] = (1 - Math.cos(Math.PI * (r + 1) / t)) / (2 * t);
        for (r = 0; r < o; r++) {
          for (i = 0, n = 0; n < s; n++) (a = r + n + 1 - t) < -o ? a -= l * Math.round(a / l) : a >= l && (a -= l * Math.floor(a / l)), a < 0 ? a = -1 - a : a >= o && (a = l - 1 - a), i += e[a] * c[n];
          u[r] = i;
        }
        return u;
      }, d.syncOrAsync = function (e, t, r) {
        var n;
        function a() {
          return d.syncOrAsync(e, t, r);
        }
        for (; e.length;) if ((n = (0, e.splice(0, 1)[0])(t)) && n.then) return n.then(a);
        return r && r(t);
      }, d.stripTrailingSlash = function (e) {
        return "/" === e.substr(-1) ? e.substr(0, e.length - 1) : e;
      }, d.noneOrAll = function (e, t, r) {
        if (e) {
          var n,
            a = !1,
            i = !0;
          for (n = 0; n < r.length; n++) null != e[r[n]] ? a = !0 : i = !1;
          if (a && !i) for (n = 0; n < r.length; n++) e[r[n]] = t[r[n]];
        }
      }, d.mergeArray = function (e, t, r, n) {
        var a = "function" == typeof n;
        if (d.isArrayOrTypedArray(e)) for (var i = Math.min(e.length, t.length), o = 0; o < i; o++) {
          var l = e[o];
          t[o][r] = a ? n(l) : l;
        }
      }, d.mergeArrayCastPositive = function (e, t, r) {
        return d.mergeArray(e, t, r, function (e) {
          var t = +e;
          return isFinite(t) && t > 0 ? t : 0;
        });
      }, d.fillArray = function (e, t, r, n) {
        if (n = n || d.identity, d.isArrayOrTypedArray(e)) for (var a = 0; a < t.length; a++) t[a][r] = n(e[a]);
      }, d.castOption = function (e, t, r, n) {
        n = n || d.identity;
        var a = d.nestedProperty(e, r).get();
        return d.isArrayOrTypedArray(a) ? Array.isArray(t) && d.isArrayOrTypedArray(a[t[0]]) ? n(a[t[0]][t[1]]) : n(a[t]) : a;
      }, d.extractOption = function (e, t, r, n) {
        if (r in e) return e[r];
        var a = d.nestedProperty(t, n).get();
        return Array.isArray(a) ? void 0 : a;
      }, d.tagSelected = function (e, t, r) {
        var n,
          a,
          i = t.selectedpoints,
          o = t._indexToPoints;
        o && (n = D(o));
        for (var l = 0; l < i.length; l++) {
          var s = i[l];
          if (d.isIndex(s) || d.isArrayOrTypedArray(s) && d.isIndex(s[0]) && d.isIndex(s[1])) {
            var c = n ? n[s] : s,
              u = r ? r[c] : c;
            void 0 !== (a = u) && a < e.length && (e[u].selected = 1);
          }
        }
      }, d.selIndices2selPoints = function (e) {
        var t = e.selectedpoints,
          r = e._indexToPoints;
        if (r) {
          for (var n = D(r), a = [], i = 0; i < t.length; i++) {
            var o = t[i];
            if (d.isIndex(o)) {
              var l = n[o];
              d.isIndex(l) && a.push(l);
            }
          }
          return a;
        }
        return t;
      }, d.getTargetArray = function (e, t) {
        var r = t.target;
        if ("string" == typeof r && r) {
          var n = d.nestedProperty(e, r).get();
          return !!Array.isArray(n) && n;
        }
        return !!Array.isArray(r) && r;
      }, d.minExtend = function (e, t) {
        var r = {};
        "object" != typeof t && (t = {});
        var n,
          a,
          i,
          o = Object.keys(e);
        for (n = 0; n < o.length; n++) i = e[a = o[n]], "_" !== a.charAt(0) && "function" != typeof i && ("module" === a ? r[a] = i : Array.isArray(i) ? r[a] = "colorscale" === a ? i.slice() : i.slice(0, 3) : d.isTypedArray(i) ? r[a] = i.subarray(0, 3) : r[a] = i && "object" == typeof i ? d.minExtend(e[a], t[a]) : i);
        for (o = Object.keys(t), n = 0; n < o.length; n++) "object" == typeof (i = t[a = o[n]]) && a in r && "object" == typeof r[a] || (r[a] = i);
        return r;
      }, d.titleCase = function (e) {
        return e.charAt(0).toUpperCase() + e.substr(1);
      }, d.containsAny = function (e, t) {
        for (var r = 0; r < t.length; r++) if (-1 !== e.indexOf(t[r])) return !0;
        return !1;
      }, d.isIE = function () {
        return void 0 !== window.navigator.msSaveBlob;
      };
      var S = /Version\/[\d\.]+.*Safari/;
      d.isSafari = function () {
        return S.test(window.navigator.userAgent);
      };
      var C = /iPad|iPhone|iPod/;
      d.isIOS = function () {
        return C.test(window.navigator.userAgent);
      };
      var O = /Firefox\/(\d+)\.\d+/;
      d.getFirefoxVersion = function () {
        var e = O.exec(window.navigator.userAgent);
        if (e && 2 === e.length) {
          var t = parseInt(e[1]);
          if (!isNaN(t)) return t;
        }
        return null;
      }, d.isD3Selection = function (e) {
        return e instanceof n.selection;
      }, d.ensureSingle = function (e, t, r, n) {
        var a = e.select(t + (r ? "." + r : ""));
        if (a.size()) return a;
        var i = e.append(t);
        return r && i.classed(r, !0), n && i.call(n), i;
      }, d.ensureSingleById = function (e, t, r, n) {
        var a = e.select(t + "#" + r);
        if (a.size()) return a;
        var i = e.append(t).attr("id", r);
        return n && i.call(n), i;
      }, d.objectFromPath = function (e, t) {
        for (var r, n = e.split("."), a = r = {}, i = 0; i < n.length; i++) {
          var o = n[i],
            l = null,
            s = n[i].match(/(.*)\[([0-9]+)\]/);
          s ? (o = s[1], l = s[2], r = r[o] = [], i === n.length - 1 ? r[l] = t : r[l] = {}, r = r[l]) : (i === n.length - 1 ? r[o] = t : r[o] = {}, r = r[o]);
        }
        return a;
      };
      var P = /^([^\[\.]+)\.(.+)?/,
        I = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
      d.expandObjectPaths = function (e) {
        var t, r, n, a, i, o, l;
        if ("object" == typeof e && !Array.isArray(e)) for (r in e) e.hasOwnProperty(r) && ((t = r.match(P)) ? (a = e[r], n = t[1], delete e[r], e[n] = d.extendDeepNoArrays(e[n] || {}, d.objectFromPath(r, d.expandObjectPaths(a))[n])) : (t = r.match(I)) ? (a = e[r], n = t[1], i = parseInt(t[2]), delete e[r], e[n] = e[n] || [], "." === t[3] ? (l = t[4], o = e[n][i] = e[n][i] || {}, d.extendDeepNoArrays(o, d.objectFromPath(l, d.expandObjectPaths(a)))) : e[n][i] = d.expandObjectPaths(a)) : e[r] = d.expandObjectPaths(e[r]));
        return e;
      }, d.numSeparate = function (e, t, r) {
        if (r || (r = !1), "string" != typeof t || 0 === t.length) throw new Error("Separator string required for formatting!");
        "number" == typeof e && (e = String(e));
        var n = /(\d+)(\d{3})/,
          a = t.charAt(0),
          i = t.charAt(1),
          o = e.split("."),
          l = o[0],
          s = o.length > 1 ? a + o[1] : "";
        if (i && (o.length > 1 || l.length > 4 || r)) for (; n.test(l);) l = l.replace(n, "$1" + i + "$2");
        return l + s;
      }, d.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
      var z = /^\w*$/;
      d.templateString = function (e, t) {
        var r = {};
        return e.replace(d.TEMPLATE_STRING_REGEX, function (e, n) {
          var a;
          return z.test(n) ? a = t[n] : (r[n] = r[n] || d.nestedProperty(t, n).get, a = r[n]()), d.isValidTextValue(a) ? a : "";
        });
      };
      var R = {
        max: 10,
        count: 0,
        name: "hovertemplate"
      };
      d.hovertemplateString = function () {
        return E.apply(R, arguments);
      };
      var N = {
        max: 10,
        count: 0,
        name: "texttemplate"
      };
      d.texttemplateString = function () {
        return E.apply(N, arguments);
      };
      var F = /^[:|\|]/;
      function E(e, t, r) {
        var n = this,
          i = arguments;
        t || (t = {});
        var o = {};
        return e.replace(d.TEMPLATE_STRING_REGEX, function (e, l, s) {
          var c,
            u,
            f,
            h = "_xother" === l || "_yother" === l,
            p = "_xother_" === l || "_yother_" === l,
            g = "xother_" === l || "yother_" === l,
            m = "xother" === l || "yother" === l || h || g || p,
            y = l;
          if ((h || p) && (y = y.substring(1)), (g || p) && (y = y.substring(0, y.length - 1)), m) {
            if (void 0 === (c = t[y])) return "";
          } else for (f = 3; f < i.length; f++) if (u = i[f]) {
            if (u.hasOwnProperty(y)) {
              c = u[y];
              break;
            }
            if (z.test(y) || (c = d.nestedProperty(u, y).get(), (c = o[y] || d.nestedProperty(u, y).get()) && (o[y] = c)), void 0 !== c) break;
          }
          if (void 0 === c && n) return n.count < n.max && (d.warn("Variable '" + y + "' in " + n.name + " could not be found!"), c = e), n.count === n.max && d.warn("Too many " + n.name + " warnings - additional warnings will be suppressed"), n.count++, e;
          if (s) {
            var v;
            if (":" === s[0] && (c = (v = r ? r.numberFormat : d.numberFormat)(s.replace(F, ""))(c)), "|" === s[0]) {
              v = r ? r.timeFormat : a;
              var x = d.dateTime2ms(c);
              c = d.formatDate(x, s.replace(F, ""), !1, v);
            }
          } else {
            var b = y + "Label";
            t.hasOwnProperty(b) && (c = t[b]);
          }
          return m && (c = "(" + c + ")", (h || p) && (c = " " + c), (g || p) && (c += " ")), c;
        });
      }
      d.subplotSort = function (e, t) {
        for (var r = Math.min(e.length, t.length) + 1, n = 0, a = 0, i = 0; i < r; i++) {
          var o = e.charCodeAt(i) || 0,
            l = t.charCodeAt(i) || 0,
            s = o >= 48 && o <= 57,
            c = l >= 48 && l <= 57;
          if (s && (n = 10 * n + o - 48), c && (a = 10 * a + l - 48), !s || !c) {
            if (n !== a) return n - a;
            if (o !== l) return o - l;
          }
        }
        return a - n;
      };
      var j = 2e9;
      d.seedPseudoRandom = function () {
        j = 2e9;
      }, d.pseudoRandom = function () {
        var e = j;
        return j = (69069 * j + 1) % 4294967296, Math.abs(j - e) < 429496729 ? d.pseudoRandom() : j / 4294967296;
      }, d.fillText = function (e, t, r) {
        var n = Array.isArray(r) ? function (e) {
            r.push(e);
          } : function (e) {
            r.text = e;
          },
          a = d.extractOption(e, t, "htx", "hovertext");
        if (d.isValidTextValue(a)) return n(a);
        var i = d.extractOption(e, t, "tx", "text");
        return d.isValidTextValue(i) ? n(i) : void 0;
      }, d.isValidTextValue = function (e) {
        return e || 0 === e;
      }, d.formatPercent = function (e, t) {
        t = t || 0;
        for (var r = (Math.round(100 * e * Math.pow(10, t)) * Math.pow(.1, t)).toFixed(t) + "%", n = 0; n < t; n++) -1 !== r.indexOf(".") && (r = (r = r.replace("0%", "%")).replace(".%", "%"));
        return r;
      }, d.isHidden = function (e) {
        var t = window.getComputedStyle(e).display;
        return !t || "none" === t;
      }, d.strTranslate = function (e, t) {
        return e || t ? "translate(" + e + "," + t + ")" : "";
      }, d.strRotate = function (e) {
        return e ? "rotate(" + e + ")" : "";
      }, d.strScale = function (e) {
        return 1 !== e ? "scale(" + e + ")" : "";
      }, d.getTextTransform = function (e) {
        var t = e.noCenter,
          r = e.textX,
          n = e.textY,
          a = e.targetX,
          i = e.targetY,
          o = e.anchorX || 0,
          l = e.anchorY || 0,
          s = e.rotate,
          c = e.scale;
        return c ? c > 1 && (c = 1) : c = 0, d.strTranslate(a - c * (r + o), i - c * (n + l)) + d.strScale(c) + (s ? "rotate(" + s + (t ? "" : " " + r + " " + n) + ")" : "");
      }, d.ensureUniformFontSize = function (e, t) {
        var r = d.extendFlat({}, t);
        return r.size = Math.max(t.size, e._fullLayout.uniformtext.minsize || 0), r;
      }, d.join2 = function (e, t, r) {
        var n = e.length;
        return n > 1 ? e.slice(0, -1).join(t) + r + e[n - 1] : e.join(t);
      }, d.bigFont = function (e) {
        return Math.round(1.2 * e);
      };
      var H = d.getFirefoxVersion(),
        B = null !== H && H < 86;
      d.getPositionFromD3Event = function () {
        return B ? [n.event.layerX, n.event.layerY] : [n.event.offsetX, n.event.offsetY];
      };
    }, {
      "../constants/numerical": 205,
      "./anchor_utils": 209,
      "./angles": 210,
      "./array": 211,
      "./clean_number": 212,
      "./clear_responsive": 214,
      "./coerce": 215,
      "./dates": 216,
      "./dom": 217,
      "./extend": 219,
      "./filter_unique": 220,
      "./filter_visible": 221,
      "./geometry2d": 222,
      "./identity": 223,
      "./increment": 224,
      "./is_plain_object": 226,
      "./keyed_container": 227,
      "./localize": 228,
      "./loggers": 229,
      "./make_trace_groups": 230,
      "./matrix": 231,
      "./mod": 232,
      "./nested_property": 233,
      "./noop": 234,
      "./notifier": 235,
      "./preserve_drawing_buffer": 238,
      "./push_unique": 239,
      "./regex": 241,
      "./relative_attr": 242,
      "./relink_private": 243,
      "./search": 244,
      "./sort_object_keys": 246,
      "./stats": 247,
      "./throttle": 249,
      "./to_log_range": 250,
      "@plotly/d3": 6,
      "d3-format": 7,
      "d3-time-format": 8,
      "fast-isnumeric": 11
    }],
    226: [function (e, t, r) {
      "use strict";

      t.exports = function (e) {
        return window && window.process && window.process.versions ? "[object Object]" === Object.prototype.toString.call(e) : "[object Object]" === Object.prototype.toString.call(e) && Object.getPrototypeOf(e).hasOwnProperty("hasOwnProperty");
      };
    }, {}],
    227: [function (e, t, r) {
      "use strict";

      var n = e("./nested_property"),
        a = /^\w*$/;
      t.exports = function (e, t, r, i) {
        var o, l, s;
        r = r || "name", i = i || "value";
        var c = {};
        t && t.length ? (s = n(e, t), l = s.get()) : l = e, t = t || "";
        var u = {};
        if (l) for (o = 0; o < l.length; o++) u[l[o][r]] = o;
        var d = a.test(i),
          f = {
            set: function set(e, t) {
              var a = null === t ? 4 : 0;
              if (!l) {
                if (!s || 4 === a) return;
                l = [], s.set(l);
              }
              var o = u[e];
              if (void 0 === o) {
                if (4 === a) return;
                a |= 3, o = l.length, u[e] = o;
              } else t !== (d ? l[o][i] : n(l[o], i).get()) && (a |= 2);
              var h = l[o] = l[o] || {};
              return h[r] = e, d ? h[i] = t : n(h, i).set(t), null !== t && (a &= -5), c[o] = c[o] | a, f;
            },
            get: function get(e) {
              if (l) {
                var t = u[e];
                return void 0 === t ? void 0 : d ? l[t][i] : n(l[t], i).get();
              }
            },
            rename: function rename(e, t) {
              var n = u[e];
              return void 0 === n || (c[n] = 1 | c[n], u[t] = n, delete u[e], l[n][r] = t), f;
            },
            remove: function remove(e) {
              var t = u[e];
              if (void 0 === t) return f;
              var a = l[t];
              if (Object.keys(a).length > 2) return c[t] = 2 | c[t], f.set(e, null);
              if (d) {
                for (o = t; o < l.length; o++) c[o] = 3 | c[o];
                for (o = t; o < l.length; o++) u[l[o][r]]--;
                l.splice(t, 1), delete u[e];
              } else n(a, i).set(null), c[t] = 6 | c[t];
              return f;
            },
            constructUpdate: function constructUpdate() {
              for (var e, a, o = {}, s = Object.keys(c), u = 0; u < s.length; u++) a = s[u], e = t + "[" + a + "]", l[a] ? (1 & c[a] && (o[e + "." + r] = l[a][r]), 2 & c[a] && (o[e + "." + i] = d ? 4 & c[a] ? null : l[a][i] : 4 & c[a] ? null : n(l[a], i).get())) : o[e] = null;
              return o;
            }
          };
        return f;
      };
    }, {
      "./nested_property": 233
    }],
    228: [function (e, t, r) {
      "use strict";

      var n = e("../registry");
      t.exports = function (e, t) {
        for (var r = e._context.locale, a = 0; a < 2; a++) {
          for (var i = e._context.locales, o = 0; o < 2; o++) {
            var l = (i[r] || {}).dictionary;
            if (l) {
              var s = l[t];
              if (s) return s;
            }
            i = n.localeRegistry;
          }
          var c = r.split("-")[0];
          if (c === r) break;
          r = c;
        }
        return t;
      };
    }, {
      "../registry": 309
    }],
    229: [function (e, t, r) {
      "use strict";

      var n = e("../plot_api/plot_config").dfltConfig,
        a = e("./notifier"),
        i = t.exports = {};
      i.log = function () {
        var e;
        if (n.logging > 1) {
          var t = ["LOG:"];
          for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
          console.trace.apply(console, t);
        }
        if (n.notifyOnLogging > 1) {
          var r = [];
          for (e = 0; e < arguments.length; e++) r.push(arguments[e]);
          a(r.join("<br>"), "long");
        }
      }, i.warn = function () {
        var e;
        if (n.logging > 0) {
          var t = ["WARN:"];
          for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
          console.trace.apply(console, t);
        }
        if (n.notifyOnLogging > 0) {
          var r = [];
          for (e = 0; e < arguments.length; e++) r.push(arguments[e]);
          a(r.join("<br>"), "stick");
        }
      }, i.error = function () {
        var e;
        if (n.logging > 0) {
          var t = ["ERROR:"];
          for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
          console.error.apply(console, t);
        }
        if (n.notifyOnLogging > 0) {
          var r = [];
          for (e = 0; e < arguments.length; e++) r.push(arguments[e]);
          a(r.join("<br>"), "stick");
        }
      };
    }, {
      "../plot_api/plot_config": 259,
      "./notifier": 235
    }],
    230: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3");
      t.exports = function (e, t, r) {
        var a = e.selectAll("g." + r.replace(/\s/g, ".")).data(t, function (e) {
          return e[0].trace.uid;
        });
        a.exit().remove(), a.enter().append("g").attr("class", r), a.order();
        var i = e.classed("rangeplot") ? "nodeRangePlot3" : "node3";
        return a.each(function (e) {
          e[0][i] = n.select(this);
        }), a;
      };
    }, {
      "@plotly/d3": 6
    }],
    231: [function (e, t, r) {
      "use strict";

      var n = e("gl-mat4");
      r.init2dArray = function (e, t) {
        for (var r = new Array(e), n = 0; n < e; n++) r[n] = new Array(t);
        return r;
      }, r.transposeRagged = function (e) {
        var t,
          r,
          n = 0,
          a = e.length;
        for (t = 0; t < a; t++) n = Math.max(n, e[t].length);
        var i = new Array(n);
        for (t = 0; t < n; t++) for (i[t] = new Array(a), r = 0; r < a; r++) i[t][r] = e[r][t];
        return i;
      }, r.dot = function (e, t) {
        if (!e.length || !t.length || e.length !== t.length) return null;
        var n,
          a,
          i = e.length;
        if (e[0].length) for (n = new Array(i), a = 0; a < i; a++) n[a] = r.dot(e[a], t);else if (t[0].length) {
          var o = r.transposeRagged(t);
          for (n = new Array(o.length), a = 0; a < o.length; a++) n[a] = r.dot(e, o[a]);
        } else for (n = 0, a = 0; a < i; a++) n += e[a] * t[a];
        return n;
      }, r.translationMatrix = function (e, t) {
        return [[1, 0, e], [0, 1, t], [0, 0, 1]];
      }, r.rotationMatrix = function (e) {
        var t = e * Math.PI / 180;
        return [[Math.cos(t), -Math.sin(t), 0], [Math.sin(t), Math.cos(t), 0], [0, 0, 1]];
      }, r.rotationXYMatrix = function (e, t, n) {
        return r.dot(r.dot(r.translationMatrix(t, n), r.rotationMatrix(e)), r.translationMatrix(-t, -n));
      }, r.apply3DTransform = function (e) {
        return function () {
          var t = arguments,
            n = 1 === arguments.length ? t[0] : [t[0], t[1], t[2] || 0];
          return r.dot(e, [n[0], n[1], n[2], 1]).slice(0, 3);
        };
      }, r.apply2DTransform = function (e) {
        return function () {
          var t = arguments;
          3 === t.length && (t = t[0]);
          var n = 1 === arguments.length ? t[0] : [t[0], t[1]];
          return r.dot(e, [n[0], n[1], 1]).slice(0, 2);
        };
      }, r.apply2DTransform2 = function (e) {
        var t = r.apply2DTransform(e);
        return function (e) {
          return t(e.slice(0, 2)).concat(t(e.slice(2, 4)));
        };
      }, r.convertCssMatrix = function (e) {
        if (e) {
          var t = e.length;
          if (16 === t) return e;
          if (6 === t) return [e[0], e[1], 0, 0, e[2], e[3], 0, 0, 0, 0, 1, 0, e[4], e[5], 0, 1];
        }
        return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
      }, r.inverseTransformMatrix = function (e) {
        var t = [];
        return n.invert(t, e), [[t[0], t[1], t[2], t[3]], [t[4], t[5], t[6], t[7]], [t[8], t[9], t[10], t[11]], [t[12], t[13], t[14], t[15]]];
      };
    }, {
      "gl-mat4": 27
    }],
    232: [function (e, t, r) {
      "use strict";

      t.exports = {
        mod: function mod(e, t) {
          var r = e % t;
          return r < 0 ? r + t : r;
        },
        modHalf: function modHalf(e, t) {
          return Math.abs(e) > t / 2 ? e - Math.round(e / t) * t : e;
        }
      };
    }, {}],
    233: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("./array").isArrayOrTypedArray;
      function i(e, t) {
        return function () {
          var r,
            n,
            o,
            l,
            s,
            c = e;
          for (l = 0; l < t.length - 1; l++) {
            if (-1 === (r = t[l])) {
              for (n = !0, o = [], s = 0; s < c.length; s++) o[s] = i(c[s], t.slice(l + 1))(), o[s] !== o[0] && (n = !1);
              return n ? o[0] : o;
            }
            if ("number" == typeof r && !a(c)) return;
            if ("object" != typeof (c = c[r]) || null === c) return;
          }
          if ("object" == typeof c && null !== c && null !== (o = c[t[l]])) return o;
        };
      }
      t.exports = function (e, t) {
        if (n(t)) t = String(t);else if ("string" != typeof t || "[-1]" === t.substr(t.length - 4)) throw "bad property string";
        for (var r, a, o, l = 0, c = t.split("."); l < c.length;) {
          if (r = String(c[l]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/)) {
            if (r[1]) c[l] = r[1];else {
              if (0 !== l) throw "bad property string";
              c.splice(0, 1);
            }
            for (a = r[2].substr(1, r[2].length - 2).split("]["), o = 0; o < a.length; o++) l++, c.splice(l, 0, Number(a[o]));
          }
          l++;
        }
        return "object" != typeof e ? function (e, t, r) {
          return {
            set: function set() {
              throw "bad container";
            },
            get: function get() {},
            astr: t,
            parts: r,
            obj: e
          };
        }(e, t, c) : {
          set: s(e, c, t),
          get: i(e, c),
          astr: t,
          parts: c,
          obj: e
        };
      };
      var o = /(^|\.)args\[/;
      function l(e, t) {
        return void 0 === e || null === e && !t.match(o);
      }
      function s(e, t, r) {
        return function (n) {
          var i,
            o,
            s = e,
            f = "",
            h = [[e, f]],
            p = l(n, r);
          for (o = 0; o < t.length - 1; o++) {
            if ("number" == typeof (i = t[o]) && !a(s)) throw "array index but container is not an array";
            if (-1 === i) {
              if (p = !u(s, t.slice(o + 1), n, r)) break;
              return;
            }
            if (!d(s, i, t[o + 1], p)) break;
            if ("object" != typeof (s = s[i]) || null === s) throw "container is not an object";
            f = c(f, i), h.push([s, f]);
          }
          if (p) {
            if (o === t.length - 1 && (delete s[t[o]], Array.isArray(s) && +t[o] == s.length - 1)) for (; s.length && void 0 === s[s.length - 1];) s.pop();
          } else s[t[o]] = n;
        };
      }
      function c(e, t) {
        var r = t;
        return n(t) ? r = "[" + t + "]" : e && (r = "." + t), e + r;
      }
      function u(e, t, r, n) {
        var i,
          o = a(r),
          c = !0,
          u = r,
          f = n.replace("-1", 0),
          h = !o && l(r, f),
          p = t[0];
        for (i = 0; i < e.length; i++) f = n.replace("-1", i), o && (h = l(u = r[i % r.length], f)), h && (c = !1), d(e, i, p, h) && s(e[i], t, n.replace("-1", i))(u);
        return c;
      }
      function d(e, t, r, n) {
        if (void 0 === e[t]) {
          if (n) return !1;
          e[t] = "number" == typeof r ? [] : {};
        }
        return !0;
      }
    }, {
      "./array": 211,
      "fast-isnumeric": 11
    }],
    234: [function (e, t, r) {
      "use strict";

      t.exports = function () {};
    }, {}],
    235: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("fast-isnumeric"),
        i = [];
      t.exports = function (e, t) {
        if (-1 === i.indexOf(e)) {
          i.push(e);
          var r = 1e3;
          a(t) ? r = t : "long" === t && (r = 3e3);
          var o = n.select("body").selectAll(".plotly-notifier").data([0]);
          o.enter().append("div").classed("plotly-notifier", !0), o.selectAll(".notifier-note").data(i).enter().append("div").classed("notifier-note", !0).style("opacity", 0).each(function (e) {
            var a = n.select(this);
            a.append("button").classed("notifier-close", !0).html("&times;").on("click", function () {
              a.transition().call(l);
            });
            for (var i = a.append("p"), o = e.split(/<br\s*\/?>/g), s = 0; s < o.length; s++) s && i.append("br"), i.append("span").text(o[s]);
            "stick" === t ? a.transition().duration(350).style("opacity", 1) : a.transition().duration(700).style("opacity", 1).transition().delay(r).call(l);
          });
        }
        function l(e) {
          e.duration(700).style("opacity", 0).each("end", function (e) {
            var t = i.indexOf(e);
            -1 !== t && i.splice(t, 1), n.select(this).remove();
          });
        }
      };
    }, {
      "@plotly/d3": 6,
      "fast-isnumeric": 11
    }],
    236: [function (e, t, r) {
      "use strict";

      var n = e("./setcursor"),
        a = "data-savedcursor";
      t.exports = function (e, t) {
        var r = e.attr(a);
        if (t) {
          if (!r) {
            for (var i = (e.attr("class") || "").split(" "), o = 0; o < i.length; o++) {
              var l = i[o];
              0 === l.indexOf("cursor-") && e.attr(a, l.substr(7)).classed(l, !1);
            }
            e.attr(a) || e.attr(a, "!!");
          }
          n(e, t);
        } else r && (e.attr(a, null), "!!" === r ? n(e) : n(e, r));
      };
    }, {
      "./setcursor": 245
    }],
    237: [function (e, t, r) {
      "use strict";

      var n = e("./matrix").dot,
        a = e("../constants/numerical").BADNUM,
        i = t.exports = {};
      i.tester = function (e) {
        var t,
          r = e.slice(),
          n = r[0][0],
          i = n,
          o = r[0][1],
          l = o;
        for (r.push(r[0]), t = 1; t < r.length; t++) n = Math.min(n, r[t][0]), i = Math.max(i, r[t][0]), o = Math.min(o, r[t][1]), l = Math.max(l, r[t][1]);
        var s,
          c = !1;
        5 === r.length && (r[0][0] === r[1][0] ? r[2][0] === r[3][0] && r[0][1] === r[3][1] && r[1][1] === r[2][1] && (c = !0, s = function s(e) {
          return e[0] === r[0][0];
        }) : r[0][1] === r[1][1] && r[2][1] === r[3][1] && r[0][0] === r[3][0] && r[1][0] === r[2][0] && (c = !0, s = function s(e) {
          return e[1] === r[0][1];
        }));
        var u = !0,
          d = r[0];
        for (t = 1; t < r.length; t++) if (d[0] !== r[t][0] || d[1] !== r[t][1]) {
          u = !1;
          break;
        }
        return {
          xmin: n,
          xmax: i,
          ymin: o,
          ymax: l,
          pts: r,
          contains: c ? function (e, t) {
            var r = e[0],
              c = e[1];
            return !(r === a || r < n || r > i || c === a || c < o || c > l) && (!t || !s(e));
          } : function (e, t) {
            var s = e[0],
              c = e[1];
            if (s === a || s < n || s > i || c === a || c < o || c > l) return !1;
            var u,
              d,
              f,
              h,
              p,
              g = r.length,
              m = r[0][0],
              y = r[0][1],
              v = 0;
            for (u = 1; u < g; u++) if (d = m, f = y, m = r[u][0], y = r[u][1], !(s < (h = Math.min(d, m)) || s > Math.max(d, m) || c > Math.max(f, y))) if (c < Math.min(f, y)) s !== h && v++;else {
              if (c === (p = m === d ? c : f + (s - d) * (y - f) / (m - d))) return 1 !== u || !t;
              c <= p && s !== h && v++;
            }
            return v % 2 == 1;
          },
          isRect: c,
          degenerate: u
        };
      }, i.isSegmentBent = function (e, t, r, a) {
        var i,
          o,
          l,
          s = e[t],
          c = [e[r][0] - s[0], e[r][1] - s[1]],
          u = n(c, c),
          d = Math.sqrt(u),
          f = [-c[1] / d, c[0] / d];
        for (i = t + 1; i < r; i++) if (o = [e[i][0] - s[0], e[i][1] - s[1]], (l = n(o, c)) < 0 || l > u || Math.abs(n(o, f)) > a) return !0;
        return !1;
      }, i.filter = function (e, t) {
        var r = [e[0]],
          n = 0,
          a = 0;
        function o(o) {
          e.push(o);
          var l = r.length,
            s = n;
          r.splice(a + 1);
          for (var c = s + 1; c < e.length; c++) (c === e.length - 1 || i.isSegmentBent(e, s, c + 1, t)) && (r.push(e[c]), r.length < l - 2 && (n = c, a = r.length - 1), s = c);
        }
        e.length > 1 && o(e.pop());
        return {
          addPt: o,
          raw: e,
          filtered: r
        };
      };
    }, {
      "../constants/numerical": 205,
      "./matrix": 231
    }],
    238: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("is-mobile");
      t.exports = function (e) {
        var t;
        if ("string" != typeof (t = e && e.hasOwnProperty("userAgent") ? e.userAgent : function () {
          var e;
          "undefined" != typeof navigator && (e = navigator.userAgent);
          e && e.headers && "string" == typeof e.headers["user-agent"] && (e = e.headers["user-agent"]);
          return e;
        }())) return !0;
        var r = a({
          ua: {
            headers: {
              "user-agent": t
            }
          },
          tablet: !0,
          featureDetect: !1
        });
        if (!r) for (var i = t.split(" "), o = 1; o < i.length; o++) {
          if (-1 !== i[o].indexOf("Safari")) for (var l = o - 1; l > -1; l--) {
            var s = i[l];
            if ("Version/" === s.substr(0, 8)) {
              var c = s.substr(8).split(".")[0];
              if (n(c) && (c = +c), c >= 13) return !0;
            }
          }
        }
        return r;
      };
    }, {
      "fast-isnumeric": 11,
      "is-mobile": 45
    }],
    239: [function (e, t, r) {
      "use strict";

      t.exports = function (e, t) {
        if (t instanceof RegExp) {
          for (var r = t.toString(), n = 0; n < e.length; n++) if (e[n] instanceof RegExp && e[n].toString() === r) return e;
          e.push(t);
        } else !t && 0 !== t || -1 !== e.indexOf(t) || e.push(t);
        return e;
      };
    }, {}],
    240: [function (e, t, r) {
      "use strict";

      var n = e("../lib"),
        a = e("../plot_api/plot_config").dfltConfig;
      var i = {
        add: function add(e, t, r, n, i) {
          var o, l;
          e.undoQueue = e.undoQueue || {
            index: 0,
            queue: [],
            sequence: !1
          }, l = e.undoQueue.index, e.autoplay ? e.undoQueue.inSequence || (e.autoplay = !1) : (!e.undoQueue.sequence || e.undoQueue.beginSequence ? (o = {
            undo: {
              calls: [],
              args: []
            },
            redo: {
              calls: [],
              args: []
            }
          }, e.undoQueue.queue.splice(l, e.undoQueue.queue.length - l, o), e.undoQueue.index += 1) : o = e.undoQueue.queue[l - 1], e.undoQueue.beginSequence = !1, o && (o.undo.calls.unshift(t), o.undo.args.unshift(r), o.redo.calls.push(n), o.redo.args.push(i)), e.undoQueue.queue.length > a.queueLength && (e.undoQueue.queue.shift(), e.undoQueue.index--));
        },
        startSequence: function startSequence(e) {
          e.undoQueue = e.undoQueue || {
            index: 0,
            queue: [],
            sequence: !1
          }, e.undoQueue.sequence = !0, e.undoQueue.beginSequence = !0;
        },
        stopSequence: function stopSequence(e) {
          e.undoQueue = e.undoQueue || {
            index: 0,
            queue: [],
            sequence: !1
          }, e.undoQueue.sequence = !1, e.undoQueue.beginSequence = !1;
        },
        undo: function undo(e) {
          var t, r;
          if (!(void 0 === e.undoQueue || isNaN(e.undoQueue.index) || e.undoQueue.index <= 0)) {
            for (e.undoQueue.index--, t = e.undoQueue.queue[e.undoQueue.index], e.undoQueue.inSequence = !0, r = 0; r < t.undo.calls.length; r++) i.plotDo(e, t.undo.calls[r], t.undo.args[r]);
            e.undoQueue.inSequence = !1, e.autoplay = !1;
          }
        },
        redo: function redo(e) {
          var t, r;
          if (!(void 0 === e.undoQueue || isNaN(e.undoQueue.index) || e.undoQueue.index >= e.undoQueue.queue.length)) {
            for (t = e.undoQueue.queue[e.undoQueue.index], e.undoQueue.inSequence = !0, r = 0; r < t.redo.calls.length; r++) i.plotDo(e, t.redo.calls[r], t.redo.args[r]);
            e.undoQueue.inSequence = !1, e.autoplay = !1, e.undoQueue.index++;
          }
        }
      };
      i.plotDo = function (e, t, r) {
        e.autoplay = !0, r = function (e, t) {
          for (var r, a = [], i = 0; i < t.length; i++) r = t[i], a[i] = r === e ? r : "object" == typeof r ? Array.isArray(r) ? n.extendDeep([], r) : n.extendDeepAll({}, r) : r;
          return a;
        }(e, r), t.apply(null, r);
      }, t.exports = i;
    }, {
      "../lib": 225,
      "../plot_api/plot_config": 259
    }],
    241: [function (e, t, r) {
      "use strict";

      r.counter = function (e, t, r, n) {
        var a = (t || "") + (r ? "" : "$"),
          i = !1 === n ? "" : "^";
        return "xy" === e ? new RegExp(i + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + a) : new RegExp(i + e + "([2-9]|[1-9][0-9]+)?" + a);
      };
    }, {}],
    242: [function (e, t, r) {
      "use strict";

      var n = /^(.*)(\.[^\.\[\]]+|\[\d\])$/,
        a = /^[^\.\[\]]+$/;
      t.exports = function (e, t) {
        for (; t;) {
          var r = e.match(n);
          if (r) e = r[1];else {
            if (!e.match(a)) throw new Error("bad relativeAttr call:" + [e, t]);
            e = "";
          }
          if ("^" !== t.charAt(0)) break;
          t = t.slice(1);
        }
        return e && "[" !== t.charAt(0) ? e + "." + t : e + t;
      };
    }, {}],
    243: [function (e, t, r) {
      "use strict";

      var n = e("./array").isArrayOrTypedArray,
        a = e("./is_plain_object");
      t.exports = function e(t, r) {
        for (var i in r) {
          var o = r[i],
            l = t[i];
          if (l !== o) if ("_" === i.charAt(0) || "function" == typeof o) {
            if (i in t) continue;
            t[i] = o;
          } else if (n(o) && n(l) && a(o[0])) {
            if ("customdata" === i || "ids" === i) continue;
            for (var s = Math.min(o.length, l.length), c = 0; c < s; c++) l[c] !== o[c] && a(o[c]) && a(l[c]) && e(l[c], o[c]);
          } else a(o) && a(l) && (e(l, o), Object.keys(l).length || delete t[i]);
        }
      };
    }, {
      "./array": 211,
      "./is_plain_object": 226
    }],
    244: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("./loggers"),
        i = e("./identity"),
        o = e("../constants/numerical").BADNUM;
      function l(e, t) {
        return e < t;
      }
      function s(e, t) {
        return e <= t;
      }
      function c(e, t) {
        return e > t;
      }
      function u(e, t) {
        return e >= t;
      }
      r.findBin = function (e, t, r) {
        if (n(t.start)) return r ? Math.ceil((e - t.start) / t.size - 1e-9) - 1 : Math.floor((e - t.start) / t.size + 1e-9);
        var i,
          o,
          d = 0,
          f = t.length,
          h = 0,
          p = f > 1 ? (t[f - 1] - t[0]) / (f - 1) : 1;
        for (o = p >= 0 ? r ? l : s : r ? u : c, e += 1e-9 * p * (r ? -1 : 1) * (p >= 0 ? 1 : -1); d < f && h++ < 100;) o(t[i = Math.floor((d + f) / 2)], e) ? d = i + 1 : f = i;
        return h > 90 && a.log("Long binary search..."), d - 1;
      }, r.sorterAsc = function (e, t) {
        return e - t;
      }, r.sorterDes = function (e, t) {
        return t - e;
      }, r.distinctVals = function (e) {
        var t,
          n = e.slice();
        for (n.sort(r.sorterAsc), t = n.length - 1; t > -1 && n[t] === o; t--);
        for (var a, i = n[t] - n[0] || 1, l = i / (t || 1) / 1e4, s = [], c = 0; c <= t; c++) {
          var u = n[c],
            d = u - a;
          void 0 === a ? (s.push(u), a = u) : d > l && (i = Math.min(i, d), s.push(u), a = u);
        }
        return {
          vals: s,
          minDiff: i
        };
      }, r.roundUp = function (e, t, r) {
        for (var n, a = 0, i = t.length - 1, o = 0, l = r ? 0 : 1, s = r ? 1 : 0, c = r ? Math.ceil : Math.floor; a < i && o++ < 100;) t[n = c((a + i) / 2)] <= e ? a = n + l : i = n - s;
        return t[a];
      }, r.sort = function (e, t) {
        for (var r = 0, n = 0, a = 1; a < e.length; a++) {
          var i = t(e[a], e[a - 1]);
          if (i < 0 ? r = 1 : i > 0 && (n = 1), r && n) return e.sort(t);
        }
        return n ? e : e.reverse();
      }, r.findIndexOfMin = function (e, t) {
        t = t || i;
        for (var r, n = 1 / 0, a = 0; a < e.length; a++) {
          var o = t(e[a]);
          o < n && (n = o, r = a);
        }
        return r;
      };
    }, {
      "../constants/numerical": 205,
      "./identity": 223,
      "./loggers": 229,
      "fast-isnumeric": 11
    }],
    245: [function (e, t, r) {
      "use strict";

      t.exports = function (e, t) {
        (e.attr("class") || "").split(" ").forEach(function (t) {
          0 === t.indexOf("cursor-") && e.classed(t, !1);
        }), t && e.classed("cursor-" + t, !0);
      };
    }, {}],
    246: [function (e, t, r) {
      "use strict";

      t.exports = function (e) {
        return Object.keys(e).sort();
      };
    }, {}],
    247: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("./array").isArrayOrTypedArray;
      r.aggNums = function (e, t, i, o) {
        var l, s;
        if ((!o || o > i.length) && (o = i.length), n(t) || (t = !1), a(i[0])) {
          for (s = new Array(o), l = 0; l < o; l++) s[l] = r.aggNums(e, t, i[l]);
          i = s;
        }
        for (l = 0; l < o; l++) n(t) ? n(i[l]) && (t = e(+t, +i[l])) : t = i[l];
        return t;
      }, r.len = function (e) {
        return r.aggNums(function (e) {
          return e + 1;
        }, 0, e);
      }, r.mean = function (e, t) {
        return t || (t = r.len(e)), r.aggNums(function (e, t) {
          return e + t;
        }, 0, e) / t;
      }, r.midRange = function (e) {
        if (void 0 !== e && 0 !== e.length) return (r.aggNums(Math.max, null, e) + r.aggNums(Math.min, null, e)) / 2;
      }, r.variance = function (e, t, a) {
        return t || (t = r.len(e)), n(a) || (a = r.mean(e, t)), r.aggNums(function (e, t) {
          return e + Math.pow(t - a, 2);
        }, 0, e) / t;
      }, r.stdev = function (e, t, n) {
        return Math.sqrt(r.variance(e, t, n));
      }, r.median = function (e) {
        var t = e.slice().sort();
        return r.interp(t, .5);
      }, r.interp = function (e, t) {
        if (!n(t)) throw "n should be a finite number";
        if ((t = t * e.length - .5) < 0) return e[0];
        if (t > e.length - 1) return e[e.length - 1];
        var r = t % 1;
        return r * e[Math.ceil(t)] + (1 - r) * e[Math.floor(t)];
      };
    }, {
      "./array": 211,
      "fast-isnumeric": 11
    }],
    248: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../lib"),
        i = a.strTranslate,
        o = e("../constants/xmlns_namespaces"),
        l = e("../constants/alignment").LINE_SPACING;
      function s(e, t) {
        return e.node().getBoundingClientRect()[t];
      }
      var c = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
      r.convertToTspans = function (e, t, g) {
        var A = e.text(),
          L = !e.attr("data-notex") && "undefined" != typeof MathJax && A.match(c),
          C = n.select(e.node().parentNode);
        if (!C.empty()) {
          var O = e.attr("class") ? e.attr("class").split(" ")[0] : "text";
          return O += "-math", C.selectAll("svg." + O).remove(), C.selectAll("g." + O + "-group").remove(), e.style("display", null).attr({
            "data-unformatted": A,
            "data-math": "N"
          }), L ? (t && t._promises || []).push(new Promise(function (t) {
            e.style("display", "none");
            var r = parseInt(e.node().style.fontSize, 10),
              o = {
                fontSize: r
              };
            !function (e, t, r) {
              var i, o, l, s;
              MathJax.Hub.Queue(function () {
                return o = a.extendDeepAll({}, MathJax.Hub.config), l = MathJax.Hub.processSectionDelay, void 0 !== MathJax.Hub.processSectionDelay && (MathJax.Hub.processSectionDelay = 0), MathJax.Hub.Config({
                  messageStyle: "none",
                  tex2jax: {
                    inlineMath: [["$", "$"], ["\\(", "\\)"]]
                  },
                  displayAlign: "left"
                });
              }, function () {
                if ("SVG" !== (i = MathJax.Hub.config.menuSettings.renderer)) return MathJax.Hub.setRenderer("SVG");
              }, function () {
                var r = "math-output-" + a.randstr({}, 64);
                return s = n.select("body").append("div").attr({
                  id: r
                }).style({
                  visibility: "hidden",
                  position: "absolute"
                }).style({
                  "font-size": t.fontSize + "px"
                }).text(e.replace(u, "\\lt ").replace(d, "\\gt ")), MathJax.Hub.Typeset(s.node());
              }, function () {
                var t = n.select("body").select("#MathJax_SVG_glyphs");
                if (s.select(".MathJax_SVG").empty() || !s.select("svg").node()) a.log("There was an error in the tex syntax.", e), r();else {
                  var o = s.select("svg").node().getBoundingClientRect();
                  r(s.select(".MathJax_SVG"), t, o);
                }
                if (s.remove(), "SVG" !== i) return MathJax.Hub.setRenderer(i);
              }, function () {
                return void 0 !== l && (MathJax.Hub.processSectionDelay = l), MathJax.Hub.Config(o);
              });
            }(L[2], o, function (n, a, o) {
              C.selectAll("svg." + O).remove(), C.selectAll("g." + O + "-group").remove();
              var l = n && n.select("svg");
              if (!l || !l.node()) return P(), void t();
              var c = C.append("g").classed(O + "-group", !0).attr({
                "pointer-events": "none",
                "data-unformatted": A,
                "data-math": "Y"
              });
              c.node().appendChild(l.node()), a && a.node() && l.node().insertBefore(a.node().cloneNode(!0), l.node().firstChild), l.attr({
                class: O,
                height: o.height,
                preserveAspectRatio: "xMinYMin meet"
              }).style({
                overflow: "visible",
                "pointer-events": "none"
              });
              var u = e.node().style.fill || "black",
                d = l.select("g");
              d.attr({
                fill: u,
                stroke: u
              });
              var f = s(d, "width"),
                h = s(d, "height"),
                p = +e.attr("x") - f * {
                  start: 0,
                  middle: .5,
                  end: 1
                }[e.attr("text-anchor") || "start"],
                m = -(r || s(e, "height")) / 4;
              "y" === O[0] ? (c.attr({
                transform: "rotate(" + [-90, +e.attr("x"), +e.attr("y")] + ")" + i(-f / 2, m - h / 2)
              }), l.attr({
                x: +e.attr("x"),
                y: +e.attr("y")
              })) : "l" === O[0] ? l.attr({
                x: e.attr("x"),
                y: m - h / 2
              }) : "a" === O[0] && 0 !== O.indexOf("atitle") ? l.attr({
                x: 0,
                y: m
              }) : l.attr({
                x: p,
                y: +e.attr("y") + m - h / 2
              }), g && g.call(e, c), t(c);
            });
          })) : P(), e;
        }
        function P() {
          C.empty() || (O = e.attr("class") + "-math", C.select("svg." + O).remove()), e.text("").style("white-space", "pre"), function (e, t) {
            t = t.replace(m, " ");
            var r,
              i = !1,
              s = [],
              c = -1;
            function u() {
              c++;
              var t = document.createElementNS(o.svg, "tspan");
              n.select(t).attr({
                class: "line",
                dy: c * l + "em"
              }), e.appendChild(t), r = t;
              var a = s;
              if (s = [{
                node: t
              }], a.length > 1) for (var i = 1; i < a.length; i++) d(a[i]);
            }
            function d(e) {
              var t,
                a = e.type,
                i = {};
              if ("a" === a) {
                t = "a";
                var l = e.target,
                  c = e.href,
                  u = e.popup;
                c && (i = {
                  "xlink:xlink:show": "_blank" === l || "_" !== l.charAt(0) ? "new" : "replace",
                  target: l,
                  "xlink:xlink:href": c
                }, u && (i.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + u + '");return false;'));
              } else t = "tspan";
              e.style && (i.style = e.style);
              var d = document.createElementNS(o.svg, t);
              if ("sup" === a || "sub" === a) {
                g(r, "\u200B"), r.appendChild(d);
                var f = document.createElementNS(o.svg, "tspan");
                g(f, "\u200B"), n.select(f).attr("dy", p[a]), i.dy = h[a], r.appendChild(d), r.appendChild(f);
              } else r.appendChild(d);
              n.select(d).attr(i), r = e.node = d, s.push(e);
            }
            function g(e, t) {
              e.appendChild(document.createTextNode(t));
            }
            function A(e) {
              if (1 !== s.length) {
                var n = s.pop();
                e !== n.type && a.log("Start tag <" + n.type + "> doesnt match end tag <" + e + ">. Pretending it did match.", t), r = s[s.length - 1].node;
              } else a.log("Ignoring unexpected end tag </" + e + ">.", t);
            }
            x.test(t) ? u() : (r = e, s = [{
              node: e
            }]);
            for (var L = t.split(y), C = 0; C < L.length; C++) {
              var O = L[C],
                P = O.match(v),
                I = P && P[2].toLowerCase(),
                z = f[I];
              if ("br" === I) u();else if (void 0 === z) g(r, D(O));else if (P[1]) A(I);else {
                var R = P[4],
                  N = {
                    type: I
                  },
                  F = T(R, b);
                if (F ? (F = F.replace(k, "$1 fill:"), z && (F += ";" + z)) : z && (F = z), F && (N.style = F), "a" === I) {
                  i = !0;
                  var E = T(R, _);
                  if (E) {
                    var j = S(E);
                    j && (N.href = j, N.target = T(R, w) || "_blank", N.popup = T(R, M));
                  }
                }
                d(N);
              }
            }
            return i;
          }(e.node(), A) && e.style("pointer-events", "all"), r.positionText(e), g && g.call(e);
        }
      };
      var u = /(<|&lt;|&#60;)/g,
        d = /(>|&gt;|&#62;)/g;
      var f = {
          sup: "font-size:70%",
          sub: "font-size:70%",
          b: "font-weight:bold",
          i: "font-style:italic",
          a: "cursor:pointer",
          span: "",
          em: "font-style:italic;font-weight:bold"
        },
        h = {
          sub: "0.3em",
          sup: "-0.6em"
        },
        p = {
          sub: "-0.21em",
          sup: "0.42em"
        },
        g = ["http:", "https:", "mailto:", "", void 0, ":"],
        m = r.NEWLINES = /(\r\n?|\n)/g,
        y = /(<[^<>]*>)/,
        v = /<(\/?)([^ >]*)(\s+(.*))?>/i,
        x = /<br(\s+.*)?>/i;
      r.BR_TAG_ALL = /<br(\s+.*)?>/gi;
      var b = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i,
        _ = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i,
        w = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i,
        M = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
      function T(e, t) {
        if (!e) return null;
        var r = e.match(t),
          n = r && (r[3] || r[4]);
        return n && D(n);
      }
      var k = /(^|;)\s*color:/;
      r.plainText = function (e, t) {
        for (var r = void 0 !== (t = t || {}).len && -1 !== t.len ? t.len : 1 / 0, n = void 0 !== t.allowedTags ? t.allowedTags : ["br"], a = "...".length, i = e.split(y), o = [], l = "", s = 0, c = 0; c < i.length; c++) {
          var u = i[c],
            d = u.match(v),
            f = d && d[2].toLowerCase();
          if (f) -1 !== n.indexOf(f) && (o.push(u), l = f);else {
            var h = u.length;
            if (s + h < r) o.push(u), s += h;else if (s < r) {
              var p = r - s;
              l && ("br" !== l || p <= a || h <= a) && o.pop(), r > a ? o.push(u.substr(0, p - a) + "...") : o.push(u.substr(0, p));
              break;
            }
            l = "";
          }
        }
        return o.join("");
      };
      var A = {
          mu: "\u03BC",
          amp: "&",
          lt: "<",
          gt: ">",
          nbsp: "\xa0",
          times: "\xd7",
          plusmn: "\xb1",
          deg: "\xb0"
        },
        L = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
      function D(e) {
        return e.replace(L, function (e, t) {
          return ("#" === t.charAt(0) ? function (e) {
            if (e > 1114111) return;
            var t = String.fromCodePoint;
            if (t) return t(e);
            var r = String.fromCharCode;
            return e <= 65535 ? r(e) : r(55232 + (e >> 10), e % 1024 + 56320);
          }("x" === t.charAt(1) ? parseInt(t.substr(2), 16) : parseInt(t.substr(1), 10)) : A[t]) || e;
        });
      }
      function S(e) {
        var t = encodeURI(decodeURI(e)),
          r = document.createElement("a"),
          n = document.createElement("a");
        r.href = e, n.href = t;
        var a = r.protocol,
          i = n.protocol;
        return -1 !== g.indexOf(a) && -1 !== g.indexOf(i) ? t : "";
      }
      function C(e, t, r) {
        var n,
          i,
          o,
          l = r.horizontalAlign,
          s = r.verticalAlign || "top",
          c = e.node().getBoundingClientRect(),
          u = t.node().getBoundingClientRect();
        return i = "bottom" === s ? function () {
          return c.bottom - n.height;
        } : "middle" === s ? function () {
          return c.top + (c.height - n.height) / 2;
        } : function () {
          return c.top;
        }, o = "right" === l ? function () {
          return c.right - n.width;
        } : "center" === l ? function () {
          return c.left + (c.width - n.width) / 2;
        } : function () {
          return c.left;
        }, function () {
          n = this.node().getBoundingClientRect();
          var e = o() - u.left,
            t = i() - u.top,
            l = r.gd || {};
          if (r.gd) {
            l._fullLayout._calcInverseTransform(l);
            var s = a.apply3DTransform(l._fullLayout._invTransform)(e, t);
            e = s[0], t = s[1];
          }
          return this.style({
            top: t + "px",
            left: e + "px",
            "z-index": 1e3
          }), this;
        };
      }
      r.convertEntities = D, r.sanitizeHTML = function (e) {
        e = e.replace(m, " ");
        for (var t = document.createElement("p"), r = t, a = [], i = e.split(y), o = 0; o < i.length; o++) {
          var l = i[o],
            s = l.match(v),
            c = s && s[2].toLowerCase();
          if (c in f) {
            if (s[1]) a.length && (r = a.pop());else {
              var u = s[4],
                d = T(u, b),
                h = d ? {
                  style: d
                } : {};
              if ("a" === c) {
                var p = T(u, _);
                if (p) {
                  var g = S(p);
                  if (g) {
                    h.href = g;
                    var x = T(u, w);
                    x && (h.target = x);
                  }
                }
              }
              var M = document.createElement(c);
              r.appendChild(M), n.select(M).attr(h), r = M, a.push(M);
            }
          } else r.appendChild(document.createTextNode(D(l)));
        }
        return t.innerHTML;
      }, r.lineCount = function (e) {
        return e.selectAll("tspan.line").size() || 1;
      }, r.positionText = function (e, t, r) {
        return e.each(function () {
          var e = n.select(this);
          function a(t, r) {
            return void 0 === r ? null === (r = e.attr(t)) && (e.attr(t, 0), r = 0) : e.attr(t, r), r;
          }
          var i = a("x", t),
            o = a("y", r);
          "text" === this.nodeName && e.selectAll("tspan.line").attr({
            x: i,
            y: o
          });
        });
      };
      r.makeTextShadow = function (e) {
        var t = "1px ",
          r = "1px ",
          n = "1px ";
        return t + r + n + e + ", -" + t + "-" + r + n + e + ", " + t + "-" + r + n + e + ", -" + t + r + n + e;
      }, r.makeEditable = function (e, t) {
        var r = t.gd,
          a = t.delegate,
          i = n.dispatch("edit", "input", "cancel"),
          o = a || e;
        if (e.style({
          "pointer-events": a ? "none" : "all"
        }), 1 !== e.size()) throw new Error("boo");
        function l() {
          !function () {
            var a = n.select(r).select(".svg-container"),
              o = a.append("div"),
              l = e.node().style,
              c = parseFloat(l.fontSize || 12),
              u = t.text;
            void 0 === u && (u = e.attr("data-unformatted"));
            o.classed("plugin-editable editable", !0).style({
              position: "absolute",
              "font-family": l.fontFamily || "Arial",
              "font-size": c,
              color: t.fill || l.fill || "black",
              opacity: 1,
              "background-color": t.background || "transparent",
              outline: "#ffffff33 1px solid",
              margin: [-c / 8 + 1, 0, 0, -1].join("px ") + "px",
              padding: "0",
              "box-sizing": "border-box"
            }).attr({
              contenteditable: !0
            }).text(u).call(C(e, a, t)).on("blur", function () {
              r._editing = !1, e.text(this.textContent).style({
                opacity: 1
              });
              var t,
                a = n.select(this).attr("class");
              (t = a ? "." + a.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(e.node().parentNode).select(t).style({
                opacity: 0
              });
              var o = this.textContent;
              n.select(this).transition().duration(0).remove(), n.select(document).on("mouseup", null), i.edit.call(e, o);
            }).on("focus", function () {
              var e = this;
              r._editing = !0, n.select(document).on("mouseup", function () {
                if (n.event.target === e) return !1;
                document.activeElement === o.node() && o.node().blur();
              });
            }).on("keyup", function () {
              27 === n.event.which ? (r._editing = !1, e.style({
                opacity: 1
              }), n.select(this).style({
                opacity: 0
              }).on("blur", function () {
                return !1;
              }).transition().remove(), i.cancel.call(e, this.textContent)) : (i.input.call(e, this.textContent), n.select(this).call(C(e, a, t)));
            }).on("keydown", function () {
              13 === n.event.which && this.blur();
            }).call(s);
          }(), e.style({
            opacity: 0
          });
          var a,
            l = o.attr("class");
          (a = l ? "." + l.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(e.node().parentNode).select(a).style({
            opacity: 0
          });
        }
        function s(e) {
          var t = e.node(),
            r = document.createRange();
          r.selectNodeContents(t);
          var n = window.getSelection();
          n.removeAllRanges(), n.addRange(r), t.focus();
        }
        return t.immediate ? l() : o.on("click", l), n.rebind(e, i, "on");
      };
    }, {
      "../constants/alignment": 201,
      "../constants/xmlns_namespaces": 206,
      "../lib": 225,
      "@plotly/d3": 6
    }],
    249: [function (e, t, r) {
      "use strict";

      var n = {};
      function a(e) {
        e && null !== e.timer && (clearTimeout(e.timer), e.timer = null);
      }
      r.throttle = function (e, t, r) {
        var i = n[e],
          o = Date.now();
        if (!i) {
          for (var l in n) n[l].ts < o - 6e4 && delete n[l];
          i = n[e] = {
            ts: 0,
            timer: null
          };
        }
        function s() {
          r(), i.ts = Date.now(), i.onDone && (i.onDone(), i.onDone = null);
        }
        a(i), o > i.ts + t ? s() : i.timer = setTimeout(function () {
          s(), i.timer = null;
        }, t);
      }, r.done = function (e) {
        var t = n[e];
        return t && t.timer ? new Promise(function (e) {
          var r = t.onDone;
          t.onDone = function () {
            r && r(), e(), t.onDone = null;
          };
        }) : Promise.resolve();
      }, r.clear = function (e) {
        if (e) a(n[e]), delete n[e];else for (var t in n) r.clear(t);
      };
    }, {}],
    250: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric");
      t.exports = function (e, t) {
        if (e > 0) return Math.log(e) / Math.LN10;
        var r = Math.log(Math.min(t[0], t[1])) / Math.LN10;
        return n(r) || (r = Math.log(Math.max(t[0], t[1])) / Math.LN10 - 6), r;
      };
    }, {
      "fast-isnumeric": 11
    }],
    251: [function (e, t, r) {
      "use strict";

      t.exports = {
        moduleType: "locale",
        name: "en-US",
        dictionary: {
          "Click to enter Colorscale title": "Click to enter Colorscale title"
        },
        format: {
          date: "%m/%d/%Y"
        }
      };
    }, {}],
    252: [function (e, t, r) {
      "use strict";

      t.exports = {
        moduleType: "locale",
        name: "en",
        dictionary: {
          "Click to enter Colorscale title": "Click to enter Colourscale title"
        },
        format: {
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          periods: ["AM", "PM"],
          dateTime: "%a %b %e %X %Y",
          date: "%d/%m/%Y",
          time: "%H:%M:%S",
          decimal: ".",
          thousands: ",",
          grouping: [3],
          currency: ["$", ""],
          year: "%Y",
          month: "%b %Y",
          dayMonth: "%b %-d",
          dayMonthYear: "%b %-d, %Y"
        }
      };
    }, {}],
    253: [function (e, t, r) {
      "use strict";

      var n = e("../registry");
      t.exports = function (e) {
        for (var t, r, a = n.layoutArrayContainers, i = n.layoutArrayRegexes, o = e.split("[")[0], l = 0; l < i.length; l++) if ((r = e.match(i[l])) && 0 === r.index) {
          t = r[0];
          break;
        }
        if (t || (t = a[a.indexOf(o)]), !t) return !1;
        var s = e.substr(t.length);
        return s ? !!(r = s.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/)) && {
          array: t,
          index: Number(r[1]),
          property: r[3] || ""
        } : {
          array: t,
          index: "",
          property: ""
        };
      };
    }, {
      "../registry": 309
    }],
    254: [function (e, t, r) {
      "use strict";

      var n = e("../lib"),
        a = n.extendFlat,
        i = n.isPlainObject,
        o = {
          valType: "flaglist",
          extras: ["none"],
          flags: ["calc", "clearAxisTypes", "plot", "style", "markerSize", "colorbars"]
        },
        l = {
          valType: "flaglist",
          extras: ["none"],
          flags: ["calc", "plot", "legend", "ticks", "axrange", "layoutstyle", "modebar", "camera", "arraydraw", "colorbars"]
        },
        s = o.flags.slice().concat(["fullReplot"]),
        c = l.flags.slice().concat("layoutReplot");
      function u(e) {
        for (var t = {}, r = 0; r < e.length; r++) t[e[r]] = !1;
        return t;
      }
      function d(e, t, r) {
        var n = a({}, e);
        for (var o in n) {
          var l = n[o];
          i(l) && (n[o] = f(l, t, r, o));
        }
        return "from-root" === r && (n.editType = t), n;
      }
      function f(e, t, r, n) {
        if (e.valType) {
          var i = a({}, e);
          if (i.editType = t, Array.isArray(e.items)) {
            i.items = new Array(e.items.length);
            for (var o = 0; o < e.items.length; o++) i.items[o] = f(e.items[o], t, "from-root");
          }
          return i;
        }
        return d(e, t, "_" === n.charAt(0) ? "nested" : "from-root");
      }
      t.exports = {
        traces: o,
        layout: l,
        traceFlags: function traceFlags() {
          return u(s);
        },
        layoutFlags: function layoutFlags() {
          return u(c);
        },
        update: function update(e, t) {
          var r = t.editType;
          if (r && "none" !== r) for (var n = r.split("+"), a = 0; a < n.length; a++) e[n[a]] = !0;
        },
        overrideAll: d
      };
    }, {
      "../lib": 225
    }],
    255: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("gl-mat4/fromQuat"),
        i = e("../registry"),
        o = e("../lib"),
        l = e("../plots/plots"),
        s = e("../plots/cartesian/axis_ids"),
        c = e("../components/color"),
        u = s.cleanId,
        d = s.getFromTrace,
        f = i.traceIs;
      function h(e, t) {
        var r = e[t],
          n = t.charAt(0);
        r && "paper" !== r && (e[t] = u(r, n, !0));
      }
      function p(e) {
        function t(t, r) {
          var n = e[t],
            a = e.title && e.title[r];
          n && !a && (e.title || (e.title = {}), e.title[r] = e[t], delete e[t]);
        }
        e && ("string" != typeof e.title && "number" != typeof e.title || (e.title = {
          text: e.title
        }), t("titlefont", "font"), t("titleposition", "position"), t("titleside", "side"), t("titleoffset", "offset"));
      }
      function g(e) {
        if (!o.isPlainObject(e)) return !1;
        var t = e.name;
        return delete e.name, delete e.showlegend, ("string" == typeof t || "number" == typeof t) && String(t);
      }
      function m(e, t, r, n) {
        if (r && !n) return e;
        if (n && !r) return t;
        if (!e.trim()) return t;
        if (!t.trim()) return e;
        var a,
          i = Math.min(e.length, t.length);
        for (a = 0; a < i && e.charAt(a) === t.charAt(a); a++);
        return e.substr(0, a).trim();
      }
      function y(e) {
        var t = "middle",
          r = "center";
        return "string" == typeof e && (-1 !== e.indexOf("top") ? t = "top" : -1 !== e.indexOf("bottom") && (t = "bottom"), -1 !== e.indexOf("left") ? r = "left" : -1 !== e.indexOf("right") && (r = "right")), t + " " + r;
      }
      function v(e, t) {
        return t in e && "object" == typeof e[t] && 0 === Object.keys(e[t]).length;
      }
      r.clearPromiseQueue = function (e) {
        Array.isArray(e._promises) && e._promises.length > 0 && o.log("Clearing previous rejected promises from queue."), e._promises = [];
      }, r.cleanLayout = function (e) {
        var t, n;
        e || (e = {}), e.xaxis1 && (e.xaxis || (e.xaxis = e.xaxis1), delete e.xaxis1), e.yaxis1 && (e.yaxis || (e.yaxis = e.yaxis1), delete e.yaxis1), e.scene1 && (e.scene || (e.scene = e.scene1), delete e.scene1);
        var i = (l.subplotsRegistry.cartesian || {}).attrRegex,
          s = (l.subplotsRegistry.polar || {}).attrRegex,
          d = (l.subplotsRegistry.ternary || {}).attrRegex,
          f = (l.subplotsRegistry.gl3d || {}).attrRegex,
          g = Object.keys(e);
        for (t = 0; t < g.length; t++) {
          var m = g[t];
          if (i && i.test(m)) {
            var y = e[m];
            y.anchor && "free" !== y.anchor && (y.anchor = u(y.anchor)), y.overlaying && (y.overlaying = u(y.overlaying)), y.type || (y.isdate ? y.type = "date" : y.islog ? y.type = "log" : !1 === y.isdate && !1 === y.islog && (y.type = "linear")), "withzero" !== y.autorange && "tozero" !== y.autorange || (y.autorange = !0, y.rangemode = "tozero"), delete y.islog, delete y.isdate, delete y.categories, v(y, "domain") && delete y.domain, void 0 !== y.autotick && (void 0 === y.tickmode && (y.tickmode = y.autotick ? "auto" : "linear"), delete y.autotick), p(y);
          } else if (s && s.test(m)) {
            p(e[m].radialaxis);
          } else if (d && d.test(m)) {
            var x = e[m];
            p(x.aaxis), p(x.baxis), p(x.caxis);
          } else if (f && f.test(m)) {
            var b = e[m],
              _ = b.cameraposition;
            if (Array.isArray(_) && 4 === _[0].length) {
              var w = _[0],
                M = _[1],
                T = _[2],
                k = a([], w),
                A = [];
              for (n = 0; n < 3; ++n) A[n] = M[n] + T * k[2 + 4 * n];
              b.camera = {
                eye: {
                  x: A[0],
                  y: A[1],
                  z: A[2]
                },
                center: {
                  x: M[0],
                  y: M[1],
                  z: M[2]
                },
                up: {
                  x: 0,
                  y: 0,
                  z: 1
                }
              }, delete b.cameraposition;
            }
            p(b.xaxis), p(b.yaxis), p(b.zaxis);
          }
        }
        var L = Array.isArray(e.annotations) ? e.annotations.length : 0;
        for (t = 0; t < L; t++) {
          var D = e.annotations[t];
          o.isPlainObject(D) && (D.ref && ("paper" === D.ref ? (D.xref = "paper", D.yref = "paper") : "data" === D.ref && (D.xref = "x", D.yref = "y"), delete D.ref), h(D, "xref"), h(D, "yref"));
        }
        var S = Array.isArray(e.shapes) ? e.shapes.length : 0;
        for (t = 0; t < S; t++) {
          var C = e.shapes[t];
          o.isPlainObject(C) && (h(C, "xref"), h(C, "yref"));
        }
        var O = Array.isArray(e.images) ? e.images.length : 0;
        for (t = 0; t < O; t++) {
          var P = e.images[t];
          o.isPlainObject(P) && (h(P, "xref"), h(P, "yref"));
        }
        var I = e.legend;
        return I && (I.x > 3 ? (I.x = 1.02, I.xanchor = "left") : I.x < -2 && (I.x = -.02, I.xanchor = "right"), I.y > 3 ? (I.y = 1.02, I.yanchor = "bottom") : I.y < -2 && (I.y = -.02, I.yanchor = "top")), p(e), "rotate" === e.dragmode && (e.dragmode = "orbit"), c.clean(e), e.template && e.template.layout && r.cleanLayout(e.template.layout), e;
      }, r.cleanData = function (e) {
        for (var t = 0; t < e.length; t++) {
          var n,
            a = e[t];
          if ("histogramy" === a.type && "xbins" in a && !("ybins" in a) && (a.ybins = a.xbins, delete a.xbins), a.error_y && "opacity" in a.error_y) {
            var s = c.defaults,
              d = a.error_y.color || (f(a, "bar") ? c.defaultLine : s[t % s.length]);
            a.error_y.color = c.addOpacity(c.rgb(d), c.opacity(d) * a.error_y.opacity), delete a.error_y.opacity;
          }
          if ("bardir" in a && ("h" !== a.bardir || !f(a, "bar") && "histogram" !== a.type.substr(0, 9) || (a.orientation = "h", r.swapXYData(a)), delete a.bardir), "histogramy" === a.type && r.swapXYData(a), "histogramx" !== a.type && "histogramy" !== a.type || (a.type = "histogram"), "scl" in a && !("colorscale" in a) && (a.colorscale = a.scl, delete a.scl), "reversescl" in a && !("reversescale" in a) && (a.reversescale = a.reversescl, delete a.reversescl), a.xaxis && (a.xaxis = u(a.xaxis, "x")), a.yaxis && (a.yaxis = u(a.yaxis, "y")), f(a, "gl3d") && a.scene && (a.scene = l.subplotsRegistry.gl3d.cleanId(a.scene)), !f(a, "pie-like") && !f(a, "bar-like")) if (Array.isArray(a.textposition)) for (n = 0; n < a.textposition.length; n++) a.textposition[n] = y(a.textposition[n]);else a.textposition && (a.textposition = y(a.textposition));
          var h = i.getModule(a);
          if (h && h.colorbar) {
            var x = h.colorbar.container,
              b = x ? a[x] : a;
            b && b.colorscale && ("YIGnBu" === b.colorscale && (b.colorscale = "YlGnBu"), "YIOrRd" === b.colorscale && (b.colorscale = "YlOrRd"));
          }
          if ("surface" === a.type && o.isPlainObject(a.contours)) {
            var _ = ["x", "y", "z"];
            for (n = 0; n < _.length; n++) {
              var w = a.contours[_[n]];
              o.isPlainObject(w) && (w.highlightColor && (w.highlightcolor = w.highlightColor, delete w.highlightColor), w.highlightWidth && (w.highlightwidth = w.highlightWidth, delete w.highlightWidth));
            }
          }
          if ("candlestick" === a.type || "ohlc" === a.type) {
            var M = !1 !== (a.increasing || {}).showlegend,
              T = !1 !== (a.decreasing || {}).showlegend,
              k = g(a.increasing),
              A = g(a.decreasing);
            if (!1 !== k && !1 !== A) {
              var L = m(k, A, M, T);
              L && (a.name = L);
            } else !k && !A || a.name || (a.name = k || A);
          }
          if (Array.isArray(a.transforms)) {
            var D = a.transforms;
            for (n = 0; n < D.length; n++) {
              var S = D[n];
              if (o.isPlainObject(S)) switch (S.type) {
                case "filter":
                  S.filtersrc && (S.target = S.filtersrc, delete S.filtersrc), S.calendar && (S.valuecalendar || (S.valuecalendar = S.calendar), delete S.calendar);
                  break;
                case "groupby":
                  if (S.styles = S.styles || S.style, S.styles && !Array.isArray(S.styles)) {
                    var C = S.styles,
                      O = Object.keys(C);
                    S.styles = [];
                    for (var P = 0; P < O.length; P++) S.styles.push({
                      target: O[P],
                      value: C[O[P]]
                    });
                  }
              }
            }
          }
          v(a, "line") && delete a.line, "marker" in a && (v(a.marker, "line") && delete a.marker.line, v(a, "marker") && delete a.marker), c.clean(a), a.autobinx && (delete a.autobinx, delete a.xbins), a.autobiny && (delete a.autobiny, delete a.ybins), p(a), a.colorbar && p(a.colorbar), a.marker && a.marker.colorbar && p(a.marker.colorbar), a.line && a.line.colorbar && p(a.line.colorbar), a.aaxis && p(a.aaxis), a.baxis && p(a.baxis);
        }
      }, r.swapXYData = function (e) {
        var t;
        if (o.swapAttrs(e, ["?", "?0", "d?", "?bins", "nbins?", "autobin?", "?src", "error_?"]), Array.isArray(e.z) && Array.isArray(e.z[0]) && (e.transpose ? delete e.transpose : e.transpose = !0), e.error_x && e.error_y) {
          var r = e.error_y,
            n = "copy_ystyle" in r ? r.copy_ystyle : !(r.color || r.thickness || r.width);
          o.swapAttrs(e, ["error_?.copy_ystyle"]), n && o.swapAttrs(e, ["error_?.color", "error_?.thickness", "error_?.width"]);
        }
        if ("string" == typeof e.hoverinfo) {
          var a = e.hoverinfo.split("+");
          for (t = 0; t < a.length; t++) "x" === a[t] ? a[t] = "y" : "y" === a[t] && (a[t] = "x");
          e.hoverinfo = a.join("+");
        }
      }, r.coerceTraceIndices = function (e, t) {
        if (n(t)) return [t];
        if (!Array.isArray(t) || !t.length) return e.data.map(function (e, t) {
          return t;
        });
        if (Array.isArray(t)) {
          for (var r = [], a = 0; a < t.length; a++) o.isIndex(t[a], e.data.length) ? r.push(t[a]) : o.warn("trace index (", t[a], ") is not a number or is out of bounds");
          return r;
        }
        return t;
      }, r.manageArrayContainers = function (e, t, r) {
        var a = e.obj,
          i = e.parts,
          l = i.length,
          s = i[l - 1],
          c = n(s);
        if (c && null === t) {
          var u = i.slice(0, l - 1).join(".");
          o.nestedProperty(a, u).get().splice(s, 1);
        } else c && void 0 === e.get() ? (void 0 === e.get() && (r[e.astr] = null), e.set(t)) : e.set(t);
      };
      var x = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
      function b(e) {
        var t = e.search(x);
        if (t > 0) return e.substr(0, t);
      }
      r.hasParent = function (e, t) {
        for (var r = b(t); r;) {
          if (r in e) return !0;
          r = b(r);
        }
        return !1;
      };
      var _ = ["x", "y", "z"];
      r.clearAxisTypes = function (e, t, r) {
        for (var n = 0; n < t.length; n++) for (var a = e._fullData[n], i = 0; i < 3; i++) {
          var l = d(e, a, _[i]);
          if (l && "log" !== l.type) {
            var s = l._name,
              c = l._id.substr(1);
            if ("scene" === c.substr(0, 5)) {
              if (void 0 !== r[c]) continue;
              s = c + "." + s;
            }
            var u = s + ".type";
            void 0 === r[s] && void 0 === r[u] && o.nestedProperty(e.layout, u).set(null);
          }
        }
      };
    }, {
      "../components/color": 96,
      "../lib": 225,
      "../plots/cartesian/axis_ids": 276,
      "../plots/plots": 307,
      "../registry": 309,
      "fast-isnumeric": 11,
      "gl-mat4/fromQuat": 17
    }],
    256: [function (e, t, r) {
      "use strict";

      var n = e("./plot_api");
      r._doPlot = n._doPlot, r.newPlot = n.newPlot, r.restyle = n.restyle, r.relayout = n.relayout, r.redraw = n.redraw, r.update = n.update, r._guiRestyle = n._guiRestyle, r._guiRelayout = n._guiRelayout, r._guiUpdate = n._guiUpdate, r._storeDirectGUIEdit = n._storeDirectGUIEdit, r.react = n.react, r.extendTraces = n.extendTraces, r.prependTraces = n.prependTraces, r.addTraces = n.addTraces, r.deleteTraces = n.deleteTraces, r.moveTraces = n.moveTraces, r.purge = n.purge, r.addFrames = n.addFrames, r.deleteFrames = n.deleteFrames, r.animate = n.animate, r.setPlotConfig = n.setPlotConfig, r.toImage = e("./to_image"), r.validate = e("./validate"), r.downloadImage = e("../snapshot/download");
      var a = e("./template_api");
      r.makeTemplate = a.makeTemplate, r.validateTemplate = a.validateTemplate;
    }, {
      "../snapshot/download": 311,
      "./plot_api": 258,
      "./template_api": 263,
      "./to_image": 264,
      "./validate": 265
    }],
    257: [function (e, t, r) {
      "use strict";

      var n = e("../lib/is_plain_object"),
        a = e("../lib/noop"),
        i = e("../lib/loggers"),
        o = e("../lib/search").sorterAsc,
        l = e("../registry");
      r.containerArrayMatch = e("./container_array_match");
      var s = r.isAddVal = function (e) {
          return "add" === e || n(e);
        },
        c = r.isRemoveVal = function (e) {
          return null === e || "remove" === e;
        };
      r.applyContainerArrayChanges = function (e, t, r, n, u) {
        var d = t.astr,
          f = l.getComponentMethod(d, "supplyLayoutDefaults"),
          h = l.getComponentMethod(d, "draw"),
          p = l.getComponentMethod(d, "drawOne"),
          g = n.replot || n.recalc || f === a || h === a,
          m = e.layout,
          y = e._fullLayout;
        if (r[""]) {
          Object.keys(r).length > 1 && i.warn("Full array edits are incompatible with other edits", d);
          var v = r[""][""];
          if (c(v)) t.set(null);else {
            if (!Array.isArray(v)) return i.warn("Unrecognized full array edit value", d, v), !0;
            t.set(v);
          }
          return !g && (f(m, y), h(e), !0);
        }
        var x,
          b,
          _,
          w,
          M,
          T,
          k,
          A,
          L = Object.keys(r).map(Number).sort(o),
          D = t.get(),
          S = D || [],
          C = u(y, d).get(),
          O = [],
          P = -1,
          I = S.length;
        for (x = 0; x < L.length; x++) if (w = r[_ = L[x]], M = Object.keys(w), T = w[""], k = s(T), _ < 0 || _ > S.length - (k ? 0 : 1)) i.warn("index out of range", d, _);else if (void 0 !== T) M.length > 1 && i.warn("Insertion & removal are incompatible with edits to the same index.", d, _), c(T) ? O.push(_) : k ? ("add" === T && (T = {}), S.splice(_, 0, T), C && C.splice(_, 0, {})) : i.warn("Unrecognized full object edit value", d, _, T), -1 === P && (P = _);else for (b = 0; b < M.length; b++) A = d + "[" + _ + "].", u(S[_], M[b], A).set(w[M[b]]);
        for (x = O.length - 1; x >= 0; x--) S.splice(O[x], 1), C && C.splice(O[x], 1);
        if (S.length ? D || t.set(S) : t.set(null), g) return !1;
        if (f(m, y), p !== a) {
          var z;
          if (-1 === P) z = L;else {
            for (I = Math.max(S.length, I), z = [], x = 0; x < L.length && !((_ = L[x]) >= P); x++) z.push(_);
            for (x = P; x < I; x++) z.push(x);
          }
          for (x = 0; x < z.length; x++) p(e, z[x]);
        } else h(e);
        return !0;
      };
    }, {
      "../lib/is_plain_object": 226,
      "../lib/loggers": 229,
      "../lib/noop": 234,
      "../lib/search": 244,
      "../registry": 309,
      "./container_array_match": 253
    }],
    258: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("fast-isnumeric"),
        i = e("has-hover"),
        o = e("../lib"),
        l = o.nestedProperty,
        s = e("../lib/events"),
        c = e("../lib/queue"),
        u = e("../registry"),
        d = e("./plot_schema"),
        f = e("../plots/plots"),
        h = e("../plots/cartesian/axes"),
        p = e("../components/drawing"),
        g = e("../components/color"),
        m = e("../plots/cartesian/graph_interact").initInteractions,
        y = e("../constants/xmlns_namespaces"),
        v = e("../plots/cartesian/select").clearSelect,
        x = e("./plot_config").dfltConfig,
        b = e("./manage_arrays"),
        _ = e("./helpers"),
        w = e("./subroutines"),
        M = e("./edit_types"),
        T = e("../plots/cartesian/constants").AX_NAME_PATTERN,
        k = 0;
      function A(e) {
        var t = e._fullLayout;
        t._redrawFromAutoMarginCount ? t._redrawFromAutoMarginCount-- : e.emit("plotly_afterplot");
      }
      function L(e, t) {
        try {
          e._fullLayout._paper.style("background", t);
        } catch (e) {
          o.error(e);
        }
      }
      function D(e, t) {
        L(e, g.combine(t, "white"));
      }
      function S(e, t) {
        if (!e._context) {
          e._context = o.extendDeep({}, x);
          var r = n.select("base");
          e._context._baseUrl = r.size() && r.attr("href") ? window.location.href.split("#")[0] : "";
        }
        var a,
          l,
          s,
          c = e._context;
        if (t) {
          for (l = Object.keys(t), a = 0; a < l.length; a++) "editable" !== (s = l[a]) && "edits" !== s && s in c && ("setBackground" === s && "opaque" === t[s] ? c[s] = D : c[s] = t[s]);
          t.plot3dPixelRatio && !c.plotGlPixelRatio && (c.plotGlPixelRatio = c.plot3dPixelRatio);
          var u = t.editable;
          if (void 0 !== u) for (c.editable = u, l = Object.keys(c.edits), a = 0; a < l.length; a++) c.edits[l[a]] = u;
          if (t.edits) for (l = Object.keys(t.edits), a = 0; a < l.length; a++) (s = l[a]) in c.edits && (c.edits[s] = t.edits[s]);
          c._exportedPlot = t._exportedPlot;
        }
        c.staticPlot && (c.editable = !1, c.edits = {}, c.autosizable = !1, c.scrollZoom = !1, c.doubleClick = !1, c.showTips = !1, c.showLink = !1, c.displayModeBar = !1), "hover" !== c.displayModeBar || i || (c.displayModeBar = !0), "transparent" !== c.setBackground && "function" == typeof c.setBackground || (c.setBackground = L), c._hasZeroHeight = c._hasZeroHeight || 0 === e.clientHeight, c._hasZeroWidth = c._hasZeroWidth || 0 === e.clientWidth;
        var d = c.scrollZoom,
          f = c._scrollZoom = {};
        if (!0 === d) f.cartesian = 1, f.gl3d = 1, f.geo = 1, f.mapbox = 1;else if ("string" == typeof d) {
          var h = d.split("+");
          for (a = 0; a < h.length; a++) f[h[a]] = 1;
        } else !1 !== d && (f.gl3d = 1, f.geo = 1, f.mapbox = 1);
      }
      function C(e, t) {
        var r,
          n,
          a = t + 1,
          i = [];
        for (r = 0; r < e.length; r++) (n = e[r]) < 0 ? i.push(a + n) : i.push(n);
        return i;
      }
      function O(e, t, r) {
        var n, a;
        for (n = 0; n < t.length; n++) {
          if ((a = t[n]) !== parseInt(a, 10)) throw new Error("all values in " + r + " must be integers");
          if (a >= e.data.length || a < -e.data.length) throw new Error(r + " must be valid indices for gd.data.");
          if (t.indexOf(a, n + 1) > -1 || a >= 0 && t.indexOf(-e.data.length + a) > -1 || a < 0 && t.indexOf(e.data.length + a) > -1) throw new Error("each index in " + r + " must be unique.");
        }
      }
      function P(e, t, r) {
        if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
        if (void 0 === t) throw new Error("currentIndices is a required argument.");
        if (Array.isArray(t) || (t = [t]), O(e, t, "currentIndices"), void 0 === r || Array.isArray(r) || (r = [r]), void 0 !== r && O(e, r, "newIndices"), void 0 !== r && t.length !== r.length) throw new Error("current and new indices must be of equal length.");
      }
      function I(e, t, r, n, i) {
        !function (e, t, r, n) {
          var a = o.isPlainObject(n);
          if (!Array.isArray(e.data)) throw new Error("gd.data must be an array");
          if (!o.isPlainObject(t)) throw new Error("update must be a key:value object");
          if (void 0 === r) throw new Error("indices must be an integer or array of integers");
          for (var i in O(e, r, "indices"), t) {
            if (!Array.isArray(t[i]) || t[i].length !== r.length) throw new Error("attribute " + i + " must be an array of length equal to indices array length");
            if (a && (!(i in n) || !Array.isArray(n[i]) || n[i].length !== t[i].length)) throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 corrispondence with the keys and number of traces in the update object");
          }
        }(e, t, r, n);
        for (var s = function (e, t, r, n) {
            var i,
              s,
              c,
              u,
              d,
              f = o.isPlainObject(n),
              h = [];
            for (var p in Array.isArray(r) || (r = [r]), r = C(r, e.data.length - 1), t) for (var g = 0; g < r.length; g++) {
              if (i = e.data[r[g]], s = (c = l(i, p)).get(), u = t[p][g], !o.isArrayOrTypedArray(u)) throw new Error("attribute: " + p + " index: " + g + " must be an array");
              if (!o.isArrayOrTypedArray(s)) throw new Error("cannot extend missing or non-array attribute: " + p);
              if (s.constructor !== u.constructor) throw new Error("cannot extend array with an array of a different type: " + p);
              d = f ? n[p][g] : n, a(d) || (d = -1), h.push({
                prop: c,
                target: s,
                insert: u,
                maxp: Math.floor(d)
              });
            }
            return h;
          }(e, t, r, n), c = {}, u = {}, d = 0; d < s.length; d++) {
          var f = s[d].prop,
            h = s[d].maxp,
            p = i(s[d].target, s[d].insert, h);
          f.set(p[0]), Array.isArray(c[f.astr]) || (c[f.astr] = []), c[f.astr].push(p[1]), Array.isArray(u[f.astr]) || (u[f.astr] = []), u[f.astr].push(s[d].target.length);
        }
        return {
          update: c,
          maxPoints: u
        };
      }
      function z(e, t) {
        var r = new e.constructor(e.length + t.length);
        return r.set(e), r.set(t, e.length), r;
      }
      function R(e, t, n, a) {
        e = o.getGraphDiv(e), _.clearPromiseQueue(e);
        var i = {};
        if ("string" == typeof t) i[t] = n;else {
          if (!o.isPlainObject(t)) return o.warn("Restyle fail.", t, n, a), Promise.reject();
          i = o.extendFlat({}, t), void 0 === a && (a = n);
        }
        Object.keys(i).length && (e.changed = !0);
        var l = _.coerceTraceIndices(e, a),
          s = j(e, i, l),
          u = s.flags;
        u.calc && (e.calcdata = void 0), u.clearAxisTypes && _.clearAxisTypes(e, l, {});
        var d = [];
        u.fullReplot ? d.push(r._doPlot) : (d.push(f.previousPromises), f.supplyDefaults(e), u.markerSize && (f.doCalcdata(e), U(d)), u.style && d.push(w.doTraceStyle), u.colorbars && d.push(w.doColorBars), d.push(A)), d.push(f.rehover, f.redrag), c.add(e, R, [e, s.undoit, s.traces], R, [e, s.redoit, s.traces]);
        var h = o.syncOrAsync(d, e);
        return h && h.then || (h = Promise.resolve()), h.then(function () {
          return e.emit("plotly_restyle", s.eventData), e;
        });
      }
      function N(e) {
        return void 0 === e ? null : e;
      }
      function F(e, t) {
        return t ? function (t, r, n) {
          var a = l(t, r),
            i = a.set;
          return a.set = function (t) {
            E((n || "") + r, a.get(), t, e), i(t);
          }, a;
        } : l;
      }
      function E(e, t, r, n) {
        if (Array.isArray(t) || Array.isArray(r)) for (var a = Array.isArray(t) ? t : [], i = Array.isArray(r) ? r : [], l = Math.max(a.length, i.length), s = 0; s < l; s++) E(e + "[" + s + "]", a[s], i[s], n);else if (o.isPlainObject(t) || o.isPlainObject(r)) {
          var c = o.isPlainObject(t) ? t : {},
            u = o.isPlainObject(r) ? r : {},
            d = o.extendFlat({}, c, u);
          for (var f in d) E(e + "." + f, c[f], u[f], n);
        } else void 0 === n[e] && (n[e] = N(t));
      }
      function j(e, t, r) {
        var n,
          a = e._fullLayout,
          i = e._fullData,
          s = e.data,
          c = a._guiEditing,
          p = F(a._preGUI, c),
          g = o.extendDeepAll({}, t);
        H(t);
        var m,
          y = M.traceFlags(),
          v = {},
          x = {};
        function b() {
          return r.map(function () {});
        }
        function w(e) {
          var t = h.id2name(e);
          -1 === m.indexOf(t) && m.push(t);
        }
        function T(e) {
          return "LAYOUT" + e + ".autorange";
        }
        function k(e) {
          return "LAYOUT" + e + ".range";
        }
        function A(e) {
          for (var t = e; t < i.length; t++) if (i[t]._input === s[e]) return i[t];
        }
        function L(n, i, o) {
          if (Array.isArray(n)) n.forEach(function (e) {
            L(e, i, o);
          });else if (!(n in t) && !_.hasParent(t, n)) {
            var l;
            if ("LAYOUT" === n.substr(0, 6)) l = p(e.layout, n.replace("LAYOUT", ""));else {
              var u = r[o];
              l = F(a._tracePreGUI[A(u)._fullInput.uid], c)(s[u], n);
            }
            n in x || (x[n] = b()), void 0 === x[n][o] && (x[n][o] = N(l.get())), void 0 !== i && l.set(i);
          }
        }
        function D(e) {
          return function (t) {
            return i[t][e];
          };
        }
        function S(e) {
          return function (t, n) {
            return !1 === t ? i[r[n]][e] : null;
          };
        }
        for (var C in t) {
          if (_.hasParent(t, C)) throw new Error("cannot set " + C + " and a parent attribute simultaneously");
          var O,
            P,
            I,
            z,
            R,
            E,
            j = t[C];
          if ("autobinx" !== C && "autobiny" !== C || (C = C.charAt(C.length - 1) + "bins", j = Array.isArray(j) ? j.map(S(C)) : !1 === j ? r.map(D(C)) : null), v[C] = j, "LAYOUT" !== C.substr(0, 6)) {
            for (x[C] = b(), n = 0; n < r.length; n++) {
              if (O = s[r[n]], P = A(r[n]), z = (I = F(a._tracePreGUI[P._fullInput.uid], c)(O, C)).get(), void 0 !== (R = Array.isArray(j) ? j[n % j.length] : j)) {
                var B = I.parts[I.parts.length - 1],
                  Y = C.substr(0, C.length - B.length - 1),
                  U = Y ? Y + "." : "",
                  V = Y ? l(P, Y).get() : P;
                if ((E = d.getTraceValObject(P, I.parts)) && E.impliedEdits && null !== R) for (var q in E.impliedEdits) L(o.relativeAttr(C, q), E.impliedEdits[q], n);else if ("thicknessmode" !== B && "lenmode" !== B || z === R || "fraction" !== R && "pixels" !== R || !V) {
                  if ("type" === C && ("pie" === R != ("pie" === z) || "funnelarea" === R != ("funnelarea" === z))) {
                    var G = "x",
                      Z = "y";
                    "bar" !== R && "bar" !== z || "h" !== O.orientation || (G = "y", Z = "x"), o.swapAttrs(O, ["?", "?src"], "labels", G), o.swapAttrs(O, ["d?", "?0"], "label", G), o.swapAttrs(O, ["?", "?src"], "values", Z), "pie" === z || "funnelarea" === z ? (l(O, "marker.color").set(l(O, "marker.colors").get()), a._pielayer.selectAll("g.trace").remove()) : u.traceIs(O, "cartesian") && l(O, "marker.colors").set(l(O, "marker.color").get());
                  }
                } else {
                  var W = a._size,
                    J = V.orient,
                    X = "top" === J || "bottom" === J;
                  if ("thicknessmode" === B) {
                    var Q = X ? W.h : W.w;
                    L(U + "thickness", V.thickness * ("fraction" === R ? 1 / Q : Q), n);
                  } else {
                    var K = X ? W.w : W.h;
                    L(U + "len", V.len * ("fraction" === R ? 1 / K : K), n);
                  }
                }
                x[C][n] = N(z);
                if (-1 !== ["swapxy", "swapxyaxes", "orientation", "orientationaxes"].indexOf(C)) {
                  if ("orientation" === C) {
                    I.set(R);
                    var $ = O.x && !O.y ? "h" : "v";
                    if ((I.get() || $) === P.orientation) continue;
                  } else "orientationaxes" === C && (O.orientation = {
                    v: "h",
                    h: "v"
                  }[P.orientation]);
                  _.swapXYData(O), y.calc = y.clearAxisTypes = !0;
                } else -1 !== f.dataArrayContainers.indexOf(I.parts[0]) ? (_.manageArrayContainers(I, R, x), y.calc = !0) : (E ? E.arrayOk && !u.traceIs(P, "regl") && (o.isArrayOrTypedArray(R) || o.isArrayOrTypedArray(z)) ? y.calc = !0 : M.update(y, E) : y.calc = !0, I.set(R));
              }
            }
            if (-1 !== ["swapxyaxes", "orientationaxes"].indexOf(C) && h.swap(e, r), "orientationaxes" === C) {
              var ee = l(e.layout, "hovermode"),
                te = ee.get();
              "x" === te ? ee.set("y") : "y" === te ? ee.set("x") : "x unified" === te ? ee.set("y unified") : "y unified" === te && ee.set("x unified");
            }
            if (-1 !== ["orientation", "type"].indexOf(C)) {
              for (m = [], n = 0; n < r.length; n++) {
                var re = s[r[n]];
                u.traceIs(re, "cartesian") && (w(re.xaxis || "x"), w(re.yaxis || "y"));
              }
              L(m.map(T), !0, 0), L(m.map(k), [0, 1], 0);
            }
          } else I = p(e.layout, C.replace("LAYOUT", "")), x[C] = [N(I.get())], I.set(Array.isArray(j) ? j[0] : j), y.calc = !0;
        }
        return (y.calc || y.plot) && (y.fullReplot = !0), {
          flags: y,
          undoit: x,
          redoit: v,
          traces: r,
          eventData: o.extendDeepNoArrays([], [g, r])
        };
      }
      function H(e) {
        var t,
          r,
          n,
          a = o.counterRegex("axis", ".title", !1, !1),
          i = /colorbar\.title$/,
          l = Object.keys(e);
        for (t = 0; t < l.length; t++) r = l[t], n = e[r], "title" !== r && !a.test(r) && !i.test(r) || "string" != typeof n && "number" != typeof n ? r.indexOf("titlefont") > -1 ? s(r, r.replace("titlefont", "title.font")) : r.indexOf("titleposition") > -1 ? s(r, r.replace("titleposition", "title.position")) : r.indexOf("titleside") > -1 ? s(r, r.replace("titleside", "title.side")) : r.indexOf("titleoffset") > -1 && s(r, r.replace("titleoffset", "title.offset")) : s(r, r.replace("title", "title.text"));
        function s(t, r) {
          e[r] = e[t], delete e[t];
        }
      }
      function B(e, t, r) {
        e = o.getGraphDiv(e), _.clearPromiseQueue(e);
        var n = {};
        if ("string" == typeof t) n[t] = r;else {
          if (!o.isPlainObject(t)) return o.warn("Relayout fail.", t, r), Promise.reject();
          n = o.extendFlat({}, t);
        }
        Object.keys(n).length && (e.changed = !0);
        var a = Z(e, n),
          i = a.flags;
        i.calc && (e.calcdata = void 0);
        var l = [f.previousPromises];
        i.layoutReplot ? l.push(w.layoutReplot) : Object.keys(n).length && (Y(e, i, a) || f.supplyDefaults(e), i.legend && l.push(w.doLegend), i.layoutstyle && l.push(w.layoutStyles), i.axrange && U(l, a.rangesAltered), i.ticks && l.push(w.doTicksRelayout), i.modebar && l.push(w.doModeBar), i.camera && l.push(w.doCamera), i.colorbars && l.push(w.doColorBars), l.push(A)), l.push(f.rehover, f.redrag), c.add(e, B, [e, a.undoit], B, [e, a.redoit]);
        var s = o.syncOrAsync(l, e);
        return s && s.then || (s = Promise.resolve(e)), s.then(function () {
          return e.emit("plotly_relayout", a.eventData), e;
        });
      }
      function Y(e, t, r) {
        var n = e._fullLayout;
        if (!t.axrange) return !1;
        for (var a in t) if ("axrange" !== a && t[a]) return !1;
        for (var i in r.rangesAltered) {
          var o = h.id2name(i),
            l = e.layout[o],
            s = n[o];
          if (s.autorange = l.autorange, l.range && (s.range = l.range.slice()), s.cleanRange(), s._matchGroup) for (var c in s._matchGroup) if (c !== i) {
            var u = n[h.id2name(c)];
            u.autorange = s.autorange, u.range = s.range.slice(), u._input.range = s.range.slice();
          }
        }
        return !0;
      }
      function U(e, t) {
        var r = t ? function (e) {
          var r = [],
            n = !0;
          for (var a in t) {
            var i = h.getFromId(e, a);
            if (r.push(a), -1 !== (i.ticklabelposition || "").indexOf("inside") && i._anchorAxis && r.push(i._anchorAxis._id), i._matchGroup) for (var o in i._matchGroup) t[o] || r.push(o);
            i.automargin && (n = !1);
          }
          return h.draw(e, r, {
            skipTitle: n
          });
        } : function (e) {
          return h.draw(e, "redraw");
        };
        e.push(v, w.doAutoRangeAndConstraints, r, w.drawData, w.finalDraw);
      }
      var V = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/,
        q = /^[xyz]axis[0-9]*\.autorange$/,
        G = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
      function Z(e, t) {
        var r,
          n,
          a,
          i = e.layout,
          s = e._fullLayout,
          c = s._guiEditing,
          f = F(s._preGUI, c),
          p = Object.keys(t),
          g = h.list(e),
          m = o.extendDeepAll({}, t),
          y = {};
        for (H(t), p = Object.keys(t), n = 0; n < p.length; n++) if (0 === p[n].indexOf("allaxes")) {
          for (a = 0; a < g.length; a++) {
            var v = g[a]._id.substr(1),
              x = -1 !== v.indexOf("scene") ? v + "." : "",
              w = p[n].replace("allaxes", x + g[a]._name);
            t[w] || (t[w] = t[p[n]]);
          }
          delete t[p[n]];
        }
        var k = M.layoutFlags(),
          A = {},
          L = {};
        function D(e, r) {
          if (Array.isArray(e)) e.forEach(function (e) {
            D(e, r);
          });else if (!(e in t) && !_.hasParent(t, e)) {
            var n = f(i, e);
            e in L || (L[e] = N(n.get())), void 0 !== r && n.set(r);
          }
        }
        var S,
          C = {};
        function O(e) {
          var t = h.name2id(e.split(".")[0]);
          return C[t] = 1, t;
        }
        for (var P in t) {
          if (_.hasParent(t, P)) throw new Error("cannot set " + P + " and a parent attribute simultaneously");
          for (var I = f(i, P), z = t[P], R = I.parts.length - 1; R > 0 && "string" != typeof I.parts[R];) R--;
          var E = I.parts[R],
            j = I.parts[R - 1] + "." + E,
            B = I.parts.slice(0, R).join("."),
            Y = l(e.layout, B).get(),
            U = l(s, B).get(),
            Z = I.get();
          if (void 0 !== z) {
            A[P] = z, L[P] = "reverse" === E ? z : N(Z);
            var J = d.getLayoutValObject(s, I.parts);
            if (J && J.impliedEdits && null !== z) for (var X in J.impliedEdits) D(o.relativeAttr(P, X), J.impliedEdits[X]);
            if (-1 !== ["width", "height"].indexOf(P)) {
              if (z) {
                D("autosize", null);
                var Q = "height" === P ? "width" : "height";
                D(Q, s[Q]);
              } else s[P] = e._initialAutoSize[P];
            } else if ("autosize" === P) D("width", z ? null : s.width), D("height", z ? null : s.height);else if (j.match(V)) O(j), l(s, B + "._inputRange").set(null);else if (j.match(q)) {
              O(j), l(s, B + "._inputRange").set(null);
              var K = l(s, B).get();
              K._inputDomain && (K._input.domain = K._inputDomain.slice());
            } else j.match(G) && l(s, B + "._inputDomain").set(null);
            if ("type" === E) {
              S = Y;
              var $ = "linear" === U.type && "log" === z,
                ee = "log" === U.type && "linear" === z;
              if ($ || ee) {
                if (S && S.range) {
                  if (U.autorange) $ && (S.range = S.range[1] > S.range[0] ? [1, 2] : [2, 1]);else {
                    var te = S.range[0],
                      re = S.range[1];
                    $ ? (te <= 0 && re <= 0 && D(B + ".autorange", !0), te <= 0 ? te = re / 1e6 : re <= 0 && (re = te / 1e6), D(B + ".range[0]", Math.log(te) / Math.LN10), D(B + ".range[1]", Math.log(re) / Math.LN10)) : (D(B + ".range[0]", Math.pow(10, te)), D(B + ".range[1]", Math.pow(10, re)));
                  }
                } else D(B + ".autorange", !0);
                Array.isArray(s._subplots.polar) && s._subplots.polar.length && s[I.parts[0]] && "radialaxis" === I.parts[1] && delete s[I.parts[0]]._subplot.viewInitial["radialaxis.range"], u.getComponentMethod("annotations", "convertCoords")(e, U, z, D), u.getComponentMethod("images", "convertCoords")(e, U, z, D);
              } else D(B + ".autorange", !0), D(B + ".range", null);
              l(s, B + "._inputRange").set(null);
            } else if (E.match(T)) {
              var ne = l(s, P).get(),
                ae = (z || {}).type;
              ae && "-" !== ae || (ae = "linear"), u.getComponentMethod("annotations", "convertCoords")(e, ne, ae, D), u.getComponentMethod("images", "convertCoords")(e, ne, ae, D);
            }
            var ie = b.containerArrayMatch(P);
            if (ie) {
              r = ie.array, n = ie.index;
              var oe = ie.property,
                le = J || {
                  editType: "calc"
                };
              "" !== n && "" === oe && (b.isAddVal(z) ? L[P] = null : b.isRemoveVal(z) ? L[P] = (l(i, r).get() || [])[n] : o.warn("unrecognized full object value", t)), M.update(k, le), y[r] || (y[r] = {});
              var se = y[r][n];
              se || (se = y[r][n] = {}), se[oe] = z, delete t[P];
            } else "reverse" === E ? (Y.range ? Y.range.reverse() : (D(B + ".autorange", !0), Y.range = [1, 0]), U.autorange ? k.calc = !0 : k.plot = !0) : (s._has("scatter-like") && s._has("regl") && "dragmode" === P && ("lasso" === z || "select" === z) && "lasso" !== Z && "select" !== Z || s._has("gl2d") ? k.plot = !0 : J ? M.update(k, J) : k.calc = !0, I.set(z));
          }
        }
        for (r in y) {
          b.applyContainerArrayChanges(e, f(i, r), y[r], k, f) || (k.plot = !0);
        }
        for (var ce in C) {
          var ue = (S = h.getFromId(e, ce)) && S._constraintGroup;
          if (ue) for (var de in k.calc = !0, ue) C[de] || (h.getFromId(e, de)._constraintShrinkable = !0);
        }
        return (W(e) || t.height || t.width) && (k.plot = !0), (k.plot || k.calc) && (k.layoutReplot = !0), {
          flags: k,
          rangesAltered: C,
          undoit: L,
          redoit: A,
          eventData: m
        };
      }
      function W(e) {
        var t = e._fullLayout,
          r = t.width,
          n = t.height;
        return e.layout.autosize && f.plotAutoSize(e, e.layout, t), t.width !== r || t.height !== n;
      }
      function J(e, t, n, a) {
        e = o.getGraphDiv(e), _.clearPromiseQueue(e), o.isPlainObject(t) || (t = {}), o.isPlainObject(n) || (n = {}), Object.keys(t).length && (e.changed = !0), Object.keys(n).length && (e.changed = !0);
        var i = _.coerceTraceIndices(e, a),
          l = j(e, o.extendFlat({}, t), i),
          s = l.flags,
          u = Z(e, o.extendFlat({}, n)),
          d = u.flags;
        (s.calc || d.calc) && (e.calcdata = void 0), s.clearAxisTypes && _.clearAxisTypes(e, i, n);
        var h = [];
        d.layoutReplot ? h.push(w.layoutReplot) : s.fullReplot ? h.push(r._doPlot) : (h.push(f.previousPromises), Y(e, d, u) || f.supplyDefaults(e), s.style && h.push(w.doTraceStyle), (s.colorbars || d.colorbars) && h.push(w.doColorBars), d.legend && h.push(w.doLegend), d.layoutstyle && h.push(w.layoutStyles), d.axrange && U(h, u.rangesAltered), d.ticks && h.push(w.doTicksRelayout), d.modebar && h.push(w.doModeBar), d.camera && h.push(w.doCamera), h.push(A)), h.push(f.rehover, f.redrag), c.add(e, J, [e, l.undoit, u.undoit, l.traces], J, [e, l.redoit, u.redoit, l.traces]);
        var p = o.syncOrAsync(h, e);
        return p && p.then || (p = Promise.resolve(e)), p.then(function () {
          return e.emit("plotly_update", {
            data: l.eventData,
            layout: u.eventData
          }), e;
        });
      }
      function X(e) {
        return function (t) {
          t._fullLayout._guiEditing = !0;
          var r = e.apply(null, arguments);
          return t._fullLayout._guiEditing = !1, r;
        };
      }
      var Q = [{
          pattern: /^hiddenlabels/,
          attr: "legend.uirevision"
        }, {
          pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
        }, {
          pattern: /axis\d*\.showspikes$/,
          attr: "modebar.uirevision"
        }, {
          pattern: /(hover|drag)mode$/,
          attr: "modebar.uirevision"
        }, {
          pattern: /^(scene\d*)\.camera/
        }, {
          pattern: /^(geo\d*)\.(projection|center|fitbounds)/
        }, {
          pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
        }, {
          pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
        }, {
          pattern: /^(polar\d*\.angularaxis)\.rotation/
        }, {
          pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
        }, {
          pattern: /^legend\.(x|y)$/,
          attr: "editrevision"
        }, {
          pattern: /^(shapes|annotations)/,
          attr: "editrevision"
        }, {
          pattern: /^title\.text$/,
          attr: "editrevision"
        }],
        K = [{
          pattern: /^selectedpoints$/,
          attr: "selectionrevision"
        }, {
          pattern: /(^|value\.)visible$/,
          attr: "legend.uirevision"
        }, {
          pattern: /^dimensions\[\d+\]\.constraintrange/
        }, {
          pattern: /^node\.(x|y|groups)/
        }, {
          pattern: /^level$/
        }, {
          pattern: /(^|value\.)name$/
        }, {
          pattern: /colorbar\.title\.text$/
        }, {
          pattern: /colorbar\.(x|y)$/,
          attr: "editrevision"
        }];
      function $(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r],
            a = e.match(n.pattern);
          if (a) return {
            head: a[1],
            attr: n.attr
          };
        }
      }
      function ee(e, t) {
        var r = l(t, e).get();
        if (void 0 !== r) return r;
        var n = e.split(".");
        for (n.pop(); n.length > 1;) if (n.pop(), void 0 !== (r = l(t, n.join(".") + ".uirevision").get())) return r;
        return t.uirevision;
      }
      function te(e, t) {
        for (var r = 0; r < t.length; r++) if (t[r]._fullInput.uid === e) return r;
        return -1;
      }
      function re(e, t, r) {
        for (var n = 0; n < t.length; n++) if (t[n].uid === e) return n;
        return !t[r] || t[r].uid ? -1 : r;
      }
      function ne(e, t) {
        var r = o.isPlainObject(e),
          n = Array.isArray(e);
        return r || n ? (r && o.isPlainObject(t) || n && Array.isArray(t)) && JSON.stringify(e) === JSON.stringify(t) : e === t;
      }
      function ae(e, t, r, n) {
        var a,
          i,
          s,
          c = n.getValObject,
          u = n.flags,
          d = n.immutable,
          f = n.inArray,
          h = n.arrayIndex;
        function p() {
          var e = a.editType;
          f && -1 !== e.indexOf("arraydraw") ? o.pushUnique(u.arrays[f], h) : (M.update(u, a), "none" !== e && u.nChanges++, n.transition && a.anim && u.nChangesAnim++, (V.test(s) || q.test(s)) && (u.rangesAltered[r[0]] = 1), G.test(s) && l(t, "_inputDomain").set(null), "datarevision" === i && (u.newDataRevision = 1));
        }
        function g(e) {
          return "data_array" === e.valType || e.arrayOk;
        }
        for (i in e) {
          if (u.calc && !n.transition) return;
          var m = e[i],
            y = t[i],
            v = r.concat(i);
          if (s = v.join("."), "_" !== i.charAt(0) && "function" != typeof m && m !== y) {
            if (("tick0" === i || "dtick" === i) && "geo" !== r[0]) {
              var x = t.tickmode;
              if ("auto" === x || "array" === x || !x) continue;
            }
            if (("range" !== i || !t.autorange) && ("zmin" !== i && "zmax" !== i || "contourcarpet" !== t.type) && (a = c(v)) && (!a._compareAsJSON || JSON.stringify(m) !== JSON.stringify(y))) {
              var b,
                _ = a.valType,
                w = g(a),
                T = Array.isArray(m),
                k = Array.isArray(y);
              if (T && k) {
                var A = "_input_" + i,
                  L = e[A],
                  D = t[A];
                if (Array.isArray(L) && L === D) continue;
              }
              if (void 0 === y) w && T ? u.calc = !0 : p();else if (a._isLinkedToArray) {
                var S = [],
                  C = !1;
                f || (u.arrays[i] = S);
                var O = Math.min(m.length, y.length),
                  P = Math.max(m.length, y.length);
                if (O !== P) {
                  if ("arraydraw" !== a.editType) {
                    p();
                    continue;
                  }
                  C = !0;
                }
                for (b = 0; b < O; b++) ae(m[b], y[b], v.concat(b), o.extendFlat({
                  inArray: i,
                  arrayIndex: b
                }, n));
                if (C) for (b = O; b < P; b++) S.push(b);
              } else !_ && o.isPlainObject(m) ? ae(m, y, v, n) : w ? T && k ? (d && (u.calc = !0), (d || n.newDataRevision) && p()) : T !== k ? u.calc = !0 : p() : T && k && m.length === y.length && String(m) === String(y) || p();
            }
          }
        }
        for (i in t) if (!(i in e) && "_" !== i.charAt(0) && "function" != typeof t[i]) {
          if (g(a = c(r.concat(i))) && Array.isArray(t[i])) return void (u.calc = !0);
          p();
        }
      }
      function ie(e) {
        var t = e._fullLayout,
          r = e.getBoundingClientRect();
        if (!o.equalDomRects(r, t._lastBBox)) {
          var n = t._invTransform = o.inverseTransformMatrix(o.getFullTransformMatrix(e));
          t._invScaleX = Math.sqrt(n[0][0] * n[0][0] + n[0][1] * n[0][1] + n[0][2] * n[0][2]), t._invScaleY = Math.sqrt(n[1][0] * n[1][0] + n[1][1] * n[1][1] + n[1][2] * n[1][2]), t._lastBBox = r;
        }
      }
      r.animate = function (e, t, r) {
        if (e = o.getGraphDiv(e), !o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plotly.com/javascript/animations/");
        var n = e._transitionData;
        n._frameQueue || (n._frameQueue = []);
        var a = (r = f.supplyAnimationDefaults(r)).transition,
          i = r.frame;
        function l(e) {
          return Array.isArray(a) ? e >= a.length ? a[0] : a[e] : a;
        }
        function s(e) {
          return Array.isArray(i) ? e >= i.length ? i[0] : i[e] : i;
        }
        function c(e, t) {
          var r = 0;
          return function () {
            if (e && ++r === t) return e();
          };
        }
        return void 0 === n._frameWaitingCnt && (n._frameWaitingCnt = 0), new Promise(function (i, u) {
          function d() {
            n._currentFrame && n._currentFrame.onComplete && n._currentFrame.onComplete();
            var t = n._currentFrame = n._frameQueue.shift();
            if (t) {
              var r = t.name ? t.name.toString() : null;
              e._fullLayout._currentFrame = r, n._lastFrameAt = Date.now(), n._timeToNext = t.frameOpts.duration, f.transition(e, t.frame.data, t.frame.layout, _.coerceTraceIndices(e, t.frame.traces), t.frameOpts, t.transitionOpts).then(function () {
                t.onComplete && t.onComplete();
              }), e.emit("plotly_animatingframe", {
                name: r,
                frame: t.frame,
                animation: {
                  frame: t.frameOpts,
                  transition: t.transitionOpts
                }
              });
            } else e.emit("plotly_animated"), window.cancelAnimationFrame(n._animationRaf), n._animationRaf = null;
          }
          function h() {
            e.emit("plotly_animating"), n._lastFrameAt = -1 / 0, n._timeToNext = 0, n._runningTransitions = 0, n._currentFrame = null;
            var _t2 = function t() {
              n._animationRaf = window.requestAnimationFrame(_t2), Date.now() - n._lastFrameAt > n._timeToNext && d();
            };
            _t2();
          }
          var p,
            g,
            m = 0;
          function y(e) {
            return Array.isArray(a) ? m >= a.length ? e.transitionOpts = a[m] : e.transitionOpts = a[0] : e.transitionOpts = a, m++, e;
          }
          var v = [],
            x = null == t,
            b = Array.isArray(t);
          if (!x && !b && o.isPlainObject(t)) v.push({
            type: "object",
            data: y(o.extendFlat({}, t))
          });else if (x || -1 !== ["string", "number"].indexOf(typeof t)) for (p = 0; p < n._frames.length; p++) (g = n._frames[p]) && (x || String(g.group) === String(t)) && v.push({
            type: "byname",
            name: String(g.name),
            data: y({
              name: g.name
            })
          });else if (b) for (p = 0; p < t.length; p++) {
            var w = t[p];
            -1 !== ["number", "string"].indexOf(typeof w) ? (w = String(w), v.push({
              type: "byname",
              name: w,
              data: y({
                name: w
              })
            })) : o.isPlainObject(w) && v.push({
              type: "object",
              data: y(o.extendFlat({}, w))
            });
          }
          for (p = 0; p < v.length; p++) if ("byname" === (g = v[p]).type && !n._frameHash[g.data.name]) return o.warn('animate failure: frame not found: "' + g.data.name + '"'), void u();
          -1 !== ["next", "immediate"].indexOf(r.mode) && function () {
            if (0 !== n._frameQueue.length) {
              for (; n._frameQueue.length;) {
                var t = n._frameQueue.pop();
                t.onInterrupt && t.onInterrupt();
              }
              e.emit("plotly_animationinterrupted", []);
            }
          }(), "reverse" === r.direction && v.reverse();
          var M = e._fullLayout._currentFrame;
          if (M && r.fromcurrent) {
            var T = -1;
            for (p = 0; p < v.length; p++) if ("byname" === (g = v[p]).type && g.name === M) {
              T = p;
              break;
            }
            if (T > 0 && T < v.length - 1) {
              var k = [];
              for (p = 0; p < v.length; p++) g = v[p], ("byname" !== v[p].type || p > T) && k.push(g);
              v = k;
            }
          }
          v.length > 0 ? function (t) {
            if (0 !== t.length) {
              for (var a = 0; a < t.length; a++) {
                var o;
                o = "byname" === t[a].type ? f.computeFrame(e, t[a].name) : t[a].data;
                var d = s(a),
                  p = l(a);
                p.duration = Math.min(p.duration, d.duration);
                var g = {
                  frame: o,
                  name: t[a].name,
                  frameOpts: d,
                  transitionOpts: p
                };
                a === t.length - 1 && (g.onComplete = c(i, 2), g.onInterrupt = u), n._frameQueue.push(g);
              }
              "immediate" === r.mode && (n._lastFrameAt = -1 / 0), n._animationRaf || h();
            }
          }(v) : (e.emit("plotly_animated"), i());
        });
      }, r.addFrames = function (e, t, r) {
        if (e = o.getGraphDiv(e), null == t) return Promise.resolve();
        if (!o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plotly.com/javascript/animations/");
        var n,
          a,
          i,
          l,
          s = e._transitionData._frames,
          u = e._transitionData._frameHash;
        if (!Array.isArray(t)) throw new Error("addFrames failure: frameList must be an Array of frame definitions" + t);
        var d = s.length + 2 * t.length,
          h = [],
          p = {};
        for (n = t.length - 1; n >= 0; n--) if (o.isPlainObject(t[n])) {
          var g = t[n].name,
            m = (u[g] || p[g] || {}).name,
            y = t[n].name,
            v = u[m] || p[m];
          m && y && "number" == typeof y && v && k < 5 && (k++, o.warn('addFrames: overwriting frame "' + (u[m] || p[m]).name + '" with a frame whose name of type "number" also equates to "' + m + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.'), 5 === k && o.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.")), p[g] = {
            name: g
          }, h.push({
            frame: f.supplyFrameDefaults(t[n]),
            index: r && void 0 !== r[n] && null !== r[n] ? r[n] : d + n
          });
        }
        h.sort(function (e, t) {
          return e.index > t.index ? -1 : e.index < t.index ? 1 : 0;
        });
        var x = [],
          b = [],
          _ = s.length;
        for (n = h.length - 1; n >= 0; n--) {
          if ("number" == typeof (a = h[n].frame).name && o.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings"), !a.name) for (; u[a.name = "frame " + e._transitionData._counter++];);
          if (u[a.name]) {
            for (i = 0; i < s.length && (s[i] || {}).name !== a.name; i++);
            x.push({
              type: "replace",
              index: i,
              value: a
            }), b.unshift({
              type: "replace",
              index: i,
              value: s[i]
            });
          } else l = Math.max(0, Math.min(h[n].index, _)), x.push({
            type: "insert",
            index: l,
            value: a
          }), b.unshift({
            type: "delete",
            index: l
          }), _++;
        }
        var w = f.modifyFrames,
          M = f.modifyFrames,
          T = [e, b],
          A = [e, x];
        return c && c.add(e, w, T, M, A), f.modifyFrames(e, x);
      }, r.deleteFrames = function (e, t) {
        if (e = o.getGraphDiv(e), !o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
        var r,
          n,
          a = e._transitionData._frames,
          i = [],
          l = [];
        if (!t) for (t = [], r = 0; r < a.length; r++) t.push(r);
        for ((t = t.slice()).sort(), r = t.length - 1; r >= 0; r--) n = t[r], i.push({
          type: "delete",
          index: n
        }), l.unshift({
          type: "insert",
          index: n,
          value: a[n]
        });
        var s = f.modifyFrames,
          u = f.modifyFrames,
          d = [e, l],
          h = [e, i];
        return c && c.add(e, s, d, u, h), f.modifyFrames(e, i);
      }, r.addTraces = function e(t, n, a) {
        t = o.getGraphDiv(t);
        var i,
          l,
          s = [],
          u = r.deleteTraces,
          d = e,
          f = [t, s],
          h = [t, n];
        for (function (e, t, r) {
          var n, a;
          if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
          if (void 0 === t) throw new Error("traces must be defined.");
          for (Array.isArray(t) || (t = [t]), n = 0; n < t.length; n++) if ("object" != typeof (a = t[n]) || Array.isArray(a) || null === a) throw new Error("all values in traces array must be non-array objects");
          if (void 0 === r || Array.isArray(r) || (r = [r]), void 0 !== r && r.length !== t.length) throw new Error("if indices is specified, traces.length must equal indices.length");
        }(t, n, a), Array.isArray(n) || (n = [n]), n = n.map(function (e) {
          return o.extendFlat({}, e);
        }), _.cleanData(n), i = 0; i < n.length; i++) t.data.push(n[i]);
        for (i = 0; i < n.length; i++) s.push(-n.length + i);
        if (void 0 === a) return l = r.redraw(t), c.add(t, u, f, d, h), l;
        Array.isArray(a) || (a = [a]);
        try {
          P(t, s, a);
        } catch (e) {
          throw t.data.splice(t.data.length - n.length, n.length), e;
        }
        return c.startSequence(t), c.add(t, u, f, d, h), l = r.moveTraces(t, s, a), c.stopSequence(t), l;
      }, r.deleteTraces = function e(t, n) {
        t = o.getGraphDiv(t);
        var a,
          i,
          l = [],
          s = r.addTraces,
          u = e,
          d = [t, l, n],
          f = [t, n];
        if (void 0 === n) throw new Error("indices must be an integer or array of integers.");
        for (Array.isArray(n) || (n = [n]), O(t, n, "indices"), (n = C(n, t.data.length - 1)).sort(o.sorterDes), a = 0; a < n.length; a += 1) i = t.data.splice(n[a], 1)[0], l.push(i);
        var h = r.redraw(t);
        return c.add(t, s, d, u, f), h;
      }, r.extendTraces = function e(t, n, a, i) {
        function l(e, t, r) {
          var n, a;
          if (o.isTypedArray(e)) {
            if (r < 0) {
              var i = new e.constructor(0),
                l = z(e, t);
              r < 0 ? (n = l, a = i) : (n = i, a = l);
            } else if (n = new e.constructor(r), a = new e.constructor(e.length + t.length - r), r === t.length) n.set(t), a.set(e);else if (r < t.length) {
              var s = t.length - r;
              n.set(t.subarray(s)), a.set(e), a.set(t.subarray(0, s), e.length);
            } else {
              var c = r - t.length,
                u = e.length - c;
              n.set(e.subarray(u)), n.set(t, c), a.set(e.subarray(0, u));
            }
          } else n = e.concat(t), a = r >= 0 && r < n.length ? n.splice(0, n.length - r) : [];
          return [n, a];
        }
        var s = I(t = o.getGraphDiv(t), n, a, i, l),
          u = r.redraw(t),
          d = [t, s.update, a, s.maxPoints];
        return c.add(t, r.prependTraces, d, e, arguments), u;
      }, r.moveTraces = function e(t, n, a) {
        var i,
          l = [],
          s = [],
          u = e,
          d = e,
          f = [t = o.getGraphDiv(t), a, n],
          h = [t, n, a];
        if (P(t, n, a), n = Array.isArray(n) ? n : [n], void 0 === a) for (a = [], i = 0; i < n.length; i++) a.push(-n.length + i);
        for (a = Array.isArray(a) ? a : [a], n = C(n, t.data.length - 1), a = C(a, t.data.length - 1), i = 0; i < t.data.length; i++) -1 === n.indexOf(i) && l.push(t.data[i]);
        for (i = 0; i < n.length; i++) s.push({
          newIndex: a[i],
          trace: t.data[n[i]]
        });
        for (s.sort(function (e, t) {
          return e.newIndex - t.newIndex;
        }), i = 0; i < s.length; i += 1) l.splice(s[i].newIndex, 0, s[i].trace);
        t.data = l;
        var p = r.redraw(t);
        return c.add(t, u, f, d, h), p;
      }, r.prependTraces = function e(t, n, a, i) {
        function l(e, t, r) {
          var n, a;
          if (o.isTypedArray(e)) {
            if (r <= 0) {
              var i = new e.constructor(0),
                l = z(t, e);
              r < 0 ? (n = l, a = i) : (n = i, a = l);
            } else if (n = new e.constructor(r), a = new e.constructor(e.length + t.length - r), r === t.length) n.set(t), a.set(e);else if (r < t.length) {
              var s = t.length - r;
              n.set(t.subarray(0, s)), a.set(t.subarray(s)), a.set(e, s);
            } else {
              var c = r - t.length;
              n.set(t), n.set(e.subarray(0, c), t.length), a.set(e.subarray(c));
            }
          } else n = t.concat(e), a = r >= 0 && r < n.length ? n.splice(r, n.length) : [];
          return [n, a];
        }
        var s = I(t = o.getGraphDiv(t), n, a, i, l),
          u = r.redraw(t),
          d = [t, s.update, a, s.maxPoints];
        return c.add(t, r.extendTraces, d, e, arguments), u;
      }, r.newPlot = function (e, t, n, a) {
        return e = o.getGraphDiv(e), f.cleanPlot([], {}, e._fullData || [], e._fullLayout || {}), f.purge(e), r._doPlot(e, t, n, a);
      }, r._doPlot = function (e, t, a, i) {
        var l;
        if (e = o.getGraphDiv(e), s.init(e), o.isPlainObject(t)) {
          var c = t;
          t = c.data, a = c.layout, i = c.config, l = c.frames;
        }
        if (!1 === s.triggerHandler(e, "plotly_beforeplot", [t, a, i])) return Promise.reject();
        t || a || o.isPlotDiv(e) || o.warn("Calling _doPlot as if redrawing but this container doesn't yet have a plot.", e), S(e, i), a || (a = {}), n.select(e).classed("js-plotly-plot", !0), p.makeTester(), Array.isArray(e._promises) || (e._promises = []);
        var d = 0 === (e.data || []).length && Array.isArray(t);
        Array.isArray(t) && (_.cleanData(t), d ? e.data = t : e.data.push.apply(e.data, t), e.empty = !1), e.layout && !d || (e.layout = _.cleanLayout(a)), f.supplyDefaults(e);
        var g = e._fullLayout,
          v = g._has("cartesian");
        g._replotting = !0, (d || g._shouldCreateBgLayer) && (!function (e) {
          var t = n.select(e),
            r = e._fullLayout;
          if (r._calcInverseTransform = ie, r._calcInverseTransform(e), r._container = t.selectAll(".plot-container").data([0]), r._container.enter().insert("div", ":first-child").classed("plot-container", !0).classed("plotly", !0), r._paperdiv = r._container.selectAll(".svg-container").data([0]), r._paperdiv.enter().append("div").classed("user-select-none", !0).classed("svg-container", !0).style("position", "relative"), r._glcontainer = r._paperdiv.selectAll(".gl-container").data([{}]), r._glcontainer.enter().append("div").classed("gl-container", !0), r._paperdiv.selectAll(".main-svg").remove(), r._paperdiv.select(".modebar-container").remove(), r._paper = r._paperdiv.insert("svg", ":first-child").classed("main-svg", !0), r._toppaper = r._paperdiv.append("svg").classed("main-svg", !0), r._modebardiv = r._paperdiv.append("div"), delete r._modeBar, r._hoverpaper = r._paperdiv.append("svg").classed("main-svg", !0), !r._uid) {
            var a = {};
            n.selectAll("defs").each(function () {
              this.id && (a[this.id.split("-")[1]] = 1);
            }), r._uid = o.randstr(a);
          }
          r._paperdiv.selectAll(".main-svg").attr(y.svgAttrs), r._defs = r._paper.append("defs").attr("id", "defs-" + r._uid), r._clips = r._defs.append("g").classed("clips", !0), r._topdefs = r._toppaper.append("defs").attr("id", "topdefs-" + r._uid), r._topclips = r._topdefs.append("g").classed("clips", !0), r._bgLayer = r._paper.append("g").classed("bglayer", !0), r._draggers = r._paper.append("g").classed("draglayer", !0);
          var i = r._paper.append("g").classed("layer-below", !0);
          r._imageLowerLayer = i.append("g").classed("imagelayer", !0), r._shapeLowerLayer = i.append("g").classed("shapelayer", !0), r._cartesianlayer = r._paper.append("g").classed("cartesianlayer", !0), r._polarlayer = r._paper.append("g").classed("polarlayer", !0), r._ternarylayer = r._paper.append("g").classed("ternarylayer", !0), r._geolayer = r._paper.append("g").classed("geolayer", !0), r._funnelarealayer = r._paper.append("g").classed("funnelarealayer", !0), r._pielayer = r._paper.append("g").classed("pielayer", !0), r._iciclelayer = r._paper.append("g").classed("iciclelayer", !0), r._treemaplayer = r._paper.append("g").classed("treemaplayer", !0), r._sunburstlayer = r._paper.append("g").classed("sunburstlayer", !0), r._indicatorlayer = r._toppaper.append("g").classed("indicatorlayer", !0), r._glimages = r._paper.append("g").classed("glimages", !0);
          var l = r._toppaper.append("g").classed("layer-above", !0);
          r._imageUpperLayer = l.append("g").classed("imagelayer", !0), r._shapeUpperLayer = l.append("g").classed("shapelayer", !0), r._infolayer = r._toppaper.append("g").classed("infolayer", !0), r._menulayer = r._toppaper.append("g").classed("menulayer", !0), r._zoomlayer = r._toppaper.append("g").classed("zoomlayer", !0), r._hoverlayer = r._hoverpaper.append("g").classed("hoverlayer", !0), r._modebardiv.classed("modebar-container", !0).style("position", "absolute").style("top", "0px").style("right", "0px"), e.emit("plotly_framework");
        }(e), g._shouldCreateBgLayer && delete g._shouldCreateBgLayer), p.initGradients(e), p.initPatterns(e), d && h.saveShowSpikeInitial(e);
        var x = !e.calcdata || e.calcdata.length !== (e._fullData || []).length;
        x && f.doCalcdata(e);
        for (var b = 0; b < e.calcdata.length; b++) e.calcdata[b][0].trace = e._fullData[b];
        e._context.responsive ? e._responsiveChartHandler || (e._responsiveChartHandler = function () {
          o.isHidden(e) || f.resize(e);
        }, window.addEventListener("resize", e._responsiveChartHandler)) : o.clearResponsive(e);
        var M = o.extendFlat({}, g._size),
          T = 0;
        function k() {
          if (f.clearAutoMarginIds(e), w.drawMarginPushers(e), h.allowAutoMargin(e), g._has("pie")) for (var t = e._fullData, r = 0; r < t.length; r++) {
            var n = t[r];
            "pie" === n.type && n.automargin && f.allowAutoMargin(e, "pie." + n.uid + ".automargin");
          }
          return f.doAutoMargin(e), f.previousPromises(e);
        }
        function L() {
          e._transitioning || (w.doAutoRangeAndConstraints(e), d && h.saveRangeInitial(e), u.getComponentMethod("rangeslider", "calcAutorange")(e));
        }
        var D = [f.previousPromises, function () {
          if (l) return r.addFrames(e, l);
        }, function t() {
          for (var r = g._basePlotModules, n = 0; n < r.length; n++) r[n].drawFramework && r[n].drawFramework(e);
          !g._glcanvas && g._has("gl") && (g._glcanvas = g._glcontainer.selectAll(".gl-canvas").data([{
            key: "contextLayer",
            context: !0,
            pick: !1
          }, {
            key: "focusLayer",
            context: !1,
            pick: !1
          }, {
            key: "pickLayer",
            context: !1,
            pick: !0
          }], function (e) {
            return e.key;
          }), g._glcanvas.enter().append("canvas").attr("class", function (e) {
            return "gl-canvas gl-canvas-" + e.key.replace("Layer", "");
          }).style({
            position: "absolute",
            top: 0,
            left: 0,
            overflow: "visible",
            "pointer-events": "none"
          }));
          var a = e._context.plotGlPixelRatio;
          if (g._glcanvas) {
            g._glcanvas.attr("width", g.width * a).attr("height", g.height * a).style("width", g.width + "px").style("height", g.height + "px");
            var i = g._glcanvas.data()[0].regl;
            if (i && (Math.floor(g.width * a) !== i._gl.drawingBufferWidth || Math.floor(g.height * a) !== i._gl.drawingBufferHeight)) {
              var l = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
              if (!T) return o.log(l + " Clearing graph and plotting again."), f.cleanPlot([], {}, e._fullData, g), f.supplyDefaults(e), g = e._fullLayout, f.doCalcdata(e), T++, t();
              o.error(l);
            }
          }
          return "h" === g.modebar.orientation ? g._modebardiv.style("height", null).style("width", "100%") : g._modebardiv.style("width", null).style("height", g.height + "px"), f.previousPromises(e);
        }, k, function () {
          if (f.didMarginChange(M, g._size)) return o.syncOrAsync([k, w.layoutStyles], e);
        }];
        v && D.push(function () {
          if (x) return o.syncOrAsync([u.getComponentMethod("shapes", "calcAutorange"), u.getComponentMethod("annotations", "calcAutorange"), L], e);
          L();
        }), D.push(w.layoutStyles), v && D.push(function () {
          return h.draw(e, d ? "" : "redraw");
        }, function (e) {
          e._fullLayout._insideTickLabelsAutorange && B(e, e._fullLayout._insideTickLabelsAutorange).then(function () {
            e._fullLayout._insideTickLabelsAutorange = void 0;
          });
        }), D.push(w.drawData, w.finalDraw, m, f.addLinks, f.rehover, f.redrag, f.doAutoMargin, function (e) {
          e._fullLayout._insideTickLabelsAutorange && d && h.saveRangeInitial(e, !0);
        }, f.previousPromises);
        var C = o.syncOrAsync(D, e);
        return C && C.then || (C = Promise.resolve()), C.then(function () {
          return A(e), e;
        });
      }, r.purge = function (e) {
        var t = (e = o.getGraphDiv(e))._fullLayout || {},
          r = e._fullData || [];
        return f.cleanPlot([], {}, r, t), f.purge(e), s.purge(e), t._container && t._container.remove(), delete e._context, e;
      }, r.react = function (e, t, n, a) {
        var i, s;
        e = o.getGraphDiv(e), _.clearPromiseQueue(e);
        var c = e._fullData,
          h = e._fullLayout;
        if (o.isPlotDiv(e) && c && h) {
          if (o.isPlainObject(t)) {
            var p = t;
            t = p.data, n = p.layout, a = p.config, i = p.frames;
          }
          var g = !1;
          if (a) {
            var m = o.extendDeep({}, e._context);
            e._context = void 0, S(e, a), g = function e(t, r) {
              var n;
              for (n in t) if ("_" !== n.charAt(0)) {
                var a = t[n],
                  i = r[n];
                if (a !== i) if (o.isPlainObject(a) && o.isPlainObject(i)) {
                  if (e(a, i)) return !0;
                } else {
                  if (!Array.isArray(a) || !Array.isArray(i)) return !0;
                  if (a.length !== i.length) return !0;
                  for (var l = 0; l < a.length; l++) if (a[l] !== i[l]) {
                    if (!o.isPlainObject(a[l]) || !o.isPlainObject(i[l])) return !0;
                    if (e(a[l], i[l])) return !0;
                  }
                }
              }
            }(m, e._context);
          }
          e.data = t || [], _.cleanData(e.data), e.layout = n || {}, _.cleanLayout(e.layout), function (e, t, r, n) {
            var a,
              i,
              s,
              c,
              u,
              d,
              f,
              h,
              p = n._preGUI,
              g = [],
              m = {};
            for (a in p) {
              if (u = $(a, Q)) {
                if (i = u.attr || u.head + ".uirevision", (c = (s = l(n, i).get()) && ee(i, t)) && c === s && (null === (d = p[a]) && (d = void 0), ne(h = (f = l(t, a)).get(), d))) {
                  void 0 === h && "autorange" === a.substr(a.length - 9) && g.push(a.substr(0, a.length - 10)), f.set(N(l(n, a).get()));
                  continue;
                }
              } else o.warn("unrecognized GUI edit: " + a);
              delete p[a], "range[" === a.substr(a.length - 8, 6) && (m[a.substr(0, a.length - 9)] = 1);
            }
            for (var y = 0; y < g.length; y++) {
              var v = g[y];
              if (m[v]) {
                var x = l(t, v).get();
                x && delete x.autorange;
              }
            }
            var b = n._tracePreGUI;
            for (var _ in b) {
              var w,
                M = b[_],
                T = null;
              for (a in M) {
                if (!T) {
                  var k = te(_, r);
                  if (k < 0) {
                    delete b[_];
                    break;
                  }
                  var A = re(_, e, (w = r[k]._fullInput).index);
                  if (A < 0) {
                    delete b[_];
                    break;
                  }
                  T = e[A];
                }
                if (u = $(a, K)) {
                  if (u.attr ? c = (s = l(n, u.attr).get()) && ee(u.attr, t) : (s = w.uirevision, void 0 === (c = T.uirevision) && (c = t.uirevision)), c && c === s && (null === (d = M[a]) && (d = void 0), ne(h = (f = l(T, a)).get(), d))) {
                    f.set(N(l(w, a).get()));
                    continue;
                  }
                } else o.warn("unrecognized GUI edit: " + a + " in trace uid " + _);
                delete M[a];
              }
            }
          }(e.data, e.layout, c, h), f.supplyDefaults(e, {
            skipUpdateCalc: !0
          });
          var y = e._fullData,
            v = e._fullLayout,
            x = void 0 === v.datarevision,
            b = v.transition,
            T = function (e, t, r, n, a) {
              var i = M.layoutFlags();
              function o(e) {
                return d.getLayoutValObject(r, e);
              }
              i.arrays = {}, i.rangesAltered = {}, i.nChanges = 0, i.nChangesAnim = 0, ae(t, r, [], {
                getValObject: o,
                flags: i,
                immutable: n,
                transition: a,
                gd: e
              }), (i.plot || i.calc) && (i.layoutReplot = !0);
              a && i.nChanges && i.nChangesAnim && (i.anim = i.nChanges === i.nChangesAnim ? "all" : "some");
              return i;
            }(e, h, v, x, b),
            k = T.newDataRevision,
            L = function (e, t, r, n, a, i) {
              var o = t.length === r.length;
              if (!a && !o) return {
                fullReplot: !0,
                calc: !0
              };
              var l,
                s,
                c = M.traceFlags();
              c.arrays = {}, c.nChanges = 0, c.nChangesAnim = 0;
              var u = {
                  getValObject: function getValObject(e) {
                    var t = d.getTraceValObject(s, e);
                    return !s._module.animatable && t.anim && (t.anim = !1), t;
                  },
                  flags: c,
                  immutable: n,
                  transition: a,
                  newDataRevision: i,
                  gd: e
                },
                h = {};
              for (l = 0; l < t.length; l++) if (r[l]) {
                if (s = r[l]._fullInput, f.hasMakesDataTransform(s) && (s = r[l]), h[s.uid]) continue;
                h[s.uid] = 1, ae(t[l]._fullInput, s, [], u);
              }
              (c.calc || c.plot) && (c.fullReplot = !0);
              a && c.nChanges && c.nChangesAnim && (c.anim = c.nChanges === c.nChangesAnim && o ? "all" : "some");
              return c;
            }(e, c, y, x, b, k);
          if (W(e) && (T.layoutReplot = !0), L.calc || T.calc) {
            e.calcdata = void 0;
            for (var D = Object.getOwnPropertyNames(v), C = 0; C < D.length; C++) {
              var O = D[C],
                P = O.substring(0, 5);
              if ("xaxis" === P || "yaxis" === P) {
                var I = v[O]._emptyCategories;
                I && I();
              }
            }
          } else f.supplyDefaultsUpdateCalc(e.calcdata, y);
          var z = [];
          if (i && (e._transitionData = {}, f.createTransitionData(e), z.push(function () {
            return r.addFrames(e, i);
          })), v.transition && !g && (L.anim || T.anim)) T.ticks && z.push(w.doTicksRelayout), f.doCalcdata(e), w.doAutoRangeAndConstraints(e), z.push(function () {
            return f.transitionFromReact(e, L, T, h);
          });else if (L.fullReplot || T.layoutReplot || g) e._fullLayout._skipDefaults = !0, z.push(r._doPlot);else {
            for (var R in T.arrays) {
              var F = T.arrays[R];
              if (F.length) {
                var E = u.getComponentMethod(R, "drawOne");
                if (E !== o.noop) for (var j = 0; j < F.length; j++) E(e, F[j]);else {
                  var H = u.getComponentMethod(R, "draw");
                  if (H === o.noop) throw new Error("cannot draw components: " + R);
                  H(e);
                }
              }
            }
            z.push(f.previousPromises), L.style && z.push(w.doTraceStyle), (L.colorbars || T.colorbars) && z.push(w.doColorBars), T.legend && z.push(w.doLegend), T.layoutstyle && z.push(w.layoutStyles), T.axrange && U(z), T.ticks && z.push(w.doTicksRelayout), T.modebar && z.push(w.doModeBar), T.camera && z.push(w.doCamera), z.push(A);
          }
          z.push(f.rehover, f.redrag), (s = o.syncOrAsync(z, e)) && s.then || (s = Promise.resolve(e));
        } else s = r.newPlot(e, t, n, a);
        return s.then(function () {
          return e.emit("plotly_react", {
            data: t,
            layout: n
          }), e;
        });
      }, r.redraw = function (e) {
        if (e = o.getGraphDiv(e), !o.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
        return _.cleanData(e.data), _.cleanLayout(e.layout), e.calcdata = void 0, r._doPlot(e).then(function () {
          return e.emit("plotly_redraw"), e;
        });
      }, r.relayout = B, r.restyle = R, r.setPlotConfig = function (e) {
        return o.extendFlat(x, e);
      }, r.update = J, r._guiRelayout = X(B), r._guiRestyle = X(R), r._guiUpdate = X(J), r._storeDirectGUIEdit = function (e, t, r) {
        for (var n in r) {
          E(n, l(e, n).get(), r[n], t);
        }
      };
    }, {
      "../components/color": 96,
      "../components/drawing": 118,
      "../constants/xmlns_namespaces": 206,
      "../lib": 225,
      "../lib/events": 218,
      "../lib/queue": 240,
      "../plots/cartesian/axes": 272,
      "../plots/cartesian/constants": 279,
      "../plots/cartesian/graph_interact": 282,
      "../plots/cartesian/select": 292,
      "../plots/plots": 307,
      "../registry": 309,
      "./edit_types": 254,
      "./helpers": 255,
      "./manage_arrays": 257,
      "./plot_config": 259,
      "./plot_schema": 260,
      "./subroutines": 262,
      "@plotly/d3": 6,
      "fast-isnumeric": 11,
      "has-hover": 42
    }],
    259: [function (e, t, r) {
      "use strict";

      var n = {
          staticPlot: {
            valType: "boolean",
            dflt: !1
          },
          plotlyServerURL: {
            valType: "string",
            dflt: ""
          },
          editable: {
            valType: "boolean",
            dflt: !1
          },
          edits: {
            annotationPosition: {
              valType: "boolean",
              dflt: !1
            },
            annotationTail: {
              valType: "boolean",
              dflt: !1
            },
            annotationText: {
              valType: "boolean",
              dflt: !1
            },
            axisTitleText: {
              valType: "boolean",
              dflt: !1
            },
            colorbarPosition: {
              valType: "boolean",
              dflt: !1
            },
            colorbarTitleText: {
              valType: "boolean",
              dflt: !1
            },
            legendPosition: {
              valType: "boolean",
              dflt: !1
            },
            legendText: {
              valType: "boolean",
              dflt: !1
            },
            shapePosition: {
              valType: "boolean",
              dflt: !1
            },
            titleText: {
              valType: "boolean",
              dflt: !1
            }
          },
          autosizable: {
            valType: "boolean",
            dflt: !1
          },
          responsive: {
            valType: "boolean",
            dflt: !1
          },
          fillFrame: {
            valType: "boolean",
            dflt: !1
          },
          frameMargins: {
            valType: "number",
            dflt: 0,
            min: 0,
            max: .5
          },
          scrollZoom: {
            valType: "flaglist",
            flags: ["cartesian", "gl3d", "geo", "mapbox"],
            extras: [!0, !1],
            dflt: "gl3d+geo+mapbox"
          },
          doubleClick: {
            valType: "enumerated",
            values: [!1, "reset", "autosize", "reset+autosize"],
            dflt: "reset+autosize"
          },
          doubleClickDelay: {
            valType: "number",
            dflt: 300,
            min: 0
          },
          showAxisDragHandles: {
            valType: "boolean",
            dflt: !0
          },
          showAxisRangeEntryBoxes: {
            valType: "boolean",
            dflt: !0
          },
          showTips: {
            valType: "boolean",
            dflt: !0
          },
          showLink: {
            valType: "boolean",
            dflt: !1
          },
          linkText: {
            valType: "string",
            dflt: "Edit chart",
            noBlank: !0
          },
          sendData: {
            valType: "boolean",
            dflt: !0
          },
          showSources: {
            valType: "any",
            dflt: !1
          },
          displayModeBar: {
            valType: "enumerated",
            values: ["hover", !0, !1],
            dflt: "hover"
          },
          showSendToCloud: {
            valType: "boolean",
            dflt: !1
          },
          showEditInChartStudio: {
            valType: "boolean",
            dflt: !1
          },
          modeBarButtonsToRemove: {
            valType: "any",
            dflt: []
          },
          modeBarButtonsToAdd: {
            valType: "any",
            dflt: []
          },
          modeBarButtons: {
            valType: "any",
            dflt: !1
          },
          toImageButtonOptions: {
            valType: "any",
            dflt: {}
          },
          displaylogo: {
            valType: "boolean",
            dflt: !0
          },
          watermark: {
            valType: "boolean",
            dflt: !1
          },
          plotGlPixelRatio: {
            valType: "number",
            dflt: 2,
            min: 1,
            max: 4
          },
          setBackground: {
            valType: "any",
            dflt: "transparent"
          },
          topojsonURL: {
            valType: "string",
            noBlank: !0,
            dflt: "https://cdn.plot.ly/"
          },
          mapboxAccessToken: {
            valType: "string",
            dflt: null
          },
          logging: {
            valType: "integer",
            min: 0,
            max: 2,
            dflt: 1
          },
          notifyOnLogging: {
            valType: "integer",
            min: 0,
            max: 2,
            dflt: 0
          },
          queueLength: {
            valType: "integer",
            min: 0,
            dflt: 0
          },
          globalTransforms: {
            valType: "any",
            dflt: []
          },
          locale: {
            valType: "string",
            dflt: "en-US"
          },
          locales: {
            valType: "any",
            dflt: {}
          }
        },
        a = {};
      !function e(t, r) {
        for (var n in t) {
          var a = t[n];
          a.valType ? r[n] = a.dflt : (r[n] || (r[n] = {}), e(a, r[n]));
        }
      }(n, a), t.exports = {
        configAttributes: n,
        dfltConfig: a
      };
    }, {}],
    260: [function (e, t, r) {
      "use strict";

      var n = e("../registry"),
        a = e("../lib"),
        i = e("../plots/attributes"),
        o = e("../plots/layout_attributes"),
        l = e("../plots/frame_attributes"),
        s = e("../plots/animation_attributes"),
        c = e("./plot_config").configAttributes,
        u = e("./edit_types"),
        d = a.extendDeepAll,
        f = a.isPlainObject,
        h = a.isArrayOrTypedArray,
        p = a.nestedProperty,
        g = a.valObjectMeta,
        m = ["_isSubplotObj", "_isLinkedToArray", "_arrayAttrRegexps", "_deprecated"];
      function y(e, t, r) {
        if (!e) return !1;
        if (e._isLinkedToArray) if (v(t[r])) r++;else if (r < t.length) return !1;
        for (; r < t.length; r++) {
          var n = e[t[r]];
          if (!f(n)) break;
          if (e = n, r === t.length - 1) break;
          if (e._isLinkedToArray) {
            if (!v(t[++r])) return !1;
          } else if ("info_array" === e.valType) {
            var a = t[++r];
            if (!v(a)) return !1;
            var i = e.items;
            if (Array.isArray(i)) {
              if (a >= i.length) return !1;
              if (2 === e.dimensions) {
                if (r++, t.length === r) return e;
                var o = t[r];
                if (!v(o)) return !1;
                e = i[a][o];
              } else e = i[a];
            } else e = i;
          }
        }
        return e;
      }
      function v(e) {
        return e === Math.round(e) && e >= 0;
      }
      function x() {
        var e,
          t,
          r = {};
        for (e in d(r, o), n.subplotsRegistry) {
          if ((t = n.subplotsRegistry[e]).layoutAttributes) if (Array.isArray(t.attr)) for (var a = 0; a < t.attr.length; a++) w(r, t, t.attr[a]);else w(r, t, "subplot" === t.attr ? t.name : t.attr);
        }
        for (e in n.componentsRegistry) {
          var i = (t = n.componentsRegistry[e]).schema;
          if (i && (i.subplots || i.layout)) {
            var l = i.subplots;
            if (l && l.xaxis && !l.yaxis) for (var s in l.xaxis) delete r.yaxis[s];
          } else "colorscale" === t.name ? d(r, t.layoutAttributes) : t.layoutAttributes && M(r, t.layoutAttributes, t.name);
        }
        return {
          layoutAttributes: _(r)
        };
      }
      function b() {
        var e = {
          frames: d({}, l)
        };
        return _(e), e.frames;
      }
      function _(e) {
        return function (e) {
          r.crawl(e, function (e, t, n) {
            r.isValObject(e) ? !0 !== e.arrayOk && "data_array" !== e.valType || (n[t + "src"] = {
              valType: "string",
              editType: "none"
            }) : f(e) && (e.role = "object");
          });
        }(e), function (e) {
          r.crawl(e, function (e, t, r) {
            if (e) {
              var n = e._isLinkedToArray;
              n && (delete e._isLinkedToArray, r[t] = {
                items: {}
              }, r[t].items[n] = e, r[t].role = "object");
            }
          });
        }(e), function (e) {
          !function e(t) {
            for (var r in t) if (f(t[r])) e(t[r]);else if (Array.isArray(t[r])) for (var n = 0; n < t[r].length; n++) e(t[r][n]);else t[r] instanceof RegExp && (t[r] = t[r].toString());
          }(e);
        }(e), e;
      }
      function w(e, t, r) {
        var n = p(e, r),
          a = d({}, t.layoutAttributes);
        a._isSubplotObj = !0, n.set(a);
      }
      function M(e, t, r) {
        var n = p(e, r);
        n.set(d(n.get() || {}, t));
      }
      r.IS_SUBPLOT_OBJ = "_isSubplotObj", r.IS_LINKED_TO_ARRAY = "_isLinkedToArray", r.DEPRECATED = "_deprecated", r.UNDERSCORE_ATTRS = m, r.get = function () {
        var e = {};
        n.allTypes.forEach(function (t) {
          e[t] = function (e) {
            var t, a;
            t = n.modules[e]._module, a = t.basePlotModule;
            var o = {
                type: null
              },
              l = d({}, i),
              s = d({}, t.attributes);
            r.crawl(s, function (e, t, r, n, a) {
              p(l, a).set(void 0), void 0 === e && p(s, a).set(void 0);
            }), d(o, l), n.traceIs(e, "noOpacity") && delete o.opacity;
            n.traceIs(e, "showLegend") || (delete o.showlegend, delete o.legendgroup);
            n.traceIs(e, "noHover") && (delete o.hoverinfo, delete o.hoverlabel);
            t.selectPoints || delete o.selectedpoints;
            d(o, s), a.attributes && d(o, a.attributes);
            o.type = e;
            var c = {
              meta: t.meta || {},
              categories: t.categories || {},
              animatable: Boolean(t.animatable),
              type: e,
              attributes: _(o)
            };
            if (t.layoutAttributes) {
              var u = {};
              d(u, t.layoutAttributes), c.layoutAttributes = _(u);
            }
            t.animatable || r.crawl(c, function (e) {
              r.isValObject(e) && "anim" in e && delete e.anim;
            });
            return c;
          }(t);
        });
        var t = {};
        return Object.keys(n.transformsRegistry).forEach(function (e) {
          t[e] = function (e) {
            var t = n.transformsRegistry[e],
              r = d({}, t.attributes);
            return Object.keys(n.componentsRegistry).forEach(function (t) {
              var a = n.componentsRegistry[t];
              a.schema && a.schema.transforms && a.schema.transforms[e] && Object.keys(a.schema.transforms[e]).forEach(function (t) {
                M(r, a.schema.transforms[e][t], t);
              });
            }), {
              attributes: _(r)
            };
          }(e);
        }), {
          defs: {
            valObjects: g,
            metaKeys: m.concat(["description", "role", "editType", "impliedEdits"]),
            editType: {
              traces: u.traces,
              layout: u.layout
            },
            impliedEdits: {}
          },
          traces: e,
          layout: x(),
          transforms: t,
          frames: b(),
          animation: _(s),
          config: _(c)
        };
      }, r.crawl = function (e, t, n, a) {
        var i = n || 0;
        a = a || "", Object.keys(e).forEach(function (n) {
          var o = e[n];
          if (-1 === m.indexOf(n)) {
            var l = (a ? a + "." : "") + n;
            t(o, n, e, i, l), r.isValObject(o) || f(o) && "impliedEdits" !== n && r.crawl(o, t, i + 1, l);
          }
        });
      }, r.isValObject = function (e) {
        return e && void 0 !== e.valType;
      }, r.findArrayAttributes = function (e) {
        var t,
          n,
          a = [],
          o = [],
          l = [];
        function s(e, r, i, s) {
          o = o.slice(0, s).concat([r]), l = l.slice(0, s).concat([e && e._isLinkedToArray]), e && ("data_array" === e.valType || !0 === e.arrayOk) && !("colorbar" === o[s - 1] && ("ticktext" === r || "tickvals" === r)) && function e(t, r, i) {
            var s = t[o[r]],
              c = i + o[r];
            if (r === o.length - 1) h(s) && a.push(n + c);else if (l[r]) {
              if (Array.isArray(s)) for (var u = 0; u < s.length; u++) f(s[u]) && e(s[u], r + 1, c + "[" + u + "].");
            } else f(s) && e(s, r + 1, c + ".");
          }(t, 0, "");
        }
        t = e, n = "", r.crawl(i, s), e._module && e._module.attributes && r.crawl(e._module.attributes, s);
        var c = e.transforms;
        if (c) for (var u = 0; u < c.length; u++) {
          var d = c[u],
            p = d._module;
          p && (n = "transforms[" + u + "].", t = d, r.crawl(p.attributes, s));
        }
        return a;
      }, r.getTraceValObject = function (e, t) {
        var r,
          a,
          o = t[0],
          l = 1;
        if ("transforms" === o) {
          if (1 === t.length) return i.transforms;
          var s = e.transforms;
          if (!Array.isArray(s) || !s.length) return !1;
          var c = t[1];
          if (!v(c) || c >= s.length) return !1;
          a = (r = (n.transformsRegistry[s[c].type] || {}).attributes) && r[t[2]], l = 3;
        } else {
          var u = e._module;
          if (u || (u = (n.modules[e.type || i.type.dflt] || {})._module), !u) return !1;
          if (!(a = (r = u.attributes) && r[o])) {
            var d = u.basePlotModule;
            d && d.attributes && (a = d.attributes[o]);
          }
          a || (a = i[o]);
        }
        return y(a, t, l);
      }, r.getLayoutValObject = function (e, t) {
        return y(function (e, t) {
          var r,
            a,
            i,
            l,
            s = e._basePlotModules;
          if (s) {
            var c;
            for (r = 0; r < s.length; r++) {
              if ((i = s[r]).attrRegex && i.attrRegex.test(t)) {
                if (i.layoutAttrOverrides) return i.layoutAttrOverrides;
                !c && i.layoutAttributes && (c = i.layoutAttributes);
              }
              var u = i.baseLayoutAttrOverrides;
              if (u && t in u) return u[t];
            }
            if (c) return c;
          }
          var d = e._modules;
          if (d) for (r = 0; r < d.length; r++) if ((l = d[r].layoutAttributes) && t in l) return l[t];
          for (a in n.componentsRegistry) {
            if ("colorscale" === (i = n.componentsRegistry[a]).name && 0 === t.indexOf("coloraxis")) return i.layoutAttributes[t];
            if (!i.schema && t === i.name) return i.layoutAttributes;
          }
          return t in o && o[t];
        }(e, t[0]), t, 1);
      };
    }, {
      "../lib": 225,
      "../plots/animation_attributes": 266,
      "../plots/attributes": 268,
      "../plots/frame_attributes": 302,
      "../plots/layout_attributes": 305,
      "../registry": 309,
      "./edit_types": 254,
      "./plot_config": 259
    }],
    261: [function (e, t, r) {
      "use strict";

      var n = e("../lib"),
        a = e("../plots/attributes"),
        i = {
          name: {
            valType: "string",
            editType: "none"
          }
        };
      function o(e) {
        return e && "string" == typeof e;
      }
      function l(e) {
        var t = e.length - 1;
        return "s" !== e.charAt(t) && n.warn("bad argument to arrayDefaultKey: " + e), e.substr(0, e.length - 1) + "defaults";
      }
      i.templateitemname = {
        valType: "string",
        editType: "calc"
      }, r.templatedArray = function (e, t) {
        return t._isLinkedToArray = e, t.name = i.name, t.templateitemname = i.templateitemname, t;
      }, r.traceTemplater = function (e) {
        var t,
          r,
          i = {};
        for (t in e) r = e[t], Array.isArray(r) && r.length && (i[t] = 0);
        return {
          newTrace: function newTrace(o) {
            var l = {
              type: t = n.coerce(o, {}, a, "type"),
              _template: null
            };
            if (t in i) {
              r = e[t];
              var s = i[t] % r.length;
              i[t]++, l._template = r[s];
            }
            return l;
          }
        };
      }, r.newContainer = function (e, t, r) {
        var a = e._template,
          i = a && (a[t] || r && a[r]);
        return n.isPlainObject(i) || (i = null), e[t] = {
          _template: i
        };
      }, r.arrayTemplater = function (e, t, r) {
        var n = e._template,
          a = n && n[l(t)],
          i = n && n[t];
        Array.isArray(i) && i.length || (i = []);
        var s = {};
        return {
          newItem: function newItem(e) {
            var t = {
                name: e.name,
                _input: e
              },
              n = t.templateitemname = e.templateitemname;
            if (!o(n)) return t._template = a, t;
            for (var l = 0; l < i.length; l++) {
              var c = i[l];
              if (c.name === n) return s[n] = 1, t._template = c, t;
            }
            return t[r] = e[r] || !1, t._template = !1, t;
          },
          defaultItems: function defaultItems() {
            for (var e = [], t = 0; t < i.length; t++) {
              var r = i[t],
                n = r.name;
              if (o(n) && !s[n]) {
                var a = {
                  _template: r,
                  name: n,
                  _input: {
                    _templateitemname: n
                  }
                };
                a.templateitemname = r.templateitemname, e.push(a), s[n] = 1;
              }
            }
            return e;
          }
        };
      }, r.arrayDefaultKey = l, r.arrayEditor = function (e, t, r) {
        var a = (n.nestedProperty(e, t).get() || []).length,
          i = r._index,
          o = i >= a && (r._input || {})._templateitemname;
        o && (i = a);
        var l,
          s = t + "[" + i + "]";
        function c() {
          l = {}, o && (l[s] = {}, l[s].templateitemname = o);
        }
        function u(e, t) {
          o ? n.nestedProperty(l[s], e).set(t) : l[s + "." + e] = t;
        }
        function d() {
          var e = l;
          return c(), e;
        }
        return c(), {
          modifyBase: function modifyBase(e, t) {
            l[e] = t;
          },
          modifyItem: u,
          getUpdateObj: d,
          applyUpdate: function applyUpdate(t, r) {
            t && u(t, r);
            var a = d();
            for (var i in a) n.nestedProperty(e, i).set(a[i]);
          }
        };
      };
    }, {
      "../lib": 225,
      "../plots/attributes": 268
    }],
    262: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../registry"),
        i = e("../plots/plots"),
        o = e("../lib"),
        l = e("../lib/clear_gl_canvases"),
        s = e("../components/color"),
        c = e("../components/drawing"),
        u = e("../components/titles"),
        d = e("../components/modebar"),
        f = e("../plots/cartesian/axes"),
        h = e("../constants/alignment"),
        p = e("../plots/cartesian/constraints"),
        g = p.enforce,
        m = p.clean,
        y = e("../plots/cartesian/autorange").doAutoRange;
      function v(e, t, r) {
        for (var n = 0; n < r.length; n++) {
          var a = r[n][0],
            i = r[n][1];
          if (!(a[0] >= e[1] || a[1] <= e[0]) && i[0] < t[1] && i[1] > t[0]) return !0;
        }
        return !1;
      }
      function x(e) {
        var t,
          a,
          l,
          u,
          p,
          g,
          m = e._fullLayout,
          y = m._size,
          x = y.p,
          _ = f.list(e, "", !0);
        if (m._paperdiv.style({
          width: e._context.responsive && m.autosize && !e._context._hasZeroWidth && !e.layout.width ? "100%" : m.width + "px",
          height: e._context.responsive && m.autosize && !e._context._hasZeroHeight && !e.layout.height ? "100%" : m.height + "px"
        }).selectAll(".main-svg").call(c.setSize, m.width, m.height), e._context.setBackground(e, m.paper_bgcolor), r.drawMainTitle(e), d.manage(e), !m._has("cartesian")) return i.previousPromises(e);
        function M(e, t, r) {
          var n = e._lw / 2;
          return "x" === e._id.charAt(0) ? t ? "top" === r ? t._offset - x - n : t._offset + t._length + x + n : y.t + y.h * (1 - (e.position || 0)) + n % 1 : t ? "right" === r ? t._offset + t._length + x + n : t._offset - x - n : y.l + y.w * (e.position || 0) + n % 1;
        }
        for (t = 0; t < _.length; t++) {
          var T = (u = _[t])._anchorAxis;
          u._linepositions = {}, u._lw = c.crispRound(e, u.linewidth, 1), u._mainLinePosition = M(u, T, u.side), u._mainMirrorPosition = u.mirror && T ? M(u, T, h.OPPOSITE_SIDE[u.side]) : null;
        }
        var k = [],
          A = [],
          L = [],
          D = 1 === s.opacity(m.paper_bgcolor) && 1 === s.opacity(m.plot_bgcolor) && m.paper_bgcolor === m.plot_bgcolor;
        for (a in m._plots) if ((l = m._plots[a]).mainplot) l.bg && l.bg.remove(), l.bg = void 0;else {
          var S = l.xaxis.domain,
            C = l.yaxis.domain,
            O = l.plotgroup;
          if (v(S, C, L)) {
            var P = O.node(),
              I = l.bg = o.ensureSingle(O, "rect", "bg");
            P.insertBefore(I.node(), P.childNodes[0]), A.push(a);
          } else O.select("rect.bg").remove(), L.push([S, C]), D || (k.push(a), A.push(a));
        }
        var z,
          R,
          N,
          F,
          E,
          j,
          H,
          B,
          Y,
          U,
          V,
          q,
          G,
          Z = m._bgLayer.selectAll(".bg").data(k);
        for (Z.enter().append("rect").classed("bg", !0), Z.exit().remove(), Z.each(function (e) {
          m._plots[e].bg = n.select(this);
        }), t = 0; t < A.length; t++) l = m._plots[A[t]], p = l.xaxis, g = l.yaxis, l.bg && void 0 !== p._offset && void 0 !== g._offset && l.bg.call(c.setRect, p._offset - x, g._offset - x, p._length + 2 * x, g._length + 2 * x).call(s.fill, m.plot_bgcolor).style("stroke-width", 0);
        if (!m._hasOnlyLargeSploms) for (a in m._plots) {
          l = m._plots[a], p = l.xaxis, g = l.yaxis;
          var W,
            J,
            X = l.clipId = "clip" + m._uid + a + "plot",
            Q = o.ensureSingleById(m._clips, "clipPath", X, function (e) {
              e.classed("plotclip", !0).append("rect");
            });
          l.clipRect = Q.select("rect").attr({
            width: p._length,
            height: g._length
          }), c.setTranslate(l.plot, p._offset, g._offset), l._hasClipOnAxisFalse ? (W = null, J = X) : (W = X, J = null), c.setClipUrl(l.plot, W, e), l.layerClipId = J;
        }
        function K(e) {
          return "M" + z + "," + e + "H" + R;
        }
        function $(e) {
          return "M" + p._offset + "," + e + "h" + p._length;
        }
        function ee(e) {
          return "M" + e + "," + B + "V" + H;
        }
        function te(e) {
          return "M" + e + "," + g._offset + "v" + g._length;
        }
        function re(e, t, r) {
          if (!e.showline || a !== e._mainSubplot) return "";
          if (!e._anchorAxis) return r(e._mainLinePosition);
          var n = t(e._mainLinePosition);
          return e.mirror && (n += t(e._mainMirrorPosition)), n;
        }
        for (a in m._plots) {
          l = m._plots[a], p = l.xaxis, g = l.yaxis;
          var ne = "M0,0";
          b(p, a) && (E = w(p, "left", g, _), z = p._offset - (E ? x + E : 0), j = w(p, "right", g, _), R = p._offset + p._length + (j ? x + j : 0), N = M(p, g, "bottom"), F = M(p, g, "top"), !(G = !p._anchorAxis || a !== p._mainSubplot) || "allticks" !== p.mirror && "all" !== p.mirror || (p._linepositions[a] = [N, F]), ne = re(p, K, $), G && p.showline && ("all" === p.mirror || "allticks" === p.mirror) && (ne += K(N) + K(F)), l.xlines.style("stroke-width", p._lw + "px").call(s.stroke, p.showline ? p.linecolor : "rgba(0,0,0,0)")), l.xlines.attr("d", ne);
          var ae = "M0,0";
          b(g, a) && (V = w(g, "bottom", p, _), H = g._offset + g._length + (V ? x : 0), q = w(g, "top", p, _), B = g._offset - (q ? x : 0), Y = M(g, p, "left"), U = M(g, p, "right"), !(G = !g._anchorAxis || a !== g._mainSubplot) || "allticks" !== g.mirror && "all" !== g.mirror || (g._linepositions[a] = [Y, U]), ae = re(g, ee, te), G && g.showline && ("all" === g.mirror || "allticks" === g.mirror) && (ae += ee(Y) + ee(U)), l.ylines.style("stroke-width", g._lw + "px").call(s.stroke, g.showline ? g.linecolor : "rgba(0,0,0,0)")), l.ylines.attr("d", ae);
        }
        return f.makeClipPaths(e), i.previousPromises(e);
      }
      function b(e, t) {
        return (e.ticks || e.showline) && (t === e._mainSubplot || "all" === e.mirror || "allticks" === e.mirror);
      }
      function _(e, t, r) {
        if (!r.showline || !r._lw) return !1;
        if ("all" === r.mirror || "allticks" === r.mirror) return !0;
        var n = r._anchorAxis;
        if (!n) return !1;
        var a = h.FROM_BL[t];
        return r.side === t ? n.domain[a] === e.domain[a] : r.mirror && n.domain[1 - a] === e.domain[1 - a];
      }
      function w(e, t, r, n) {
        if (_(e, t, r)) return r._lw;
        for (var a = 0; a < n.length; a++) {
          var i = n[a];
          if (i._mainAxis === r._mainAxis && _(e, t, i)) return i._lw;
        }
        return 0;
      }
      function M(e, t) {
        var r = e.title,
          n = e._size,
          a = 0;
        switch ("start" === t ? a = r.pad.l : "end" === t && (a = -r.pad.r), r.xref) {
          case "paper":
            return n.l + n.w * r.x + a;
          case "container":
          default:
            return e.width * r.x + a;
        }
      }
      function T(e, t) {
        var r = e.title,
          n = e._size,
          a = 0;
        if ("0em" !== t && t ? t === h.CAP_SHIFT + "em" && (a = r.pad.t) : a = -r.pad.b, "auto" === r.y) return n.t / 2;
        switch (r.yref) {
          case "paper":
            return n.t + n.h - n.h * r.y + a;
          case "container":
          default:
            return e.height - e.height * r.y + a;
        }
      }
      r.layoutStyles = function (e) {
        return o.syncOrAsync([i.doAutoMargin, x], e);
      }, r.drawMainTitle = function (e) {
        var t = e._fullLayout,
          r = function (e) {
            var t = e.title,
              r = "middle";
            o.isRightAnchor(t) ? r = "end" : o.isLeftAnchor(t) && (r = "start");
            return r;
          }(t),
          n = function (e) {
            var t = e.title,
              r = "0em";
            o.isTopAnchor(t) ? r = h.CAP_SHIFT + "em" : o.isMiddleAnchor(t) && (r = h.MID_SHIFT + "em");
            return r;
          }(t);
        u.draw(e, "gtitle", {
          propContainer: t,
          propName: "title.text",
          placeholder: t._dfltTitle.plot,
          attributes: {
            x: M(t, r),
            y: T(t, n),
            "text-anchor": r,
            dy: n
          }
        });
      }, r.doTraceStyle = function (e) {
        var t,
          n = e.calcdata,
          o = [];
        for (t = 0; t < n.length; t++) {
          var s = n[t],
            c = s[0] || {},
            u = c.trace || {},
            d = u._module || {},
            f = d.arraysToCalcdata;
          f && f(s, u);
          var h = d.editStyle;
          h && o.push({
            fn: h,
            cd0: c
          });
        }
        if (o.length) {
          for (t = 0; t < o.length; t++) {
            var p = o[t];
            p.fn(e, p.cd0);
          }
          l(e), r.redrawReglTraces(e);
        }
        return i.style(e), a.getComponentMethod("legend", "draw")(e), i.previousPromises(e);
      }, r.doColorBars = function (e) {
        return a.getComponentMethod("colorbar", "draw")(e), i.previousPromises(e);
      }, r.layoutReplot = function (e) {
        var t = e.layout;
        return e.layout = void 0, a.call("_doPlot", e, "", t);
      }, r.doLegend = function (e) {
        return a.getComponentMethod("legend", "draw")(e), i.previousPromises(e);
      }, r.doTicksRelayout = function (e) {
        return f.draw(e, "redraw"), e._fullLayout._hasOnlyLargeSploms && (a.subplotsRegistry.splom.updateGrid(e), l(e), r.redrawReglTraces(e)), r.drawMainTitle(e), i.previousPromises(e);
      }, r.doModeBar = function (e) {
        var t = e._fullLayout;
        d.manage(e);
        for (var r = 0; r < t._basePlotModules.length; r++) {
          var n = t._basePlotModules[r].updateFx;
          n && n(e);
        }
        return i.previousPromises(e);
      }, r.doCamera = function (e) {
        for (var t = e._fullLayout, r = t._subplots.gl3d, n = 0; n < r.length; n++) {
          var a = t[r[n]];
          a._scene.setViewport(a);
        }
      }, r.drawData = function (e) {
        var t = e._fullLayout;
        l(e);
        for (var n = t._basePlotModules, o = 0; o < n.length; o++) n[o].plot(e);
        return r.redrawReglTraces(e), i.style(e), a.getComponentMethod("shapes", "draw")(e), a.getComponentMethod("annotations", "draw")(e), a.getComponentMethod("images", "draw")(e), t._replotting = !1, i.previousPromises(e);
      }, r.redrawReglTraces = function (e) {
        var t = e._fullLayout;
        if (t._has("regl")) {
          var r,
            n,
            a = e._fullData,
            i = [],
            l = [];
          for (t._hasOnlyLargeSploms && t._splomGrid.draw(), r = 0; r < a.length; r++) {
            var s = a[r];
            !0 === s.visible && 0 !== s._length && ("splom" === s.type ? t._splomScenes[s.uid].draw() : "scattergl" === s.type ? o.pushUnique(i, s.xaxis + s.yaxis) : "scatterpolargl" === s.type && o.pushUnique(l, s.subplot));
          }
          for (r = 0; r < i.length; r++) (n = t._plots[i[r]])._scene && n._scene.draw();
          for (r = 0; r < l.length; r++) (n = t[l[r]]._subplot)._scene && n._scene.draw();
        }
      }, r.doAutoRangeAndConstraints = function (e) {
        for (var t, r = f.list(e, "", !0), n = {}, a = 0; a < r.length; a++) if (!n[(t = r[a])._id]) {
          n[t._id] = 1, m(e, t), y(e, t);
          var i = t._matchGroup;
          if (i) for (var o in i) {
            var l = f.getFromId(e, o);
            y(e, l, t.range), n[o] = 1;
          }
        }
        g(e);
      }, r.finalDraw = function (e) {
        a.getComponentMethod("rangeslider", "draw")(e), a.getComponentMethod("rangeselector", "draw")(e);
      }, r.drawMarginPushers = function (e) {
        a.getComponentMethod("legend", "draw")(e), a.getComponentMethod("rangeselector", "draw")(e), a.getComponentMethod("sliders", "draw")(e), a.getComponentMethod("updatemenus", "draw")(e), a.getComponentMethod("colorbar", "draw")(e);
      };
    }, {
      "../components/color": 96,
      "../components/drawing": 118,
      "../components/modebar": 159,
      "../components/titles": 194,
      "../constants/alignment": 201,
      "../lib": 225,
      "../lib/clear_gl_canvases": 213,
      "../plots/cartesian/autorange": 271,
      "../plots/cartesian/axes": 272,
      "../plots/cartesian/constraints": 280,
      "../plots/plots": 307,
      "../registry": 309,
      "@plotly/d3": 6
    }],
    263: [function (e, t, r) {
      "use strict";

      var n = e("../lib"),
        a = n.isPlainObject,
        i = e("./plot_schema"),
        o = e("../plots/plots"),
        l = e("../plots/attributes"),
        s = e("./plot_template"),
        c = e("./plot_config").dfltConfig;
      function u(e, t) {
        e = n.extendDeep({}, e);
        var r,
          i,
          o = Object.keys(e).sort();
        function l(t, r, n) {
          if (a(r) && a(t)) u(t, r);else if (Array.isArray(r) && Array.isArray(t)) {
            var o = s.arrayTemplater({
              _template: e
            }, n);
            for (i = 0; i < r.length; i++) {
              var l = r[i],
                c = o.newItem(l)._template;
              c && u(c, l);
            }
            var d = o.defaultItems();
            for (i = 0; i < d.length; i++) r.push(d[i]._template);
            for (i = 0; i < r.length; i++) delete r[i].templateitemname;
          }
        }
        for (r = 0; r < o.length; r++) {
          var c = o[r],
            f = e[c];
          if (c in t ? l(f, t[c], c) : t[c] = f, d(c) === c) for (var h in t) {
            var p = d(h);
            h === p || p !== c || h in e || l(f, t[h], c);
          }
        }
      }
      function d(e) {
        return e.replace(/[0-9]+$/, "");
      }
      function f(e, t, r, i, o) {
        var l = o && r(o);
        for (var c in e) {
          var u = e[c],
            h = g(e, c, i),
            p = g(e, c, o),
            m = r(p);
          if (!m) {
            var y = d(c);
            y !== c && (m = r(p = g(e, y, o)));
          }
          if ((!l || l !== m) && !(!m || m._noTemplating || "data_array" === m.valType || m.arrayOk && Array.isArray(u))) if (!m.valType && a(u)) f(u, t, r, h, p);else if (m._isLinkedToArray && Array.isArray(u)) for (var v = !1, x = 0, b = {}, _ = 0; _ < u.length; _++) {
            var w = u[_];
            if (a(w)) {
              var M = w.name;
              if (M) b[M] || (f(w, t, r, g(u, x, h), g(u, x, p)), x++, b[M] = 1);else if (!v) {
                var T = g(e, s.arrayDefaultKey(c), i),
                  k = g(u, x, h);
                f(w, t, r, k, g(u, x, p));
                var A = n.nestedProperty(t, k);
                n.nestedProperty(t, T).set(A.get()), A.set(null), v = !0;
              }
            }
          } else {
            n.nestedProperty(t, h).set(u);
          }
        }
      }
      function h(e, t) {
        return i.getLayoutValObject(e, n.nestedProperty({}, t).parts);
      }
      function p(e, t) {
        return i.getTraceValObject(e, n.nestedProperty({}, t).parts);
      }
      function g(e, t, r) {
        return r ? Array.isArray(e) ? r + "[" + t + "]" : r + "." + t : t;
      }
      function m(e) {
        for (var t = 0; t < e.length; t++) if (a(e[t])) return !0;
      }
      function y(e) {
        var t;
        switch (e.code) {
          case "data":
            t = "The template has no key data.";
            break;
          case "layout":
            t = "The template has no key layout.";
            break;
          case "missing":
            t = e.path ? "There are no templates for item " + e.path + " with name " + e.templateitemname : "There are no templates for trace " + e.index + ", of type " + e.traceType + ".";
            break;
          case "unused":
            t = e.path ? "The template item at " + e.path + " was not used in constructing the plot." : e.dataCount ? "Some of the templates of type " + e.traceType + " were not used. The template has " + e.templateCount + " traces, the data only has " + e.dataCount + " of this type." : "The template has " + e.templateCount + " traces of type " + e.traceType + " but there are none in the data.";
            break;
          case "reused":
            t = "Some of the templates of type " + e.traceType + " were used more than once. The template has " + e.templateCount + " traces, the data has " + e.dataCount + " of this type.";
        }
        return e.msg = t, e;
      }
      r.makeTemplate = function (e) {
        e = n.isPlainObject(e) ? e : n.getGraphDiv(e), e = n.extendDeep({
          _context: c
        }, {
          data: e.data,
          layout: e.layout
        }), o.supplyDefaults(e);
        var t = e.data || [],
          r = e.layout || {};
        r._basePlotModules = e._fullLayout._basePlotModules, r._modules = e._fullLayout._modules;
        var i = {
          data: {},
          layout: {}
        };
        t.forEach(function (e) {
          var t = {};
          f(e, t, p.bind(null, e));
          var r = n.coerce(e, {}, l, "type"),
            a = i.data[r];
          a || (a = i.data[r] = []), a.push(t);
        }), f(r, i.layout, h.bind(null, r)), delete i.layout.template;
        var s = r.template;
        if (a(s)) {
          var d,
            g,
            m,
            y,
            v,
            x,
            b = s.layout;
          a(b) && u(b, i.layout);
          var _ = s.data;
          if (a(_)) {
            for (g in i.data) if (m = _[g], Array.isArray(m)) {
              for (x = (v = i.data[g]).length, y = m.length, d = 0; d < x; d++) u(m[d % y], v[d]);
              for (d = x; d < y; d++) v.push(n.extendDeep({}, m[d]));
            }
            for (g in _) g in i.data || (i.data[g] = n.extendDeep([], _[g]));
          }
        }
        return i;
      }, r.validateTemplate = function (e, t) {
        var r = n.extendDeep({}, {
            _context: c,
            data: e.data,
            layout: e.layout
          }),
          i = r.layout || {};
        a(t) || (t = i.template || {});
        var l = t.layout,
          s = t.data,
          u = [];
        r.layout = i, r.layout.template = t, o.supplyDefaults(r);
        var f = r._fullLayout,
          h = r._fullData,
          p = {};
        if (a(l) ? (!function e(t, r) {
          for (var n in t) if ("_" !== n.charAt(0) && a(t[n])) {
            var i,
              o = d(n),
              l = [];
            for (i = 0; i < r.length; i++) l.push(g(t, n, r[i])), o !== n && l.push(g(t, o, r[i]));
            for (i = 0; i < l.length; i++) p[l[i]] = 1;
            e(t[n], l);
          }
        }(f, ["layout"]), function e(t, r) {
          for (var n in t) if (-1 === n.indexOf("defaults") && a(t[n])) {
            var i = g(t, n, r);
            p[i] ? e(t[n], i) : u.push({
              code: "unused",
              path: i
            });
          }
        }(l, "layout")) : u.push({
          code: "layout"
        }), a(s)) {
          for (var v, x = {}, b = 0; b < h.length; b++) {
            var _ = h[b];
            x[v = _.type] = (x[v] || 0) + 1, _._fullInput._template || u.push({
              code: "missing",
              index: _._fullInput.index,
              traceType: v
            });
          }
          for (v in s) {
            var w = s[v].length,
              M = x[v] || 0;
            w > M ? u.push({
              code: "unused",
              traceType: v,
              templateCount: w,
              dataCount: M
            }) : M > w && u.push({
              code: "reused",
              traceType: v,
              templateCount: w,
              dataCount: M
            });
          }
        } else u.push({
          code: "data"
        });
        if (function e(t, r) {
          for (var n in t) if ("_" !== n.charAt(0)) {
            var i = t[n],
              o = g(t, n, r);
            a(i) ? (Array.isArray(t) && !1 === i._template && i.templateitemname && u.push({
              code: "missing",
              path: o,
              templateitemname: i.templateitemname
            }), e(i, o)) : Array.isArray(i) && m(i) && e(i, o);
          }
        }({
          data: h,
          layout: f
        }, ""), u.length) return u.map(y);
      };
    }, {
      "../lib": 225,
      "../plots/attributes": 268,
      "../plots/plots": 307,
      "./plot_config": 259,
      "./plot_schema": 260,
      "./plot_template": 261
    }],
    264: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("./plot_api"),
        i = e("../plots/plots"),
        o = e("../lib"),
        l = e("../snapshot/helpers"),
        s = e("../snapshot/tosvg"),
        c = e("../snapshot/svgtoimg"),
        u = e("../version").version,
        d = {
          format: {
            valType: "enumerated",
            values: ["png", "jpeg", "webp", "svg", "full-json"],
            dflt: "png"
          },
          width: {
            valType: "number",
            min: 1
          },
          height: {
            valType: "number",
            min: 1
          },
          scale: {
            valType: "number",
            min: 0,
            dflt: 1
          },
          setBackground: {
            valType: "any",
            dflt: !1
          },
          imageDataOnly: {
            valType: "boolean",
            dflt: !1
          }
        };
      t.exports = function (e, t) {
        var r, f, h, p;
        function g(e) {
          return !(e in t) || o.validate(t[e], d[e]);
        }
        if (t = t || {}, o.isPlainObject(e) ? (r = e.data || [], f = e.layout || {}, h = e.config || {}, p = {}) : (e = o.getGraphDiv(e), r = o.extendDeep([], e.data), f = o.extendDeep({}, e.layout), h = e._context, p = e._fullLayout || {}), !g("width") && null !== t.width || !g("height") && null !== t.height) throw new Error("Height and width should be pixel values.");
        if (!g("format")) throw new Error("Export format is not " + o.join2(d.format.values, ", ", " or ") + ".");
        var m = {};
        function y(e, r) {
          return o.coerce(t, m, d, e, r);
        }
        var v = y("format"),
          x = y("width"),
          b = y("height"),
          _ = y("scale"),
          w = y("setBackground"),
          M = y("imageDataOnly"),
          T = document.createElement("div");
        T.style.position = "absolute", T.style.left = "-5000px", document.body.appendChild(T);
        var k = o.extendFlat({}, f);
        x ? k.width = x : null === t.width && n(p.width) && (k.width = p.width), b ? k.height = b : null === t.height && n(p.height) && (k.height = p.height);
        var A = o.extendFlat({}, h, {
            _exportedPlot: !0,
            staticPlot: !0,
            setBackground: w
          }),
          L = l.getRedrawFunc(T);
        function D() {
          return new Promise(function (e) {
            setTimeout(e, l.getDelay(T._fullLayout));
          });
        }
        function S() {
          return new Promise(function (e, t) {
            var r = s(T, v, _),
              n = T._fullLayout.width,
              d = T._fullLayout.height;
            function f() {
              a.purge(T), document.body.removeChild(T);
            }
            if ("full-json" === v) {
              var h = i.graphJson(T, !1, "keepdata", "object", !0, !0);
              return h.version = u, h = JSON.stringify(h), f(), e(M ? h : l.encodeJSON(h));
            }
            if (f(), "svg" === v) return e(M ? r : l.encodeSVG(r));
            var p = document.createElement("canvas");
            p.id = o.randstr(), c({
              format: v,
              width: n,
              height: d,
              scale: _,
              canvas: p,
              svg: r,
              promise: !0
            }).then(e).catch(t);
          });
        }
        return new Promise(function (e, t) {
          a.newPlot(T, r, k, A).then(L).then(D).then(S).then(function (t) {
            e(function (e) {
              return M ? e.replace(l.IMAGE_URL_PREFIX, "") : e;
            }(t));
          }).catch(function (e) {
            t(e);
          });
        });
      };
    }, {
      "../lib": 225,
      "../plots/plots": 307,
      "../snapshot/helpers": 313,
      "../snapshot/svgtoimg": 315,
      "../snapshot/tosvg": 317,
      "../version": 371,
      "./plot_api": 258,
      "fast-isnumeric": 11
    }],
    265: [function (e, t, r) {
      "use strict";

      var n = e("../lib"),
        a = e("../plots/plots"),
        i = e("./plot_schema"),
        o = e("./plot_config").dfltConfig,
        l = n.isPlainObject,
        s = Array.isArray,
        c = n.isArrayOrTypedArray;
      function u(e, t, r, a, i, o) {
        o = o || [];
        for (var d = Object.keys(e), f = 0; f < d.length; f++) {
          var h = d[f];
          if ("transforms" !== h) {
            var y = o.slice();
            y.push(h);
            var v = e[h],
              x = t[h],
              b = m(r, h),
              _ = (b || {}).valType,
              w = "info_array" === _,
              M = "colorscale" === _,
              T = (b || {}).items;
            if (g(r, h)) {
              if (l(v) && l(x) && "any" !== _) u(v, x, b, a, i, y);else if (w && s(v)) {
                v.length > x.length && a.push(p("unused", i, y.concat(x.length)));
                var k,
                  A,
                  L,
                  D,
                  S,
                  C = x.length,
                  O = Array.isArray(T);
                if (O && (C = Math.min(C, T.length)), 2 === b.dimensions) {
                  for (A = 0; A < C; A++) if (s(v[A])) {
                    v[A].length > x[A].length && a.push(p("unused", i, y.concat(A, x[A].length)));
                    var P = x[A].length;
                    for (k = 0; k < (O ? Math.min(P, T[A].length) : P); k++) L = O ? T[A][k] : T, D = v[A][k], S = x[A][k], n.validate(D, L) ? S !== D && S !== +D && a.push(p("dynamic", i, y.concat(A, k), D, S)) : a.push(p("value", i, y.concat(A, k), D));
                  } else a.push(p("array", i, y.concat(A), v[A]));
                } else for (A = 0; A < C; A++) L = O ? T[A] : T, D = v[A], S = x[A], n.validate(D, L) ? S !== D && S !== +D && a.push(p("dynamic", i, y.concat(A), D, S)) : a.push(p("value", i, y.concat(A), D));
              } else if (b.items && !w && s(v)) {
                var I,
                  z,
                  R = T[Object.keys(T)[0]],
                  N = [];
                for (I = 0; I < x.length; I++) {
                  var F = x[I]._index || I;
                  if ((z = y.slice()).push(F), l(v[F]) && l(x[I])) {
                    N.push(F);
                    var E = v[F],
                      j = x[I];
                    l(E) && !1 !== E.visible && !1 === j.visible ? a.push(p("invisible", i, z)) : u(E, j, R, a, i, z);
                  }
                }
                for (I = 0; I < v.length; I++) (z = y.slice()).push(I), l(v[I]) ? -1 === N.indexOf(I) && a.push(p("unused", i, z)) : a.push(p("object", i, z, v[I]));
              } else !l(v) && l(x) ? a.push(p("object", i, y, v)) : c(v) || !c(x) || w || M ? h in t ? n.validate(v, b) ? "enumerated" === b.valType && (b.coerceNumber && v !== +x || v !== x) && a.push(p("dynamic", i, y, v, x)) : a.push(p("value", i, y, v)) : a.push(p("unused", i, y, v)) : a.push(p("array", i, y, v));
            } else a.push(p("schema", i, y));
          }
        }
        return a;
      }
      function d(e, t) {
        for (var r = e.layout.layoutAttributes, a = 0; a < t.length; a++) {
          var i = t[a],
            o = e.traces[i.type],
            l = o.layoutAttributes;
          l && (i.subplot ? n.extendFlat(r[o.attributes.subplot.dflt], l) : n.extendFlat(r, l));
        }
        return r;
      }
      t.exports = function (e, t) {
        void 0 === e && (e = []), void 0 === t && (t = {});
        var r,
          c,
          f = i.get(),
          h = [],
          g = {
            _context: n.extendFlat({}, o)
          };
        s(e) ? (g.data = n.extendDeep([], e), r = e) : (g.data = [], r = [], h.push(p("array", "data"))), l(t) ? (g.layout = n.extendDeep({}, t), c = t) : (g.layout = {}, c = {}, arguments.length > 1 && h.push(p("object", "layout"))), a.supplyDefaults(g);
        for (var m = g._fullData, y = r.length, v = 0; v < y; v++) {
          var x = r[v],
            b = ["data", v];
          if (l(x)) {
            var _ = m[v],
              w = _.type,
              M = f.traces[w].attributes;
            M.type = {
              valType: "enumerated",
              values: [w]
            }, !1 === _.visible && !1 !== x.visible && h.push(p("invisible", b)), u(x, _, M, h, b);
            var T = x.transforms,
              k = _.transforms;
            if (T) {
              s(T) || h.push(p("array", b, ["transforms"])), b.push("transforms");
              for (var A = 0; A < T.length; A++) {
                var L = ["transforms", A],
                  D = T[A].type;
                if (l(T[A])) {
                  var S = f.transforms[D] ? f.transforms[D].attributes : {};
                  S.type = {
                    valType: "enumerated",
                    values: Object.keys(f.transforms)
                  }, u(T[A], k[A], S, h, b, L);
                } else h.push(p("object", b, L));
              }
            }
          } else h.push(p("object", b));
        }
        var C = g._fullLayout,
          O = d(f, m);
        return u(c, C, O, h, "layout"), 0 === h.length ? void 0 : h;
      };
      var f = {
        object: function object(e, t) {
          return ("layout" === e && "" === t ? "The layout argument" : "data" === e[0] && "" === t ? "Trace " + e[1] + " in the data argument" : h(e) + "key " + t) + " must be linked to an object container";
        },
        array: function array(e, t) {
          return ("data" === e ? "The data argument" : h(e) + "key " + t) + " must be linked to an array container";
        },
        schema: function schema(e, t) {
          return h(e) + "key " + t + " is not part of the schema";
        },
        unused: function unused(e, t, r) {
          var n = l(r) ? "container" : "key";
          return h(e) + n + " " + t + " did not get coerced";
        },
        dynamic: function dynamic(e, t, r, n) {
          return [h(e) + "key", t, "(set to '" + r + "')", "got reset to", "'" + n + "'", "during defaults."].join(" ");
        },
        invisible: function invisible(e, t) {
          return (t ? h(e) + "item " + t : "Trace " + e[1]) + " got defaulted to be not visible";
        },
        value: function value(e, t, r) {
          return [h(e) + "key " + t, "is set to an invalid value (" + r + ")"].join(" ");
        }
      };
      function h(e) {
        return s(e) ? "In data trace " + e[1] + ", " : "In " + e + ", ";
      }
      function p(e, t, r, a, i) {
        var o, l;
        r = r || "", s(t) ? (o = t[0], l = t[1]) : (o = t, l = null);
        var c = function (e) {
            if (!s(e)) return String(e);
            for (var t = "", r = 0; r < e.length; r++) {
              var n = e[r];
              "number" == typeof n ? t = t.substr(0, t.length - 1) + "[" + n + "]" : t += n, r < e.length - 1 && (t += ".");
            }
            return t;
          }(r),
          u = f[e](t, c, a, i);
        return n.log(u), {
          code: e,
          container: o,
          trace: l,
          path: r,
          astr: c,
          msg: u
        };
      }
      function g(e, t) {
        var r = v(t),
          n = r.keyMinusId,
          a = r.id;
        return !!(n in e && e[n]._isSubplotObj && a) || t in e;
      }
      function m(e, t) {
        return t in e ? e[t] : e[v(t).keyMinusId];
      }
      var y = n.counterRegex("([a-z]+)");
      function v(e) {
        var t = e.match(y);
        return {
          keyMinusId: t && t[1],
          id: t && t[2]
        };
      }
    }, {
      "../lib": 225,
      "../plots/plots": 307,
      "./plot_config": 259,
      "./plot_schema": 260
    }],
    266: [function (e, t, r) {
      "use strict";

      t.exports = {
        mode: {
          valType: "enumerated",
          dflt: "afterall",
          values: ["immediate", "next", "afterall"]
        },
        direction: {
          valType: "enumerated",
          values: ["forward", "reverse"],
          dflt: "forward"
        },
        fromcurrent: {
          valType: "boolean",
          dflt: !1
        },
        frame: {
          duration: {
            valType: "number",
            min: 0,
            dflt: 500
          },
          redraw: {
            valType: "boolean",
            dflt: !0
          }
        },
        transition: {
          duration: {
            valType: "number",
            min: 0,
            dflt: 500,
            editType: "none"
          },
          easing: {
            valType: "enumerated",
            dflt: "cubic-in-out",
            values: ["linear", "quad", "cubic", "sin", "exp", "circle", "elastic", "back", "bounce", "linear-in", "quad-in", "cubic-in", "sin-in", "exp-in", "circle-in", "elastic-in", "back-in", "bounce-in", "linear-out", "quad-out", "cubic-out", "sin-out", "exp-out", "circle-out", "elastic-out", "back-out", "bounce-out", "linear-in-out", "quad-in-out", "cubic-in-out", "sin-in-out", "exp-in-out", "circle-in-out", "elastic-in-out", "back-in-out", "bounce-in-out"],
            editType: "none"
          },
          ordering: {
            valType: "enumerated",
            values: ["layout first", "traces first"],
            dflt: "layout first",
            editType: "none"
          }
        }
      };
    }, {}],
    267: [function (e, t, r) {
      "use strict";

      var n = e("../lib"),
        a = e("../plot_api/plot_template");
      t.exports = function (e, t, r) {
        var i,
          o,
          l = r.name,
          s = r.inclusionAttr || "visible",
          c = t[l],
          u = n.isArrayOrTypedArray(e[l]) ? e[l] : [],
          d = t[l] = [],
          f = a.arrayTemplater(t, l, s);
        for (i = 0; i < u.length; i++) {
          var h = u[i];
          n.isPlainObject(h) ? o = f.newItem(h) : (o = f.newItem({}))[s] = !1, o._index = i, !1 !== o[s] && r.handleItemDefaults(h, o, t, r), d.push(o);
        }
        var p = f.defaultItems();
        for (i = 0; i < p.length; i++) (o = p[i])._index = d.length, r.handleItemDefaults({}, o, t, r, {}), d.push(o);
        if (n.isArrayOrTypedArray(c)) {
          var g = Math.min(c.length, d.length);
          for (i = 0; i < g; i++) n.relinkPrivateKeys(d[i], c[i]);
        }
        return d;
      };
    }, {
      "../lib": 225,
      "../plot_api/plot_template": 261
    }],
    268: [function (e, t, r) {
      "use strict";

      var n = e("./font_attributes"),
        a = e("../components/fx/attributes");
      t.exports = {
        type: {
          valType: "enumerated",
          values: [],
          dflt: "scatter",
          editType: "calc+clearAxisTypes",
          _noTemplating: !0
        },
        visible: {
          valType: "enumerated",
          values: [!0, !1, "legendonly"],
          dflt: !0,
          editType: "calc"
        },
        showlegend: {
          valType: "boolean",
          dflt: !0,
          editType: "style"
        },
        legendgroup: {
          valType: "string",
          dflt: "",
          editType: "style"
        },
        legendgrouptitle: {
          text: {
            valType: "string",
            dflt: "",
            editType: "style"
          },
          font: n({
            editType: "style"
          }),
          editType: "style"
        },
        legendrank: {
          valType: "number",
          dflt: 1e3,
          editType: "style"
        },
        opacity: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 1,
          editType: "style"
        },
        name: {
          valType: "string",
          editType: "style"
        },
        uid: {
          valType: "string",
          editType: "plot",
          anim: !0
        },
        ids: {
          valType: "data_array",
          editType: "calc",
          anim: !0
        },
        customdata: {
          valType: "data_array",
          editType: "calc"
        },
        meta: {
          valType: "any",
          arrayOk: !0,
          editType: "plot"
        },
        selectedpoints: {
          valType: "any",
          editType: "calc"
        },
        hoverinfo: {
          valType: "flaglist",
          flags: ["x", "y", "z", "text", "name"],
          extras: ["all", "none", "skip"],
          arrayOk: !0,
          dflt: "all",
          editType: "none"
        },
        hoverlabel: a.hoverlabel,
        stream: {
          token: {
            valType: "string",
            noBlank: !0,
            strict: !0,
            editType: "calc"
          },
          maxpoints: {
            valType: "number",
            min: 0,
            max: 1e4,
            dflt: 500,
            editType: "calc"
          },
          editType: "calc"
        },
        transforms: {
          _isLinkedToArray: "transform",
          editType: "calc"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        }
      };
    }, {
      "../components/fx/attributes": 127,
      "./font_attributes": 301
    }],
    269: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib"),
        i = a.dateTime2ms,
        o = a.incrementMonth,
        l = e("../../constants/numerical").ONEAVGMONTH;
      t.exports = function (e, t, r, a) {
        if ("date" !== t.type) return {
          vals: a
        };
        var s = e[r + "periodalignment"];
        if (!s) return {
          vals: a
        };
        var c,
          u = e[r + "period"];
        if (n(u)) {
          if ((u = +u) <= 0) return {
            vals: a
          };
        } else if ("string" == typeof u && "M" === u.charAt(0)) {
          var d = +u.substring(1);
          if (!(d > 0 && Math.round(d) === d)) return {
            vals: a
          };
          c = d;
        }
        for (var f = t.calendar, h = "start" === s, p = "end" === s, g = e[r + "period0"], m = i(g, f) || 0, y = [], v = [], x = [], b = a.length, _ = 0; _ < b; _++) {
          var w,
            M,
            T,
            k = a[_];
          if (c) {
            for (w = Math.round((k - m) / (c * l)), T = o(m, c * w, f); T > k;) T = o(T, -c, f);
            for (; T <= k;) T = o(T, c, f);
            M = o(T, -c, f);
          } else {
            for (T = m + (w = Math.round((k - m) / u)) * u; T > k;) T -= u;
            for (; T <= k;) T += u;
            M = T - u;
          }
          y[_] = h ? M : p ? T : (M + T) / 2, v[_] = M, x[_] = T;
        }
        return {
          vals: y,
          starts: v,
          ends: x
        };
      };
    }, {
      "../../constants/numerical": 205,
      "../../lib": 225,
      "fast-isnumeric": 11
    }],
    270: [function (e, t, r) {
      "use strict";

      t.exports = {
        xaxis: {
          valType: "subplotid",
          dflt: "x",
          editType: "calc+clearAxisTypes"
        },
        yaxis: {
          valType: "subplotid",
          dflt: "y",
          editType: "calc+clearAxisTypes"
        }
      };
    }, {}],
    271: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("fast-isnumeric"),
        i = e("../../lib"),
        o = e("../../constants/numerical").FP_SAFE,
        l = e("../../registry"),
        s = e("../../components/drawing"),
        c = e("./axis_ids"),
        u = c.getFromId,
        d = c.isLinked;
      function f(e, t) {
        var r,
          n,
          a = [],
          o = e._fullLayout,
          l = p(o, t, 0),
          s = p(o, t, 1),
          c = g(e, t),
          u = c.min,
          d = c.max;
        if (0 === u.length || 0 === d.length) return i.simpleMap(t.range, t.r2l);
        var f = u[0].val,
          m = d[0].val;
        for (r = 1; r < u.length && f === m; r++) f = Math.min(f, u[r].val);
        for (r = 1; r < d.length && f === m; r++) m = Math.max(m, d[r].val);
        var y = !1;
        if (t.range) {
          var v = i.simpleMap(t.range, t.r2l);
          y = v[1] < v[0];
        }
        "reversed" === t.autorange && (y = !0, t.autorange = !0);
        var x,
          b,
          _,
          w,
          M,
          T,
          k = t.rangemode,
          A = "tozero" === k,
          L = "nonnegative" === k,
          D = t._length,
          S = D / 10,
          C = 0;
        for (r = 0; r < u.length; r++) for (x = u[r], n = 0; n < d.length; n++) (T = (b = d[n]).val - x.val - h(t, x.val, b.val)) > 0 && ((M = D - l(x) - s(b)) > S ? T / M > C && (_ = x, w = b, C = T / M) : T / D > C && (_ = {
          val: x.val,
          nopad: 1
        }, w = {
          val: b.val,
          nopad: 1
        }, C = T / D));
        if (f === m) {
          var O = f - 1,
            P = f + 1;
          if (A) {
            if (0 === f) a = [0, 1];else {
              var I = (f > 0 ? d : u).reduce(function (e, t) {
                  return Math.max(e, s(t));
                }, 0),
                z = f / (1 - Math.min(.5, I / D));
              a = f > 0 ? [0, z] : [z, 0];
            }
          } else a = L ? [Math.max(0, O), Math.max(1, P)] : [O, P];
        } else A ? (_.val >= 0 && (_ = {
          val: 0,
          nopad: 1
        }), w.val <= 0 && (w = {
          val: 0,
          nopad: 1
        })) : L && (_.val - C * l(_) < 0 && (_ = {
          val: 0,
          nopad: 1
        }), w.val <= 0 && (w = {
          val: 1,
          nopad: 1
        })), C = (w.val - _.val - h(t, x.val, b.val)) / (D - l(_) - s(w)), a = [_.val - C * l(_), w.val + C * s(w)];
        return y && a.reverse(), i.simpleMap(a, t.l2r || Number);
      }
      function h(e, t, r) {
        var n = 0;
        if (e.rangebreaks) for (var a = e.locateBreaks(t, r), i = 0; i < a.length; i++) {
          var o = a[i];
          n += o.max - o.min;
        }
        return n;
      }
      function p(e, t, r) {
        var a = .05 * t._length,
          o = t._anchorAxis || {};
        if (-1 !== (t.ticklabelposition || "").indexOf("inside") || -1 !== (o.ticklabelposition || "").indexOf("inside")) {
          var l = "reversed" === t.autorange;
          if (!l) {
            var c = i.simpleMap(t.range, t.r2l);
            l = c[1] < c[0];
          }
          l && (r = !r);
        }
        var u = 0;
        return d(e, t._id) || (u = function (e, t, r) {
          var a = 0,
            o = "x" === t._id.charAt(0);
          for (var l in e._plots) {
            var c = e._plots[l];
            if (t._id === c.xaxis._id || t._id === c.yaxis._id) {
              var u = (o ? c.yaxis : c.xaxis) || {};
              if (-1 !== (u.ticklabelposition || "").indexOf("inside") && (!r && ("left" === u.side || "bottom" === u.side) || r && ("top" === u.side || "right" === u.side))) {
                if (u._vals) {
                  var d = i.deg2rad(u._tickAngles[u._id + "tick"] || 0),
                    f = Math.abs(Math.cos(d)),
                    h = Math.abs(Math.sin(d));
                  if (!u._vals[0].bb) {
                    var p = u._id + "tick";
                    u._selections[p].each(function (e) {
                      var t = n.select(this);
                      t.select(".text-math-group").empty() && (e.bb = s.bBox(t.node()));
                    });
                  }
                  for (var g = 0; g < u._vals.length; g++) {
                    var m = u._vals[g].bb;
                    if (m) {
                      var y = 6 + m.width,
                        v = 6 + m.height;
                      a = Math.max(a, o ? Math.max(y * f, v * h) : Math.max(v * f, y * h));
                    }
                  }
                }
                "inside" === u.ticks && "inside" === u.ticklabelposition && (a += u.ticklen || 0);
              }
            }
          }
          return a;
        }(e, t, r)), a = Math.max(u, a), "domain" === t.constrain && t._inputDomain && (a *= (t._inputDomain[1] - t._inputDomain[0]) / (t.domain[1] - t.domain[0])), function (e) {
          return e.nopad ? 0 : e.pad + (e.extrapad ? a : u);
        };
      }
      t.exports = {
        getAutoRange: f,
        makePadFn: p,
        doAutoRange: function doAutoRange(e, t, r) {
          if (t.setScale(), t.autorange) {
            t.range = r ? r.slice() : f(e, t), t._r = t.range.slice(), t._rl = i.simpleMap(t._r, t.r2l);
            var n = t._input,
              a = {};
            a[t._attr + ".range"] = t.range, a[t._attr + ".autorange"] = t.autorange, l.call("_storeDirectGUIEdit", e.layout, e._fullLayout._preGUI, a), n.range = t.range.slice(), n.autorange = t.autorange;
          }
          var o = t._anchorAxis;
          if (o && o.rangeslider) {
            var s = o.rangeslider[t._name];
            s && "auto" === s.rangemode && (s.range = f(e, t)), o._input.rangeslider[t._name] = i.extendFlat({}, s);
          }
        },
        findExtremes: function findExtremes(e, t, r) {
          r || (r = {});
          e._m || e.setScale();
          var n,
            i,
            l,
            s,
            c,
            u,
            d,
            f,
            h,
            p = [],
            g = [],
            v = t.length,
            b = r.padded || !1,
            _ = r.tozero && ("linear" === e.type || "-" === e.type),
            w = "log" === e.type,
            M = !1,
            T = r.vpadLinearized || !1;
          function k(e) {
            if (Array.isArray(e)) return M = !0, function (t) {
              return Math.max(Number(e[t] || 0), 0);
            };
            var t = Math.max(Number(e || 0), 0);
            return function () {
              return t;
            };
          }
          var A = k((e._m > 0 ? r.ppadplus : r.ppadminus) || r.ppad || 0),
            L = k((e._m > 0 ? r.ppadminus : r.ppadplus) || r.ppad || 0),
            D = k(r.vpadplus || r.vpad),
            S = k(r.vpadminus || r.vpad);
          if (!M) {
            if (f = 1 / 0, h = -1 / 0, w) for (n = 0; n < v; n++) (i = t[n]) < f && i > 0 && (f = i), i > h && i < o && (h = i);else for (n = 0; n < v; n++) (i = t[n]) < f && i > -o && (f = i), i > h && i < o && (h = i);
            t = [f, h], v = 2;
          }
          var C = {
            tozero: _,
            extrapad: b
          };
          function O(r) {
            l = t[r], a(l) && (u = A(r), d = L(r), T ? (s = e.c2l(l) - S(r), c = e.c2l(l) + D(r)) : (f = l - S(r), h = l + D(r), w && f < h / 10 && (f = h / 10), s = e.c2l(f), c = e.c2l(h)), _ && (s = Math.min(0, s), c = Math.max(0, c)), x(s) && m(p, s, d, C), x(c) && y(g, c, u, C));
          }
          var P = Math.min(6, v);
          for (n = 0; n < P; n++) O(n);
          for (n = v - 1; n >= P; n--) O(n);
          return {
            min: p,
            max: g,
            opts: r
          };
        },
        concatExtremes: g
      };
      function g(e, t, r) {
        var n,
          a,
          i,
          o = t._id,
          l = e._fullData,
          s = e._fullLayout,
          c = [],
          d = [];
        function f(e, t) {
          for (n = 0; n < t.length; n++) {
            var r = e[t[n]],
              l = (r._extremes || {})[o];
            if (!0 === r.visible && l) {
              for (a = 0; a < l.min.length; a++) i = l.min[a], m(c, i.val, i.pad, {
                extrapad: i.extrapad
              });
              for (a = 0; a < l.max.length; a++) i = l.max[a], y(d, i.val, i.pad, {
                extrapad: i.extrapad
              });
            }
          }
        }
        if (f(l, t._traceIndices), f(s.annotations || [], t._annIndices || []), f(s.shapes || [], t._shapeIndices || []), t._matchGroup && !r) for (var h in t._matchGroup) if (h !== t._id) {
          var p = u(e, h),
            v = g(e, p, !0),
            x = t._length / p._length;
          for (a = 0; a < v.min.length; a++) i = v.min[a], m(c, i.val, i.pad * x, {
            extrapad: i.extrapad
          });
          for (a = 0; a < v.max.length; a++) i = v.max[a], y(d, i.val, i.pad * x, {
            extrapad: i.extrapad
          });
        }
        return {
          min: c,
          max: d
        };
      }
      function m(e, t, r, n) {
        v(e, t, r, n, b);
      }
      function y(e, t, r, n) {
        v(e, t, r, n, _);
      }
      function v(e, t, r, n, a) {
        for (var i = n.tozero, o = n.extrapad, l = !0, s = 0; s < e.length && l; s++) {
          var c = e[s];
          if (a(c.val, t) && c.pad >= r && (c.extrapad || !o)) {
            l = !1;
            break;
          }
          a(t, c.val) && c.pad <= r && (o || !c.extrapad) && (e.splice(s, 1), s--);
        }
        if (l) {
          var u = i && 0 === t;
          e.push({
            val: t,
            pad: u ? 0 : r,
            extrapad: !u && o
          });
        }
      }
      function x(e) {
        return a(e) && Math.abs(e) < o;
      }
      function b(e, t) {
        return e <= t;
      }
      function _(e, t) {
        return e >= t;
      }
    }, {
      "../../components/drawing": 118,
      "../../constants/numerical": 205,
      "../../lib": 225,
      "../../registry": 309,
      "./axis_ids": 276,
      "@plotly/d3": 6,
      "fast-isnumeric": 11
    }],
    272: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("fast-isnumeric"),
        i = e("../../plots/plots"),
        o = e("../../registry"),
        l = e("../../lib"),
        s = l.strTranslate,
        c = e("../../lib/svg_text_utils"),
        u = e("../../components/titles"),
        d = e("../../components/color"),
        f = e("../../components/drawing"),
        h = e("./layout_attributes"),
        p = e("./clean_ticks"),
        g = e("../../constants/numerical"),
        m = g.ONEMAXYEAR,
        y = g.ONEAVGYEAR,
        v = g.ONEMINYEAR,
        x = g.ONEMAXQUARTER,
        b = g.ONEAVGQUARTER,
        _ = g.ONEMINQUARTER,
        w = g.ONEMAXMONTH,
        M = g.ONEAVGMONTH,
        T = g.ONEMINMONTH,
        k = g.ONEWEEK,
        A = g.ONEDAY,
        L = A / 2,
        D = g.ONEHOUR,
        S = g.ONEMIN,
        C = g.ONESEC,
        O = g.MINUS_SIGN,
        P = g.BADNUM,
        I = {
          K: "zeroline"
        },
        z = {
          K: "gridline",
          L: "path"
        },
        R = {
          K: "tick",
          L: "path"
        },
        N = {
          K: "tick",
          L: "text"
        },
        F = e("../../constants/alignment"),
        E = F.MID_SHIFT,
        j = F.CAP_SHIFT,
        H = F.LINE_SPACING,
        B = F.OPPOSITE_SIDE,
        Y = t.exports = {};
      Y.setConvert = e("./set_convert");
      var U = e("./axis_autotype"),
        V = e("./axis_ids"),
        q = V.idSort,
        G = V.isLinked;
      Y.id2name = V.id2name, Y.name2id = V.name2id, Y.cleanId = V.cleanId, Y.list = V.list, Y.listIds = V.listIds, Y.getFromId = V.getFromId, Y.getFromTrace = V.getFromTrace;
      var Z = e("./autorange");
      Y.getAutoRange = Z.getAutoRange, Y.findExtremes = Z.findExtremes;
      function W(e) {
        var t = 1e-4 * (e[1] - e[0]);
        return [e[0] - t, e[1] + t];
      }
      Y.coerceRef = function (e, t, r, n, a, i) {
        var o = n.charAt(n.length - 1),
          s = r._fullLayout._subplots[o + "axis"],
          c = n + "ref",
          u = {};
        return a || (a = s[0] || ("string" == typeof i ? i : i[0])), i || (i = a), s = s.concat(s.map(function (e) {
          return e + " domain";
        })), u[c] = {
          valType: "enumerated",
          values: s.concat(i ? "string" == typeof i ? [i] : i : []),
          dflt: a
        }, l.coerce(e, t, u, c);
      }, Y.getRefType = function (e) {
        return void 0 === e ? e : "paper" === e ? "paper" : "pixel" === e ? "pixel" : /( domain)$/.test(e) ? "domain" : "range";
      }, Y.coercePosition = function (e, t, r, n, a, i) {
        var o, s;
        if ("range" !== Y.getRefType(n)) o = l.ensureNumber, s = r(a, i);else {
          var c = Y.getFromId(t, n);
          s = r(a, i = c.fraction2r(i)), o = c.cleanPos;
        }
        e[a] = o(s);
      }, Y.cleanPosition = function (e, t, r) {
        return ("paper" === r || "pixel" === r ? l.ensureNumber : Y.getFromId(t, r).cleanPos)(e);
      }, Y.redrawComponents = function (e, t) {
        t = t || Y.listIds(e);
        var r = e._fullLayout;
        function n(n, a, i, l) {
          for (var s = o.getComponentMethod(n, a), c = {}, u = 0; u < t.length; u++) for (var d = r[Y.id2name(t[u])][i], f = 0; f < d.length; f++) {
            var h = d[f];
            if (!c[h] && (s(e, h), c[h] = 1, l)) return;
          }
        }
        n("annotations", "drawOne", "_annIndices"), n("shapes", "drawOne", "_shapeIndices"), n("images", "draw", "_imgIndices", !0);
      };
      var J = Y.getDataConversions = function (e, t, r, n) {
        var a,
          i = "x" === r || "y" === r || "z" === r ? r : n;
        if (Array.isArray(i)) {
          if (a = {
            type: U(n, void 0, {
              autotypenumbers: e._fullLayout.autotypenumbers
            }),
            _categories: []
          }, Y.setConvert(a), "category" === a.type) for (var o = 0; o < n.length; o++) a.d2c(n[o]);
        } else a = Y.getFromTrace(e, t, i);
        return a ? {
          d2c: a.d2c,
          c2d: a.c2d
        } : "ids" === i ? {
          d2c: Q,
          c2d: Q
        } : {
          d2c: X,
          c2d: X
        };
      };
      function X(e) {
        return +e;
      }
      function Q(e) {
        return String(e);
      }
      function K(e) {
        return +e.substring(1);
      }
      Y.getDataToCoordFunc = function (e, t, r, n) {
        return J(e, t, r, n).d2c;
      }, Y.counterLetter = function (e) {
        var t = e.charAt(0);
        return "x" === t ? "y" : "y" === t ? "x" : void 0;
      }, Y.minDtick = function (e, t, r, n) {
        -1 === ["log", "category", "multicategory"].indexOf(e.type) && n ? void 0 === e._minDtick ? (e._minDtick = t, e._forceTick0 = r) : e._minDtick && ((e._minDtick / t + 1e-6) % 1 < 2e-6 && ((r - e._forceTick0) / t % 1 + 1.000001) % 1 < 2e-6 ? (e._minDtick = t, e._forceTick0 = r) : ((t / e._minDtick + 1e-6) % 1 > 2e-6 || ((r - e._forceTick0) / e._minDtick % 1 + 1.000001) % 1 > 2e-6) && (e._minDtick = 0)) : e._minDtick = 0;
      }, Y.saveRangeInitial = function (e, t) {
        for (var r = Y.list(e, "", !0), n = !1, a = 0; a < r.length; a++) {
          var i = r[a],
            o = void 0 === i._rangeInitial,
            l = o || !(i.range[0] === i._rangeInitial[0] && i.range[1] === i._rangeInitial[1]);
          (o && !1 === i.autorange || t && l) && (i._rangeInitial = i.range.slice(), n = !0);
        }
        return n;
      }, Y.saveShowSpikeInitial = function (e, t) {
        for (var r = Y.list(e, "", !0), n = !1, a = "on", i = 0; i < r.length; i++) {
          var o = r[i],
            l = void 0 === o._showSpikeInitial,
            s = l || !(o.showspikes === o._showspikes);
          (l || t && s) && (o._showSpikeInitial = o.showspikes, n = !0), "on" !== a || o.showspikes || (a = "off");
        }
        return e._fullLayout._cartesianSpikesEnabled = a, n;
      }, Y.autoBin = function (e, t, r, n, i, o) {
        var s,
          c = l.aggNums(Math.min, null, e),
          u = l.aggNums(Math.max, null, e);
        if ("category" === t.type || "multicategory" === t.type) return {
          start: c - .5,
          end: u + .5,
          size: Math.max(1, Math.round(o) || 1),
          _dataSpan: u - c
        };
        if (i || (i = t.calendar), s = "log" === t.type ? {
          type: "linear",
          range: [c, u]
        } : {
          type: t.type,
          range: l.simpleMap([c, u], t.c2r, 0, i),
          calendar: i
        }, Y.setConvert(s), o = o && p.dtick(o, s.type)) s.dtick = o, s.tick0 = p.tick0(void 0, s.type, i);else {
          var d;
          if (r) d = (u - c) / r;else {
            var f = l.distinctVals(e),
              h = Math.pow(10, Math.floor(Math.log(f.minDiff) / Math.LN10)),
              g = h * l.roundUp(f.minDiff / h, [.9, 1.9, 4.9, 9.9], !0);
            d = Math.max(g, 2 * l.stdev(e) / Math.pow(e.length, n ? .25 : .4)), a(d) || (d = 1);
          }
          Y.autoTicks(s, d);
        }
        var m,
          y = s.dtick,
          v = Y.tickIncrement(Y.tickFirst(s), y, "reverse", i);
        if ("number" == typeof y) m = (v = function (e, t, r, n, i) {
          var o = 0,
            l = 0,
            s = 0,
            c = 0;
          function u(t) {
            return (1 + 100 * (t - e) / r.dtick) % 100 < 2;
          }
          for (var d = 0; d < t.length; d++) t[d] % 1 == 0 ? s++ : a(t[d]) || c++, u(t[d]) && o++, u(t[d] + r.dtick / 2) && l++;
          var f = t.length - c;
          if (s === f && "date" !== r.type) r.dtick < 1 ? e = n - .5 * r.dtick : (e -= .5) + r.dtick < n && (e += r.dtick);else if (l < .1 * f && (o > .3 * f || u(n) || u(i))) {
            var h = r.dtick / 2;
            e += e + h < n ? h : -h;
          }
          return e;
        }(v, e, s, c, u)) + (1 + Math.floor((u - v) / y)) * y;else for ("M" === s.dtick.charAt(0) && (v = function (e, t, r, n, a) {
          var i = l.findExactDates(t, a);
          if (i.exactDays > .8) {
            var o = Number(r.substr(1));
            i.exactYears > .8 && o % 12 == 0 ? e = Y.tickIncrement(e, "M6", "reverse") + 1.5 * A : i.exactMonths > .8 ? e = Y.tickIncrement(e, "M1", "reverse") + 15.5 * A : e -= L;
            var s = Y.tickIncrement(e, r);
            if (s <= n) return s;
          }
          return e;
        }(v, e, y, c, i)), m = v, 0; m <= u;) m = Y.tickIncrement(m, y, !1, i);
        return {
          start: t.c2r(v, 0, i),
          end: t.c2r(m, 0, i),
          size: y,
          _dataSpan: u - c
        };
      }, Y.prepTicks = function (e, t) {
        var r = l.simpleMap(e.range, e.r2l, void 0, void 0, t);
        if (e._dtickInit = e.dtick, e._tick0Init = e.tick0, "auto" === e.tickmode || !e.dtick) {
          var n,
            i = e.nticks;
          i || ("category" === e.type || "multicategory" === e.type ? (n = e.tickfont ? l.bigFont(e.tickfont.size || 12) : 15, i = e._length / n) : (n = "y" === e._id.charAt(0) ? 40 : 80, i = l.constrain(e._length / n, 4, 9) + 1), "radialaxis" === e._name && (i *= 2)), "array" === e.tickmode && (i *= 100), e._roughDTick = Math.abs(r[1] - r[0]) / i, Y.autoTicks(e, e._roughDTick), e._minDtick > 0 && e.dtick < 2 * e._minDtick && (e.dtick = e._minDtick, e.tick0 = e.l2r(e._forceTick0));
        }
        "period" === e.ticklabelmode && function (e) {
          var t;
          function r() {
            return !(a(e.dtick) || "M" !== e.dtick.charAt(0));
          }
          var n = r(),
            i = Y.getTickFormat(e);
          if (i) {
            var o = e._dtickInit !== e.dtick;
            /%[fLQsSMX]/.test(i) || (/%[HI]/.test(i) ? (t = D, o && !n && e.dtick < D && (e.dtick = D)) : /%p/.test(i) ? (t = L, o && !n && e.dtick < L && (e.dtick = L)) : /%[Aadejuwx]/.test(i) ? (t = A, o && !n && e.dtick < A && (e.dtick = A)) : /%[UVW]/.test(i) ? (t = k, o && !n && e.dtick < k && (e.dtick = k)) : /%[Bbm]/.test(i) ? (t = M, o && (n ? K(e.dtick) < 1 : e.dtick < T) && (e.dtick = "M1")) : /%[q]/.test(i) ? (t = b, o && (n ? K(e.dtick) < 3 : e.dtick < _) && (e.dtick = "M3")) : /%[Yy]/.test(i) && (t = y, o && (n ? K(e.dtick) < 12 : e.dtick < v) && (e.dtick = "M12")));
          }
          (n = r()) && e.tick0 === e._dowTick0 && (e.tick0 = e._rawTick0);
          e._definedDelta = t;
        }(e), e.tick0 || (e.tick0 = "date" === e.type ? "2000-01-01" : 0), "date" === e.type && e.dtick < .1 && (e.dtick = .1), le(e);
      }, Y.calcTicks = function (e, t) {
        Y.prepTicks(e, t);
        var r = l.simpleMap(e.range, e.r2l, void 0, void 0, t);
        if ("array" === e.tickmode) return function (e) {
          var t = e.tickvals,
            r = e.ticktext,
            n = new Array(t.length),
            a = W(l.simpleMap(e.range, e.r2l)),
            i = Math.min(a[0], a[1]),
            o = Math.max(a[0], a[1]),
            s = 0;
          Array.isArray(r) || (r = []);
          var c = "category" === e.type ? e.d2l_noadd : e.d2l;
          "log" === e.type && "L" !== String(e.dtick).charAt(0) && (e.dtick = "L" + Math.pow(10, Math.floor(Math.min(e.range[0], e.range[1])) - 1));
          for (var u = 0; u < t.length; u++) {
            var d = c(t[u]);
            d > i && d < o && (void 0 === r[u] ? n[s] = Y.tickText(e, d) : n[s] = se(e, d, String(r[u])), s++);
          }
          s < t.length && n.splice(s, t.length - s);
          e.rangebreaks && (n = n.filter(function (t) {
            return e.maskBreaks(t.x) !== P;
          }));
          return n;
        }(e);
        var n = W(r),
          i = n[0],
          o = n[1],
          s = r[1] < r[0],
          c = Math.min(r[0], r[1]),
          u = Math.max(r[0], r[1]),
          d = "log" === e.type && !(a(e.dtick) || "L" === e.dtick.charAt(0)),
          f = "period" === e.ticklabelmode;
        if (e._tmin = Y.tickFirst(e, t), e._tmin < i !== s) return [];
        "category" !== e.type && "multicategory" !== e.type || (o = s ? Math.max(-.5, o) : Math.min(e._categories.length - .5, o));
        var h = e._tmin;
        e.rangebreaks && e._tick0Init !== e.tick0 && (h = Ae(h, e), s || (h = Y.tickIncrement(h, e.dtick, !s, e.calendar))), f && (h = Y.tickIncrement(h, e.dtick, !s, e.calendar));
        for (var p, g = Math.max(1e3, e._length || 0), S = [], C = null; s ? h >= o : h <= o; h = Y.tickIncrement(h, e.dtick, s, e.calendar)) {
          if (e.rangebreaks && !s) {
            if (h < i) continue;
            if (e.maskBreaks(h) === P && Ae(h, e) >= u) break;
          }
          if (S.length > g || h === C) break;
          C = h;
          var O = !1;
          d && h !== (0 | h) && (O = !0), S.push({
            minor: O,
            value: h
          });
        }
        if (f && function (e, t, r) {
          for (var n = 0; n < e.length; n++) {
            var a = e[n].value,
              i = n,
              o = n + 1;
            n < e.length - 1 ? (i = n, o = n + 1) : n > 0 ? (i = n - 1, o = n) : (i = n, o = n);
            var l,
              s = e[i].value,
              c = e[o].value,
              u = Math.abs(c - s),
              d = r || u,
              f = 0;
            d >= v ? f = u >= v && u <= m ? u : y : r === b && d >= _ ? f = u >= _ && u <= x ? u : b : d >= T ? f = u >= T && u <= w ? u : M : r === k && d >= k ? f = k : d >= A ? f = A : r === L && d >= L ? f = L : r === D && d >= D && (f = D), f >= u && (f = u, l = !0);
            var h = a + f;
            if (t.rangebreaks && f > 0) {
              for (var p = 0, g = 0; g < 84; g++) {
                var S = (g + .5) / 84;
                t.maskBreaks(a * (1 - S) + S * h) !== P && p++;
              }
              (f *= p / 84) || (e[n].drop = !0), l && u > k && (f = u);
            }
            (f > 0 || 0 === n) && (e[n].periodX = a + f / 2);
          }
        }(S, e, e._definedDelta), e.rangebreaks) {
          var I = "y" === e._id.charAt(0),
            z = 1;
          "auto" === e.tickmode && (z = e.tickfont ? e.tickfont.size : 12);
          var R = NaN;
          for (p = S.length - 1; p > -1; p--) if (S[p].drop) S.splice(p, 1);else {
            S[p].value = Ae(S[p].value, e);
            var N = e.c2p(S[p].value);
            (I ? R > N - z : R < N + z) ? S.splice(s ? p + 1 : p, 1) : R = N;
          }
        }
        ke(e) && 360 === Math.abs(r[1] - r[0]) && S.pop(), e._tmax = (S[S.length - 1] || {}).value, e._prevDateHead = "", e._inCalcTicks = !0;
        var F,
          E,
          j = [];
        for (p = 0; p < S.length; p++) {
          var H = S[p].minor,
            B = S[p].value;
          F = Y.tickText(e, B, !1, H), void 0 !== (E = S[p].periodX) && (F.periodX = E, (E > u || E < c) && (E > u && (F.periodX = u), E < c && (F.periodX = c), F.text = " ", e._prevDateHead = "")), j.push(F);
        }
        return e._inCalcTicks = !1, j;
      };
      var $ = [2, 5, 10],
        ee = [1, 2, 3, 6, 12],
        te = [1, 2, 5, 10, 15, 30],
        re = [1, 2, 3, 7, 14],
        ne = [-.046, 0, .301, .477, .602, .699, .778, .845, .903, .954, 1],
        ae = [-.301, 0, .301, .699, 1],
        ie = [15, 30, 45, 90, 180];
      function oe(e, t, r) {
        return t * l.roundUp(e / t, r);
      }
      function le(e) {
        var t = e.dtick;
        if (e._tickexponent = 0, a(t) || "string" == typeof t || (t = 1), "category" !== e.type && "multicategory" !== e.type || (e._tickround = null), "date" === e.type) {
          var r = e.r2l(e.tick0),
            n = e.l2r(r).replace(/(^-|i)/g, ""),
            i = n.length;
          if ("M" === String(t).charAt(0)) i > 10 || "01-01" !== n.substr(5) ? e._tickround = "d" : e._tickround = +t.substr(1) % 12 == 0 ? "y" : "m";else if (t >= A && i <= 10 || t >= 15 * A) e._tickround = "d";else if (t >= S && i <= 16 || t >= D) e._tickround = "M";else if (t >= C && i <= 19 || t >= S) e._tickround = "S";else {
            var o = e.l2r(r + t).replace(/^-/, "").length;
            e._tickround = Math.max(i, o) - 20, e._tickround < 0 && (e._tickround = 4);
          }
        } else if (a(t) || "L" === t.charAt(0)) {
          var l = e.range.map(e.r2d || Number);
          a(t) || (t = Number(t.substr(1))), e._tickround = 2 - Math.floor(Math.log(t) / Math.LN10 + .01);
          var s = Math.max(Math.abs(l[0]), Math.abs(l[1])),
            c = Math.floor(Math.log(s) / Math.LN10 + .01),
            u = void 0 === e.minexponent ? 3 : e.minexponent;
          Math.abs(c) > u && (ue(e.exponentformat) && !de(c) ? e._tickexponent = 3 * Math.round((c - 1) / 3) : e._tickexponent = c);
        } else e._tickround = null;
      }
      function se(e, t, r) {
        var n = e.tickfont || {};
        return {
          x: t,
          dx: 0,
          dy: 0,
          text: r || "",
          fontSize: n.size,
          font: n.family,
          fontColor: n.color
        };
      }
      Y.autoTicks = function (e, t) {
        var r;
        function n(e) {
          return Math.pow(e, Math.floor(Math.log(t) / Math.LN10));
        }
        if ("date" === e.type) {
          e.tick0 = l.dateTick0(e.calendar, 0);
          var i = 2 * t;
          if (i > y) t /= y, r = n(10), e.dtick = "M" + 12 * oe(t, r, $);else if (i > M) t /= M, e.dtick = "M" + oe(t, 1, ee);else if (i > A) {
            e.dtick = oe(t, A, e._hasDayOfWeekBreaks ? [1, 2, 7, 14] : re);
            var o = Y.getTickFormat(e),
              s = "period" === e.ticklabelmode;
            s && (e._rawTick0 = e.tick0), /%[uVW]/.test(o) ? e.tick0 = l.dateTick0(e.calendar, 2) : e.tick0 = l.dateTick0(e.calendar, 1), s && (e._dowTick0 = e.tick0);
          } else i > D ? e.dtick = oe(t, D, ee) : i > S ? e.dtick = oe(t, S, te) : i > C ? e.dtick = oe(t, C, te) : (r = n(10), e.dtick = oe(t, r, $));
        } else if ("log" === e.type) {
          e.tick0 = 0;
          var c = l.simpleMap(e.range, e.r2l);
          if (t > .7) e.dtick = Math.ceil(t);else if (Math.abs(c[1] - c[0]) < 1) {
            var u = 1.5 * Math.abs((c[1] - c[0]) / t);
            t = Math.abs(Math.pow(10, c[1]) - Math.pow(10, c[0])) / u, r = n(10), e.dtick = "L" + oe(t, r, $);
          } else e.dtick = t > .3 ? "D2" : "D1";
        } else "category" === e.type || "multicategory" === e.type ? (e.tick0 = 0, e.dtick = Math.ceil(Math.max(t, 1))) : ke(e) ? (e.tick0 = 0, r = 1, e.dtick = oe(t, r, ie)) : (e.tick0 = 0, r = n(10), e.dtick = oe(t, r, $));
        if (0 === e.dtick && (e.dtick = 1), !a(e.dtick) && "string" != typeof e.dtick) {
          var d = e.dtick;
          throw e.dtick = 1, "ax.dtick error: " + String(d);
        }
      }, Y.tickIncrement = function (e, t, r, i) {
        var o = r ? -1 : 1;
        if (a(t)) return l.increment(e, o * t);
        var s = t.charAt(0),
          c = o * Number(t.substr(1));
        if ("M" === s) return l.incrementMonth(e, c, i);
        if ("L" === s) return Math.log(Math.pow(10, e) + c) / Math.LN10;
        if ("D" === s) {
          var u = "D2" === t ? ae : ne,
            d = e + .01 * o,
            f = l.roundUp(l.mod(d, 1), u, r);
          return Math.floor(d) + Math.log(n.round(Math.pow(10, f), 1)) / Math.LN10;
        }
        throw "unrecognized dtick " + String(t);
      }, Y.tickFirst = function (e, t) {
        var r = e.r2l || Number,
          i = l.simpleMap(e.range, r, void 0, void 0, t),
          o = i[1] < i[0],
          s = o ? Math.floor : Math.ceil,
          c = W(i)[0],
          u = e.dtick,
          d = r(e.tick0);
        if (a(u)) {
          var f = s((c - d) / u) * u + d;
          return "category" !== e.type && "multicategory" !== e.type || (f = l.constrain(f, 0, e._categories.length - 1)), f;
        }
        var h = u.charAt(0),
          p = Number(u.substr(1));
        if ("M" === h) {
          for (var g, m, y, v = 0, x = d; v < 10;) {
            if (((g = Y.tickIncrement(x, u, o, e.calendar)) - c) * (x - c) <= 0) return o ? Math.min(x, g) : Math.max(x, g);
            m = (c - (x + g) / 2) / (g - x), y = h + (Math.abs(Math.round(m)) || 1) * p, x = Y.tickIncrement(x, y, m < 0 ? !o : o, e.calendar), v++;
          }
          return l.error("tickFirst did not converge", e), x;
        }
        if ("L" === h) return Math.log(s((Math.pow(10, c) - d) / p) * p + d) / Math.LN10;
        if ("D" === h) {
          var b = "D2" === u ? ae : ne,
            _ = l.roundUp(l.mod(c, 1), b, o);
          return Math.floor(c) + Math.log(n.round(Math.pow(10, _), 1)) / Math.LN10;
        }
        throw "unrecognized dtick " + String(u);
      }, Y.tickText = function (e, t, r, n) {
        var i,
          o = se(e, t),
          s = "array" === e.tickmode,
          c = r || s,
          u = e.type,
          d = "category" === u ? e.d2l_noadd : e.d2l;
        if (s && Array.isArray(e.ticktext)) {
          var f = l.simpleMap(e.range, e.r2l),
            h = (Math.abs(f[1] - f[0]) - (e._lBreaks || 0)) / 1e4;
          for (i = 0; i < e.ticktext.length && !(Math.abs(t - d(e.tickvals[i])) < h); i++);
          if (i < e.ticktext.length) return o.text = String(e.ticktext[i]), o;
        }
        function p(n) {
          if (void 0 === n) return !0;
          if (r) return "none" === n;
          var a = {
            first: e._tmin,
            last: e._tmax
          }[n];
          return "all" !== n && t !== a;
        }
        var g = r ? "never" : "none" !== e.exponentformat && p(e.showexponent) ? "hide" : "";
        if ("date" === u ? function (e, t, r, n) {
          var i = e._tickround,
            o = r && e.hoverformat || Y.getTickFormat(e);
          n && (i = a(i) ? 4 : {
            y: "m",
            m: "d",
            d: "M",
            M: "S",
            S: 4
          }[i]);
          var s,
            c = l.formatDate(t.x, o, i, e._dateFormat, e.calendar, e._extraFormat),
            u = c.indexOf("\n");
          -1 !== u && (s = c.substr(u + 1), c = c.substr(0, u));
          n && ("00:00:00" === c || "00:00" === c ? (c = s, s = "") : 8 === c.length && (c = c.replace(/:00$/, "")));
          if (s) if (r) "d" === i ? c += ", " + s : c = s + (c ? ", " + c : "");else if (e._inCalcTicks && e._prevDateHead === s) {
            var d = Le(e),
              f = e._realSide || e.side;
            (!d && "top" === f || d && "bottom" === f) && (c += "<br> ");
          } else e._prevDateHead = s, c += "<br>" + s;
          t.text = c;
        }(e, o, r, c) : "log" === u ? function (e, t, r, n, i) {
          var o = e.dtick,
            s = t.x,
            c = e.tickformat,
            u = "string" == typeof o && o.charAt(0);
          "never" === i && (i = "");
          n && "L" !== u && (o = "L3", u = "L");
          if (c || "L" === u) t.text = fe(Math.pow(10, s), e, i, n);else if (a(o) || "D" === u && l.mod(s + .01, 1) < .1) {
            var d = Math.round(s),
              f = Math.abs(d),
              h = e.exponentformat;
            "power" === h || ue(h) && de(d) ? (t.text = 0 === d ? 1 : 1 === d ? "10" : "10<sup>" + (d > 1 ? "" : O) + f + "</sup>", t.fontSize *= 1.25) : ("e" === h || "E" === h) && f > 2 ? t.text = "1" + h + (d > 0 ? "+" : O) + f : (t.text = fe(Math.pow(10, s), e, "", "fakehover"), "D1" === o && "y" === e._id.charAt(0) && (t.dy -= t.fontSize / 6));
          } else {
            if ("D" !== u) throw "unrecognized dtick " + String(o);
            t.text = String(Math.round(Math.pow(10, l.mod(s, 1)))), t.fontSize *= .75;
          }
          if ("D1" === e.dtick) {
            var p = String(t.text).charAt(0);
            "0" !== p && "1" !== p || ("y" === e._id.charAt(0) ? t.dx -= t.fontSize / 4 : (t.dy += t.fontSize / 2, t.dx += (e.range[1] > e.range[0] ? 1 : -1) * t.fontSize * (s < 0 ? .5 : .25)));
          }
        }(e, o, 0, c, g) : "category" === u ? function (e, t) {
          var r = e._categories[Math.round(t.x)];
          void 0 === r && (r = "");
          t.text = String(r);
        }(e, o) : "multicategory" === u ? function (e, t, r) {
          var n = Math.round(t.x),
            a = e._categories[n] || [],
            i = void 0 === a[1] ? "" : String(a[1]),
            o = void 0 === a[0] ? "" : String(a[0]);
          r ? t.text = o + " - " + i : (t.text = i, t.text2 = o);
        }(e, o, r) : ke(e) ? function (e, t, r, n, a) {
          if ("radians" !== e.thetaunit || r) t.text = fe(t.x, e, a, n);else {
            var i = t.x / 180;
            if (0 === i) t.text = "0";else {
              var o = function (e) {
                function t(e, t) {
                  return Math.abs(e - t) <= 1e-6;
                }
                var r = function (e) {
                    for (var r = 1; !t(Math.round(e * r) / r, e);) r *= 10;
                    return r;
                  }(e),
                  n = e * r,
                  a = Math.abs(function e(r, n) {
                    return t(n, 0) ? r : e(n, r % n);
                  }(n, r));
                return [Math.round(n / a), Math.round(r / a)];
              }(i);
              if (o[1] >= 100) t.text = fe(l.deg2rad(t.x), e, a, n);else {
                var s = t.x < 0;
                1 === o[1] ? 1 === o[0] ? t.text = "\u03C0" : t.text = o[0] + "\u03C0" : t.text = ["<sup>", o[0], "</sup>", "\u2044", "<sub>", o[1], "</sub>", "\u03C0"].join(""), s && (t.text = O + t.text);
              }
            }
          }
        }(e, o, r, c, g) : function (e, t, r, n, a) {
          "never" === a ? a = "" : "all" === e.showexponent && Math.abs(t.x / e.dtick) < 1e-6 && (a = "hide");
          t.text = fe(t.x, e, a, n);
        }(e, o, 0, c, g), n || (e.tickprefix && !p(e.showtickprefix) && (o.text = e.tickprefix + o.text), e.ticksuffix && !p(e.showticksuffix) && (o.text += e.ticksuffix)), "boundaries" === e.tickson || e.showdividers) {
          var m = function m(t) {
            var r = e.l2p(t);
            return r >= 0 && r <= e._length ? t : null;
          };
          o.xbnd = [m(o.x - .5), m(o.x + e.dtick - .5)];
        }
        return o;
      }, Y.hoverLabelText = function (e, t, r) {
        r && (e = l.extendFlat({}, e, {
          hoverformat: r
        }));
        var n = Array.isArray(t) ? t[0] : t,
          a = Array.isArray(t) ? t[1] : void 0;
        if (void 0 !== a && a !== n) return Y.hoverLabelText(e, n, r) + " - " + Y.hoverLabelText(e, a, r);
        var i = "log" === e.type && n <= 0,
          o = Y.tickText(e, e.c2l(i ? -n : n), "hover").text;
        return i ? 0 === n ? "0" : O + o : o;
      };
      var ce = ["f", "p", "n", "\u03BC", "m", "", "k", "M", "G", "T"];
      function ue(e) {
        return "SI" === e || "B" === e;
      }
      function de(e) {
        return e > 14 || e < -15;
      }
      function fe(e, t, r, n) {
        var i = e < 0,
          o = t._tickround,
          s = r || t.exponentformat || "B",
          c = t._tickexponent,
          u = Y.getTickFormat(t),
          d = t.separatethousands;
        if (n) {
          var f = {
            exponentformat: s,
            minexponent: t.minexponent,
            dtick: "none" === t.showexponent ? t.dtick : a(e) && Math.abs(e) || 1,
            range: "none" === t.showexponent ? t.range.map(t.r2d) : [0, e || 1]
          };
          le(f), o = (Number(f._tickround) || 0) + 4, c = f._tickexponent, t.hoverformat && (u = t.hoverformat);
        }
        if (u) return t._numFormat(u)(e).replace(/-/g, O);
        var h,
          p = Math.pow(10, -o) / 2;
        if ("none" === s && (c = 0), (e = Math.abs(e)) < p) e = "0", i = !1;else {
          if (e += p, c && (e *= Math.pow(10, -c), o += c), 0 === o) e = String(Math.floor(e));else if (o < 0) {
            e = (e = String(Math.round(e))).substr(0, e.length + o);
            for (var g = o; g < 0; g++) e += "0";
          } else {
            var m = (e = String(e)).indexOf(".") + 1;
            m && (e = e.substr(0, m + o).replace(/\.?0+$/, ""));
          }
          e = l.numSeparate(e, t._separators, d);
        }
        c && "hide" !== s && (ue(s) && de(c) && (s = "power"), h = c < 0 ? O + -c : "power" !== s ? "+" + c : String(c), "e" === s || "E" === s ? e += s + h : "power" === s ? e += "\xd710<sup>" + h + "</sup>" : "B" === s && 9 === c ? e += "B" : ue(s) && (e += ce[c / 3 + 5]));
        return i ? O + e : e;
      }
      function he(e, t) {
        for (var r = [], n = {}, a = 0; a < t.length; a++) {
          var i = t[a];
          n[i.text2] ? n[i.text2].push(i.x) : n[i.text2] = [i.x];
        }
        for (var o in n) r.push(se(e, l.interp(n[o], .5), o));
        return r;
      }
      function pe(e) {
        return void 0 !== e.periodX ? e.periodX : e.x;
      }
      function ge(e) {
        return [e.text, e.x, e.axInfo, e.font, e.fontSize, e.fontColor].join("_");
      }
      function me(e) {
        var t = e.title.font.size,
          r = (e.title.text.match(c.BR_TAG_ALL) || []).length;
        return e.title.hasOwnProperty("standoff") ? r ? t * (j + r * H) : t * j : r ? t * (r + 1) * H : t;
      }
      function ye(e, t) {
        var r = e.l2p(t);
        return r > 1 && r < e._length - 1;
      }
      function ve(e) {
        var t = n.select(e),
          r = t.select(".text-math-group");
        return r.empty() ? t.select("text") : r;
      }
      function xe(e) {
        return e._id + ".automargin";
      }
      function be(e) {
        return xe(e) + ".mirror";
      }
      function _e(e) {
        return e._id + ".rangeslider";
      }
      function we(e, t) {
        for (var r = 0; r < t.length; r++) -1 === e.indexOf(t[r]) && e.push(t[r]);
      }
      function Me(e, t, r) {
        var n,
          a,
          i = [],
          o = [],
          s = e.layout;
        for (n = 0; n < t.length; n++) i.push(Y.getFromId(e, t[n]));
        for (n = 0; n < r.length; n++) o.push(Y.getFromId(e, r[n]));
        var c = Object.keys(h),
          u = ["anchor", "domain", "overlaying", "position", "side", "tickangle", "editType"],
          d = ["linear", "log"];
        for (n = 0; n < c.length; n++) {
          var f = c[n],
            p = i[0][f],
            g = o[0][f],
            m = !0,
            y = !1,
            v = !1;
          if ("_" !== f.charAt(0) && "function" != typeof p && -1 === u.indexOf(f)) {
            for (a = 1; a < i.length && m; a++) {
              var x = i[a][f];
              "type" === f && -1 !== d.indexOf(p) && -1 !== d.indexOf(x) && p !== x ? y = !0 : x !== p && (m = !1);
            }
            for (a = 1; a < o.length && m; a++) {
              var b = o[a][f];
              "type" === f && -1 !== d.indexOf(g) && -1 !== d.indexOf(b) && g !== b ? v = !0 : o[a][f] !== g && (m = !1);
            }
            m && (y && (s[i[0]._name].type = "linear"), v && (s[o[0]._name].type = "linear"), Te(s, f, i, o, e._fullLayout._dfltTitle));
          }
        }
        for (n = 0; n < e._fullLayout.annotations.length; n++) {
          var _ = e._fullLayout.annotations[n];
          -1 !== t.indexOf(_.xref) && -1 !== r.indexOf(_.yref) && l.swapAttrs(s.annotations[n], ["?"]);
        }
      }
      function Te(e, t, r, n, a) {
        var i,
          o = l.nestedProperty,
          s = o(e[r[0]._name], t).get(),
          c = o(e[n[0]._name], t).get();
        for ("title" === t && (s && s.text === a.x && (s.text = a.y), c && c.text === a.y && (c.text = a.x)), i = 0; i < r.length; i++) o(e, r[i]._name + "." + t).set(c);
        for (i = 0; i < n.length; i++) o(e, n[i]._name + "." + t).set(s);
      }
      function ke(e) {
        return "angularaxis" === e._id;
      }
      function Ae(e, t) {
        for (var r = t._rangebreaks.length, n = 0; n < r; n++) {
          var a = t._rangebreaks[n];
          if (e >= a.min && e < a.max) return a.max;
        }
        return e;
      }
      function Le(e) {
        return -1 !== (e.ticklabelposition || "").indexOf("inside");
      }
      function De(e, t) {
        Le(e._anchorAxis || {}) && e._hideCounterAxisInsideTickLabels && e._hideCounterAxisInsideTickLabels(t);
      }
      Y.getTickFormat = function (e) {
        var t, r, n, a, i, o, l, s;
        function c(e) {
          return "string" != typeof e ? e : Number(e.replace("M", "")) * M;
        }
        function u(e, t) {
          var r = ["L", "D"];
          if (typeof e == typeof t) {
            if ("number" == typeof e) return e - t;
            var n = r.indexOf(e.charAt(0)),
              a = r.indexOf(t.charAt(0));
            return n === a ? Number(e.replace(/(L|D)/g, "")) - Number(t.replace(/(L|D)/g, "")) : n - a;
          }
          return "number" == typeof e ? 1 : -1;
        }
        function d(e, t) {
          var r = null === t[0],
            n = null === t[1],
            a = u(e, t[0]) >= 0,
            i = u(e, t[1]) <= 0;
          return (r || a) && (n || i);
        }
        if (e.tickformatstops && e.tickformatstops.length > 0) switch (e.type) {
          case "date":
          case "linear":
            for (t = 0; t < e.tickformatstops.length; t++) if ((n = e.tickformatstops[t]).enabled && (a = e.dtick, i = n.dtickrange, o = void 0, l = void 0, s = void 0, o = c || function (e) {
              return e;
            }, l = i[0], s = i[1], (!l && "number" != typeof l || o(l) <= o(a)) && (!s && "number" != typeof s || o(s) >= o(a)))) {
              r = n;
              break;
            }
            break;
          case "log":
            for (t = 0; t < e.tickformatstops.length; t++) if ((n = e.tickformatstops[t]).enabled && d(e.dtick, n.dtickrange)) {
              r = n;
              break;
            }
        }
        return r ? r.value : e.tickformat;
      }, Y.getSubplots = function (e, t) {
        var r = e._fullLayout._subplots,
          n = r.cartesian.concat(r.gl2d || []),
          a = t ? Y.findSubplotsWithAxis(n, t) : n;
        return a.sort(function (e, t) {
          var r = e.substr(1).split("y"),
            n = t.substr(1).split("y");
          return r[0] === n[0] ? +r[1] - +n[1] : +r[0] - +n[0];
        }), a;
      }, Y.findSubplotsWithAxis = function (e, t) {
        for (var r = new RegExp("x" === t._id.charAt(0) ? "^" + t._id + "y" : t._id + "$"), n = [], a = 0; a < e.length; a++) {
          var i = e[a];
          r.test(i) && n.push(i);
        }
        return n;
      }, Y.makeClipPaths = function (e) {
        var t = e._fullLayout;
        if (!t._hasOnlyLargeSploms) {
          var r,
            a,
            i = {
              _offset: 0,
              _length: t.width,
              _id: ""
            },
            o = {
              _offset: 0,
              _length: t.height,
              _id: ""
            },
            l = Y.list(e, "x", !0),
            s = Y.list(e, "y", !0),
            c = [];
          for (r = 0; r < l.length; r++) for (c.push({
            x: l[r],
            y: o
          }), a = 0; a < s.length; a++) 0 === r && c.push({
            x: i,
            y: s[a]
          }), c.push({
            x: l[r],
            y: s[a]
          });
          var u = t._clips.selectAll(".axesclip").data(c, function (e) {
            return e.x._id + e.y._id;
          });
          u.enter().append("clipPath").classed("axesclip", !0).attr("id", function (e) {
            return "clip" + t._uid + e.x._id + e.y._id;
          }).append("rect"), u.exit().remove(), u.each(function (e) {
            n.select(this).select("rect").attr({
              x: e.x._offset || 0,
              y: e.y._offset || 0,
              width: e.x._length || 1,
              height: e.y._length || 1
            });
          });
        }
      }, Y.draw = function (e, t, r) {
        var n = e._fullLayout;
        "redraw" === t && n._paper.selectAll("g.subplot").each(function (e) {
          var t = e[0],
            r = n._plots[t];
          if (r) {
            var a = r.xaxis,
              i = r.yaxis;
            r.xaxislayer.selectAll("." + a._id + "tick").remove(), r.yaxislayer.selectAll("." + i._id + "tick").remove(), r.xaxislayer.selectAll("." + a._id + "tick2").remove(), r.yaxislayer.selectAll("." + i._id + "tick2").remove(), r.xaxislayer.selectAll("." + a._id + "divider").remove(), r.yaxislayer.selectAll("." + i._id + "divider").remove(), r.gridlayer && r.gridlayer.selectAll("path").remove(), r.zerolinelayer && r.zerolinelayer.selectAll("path").remove(), n._infolayer.select(".g-" + a._id + "title").remove(), n._infolayer.select(".g-" + i._id + "title").remove();
          }
        });
        var a = t && "redraw" !== t ? t : Y.listIds(e);
        return l.syncOrAsync(a.map(function (t) {
          return function () {
            if (t) {
              var n = Y.getFromId(e, t),
                a = Y.drawOne(e, n, r);
              return n._r = n.range.slice(), n._rl = l.simpleMap(n._r, n.r2l), a;
            }
          };
        }));
      }, Y.drawOne = function (e, t, r) {
        var n, a, s;
        r = r || {}, t.setScale();
        var c = e._fullLayout,
          h = t._id,
          p = h.charAt(0),
          g = Y.counterLetter(h),
          m = c._plots[t._mainSubplot];
        if (m) {
          var y = m[p + "axislayer"],
            v = t._mainLinePosition,
            x = t._mainMirrorPosition,
            b = t._vals = Y.calcTicks(t),
            _ = [t.mirror, v, x].join("_");
          for (n = 0; n < b.length; n++) b[n].axInfo = _;
          t._selections = {}, t._tickAngles && (t._prevTickAngles = t._tickAngles), t._tickAngles = {}, t._depth = null;
          var w = {};
          if (t.visible) {
            var M,
              T,
              k = Y.makeTransTickFn(t),
              A = Y.makeTransTickLabelFn(t),
              L = "inside" === t.ticks,
              D = "outside" === t.ticks;
            if ("boundaries" === t.tickson) {
              var S = function (e, t) {
                var r,
                  n = [],
                  a = function a(e, t) {
                    var r = e.xbnd[t];
                    null !== r && n.push(l.extendFlat({}, e, {
                      x: r
                    }));
                  };
                if (t.length) {
                  for (r = 0; r < t.length; r++) a(t[r], 0);
                  a(t[r - 1], 1);
                }
                return n;
              }(0, b);
              T = Y.clipEnds(t, S), M = L ? T : S;
            } else T = Y.clipEnds(t, b), M = L && "period" !== t.ticklabelmode ? T : b;
            var C = t._gridVals = T,
              O = function (e, t) {
                var r,
                  n,
                  a = [],
                  i = t.length && t[t.length - 1].x < t[0].x,
                  o = function o(e, t) {
                    var r = e.xbnd[t];
                    null !== r && a.push(l.extendFlat({}, e, {
                      x: r
                    }));
                  };
                if (e.showdividers && t.length) {
                  for (r = 0; r < t.length; r++) {
                    var s = t[r];
                    s.text2 !== n && o(s, i ? 1 : 0), n = s.text2;
                  }
                  o(t[r - 1], i ? 0 : 1);
                }
                return a;
              }(t, b);
            if (!c._hasOnlyLargeSploms) {
              var P = t._subplotsWith,
                I = {};
              for (n = 0; n < P.length; n++) {
                a = P[n];
                var z = (s = c._plots[a])[g + "axis"],
                  R = z._mainAxis._id;
                if (!I[R]) {
                  I[R] = 1;
                  var N = "x" === p ? "M0," + z._offset + "v" + z._length : "M" + z._offset + ",0h" + z._length;
                  Y.drawGrid(e, t, {
                    vals: C,
                    counterAxis: z,
                    layer: s.gridlayer.select("." + h),
                    path: N,
                    transFn: k
                  }), Y.drawZeroLine(e, t, {
                    counterAxis: z,
                    layer: s.zerolinelayer,
                    path: N,
                    transFn: k
                  });
                }
              }
            }
            var F = Y.getTickSigns(t),
              E = [];
            if (t.ticks) {
              var j,
                U,
                V,
                q = Y.makeTickPath(t, v, F[2]);
              if (t._anchorAxis && t.mirror && !0 !== t.mirror ? (j = Y.makeTickPath(t, x, F[3]), U = q + j) : (j = "", U = q), t.showdividers && D && "boundaries" === t.tickson) {
                var G = {};
                for (n = 0; n < O.length; n++) G[O[n].x] = 1;
                V = function V(e) {
                  return G[e.x] ? j : U;
                };
              } else V = U;
              Y.drawTicks(e, t, {
                vals: M,
                layer: y,
                path: V,
                transFn: k
              }), "allticks" === t.mirror && (E = Object.keys(t._linepositions || {}));
            }
            for (n = 0; n < E.length; n++) {
              a = E[n], s = c._plots[a];
              var Z = t._linepositions[a] || [],
                W = Y.makeTickPath(t, Z[0], F[0]) + Y.makeTickPath(t, Z[1], F[1]);
              Y.drawTicks(e, t, {
                vals: M,
                layer: s[p + "axislayer"],
                path: W,
                transFn: k
              });
            }
            var J = [];
            if (J.push(function () {
              return Y.drawLabels(e, t, {
                vals: b,
                layer: y,
                plotinfo: s,
                transFn: A,
                labelFns: Y.makeLabelFns(t, v)
              });
            }), "multicategory" === t.type) {
              var X = {
                x: 2,
                y: 10
              }[p];
              J.push(function () {
                var r = {
                    x: "height",
                    y: "width"
                  }[p],
                  n = K()[r] + X + (t._tickAngles[h + "tick"] ? t.tickfont.size * H : 0);
                return Y.drawLabels(e, t, {
                  vals: he(t, b),
                  layer: y,
                  cls: h + "tick2",
                  repositionOnUpdate: !0,
                  secondary: !0,
                  transFn: k,
                  labelFns: Y.makeLabelFns(t, v + n * F[4])
                });
              }), J.push(function () {
                return t._depth = F[4] * (K("tick2")[t.side] - v), function (e, t, r) {
                  var n = t._id + "divider",
                    a = r.vals,
                    i = r.layer.selectAll("path." + n).data(a, ge);
                  i.exit().remove(), i.enter().insert("path", ":first-child").classed(n, 1).classed("crisp", 1).call(d.stroke, t.dividercolor).style("stroke-width", f.crispRound(e, t.dividerwidth, 1) + "px"), i.attr("transform", r.transFn).attr("d", r.path);
                }(e, t, {
                  vals: O,
                  layer: y,
                  path: Y.makeTickPath(t, v, F[4], t._depth),
                  transFn: k
                });
              });
            } else t.title.hasOwnProperty("standoff") && J.push(function () {
              t._depth = F[4] * (K()[t.side] - v);
            });
            var Q = o.getComponentMethod("rangeslider", "isVisible")(t);
            return J.push(function () {
              var r,
                n,
                a,
                l,
                s = t.side.charAt(0),
                u = B[t.side].charAt(0),
                d = Y.getPxPosition(e, t),
                f = D ? t.ticklen : 0;
              if ((t.automargin || Q) && ("multicategory" === t.type ? r = K("tick2") : (r = K(), "x" === p && "b" === s && (t._depth = Math.max(r.width > 0 ? r.bottom - d : 0, f)))), t.automargin) {
                n = {
                  x: 0,
                  y: 0,
                  r: 0,
                  l: 0,
                  t: 0,
                  b: 0
                };
                var h = [0, 1];
                if ("x" === p) {
                  if ("b" === s ? n[s] = t._depth : (n[s] = t._depth = Math.max(r.width > 0 ? d - r.top : 0, f), h.reverse()), r.width > 0) {
                    var m = r.right - (t._offset + t._length);
                    m > 0 && (n.xr = 1, n.r = m);
                    var y = t._offset - r.left;
                    y > 0 && (n.xl = 0, n.l = y);
                  }
                } else if ("l" === s ? n[s] = t._depth = Math.max(r.height > 0 ? d - r.left : 0, f) : (n[s] = t._depth = Math.max(r.height > 0 ? r.right - d : 0, f), h.reverse()), r.height > 0) {
                  var v = r.bottom - (t._offset + t._length);
                  v > 0 && (n.yb = 0, n.b = v);
                  var x = t._offset - r.top;
                  x > 0 && (n.yt = 1, n.t = x);
                }
                n[g] = "free" === t.anchor ? t.position : t._anchorAxis.domain[h[0]], t.title.text !== c._dfltTitle[p] && (n[s] += me(t) + (t.title.standoff || 0)), t.mirror && "free" !== t.anchor && ((a = {
                  x: 0,
                  y: 0,
                  r: 0,
                  l: 0,
                  t: 0,
                  b: 0
                })[u] = t.linewidth, t.mirror && !0 !== t.mirror && (a[u] += f), !0 === t.mirror || "ticks" === t.mirror ? a[g] = t._anchorAxis.domain[h[1]] : "all" !== t.mirror && "allticks" !== t.mirror || (a[g] = [t._counterDomainMin, t._counterDomainMax][h[1]]));
              }
              Q && (l = o.getComponentMethod("rangeslider", "autoMarginOpts")(e, t)), i.autoMargin(e, xe(t), n), i.autoMargin(e, be(t), a), i.autoMargin(e, _e(t), l);
            }), r.skipTitle || Q && "bottom" === t.side || J.push(function () {
              return function (e, t) {
                var r,
                  n = e._fullLayout,
                  a = t._id,
                  i = a.charAt(0),
                  o = t.title.font.size;
                if (t.title.hasOwnProperty("standoff")) r = t._depth + t.title.standoff + me(t);else {
                  var l = Le(t);
                  if ("multicategory" === t.type) r = t._depth;else {
                    var s = 1.5 * o;
                    l && (s = .5 * o, "outside" === t.ticks && (s += t.ticklen)), r = 10 + s + (t.linewidth ? t.linewidth - 1 : 0);
                  }
                  l || (r += "x" === i ? "top" === t.side ? o * (t.showticklabels ? 1 : 0) : o * (t.showticklabels ? 1.5 : .5) : "right" === t.side ? o * (t.showticklabels ? 1 : .5) : o * (t.showticklabels ? .5 : 0));
                }
                var c,
                  d,
                  h,
                  p,
                  g = Y.getPxPosition(e, t);
                "x" === i ? (d = t._offset + t._length / 2, h = "top" === t.side ? g - r : g + r) : (h = t._offset + t._length / 2, d = "right" === t.side ? g + r : g - r, c = {
                  rotate: "-90",
                  offset: 0
                });
                if ("multicategory" !== t.type) {
                  var m = t._selections[t._id + "tick"];
                  if (p = {
                    selection: m,
                    side: t.side
                  }, m && m.node() && m.node().parentNode) {
                    var y = f.getTranslate(m.node().parentNode);
                    p.offsetLeft = y.x, p.offsetTop = y.y;
                  }
                  t.title.hasOwnProperty("standoff") && (p.pad = 0);
                }
                return u.draw(e, a + "title", {
                  propContainer: t,
                  propName: t._name + ".title.text",
                  placeholder: n._dfltTitle[i],
                  avoid: p,
                  transform: c,
                  attributes: {
                    x: d,
                    y: h,
                    "text-anchor": "middle"
                  }
                });
              }(e, t);
            }), l.syncOrAsync(J);
          }
        }
        function K(e) {
          var r = h + (e || "tick");
          return w[r] || (w[r] = function (e, t) {
            var r, n, a, i;
            e._selections[t].size() ? (r = 1 / 0, n = -1 / 0, a = 1 / 0, i = -1 / 0, e._selections[t].each(function () {
              var e = ve(this),
                t = f.bBox(e.node().parentNode);
              r = Math.min(r, t.top), n = Math.max(n, t.bottom), a = Math.min(a, t.left), i = Math.max(i, t.right);
            })) : (r = 0, n = 0, a = 0, i = 0);
            return {
              top: r,
              bottom: n,
              left: a,
              right: i,
              height: n - r,
              width: i - a
            };
          }(t, r)), w[r];
        }
      }, Y.getTickSigns = function (e) {
        var t = e._id.charAt(0),
          r = {
            x: "top",
            y: "right"
          }[t],
          n = e.side === r ? 1 : -1,
          a = [-1, 1, n, -n];
        return "inside" !== e.ticks == ("x" === t) && (a = a.map(function (e) {
          return -e;
        })), e.side && a.push({
          l: -1,
          t: -1,
          r: 1,
          b: 1
        }[e.side.charAt(0)]), a;
      }, Y.makeTransTickFn = function (e) {
        return "x" === e._id.charAt(0) ? function (t) {
          return s(e._offset + e.l2p(t.x), 0);
        } : function (t) {
          return s(0, e._offset + e.l2p(t.x));
        };
      }, Y.makeTransTickLabelFn = function (e) {
        var t = function (e) {
            var t = e.ticklabelposition || "",
              r = function r(e) {
                return -1 !== t.indexOf(e);
              },
              n = r("top"),
              a = r("left"),
              i = r("right"),
              o = r("bottom"),
              l = r("inside"),
              s = o || a || n || i;
            if (!s && !l) return [0, 0];
            var c = e.side,
              u = s ? (e.tickwidth || 0) / 2 : 0,
              d = 3,
              f = e.tickfont ? e.tickfont.size : 12;
            (o || n) && (u += f * j, d += (e.linewidth || 0) / 2);
            (a || i) && (u += (e.linewidth || 0) / 2, d += 3);
            l && "top" === c && (d -= f * (1 - j));
            (a || n) && (u = -u);
            "bottom" !== c && "right" !== c || (d = -d);
            return [s ? u : 0, l ? d : 0];
          }(e),
          r = t[0],
          n = t[1];
        return "x" === e._id.charAt(0) ? function (t) {
          return s(r + e._offset + e.l2p(pe(t)), n);
        } : function (t) {
          return s(n, r + e._offset + e.l2p(pe(t)));
        };
      }, Y.makeTickPath = function (e, t, r, n) {
        n = void 0 !== n ? n : e.ticklen;
        var a = e._id.charAt(0),
          i = (e.linewidth || 1) / 2;
        return "x" === a ? "M0," + (t + i * r) + "v" + n * r : "M" + (t + i * r) + ",0h" + n * r;
      }, Y.makeLabelFns = function (e, t, r) {
        var n = e.ticklabelposition || "",
          i = function i(e) {
            return -1 !== n.indexOf(e);
          },
          o = i("top"),
          s = i("left"),
          c = i("right"),
          u = i("bottom") || s || o || c,
          d = i("inside"),
          f = "inside" === n && "inside" === e.ticks || !d && "outside" === e.ticks && "boundaries" !== e.tickson,
          h = 0,
          p = 0,
          g = f ? e.ticklen : 0;
        if (d ? g *= -1 : u && (g = 0), f && (h += g, r)) {
          var m = l.deg2rad(r);
          h = g * Math.cos(m) + 1, p = g * Math.sin(m);
        }
        e.showticklabels && (f || e.showline) && (h += .2 * e.tickfont.size);
        var y,
          v,
          x,
          b,
          _,
          w = {
            labelStandoff: h += (e.linewidth || 1) / 2 * (d ? -1 : 1),
            labelShift: p
          },
          M = 0,
          T = e.side,
          k = e._id.charAt(0),
          A = e.tickangle;
        if ("x" === k) b = (_ = !d && "bottom" === T || d && "top" === T) ? 1 : -1, d && (b *= -1), y = p * b, v = t + h * b, x = _ ? 1 : -.2, 90 === Math.abs(A) && (d ? x += E : x = -90 === A && "bottom" === T ? j : 90 === A && "top" === T ? E : .5, M = E / 2 * (A / 90)), w.xFn = function (e) {
          return e.dx + y + M * e.fontSize;
        }, w.yFn = function (e) {
          return e.dy + v + e.fontSize * x;
        }, w.anchorFn = function (e, t) {
          if (u) {
            if (s) return "end";
            if (c) return "start";
          }
          return a(t) && 0 !== t && 180 !== t ? t * b < 0 !== d ? "end" : "start" : "middle";
        }, w.heightFn = function (t, r, n) {
          return r < -60 || r > 60 ? -.5 * n : "top" === e.side !== d ? -n : 0;
        };else if ("y" === k) {
          if (b = (_ = !d && "left" === T || d && "right" === T) ? 1 : -1, d && (b *= -1), y = h, v = p * b, x = 0, d || 90 !== Math.abs(A) || (x = -90 === A && "left" === T || 90 === A && "right" === T ? j : .5), d) {
            var L = a(A) ? +A : 0;
            if (0 !== L) {
              var D = l.deg2rad(L);
              M = Math.abs(Math.sin(D)) * j * b, x = 0;
            }
          }
          w.xFn = function (e) {
            return e.dx + t - (y + e.fontSize * x) * b + M * e.fontSize;
          }, w.yFn = function (e) {
            return e.dy + v + e.fontSize * E;
          }, w.anchorFn = function (e, t) {
            return a(t) && 90 === Math.abs(t) ? "middle" : _ ? "end" : "start";
          }, w.heightFn = function (t, r, n) {
            return "right" === e.side && (r *= -1), r < -30 ? -n : r < 30 ? -.5 * n : 0;
          };
        }
        return w;
      }, Y.drawTicks = function (e, t, r) {
        r = r || {};
        var n = t._id + "tick",
          a = r.vals;
        "period" === t.ticklabelmode && (a = a.slice()).shift();
        var i = r.layer.selectAll("path." + n).data(t.ticks ? a : [], ge);
        i.exit().remove(), i.enter().append("path").classed(n, 1).classed("ticks", 1).classed("crisp", !1 !== r.crisp).call(d.stroke, t.tickcolor).style("stroke-width", f.crispRound(e, t.tickwidth, 1) + "px").attr("d", r.path).style("display", null), De(t, [R]), i.attr("transform", r.transFn);
      }, Y.drawGrid = function (e, t, r) {
        r = r || {};
        var n = t._id + "grid",
          a = r.vals,
          i = r.counterAxis;
        if (!1 === t.showgrid) a = [];else if (i && Y.shouldShowZeroLine(e, t, i)) for (var o = "array" === t.tickmode, l = 0; l < a.length; l++) {
          var s = a[l].x;
          if (o ? !s : Math.abs(s) < t.dtick / 100) {
            if (a = a.slice(0, l).concat(a.slice(l + 1)), !o) break;
            l--;
          }
        }
        var c = r.layer.selectAll("path." + n).data(a, ge);
        c.exit().remove(), c.enter().append("path").classed(n, 1).classed("crisp", !1 !== r.crisp), t._gw = f.crispRound(e, t.gridwidth, 1), c.attr("transform", r.transFn).attr("d", r.path).call(d.stroke, t.gridcolor || "#ddd").style("stroke-width", t._gw + "px").style("display", null), De(t, [z]), "function" == typeof r.path && c.attr("d", r.path);
      }, Y.drawZeroLine = function (e, t, r) {
        r = r || r;
        var n = t._id + "zl",
          a = Y.shouldShowZeroLine(e, t, r.counterAxis),
          i = r.layer.selectAll("path." + n).data(a ? [{
            x: 0,
            id: t._id
          }] : []);
        i.exit().remove(), i.enter().append("path").classed(n, 1).classed("zl", 1).classed("crisp", !1 !== r.crisp).each(function () {
          r.layer.selectAll("path").sort(function (e, t) {
            return q(e.id, t.id);
          });
        }), i.attr("transform", r.transFn).attr("d", r.path).call(d.stroke, t.zerolinecolor || d.defaultLine).style("stroke-width", f.crispRound(e, t.zerolinewidth, t._gw || 1) + "px").style("display", null), De(t, [I]);
      }, Y.drawLabels = function (e, t, r) {
        r = r || {};
        var i = e._fullLayout,
          o = t._id,
          u = o.charAt(0),
          d = r.cls || o + "tick",
          h = r.vals,
          p = r.labelFns,
          g = r.secondary ? 0 : t.tickangle,
          m = (t._prevTickAngles || {})[d],
          y = r.layer.selectAll("g." + d).data(t.showticklabels ? h : [], ge),
          v = [];
        function x(e, i) {
          e.each(function (e) {
            var o = n.select(this),
              l = o.select(".text-math-group"),
              u = p.anchorFn(e, i),
              d = r.transFn.call(o.node(), e) + (a(i) && 0 != +i ? " rotate(" + i + "," + p.xFn(e) + "," + (p.yFn(e) - e.fontSize / 2) + ")" : ""),
              h = c.lineCount(o),
              g = H * e.fontSize,
              m = p.heightFn(e, a(i) ? +i : 0, (h - 1) * g);
            if (m && (d += s(0, m)), l.empty()) {
              var y = o.select("text");
              y.attr({
                transform: d,
                "text-anchor": u
              }), y.style("opacity", 1), t._adjustTickLabelsOverflow && t._adjustTickLabelsOverflow();
            } else {
              var v = f.bBox(l.node()).width * {
                end: -.5,
                start: .5
              }[u];
              l.attr("transform", d + s(v, 0));
            }
          });
        }
        y.enter().append("g").classed(d, 1).append("text").attr("text-anchor", "middle").each(function (t) {
          var r = n.select(this),
            a = e._promises.length;
          r.call(c.positionText, p.xFn(t), p.yFn(t)).call(f.font, t.font, t.fontSize, t.fontColor).text(t.text).call(c.convertToTspans, e), e._promises[a] ? v.push(e._promises.pop().then(function () {
            x(r, g);
          })) : x(r, g);
        }), De(t, [N]), y.exit().remove(), r.repositionOnUpdate && y.each(function (e) {
          n.select(this).select("text").call(c.positionText, p.xFn(e), p.yFn(e));
        }), t._adjustTickLabelsOverflow = function () {
          var r = t.ticklabeloverflow;
          if (r && "allow" !== r) {
            var a = -1 !== r.indexOf("hide"),
              o = "x" === t._id.charAt(0),
              s = 0,
              c = o ? e._fullLayout.width : e._fullLayout.height;
            if (-1 !== r.indexOf("domain")) {
              var u = l.simpleMap(t.range, t.r2l);
              s = t.l2p(u[0]) + t._offset, c = t.l2p(u[1]) + t._offset;
            }
            var d = Math.min(s, c),
              h = Math.max(s, c),
              p = t.side,
              g = 1 / 0,
              m = -1 / 0;
            for (var v in y.each(function (e) {
              var r = n.select(this);
              if (r.select(".text-math-group").empty()) {
                var i = f.bBox(r.node()),
                  l = 0;
                o ? (i.right > h || i.left < d) && (l = 1) : (i.bottom > h || i.top + (t.tickangle ? 0 : e.fontSize / 4) < d) && (l = 1);
                var s = r.select("text");
                l ? a && s.style("opacity", 0) : (s.style("opacity", 1), g = "bottom" === p || "right" === p ? Math.min(g, o ? i.top : i.left) : -1 / 0, m = "top" === p || "left" === p ? Math.max(m, o ? i.bottom : i.right) : 1 / 0);
              }
            }), i._plots) {
              var x = i._plots[v];
              if (t._id === x.xaxis._id || t._id === x.yaxis._id) {
                var b = o ? x.yaxis : x.xaxis;
                b && (b["_visibleLabelMin_" + t._id] = g, b["_visibleLabelMax_" + t._id] = m);
              }
            }
          }
        }, t._hideCounterAxisInsideTickLabels = function (e) {
          var r = "x" === t._id.charAt(0),
            a = [];
          for (var o in i._plots) {
            var l = i._plots[o];
            t._id !== l.xaxis._id && t._id !== l.yaxis._id || a.push(r ? l.yaxis : l.xaxis);
          }
          a.forEach(function (r, a) {
            r && Le(r) && (e || [I, z, R, N]).forEach(function (e) {
              var o = "tick" === e.K && "text" === e.L && "period" === t.ticklabelmode,
                l = i._plots[t._mainSubplot];
              (e.K === I.K ? l.zerolinelayer.selectAll("." + t._id + "zl") : e.K === z.K ? l.gridlayer.selectAll("." + t._id) : l[t._id.charAt(0) + "axislayer"]).each(function () {
                var i = n.select(this);
                e.L && (i = i.selectAll(e.L)), i.each(function (i) {
                  var l = t.l2p(o ? pe(i) : i.x) + t._offset,
                    s = n.select(this);
                  l < t["_visibleLabelMax_" + r._id] && l > t["_visibleLabelMin_" + r._id] ? s.style("display", "none") : "tick" !== e.K || a || s.style("display", null);
                });
              });
            });
          });
        }, x(y, m + 1 ? m : g);
        var b = null;
        t._selections && (t._selections[d] = y);
        var _ = [function () {
          return v.length && Promise.all(v);
        }];
        t.automargin && i._redrawFromAutoMarginCount && 90 === m ? (b = 90, _.push(function () {
          x(y, m);
        })) : _.push(function () {
          if (x(y, g), h.length && "x" === u && !a(g) && ("log" !== t.type || "D" !== String(t.dtick).charAt(0))) {
            b = 0;
            var e,
              n = 0,
              i = [];
            if (y.each(function (e) {
              n = Math.max(n, e.fontSize);
              var r = t.l2p(e.x),
                a = ve(this),
                o = f.bBox(a.node());
              i.push({
                top: 0,
                bottom: 10,
                height: 10,
                left: r - o.width / 2,
                right: r + o.width / 2 + 2,
                width: o.width + 2
              });
            }), "boundaries" !== t.tickson && !t.showdividers || r.secondary) {
              var o = h.length,
                s = Math.abs((h[o - 1].x - h[0].x) * t._m) / (o - 1),
                c = t.ticklabelposition || "",
                d = function d(e) {
                  return -1 !== c.indexOf(e);
                },
                p = d("top"),
                m = d("left"),
                v = d("right"),
                _ = d("bottom") || m || p || v ? (t.tickwidth || 0) + 6 : 0,
                w = s < 2.5 * n || "multicategory" === t.type;
              for (e = 0; e < i.length - 1; e++) if (l.bBoxIntersect(i[e], i[e + 1], _)) {
                b = w ? 90 : 30;
                break;
              }
            } else {
              var M = 2;
              for (t.ticks && (M += t.tickwidth / 2), e = 0; e < i.length; e++) {
                var T = h[e].xbnd,
                  k = i[e];
                if (null !== T[0] && k.left - t.l2p(T[0]) < M || null !== T[1] && t.l2p(T[1]) - k.right < M) {
                  b = 90;
                  break;
                }
              }
            }
            b && x(y, b);
          }
        }), t._tickAngles && _.push(function () {
          t._tickAngles[d] = null === b ? a(g) ? g : 0 : b;
        });
        var w = t._anchorAxis;
        w && w.autorange && Le(t) && !G(i, t._id) && (i._insideTickLabelsAutorange || (i._insideTickLabelsAutorange = {}), i._insideTickLabelsAutorange[w._name + ".autorange"] = w.autorange, _.push(function () {
          y.each(function (e, r) {
            var n = ve(this);
            n.select(".text-math-group").empty() && (t._vals[r].bb = f.bBox(n.node()));
          });
        }));
        var M = l.syncOrAsync(_);
        return M && M.then && e._promises.push(M), M;
      }, Y.getPxPosition = function (e, t) {
        var r,
          n = e._fullLayout._size,
          a = t._id.charAt(0),
          i = t.side;
        return "free" !== t.anchor ? r = t._anchorAxis : "x" === a ? r = {
          _offset: n.t + (1 - (t.position || 0)) * n.h,
          _length: 0
        } : "y" === a && (r = {
          _offset: n.l + (t.position || 0) * n.w,
          _length: 0
        }), "top" === i || "left" === i ? r._offset : "bottom" === i || "right" === i ? r._offset + r._length : void 0;
      }, Y.shouldShowZeroLine = function (e, t, r) {
        var n = l.simpleMap(t.range, t.r2l);
        return n[0] * n[1] <= 0 && t.zeroline && ("linear" === t.type || "-" === t.type) && !(t.rangebreaks && t.maskBreaks(0) === P) && (ye(t, 0) || !function (e, t, r, n) {
          var a = r._mainAxis;
          if (!a) return;
          var i = e._fullLayout,
            o = t._id.charAt(0),
            l = Y.counterLetter(t._id),
            s = t._offset + (Math.abs(n[0]) < Math.abs(n[1]) == ("x" === o) ? 0 : t._length);
          function c(e) {
            if (!e.showline || !e.linewidth) return !1;
            var r = Math.max((e.linewidth + t.zerolinewidth) / 2, 1);
            function n(e) {
              return "number" == typeof e && Math.abs(e - s) < r;
            }
            if (n(e._mainLinePosition) || n(e._mainMirrorPosition)) return !0;
            var a = e._linepositions || {};
            for (var i in a) if (n(a[i][0]) || n(a[i][1])) return !0;
          }
          var u = i._plots[r._mainSubplot];
          if (!(u.mainplotinfo || u).overlays.length) return c(r);
          for (var d = Y.list(e, l), f = 0; f < d.length; f++) {
            var h = d[f];
            if (h._mainAxis === a && c(h)) return !0;
          }
        }(e, t, r, n) || function (e, t) {
          for (var r = e._fullData, n = t._mainSubplot, a = t._id.charAt(0), i = 0; i < r.length; i++) {
            var l = r[i];
            if (!0 === l.visible && l.xaxis + l.yaxis === n) {
              if (o.traceIs(l, "bar-like") && l.orientation === {
                x: "h",
                y: "v"
              }[a]) return !0;
              if (l.fill && l.fill.charAt(l.fill.length - 1) === a) return !0;
            }
          }
          return !1;
        }(e, t));
      }, Y.clipEnds = function (e, t) {
        return t.filter(function (t) {
          return ye(e, t.x);
        });
      }, Y.allowAutoMargin = function (e) {
        for (var t = Y.list(e, "", !0), r = 0; r < t.length; r++) {
          var n = t[r];
          n.automargin && (i.allowAutoMargin(e, xe(n)), n.mirror && i.allowAutoMargin(e, be(n))), o.getComponentMethod("rangeslider", "isVisible")(n) && i.allowAutoMargin(e, _e(n));
        }
      }, Y.swap = function (e, t) {
        for (var r = function (e, t) {
            var r,
              n,
              a = [];
            for (r = 0; r < t.length; r++) {
              var i = [],
                o = e._fullData[t[r]].xaxis,
                l = e._fullData[t[r]].yaxis;
              if (o && l) {
                for (n = 0; n < a.length; n++) -1 === a[n].x.indexOf(o) && -1 === a[n].y.indexOf(l) || i.push(n);
                if (i.length) {
                  var s,
                    c = a[i[0]];
                  if (i.length > 1) for (n = 1; n < i.length; n++) s = a[i[n]], we(c.x, s.x), we(c.y, s.y);
                  we(c.x, [o]), we(c.y, [l]);
                } else a.push({
                  x: [o],
                  y: [l]
                });
              }
            }
            return a;
          }(e, t), n = 0; n < r.length; n++) Me(e, r[n].x, r[n].y);
      };
    }, {
      "../../components/color": 96,
      "../../components/drawing": 118,
      "../../components/titles": 194,
      "../../constants/alignment": 201,
      "../../constants/numerical": 205,
      "../../lib": 225,
      "../../lib/svg_text_utils": 248,
      "../../plots/plots": 307,
      "../../registry": 309,
      "./autorange": 271,
      "./axis_autotype": 273,
      "./axis_ids": 276,
      "./clean_ticks": 278,
      "./layout_attributes": 287,
      "./set_convert": 293,
      "@plotly/d3": 6,
      "fast-isnumeric": 11
    }],
    273: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib"),
        i = e("../../constants/numerical").BADNUM,
        o = a.isArrayOrTypedArray,
        l = a.isDateTime,
        s = a.cleanNumber,
        c = Math.round;
      function u(e, t) {
        return t ? n(e) : "number" == typeof e;
      }
      function d(e) {
        return Math.max(1, (e - 1) / 1e3);
      }
      t.exports = function (e, t, r) {
        var a = e,
          f = r.noMultiCategory;
        if (o(a) && !a.length) return "-";
        if (!f && function (e) {
          return o(e[0]) && o(e[1]);
        }(a)) return "multicategory";
        if (f && Array.isArray(a[0])) {
          for (var h = [], p = 0; p < a.length; p++) if (o(a[p])) for (var g = 0; g < a[p].length; g++) h.push(a[p][g]);
          a = h;
        }
        if (function (e, t) {
          for (var r = e.length, a = d(r), i = 0, o = 0, s = {}, u = 0; u < r; u += a) {
            var f = c(u),
              h = e[f],
              p = String(h);
            s[p] || (s[p] = 1, l(h, t) && i++, n(h) && o++);
          }
          return i > 2 * o;
        }(a, t)) return "date";
        var m = "strict" !== r.autotypenumbers;
        return function (e, t) {
          for (var r = e.length, n = d(r), a = 0, o = 0, l = {}, u = 0; u < r; u += n) {
            var f = c(u),
              h = e[f],
              p = String(h);
            if (!l[p]) {
              l[p] = 1;
              var g = typeof h;
              "boolean" === g ? o++ : (t ? s(h) !== i : "number" === g) ? a++ : "string" === g && o++;
            }
          }
          return o > 2 * a;
        }(a, m) ? "category" : function (e, t) {
          for (var r = e.length, n = 0; n < r; n++) if (u(e[n], t)) return !0;
          return !1;
        }(a, m) ? "linear" : "-";
      };
    }, {
      "../../constants/numerical": 205,
      "../../lib": 225,
      "fast-isnumeric": 11
    }],
    274: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../registry"),
        i = e("../../lib"),
        o = e("../array_container_defaults"),
        l = e("./layout_attributes"),
        s = e("./tick_value_defaults"),
        c = e("./tick_mark_defaults"),
        u = e("./tick_label_defaults"),
        d = e("./category_order_defaults"),
        f = e("./line_grid_defaults"),
        h = e("./set_convert"),
        p = e("./constants").WEEKDAY_PATTERN,
        g = e("./constants").HOUR_PATTERN;
      function m(e, t, r) {
        function a(r, n) {
          return i.coerce(e, t, l.rangebreaks, r, n);
        }
        if (a("enabled")) {
          var o = a("bounds");
          if (o && o.length >= 2) {
            var s,
              c,
              u = "";
            if (2 === o.length) for (s = 0; s < 2; s++) if (c = v(o[s])) {
              u = p;
              break;
            }
            var d = a("pattern", u);
            if (d === p) for (s = 0; s < 2; s++) (c = v(o[s])) && (t.bounds[s] = o[s] = c - 1);
            if (d) for (s = 0; s < 2; s++) switch (c = o[s], d) {
              case p:
                if (!n(c)) return void (t.enabled = !1);
                if ((c = +c) !== Math.floor(c) || c < 0 || c >= 7) return void (t.enabled = !1);
                t.bounds[s] = o[s] = c;
                break;
              case g:
                if (!n(c)) return void (t.enabled = !1);
                if ((c = +c) < 0 || c > 24) return void (t.enabled = !1);
                t.bounds[s] = o[s] = c;
            }
            if (!1 === r.autorange) {
              var f = r.range;
              if (f[0] < f[1]) {
                if (o[0] < f[0] && o[1] > f[1]) return void (t.enabled = !1);
              } else if (o[0] > f[0] && o[1] < f[1]) return void (t.enabled = !1);
            }
          } else {
            var h = a("values");
            if (!h || !h.length) return void (t.enabled = !1);
            a("dvalue");
          }
        }
      }
      t.exports = function (e, t, r, n, g) {
        var y,
          v = n.letter,
          x = n.font || {},
          b = n.splomStash || {},
          _ = r("visible", !n.visibleDflt),
          w = t._template || {},
          M = t.type || w.type || "-";
        "date" === M && (a.getComponentMethod("calendars", "handleDefaults")(e, t, "calendar", n.calendar), n.noTicklabelmode || (y = r("ticklabelmode")));
        var T = "";
        n.noTicklabelposition && "multicategory" !== M || (T = i.coerce(e, t, {
          ticklabelposition: {
            valType: "enumerated",
            dflt: "outside",
            values: "period" === y ? ["outside", "inside"] : "x" === v ? ["outside", "inside", "outside left", "inside left", "outside right", "inside right"] : ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"]
          }
        }, "ticklabelposition")), n.noTicklabeloverflow || r("ticklabeloverflow", -1 !== T.indexOf("inside") ? "hide past domain" : "category" === M || "multicategory" === M ? "allow" : "hide past div"), h(t, g);
        var k = !t.isValidRange(e.range);
        k && n.reverseDflt && (k = "reversed"), !r("autorange", k) || "linear" !== M && "-" !== M || r("rangemode"), r("range"), t.cleanRange(), d(e, t, r, n), "category" === M || n.noHover || r("hoverformat");
        var A = r("color"),
          L = A !== l.color.dflt ? A : x.color,
          D = b.label || g._dfltTitle[v];
        if (u(e, t, r, M, n, {
          pass: 1
        }), !_) return t;
        r("title.text", D), i.coerceFont(r, "title.font", {
          family: x.family,
          size: i.bigFont(x.size),
          color: L
        }), s(e, t, r, M), u(e, t, r, M, n, {
          pass: 2
        }), c(e, t, r, n), f(e, t, r, {
          dfltColor: A,
          bgColor: n.bgColor,
          showGrid: n.showGrid,
          attributes: l
        }), (t.showline || t.ticks) && r("mirror"), n.automargin && r("automargin");
        var S,
          C = "multicategory" === M;
        n.noTickson || "category" !== M && !C || !t.ticks && !t.showgrid || (C && (S = "boundaries"), "boundaries" === r("tickson", S) && delete t.ticklabelposition);
        C && r("showdividers") && (r("dividercolor"), r("dividerwidth"));
        if ("date" === M) if (o(e, t, {
          name: "rangebreaks",
          inclusionAttr: "enabled",
          handleItemDefaults: m
        }), t.rangebreaks.length) {
          for (var O = 0; O < t.rangebreaks.length; O++) if (t.rangebreaks[O].pattern === p) {
            t._hasDayOfWeekBreaks = !0;
            break;
          }
          if (h(t, g), g._has("scattergl") || g._has("splom")) for (var P = 0; P < n.data.length; P++) {
            var I = n.data[P];
            "scattergl" !== I.type && "splom" !== I.type || (I.visible = !1, i.warn(I.type + " traces do not work on axes with rangebreaks. Setting trace " + I.index + " to `visible: false`."));
          }
        } else delete t.rangebreaks;
        return t;
      };
      var y = {
        sun: 1,
        mon: 2,
        tue: 3,
        wed: 4,
        thu: 5,
        fri: 6,
        sat: 7
      };
      function v(e) {
        if ("string" == typeof e) return y[e.substr(0, 3).toLowerCase()];
      }
    }, {
      "../../lib": 225,
      "../../registry": 309,
      "../array_container_defaults": 267,
      "./category_order_defaults": 277,
      "./constants": 279,
      "./layout_attributes": 287,
      "./line_grid_defaults": 289,
      "./set_convert": 293,
      "./tick_label_defaults": 294,
      "./tick_mark_defaults": 295,
      "./tick_value_defaults": 296,
      "fast-isnumeric": 11
    }],
    275: [function (e, t, r) {
      "use strict";

      var n = e("../../constants/docs"),
        a = n.FORMAT_LINK,
        i = n.DATE_FORMAT_LINK;
      function o(e, t) {
        return ["Sets the " + e + " formatting rule" + (t ? "for `" + t + "` " : ""), "using d3 formatting mini-languages", "which are very similar to those in Python. For numbers, see: " + a + "."].join(" ");
      }
      function l(e, t) {
        return o(e, t) + [" And for dates see: " + i + ".", "We add two items to d3's date formatter:", "*%h* for half of the year as a decimal number as well as", "*%{n}f* for fractional seconds", "with n digits. For example, *2016-10-13 09:15:23.456* with tickformat", "*%H~%M~%S.%2f* would display *09~15~23.46*"].join(" ");
      }
      t.exports = {
        axisHoverFormat: function axisHoverFormat(e, t) {
          return {
            valType: "string",
            dflt: "",
            editType: "none",
            description: (t ? o : l)("hover text", e) + ["By default the values are formatted using " + (t ? "generic number format" : "`" + e + "axis.hoverformat`") + "."].join(" ")
          };
        },
        descriptionOnlyNumbers: o,
        descriptionWithDates: l
      };
    }, {
      "../../constants/docs": 203
    }],
    276: [function (e, t, r) {
      "use strict";

      var n = e("../../registry"),
        a = e("./constants");
      function i(e, t) {
        if (t && t.length) for (var r = 0; r < t.length; r++) if (t[r][e]) return !0;
        return !1;
      }
      r.id2name = function (e) {
        if ("string" == typeof e && e.match(a.AX_ID_PATTERN)) {
          var t = e.split(" ")[0].substr(1);
          return "1" === t && (t = ""), e.charAt(0) + "axis" + t;
        }
      }, r.name2id = function (e) {
        if (e.match(a.AX_NAME_PATTERN)) {
          var t = e.substr(5);
          return "1" === t && (t = ""), e.charAt(0) + t;
        }
      }, r.cleanId = function (e, t, r) {
        var n = /( domain)$/.test(e);
        if ("string" == typeof e && e.match(a.AX_ID_PATTERN) && (!t || e.charAt(0) === t) && (!n || r)) {
          var i = e.split(" ")[0].substr(1).replace(/^0+/, "");
          return "1" === i && (i = ""), e.charAt(0) + i + (n && r ? " domain" : "");
        }
      }, r.list = function (e, t, n) {
        var a = e._fullLayout;
        if (!a) return [];
        var i,
          o = r.listIds(e, t),
          l = new Array(o.length);
        for (i = 0; i < o.length; i++) {
          var s = o[i];
          l[i] = a[s.charAt(0) + "axis" + s.substr(1)];
        }
        if (!n) {
          var c = a._subplots.gl3d || [];
          for (i = 0; i < c.length; i++) {
            var u = a[c[i]];
            t ? l.push(u[t + "axis"]) : l.push(u.xaxis, u.yaxis, u.zaxis);
          }
        }
        return l;
      }, r.listIds = function (e, t) {
        var r = e._fullLayout;
        if (!r) return [];
        var n = r._subplots;
        return t ? n[t + "axis"] : n.xaxis.concat(n.yaxis);
      }, r.getFromId = function (e, t, n) {
        var a = e._fullLayout;
        return t = void 0 === t || "string" != typeof t ? t : t.replace(" domain", ""), "x" === n ? t = t.replace(/y[0-9]*/, "") : "y" === n && (t = t.replace(/x[0-9]*/, "")), a[r.id2name(t)];
      }, r.getFromTrace = function (e, t, a) {
        var i = e._fullLayout,
          o = null;
        if (n.traceIs(t, "gl3d")) {
          var l = t.scene;
          "scene" === l.substr(0, 5) && (o = i[l][a + "axis"]);
        } else o = r.getFromId(e, t[a + "axis"] || a);
        return o;
      }, r.idSort = function (e, t) {
        var r = e.charAt(0),
          n = t.charAt(0);
        return r !== n ? r > n ? 1 : -1 : +(e.substr(1) || 1) - +(t.substr(1) || 1);
      }, r.ref2id = function (e) {
        return !!/^[xyz]/.test(e) && e.split(" ")[0];
      }, r.isLinked = function (e, t) {
        return i(t, e._axisMatchGroups) || i(t, e._axisConstraintGroups);
      };
    }, {
      "../../registry": 309,
      "./constants": 279
    }],
    277: [function (e, t, r) {
      "use strict";

      t.exports = function (e, t, r, n) {
        if ("category" === t.type) {
          var a,
            i = e.categoryarray,
            o = Array.isArray(i) && i.length > 0;
          o && (a = "array");
          var l,
            s = r("categoryorder", a);
          "array" === s && (l = r("categoryarray")), o || "array" !== s || (s = t.categoryorder = "trace"), "trace" === s ? t._initialCategories = [] : "array" === s ? t._initialCategories = l.slice() : (l = function (e, t) {
            var r,
              n,
              a,
              i = t.dataAttr || e._id.charAt(0),
              o = {};
            if (t.axData) r = t.axData;else for (r = [], n = 0; n < t.data.length; n++) {
              var l = t.data[n];
              l[i + "axis"] === e._id && r.push(l);
            }
            for (n = 0; n < r.length; n++) {
              var s = r[n][i];
              for (a = 0; a < s.length; a++) {
                var c = s[a];
                null != c && (o[c] = 1);
              }
            }
            return Object.keys(o);
          }(t, n).sort(), "category ascending" === s ? t._initialCategories = l : "category descending" === s && (t._initialCategories = l.reverse()));
        }
      };
    }, {}],
    278: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib"),
        i = e("../../constants/numerical"),
        o = i.ONEDAY,
        l = i.ONEWEEK;
      r.dtick = function (e, t) {
        var r = "log" === t,
          a = "date" === t,
          i = "category" === t,
          l = a ? o : 1;
        if (!e) return l;
        if (n(e)) return (e = Number(e)) <= 0 ? l : i ? Math.max(1, Math.round(e)) : a ? Math.max(.1, e) : e;
        if ("string" != typeof e || !a && !r) return l;
        var s = e.charAt(0),
          c = e.substr(1);
        return (c = n(c) ? Number(c) : 0) <= 0 || !(a && "M" === s && c === Math.round(c) || r && "L" === s || r && "D" === s && (1 === c || 2 === c)) ? l : e;
      }, r.tick0 = function (e, t, r, i) {
        return "date" === t ? a.cleanDate(e, a.dateTick0(r, i % l == 0 ? 1 : 0)) : "D1" !== i && "D2" !== i ? n(e) ? Number(e) : 0 : void 0;
      };
    }, {
      "../../constants/numerical": 205,
      "../../lib": 225,
      "fast-isnumeric": 11
    }],
    279: [function (e, t, r) {
      "use strict";

      var n = e("../../lib/regex").counter;
      t.exports = {
        idRegex: {
          x: n("x", "( domain)?"),
          y: n("y", "( domain)?")
        },
        attrRegex: n("[xy]axis"),
        xAxisMatch: n("xaxis"),
        yAxisMatch: n("yaxis"),
        AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
        AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
        SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
        HOUR_PATTERN: "hour",
        WEEKDAY_PATTERN: "day of week",
        MINDRAG: 8,
        MINSELECT: 12,
        MINZOOM: 20,
        DRAGGERSIZE: 20,
        BENDPX: 1.5,
        REDRAWDELAY: 50,
        SELECTDELAY: 100,
        SELECTID: "-select",
        DFLTRANGEX: [-1, 6],
        DFLTRANGEY: [-1, 4],
        traceLayerClasses: ["imagelayer", "heatmaplayer", "contourcarpetlayer", "contourlayer", "funnellayer", "waterfalllayer", "barlayer", "carpetlayer", "violinlayer", "boxlayer", "ohlclayer", "scattercarpetlayer", "scatterlayer"],
        clipOnAxisFalseQuery: [".scatterlayer", ".barlayer", ".funnellayer", ".waterfalllayer"],
        layerValue2layerClass: {
          "above traces": "above",
          "below traces": "below"
        }
      };
    }, {
      "../../lib/regex": 241
    }],
    280: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("./autorange"),
        i = e("./axis_ids").id2name,
        o = e("./layout_attributes"),
        l = e("./scale_zoom"),
        s = e("./set_convert"),
        c = e("../../constants/numerical").ALMOST_EQUAL,
        u = e("../../constants/alignment").FROM_BL;
      function d(e, t, r) {
        var a = r.axIds,
          l = r.layoutOut,
          s = r.hasImage,
          c = l._axisConstraintGroups,
          u = l._axisMatchGroups,
          d = t._id,
          g = d.charAt(0),
          m = ((l._splomAxes || {})[g] || {})[d] || {},
          y = t._id,
          v = "x" === y.charAt(0);
        function x(r, a) {
          return n.coerce(e, t, o, r, a);
        }
        t._matchGroup = null, t._constraintGroup = null, x("constrain", s ? "domain" : "range"), n.coerce(e, t, {
          constraintoward: {
            valType: "enumerated",
            values: v ? ["left", "center", "right"] : ["bottom", "middle", "top"],
            dflt: v ? "center" : "middle"
          }
        }, "constraintoward");
        var b,
          _,
          w = t.type,
          M = [];
        for (b = 0; b < a.length; b++) {
          if ((_ = a[b]) !== y) l[i(_)].type === w && M.push(_);
        }
        var T = h(c, y);
        if (T) {
          var k = [];
          for (b = 0; b < M.length; b++) T[_ = M[b]] || k.push(_);
          M = k;
        }
        var A,
          L,
          D = M.length;
        D && (e.matches || m.matches) && (A = n.coerce(e, t, {
          matches: {
            valType: "enumerated",
            values: M,
            dflt: -1 !== M.indexOf(m.matches) ? m.matches : void 0
          }
        }, "matches"));
        var S = s && !v ? t.anchor : void 0;
        if (D && !A && (e.scaleanchor || S) && (L = n.coerce(e, t, {
          scaleanchor: {
            valType: "enumerated",
            values: M
          }
        }, "scaleanchor", S)), A) {
          t._matchGroup = p(u, y, A, 1);
          var C = l[i(A)],
            O = f(l, t) / f(l, C);
          v !== ("x" === A.charAt(0)) && (O = (v ? "x" : "y") + O), p(c, y, A, O);
        } else e.matches && -1 !== a.indexOf(e.matches) && n.warn("ignored " + t._name + '.matches: "' + e.matches + '" to avoid an infinite loop');
        if (L) {
          var P = x("scaleratio");
          P || (P = t.scaleratio = 1), p(c, y, L, P);
        } else e.scaleanchor && -1 !== a.indexOf(e.scaleanchor) && n.warn("ignored " + t._name + '.scaleanchor: "' + e.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because this axis declares a *matches* constraint.');
      }
      function f(e, t) {
        var r = t.domain;
        return r || (r = e[i(t.overlaying)].domain), r[1] - r[0];
      }
      function h(e, t) {
        for (var r = 0; r < e.length; r++) if (e[r][t]) return e[r];
        return null;
      }
      function p(e, t, r, n) {
        var a,
          i,
          o,
          l,
          s,
          c = h(e, t);
        null === c ? ((c = {})[t] = 1, s = e.length, e.push(c)) : s = e.indexOf(c);
        var u = Object.keys(c);
        for (a = 0; a < e.length; a++) if (o = e[a], a !== s && o[r]) {
          var d = o[r];
          for (i = 0; i < u.length; i++) o[l = u[i]] = g(d, g(n, c[l]));
          return void e.splice(s, 1);
        }
        if (1 !== n) for (i = 0; i < u.length; i++) {
          var f = u[i];
          c[f] = g(n, c[f]);
        }
        c[r] = 1;
      }
      function g(e, t) {
        var r,
          n,
          a = "",
          i = "";
        "string" == typeof e && (r = (a = e.match(/^[xy]*/)[0]).length, e = +e.substr(r)), "string" == typeof t && (n = (i = t.match(/^[xy]*/)[0]).length, t = +t.substr(n));
        var o = e * t;
        return r || n ? r && n && a.charAt(0) !== i.charAt(0) ? r === n ? o : (r > n ? a.substr(n) : i.substr(r)) + o : a + i + e * t : o;
      }
      function m(e, t) {
        for (var r = t._size, n = r.h / r.w, a = {}, i = Object.keys(e), o = 0; o < i.length; o++) {
          var l = i[o],
            s = e[l];
          if ("string" == typeof s) {
            var c = s.match(/^[xy]*/)[0],
              u = c.length;
            s = +s.substr(u);
            for (var d = "y" === c.charAt(0) ? n : 1 / n, f = 0; f < u; f++) s *= d;
          }
          a[l] = s;
        }
        return a;
      }
      function y(e, t) {
        var r = e._inputDomain,
          n = u[e.constraintoward],
          a = r[0] + (r[1] - r[0]) * n;
        e.domain = e._input.domain = [a + (r[0] - a) / t, a + (r[1] - a) / t], e.setScale();
      }
      r.handleDefaults = function (e, t, r) {
        var a,
          o,
          l,
          c,
          u,
          f,
          h,
          p,
          g = r.axIds,
          m = r.axHasImage,
          y = t._axisConstraintGroups = [],
          v = t._axisMatchGroups = [];
        for (a = 0; a < g.length; a++) d(u = e[c = i(g[a])], f = t[c], {
          axIds: g,
          layoutOut: t,
          hasImage: m[c]
        });
        function x(e, r) {
          for (a = 0; a < e.length; a++) for (l in o = e[a]) t[i(l)][r] = o;
        }
        for (x(v, "_matchGroup"), a = 0; a < y.length; a++) for (l in o = y[a]) if ((f = t[i(l)]).fixedrange) {
          for (var b in o) {
            var _ = i(b);
            !1 === (e[_] || {}).fixedrange && n.warn("fixedrange was specified as false for axis " + _ + " but was overridden because another axis in its constraint group has fixedrange true"), t[_].fixedrange = !0;
          }
          break;
        }
        for (a = 0; a < y.length;) {
          for (l in o = y[a]) {
            (f = t[i(l)])._matchGroup && Object.keys(f._matchGroup).length === Object.keys(o).length && (y.splice(a, 1), a--);
            break;
          }
          a++;
        }
        x(y, "_constraintGroup");
        var w = ["constrain", "range", "autorange", "rangemode", "rangebreaks", "categoryorder", "categoryarray"],
          M = !1,
          T = !1;
        function k() {
          p = f[h], "rangebreaks" === h && (T = f._hasDayOfWeekBreaks);
        }
        for (a = 0; a < v.length; a++) {
          o = v[a];
          for (var A = 0; A < w.length; A++) {
            var L;
            for (l in h = w[A], p = null, o) if (u = e[c = i(l)], f = t[c], h in f) {
              if (!f.matches && (L = f, h in u)) {
                k();
                break;
              }
              null === p && h in u && k();
            }
            if ("range" === h && p && (M = !0), "autorange" === h && null === p && M && (p = !1), null === p && h in L && (p = L[h]), null !== p) for (l in o) (f = t[i(l)])[h] = "range" === h ? p.slice() : p, "rangebreaks" === h && (f._hasDayOfWeekBreaks = T, s(f, t));
          }
        }
      }, r.enforce = function (e) {
        var t,
          r,
          n,
          o,
          s,
          u,
          d,
          f,
          h = e._fullLayout,
          p = h._axisConstraintGroups || [];
        for (t = 0; t < p.length; t++) {
          n = m(p[t], h);
          var g = Object.keys(n),
            v = 1 / 0,
            x = 0,
            b = 1 / 0,
            _ = {},
            w = {},
            M = !1;
          for (r = 0; r < g.length; r++) w[o = g[r]] = s = h[i(o)], s._inputDomain ? s.domain = s._inputDomain.slice() : s._inputDomain = s.domain.slice(), s._inputRange || (s._inputRange = s.range.slice()), s.setScale(), _[o] = u = Math.abs(s._m) / n[o], v = Math.min(v, u), "domain" !== s.constrain && s._constraintShrinkable || (b = Math.min(b, u)), delete s._constraintShrinkable, x = Math.max(x, u), "domain" === s.constrain && (M = !0);
          if (!(v > c * x) || M) for (r = 0; r < g.length; r++) if (u = _[o = g[r]], d = (s = w[o]).constrain, u !== b || "domain" === d) if (f = u / b, "range" === d) l(s, f);else {
            var T = s._inputDomain,
              k = (s.domain[1] - s.domain[0]) / (T[1] - T[0]),
              A = (s.r2l(s.range[1]) - s.r2l(s.range[0])) / (s.r2l(s._inputRange[1]) - s.r2l(s._inputRange[0]));
            if ((f /= k) * A < 1) {
              s.domain = s._input.domain = T.slice(), l(s, f);
              continue;
            }
            if (A < 1 && (s.range = s._input.range = s._inputRange.slice(), f *= A), s.autorange) {
              var L = s.r2l(s.range[0]),
                D = s.r2l(s.range[1]),
                S = (L + D) / 2,
                C = S,
                O = S,
                P = Math.abs(D - S),
                I = S - P * f * 1.0001,
                z = S + P * f * 1.0001,
                R = a.makePadFn(h, s, 0),
                N = a.makePadFn(h, s, 1);
              y(s, f);
              var F,
                E,
                j = Math.abs(s._m),
                H = a.concatExtremes(e, s),
                B = H.min,
                Y = H.max;
              for (E = 0; E < B.length; E++) (F = B[E].val - R(B[E]) / j) > I && F < C && (C = F);
              for (E = 0; E < Y.length; E++) (F = Y[E].val + N(Y[E]) / j) < z && F > O && (O = F);
              f /= (O - C) / (2 * P), C = s.l2r(C), O = s.l2r(O), s.range = s._input.range = L < D ? [C, O] : [O, C];
            }
            y(s, f);
          }
        }
      }, r.getAxisGroup = function (e, t) {
        for (var r = e._axisMatchGroups, n = 0; n < r.length; n++) {
          if (r[n][t]) return "g" + n;
        }
        return t;
      }, r.clean = function (e, t) {
        if (t._inputDomain) {
          for (var r = !1, n = t._id, a = e._fullLayout._axisConstraintGroups, i = 0; i < a.length; i++) if (a[i][n]) {
            r = !0;
            break;
          }
          r && "domain" === t.constrain || (t._input.domain = t.domain = t._inputDomain, delete t._inputDomain);
        }
      };
    }, {
      "../../constants/alignment": 201,
      "../../constants/numerical": 205,
      "../../lib": 225,
      "./autorange": 271,
      "./axis_ids": 276,
      "./layout_attributes": 287,
      "./scale_zoom": 291,
      "./set_convert": 293
    }],
    281: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../lib"),
        i = a.numberFormat,
        o = e("tinycolor2"),
        l = e("has-passive-events"),
        s = e("../../registry"),
        c = a.strTranslate,
        u = e("../../lib/svg_text_utils"),
        d = e("../../components/color"),
        f = e("../../components/drawing"),
        h = e("../../components/fx"),
        p = e("./axes"),
        g = e("../../lib/setcursor"),
        m = e("../../components/dragelement"),
        y = e("../../components/dragelement/helpers"),
        v = y.selectingOrDrawing,
        x = y.freeMode,
        b = e("../../constants/alignment").FROM_TL,
        _ = e("../../lib/clear_gl_canvases"),
        w = e("../../plot_api/subroutines").redrawReglTraces,
        M = e("../plots"),
        T = e("./axis_ids").getFromId,
        k = e("./select").prepSelect,
        A = e("./select").clearSelect,
        L = e("./select").selectOnClick,
        D = e("./scale_zoom"),
        S = e("./constants"),
        C = S.MINDRAG,
        O = S.MINZOOM,
        P = !0;
      function I(e, t, r, n) {
        var i = a.ensureSingle(e.draglayer, t, r, function (t) {
          t.classed("drag", !0).style({
            fill: "transparent",
            "stroke-width": 0
          }).attr("data-subplot", e.id);
        });
        return i.call(g, n), i.node();
      }
      function z(e, t, r, a, i, o, l) {
        var s = I(e, "rect", t, r);
        return n.select(s).call(f.setRect, a, i, o, l), s;
      }
      function R(e, t) {
        for (var r = 0; r < e.length; r++) if (!e[r].fixedrange) return t;
        return "";
      }
      function N(e, t, r, n, a) {
        for (var i = 0; i < e.length; i++) {
          var o = e[i];
          if (!o.fixedrange) if (o.rangebreaks) {
            var l = "y" === o._id.charAt(0),
              s = l ? 1 - t : t,
              c = l ? 1 - r : r;
            n[o._name + ".range[0]"] = o.l2r(o.p2l(s * o._length)), n[o._name + ".range[1]"] = o.l2r(o.p2l(c * o._length));
          } else {
            var u = o._rl[0],
              d = o._rl[1] - u;
            n[o._name + ".range[0]"] = o.l2r(u + d * t), n[o._name + ".range[1]"] = o.l2r(u + d * r);
          }
        }
        if (a && a.length) {
          var f = (t + (1 - r)) / 2;
          N(a, f, 1 - f, n, []);
        }
      }
      function F(e, t) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          if (!n.fixedrange) if (n.rangebreaks) {
            var a = n._length,
              i = (n.p2l(0 + t) - n.p2l(0) + (n.p2l(a + t) - n.p2l(a))) / 2;
            n.range = [n.l2r(n._rl[0] - i), n.l2r(n._rl[1] - i)];
          } else n.range = [n.l2r(n._rl[0] - t / n._m), n.l2r(n._rl[1] - t / n._m)];
        }
      }
      function E(e) {
        return 1 - (e >= 0 ? Math.min(e, .9) : 1 / (1 / Math.max(e, -.3) + 3.222));
      }
      function j(e, t, r, n, a) {
        return e.append("path").attr("class", "zoombox").style({
          fill: t > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
          "stroke-width": 0
        }).attr("transform", c(r, n)).attr("d", a + "Z");
      }
      function H(e, t, r) {
        return e.append("path").attr("class", "zoombox-corners").style({
          fill: d.background,
          stroke: d.defaultLine,
          "stroke-width": 1,
          opacity: 0
        }).attr("transform", c(t, r)).attr("d", "M0,0Z");
      }
      function B(e, t, r, n, a, i) {
        e.attr("d", n + "M" + r.l + "," + r.t + "v" + r.h + "h" + r.w + "v-" + r.h + "h-" + r.w + "Z"), Y(e, t, a, i);
      }
      function Y(e, t, r, n) {
        r || (e.transition().style("fill", n > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), t.transition().style("opacity", 1).duration(200));
      }
      function U(e) {
        n.select(e).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
      }
      function V(e) {
        P && e.data && e._context.showTips && (a.notifier(a._(e, "Double-click to zoom back out"), "long"), P = !1);
      }
      function q(e) {
        var t = Math.floor(Math.min(e.b - e.t, e.r - e.l, O) / 2);
        return "M" + (e.l - 3.5) + "," + (e.t - .5 + t) + "h3v" + -t + "h" + t + "v-3h-" + (t + 3) + "ZM" + (e.r + 3.5) + "," + (e.t - .5 + t) + "h-3v" + -t + "h" + -t + "v-3h" + (t + 3) + "ZM" + (e.r + 3.5) + "," + (e.b + .5 - t) + "h-3v" + t + "h" + -t + "v3h" + (t + 3) + "ZM" + (e.l - 3.5) + "," + (e.b + .5 - t) + "h3v" + t + "h" + t + "v3h-" + (t + 3) + "Z";
      }
      function G(e, t, r, n, i) {
        for (var o, l, s, c, u = !1, d = {}, f = {}, h = (i || {}).xaHash, p = (i || {}).yaHash, g = 0; g < t.length; g++) {
          var m = t[g];
          for (o in r) if (m[o]) {
            for (s in m) i && (h[s] || p[s]) || ("x" === s.charAt(0) ? r : n)[s] || (d[s] = o);
            for (l in n) i && (h[l] || p[l]) || !m[l] || (u = !0);
          }
          for (l in n) if (m[l]) for (c in m) i && (h[c] || p[c]) || ("x" === c.charAt(0) ? r : n)[c] || (f[c] = l);
        }
        u && (a.extendFlat(d, f), f = {});
        var y = {},
          v = [];
        for (s in d) {
          var x = T(e, s);
          v.push(x), y[x._id] = x;
        }
        var b = {},
          _ = [];
        for (c in f) {
          var w = T(e, c);
          _.push(w), b[w._id] = w;
        }
        return {
          xaHash: y,
          yaHash: b,
          xaxes: v,
          yaxes: _,
          xLinks: d,
          yLinks: f,
          isSubplotConstrained: u
        };
      }
      function Z(e, t) {
        if (l) {
          var r = void 0 !== e.onwheel ? "wheel" : "mousewheel";
          e._onwheel && e.removeEventListener(r, e._onwheel), e._onwheel = t, e.addEventListener(r, t, {
            passive: !1
          });
        } else void 0 !== e.onwheel ? e.onwheel = t : void 0 !== e.onmousewheel ? e.onmousewheel = t : e.isAddedWheelEvent || (e.isAddedWheelEvent = !0, e.addEventListener("wheel", t, {
          passive: !1
        }));
      }
      function W(e) {
        var t = [];
        for (var r in e) t.push(e[r]);
        return t;
      }
      t.exports = {
        makeDragBox: function makeDragBox(e, t, r, l, c, d, g, y) {
          var P,
            I,
            Y,
            J,
            X,
            Q,
            K,
            $,
            ee,
            te,
            re,
            ne,
            ae,
            ie,
            oe,
            le,
            se,
            ce,
            ue,
            de,
            fe,
            he,
            pe,
            ge = e._fullLayout._zoomlayer,
            me = g + y === "nsew",
            ye = 1 === (g + y).length;
          function ve() {
            if (P = t.xaxis, I = t.yaxis, ee = P._length, te = I._length, K = P._offset, $ = I._offset, (Y = {})[P._id] = P, (J = {})[I._id] = I, g && y) for (var r = t.overlays, n = 0; n < r.length; n++) {
              var a = r[n].xaxis;
              Y[a._id] = a;
              var i = r[n].yaxis;
              J[i._id] = i;
            }
            X = W(Y), Q = W(J), ae = R(X, y), ie = R(Q, g), oe = !ie && !ae, ne = G(e, e._fullLayout._axisMatchGroups, Y, J);
            var o = (re = G(e, e._fullLayout._axisConstraintGroups, Y, J, ne)).isSubplotConstrained || ne.isSubplotConstrained;
            le = y || o, se = g || o;
            var l = e._fullLayout;
            ce = l._has("scattergl"), ue = l._has("splom"), de = l._has("svg");
          }
          ve();
          var xe = function (e, t, r) {
              if (!e) return "pointer";
              if ("nsew" === e) return r ? "" : "pan" === t ? "move" : "crosshair";
              return e.toLowerCase() + "-resize";
            }(ie + ae, e._fullLayout.dragmode, me),
            be = z(t, g + y + "drag", xe, r, l, c, d);
          if (oe && !me) return be.onmousedown = null, be.style.pointerEvents = "none", be;
          var _e,
            we,
            Me,
            Te,
            ke,
            Ae,
            Le,
            De,
            Se,
            Ce,
            Oe = {
              element: be,
              gd: e,
              plotinfo: t
            };
          function Pe() {
            Oe.plotinfo.selection = !1, A(e);
          }
          function Ie(e, r) {
            var a = Oe.gd;
            if (a._fullLayout._activeShapeIndex >= 0) a._fullLayout._deactivateShape(a);else {
              var o = a._fullLayout.clickmode;
              if (U(a), 2 !== e || ye || Ve(), me) o.indexOf("select") > -1 && L(r, a, X, Q, t.id, Oe), o.indexOf("event") > -1 && h.click(a, r, t.id);else if (1 === e && ye) {
                var l = g ? I : P,
                  c = "s" === g || "w" === y ? 0 : 1,
                  d = l._name + ".range[" + c + "]",
                  f = function (e, t) {
                    var r,
                      n = e.range[t],
                      a = Math.abs(n - e.range[1 - t]);
                    return "date" === e.type ? n : "log" === e.type ? (r = Math.ceil(Math.max(0, -Math.log(a) / Math.LN10)) + 3, i("." + r + "g")(Math.pow(10, n))) : (r = Math.floor(Math.log(Math.abs(n)) / Math.LN10) - Math.floor(Math.log(a) / Math.LN10) + 4, i("." + String(r) + "g")(n));
                  }(l, c),
                  p = "left",
                  m = "middle";
                if (l.fixedrange) return;
                g ? (m = "n" === g ? "top" : "bottom", "right" === l.side && (p = "right")) : "e" === y && (p = "right"), a._context.showAxisRangeEntryBoxes && n.select(be).call(u.makeEditable, {
                  gd: a,
                  immediate: !0,
                  background: a._fullLayout.paper_bgcolor,
                  text: String(f),
                  fill: l.tickfont ? l.tickfont.color : "#444",
                  horizontalAlign: p,
                  verticalAlign: m
                }).on("edit", function (e) {
                  var t = l.d2r(e);
                  void 0 !== t && s.call("_guiRelayout", a, d, t);
                });
              }
            }
          }
          function ze(t, r) {
            if (e._transitioningWithDuration) return !1;
            var n = Math.max(0, Math.min(ee, he * t + _e)),
              a = Math.max(0, Math.min(te, pe * r + we)),
              i = Math.abs(n - _e),
              o = Math.abs(a - we);
            function l() {
              Le = "", Me.r = Me.l, Me.t = Me.b, Se.attr("d", "M0,0Z");
            }
            if (Me.l = Math.min(_e, n), Me.r = Math.max(_e, n), Me.t = Math.min(we, a), Me.b = Math.max(we, a), re.isSubplotConstrained) i > O || o > O ? (Le = "xy", i / ee > o / te ? (o = i * te / ee, we > a ? Me.t = we - o : Me.b = we + o) : (i = o * ee / te, _e > n ? Me.l = _e - i : Me.r = _e + i), Se.attr("d", q(Me))) : l();else if (ne.isSubplotConstrained) {
              if (i > O || o > O) {
                Le = "xy";
                var s = Math.min(Me.l / ee, (te - Me.b) / te),
                  c = Math.max(Me.r / ee, (te - Me.t) / te);
                Me.l = s * ee, Me.r = c * ee, Me.b = (1 - s) * te, Me.t = (1 - c) * te, Se.attr("d", q(Me));
              } else l();
            } else !ie || o < Math.min(Math.max(.6 * i, C), O) ? i < C || !ae ? l() : (Me.t = 0, Me.b = te, Le = "x", Se.attr("d", function (e, t) {
              return "M" + (e.l - .5) + "," + (t - O - .5) + "h-3v" + (2 * O + 1) + "h3ZM" + (e.r + .5) + "," + (t - O - .5) + "h3v" + (2 * O + 1) + "h-3Z";
            }(Me, we))) : !ae || i < Math.min(.6 * o, O) ? (Me.l = 0, Me.r = ee, Le = "y", Se.attr("d", function (e, t) {
              return "M" + (t - O - .5) + "," + (e.t - .5) + "v-3h" + (2 * O + 1) + "v3ZM" + (t - O - .5) + "," + (e.b + .5) + "v3h" + (2 * O + 1) + "v-3Z";
            }(Me, _e))) : (Le = "xy", Se.attr("d", q(Me)));
            Me.w = Me.r - Me.l, Me.h = Me.b - Me.t, Le && (Ce = !0), e._dragged = Ce, B(De, Se, Me, ke, Ae, Te), Re(), e.emit("plotly_relayouting", fe), Ae = !0;
          }
          function Re() {
            fe = {}, "xy" !== Le && "x" !== Le || (N(X, Me.l / ee, Me.r / ee, fe, re.xaxes), Ye("x", fe)), "xy" !== Le && "y" !== Le || (N(Q, (te - Me.b) / te, (te - Me.t) / te, fe, re.yaxes), Ye("y", fe));
          }
          function Ne() {
            Re(), U(e), qe(), V(e);
          }
          Oe.prepFn = function (t, r, n) {
            var i = Oe.dragmode,
              l = e._fullLayout.dragmode;
            l !== i && (Oe.dragmode = l), ve(), he = e._fullLayout._invScaleX, pe = e._fullLayout._invScaleY, oe || (me ? t.shiftKey ? "pan" === l ? l = "zoom" : v(l) || (l = "pan") : t.ctrlKey && (l = "pan") : l = "pan"), x(l) ? Oe.minDrag = 1 : Oe.minDrag = void 0, v(l) ? (Oe.xaxes = X, Oe.yaxes = Q, k(t, r, n, Oe, l)) : (Oe.clickFn = Ie, v(i) && Pe(), oe || ("zoom" === l ? (Oe.moveFn = ze, Oe.doneFn = Ne, Oe.minDrag = 1, function (t, r, n) {
              var i = be.getBoundingClientRect();
              _e = r - i.left, we = n - i.top, e._fullLayout._calcInverseTransform(e);
              var l = a.apply3DTransform(e._fullLayout._invTransform)(_e, we);
              _e = l[0], we = l[1], Me = {
                l: _e,
                r: _e,
                w: 0,
                t: we,
                b: we,
                h: 0
              }, Te = e._hmpixcount ? e._hmlumcount / e._hmpixcount : o(e._fullLayout.plot_bgcolor).getLuminance(), Ae = !1, Le = "xy", Ce = !1, De = j(ge, Te, K, $, ke = "M0,0H" + ee + "V" + te + "H0V0"), Se = H(ge, K, $);
            }(0, r, n)) : "pan" === l && (Oe.moveFn = Be, Oe.doneFn = qe))), e._fullLayout._redrag = function () {
              var t = e._dragdata;
              if (t && t.element === be) {
                var r = e._fullLayout.dragmode;
                v(r) || (ve(), Ge([0, 0, ee, te]), Oe.moveFn(t.dx, t.dy));
              }
            };
          }, m.init(Oe);
          var Fe = [0, 0, ee, te],
            Ee = null,
            je = S.REDRAWDELAY,
            He = t.mainplot ? e._fullLayout._plots[t.mainplot] : t;
          function Be(t, r) {
            if (t *= he, r *= pe, !e._transitioningWithDuration) {
              if (e._fullLayout._replotting = !0, "ew" === ae || "ns" === ie) {
                var n = ae ? -t : 0,
                  a = ie ? -r : 0;
                if (ne.isSubplotConstrained) {
                  if (ae && ie) {
                    var i = (t / ee - r / te) / 2;
                    n = -(t = i * ee), a = -(r = -i * te);
                  }
                  ie ? n = -a * ee / te : a = -n * te / ee;
                }
                return ae && (F(X, t), Ye("x")), ie && (F(Q, r), Ye("y")), Ge([n, a, ee, te]), Ue(), void e.emit("plotly_relayouting", fe);
              }
              var o,
                l,
                s = "w" === ae == ("n" === ie) ? 1 : -1;
              if (ae && ie && (re.isSubplotConstrained || ne.isSubplotConstrained)) {
                var c = (t / ee + s * r / te) / 2;
                t = c * ee, r = s * c * te;
              }
              if ("w" === ae ? t = h(X, 0, t) : "e" === ae ? t = h(X, 1, -t) : ae || (t = 0), "n" === ie ? r = h(Q, 1, r) : "s" === ie ? r = h(Q, 0, -r) : ie || (r = 0), o = "w" === ae ? t : 0, l = "n" === ie ? r : 0, re.isSubplotConstrained && !ne.isSubplotConstrained || ne.isSubplotConstrained && ae && ie && s > 0) {
                var u;
                if (ne.isSubplotConstrained || !ae && 1 === ie.length) {
                  for (u = 0; u < X.length; u++) X[u].range = X[u]._r.slice(), D(X[u], 1 - r / te);
                  o = (t = r * ee / te) / 2;
                }
                if (ne.isSubplotConstrained || !ie && 1 === ae.length) {
                  for (u = 0; u < Q.length; u++) Q[u].range = Q[u]._r.slice(), D(Q[u], 1 - t / ee);
                  l = (r = t * te / ee) / 2;
                }
              }
              ne.isSubplotConstrained && ie || Ye("x"), ne.isSubplotConstrained && ae || Ye("y");
              var d = ee - t,
                f = te - r;
              !ne.isSubplotConstrained || ae && ie || (ae ? (l = o ? 0 : t * te / ee, f = d * te / ee) : (o = l ? 0 : r * ee / te, d = f * ee / te)), Ge([o, l, d, f]), Ue(), e.emit("plotly_relayouting", fe);
            }
            function h(e, t, r) {
              for (var n, a, i = 1 - t, o = 0; o < e.length; o++) {
                var l = e[o];
                if (!l.fixedrange) {
                  n = l, a = l._rl[i] + (l._rl[t] - l._rl[i]) / E(r / l._length);
                  var s = l.l2r(a);
                  !1 !== s && void 0 !== s && (l.range[t] = s);
                }
              }
              return n._length * (n._rl[t] - a) / (n._rl[t] - n._rl[i]);
            }
          }
          function Ye(e, t) {
            for (var r = ne.isSubplotConstrained ? {
                x: Q,
                y: X
              }[e] : ne[e + "axes"], n = ne.isSubplotConstrained ? {
                x: X,
                y: Q
              }[e] : [], a = 0; a < r.length; a++) {
              var i = r[a],
                o = i._id,
                l = ne.xLinks[o] || ne.yLinks[o],
                s = n[0] || Y[l] || J[l];
              s && (t ? (t[i._name + ".range[0]"] = t[s._name + ".range[0]"], t[i._name + ".range[1]"] = t[s._name + ".range[1]"]) : i.range = s.range.slice());
            }
          }
          function Ue() {
            var t,
              r = [];
            function n(e) {
              for (t = 0; t < e.length; t++) e[t].fixedrange || r.push(e[t]._id);
            }
            for (le && (n(X), n(re.xaxes), n(ne.xaxes)), se && (n(Q), n(re.yaxes), n(ne.yaxes)), fe = {}, t = 0; t < r.length; t++) {
              var a = r[t],
                i = T(e, a);
              p.drawOne(e, i, {
                skipTitle: !0
              }), fe[i._name + ".range[0]"] = i.range[0], fe[i._name + ".range[1]"] = i.range[1];
            }
            p.redrawComponents(e, r);
          }
          function Ve() {
            if (!e._transitioningWithDuration) {
              var t = e._context.doubleClick,
                r = [];
              ae && (r = r.concat(X)), ie && (r = r.concat(Q)), ne.xaxes && (r = r.concat(ne.xaxes)), ne.yaxes && (r = r.concat(ne.yaxes));
              var n,
                a,
                i,
                o = {};
              if ("reset+autosize" === t) for (t = "autosize", a = 0; a < r.length; a++) if ((n = r[a])._rangeInitial && (n.range[0] !== n._rangeInitial[0] || n.range[1] !== n._rangeInitial[1]) || !n._rangeInitial && !n.autorange) {
                t = "reset";
                break;
              }
              if ("autosize" === t) for (a = 0; a < r.length; a++) (n = r[a]).fixedrange || (o[n._name + ".autorange"] = !0);else if ("reset" === t) for ((ae || re.isSubplotConstrained) && (r = r.concat(re.xaxes)), ie && !re.isSubplotConstrained && (r = r.concat(re.yaxes)), re.isSubplotConstrained && (ae ? ie || (r = r.concat(Q)) : r = r.concat(X)), a = 0; a < r.length; a++) (n = r[a]).fixedrange || (n._rangeInitial ? (i = n._rangeInitial, o[n._name + ".range[0]"] = i[0], o[n._name + ".range[1]"] = i[1]) : o[n._name + ".autorange"] = !0);
              e.emit("plotly_doubleclick", null), s.call("_guiRelayout", e, o);
            }
          }
          function qe() {
            Ge([0, 0, ee, te]), a.syncOrAsync([M.previousPromises, function () {
              e._fullLayout._replotting = !1, s.call("_guiRelayout", e, fe);
            }], e);
          }
          function Ge(t) {
            var r,
              n,
              i,
              o,
              l = e._fullLayout,
              c = l._plots,
              u = l._subplots.cartesian;
            if (ue && s.subplotsRegistry.splom.drag(e), ce) for (r = 0; r < u.length; r++) if (i = (n = c[u[r]]).xaxis, o = n.yaxis, n._scene) {
              var d = a.simpleMap(i.range, i.r2l),
                h = a.simpleMap(o.range, o.r2l);
              n._scene.update({
                range: [d[0], h[0], d[1], h[1]]
              });
            }
            if ((ue || ce) && (_(e), w(e)), de) {
              var p = t[2] / P._length,
                m = t[3] / I._length;
              for (r = 0; r < u.length; r++) {
                i = (n = c[u[r]]).xaxis, o = n.yaxis;
                var v,
                  x,
                  b,
                  M,
                  T = (le || ne.isSubplotConstrained) && !i.fixedrange && Y[i._id],
                  k = (se || ne.isSubplotConstrained) && !o.fixedrange && J[o._id];
                if (T ? (v = p, b = y || ne.isSubplotConstrained ? t[0] : Je(i, v)) : ne.xaHash[i._id] ? (v = p, b = t[0] * i._length / P._length) : ne.yaHash[i._id] ? (v = m, b = "ns" === ie ? -t[1] * i._length / I._length : Je(i, v, {
                  n: "top",
                  s: "bottom"
                }[ie])) : b = We(i, v = Ze(i, p, m)), k ? (x = m, M = g || ne.isSubplotConstrained ? t[1] : Je(o, x)) : ne.yaHash[o._id] ? (x = m, M = t[1] * o._length / I._length) : ne.xaHash[o._id] ? (x = p, M = "ew" === ae ? -t[0] * o._length / P._length : Je(o, x, {
                  e: "right",
                  w: "left"
                }[ae])) : M = We(o, x = Ze(o, p, m)), v || x) {
                  v || (v = 1), x || (x = 1);
                  var A = i._offset - b / v,
                    L = o._offset - M / x;
                  n.clipRect.call(f.setTranslate, b, M).call(f.setScale, v, x), n.plot.call(f.setTranslate, A, L).call(f.setScale, 1 / v, 1 / x), v === n.xScaleFactor && x === n.yScaleFactor || (f.setPointGroupScale(n.zoomScalePts, v, x), f.setTextPointsScale(n.zoomScaleTxt, v, x)), f.hideOutsideRangePoints(n.clipOnAxisFalseTraces, n), n.xScaleFactor = v, n.yScaleFactor = x;
                }
              }
            }
          }
          function Ze(e, t, r) {
            return e.fixedrange ? 0 : le && re.xaHash[e._id] ? t : se && (re.isSubplotConstrained ? re.xaHash : re.yaHash)[e._id] ? r : 0;
          }
          function We(e, t) {
            return t ? (e.range = e._r.slice(), D(e, t), Je(e, t)) : 0;
          }
          function Je(e, t, r) {
            return e._length * (1 - t) * b[r || e.constraintoward || "middle"];
          }
          return g.length * y.length != 1 && Z(be, function (t) {
            if (e._context._scrollZoom.cartesian || e._fullLayout._enablescrollzoom) {
              if (Pe(), e._transitioningWithDuration) return t.preventDefault(), void t.stopPropagation();
              ve(), clearTimeout(Ee);
              var r = -t.deltaY;
              if (isFinite(r) || (r = t.wheelDelta / 10), isFinite(r)) {
                var n,
                  i = Math.exp(-Math.min(Math.max(r, -20), 20) / 200),
                  o = He.draglayer.select(".nsewdrag").node().getBoundingClientRect(),
                  l = (t.clientX - o.left) / o.width,
                  s = (o.bottom - t.clientY) / o.height;
                if (le) {
                  for (y || (l = .5), n = 0; n < X.length; n++) c(X[n], l, i);
                  Ye("x"), Fe[2] *= i, Fe[0] += Fe[2] * l * (1 / i - 1);
                }
                if (se) {
                  for (g || (s = .5), n = 0; n < Q.length; n++) c(Q[n], s, i);
                  Ye("y"), Fe[3] *= i, Fe[1] += Fe[3] * (1 - s) * (1 / i - 1);
                }
                Ge(Fe), Ue(), e.emit("plotly_relayouting", fe), Ee = setTimeout(function () {
                  e._fullLayout && (Fe = [0, 0, ee, te], qe());
                }, je), t.preventDefault();
              } else a.log("Did not find wheel motion attributes: ", t);
            }
            function c(e, t, r) {
              if (!e.fixedrange) {
                var n = a.simpleMap(e.range, e.r2l),
                  i = n[0] + (n[1] - n[0]) * t;
                e.range = n.map(function (t) {
                  return e.l2r(i + (t - i) * r);
                });
              }
            }
          }), be;
        },
        makeDragger: I,
        makeRectDragger: z,
        makeZoombox: j,
        makeCorners: H,
        updateZoombox: B,
        xyCorners: q,
        transitionZoombox: Y,
        removeZoombox: U,
        showDoubleClickNotifier: V,
        attachWheelEventHandler: Z
      };
    }, {
      "../../components/color": 96,
      "../../components/dragelement": 115,
      "../../components/dragelement/helpers": 114,
      "../../components/drawing": 118,
      "../../components/fx": 136,
      "../../constants/alignment": 201,
      "../../lib": 225,
      "../../lib/clear_gl_canvases": 213,
      "../../lib/setcursor": 245,
      "../../lib/svg_text_utils": 248,
      "../../plot_api/subroutines": 262,
      "../../registry": 309,
      "../plots": 307,
      "./axes": 272,
      "./axis_ids": 276,
      "./constants": 279,
      "./scale_zoom": 291,
      "./select": 292,
      "@plotly/d3": 6,
      "has-passive-events": 43,
      tinycolor2: 61
    }],
    282: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../components/fx"),
        i = e("../../components/dragelement"),
        o = e("../../lib/setcursor"),
        l = e("./dragbox").makeDragBox,
        s = e("./constants").DRAGGERSIZE;
      r.initInteractions = function (e) {
        var t = e._fullLayout;
        if (e._context.staticPlot) n.select(e).selectAll(".drag").remove();else if (t._has("cartesian") || t._has("splom")) {
          Object.keys(t._plots || {}).sort(function (e, r) {
            if ((t._plots[e].mainplot && !0) === (t._plots[r].mainplot && !0)) {
              var n = e.split("y"),
                a = r.split("y");
              return n[0] === a[0] ? Number(n[1] || 1) - Number(a[1] || 1) : Number(n[0] || 1) - Number(a[0] || 1);
            }
            return t._plots[e].mainplot ? 1 : -1;
          }).forEach(function (r) {
            var n = t._plots[r],
              o = n.xaxis,
              c = n.yaxis;
            if (!n.mainplot) {
              var u = l(e, n, o._offset, c._offset, o._length, c._length, "ns", "ew");
              u.onmousemove = function (t) {
                e._fullLayout._rehover = function () {
                  e._fullLayout._hoversubplot === r && e._fullLayout._plots[r] && a.hover(e, t, r);
                }, a.hover(e, t, r), e._fullLayout._lasthover = u, e._fullLayout._hoversubplot = r;
              }, u.onmouseout = function (t) {
                e._dragging || (e._fullLayout._hoversubplot = null, i.unhover(e, t));
              }, e._context.showAxisDragHandles && (l(e, n, o._offset - s, c._offset - s, s, s, "n", "w"), l(e, n, o._offset + o._length, c._offset - s, s, s, "n", "e"), l(e, n, o._offset - s, c._offset + c._length, s, s, "s", "w"), l(e, n, o._offset + o._length, c._offset + c._length, s, s, "s", "e"));
            }
            if (e._context.showAxisDragHandles) {
              if (r === o._mainSubplot) {
                var d = o._mainLinePosition;
                "top" === o.side && (d -= s), l(e, n, o._offset + .1 * o._length, d, .8 * o._length, s, "", "ew"), l(e, n, o._offset, d, .1 * o._length, s, "", "w"), l(e, n, o._offset + .9 * o._length, d, .1 * o._length, s, "", "e");
              }
              if (r === c._mainSubplot) {
                var f = c._mainLinePosition;
                "right" !== c.side && (f -= s), l(e, n, f, c._offset + .1 * c._length, s, .8 * c._length, "ns", ""), l(e, n, f, c._offset + .9 * c._length, s, .1 * c._length, "s", ""), l(e, n, f, c._offset, s, .1 * c._length, "n", "");
              }
            }
          });
          var o = t._hoverlayer.node();
          o.onmousemove = function (r) {
            r.target = e._fullLayout._lasthover, a.hover(e, r, t._hoversubplot);
          }, o.onclick = function (t) {
            t.target = e._fullLayout._lasthover, a.click(e, t);
          }, o.onmousedown = function (t) {
            e._fullLayout._lasthover.onmousedown(t);
          }, r.updateFx(e);
        }
      }, r.updateFx = function (e) {
        var t = e._fullLayout,
          r = "pan" === t.dragmode ? "move" : "crosshair";
        o(t._draggers, r);
      };
    }, {
      "../../components/dragelement": 115,
      "../../components/fx": 136,
      "../../lib/setcursor": 245,
      "./constants": 279,
      "./dragbox": 281,
      "@plotly/d3": 6
    }],
    283: [function (e, t, r) {
      "use strict";

      t.exports = {
        clearOutlineControllers: function clearOutlineControllers(e) {
          var t = e._fullLayout._zoomlayer;
          t && t.selectAll(".outline-controllers").remove();
        },
        clearSelect: function clearSelect(e) {
          var t = e._fullLayout._zoomlayer;
          t && t.selectAll(".select-outline").remove(), e._fullLayout._drawing = !1;
        }
      };
    }, {}],
    284: [function (e, t, r) {
      "use strict";

      var n = e("../../lib").strTranslate;
      function a(e, t) {
        switch (e.type) {
          case "log":
            return e.p2d(t);
          case "date":
            return e.p2r(t, 0, e.calendar);
          default:
            return e.p2r(t);
        }
      }
      t.exports = {
        p2r: a,
        r2p: function r2p(e, t) {
          switch (e.type) {
            case "log":
              return e.d2p(t);
            case "date":
              return e.r2p(t, 0, e.calendar);
            default:
              return e.r2p(t);
          }
        },
        axValue: function axValue(e) {
          var t = "y" === e._id.charAt(0) ? 1 : 0;
          return function (r) {
            return a(e, r[t]);
          };
        },
        getTransform: function getTransform(e) {
          return n(e.xaxis._offset, e.yaxis._offset);
        }
      };
    }, {
      "../../lib": 225
    }],
    285: [function (e, t, r) {
      "use strict";

      var n = e("../../registry"),
        a = e("../../lib"),
        i = e("./axis_ids");
      t.exports = function (e) {
        return function (t, r) {
          var o = t[e];
          if (Array.isArray(o)) for (var l = n.subplotsRegistry.cartesian, s = l.idRegex, c = r._subplots, u = c.xaxis, d = c.yaxis, f = c.cartesian, h = r._has("cartesian") || r._has("gl2d"), p = 0; p < o.length; p++) {
            var g = o[p];
            if (a.isPlainObject(g)) {
              var m = i.cleanId(g.xref, "x", !1),
                y = i.cleanId(g.yref, "y", !1),
                v = s.x.test(m),
                x = s.y.test(y);
              if (v || x) {
                h || a.pushUnique(r._basePlotModules, l);
                var b = !1;
                v && -1 === u.indexOf(m) && (u.push(m), b = !0), x && -1 === d.indexOf(y) && (d.push(y), b = !0), b && v && x && f.push(m + y);
              }
            }
          }
        };
      };
    }, {
      "../../lib": 225,
      "../../registry": 309,
      "./axis_ids": 276
    }],
    286: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../registry"),
        i = e("../../lib"),
        o = e("../plots"),
        l = e("../../components/drawing"),
        s = e("../get_data").getModuleCalcData,
        c = e("./axis_ids"),
        u = e("./constants"),
        d = e("../../constants/xmlns_namespaces"),
        f = i.ensureSingle;
      function h(e, t, r) {
        return i.ensureSingle(e, t, r, function (e) {
          e.datum(r);
        });
      }
      function p(e, t, r, i, o) {
        for (var c, d, f, h = u.traceLayerClasses, p = e._fullLayout, g = p._modules, m = [], y = [], v = 0; v < g.length; v++) {
          var x = (c = g[v]).name,
            b = a.modules[x].categories;
          if (b.svg) {
            var _ = c.layerName || x + "layer",
              w = c.plot;
            f = (d = s(r, w))[0], r = d[1], f.length && m.push({
              i: h.indexOf(_),
              className: _,
              plotMethod: w,
              cdModule: f
            }), b.zoomScale && y.push("." + _);
          }
        }
        m.sort(function (e, t) {
          return e.i - t.i;
        });
        var M = t.plot.selectAll("g.mlayer").data(m, function (e) {
          return e.className;
        });
        if (M.enter().append("g").attr("class", function (e) {
          return e.className;
        }).classed("mlayer", !0).classed("rangeplot", t.isRangePlot), M.exit().remove(), M.order(), M.each(function (r) {
          var a = n.select(this),
            s = r.className;
          r.plotMethod(e, t, r.cdModule, a, i, o), -1 === u.clipOnAxisFalseQuery.indexOf("." + s) && l.setClipUrl(a, t.layerClipId, e);
        }), p._has("scattergl") && (c = a.getModule("scattergl"), f = s(r, c)[0], c.plot(e, t, f)), !e._context.staticPlot && (t._hasClipOnAxisFalse && (t.clipOnAxisFalseTraces = t.plot.selectAll(u.clipOnAxisFalseQuery.join(",")).selectAll(".trace")), y.length)) {
          var T = t.plot.selectAll(y.join(",")).selectAll(".trace");
          t.zoomScalePts = T.selectAll("path.point"), t.zoomScaleTxt = T.selectAll(".textpoint");
        }
      }
      function g(e, t) {
        var r = t.plotgroup,
          n = t.id,
          a = u.layerValue2layerClass[t.xaxis.layer],
          i = u.layerValue2layerClass[t.yaxis.layer],
          o = e._fullLayout._hasOnlyLargeSploms;
        if (t.mainplot) {
          var l = t.mainplotinfo,
            s = l.plotgroup,
            d = n + "-x",
            p = n + "-y";
          t.gridlayer = l.gridlayer, t.zerolinelayer = l.zerolinelayer, f(l.overlinesBelow, "path", d), f(l.overlinesBelow, "path", p), f(l.overaxesBelow, "g", d), f(l.overaxesBelow, "g", p), t.plot = f(l.overplot, "g", n), f(l.overlinesAbove, "path", d), f(l.overlinesAbove, "path", p), f(l.overaxesAbove, "g", d), f(l.overaxesAbove, "g", p), t.xlines = s.select(".overlines-" + a).select("." + d), t.ylines = s.select(".overlines-" + i).select("." + p), t.xaxislayer = s.select(".overaxes-" + a).select("." + d), t.yaxislayer = s.select(".overaxes-" + i).select("." + p);
        } else if (o) t.xlines = f(r, "path", "xlines-above"), t.ylines = f(r, "path", "ylines-above"), t.xaxislayer = f(r, "g", "xaxislayer-above"), t.yaxislayer = f(r, "g", "yaxislayer-above");else {
          var g = f(r, "g", "layer-subplot");
          t.shapelayer = f(g, "g", "shapelayer"), t.imagelayer = f(g, "g", "imagelayer"), t.gridlayer = f(r, "g", "gridlayer"), t.zerolinelayer = f(r, "g", "zerolinelayer"), f(r, "path", "xlines-below"), f(r, "path", "ylines-below"), t.overlinesBelow = f(r, "g", "overlines-below"), f(r, "g", "xaxislayer-below"), f(r, "g", "yaxislayer-below"), t.overaxesBelow = f(r, "g", "overaxes-below"), t.plot = f(r, "g", "plot"), t.overplot = f(r, "g", "overplot"), t.xlines = f(r, "path", "xlines-above"), t.ylines = f(r, "path", "ylines-above"), t.overlinesAbove = f(r, "g", "overlines-above"), f(r, "g", "xaxislayer-above"), f(r, "g", "yaxislayer-above"), t.overaxesAbove = f(r, "g", "overaxes-above"), t.xlines = r.select(".xlines-" + a), t.ylines = r.select(".ylines-" + i), t.xaxislayer = r.select(".xaxislayer-" + a), t.yaxislayer = r.select(".yaxislayer-" + i);
        }
        o || (h(t.gridlayer, "g", t.xaxis._id), h(t.gridlayer, "g", t.yaxis._id), t.gridlayer.selectAll("g").map(function (e) {
          return e[0];
        }).sort(c.idSort)), t.xlines.style("fill", "none").classed("crisp", !0), t.ylines.style("fill", "none").classed("crisp", !0);
      }
      function m(e, t) {
        if (e) {
          var r = {};
          for (var a in e.each(function (e) {
            var a = e[0];
            n.select(this).remove(), y(a, t), r[a] = !0;
          }), t._plots) for (var i = t._plots[a].overlays || [], o = 0; o < i.length; o++) {
            var l = i[o];
            r[l.id] && l.plot.selectAll(".trace").remove();
          }
        }
      }
      function y(e, t) {
        t._draggers.selectAll("g." + e).remove(), t._defs.select("#clip" + t._uid + e + "plot").remove();
      }
      r.name = "cartesian", r.attr = ["xaxis", "yaxis"], r.idRoot = ["x", "y"], r.idRegex = u.idRegex, r.attrRegex = u.attrRegex, r.attributes = e("./attributes"), r.layoutAttributes = e("./layout_attributes"), r.supplyLayoutDefaults = e("./layout_defaults"), r.transitionAxes = e("./transition_axes"), r.finalizeSubplots = function (e, t) {
        var r,
          n,
          a,
          o = t._subplots,
          l = o.xaxis,
          s = o.yaxis,
          d = o.cartesian,
          f = d.concat(o.gl2d || []),
          h = {},
          p = {};
        for (r = 0; r < f.length; r++) {
          var g = f[r].split("y");
          h[g[0]] = 1, p["y" + g[1]] = 1;
        }
        for (r = 0; r < l.length; r++) h[n = l[r]] || (a = (e[c.id2name(n)] || {}).anchor, u.idRegex.y.test(a) || (a = "y"), d.push(n + a), f.push(n + a), p[a] || (p[a] = 1, i.pushUnique(s, a)));
        for (r = 0; r < s.length; r++) p[a = s[r]] || (n = (e[c.id2name(a)] || {}).anchor, u.idRegex.x.test(n) || (n = "x"), d.push(n + a), f.push(n + a), h[n] || (h[n] = 1, i.pushUnique(l, n)));
        if (!f.length) {
          for (var m in n = "", a = "", e) {
            if (u.attrRegex.test(m)) "x" === m.charAt(0) ? (!n || +m.substr(5) < +n.substr(5)) && (n = m) : (!a || +m.substr(5) < +a.substr(5)) && (a = m);
          }
          n = n ? c.name2id(n) : "x", a = a ? c.name2id(a) : "y", l.push(n), s.push(a), d.push(n + a);
        }
      }, r.plot = function (e, t, r, n) {
        var a,
          i = e._fullLayout,
          o = i._subplots.cartesian,
          l = e.calcdata;
        if (!Array.isArray(t)) for (t = [], a = 0; a < l.length; a++) t.push(a);
        for (a = 0; a < o.length; a++) {
          for (var s, c = o[a], u = i._plots[c], d = [], f = 0; f < l.length; f++) {
            var h = l[f],
              g = h[0].trace;
            g.xaxis + g.yaxis === c && ((-1 !== t.indexOf(g.index) || g.carpet) && (s && s[0].trace.xaxis + s[0].trace.yaxis === c && -1 !== ["tonextx", "tonexty", "tonext"].indexOf(g.fill) && -1 === d.indexOf(s) && d.push(s), d.push(h)), s = h);
          }
          p(e, u, d, r, n);
        }
      }, r.clean = function (e, t, r, n) {
        var a,
          i,
          o,
          l = n._plots || {},
          s = t._plots || {},
          u = n._subplots || {};
        if (n._hasOnlyLargeSploms && !t._hasOnlyLargeSploms) for (o in l) (a = l[o]).plotgroup && a.plotgroup.remove();
        var d = n._has && n._has("gl"),
          f = t._has && t._has("gl");
        if (d && !f) for (o in l) (a = l[o])._scene && a._scene.destroy();
        if (u.xaxis && u.yaxis) {
          var h = c.listIds({
            _fullLayout: n
          });
          for (i = 0; i < h.length; i++) {
            var p = h[i];
            t[c.id2name(p)] || n._infolayer.selectAll(".g-" + p + "title").remove();
          }
        }
        var g = n._has && n._has("cartesian"),
          v = t._has && t._has("cartesian");
        if (g && !v) m(n._cartesianlayer.selectAll(".subplot"), n), n._defs.selectAll(".axesclip").remove(), delete n._axisConstraintGroups, delete n._axisMatchGroups;else if (u.cartesian) for (i = 0; i < u.cartesian.length; i++) {
          var x = u.cartesian[i];
          if (!s[x]) {
            var b = "." + x + ",." + x + "-x,." + x + "-y";
            n._cartesianlayer.selectAll(b).remove(), y(x, n);
          }
        }
      }, r.drawFramework = function (e) {
        var t = e._fullLayout,
          r = function (e) {
            var t,
              r,
              n,
              a,
              i,
              o,
              l = e._fullLayout,
              s = l._subplots.cartesian,
              c = s.length,
              u = [],
              d = [];
            for (t = 0; t < c; t++) {
              n = s[t], a = l._plots[n], i = a.xaxis, o = a.yaxis;
              var f = i._mainAxis,
                h = o._mainAxis,
                p = f._id + h._id,
                g = l._plots[p];
              a.overlays = [], p !== n && g ? (a.mainplot = p, a.mainplotinfo = g, d.push(n)) : (a.mainplot = void 0, a.mainplotinfo = void 0, u.push(n));
            }
            for (t = 0; t < d.length; t++) n = d[t], (a = l._plots[n]).mainplotinfo.overlays.push(a);
            var m = u.concat(d),
              y = new Array(c);
            for (t = 0; t < c; t++) {
              n = m[t], a = l._plots[n], i = a.xaxis, o = a.yaxis;
              var v = [n, i.layer, o.layer, i.overlaying || "", o.overlaying || ""];
              for (r = 0; r < a.overlays.length; r++) v.push(a.overlays[r].id);
              y[t] = v;
            }
            return y;
          }(e),
          a = t._cartesianlayer.selectAll(".subplot").data(r, String);
        a.enter().append("g").attr("class", function (e) {
          return "subplot " + e[0];
        }), a.order(), a.exit().call(m, t), a.each(function (r) {
          var a = r[0],
            i = t._plots[a];
          i.plotgroup = n.select(this), g(e, i), i.draglayer = f(t._draggers, "g", a);
        });
      }, r.rangePlot = function (e, t, r) {
        g(e, t), p(e, t, r), o.style(e);
      }, r.toSVG = function (e) {
        var t = e._fullLayout._glimages,
          r = n.select(e).selectAll(".svg-container");
        r.filter(function (e, t) {
          return t === r.size() - 1;
        }).selectAll(".gl-canvas-context, .gl-canvas-focus").each(function () {
          var e = this.toDataURL("image/png");
          t.append("svg:image").attr({
            xmlns: d.svg,
            "xlink:href": e,
            preserveAspectRatio: "none",
            x: 0,
            y: 0,
            width: this.style.width,
            height: this.style.height
          });
        });
      }, r.updateFx = e("./graph_interact").updateFx;
    }, {
      "../../components/drawing": 118,
      "../../constants/xmlns_namespaces": 206,
      "../../lib": 225,
      "../../registry": 309,
      "../get_data": 303,
      "../plots": 307,
      "./attributes": 270,
      "./axis_ids": 276,
      "./constants": 279,
      "./graph_interact": 282,
      "./layout_attributes": 287,
      "./layout_defaults": 288,
      "./transition_axes": 297,
      "@plotly/d3": 6
    }],
    287: [function (e, t, r) {
      "use strict";

      var n = e("../font_attributes"),
        a = e("../../components/color/attributes"),
        i = e("../../components/drawing/attributes").dash,
        o = e("../../lib/extend").extendFlat,
        l = e("../../plot_api/plot_template").templatedArray,
        s = e("../../plots/cartesian/axis_format_attributes").descriptionWithDates,
        c = e("../../constants/numerical").ONEDAY,
        u = e("./constants"),
        d = u.HOUR_PATTERN,
        f = u.WEEKDAY_PATTERN;
      t.exports = {
        visible: {
          valType: "boolean",
          editType: "plot"
        },
        color: {
          valType: "color",
          dflt: a.defaultLine,
          editType: "ticks"
        },
        title: {
          text: {
            valType: "string",
            editType: "ticks"
          },
          font: n({
            editType: "ticks"
          }),
          standoff: {
            valType: "number",
            min: 0,
            editType: "ticks"
          },
          editType: "ticks"
        },
        type: {
          valType: "enumerated",
          values: ["-", "linear", "log", "date", "category", "multicategory"],
          dflt: "-",
          editType: "calc",
          _noTemplating: !0
        },
        autotypenumbers: {
          valType: "enumerated",
          values: ["convert types", "strict"],
          dflt: "convert types",
          editType: "calc"
        },
        autorange: {
          valType: "enumerated",
          values: [!0, !1, "reversed"],
          dflt: !0,
          editType: "axrange",
          impliedEdits: {
            "range[0]": void 0,
            "range[1]": void 0
          }
        },
        rangemode: {
          valType: "enumerated",
          values: ["normal", "tozero", "nonnegative"],
          dflt: "normal",
          editType: "plot"
        },
        range: {
          valType: "info_array",
          items: [{
            valType: "any",
            editType: "axrange",
            impliedEdits: {
              "^autorange": !1
            },
            anim: !0
          }, {
            valType: "any",
            editType: "axrange",
            impliedEdits: {
              "^autorange": !1
            },
            anim: !0
          }],
          editType: "axrange",
          impliedEdits: {
            autorange: !1
          },
          anim: !0
        },
        fixedrange: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        scaleanchor: {
          valType: "enumerated",
          values: [u.idRegex.x.toString(), u.idRegex.y.toString()],
          editType: "plot"
        },
        scaleratio: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "plot"
        },
        constrain: {
          valType: "enumerated",
          values: ["range", "domain"],
          editType: "plot"
        },
        constraintoward: {
          valType: "enumerated",
          values: ["left", "center", "right", "top", "middle", "bottom"],
          editType: "plot"
        },
        matches: {
          valType: "enumerated",
          values: [u.idRegex.x.toString(), u.idRegex.y.toString()],
          editType: "calc"
        },
        rangebreaks: l("rangebreak", {
          enabled: {
            valType: "boolean",
            dflt: !0,
            editType: "calc"
          },
          bounds: {
            valType: "info_array",
            items: [{
              valType: "any",
              editType: "calc"
            }, {
              valType: "any",
              editType: "calc"
            }],
            editType: "calc"
          },
          pattern: {
            valType: "enumerated",
            values: [f, d, ""],
            editType: "calc"
          },
          values: {
            valType: "info_array",
            freeLength: !0,
            editType: "calc",
            items: {
              valType: "any",
              editType: "calc"
            }
          },
          dvalue: {
            valType: "number",
            editType: "calc",
            min: 0,
            dflt: c
          },
          editType: "calc"
        }),
        tickmode: {
          valType: "enumerated",
          values: ["auto", "linear", "array"],
          editType: "ticks",
          impliedEdits: {
            tick0: void 0,
            dtick: void 0
          }
        },
        nticks: {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: "ticks"
        },
        tick0: {
          valType: "any",
          editType: "ticks",
          impliedEdits: {
            tickmode: "linear"
          }
        },
        dtick: {
          valType: "any",
          editType: "ticks",
          impliedEdits: {
            tickmode: "linear"
          }
        },
        tickvals: {
          valType: "data_array",
          editType: "ticks"
        },
        ticktext: {
          valType: "data_array",
          editType: "ticks"
        },
        ticks: {
          valType: "enumerated",
          values: ["outside", "inside", ""],
          editType: "ticks"
        },
        tickson: {
          valType: "enumerated",
          values: ["labels", "boundaries"],
          dflt: "labels",
          editType: "ticks"
        },
        ticklabelmode: {
          valType: "enumerated",
          values: ["instant", "period"],
          dflt: "instant",
          editType: "ticks"
        },
        ticklabelposition: {
          valType: "enumerated",
          values: ["outside", "inside", "outside top", "inside top", "outside left", "inside left", "outside right", "inside right", "outside bottom", "inside bottom"],
          dflt: "outside",
          editType: "calc"
        },
        ticklabeloverflow: {
          valType: "enumerated",
          values: ["allow", "hide past div", "hide past domain"],
          editType: "calc"
        },
        mirror: {
          valType: "enumerated",
          values: [!0, "ticks", !1, "all", "allticks"],
          dflt: !1,
          editType: "ticks+layoutstyle"
        },
        ticklen: {
          valType: "number",
          min: 0,
          dflt: 5,
          editType: "ticks"
        },
        tickwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "ticks"
        },
        tickcolor: {
          valType: "color",
          dflt: a.defaultLine,
          editType: "ticks"
        },
        showticklabels: {
          valType: "boolean",
          dflt: !0,
          editType: "ticks"
        },
        automargin: {
          valType: "boolean",
          dflt: !1,
          editType: "ticks"
        },
        showspikes: {
          valType: "boolean",
          dflt: !1,
          editType: "modebar"
        },
        spikecolor: {
          valType: "color",
          dflt: null,
          editType: "none"
        },
        spikethickness: {
          valType: "number",
          dflt: 3,
          editType: "none"
        },
        spikedash: o({}, i, {
          dflt: "dash",
          editType: "none"
        }),
        spikemode: {
          valType: "flaglist",
          flags: ["toaxis", "across", "marker"],
          dflt: "toaxis",
          editType: "none"
        },
        spikesnap: {
          valType: "enumerated",
          values: ["data", "cursor", "hovered data"],
          dflt: "hovered data",
          editType: "none"
        },
        tickfont: n({
          editType: "ticks"
        }),
        tickangle: {
          valType: "angle",
          dflt: "auto",
          editType: "ticks"
        },
        tickprefix: {
          valType: "string",
          dflt: "",
          editType: "ticks"
        },
        showtickprefix: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "ticks"
        },
        ticksuffix: {
          valType: "string",
          dflt: "",
          editType: "ticks"
        },
        showticksuffix: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "ticks"
        },
        showexponent: {
          valType: "enumerated",
          values: ["all", "first", "last", "none"],
          dflt: "all",
          editType: "ticks"
        },
        exponentformat: {
          valType: "enumerated",
          values: ["none", "e", "E", "power", "SI", "B"],
          dflt: "B",
          editType: "ticks"
        },
        minexponent: {
          valType: "number",
          dflt: 3,
          min: 0,
          editType: "ticks"
        },
        separatethousands: {
          valType: "boolean",
          dflt: !1,
          editType: "ticks"
        },
        tickformat: {
          valType: "string",
          dflt: "",
          editType: "ticks",
          description: s("tick label")
        },
        tickformatstops: l("tickformatstop", {
          enabled: {
            valType: "boolean",
            dflt: !0,
            editType: "ticks"
          },
          dtickrange: {
            valType: "info_array",
            items: [{
              valType: "any",
              editType: "ticks"
            }, {
              valType: "any",
              editType: "ticks"
            }],
            editType: "ticks"
          },
          value: {
            valType: "string",
            dflt: "",
            editType: "ticks"
          },
          editType: "ticks"
        }),
        hoverformat: {
          valType: "string",
          dflt: "",
          editType: "none",
          description: s("hover text")
        },
        showline: {
          valType: "boolean",
          dflt: !1,
          editType: "ticks+layoutstyle"
        },
        linecolor: {
          valType: "color",
          dflt: a.defaultLine,
          editType: "layoutstyle"
        },
        linewidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "ticks+layoutstyle"
        },
        showgrid: {
          valType: "boolean",
          editType: "ticks"
        },
        gridcolor: {
          valType: "color",
          dflt: a.lightLine,
          editType: "ticks"
        },
        gridwidth: {
          valType: "number",
          min: 0,
          dflt: 1,
          editType: "ticks"
        },
        zeroline: {
          valType: "boolean",
          editType: "ticks"
        },
        zerolinecolor: {
          valType: "color",
          dflt: a.defaultLine,
          editType: "ticks"
        },
        zerolinewidth: {
          valType: "number",
          dflt: 1,
          editType: "ticks"
        },
        showdividers: {
          valType: "boolean",
          dflt: !0,
          editType: "ticks"
        },
        dividercolor: {
          valType: "color",
          dflt: a.defaultLine,
          editType: "ticks"
        },
        dividerwidth: {
          valType: "number",
          dflt: 1,
          editType: "ticks"
        },
        anchor: {
          valType: "enumerated",
          values: ["free", u.idRegex.x.toString(), u.idRegex.y.toString()],
          editType: "plot"
        },
        side: {
          valType: "enumerated",
          values: ["top", "bottom", "left", "right"],
          editType: "plot"
        },
        overlaying: {
          valType: "enumerated",
          values: ["free", u.idRegex.x.toString(), u.idRegex.y.toString()],
          editType: "plot"
        },
        layer: {
          valType: "enumerated",
          values: ["above traces", "below traces"],
          dflt: "above traces",
          editType: "plot"
        },
        domain: {
          valType: "info_array",
          items: [{
            valType: "number",
            min: 0,
            max: 1,
            editType: "plot"
          }, {
            valType: "number",
            min: 0,
            max: 1,
            editType: "plot"
          }],
          dflt: [0, 1],
          editType: "plot"
        },
        position: {
          valType: "number",
          min: 0,
          max: 1,
          dflt: 0,
          editType: "plot"
        },
        categoryorder: {
          valType: "enumerated",
          values: ["trace", "category ascending", "category descending", "array", "total ascending", "total descending", "min ascending", "min descending", "max ascending", "max descending", "sum ascending", "sum descending", "mean ascending", "mean descending", "median ascending", "median descending"],
          dflt: "trace",
          editType: "calc"
        },
        categoryarray: {
          valType: "data_array",
          editType: "calc"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        editType: "calc",
        _deprecated: {
          autotick: {
            valType: "boolean",
            editType: "ticks"
          },
          title: {
            valType: "string",
            editType: "ticks"
          },
          titlefont: n({
            editType: "ticks"
          })
        }
      };
    }, {
      "../../components/color/attributes": 95,
      "../../components/drawing/attributes": 117,
      "../../constants/numerical": 205,
      "../../lib/extend": 219,
      "../../plot_api/plot_template": 261,
      "../../plots/cartesian/axis_format_attributes": 275,
      "../font_attributes": 301,
      "./constants": 279
    }],
    288: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../components/color"),
        i = e("../../components/fx/helpers").isUnifiedHover,
        o = e("../../components/fx/hovermode_defaults"),
        l = e("../../plot_api/plot_template"),
        s = e("../layout_attributes"),
        c = e("./layout_attributes"),
        u = e("./type_defaults"),
        d = e("./axis_defaults"),
        f = e("./constraints"),
        h = e("./position_defaults"),
        p = e("./axis_ids"),
        g = p.id2name,
        m = p.name2id,
        y = e("./constants").AX_ID_PATTERN,
        v = e("../../registry"),
        x = v.traceIs,
        b = v.getComponentMethod;
      function _(e, t, r) {
        Array.isArray(e[t]) ? e[t].push(r) : e[t] = [r];
      }
      t.exports = function (e, t, r) {
        var v,
          w,
          M = t.autotypenumbers,
          T = {},
          k = {},
          A = {},
          L = {},
          D = {},
          S = {},
          C = {},
          O = {},
          P = {},
          I = {};
        for (v = 0; v < r.length; v++) {
          var z = r[v];
          if (x(z, "cartesian") || x(z, "gl2d")) {
            var R, N;
            if (z.xaxis) R = g(z.xaxis), _(T, R, z);else if (z.xaxes) for (w = 0; w < z.xaxes.length; w++) _(T, g(z.xaxes[w]), z);
            if (z.yaxis) N = g(z.yaxis), _(T, N, z);else if (z.yaxes) for (w = 0; w < z.yaxes.length; w++) _(T, g(z.yaxes[w]), z);
            if ("funnel" === z.type ? "h" === z.orientation ? (R && (k[R] = !0), N && (C[N] = !0)) : N && (A[N] = !0) : "image" === z.type ? (N && (O[N] = !0), R && (O[R] = !0)) : (N && (D[N] = !0, S[N] = !0), x(z, "carpet") && ("carpet" !== z.type || z._cheater) || R && (L[R] = !0)), "carpet" === z.type && z._cheater && R && (k[R] = !0), x(z, "2dMap") && (P[R] = !0, P[N] = !0), x(z, "oriented")) I["h" === z.orientation ? N : R] = !0;
          }
        }
        var F = t._subplots,
          E = F.xaxis,
          j = F.yaxis,
          H = n.simpleMap(E, g),
          B = n.simpleMap(j, g),
          Y = H.concat(B),
          U = a.background;
        E.length && j.length && (U = n.coerce(e, t, s, "plot_bgcolor"));
        var V,
          q,
          G,
          Z,
          W,
          J = a.combine(U, t.paper_bgcolor);
        function X() {
          var e = T[V] || [];
          W._traceIndices = e.map(function (e) {
            return e._expandedIndex;
          }), W._annIndices = [], W._shapeIndices = [], W._imgIndices = [], W._subplotsWith = [], W._counterAxes = [], W._name = W._attr = V, W._id = q;
        }
        function Q(e, t) {
          return n.coerce(Z, W, c, e, t);
        }
        function K(e, t) {
          return n.coerce2(Z, W, c, e, t);
        }
        function $(e) {
          return "x" === e ? j : E;
        }
        function ee(t, r) {
          for (var n = "x" === t ? H : B, a = [], i = 0; i < n.length; i++) {
            var o = n[i];
            o === r || (e[o] || {}).overlaying || a.push(m(o));
          }
          return a;
        }
        var te = {
            x: $("x"),
            y: $("y")
          },
          re = te.x.concat(te.y),
          ne = {},
          ae = [];
        function ie() {
          var e = Z.matches;
          y.test(e) && -1 === re.indexOf(e) && (ne[e] = Z.type, ae = Object.keys(ne));
        }
        var oe = o(e, t),
          le = i(oe);
        for (v = 0; v < Y.length; v++) {
          V = Y[v], q = m(V), G = V.charAt(0), n.isPlainObject(e[V]) || (e[V] = {}), Z = e[V], W = l.newContainer(t, V, G + "axis"), X();
          var se = "x" === G && !L[V] && k[V] || "y" === G && !D[V] && A[V],
            ce = "y" === G && (!S[V] && C[V] || O[V]),
            ue = {
              letter: G,
              font: t.font,
              outerTicks: P[V],
              showGrid: !I[V],
              data: T[V] || [],
              bgColor: J,
              calendar: t.calendar,
              automargin: !0,
              visibleDflt: se,
              reverseDflt: ce,
              autotypenumbersDflt: M,
              splomStash: ((t._splomAxes || {})[G] || {})[q]
            };
          Q("uirevision", t.uirevision), u(Z, W, Q, ue), d(Z, W, Q, ue, t);
          var de = le && G === oe.charAt(0),
            fe = K("spikecolor", le ? W.color : void 0),
            he = K("spikethickness", le ? 1.5 : void 0),
            pe = K("spikedash", le ? "dot" : void 0),
            ge = K("spikemode", le ? "across" : void 0),
            me = K("spikesnap");
          Q("showspikes", !!(de || fe || he || pe || ge || me)) || (delete W.spikecolor, delete W.spikethickness, delete W.spikedash, delete W.spikemode, delete W.spikesnap), h(Z, W, Q, {
            letter: G,
            counterAxes: te[G],
            overlayableAxes: ee(G, V),
            grid: t.grid
          }), Q("title.standoff"), ie(), W._input = Z;
        }
        for (v = 0; v < ae.length;) {
          q = ae[v++], G = (V = g(q)).charAt(0), n.isPlainObject(e[V]) || (e[V] = {}), Z = e[V], W = l.newContainer(t, V, G + "axis"), X();
          var ye = {
            letter: G,
            font: t.font,
            outerTicks: P[V],
            showGrid: !I[V],
            data: [],
            bgColor: J,
            calendar: t.calendar,
            automargin: !0,
            visibleDflt: !1,
            reverseDflt: !1,
            autotypenumbersDflt: M,
            splomStash: ((t._splomAxes || {})[G] || {})[q]
          };
          Q("uirevision", t.uirevision), W.type = ne[q] || "linear", d(Z, W, Q, ye, t), h(Z, W, Q, {
            letter: G,
            counterAxes: te[G],
            overlayableAxes: ee(G, V),
            grid: t.grid
          }), Q("fixedrange"), ie(), W._input = Z;
        }
        var ve = b("rangeslider", "handleDefaults"),
          xe = b("rangeselector", "handleDefaults");
        for (v = 0; v < H.length; v++) V = H[v], Z = e[V], W = t[V], ve(e, t, V), "date" === W.type && xe(Z, W, t, B, W.calendar), Q("fixedrange");
        for (v = 0; v < B.length; v++) {
          V = B[v], Z = e[V], W = t[V];
          var be = t[g(W.anchor)];
          Q("fixedrange", b("rangeslider", "isVisible")(be));
        }
        f.handleDefaults(e, t, {
          axIds: re.concat(ae).sort(p.idSort),
          axHasImage: O
        });
      };
    }, {
      "../../components/color": 96,
      "../../components/fx/helpers": 132,
      "../../components/fx/hovermode_defaults": 135,
      "../../lib": 225,
      "../../plot_api/plot_template": 261,
      "../../registry": 309,
      "../layout_attributes": 305,
      "./axis_defaults": 274,
      "./axis_ids": 276,
      "./constants": 279,
      "./constraints": 280,
      "./layout_attributes": 287,
      "./position_defaults": 290,
      "./type_defaults": 298
    }],
    289: [function (e, t, r) {
      "use strict";

      var n = e("tinycolor2").mix,
        a = e("../../components/color/attributes").lightFraction,
        i = e("../../lib");
      t.exports = function (e, t, r, o) {
        var l = (o = o || {}).dfltColor;
        function s(r, n) {
          return i.coerce2(e, t, o.attributes, r, n);
        }
        var c = s("linecolor", l),
          u = s("linewidth");
        r("showline", o.showLine || !!c || !!u) || (delete t.linecolor, delete t.linewidth);
        var d = s("gridcolor", n(l, o.bgColor, o.blend || a).toRgbString()),
          f = s("gridwidth");
        if (r("showgrid", o.showGrid || !!d || !!f) || (delete t.gridcolor, delete t.gridwidth), !o.noZeroLine) {
          var h = s("zerolinecolor", l),
            p = s("zerolinewidth");
          r("zeroline", o.showGrid || !!h || !!p) || (delete t.zerolinecolor, delete t.zerolinewidth);
        }
      };
    }, {
      "../../components/color/attributes": 95,
      "../../lib": 225,
      tinycolor2: 61
    }],
    290: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib");
      t.exports = function (e, t, r, i) {
        var o,
          l,
          s,
          c,
          u = i.counterAxes || [],
          d = i.overlayableAxes || [],
          f = i.letter,
          h = i.grid;
        h && (l = h._domains[f][h._axisMap[t._id]], o = h._anchors[t._id], l && (s = h[f + "side"].split(" ")[0], c = h.domain[f]["right" === s || "top" === s ? 1 : 0])), l = l || [0, 1], o = o || (n(e.position) ? "free" : u[0] || "free"), s = s || ("x" === f ? "bottom" : "left"), c = c || 0, "free" === a.coerce(e, t, {
          anchor: {
            valType: "enumerated",
            values: ["free"].concat(u),
            dflt: o
          }
        }, "anchor") && r("position", c), a.coerce(e, t, {
          side: {
            valType: "enumerated",
            values: "x" === f ? ["bottom", "top"] : ["left", "right"],
            dflt: s
          }
        }, "side");
        var p = !1;
        if (d.length && (p = a.coerce(e, t, {
          overlaying: {
            valType: "enumerated",
            values: [!1].concat(d),
            dflt: !1
          }
        }, "overlaying")), !p) {
          var g = r("domain", l);
          g[0] > g[1] - 1 / 4096 && (t.domain = l), a.noneOrAll(e.domain, t.domain, l);
        }
        return r("layer"), t;
      };
    }, {
      "../../lib": 225,
      "fast-isnumeric": 11
    }],
    291: [function (e, t, r) {
      "use strict";

      var n = e("../../constants/alignment").FROM_BL;
      t.exports = function (e, t, r) {
        void 0 === r && (r = n[e.constraintoward || "center"]);
        var a = [e.r2l(e.range[0]), e.r2l(e.range[1])],
          i = a[0] + (a[1] - a[0]) * r;
        e.range = e._input.range = [e.l2r(i + (a[0] - i) * t), e.l2r(i + (a[1] - i) * t)], e.setScale();
      };
    }, {
      "../../constants/alignment": 201
    }],
    292: [function (e, t, r) {
      "use strict";

      var n = e("polybooljs"),
        a = e("../../registry"),
        i = e("../../components/drawing").dashStyle,
        o = e("../../components/color"),
        l = e("../../components/fx"),
        s = e("../../components/fx/helpers").makeEventData,
        c = e("../../components/dragelement/helpers"),
        u = c.freeMode,
        d = c.rectMode,
        f = c.drawMode,
        h = c.openMode,
        p = c.selectMode,
        g = e("../../components/shapes/draw_newshape/display_outlines"),
        m = e("../../components/shapes/draw_newshape/helpers").handleEllipse,
        y = e("../../components/shapes/draw_newshape/newshapes"),
        v = e("../../lib"),
        x = e("../../lib/polygon"),
        b = e("../../lib/throttle"),
        _ = e("./axis_ids").getFromId,
        w = e("../../lib/clear_gl_canvases"),
        M = e("../../plot_api/subroutines").redrawReglTraces,
        T = e("./constants"),
        k = T.MINSELECT,
        A = x.filter,
        L = x.tester,
        D = e("./handle_outline").clearSelect,
        S = e("./helpers"),
        C = S.p2r,
        O = S.axValue,
        P = S.getTransform;
      function I(e, t, r, n, a, i, o) {
        var l,
          s,
          c,
          u,
          d,
          f,
          p,
          m,
          y,
          v = t._hoverdata,
          x = t._fullLayout.clickmode.indexOf("event") > -1,
          b = [];
        if (function (e) {
          return e && Array.isArray(e) && !0 !== e[0].hoverOnBox;
        }(v)) {
          F(e, t, i);
          var _ = function (e, t) {
            var r,
              n,
              a = e[0],
              i = -1,
              o = [];
            for (n = 0; n < t.length; n++) if (r = t[n], a.fullData._expandedIndex === r.cd[0].trace._expandedIndex) {
              if (!0 === a.hoverOnBox) break;
              void 0 !== a.pointNumber ? i = a.pointNumber : void 0 !== a.binNumber && (i = a.binNumber, o = a.pointNumbers);
              break;
            }
            return {
              pointNumber: i,
              pointNumbers: o,
              searchInfo: r
            };
          }(v, l = j(t, r, n, a));
          if (_.pointNumbers.length > 0 ? function (e, t) {
            var r,
              n,
              a,
              i = [];
            for (a = 0; a < e.length; a++) (r = e[a]).cd[0].trace.selectedpoints && r.cd[0].trace.selectedpoints.length > 0 && i.push(r);
            if (1 === i.length && i[0] === t.searchInfo && (n = t.searchInfo.cd[0].trace).selectedpoints.length === t.pointNumbers.length) {
              for (a = 0; a < t.pointNumbers.length; a++) if (n.selectedpoints.indexOf(t.pointNumbers[a]) < 0) return !1;
              return !0;
            }
            return !1;
          }(l, _) : function (e) {
            var t,
              r,
              n,
              a = 0;
            for (n = 0; n < e.length; n++) if (t = e[n], (r = t.cd[0].trace).selectedpoints) {
              if (r.selectedpoints.length > 1) return !1;
              if ((a += r.selectedpoints.length) > 1) return !1;
            }
            return 1 === a;
          }(l) && (f = H(_))) {
            for (o && o.remove(), y = 0; y < l.length; y++) (s = l[y])._module.selectPoints(s, !1);
            B(t, l), E(i), x && t.emit("plotly_deselect", null);
          } else {
            for (p = e.shiftKey && (void 0 !== f ? f : H(_)), c = function (e, t, r) {
              return {
                pointNumber: e,
                searchInfo: t,
                subtract: r
              };
            }(_.pointNumber, _.searchInfo, p), u = N(i.selectionDefs.concat([c])), y = 0; y < l.length; y++) if (d = Y(l[y]._module.selectPoints(l[y], u), l[y]), b.length) for (var w = 0; w < d.length; w++) b.push(d[w]);else b = d;
            if (B(t, l, m = {
              points: b
            }), c && i && i.selectionDefs.push(c), o) {
              var M = i.mergedPolygons,
                T = h(i.dragmode);
              g(U(M, T), o, i);
            }
            x && t.emit("plotly_selected", m);
          }
        }
      }
      function z(e) {
        return "pointNumber" in e && "searchInfo" in e;
      }
      function R(e) {
        return {
          xmin: 0,
          xmax: 0,
          ymin: 0,
          ymax: 0,
          pts: [],
          contains: function contains(t, r, n, a) {
            var i = e.searchInfo.cd[0].trace._expandedIndex;
            return a.cd[0].trace._expandedIndex === i && n === e.pointNumber;
          },
          isRect: !1,
          degenerate: !1,
          subtract: e.subtract
        };
      }
      function N(e) {
        for (var t = [], r = z(e[0]) ? 0 : e[0][0][0], n = r, a = z(e[0]) ? 0 : e[0][0][1], i = a, o = 0; o < e.length; o++) if (z(e[o])) t.push(R(e[o]));else {
          var l = x.tester(e[o]);
          l.subtract = e[o].subtract, t.push(l), r = Math.min(r, l.xmin), n = Math.max(n, l.xmax), a = Math.min(a, l.ymin), i = Math.max(i, l.ymax);
        }
        return {
          xmin: r,
          xmax: n,
          ymin: a,
          ymax: i,
          pts: [],
          contains: function contains(e, r, n, a) {
            for (var i = !1, o = 0; o < t.length; o++) t[o].contains(e, r, n, a) && (i = !1 === t[o].subtract);
            return i;
          },
          isRect: !1,
          degenerate: !1
        };
      }
      function F(e, t, r) {
        t._fullLayout._drawing = !1;
        var n = t._fullLayout,
          a = r.plotinfo,
          i = r.dragmode,
          o = n._lastSelectedSubplot && n._lastSelectedSubplot === a.id,
          l = (e.shiftKey || e.altKey) && !(f(i) && h(i));
        o && l && a.selection && a.selection.selectionDefs && !r.selectionDefs ? (r.selectionDefs = a.selection.selectionDefs, r.mergedPolygons = a.selection.mergedPolygons) : l && a.selection || E(r), o || (D(t), n._lastSelectedSubplot = a.id);
      }
      function E(e) {
        var t = e.dragmode,
          r = e.plotinfo,
          n = e.gd;
        if (n._fullLayout._activeShapeIndex >= 0 && n._fullLayout._deactivateShape(n), f(t)) {
          var i = n._fullLayout._zoomlayer.selectAll(".select-outline-" + r.id);
          if (i && n._fullLayout._drawing) {
            var o = y(i, e);
            o && a.call("_guiRelayout", n, {
              shapes: o
            }), n._fullLayout._drawing = !1;
          }
        }
        r.selection = {}, r.selection.selectionDefs = e.selectionDefs = [], r.selection.mergedPolygons = e.mergedPolygons = [];
      }
      function j(e, t, r, n) {
        var a,
          i,
          o,
          l = [],
          s = t.map(function (e) {
            return e._id;
          }),
          c = r.map(function (e) {
            return e._id;
          });
        for (o = 0; o < e.calcdata.length; o++) if (!0 === (i = (a = e.calcdata[o])[0].trace).visible && i._module && i._module.selectPoints) if (!n || i.subplot !== n && i.geo !== n) {
          if ("splom" === i.type && i._xaxes[s[0]] && i._yaxes[c[0]]) {
            var u = f(i._module, a, t[0], r[0]);
            u.scene = e._fullLayout._splomScenes[i.uid], l.push(u);
          } else if ("sankey" === i.type) {
            var d = f(i._module, a, t[0], r[0]);
            l.push(d);
          } else {
            if (-1 === s.indexOf(i.xaxis)) continue;
            if (-1 === c.indexOf(i.yaxis)) continue;
            l.push(f(i._module, a, _(e, i.xaxis), _(e, i.yaxis)));
          }
        } else l.push(f(i._module, a, t[0], r[0]));
        return l;
        function f(e, t, r, n) {
          return {
            _module: e,
            cd: t,
            xaxis: r,
            yaxis: n
          };
        }
      }
      function H(e) {
        var t = e.searchInfo.cd[0].trace,
          r = e.pointNumber,
          n = e.pointNumbers,
          a = n.length > 0 ? n[0] : r;
        return !!t.selectedpoints && t.selectedpoints.indexOf(a) > -1;
      }
      function B(e, t, r) {
        var n, i, o, l;
        for (n = 0; n < t.length; n++) {
          var s = t[n].cd[0].trace._fullInput,
            c = e._fullLayout._tracePreGUI[s.uid] || {};
          void 0 === c.selectedpoints && (c.selectedpoints = s._input.selectedpoints || null);
        }
        if (r) {
          var u = r.points || [];
          for (n = 0; n < t.length; n++) (l = t[n].cd[0].trace)._input.selectedpoints = l._fullInput.selectedpoints = [], l._fullInput !== l && (l.selectedpoints = []);
          for (n = 0; n < u.length; n++) {
            var d = u[n],
              f = d.data,
              h = d.fullData;
            d.pointIndices ? ([].push.apply(f.selectedpoints, d.pointIndices), l._fullInput !== l && [].push.apply(h.selectedpoints, d.pointIndices)) : (f.selectedpoints.push(d.pointIndex), l._fullInput !== l && h.selectedpoints.push(d.pointIndex));
          }
        } else for (n = 0; n < t.length; n++) delete (l = t[n].cd[0].trace).selectedpoints, delete l._input.selectedpoints, l._fullInput !== l && delete l._fullInput.selectedpoints;
        var p = !1;
        for (n = 0; n < t.length; n++) {
          l = (o = (i = t[n]).cd)[0].trace, a.traceIs(l, "regl") && (p = !0);
          var g = i._module,
            m = g.styleOnSelect || g.style;
          m && (m(e, o, o[0].node3), o[0].nodeRangePlot3 && m(e, o, o[0].nodeRangePlot3));
        }
        p && (w(e), M(e));
      }
      function Y(e, t) {
        if (Array.isArray(e)) for (var r = t.cd, n = t.cd[0].trace, a = 0; a < e.length; a++) e[a] = s(e[a], n, r);
        return e;
      }
      function U(e, t) {
        for (var r = [], n = 0; n < e.length; n++) {
          r[n] = [];
          for (var a = 0; a < e[n].length; a++) {
            r[n][a] = [], r[n][a][0] = a ? "L" : "M";
            for (var i = 0; i < e[n][a].length; i++) r[n][a].push(e[n][a][i]);
          }
          t || r[n].push(["Z", r[n][0][1], r[n][0][2]]);
        }
        return r;
      }
      t.exports = {
        prepSelect: function prepSelect(e, t, r, a, s) {
          var c = u(s),
            y = d(s),
            x = h(s),
            _ = f(s),
            w = p(s),
            M = "drawcircle" === s,
            D = "drawline" === s || M,
            S = a.gd,
            z = S._fullLayout,
            R = z._zoomlayer,
            H = a.element.getBoundingClientRect(),
            V = a.plotinfo,
            q = P(V),
            G = t - H.left,
            Z = r - H.top;
          z._calcInverseTransform(S);
          var W = v.apply3DTransform(z._invTransform)(G, Z);
          G = W[0], Z = W[1];
          var J,
            X,
            Q,
            K,
            $,
            ee,
            te,
            re = z._invScaleX,
            ne = z._invScaleY,
            ae = G,
            ie = Z,
            oe = "M" + G + "," + Z,
            le = a.xaxes[0]._length,
            se = a.yaxes[0]._length,
            ce = a.xaxes.concat(a.yaxes),
            ue = e.altKey && !(f(s) && x);
          F(e, S, a), c && (J = A([[G, Z]], T.BENDPX));
          var de = R.selectAll("path.select-outline-" + V.id).data(_ ? [0] : [1, 2]),
            fe = z.newshape;
          de.enter().append("path").attr("class", function (e) {
            return "select-outline select-outline-" + e + " select-outline-" + V.id;
          }).style(_ ? {
            opacity: fe.opacity / 2,
            fill: x ? void 0 : fe.fillcolor,
            stroke: fe.line.color,
            "stroke-dasharray": i(fe.line.dash, fe.line.width),
            "stroke-width": fe.line.width + "px"
          } : {}).attr("fill-rule", fe.fillrule).classed("cursor-move", !!_).attr("transform", q).attr("d", oe + "Z");
          var he,
            pe = R.append("path").attr("class", "zoombox-corners").style({
              fill: o.background,
              stroke: o.defaultLine,
              "stroke-width": 1
            }).attr("transform", q).attr("d", "M0,0Z"),
            ge = z._uid + T.SELECTID,
            me = [],
            ye = j(S, a.xaxes, a.yaxes, a.subplot);
          function ve(e, t) {
            return e - t;
          }
          he = V.fillRangeItems ? V.fillRangeItems : y ? function (e, t) {
            var r = e.range = {};
            for ($ = 0; $ < ce.length; $++) {
              var n = ce[$],
                a = n._id.charAt(0);
              r[n._id] = [C(n, t[a + "min"]), C(n, t[a + "max"])].sort(ve);
            }
          } : function (e, t, r) {
            var n = e.lassoPoints = {};
            for ($ = 0; $ < ce.length; $++) {
              var a = ce[$];
              n[a._id] = r.filtered.map(O(a));
            }
          }, a.moveFn = function (e, t) {
            ae = Math.max(0, Math.min(le, re * e + G)), ie = Math.max(0, Math.min(se, ne * t + Z));
            var r = Math.abs(ae - G),
              i = Math.abs(ie - Z);
            if (y) {
              var o, l, s;
              if (w) {
                var u = z.selectdirection;
                switch (o = "any" === u ? i < Math.min(.6 * r, k) ? "h" : r < Math.min(.6 * i, k) ? "v" : "d" : u) {
                  case "h":
                    l = M ? se / 2 : 0, s = se;
                    break;
                  case "v":
                    l = M ? le / 2 : 0, s = le;
                }
              }
              if (_) switch (z.newshape.drawdirection) {
                case "vertical":
                  o = "h", l = M ? se / 2 : 0, s = se;
                  break;
                case "horizontal":
                  o = "v", l = M ? le / 2 : 0, s = le;
                  break;
                case "ortho":
                  r < i ? (o = "h", l = Z, s = ie) : (o = "v", l = G, s = ae);
                  break;
                default:
                  o = "d";
              }
              "h" === o ? ((K = D ? m(M, [ae, l], [ae, s]) : [[G, l], [G, s], [ae, s], [ae, l]]).xmin = D ? ae : Math.min(G, ae), K.xmax = D ? ae : Math.max(G, ae), K.ymin = Math.min(l, s), K.ymax = Math.max(l, s), pe.attr("d", "M" + K.xmin + "," + (Z - k) + "h-4v" + 2 * k + "h4ZM" + (K.xmax - 1) + "," + (Z - k) + "h4v" + 2 * k + "h-4Z")) : "v" === o ? ((K = D ? m(M, [l, ie], [s, ie]) : [[l, Z], [l, ie], [s, ie], [s, Z]]).xmin = Math.min(l, s), K.xmax = Math.max(l, s), K.ymin = D ? ie : Math.min(Z, ie), K.ymax = D ? ie : Math.max(Z, ie), pe.attr("d", "M" + (G - k) + "," + K.ymin + "v-4h" + 2 * k + "v4ZM" + (G - k) + "," + (K.ymax - 1) + "v4h" + 2 * k + "v-4Z")) : "d" === o && ((K = D ? m(M, [G, Z], [ae, ie]) : [[G, Z], [G, ie], [ae, ie], [ae, Z]]).xmin = Math.min(G, ae), K.xmax = Math.max(G, ae), K.ymin = Math.min(Z, ie), K.ymax = Math.max(Z, ie), pe.attr("d", "M0,0Z"));
            } else c && (J.addPt([ae, ie]), K = J.filtered);
            a.selectionDefs && a.selectionDefs.length ? (Q = function (e, t, r) {
              if (r) return n.difference({
                regions: e,
                inverted: !1
              }, {
                regions: [t],
                inverted: !1
              }).regions;
              return n.union({
                regions: e,
                inverted: !1
              }, {
                regions: [t],
                inverted: !1
              }).regions;
            }(a.mergedPolygons, K, ue), K.subtract = ue, X = N(a.selectionDefs.concat([K]))) : (Q = [K], X = L(K)), g(U(Q, x), de, a), w && b.throttle(ge, T.SELECTDELAY, function () {
              var e;
              me = [];
              var t,
                r = [];
              for ($ = 0; $ < ye.length; $++) if (t = (ee = ye[$])._module.selectPoints(ee, X), r.push(t), e = Y(t, ee), me.length) for (var n = 0; n < e.length; n++) me.push(e[n]);else me = e;
              B(S, ye, te = {
                points: me
              }), he(te, K, J), a.gd.emit("plotly_selecting", te);
            });
          }, a.clickFn = function (e, t) {
            if (pe.remove(), S._fullLayout._activeShapeIndex >= 0) S._fullLayout._deactivateShape(S);else if (!_) {
              var r = z.clickmode;
              b.done(ge).then(function () {
                if (b.clear(ge), 2 === e) {
                  for (de.remove(), $ = 0; $ < ye.length; $++) (ee = ye[$])._module.selectPoints(ee, !1);
                  B(S, ye), E(a), S.emit("plotly_deselect", null);
                } else r.indexOf("select") > -1 && I(t, S, a.xaxes, a.yaxes, a.subplot, a, de), "event" === r && S.emit("plotly_selected", void 0);
                l.click(S, t);
              }).catch(v.error);
            }
          }, a.doneFn = function () {
            pe.remove(), b.done(ge).then(function () {
              b.clear(ge), a.gd.emit("plotly_selected", te), K && a.selectionDefs && (K.subtract = ue, a.selectionDefs.push(K), a.mergedPolygons.length = 0, [].push.apply(a.mergedPolygons, Q)), a.doneFnCompleted && a.doneFnCompleted(me);
            }).catch(v.error), _ && E(a);
          };
        },
        clearSelect: D,
        clearSelectionsCache: E,
        selectOnClick: I
      };
    }, {
      "../../components/color": 96,
      "../../components/dragelement/helpers": 114,
      "../../components/drawing": 118,
      "../../components/fx": 136,
      "../../components/fx/helpers": 132,
      "../../components/shapes/draw_newshape/display_outlines": 184,
      "../../components/shapes/draw_newshape/helpers": 185,
      "../../components/shapes/draw_newshape/newshapes": 186,
      "../../lib": 225,
      "../../lib/clear_gl_canvases": 213,
      "../../lib/polygon": 237,
      "../../lib/throttle": 249,
      "../../plot_api/subroutines": 262,
      "../../registry": 309,
      "./axis_ids": 276,
      "./constants": 279,
      "./handle_outline": 283,
      "./helpers": 284,
      polybooljs: 51
    }],
    293: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("d3-time-format").utcFormat,
        i = e("../../lib"),
        o = i.numberFormat,
        l = e("fast-isnumeric"),
        s = i.cleanNumber,
        c = i.ms2DateTime,
        u = i.dateTime2ms,
        d = i.ensureNumber,
        f = i.isArrayOrTypedArray,
        h = e("../../constants/numerical"),
        p = h.FP_SAFE,
        g = h.BADNUM,
        m = h.LOG_CLIP,
        y = h.ONEWEEK,
        v = h.ONEDAY,
        x = h.ONEHOUR,
        b = h.ONEMIN,
        _ = h.ONESEC,
        w = e("./axis_ids"),
        M = e("./constants"),
        T = M.HOUR_PATTERN,
        k = M.WEEKDAY_PATTERN;
      function A(e) {
        return Math.pow(10, e);
      }
      function L(e) {
        return null != e;
      }
      t.exports = function (e, t) {
        t = t || {};
        var r = e._id || "x",
          h = r.charAt(0);
        function D(t, r) {
          if (t > 0) return Math.log(t) / Math.LN10;
          if (t <= 0 && r && e.range && 2 === e.range.length) {
            var n = e.range[0],
              a = e.range[1];
            return .5 * (n + a - 2 * m * Math.abs(n - a));
          }
          return g;
        }
        function S(t, r, n, a) {
          if ((a || {}).msUTC && l(t)) return +t;
          var o = u(t, n || e.calendar);
          if (o === g) {
            if (!l(t)) return g;
            t = +t;
            var s = Math.floor(10 * i.mod(t + .05, 1)),
              c = Math.round(t - s / 10);
            o = u(new Date(c)) + s / 10;
          }
          return o;
        }
        function C(t, r, n) {
          return c(t, r, n || e.calendar);
        }
        function O(t) {
          return e._categories[Math.round(t)];
        }
        function P(t) {
          if (L(t)) {
            if (void 0 === e._categoriesMap && (e._categoriesMap = {}), void 0 !== e._categoriesMap[t]) return e._categoriesMap[t];
            e._categories.push("number" == typeof t ? String(t) : t);
            var r = e._categories.length - 1;
            return e._categoriesMap[t] = r, r;
          }
          return g;
        }
        function I(t) {
          if (e._categoriesMap) return e._categoriesMap[t];
        }
        function z(e) {
          var t = I(e);
          return void 0 !== t ? t : l(e) ? +e : void 0;
        }
        function R(e) {
          return l(e) ? +e : I(e);
        }
        function N(e, t, r) {
          return n.round(r + t * e, 2);
        }
        function F(e, t, r) {
          return (e - r) / t;
        }
        var E = function E(t) {
            return l(t) ? N(t, e._m, e._b) : g;
          },
          j = function j(t) {
            return F(t, e._m, e._b);
          };
        if (e.rangebreaks) {
          var H = "y" === h;
          E = function E(t) {
            if (!l(t)) return g;
            var r = e._rangebreaks.length;
            if (!r) return N(t, e._m, e._b);
            var n = H;
            e.range[0] > e.range[1] && (n = !n);
            for (var a = n ? -1 : 1, i = a * t, o = 0, s = 0; s < r; s++) {
              var c = a * e._rangebreaks[s].min,
                u = a * e._rangebreaks[s].max;
              if (i < c) break;
              if (!(i > u)) {
                o = i < (c + u) / 2 ? s : s + 1;
                break;
              }
              o = s + 1;
            }
            var d = e._B[o] || 0;
            return isFinite(d) ? N(t, e._m2, d) : 0;
          }, j = function j(t) {
            var r = e._rangebreaks.length;
            if (!r) return F(t, e._m, e._b);
            for (var n = 0, a = 0; a < r && !(t < e._rangebreaks[a].pmin); a++) t > e._rangebreaks[a].pmax && (n = a + 1);
            return F(t, e._m2, e._B[n]);
          };
        }
        e.c2l = "log" === e.type ? D : d, e.l2c = "log" === e.type ? A : d, e.l2p = E, e.p2l = j, e.c2p = "log" === e.type ? function (e, t) {
          return E(D(e, t));
        } : E, e.p2c = "log" === e.type ? function (e) {
          return A(j(e));
        } : j, -1 !== ["linear", "-"].indexOf(e.type) ? (e.d2r = e.r2d = e.d2c = e.r2c = e.d2l = e.r2l = s, e.c2d = e.c2r = e.l2d = e.l2r = d, e.d2p = e.r2p = function (t) {
          return e.l2p(s(t));
        }, e.p2d = e.p2r = j, e.cleanPos = d) : "log" === e.type ? (e.d2r = e.d2l = function (e, t) {
          return D(s(e), t);
        }, e.r2d = e.r2c = function (e) {
          return A(s(e));
        }, e.d2c = e.r2l = s, e.c2d = e.l2r = d, e.c2r = D, e.l2d = A, e.d2p = function (t, r) {
          return e.l2p(e.d2r(t, r));
        }, e.p2d = function (e) {
          return A(j(e));
        }, e.r2p = function (t) {
          return e.l2p(s(t));
        }, e.p2r = j, e.cleanPos = d) : "date" === e.type ? (e.d2r = e.r2d = i.identity, e.d2c = e.r2c = e.d2l = e.r2l = S, e.c2d = e.c2r = e.l2d = e.l2r = C, e.d2p = e.r2p = function (t, r, n) {
          return e.l2p(S(t, 0, n));
        }, e.p2d = e.p2r = function (e, t, r) {
          return C(j(e), t, r);
        }, e.cleanPos = function (t) {
          return i.cleanDate(t, g, e.calendar);
        }) : "category" === e.type ? (e.d2c = e.d2l = P, e.r2d = e.c2d = e.l2d = O, e.d2r = e.d2l_noadd = z, e.r2c = function (t) {
          var r = R(t);
          return void 0 !== r ? r : e.fraction2r(.5);
        }, e.l2r = e.c2r = d, e.r2l = R, e.d2p = function (t) {
          return e.l2p(e.r2c(t));
        }, e.p2d = function (e) {
          return O(j(e));
        }, e.r2p = e.d2p, e.p2r = j, e.cleanPos = function (e) {
          return "string" == typeof e && "" !== e ? e : d(e);
        }) : "multicategory" === e.type && (e.r2d = e.c2d = e.l2d = O, e.d2r = e.d2l_noadd = z, e.r2c = function (t) {
          var r = z(t);
          return void 0 !== r ? r : e.fraction2r(.5);
        }, e.r2c_just_indices = I, e.l2r = e.c2r = d, e.r2l = z, e.d2p = function (t) {
          return e.l2p(e.r2c(t));
        }, e.p2d = function (e) {
          return O(j(e));
        }, e.r2p = e.d2p, e.p2r = j, e.cleanPos = function (e) {
          return Array.isArray(e) || "string" == typeof e && "" !== e ? e : d(e);
        }, e.setupMultiCategory = function (n) {
          var a,
            o,
            l = e._traceIndices,
            s = e._matchGroup;
          if (s && 0 === e._categories.length) for (var c in s) if (c !== r) {
            var u = t[w.id2name(c)];
            l = l.concat(u._traceIndices);
          }
          var d = [[0, {}], [0, {}]],
            p = [];
          for (a = 0; a < l.length; a++) {
            var g = n[l[a]];
            if (h in g) {
              var m = g[h],
                y = g._length || i.minRowLength(m);
              if (f(m[0]) && f(m[1])) for (o = 0; o < y; o++) {
                var v = m[0][o],
                  x = m[1][o];
                L(v) && L(x) && (p.push([v, x]), v in d[0][1] || (d[0][1][v] = d[0][0]++), x in d[1][1] || (d[1][1][x] = d[1][0]++));
              }
            }
          }
          for (p.sort(function (e, t) {
            var r = d[0][1],
              n = r[e[0]] - r[t[0]];
            if (n) return n;
            var a = d[1][1];
            return a[e[1]] - a[t[1]];
          }), a = 0; a < p.length; a++) P(p[a]);
        }), e.fraction2r = function (t) {
          var r = e.r2l(e.range[0]),
            n = e.r2l(e.range[1]);
          return e.l2r(r + t * (n - r));
        }, e.r2fraction = function (t) {
          var r = e.r2l(e.range[0]),
            n = e.r2l(e.range[1]);
          return (e.r2l(t) - r) / (n - r);
        }, e.cleanRange = function (t, r) {
          r || (r = {}), t || (t = "range");
          var n,
            a,
            o = i.nestedProperty(e, t).get();
          if (a = (a = "date" === e.type ? i.dfltRange(e.calendar) : "y" === h ? M.DFLTRANGEY : r.dfltRange || M.DFLTRANGEX).slice(), "tozero" !== e.rangemode && "nonnegative" !== e.rangemode || (a[0] = 0), o && 2 === o.length) {
            for ("date" !== e.type || e.autorange || (o[0] = i.cleanDate(o[0], g, e.calendar), o[1] = i.cleanDate(o[1], g, e.calendar)), n = 0; n < 2; n++) if ("date" === e.type) {
              if (!i.isDateTime(o[n], e.calendar)) {
                e[t] = a;
                break;
              }
              if (e.r2l(o[0]) === e.r2l(o[1])) {
                var s = i.constrain(e.r2l(o[0]), i.MIN_MS + 1e3, i.MAX_MS - 1e3);
                o[0] = e.l2r(s - 1e3), o[1] = e.l2r(s + 1e3);
                break;
              }
            } else {
              if (!l(o[n])) {
                if (!l(o[1 - n])) {
                  e[t] = a;
                  break;
                }
                o[n] = o[1 - n] * (n ? 10 : .1);
              }
              if (o[n] < -p ? o[n] = -p : o[n] > p && (o[n] = p), o[0] === o[1]) {
                var c = Math.max(1, Math.abs(1e-6 * o[0]));
                o[0] -= c, o[1] += c;
              }
            }
          } else i.nestedProperty(e, t).set(a);
        }, e.setScale = function (r) {
          var n = t._size;
          if (e.overlaying) {
            var a = w.getFromId({
              _fullLayout: t
            }, e.overlaying);
            e.domain = a.domain;
          }
          var i = r && e._r ? "_r" : "range",
            o = e.calendar;
          e.cleanRange(i);
          var l,
            s,
            c = e.r2l(e[i][0], o),
            u = e.r2l(e[i][1], o),
            d = "y" === h;
          if ((d ? (e._offset = n.t + (1 - e.domain[1]) * n.h, e._length = n.h * (e.domain[1] - e.domain[0]), e._m = e._length / (c - u), e._b = -e._m * u) : (e._offset = n.l + e.domain[0] * n.w, e._length = n.w * (e.domain[1] - e.domain[0]), e._m = e._length / (u - c), e._b = -e._m * c), e._rangebreaks = [], e._lBreaks = 0, e._m2 = 0, e._B = [], e.rangebreaks) && (e._rangebreaks = e.locateBreaks(Math.min(c, u), Math.max(c, u)), e._rangebreaks.length)) {
            for (l = 0; l < e._rangebreaks.length; l++) s = e._rangebreaks[l], e._lBreaks += Math.abs(s.max - s.min);
            var f = d;
            c > u && (f = !f), f && e._rangebreaks.reverse();
            var p = f ? -1 : 1;
            for (e._m2 = p * e._length / (Math.abs(u - c) - e._lBreaks), e._B.push(-e._m2 * (d ? u : c)), l = 0; l < e._rangebreaks.length; l++) s = e._rangebreaks[l], e._B.push(e._B[e._B.length - 1] - p * e._m2 * (s.max - s.min));
            for (l = 0; l < e._rangebreaks.length; l++) (s = e._rangebreaks[l]).pmin = E(s.min), s.pmax = E(s.max);
          }
          if (!isFinite(e._m) || !isFinite(e._b) || e._length < 0) throw t._replotting = !1, new Error("Something went wrong with axis scaling");
        }, e.maskBreaks = function (t) {
          var r,
            n,
            a,
            o,
            l,
            c = e.rangebreaks || [];
          c._cachedPatterns || (c._cachedPatterns = c.map(function (t) {
            return t.enabled && t.bounds ? i.simpleMap(t.bounds, t.pattern ? s : e.d2c) : null;
          })), c._cachedValues || (c._cachedValues = c.map(function (t) {
            return t.enabled && t.values ? i.simpleMap(t.values, e.d2c).sort(i.sorterAsc) : null;
          }));
          for (var u = 0; u < c.length; u++) {
            var d = c[u];
            if (d.enabled) if (d.bounds) {
              var f = d.pattern;
              switch (n = (r = c._cachedPatterns[u])[0], a = r[1], f) {
                case k:
                  o = (l = new Date(t)).getUTCDay(), n > a && (a += 7, o < n && (o += 7));
                  break;
                case T:
                  o = (l = new Date(t)).getUTCHours() + (l.getUTCMinutes() / 60 + l.getUTCSeconds() / 3600 + l.getUTCMilliseconds() / 36e5), n > a && (a += 24, o < n && (o += 24));
                  break;
                case "":
                  o = t;
              }
              if (o >= n && o < a) return g;
            } else for (var h = c._cachedValues[u], p = 0; p < h.length; p++) if (a = (n = h[p]) + d.dvalue, t >= n && t < a) return g;
          }
          return t;
        }, e.locateBreaks = function (t, r) {
          var n,
            a,
            o,
            l,
            c = [];
          if (!e.rangebreaks) return c;
          var u = e.rangebreaks.slice().sort(function (e, t) {
              return e.pattern === k && t.pattern === T ? -1 : t.pattern === k && e.pattern === T ? 1 : 0;
            }),
            d = function d(e, n) {
              if ((e = i.constrain(e, t, r)) !== (n = i.constrain(n, t, r))) {
                for (var a = !0, o = 0; o < c.length; o++) {
                  var l = c[o];
                  e < l.max && n >= l.min && (e < l.min && (l.min = e), n > l.max && (l.max = n), a = !1);
                }
                a && c.push({
                  min: e,
                  max: n
                });
              }
            };
          for (n = 0; n < u.length; n++) {
            var f = u[n];
            if (f.enabled) if (f.bounds) {
              var h = t,
                p = r;
              f.pattern && (h = Math.floor(h)), o = (a = i.simpleMap(f.bounds, f.pattern ? s : e.r2l))[0], l = a[1];
              var g,
                m,
                w = new Date(h);
              switch (f.pattern) {
                case k:
                  m = y, g = (l - o + (l < o ? 7 : 0)) * v, h += o * v - (w.getUTCDay() * v + w.getUTCHours() * x + w.getUTCMinutes() * b + w.getUTCSeconds() * _ + w.getUTCMilliseconds());
                  break;
                case T:
                  m = v, g = (l - o + (l < o ? 24 : 0)) * x, h += o * x - (w.getUTCHours() * x + w.getUTCMinutes() * b + w.getUTCSeconds() * _ + w.getUTCMilliseconds());
                  break;
                default:
                  h = Math.min(a[0], a[1]), g = m = (p = Math.max(a[0], a[1])) - h;
              }
              for (var M = h; M < p; M += m) d(M, M + g);
            } else for (var A = i.simpleMap(f.values, e.d2c), L = 0; L < A.length; L++) d(o = A[L], l = o + f.dvalue);
          }
          return c.sort(function (e, t) {
            return e.min - t.min;
          }), c;
        }, e.makeCalcdata = function (t, r, n) {
          var a,
            o,
            l,
            s,
            c = e.type,
            u = "date" === c && t[r + "calendar"];
          if (r in t) {
            if (a = t[r], s = t._length || i.minRowLength(a), i.isTypedArray(a) && ("linear" === c || "log" === c)) {
              if (s === a.length) return a;
              if (a.subarray) return a.subarray(0, s);
            }
            if ("multicategory" === c) return function (e, t) {
              for (var r = new Array(t), n = 0; n < t; n++) {
                var a = (e[0] || [])[n],
                  i = (e[1] || [])[n];
                r[n] = I([a, i]);
              }
              return r;
            }(a, s);
            for (o = new Array(s), l = 0; l < s; l++) o[l] = e.d2c(a[l], 0, u, n);
          } else {
            var d = r + "0" in t ? e.d2c(t[r + "0"], 0, u) : 0,
              f = t["d" + r] ? Number(t["d" + r]) : 1;
            for (a = t[{
              x: "y",
              y: "x"
            }[r]], s = t._length || a.length, o = new Array(s), l = 0; l < s; l++) o[l] = d + l * f;
          }
          if (e.rangebreaks) for (l = 0; l < s; l++) o[l] = e.maskBreaks(o[l]);
          return o;
        }, e.isValidRange = function (t) {
          return Array.isArray(t) && 2 === t.length && l(e.r2l(t[0])) && l(e.r2l(t[1]));
        }, e.isPtWithinRange = function (t, r) {
          var n = e.c2l(t[h], null, r),
            a = e.r2l(e.range[0]),
            i = e.r2l(e.range[1]);
          return a < i ? a <= n && n <= i : i <= n && n <= a;
        }, e._emptyCategories = function () {
          e._categories = [], e._categoriesMap = {};
        }, e.clearCalc = function () {
          var r = e._matchGroup;
          if (r) {
            var n = null,
              a = null;
            for (var i in r) {
              var o = t[w.id2name(i)];
              if (o._categories) {
                n = o._categories, a = o._categoriesMap;
                break;
              }
            }
            n && a ? (e._categories = n, e._categoriesMap = a) : e._emptyCategories();
          } else e._emptyCategories();
          if (e._initialCategories) for (var l = 0; l < e._initialCategories.length; l++) P(e._initialCategories[l]);
        }, e.sortByInitialCategories = function () {
          var n = [];
          if (e._emptyCategories(), e._initialCategories) for (var a = 0; a < e._initialCategories.length; a++) P(e._initialCategories[a]);
          n = n.concat(e._traceIndices);
          var i = e._matchGroup;
          for (var o in i) if (r !== o) {
            var l = t[w.id2name(o)];
            l._categories = e._categories, l._categoriesMap = e._categoriesMap, n = n.concat(l._traceIndices);
          }
          return n;
        };
        var B = t._d3locale;
        "date" === e.type && (e._dateFormat = B ? B.timeFormat : a, e._extraFormat = t._extraFormat), e._separators = t.separators, e._numFormat = B ? B.numberFormat : o, delete e._minDtick, delete e._forceTick0;
      };
    }, {
      "../../constants/numerical": 205,
      "../../lib": 225,
      "./axis_ids": 276,
      "./constants": 279,
      "@plotly/d3": 6,
      "d3-time-format": 8,
      "fast-isnumeric": 11
    }],
    294: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../components/color").contrast,
        i = e("./layout_attributes"),
        o = e("../array_container_defaults");
      function l(e) {
        var t = ["showexponent", "showtickprefix", "showticksuffix"].filter(function (t) {
          return void 0 !== e[t];
        });
        if (t.every(function (r) {
          return e[r] === e[t[0]];
        }) || 1 === t.length) return e[t[0]];
      }
      function s(e, t) {
        function r(r, a) {
          return n.coerce(e, t, i.tickformatstops, r, a);
        }
        r("enabled") && (r("dtickrange"), r("value"));
      }
      t.exports = function (e, t, r, c, u, d) {
        d && 1 !== d.pass || function (e, t, r, n, a) {
          var i = l(e);
          r("tickprefix") && r("showtickprefix", i);
          r("ticksuffix", a.tickSuffixDflt) && r("showticksuffix", i);
        }(e, 0, r, 0, u), d && 2 !== d.pass || function (e, t, r, c, u) {
          var d = l(e);
          r("tickprefix") && r("showtickprefix", d);
          r("ticksuffix", u.tickSuffixDflt) && r("showticksuffix", d);
          if (r("showticklabels")) {
            var f = u.font || {},
              h = t.color,
              p = -1 !== (t.ticklabelposition || "").indexOf("inside") ? a(u.bgColor) : h && h !== i.color.dflt ? h : f.color;
            if (n.coerceFont(r, "tickfont", {
              family: f.family,
              size: f.size,
              color: p
            }), r("tickangle"), "category" !== c) {
              var g = r("tickformat");
              o(e, t, {
                name: "tickformatstops",
                inclusionAttr: "enabled",
                handleItemDefaults: s
              }), t.tickformatstops.length || delete t.tickformatstops, g || "date" === c || (r("showexponent", d), r("exponentformat"), r("minexponent"), r("separatethousands"));
            }
          }
        }(e, t, r, c, u);
      };
    }, {
      "../../components/color": 96,
      "../../lib": 225,
      "../array_container_defaults": 267,
      "./layout_attributes": 287
    }],
    295: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("./layout_attributes");
      t.exports = function (e, t, r, i) {
        var o = n.coerce2(e, t, a, "ticklen"),
          l = n.coerce2(e, t, a, "tickwidth"),
          s = n.coerce2(e, t, a, "tickcolor", t.color);
        r("ticks", i.outerTicks || o || l || s ? "outside" : "") || (delete t.ticklen, delete t.tickwidth, delete t.tickcolor);
      };
    }, {
      "../../lib": 225,
      "./layout_attributes": 287
    }],
    296: [function (e, t, r) {
      "use strict";

      var n = e("./clean_ticks"),
        a = e("../../lib").isArrayOrTypedArray;
      t.exports = function (e, t, r, i) {
        function o(r) {
          var n = e[r];
          return void 0 !== n ? n : (t._template || {})[r];
        }
        var l = o("tick0"),
          s = o("dtick"),
          c = o("tickvals"),
          u = r("tickmode", a(c) ? "array" : s ? "linear" : "auto");
        if ("auto" === u) r("nticks");else if ("linear" === u) {
          var d = t.dtick = n.dtick(s, i);
          t.tick0 = n.tick0(l, i, t.calendar, d);
        } else if ("multicategory" !== i) {
          void 0 === r("tickvals") ? t.tickmode = "auto" : r("ticktext");
        }
      };
    }, {
      "../../lib": 225,
      "./clean_ticks": 278
    }],
    297: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../registry"),
        i = e("../../lib"),
        o = e("../../components/drawing"),
        l = e("./axes");
      t.exports = function (e, t, r, s) {
        var c = e._fullLayout;
        if (0 !== t.length) {
          var u, d, f, h;
          s && (u = s());
          var p = n.ease(r.easing);
          return e._transitionData._interruptCallbacks.push(function () {
            return window.cancelAnimationFrame(h), h = null, function () {
              for (var r = {}, n = 0; n < t.length; n++) {
                var i = t[n],
                  o = i.plotinfo.xaxis,
                  l = i.plotinfo.yaxis;
                i.xr0 && (r[o._name + ".range"] = i.xr0.slice()), i.yr0 && (r[l._name + ".range"] = i.yr0.slice());
              }
              return a.call("relayout", e, r).then(function () {
                for (var e = 0; e < t.length; e++) g(t[e].plotinfo);
              });
            }();
          }), d = Date.now(), h = window.requestAnimationFrame(function n() {
            f = Date.now();
            for (var i = Math.min(1, (f - d) / r.duration), o = p(i), l = 0; l < t.length; l++) m(t[l], o);
            f - d > r.duration ? (!function () {
              for (var r = {}, n = 0; n < t.length; n++) {
                var i = t[n],
                  o = i.plotinfo.xaxis,
                  l = i.plotinfo.yaxis;
                i.xr1 && (r[o._name + ".range"] = i.xr1.slice()), i.yr1 && (r[l._name + ".range"] = i.yr1.slice());
              }
              u && u(), a.call("relayout", e, r).then(function () {
                for (var e = 0; e < t.length; e++) g(t[e].plotinfo);
              });
            }(), h = window.cancelAnimationFrame(n)) : h = window.requestAnimationFrame(n);
          }), Promise.resolve();
        }
        function g(e) {
          var t = e.xaxis,
            r = e.yaxis;
          c._defs.select("#" + e.clipId + "> rect").call(o.setTranslate, 0, 0).call(o.setScale, 1, 1), e.plot.call(o.setTranslate, t._offset, r._offset).call(o.setScale, 1, 1);
          var n = e.plot.selectAll(".scatterlayer .trace");
          n.selectAll(".point").call(o.setPointGroupScale, 1, 1), n.selectAll(".textpoint").call(o.setTextPointsScale, 1, 1), n.call(o.hideOutsideRangePoints, e);
        }
        function m(t, r) {
          var n = t.plotinfo,
            a = n.xaxis,
            s = n.yaxis,
            c = a._length,
            u = s._length,
            d = !!t.xr1,
            f = !!t.yr1,
            h = [];
          if (d) {
            var p = i.simpleMap(t.xr0, a.r2l),
              g = i.simpleMap(t.xr1, a.r2l),
              m = p[1] - p[0],
              y = g[1] - g[0];
            h[0] = (p[0] * (1 - r) + r * g[0] - p[0]) / (p[1] - p[0]) * c, h[2] = c * (1 - r + r * y / m), a.range[0] = a.l2r(p[0] * (1 - r) + r * g[0]), a.range[1] = a.l2r(p[1] * (1 - r) + r * g[1]);
          } else h[0] = 0, h[2] = c;
          if (f) {
            var v = i.simpleMap(t.yr0, s.r2l),
              x = i.simpleMap(t.yr1, s.r2l),
              b = v[1] - v[0],
              _ = x[1] - x[0];
            h[1] = (v[1] * (1 - r) + r * x[1] - v[1]) / (v[0] - v[1]) * u, h[3] = u * (1 - r + r * _ / b), s.range[0] = a.l2r(v[0] * (1 - r) + r * x[0]), s.range[1] = s.l2r(v[1] * (1 - r) + r * x[1]);
          } else h[1] = 0, h[3] = u;
          l.drawOne(e, a, {
            skipTitle: !0
          }), l.drawOne(e, s, {
            skipTitle: !0
          }), l.redrawComponents(e, [a._id, s._id]);
          var w = d ? c / h[2] : 1,
            M = f ? u / h[3] : 1,
            T = d ? h[0] : 0,
            k = f ? h[1] : 0,
            A = d ? h[0] / h[2] * c : 0,
            L = f ? h[1] / h[3] * u : 0,
            D = a._offset - A,
            S = s._offset - L;
          n.clipRect.call(o.setTranslate, T, k).call(o.setScale, 1 / w, 1 / M), n.plot.call(o.setTranslate, D, S).call(o.setScale, w, M), o.setPointGroupScale(n.zoomScalePts, 1 / w, 1 / M), o.setTextPointsScale(n.zoomScaleTxt, 1 / w, 1 / M);
        }
        l.redrawComponents(e);
      };
    }, {
      "../../components/drawing": 118,
      "../../lib": 225,
      "../../registry": 309,
      "./axes": 272,
      "@plotly/d3": 6
    }],
    298: [function (e, t, r) {
      "use strict";

      var n = e("../../registry").traceIs,
        a = e("./axis_autotype");
      function i(e) {
        return {
          v: "x",
          h: "y"
        }[e.orientation || "v"];
      }
      function o(e, t) {
        var r = i(e),
          a = n(e, "box-violin"),
          o = n(e._fullInput || {}, "candlestick");
        return a && !o && t === r && void 0 === e[r] && void 0 === e[r + "0"];
      }
      t.exports = function (e, t, r, l) {
        r("autotypenumbers", l.autotypenumbersDflt), "-" === r("type", (l.splomStash || {}).type) && (!function (e, t) {
          if ("-" !== e.type) return;
          var r,
            l = e._id,
            s = l.charAt(0);
          -1 !== l.indexOf("scene") && (l = s);
          var c = function (e, t, r) {
            for (var n = 0; n < e.length; n++) {
              var a = e[n];
              if ("splom" === a.type && a._length > 0 && (a["_" + r + "axes"] || {})[t]) return a;
              if ((a[r + "axis"] || r) === t) {
                if (o(a, r)) return a;
                if ((a[r] || []).length || a[r + "0"]) return a;
              }
            }
          }(t, l, s);
          if (!c) return;
          if ("histogram" === c.type && s === {
            v: "y",
            h: "x"
          }[c.orientation || "v"]) return void (e.type = "linear");
          var u = s + "calendar",
            d = c[u],
            f = {
              noMultiCategory: !n(c, "cartesian") || n(c, "noMultiCategory")
            };
          "box" === c.type && c._hasPreCompStats && s === {
            h: "x",
            v: "y"
          }[c.orientation || "v"] && (f.noMultiCategory = !0);
          if (f.autotypenumbers = e.autotypenumbers, o(c, s)) {
            var h = i(c),
              p = [];
            for (r = 0; r < t.length; r++) {
              var g = t[r];
              n(g, "box-violin") && (g[s + "axis"] || s) === l && (void 0 !== g[h] ? p.push(g[h][0]) : void 0 !== g.name ? p.push(g.name) : p.push("text"), g[u] !== d && (d = void 0));
            }
            e.type = a(p, d, f);
          } else if ("splom" === c.type) {
            var m = c.dimensions[c._axesDim[l]];
            m.visible && (e.type = a(m.values, d, f));
          } else e.type = a(c[s] || [c[s + "0"]], d, f);
        }(t, l.data), "-" === t.type ? t.type = "linear" : e.type = t.type);
      };
    }, {
      "../../registry": 309,
      "./axis_autotype": 273
    }],
    299: [function (e, t, r) {
      "use strict";

      var n = e("../registry"),
        a = e("../lib");
      function i(e, t, r) {
        var n,
          i,
          o,
          l = !1;
        if ("data" === t.type) n = e._fullData[null !== t.traces ? t.traces[0] : 0];else {
          if ("layout" !== t.type) return !1;
          n = e._fullLayout;
        }
        return i = a.nestedProperty(n, t.prop).get(), (o = r[t.type] = r[t.type] || {}).hasOwnProperty(t.prop) && o[t.prop] !== i && (l = !0), o[t.prop] = i, {
          changed: l,
          value: i
        };
      }
      function o(e, t) {
        var r = [],
          n = t[0],
          i = {};
        if ("string" == typeof n) i[n] = t[1];else {
          if (!a.isPlainObject(n)) return r;
          i = n;
        }
        return s(i, function (e, t, n) {
          r.push({
            type: "layout",
            prop: e,
            value: n
          });
        }, "", 0), r;
      }
      function l(e, t) {
        var r,
          n,
          i,
          o,
          l = [];
        if (n = t[0], i = t[1], r = t[2], o = {}, "string" == typeof n) o[n] = i;else {
          if (!a.isPlainObject(n)) return l;
          o = n, void 0 === r && (r = i);
        }
        return void 0 === r && (r = null), s(o, function (t, n, a) {
          var i, o;
          if (Array.isArray(a)) {
            o = a.slice();
            var s = Math.min(o.length, e.data.length);
            r && (s = Math.min(s, r.length)), i = [];
            for (var c = 0; c < s; c++) i[c] = r ? r[c] : c;
          } else o = a, i = r ? r.slice() : null;
          if (null === i) Array.isArray(o) && (o = o[0]);else if (Array.isArray(i)) {
            if (!Array.isArray(o)) {
              var u = o;
              o = [];
              for (var d = 0; d < i.length; d++) o[d] = u;
            }
            o.length = Math.min(i.length, o.length);
          }
          l.push({
            type: "data",
            prop: t,
            traces: i,
            value: o
          });
        }, "", 0), l;
      }
      function s(e, t, r, n) {
        Object.keys(e).forEach(function (i) {
          var o = e[i];
          if ("_" !== i[0]) {
            var l = r + (n > 0 ? "." : "") + i;
            a.isPlainObject(o) ? s(o, t, l, n + 1) : t(l, i, o);
          }
        });
      }
      r.manageCommandObserver = function (e, t, n, o) {
        var l = {},
          s = !0;
        t && t._commandObserver && (l = t._commandObserver), l.cache || (l.cache = {}), l.lookupTable = {};
        var c = r.hasSimpleAPICommandBindings(e, n, l.lookupTable);
        if (t && t._commandObserver) {
          if (c) return l;
          if (t._commandObserver.remove) return t._commandObserver.remove(), t._commandObserver = null, l;
        }
        if (c) {
          i(e, c, l.cache), l.check = function () {
            if (s) {
              var t = i(e, c, l.cache);
              return t.changed && o && void 0 !== l.lookupTable[t.value] && (l.disable(), Promise.resolve(o({
                value: t.value,
                type: c.type,
                prop: c.prop,
                traces: c.traces,
                index: l.lookupTable[t.value]
              })).then(l.enable, l.enable)), t.changed;
            }
          };
          for (var u = ["plotly_relayout", "plotly_redraw", "plotly_restyle", "plotly_update", "plotly_animatingframe", "plotly_afterplot"], d = 0; d < u.length; d++) e._internalOn(u[d], l.check);
          l.remove = function () {
            for (var t = 0; t < u.length; t++) e._removeInternalListener(u[t], l.check);
          };
        } else a.log("Unable to automatically bind plot updates to API command"), l.lookupTable = {}, l.remove = function () {};
        return l.disable = function () {
          s = !1;
        }, l.enable = function () {
          s = !0;
        }, t && (t._commandObserver = l), l;
      }, r.hasSimpleAPICommandBindings = function (e, t, n) {
        var a,
          i,
          o = t.length;
        for (a = 0; a < o; a++) {
          var l,
            s = t[a],
            c = s.method,
            u = s.args;
          if (Array.isArray(u) || (u = []), !c) return !1;
          var d = r.computeAPICommandBindings(e, c, u);
          if (1 !== d.length) return !1;
          if (i) {
            if ((l = d[0]).type !== i.type) return !1;
            if (l.prop !== i.prop) return !1;
            if (Array.isArray(i.traces)) {
              if (!Array.isArray(l.traces)) return !1;
              l.traces.sort();
              for (var f = 0; f < i.traces.length; f++) if (i.traces[f] !== l.traces[f]) return !1;
            } else if (l.prop !== i.prop) return !1;
          } else i = d[0], Array.isArray(i.traces) && i.traces.sort();
          var h = (l = d[0]).value;
          if (Array.isArray(h)) {
            if (1 !== h.length) return !1;
            h = h[0];
          }
          n && (n[h] = a);
        }
        return i;
      }, r.executeAPICommand = function (e, t, r) {
        if ("skip" === t) return Promise.resolve();
        var i = n.apiMethodRegistry[t],
          o = [e];
        Array.isArray(r) || (r = []);
        for (var l = 0; l < r.length; l++) o.push(r[l]);
        return i.apply(null, o).catch(function (e) {
          return a.warn("API call to Plotly." + t + " rejected.", e), Promise.reject(e);
        });
      }, r.computeAPICommandBindings = function (e, t, r) {
        var n;
        switch (Array.isArray(r) || (r = []), t) {
          case "restyle":
            n = l(e, r);
            break;
          case "relayout":
            n = o(e, r);
            break;
          case "update":
            n = l(e, [r[0], r[2]]).concat(o(e, [r[1]]));
            break;
          case "animate":
            n = function (e, t) {
              return Array.isArray(t[0]) && 1 === t[0].length && -1 !== ["string", "number"].indexOf(typeof t[0][0]) ? [{
                type: "layout",
                prop: "_currentFrame",
                value: t[0][0].toString()
              }] : [];
            }(0, r);
            break;
          default:
            n = [];
        }
        return n;
      };
    }, {
      "../lib": 225,
      "../registry": 309
    }],
    300: [function (e, t, r) {
      "use strict";

      var n = e("../lib/extend").extendFlat;
      r.attributes = function (e, t) {
        t = t || {};
        var r = {
            valType: "info_array",
            editType: (e = e || {}).editType,
            items: [{
              valType: "number",
              min: 0,
              max: 1,
              editType: e.editType
            }, {
              valType: "number",
              min: 0,
              max: 1,
              editType: e.editType
            }],
            dflt: [0, 1]
          },
          a = (e.name && e.name, e.trace, t.description && t.description, {
            x: n({}, r, {}),
            y: n({}, r, {}),
            editType: e.editType
          });
        return e.noGridCell || (a.row = {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: e.editType
        }, a.column = {
          valType: "integer",
          min: 0,
          dflt: 0,
          editType: e.editType
        }), a;
      }, r.defaults = function (e, t, r, n) {
        var a = n && n.x || [0, 1],
          i = n && n.y || [0, 1],
          o = t.grid;
        if (o) {
          var l = r("domain.column");
          void 0 !== l && (l < o.columns ? a = o._domains.x[l] : delete e.domain.column);
          var s = r("domain.row");
          void 0 !== s && (s < o.rows ? i = o._domains.y[s] : delete e.domain.row);
        }
        var c = r("domain.x", a),
          u = r("domain.y", i);
        c[0] < c[1] || (e.domain.x = a.slice()), u[0] < u[1] || (e.domain.y = i.slice());
      };
    }, {
      "../lib/extend": 219
    }],
    301: [function (e, t, r) {
      "use strict";

      t.exports = function (e) {
        var t = e.editType,
          r = e.colorEditType;
        void 0 === r && (r = t);
        var n = {
          family: {
            valType: "string",
            noBlank: !0,
            strict: !0,
            editType: t
          },
          size: {
            valType: "number",
            min: 1,
            editType: t
          },
          color: {
            valType: "color",
            editType: r
          },
          editType: t
        };
        return e.arrayOk && (n.family.arrayOk = !0, n.size.arrayOk = !0, n.color.arrayOk = !0), n;
      };
    }, {}],
    302: [function (e, t, r) {
      "use strict";

      t.exports = {
        _isLinkedToArray: "frames_entry",
        group: {
          valType: "string"
        },
        name: {
          valType: "string"
        },
        traces: {
          valType: "any"
        },
        baseframe: {
          valType: "string"
        },
        data: {
          valType: "any"
        },
        layout: {
          valType: "any"
        }
      };
    }, {}],
    303: [function (e, t, r) {
      "use strict";

      var n = e("../registry"),
        a = e("./cartesian/constants").SUBPLOT_PATTERN;
      r.getSubplotCalcData = function (e, t, r) {
        var a = n.subplotsRegistry[t];
        if (!a) return [];
        for (var i = a.attr, o = [], l = 0; l < e.length; l++) {
          var s = e[l];
          s[0].trace[i] === r && o.push(s);
        }
        return o;
      }, r.getModuleCalcData = function (e, t) {
        var r,
          a = [],
          i = [];
        if (!(r = "string" == typeof t ? n.getModule(t).plot : "function" == typeof t ? t : t.plot)) return [a, e];
        for (var o = 0; o < e.length; o++) {
          var l = e[o],
            s = l[0].trace;
          !0 === s.visible && 0 !== s._length && (s._module.plot === r ? a.push(l) : i.push(l));
        }
        return [a, i];
      }, r.getSubplotData = function (e, t, r) {
        if (!n.subplotsRegistry[t]) return [];
        var i,
          o,
          l,
          s = n.subplotsRegistry[t].attr,
          c = [];
        if ("gl2d" === t) {
          var u = r.match(a);
          o = "x" + u[1], l = "y" + u[2];
        }
        for (var d = 0; d < e.length; d++) i = e[d], "gl2d" === t && n.traceIs(i, "gl2d") ? i[s[0]] === o && i[s[1]] === l && c.push(i) : i[s] === r && c.push(i);
        return c;
      };
    }, {
      "../registry": 309,
      "./cartesian/constants": 279
    }],
    304: [function (e, t, r) {
      "use strict";

      function n(e, t) {
        var r,
          n,
          a = [0, 0, 0, 0];
        for (r = 0; r < 4; ++r) for (n = 0; n < 4; ++n) a[n] += e[4 * r + n] * t[r];
        return a;
      }
      t.exports = function (e, t) {
        return n(e.projection, n(e.view, n(e.model, [t[0], t[1], t[2], 1])));
      };
    }, {}],
    305: [function (e, t, r) {
      "use strict";

      var n = e("./font_attributes"),
        a = e("./animation_attributes"),
        i = e("../components/color/attributes"),
        o = e("../components/shapes/draw_newshape/attributes"),
        l = e("./pad_attributes"),
        s = e("../lib/extend").extendFlat,
        c = n({
          editType: "calc"
        });
      c.family.dflt = '"Open Sans", verdana, arial, sans-serif', c.size.dflt = 12, c.color.dflt = i.defaultLine, t.exports = {
        font: c,
        title: {
          text: {
            valType: "string",
            editType: "layoutstyle"
          },
          font: n({
            editType: "layoutstyle"
          }),
          xref: {
            valType: "enumerated",
            dflt: "container",
            values: ["container", "paper"],
            editType: "layoutstyle"
          },
          yref: {
            valType: "enumerated",
            dflt: "container",
            values: ["container", "paper"],
            editType: "layoutstyle"
          },
          x: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: .5,
            editType: "layoutstyle"
          },
          y: {
            valType: "number",
            min: 0,
            max: 1,
            dflt: "auto",
            editType: "layoutstyle"
          },
          xanchor: {
            valType: "enumerated",
            dflt: "auto",
            values: ["auto", "left", "center", "right"],
            editType: "layoutstyle"
          },
          yanchor: {
            valType: "enumerated",
            dflt: "auto",
            values: ["auto", "top", "middle", "bottom"],
            editType: "layoutstyle"
          },
          pad: s(l({
            editType: "layoutstyle"
          }), {}),
          editType: "layoutstyle"
        },
        uniformtext: {
          mode: {
            valType: "enumerated",
            values: [!1, "hide", "show"],
            dflt: !1,
            editType: "plot"
          },
          minsize: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "plot"
          },
          editType: "plot"
        },
        autosize: {
          valType: "boolean",
          dflt: !1,
          editType: "none"
        },
        width: {
          valType: "number",
          min: 10,
          dflt: 700,
          editType: "plot"
        },
        height: {
          valType: "number",
          min: 10,
          dflt: 450,
          editType: "plot"
        },
        margin: {
          l: {
            valType: "number",
            min: 0,
            dflt: 80,
            editType: "plot"
          },
          r: {
            valType: "number",
            min: 0,
            dflt: 80,
            editType: "plot"
          },
          t: {
            valType: "number",
            min: 0,
            dflt: 100,
            editType: "plot"
          },
          b: {
            valType: "number",
            min: 0,
            dflt: 80,
            editType: "plot"
          },
          pad: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "plot"
          },
          autoexpand: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          editType: "plot"
        },
        computed: {
          valType: "any",
          editType: "none"
        },
        paper_bgcolor: {
          valType: "color",
          dflt: i.background,
          editType: "plot"
        },
        plot_bgcolor: {
          valType: "color",
          dflt: i.background,
          editType: "layoutstyle"
        },
        autotypenumbers: {
          valType: "enumerated",
          values: ["convert types", "strict"],
          dflt: "convert types",
          editType: "calc"
        },
        separators: {
          valType: "string",
          editType: "plot"
        },
        hidesources: {
          valType: "boolean",
          dflt: !1,
          editType: "plot"
        },
        showlegend: {
          valType: "boolean",
          editType: "legend"
        },
        colorway: {
          valType: "colorlist",
          dflt: i.defaults,
          editType: "calc"
        },
        datarevision: {
          valType: "any",
          editType: "calc"
        },
        uirevision: {
          valType: "any",
          editType: "none"
        },
        editrevision: {
          valType: "any",
          editType: "none"
        },
        selectionrevision: {
          valType: "any",
          editType: "none"
        },
        template: {
          valType: "any",
          editType: "calc"
        },
        newshape: o.newshape,
        activeshape: o.activeshape,
        meta: {
          valType: "any",
          arrayOk: !0,
          editType: "plot"
        },
        transition: s({}, a.transition, {
          editType: "none"
        }),
        _deprecated: {
          title: {
            valType: "string",
            editType: "layoutstyle"
          },
          titlefont: n({
            editType: "layoutstyle"
          })
        }
      };
    }, {
      "../components/color/attributes": 95,
      "../components/shapes/draw_newshape/attributes": 181,
      "../lib/extend": 219,
      "./animation_attributes": 266,
      "./font_attributes": 301,
      "./pad_attributes": 306
    }],
    306: [function (e, t, r) {
      "use strict";

      t.exports = function (e) {
        var t = e.editType;
        return {
          t: {
            valType: "number",
            dflt: 0,
            editType: t
          },
          r: {
            valType: "number",
            dflt: 0,
            editType: t
          },
          b: {
            valType: "number",
            dflt: 0,
            editType: t
          },
          l: {
            valType: "number",
            dflt: 0,
            editType: t
          },
          editType: t
        };
      };
    }, {}],
    307: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("d3-time-format").timeFormatLocale,
        i = e("d3-format").formatLocale,
        o = e("fast-isnumeric"),
        l = e("../registry"),
        s = e("../plot_api/plot_schema"),
        c = e("../plot_api/plot_template"),
        u = e("../lib"),
        d = e("../components/color"),
        f = e("../constants/numerical").BADNUM,
        h = e("./cartesian/axis_ids"),
        p = e("./cartesian/handle_outline").clearSelect,
        g = e("./animation_attributes"),
        m = e("./frame_attributes"),
        y = e("../plots/get_data").getModuleCalcData,
        v = u.relinkPrivateKeys,
        x = u._,
        b = t.exports = {};
      u.extendFlat(b, l), b.attributes = e("./attributes"), b.attributes.type.values = b.allTypes, b.fontAttrs = e("./font_attributes"), b.layoutAttributes = e("./layout_attributes"), b.fontWeight = "normal";
      var _ = b.transformsRegistry,
        w = e("./command");
      b.executeAPICommand = w.executeAPICommand, b.computeAPICommandBindings = w.computeAPICommandBindings, b.manageCommandObserver = w.manageCommandObserver, b.hasSimpleAPICommandBindings = w.hasSimpleAPICommandBindings, b.redrawText = function (e) {
        return e = u.getGraphDiv(e), new Promise(function (t) {
          setTimeout(function () {
            e._fullLayout && (l.getComponentMethod("annotations", "draw")(e), l.getComponentMethod("legend", "draw")(e), l.getComponentMethod("colorbar", "draw")(e), t(b.previousPromises(e)));
          }, 300);
        });
      }, b.resize = function (e) {
        var t;
        e = u.getGraphDiv(e);
        var r = new Promise(function (r, n) {
          e && !u.isHidden(e) || n(new Error("Resize must be passed a displayed plot div element.")), e._redrawTimer && clearTimeout(e._redrawTimer), e._resolveResize && (t = e._resolveResize), e._resolveResize = r, e._redrawTimer = setTimeout(function () {
            if (!e.layout || e.layout.width && e.layout.height || u.isHidden(e)) r(e);else {
              delete e.layout.width, delete e.layout.height;
              var t = e.changed;
              e.autoplay = !0, l.call("relayout", e, {
                autosize: !0
              }).then(function () {
                e.changed = t, e._resolveResize === r && (delete e._resolveResize, r(e));
              });
            }
          }, 100);
        });
        return t && t(r), r;
      }, b.previousPromises = function (e) {
        if ((e._promises || []).length) return Promise.all(e._promises).then(function () {
          e._promises = [];
        });
      }, b.addLinks = function (e) {
        if (e._context.showLink || e._context.showSources) {
          var t = e._fullLayout,
            r = u.ensureSingle(t._paper, "text", "js-plot-link-container", function (e) {
              e.style({
                "font-family": '"Open Sans", Arial, sans-serif',
                "font-size": "12px",
                fill: d.defaultLine,
                "pointer-events": "all"
              }).each(function () {
                var e = n.select(this);
                e.append("tspan").classed("js-link-to-tool", !0), e.append("tspan").classed("js-link-spacer", !0), e.append("tspan").classed("js-sourcelinks", !0);
              });
            }),
            a = r.node(),
            i = {
              y: t._paper.attr("height") - 9
            };
          document.body.contains(a) && a.getComputedTextLength() >= t.width - 20 ? (i["text-anchor"] = "start", i.x = 5) : (i["text-anchor"] = "end", i.x = t._paper.attr("width") - 7), r.attr(i);
          var o = r.select(".js-link-to-tool"),
            l = r.select(".js-link-spacer"),
            s = r.select(".js-sourcelinks");
          e._context.showSources && e._context.showSources(e), e._context.showLink && function (e, t) {
            t.text("");
            var r = t.append("a").attr({
              "xlink:xlink:href": "#",
              class: "link--impt link--embedview",
              "font-weight": "bold"
            }).text(e._context.linkText + " " + String.fromCharCode(187));
            if (e._context.sendData) r.on("click", function () {
              b.sendDataToCloud(e);
            });else {
              var n = window.location.pathname.split("/"),
                a = window.location.search;
              r.attr({
                "xlink:xlink:show": "new",
                "xlink:xlink:href": "/" + n[2].split(".")[0] + "/" + n[1] + a
              });
            }
          }(e, o), l.text(o.text() && s.text() ? " - " : "");
        }
      }, b.sendDataToCloud = function (e) {
        var t = (window.PLOTLYENV || {}).BASE_URL || e._context.plotlyServerURL;
        if (t) {
          e.emit("plotly_beforeexport");
          var r = n.select(e).append("div").attr("id", "hiddenform").style("display", "none"),
            a = r.append("form").attr({
              action: t + "/external",
              method: "post",
              target: "_blank"
            });
          return a.append("input").attr({
            type: "text",
            name: "data"
          }).node().value = b.graphJson(e, !1, "keepdata"), a.node().submit(), r.remove(), e.emit("plotly_afterexport"), !1;
        }
      };
      var M = ["days", "shortDays", "months", "shortMonths", "periods", "dateTime", "date", "time", "decimal", "thousands", "grouping", "currency"],
        T = ["year", "month", "dayMonth", "dayMonthYear"];
      function k(e, t) {
        var r = e._context.locale;
        r || (r = "en-US");
        var n = !1,
          a = {};
        function i(e) {
          for (var r = !0, i = 0; i < t.length; i++) {
            var o = t[i];
            a[o] || (e[o] ? a[o] = e[o] : r = !1);
          }
          r && (n = !0);
        }
        for (var o = 0; o < 2; o++) {
          for (var s = e._context.locales, c = 0; c < 2; c++) {
            var u = (s[r] || {}).format;
            if (u && (i(u), n)) break;
            s = l.localeRegistry;
          }
          var d = r.split("-")[0];
          if (n || d === r) break;
          r = d;
        }
        return n || i(l.localeRegistry.en.format), a;
      }
      function A(e, t) {
        var r = {
            _fullLayout: t
          },
          n = "x" === e._id.charAt(0),
          a = e._mainAxis._anchorAxis,
          i = "",
          o = "",
          l = "";
        if (a && (l = a._mainAxis._id, i = n ? e._id + l : l + e._id), !i || !t._plots[i]) {
          i = "";
          for (var s = e._counterAxes, c = 0; c < s.length; c++) {
            var u = s[c],
              d = n ? e._id + u : u + e._id;
            o || (o = d);
            var f = h.getFromId(r, u);
            if (l && f.overlaying === l) {
              i = d;
              break;
            }
          }
        }
        return i || o;
      }
      function L(e) {
        var t = e.transforms;
        if (Array.isArray(t) && t.length) for (var r = 0; r < t.length; r++) {
          var n = t[r],
            a = n._module || _[n.type];
          if (a && a.makesData) return !0;
        }
        return !1;
      }
      function D(e, t, r, n) {
        for (var a = e.transforms, i = [e], o = 0; o < a.length; o++) {
          var l = a[o],
            s = _[l.type];
          s && s.transform && (i = s.transform(i, {
            transform: l,
            fullTrace: e,
            fullData: t,
            layout: r,
            fullLayout: n,
            transformIndex: o
          }));
        }
        return i;
      }
      function S(e) {
        return "string" == typeof e && "px" === e.substr(e.length - 2) && parseFloat(e);
      }
      function C(e) {
        var t = e.margin;
        if (!e._size) {
          var r = e._size = {
            l: Math.round(t.l),
            r: Math.round(t.r),
            t: Math.round(t.t),
            b: Math.round(t.b),
            p: Math.round(t.pad)
          };
          r.w = Math.round(e.width) - r.l - r.r, r.h = Math.round(e.height) - r.t - r.b;
        }
        e._pushmargin || (e._pushmargin = {}), e._pushmarginIds || (e._pushmarginIds = {});
      }
      b.supplyDefaults = function (e, t) {
        var r = t && t.skipUpdateCalc,
          n = e._fullLayout || {};
        if (n._skipDefaults) delete n._skipDefaults;else {
          var o,
            s = e._fullLayout = {},
            c = e.layout || {},
            d = e._fullData || [],
            f = e._fullData = [],
            h = e.data || [],
            g = e.calcdata || [],
            m = e._context || {};
          e._transitionData || b.createTransitionData(e), s._dfltTitle = {
            plot: x(e, "Click to enter Plot title"),
            x: x(e, "Click to enter X axis title"),
            y: x(e, "Click to enter Y axis title"),
            colorbar: x(e, "Click to enter Colorscale title"),
            annotation: x(e, "new text")
          }, s._traceWord = x(e, "trace");
          var y = k(e, M);
          if (s._mapboxAccessToken = m.mapboxAccessToken, n._initialAutoSizeIsDone) {
            var _ = n.width,
              w = n.height;
            b.supplyLayoutGlobalDefaults(c, s, y), c.width || (s.width = _), c.height || (s.height = w), b.sanitizeMargins(s);
          } else {
            b.supplyLayoutGlobalDefaults(c, s, y);
            var A = !c.width || !c.height,
              L = s.autosize,
              D = m.autosizable;
            A && (L || D) ? b.plotAutoSize(e, c, s) : A && b.sanitizeMargins(s), !L && A && (c.width = s.width, c.height = s.height);
          }
          s._d3locale = function (e, t) {
            return e.decimal = t.charAt(0), e.thousands = t.charAt(1), {
              numberFormat: function numberFormat(t) {
                try {
                  t = i(e).format(u.adjustFormat(t));
                } catch (e) {
                  return u.warnBadFormat(t), u.noFormat;
                }
                return t;
              },
              timeFormat: a(e).utcFormat
            };
          }(y, s.separators), s._extraFormat = k(e, T), s._initialAutoSizeIsDone = !0, s._dataLength = h.length, s._modules = [], s._visibleModules = [], s._basePlotModules = [];
          var S = s._subplots = function () {
              var e,
                t,
                r = l.collectableSubplotTypes,
                n = {};
              if (!r) {
                r = [];
                var a = l.subplotsRegistry;
                for (var i in a) {
                  var o = a[i].attr;
                  if (o && (r.push(i), Array.isArray(o))) for (t = 0; t < o.length; t++) u.pushUnique(r, o[t]);
                }
              }
              for (e = 0; e < r.length; e++) n[r[e]] = [];
              return n;
            }(),
            O = s._splomAxes = {
              x: {},
              y: {}
            },
            P = s._splomSubplots = {};
          s._splomGridDflt = {}, s._scatterStackOpts = {}, s._firstScatter = {}, s._alignmentOpts = {}, s._colorAxes = {}, s._requestRangeslider = {}, s._traceUids = function (e, t) {
            var r,
              n,
              a = t.length,
              i = [];
            for (r = 0; r < e.length; r++) {
              var o = e[r]._fullInput;
              o !== n && i.push(o), n = o;
            }
            var l = i.length,
              s = new Array(a),
              c = {};
            function d(e, t) {
              s[t] = e, c[e] = 1;
            }
            function f(e, t) {
              if (e && "string" == typeof e && !c[e]) return d(e, t), !0;
            }
            for (r = 0; r < a; r++) {
              var h = t[r].uid;
              "number" == typeof h && (h = String(h)), f(h, r) || r < l && f(i[r].uid, r) || d(u.randstr(c), r);
            }
            return s;
          }(d, h), s._globalTransforms = (e._context || {}).globalTransforms, b.supplyDataDefaults(h, f, c, s);
          var I = Object.keys(O.x),
            z = Object.keys(O.y);
          if (I.length > 1 && z.length > 1) {
            for (l.getComponentMethod("grid", "sizeDefaults")(c, s), o = 0; o < I.length; o++) u.pushUnique(S.xaxis, I[o]);
            for (o = 0; o < z.length; o++) u.pushUnique(S.yaxis, z[o]);
            for (var R in P) u.pushUnique(S.cartesian, R);
          }
          if (s._has = b._hasPlotType.bind(s), d.length === f.length) for (o = 0; o < f.length; o++) v(f[o], d[o]);
          b.supplyLayoutModuleDefaults(c, s, f, e._transitionData);
          var N = s._visibleModules,
            F = [];
          for (o = 0; o < N.length; o++) {
            var E = N[o].crossTraceDefaults;
            E && u.pushUnique(F, E);
          }
          for (o = 0; o < F.length; o++) F[o](f, s);
          s._hasOnlyLargeSploms = 1 === s._basePlotModules.length && "splom" === s._basePlotModules[0].name && I.length > 15 && z.length > 15 && 0 === s.shapes.length && 0 === s.images.length, b.linkSubplots(f, s, d, n), b.cleanPlot(f, s, d, n);
          var j = !(!n._has || !n._has("gl2d")),
            H = !(!s._has || !s._has("gl2d")),
            B = !(!n._has || !n._has("cartesian")) || j,
            Y = !(!s._has || !s._has("cartesian")) || H;
          B && !Y ? n._bgLayer.remove() : Y && !B && (s._shouldCreateBgLayer = !0), n._zoomlayer && !e._dragging && p({
            _fullLayout: n
          }), function (e, t) {
            var r,
              n = [];
            t.meta && (r = t._meta = {
              meta: t.meta,
              layout: {
                meta: t.meta
              }
            });
            for (var a = 0; a < e.length; a++) {
              var i = e[a];
              i.meta ? n[i.index] = i._meta = {
                meta: i.meta
              } : t.meta && (i._meta = {
                meta: t.meta
              }), t.meta && (i._meta.layout = {
                meta: t.meta
              });
            }
            n.length && (r || (r = t._meta = {}), r.data = n);
          }(f, s), v(s, n), l.getComponentMethod("colorscale", "crossTraceDefaults")(f, s), s._preGUI || (s._preGUI = {}), s._tracePreGUI || (s._tracePreGUI = {});
          var U,
            V = s._tracePreGUI,
            q = {};
          for (U in V) q[U] = "old";
          for (o = 0; o < f.length; o++) q[U = f[o]._fullInput.uid] || (V[U] = {}), q[U] = "new";
          for (U in q) "old" === q[U] && delete V[U];
          C(s), l.getComponentMethod("rangeslider", "makeData")(s), r || g.length !== f.length || b.supplyDefaultsUpdateCalc(g, f);
        }
      }, b.supplyDefaultsUpdateCalc = function (e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r],
            a = (e[r] || [])[0];
          if (a && a.trace) {
            var i = a.trace;
            if (i._hasCalcTransform) {
              var o,
                l,
                s,
                c = i._arrayAttrs;
              for (o = 0; o < c.length; o++) l = c[o], s = u.nestedProperty(i, l).get().slice(), u.nestedProperty(n, l).set(s);
            }
            a.trace = n;
          }
        }
      }, b.createTransitionData = function (e) {
        e._transitionData || (e._transitionData = {}), e._transitionData._frames || (e._transitionData._frames = []), e._transitionData._frameHash || (e._transitionData._frameHash = {}), e._transitionData._counter || (e._transitionData._counter = 0), e._transitionData._interruptCallbacks || (e._transitionData._interruptCallbacks = []);
      }, b._hasPlotType = function (e) {
        var t,
          r = this._basePlotModules || [];
        for (t = 0; t < r.length; t++) if (r[t].name === e) return !0;
        var n = this._modules || [];
        for (t = 0; t < n.length; t++) {
          var a = n[t].name;
          if (a === e) return !0;
          var i = l.modules[a];
          if (i && i.categories[e]) return !0;
        }
        return !1;
      }, b.cleanPlot = function (e, t, r, n) {
        var a,
          i,
          o = n._basePlotModules || [];
        for (a = 0; a < o.length; a++) {
          var l = o[a];
          l.clean && l.clean(e, t, r, n);
        }
        var s = n._has && n._has("gl"),
          c = t._has && t._has("gl");
        s && !c && void 0 !== n._glcontainer && (n._glcontainer.selectAll(".gl-canvas").remove(), n._glcontainer.selectAll(".no-webgl").remove(), n._glcanvas = null);
        var u = !!n._infolayer;
        e: for (a = 0; a < r.length; a++) {
          var d = r[a].uid;
          for (i = 0; i < e.length; i++) {
            if (d === e[i].uid) continue e;
          }
          u && n._infolayer.select(".cb" + d).remove();
        }
      }, b.linkSubplots = function (e, t, r, n) {
        var a,
          i,
          o = n._plots || {},
          s = t._plots = {},
          c = t._subplots,
          d = {
            _fullData: e,
            _fullLayout: t
          },
          f = c.cartesian.concat(c.gl2d || []);
        for (a = 0; a < f.length; a++) {
          var p,
            g = f[a],
            m = o[g],
            y = h.getFromId(d, g, "x"),
            v = h.getFromId(d, g, "y");
          for (m ? p = s[g] = m : (p = s[g] = {}).id = g, y._counterAxes.push(v._id), v._counterAxes.push(y._id), y._subplotsWith.push(g), v._subplotsWith.push(g), p.xaxis = y, p.yaxis = v, p._hasClipOnAxisFalse = !1, i = 0; i < e.length; i++) {
            var x = e[i];
            if (x.xaxis === p.xaxis._id && x.yaxis === p.yaxis._id && !1 === x.cliponaxis) {
              p._hasClipOnAxisFalse = !0;
              break;
            }
          }
        }
        var b,
          _ = h.list(d, null, !0);
        for (a = 0; a < _.length; a++) {
          var w = null;
          (b = _[a]).overlaying && (w = h.getFromId(d, b.overlaying)) && w.overlaying && (b.overlaying = !1, w = null), b._mainAxis = w || b, w && (b.domain = w.domain.slice()), b._anchorAxis = "free" === b.anchor ? null : h.getFromId(d, b.anchor);
        }
        for (a = 0; a < _.length; a++) if ((b = _[a])._counterAxes.sort(h.idSort), b._subplotsWith.sort(u.subplotSort), b._mainSubplot = A(b, t), b._counterAxes.length && (b.spikemode && -1 !== b.spikemode.indexOf("across") || b.automargin && b.mirror && "free" !== b.anchor || l.getComponentMethod("rangeslider", "isVisible")(b))) {
          var M = 1,
            T = 0;
          for (i = 0; i < b._counterAxes.length; i++) {
            var k = h.getFromId(d, b._counterAxes[i]);
            M = Math.min(M, k.domain[0]), T = Math.max(T, k.domain[1]);
          }
          M < T && (b._counterDomainMin = M, b._counterDomainMax = T);
        }
      }, b.clearExpandedTraceDefaultColors = function (e) {
        var t, r, n;
        for (r = [], (t = e._module._colorAttrs) || (e._module._colorAttrs = t = [], s.crawl(e._module.attributes, function (e, n, a, i) {
          r[i] = n, r.length = i + 1, "color" === e.valType && void 0 === e.dflt && t.push(r.join("."));
        })), n = 0; n < t.length; n++) {
          u.nestedProperty(e, "_input." + t[n]).get() || u.nestedProperty(e, t[n]).set(null);
        }
      }, b.supplyDataDefaults = function (e, t, r, n) {
        var a,
          i,
          o,
          s = n._modules,
          d = n._visibleModules,
          f = n._basePlotModules,
          h = 0,
          p = 0;
        function g(e) {
          t.push(e);
          var r = e._module;
          r && (u.pushUnique(s, r), !0 === e.visible && u.pushUnique(d, r), u.pushUnique(f, e._module.basePlotModule), h++, !1 !== e._input.visible && p++);
        }
        n._transformModules = [];
        var m = {},
          y = [],
          x = (r.template || {}).data || {},
          _ = c.traceTemplater(x);
        for (a = 0; a < e.length; a++) {
          if (o = e[a], (i = _.newTrace(o)).uid = n._traceUids[a], b.supplyTraceDefaults(o, i, p, n, a), i.index = a, i._input = o, i._expandedIndex = h, i.transforms && i.transforms.length) for (var w = !1 !== o.visible && !1 === i.visible, M = D(i, t, r, n), T = 0; T < M.length; T++) {
            var k = M[T],
              A = {
                _template: i._template,
                type: i.type,
                uid: i.uid + T
              };
            w && !1 === k.visible && delete k.visible, b.supplyTraceDefaults(k, A, h, n, a), v(A, k), A.index = a, A._input = o, A._fullInput = i, A._expandedIndex = h, A._expandedInput = k, g(A);
          } else i._fullInput = i, i._expandedInput = i, g(i);
          l.traceIs(i, "carpetAxis") && (m[i.carpet] = i), l.traceIs(i, "carpetDependent") && y.push(a);
        }
        for (a = 0; a < y.length; a++) if ((i = t[y[a]]).visible) {
          var L = m[i.carpet];
          i._carpet = L, L && L.visible ? (i.xaxis = L.xaxis, i.yaxis = L.yaxis) : i.visible = !1;
        }
      }, b.supplyAnimationDefaults = function (e) {
        var t;
        e = e || {};
        var r = {};
        function n(t, n) {
          return u.coerce(e || {}, r, g, t, n);
        }
        if (n("mode"), n("direction"), n("fromcurrent"), Array.isArray(e.frame)) for (r.frame = [], t = 0; t < e.frame.length; t++) r.frame[t] = b.supplyAnimationFrameDefaults(e.frame[t] || {});else r.frame = b.supplyAnimationFrameDefaults(e.frame || {});
        if (Array.isArray(e.transition)) for (r.transition = [], t = 0; t < e.transition.length; t++) r.transition[t] = b.supplyAnimationTransitionDefaults(e.transition[t] || {});else r.transition = b.supplyAnimationTransitionDefaults(e.transition || {});
        return r;
      }, b.supplyAnimationFrameDefaults = function (e) {
        var t = {};
        function r(r, n) {
          return u.coerce(e || {}, t, g.frame, r, n);
        }
        return r("duration"), r("redraw"), t;
      }, b.supplyAnimationTransitionDefaults = function (e) {
        var t = {};
        function r(r, n) {
          return u.coerce(e || {}, t, g.transition, r, n);
        }
        return r("duration"), r("easing"), t;
      }, b.supplyFrameDefaults = function (e) {
        var t = {};
        function r(r, n) {
          return u.coerce(e, t, m, r, n);
        }
        return r("group"), r("name"), r("traces"), r("baseframe"), r("data"), r("layout"), t;
      }, b.supplyTraceDefaults = function (e, t, r, n, a) {
        var i,
          o = n.colorway || d.defaults,
          s = o[r % o.length];
        function c(r, n) {
          return u.coerce(e, t, b.attributes, r, n);
        }
        var f = c("visible");
        c("type"), c("name", n._traceWord + " " + a), c("uirevision", n.uirevision);
        var h = b.getModule(t);
        if (t._module = h, h) {
          var p = h.basePlotModule,
            g = p.attr,
            m = p.attributes;
          if (g && m) {
            var y = n._subplots,
              v = "";
            if (f || "gl2d" !== p.name) {
              if (Array.isArray(g)) for (i = 0; i < g.length; i++) {
                var x = g[i],
                  _ = u.coerce(e, t, m, x);
                y[x] && u.pushUnique(y[x], _), v += _;
              } else v = u.coerce(e, t, m, g);
              y[p.name] && u.pushUnique(y[p.name], v);
            }
          }
        }
        if (f) {
          if (c("customdata"), c("ids"), c("meta"), l.traceIs(t, "showLegend")) u.coerce(e, t, h.attributes.showlegend ? h.attributes : b.attributes, "showlegend"), c("legendgroup"), c("legendgrouptitle.text") && u.coerceFont(c, "legendgrouptitle.font", u.extendFlat({}, n.font, {
            size: Math.round(1.1 * n.font.size)
          })), c("legendrank"), t._dfltShowLegend = !0;else t._dfltShowLegend = !1;
          h && h.supplyDefaults(e, t, s, n), l.traceIs(t, "noOpacity") || c("opacity"), l.traceIs(t, "notLegendIsolatable") && (t.visible = !!t.visible), l.traceIs(t, "noHover") || (t.hovertemplate || u.coerceHoverinfo(e, t, n), "parcats" !== t.type && l.getComponentMethod("fx", "supplyDefaults")(e, t, s, n)), h && h.selectPoints && c("selectedpoints"), b.supplyTransformDefaults(e, t, n);
        }
        return t;
      }, b.hasMakesDataTransform = L, b.supplyTransformDefaults = function (e, t, r) {
        if (t._length || L(e)) {
          var n = r._globalTransforms || [],
            a = r._transformModules || [];
          if (Array.isArray(e.transforms) || 0 !== n.length) for (var i = e.transforms || [], o = n.concat(i), l = t.transforms = [], s = 0; s < o.length; s++) {
            var c,
              d = o[s],
              f = d.type,
              h = _[f],
              p = !(d._module && d._module === h),
              g = h && "function" == typeof h.transform;
            h || u.warn("Unrecognized transform type " + f + "."), h && h.supplyDefaults && (p || g) ? ((c = h.supplyDefaults(d, t, r, e)).type = f, c._module = h, u.pushUnique(a, h)) : c = u.extendFlat({}, d), l.push(c);
          }
        }
      }, b.supplyLayoutGlobalDefaults = function (e, t, r) {
        function n(r, n) {
          return u.coerce(e, t, b.layoutAttributes, r, n);
        }
        var a = e.template;
        u.isPlainObject(a) && (t.template = a, t._template = a.layout, t._dataTemplate = a.data), n("autotypenumbers");
        var i = u.coerceFont(n, "font");
        n("title.text", t._dfltTitle.plot), u.coerceFont(n, "title.font", {
          family: i.family,
          size: Math.round(1.4 * i.size),
          color: i.color
        }), n("title.xref"), n("title.yref"), n("title.x"), n("title.y"), n("title.xanchor"), n("title.yanchor"), n("title.pad.t"), n("title.pad.r"), n("title.pad.b"), n("title.pad.l"), n("uniformtext.mode") && n("uniformtext.minsize"), n("autosize", !(e.width && e.height)), n("width"), n("height"), n("margin.l"), n("margin.r"), n("margin.t"), n("margin.b"), n("margin.pad"), n("margin.autoexpand"), e.width && e.height && b.sanitizeMargins(t), l.getComponentMethod("grid", "sizeDefaults")(e, t), n("paper_bgcolor"), n("separators", r.decimal + r.thousands), n("hidesources"), n("colorway"), n("datarevision");
        var o = n("uirevision");
        n("editrevision", o), n("selectionrevision", o), l.getComponentMethod("modebar", "supplyLayoutDefaults")(e, t), l.getComponentMethod("shapes", "supplyDrawNewShapeDefaults")(e, t, n), n("meta"), u.isPlainObject(e.transition) && (n("transition.duration"), n("transition.easing"), n("transition.ordering")), l.getComponentMethod("calendars", "handleDefaults")(e, t, "calendar"), l.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(e, t, n);
      }, b.plotAutoSize = function (e, t, r) {
        var n,
          a,
          i = e._context || {},
          l = i.frameMargins,
          s = u.isPlotDiv(e);
        if (s && e.emit("plotly_autosize"), i.fillFrame) n = window.innerWidth, a = window.innerHeight, document.body.style.overflow = "hidden";else {
          var c = s ? window.getComputedStyle(e) : {};
          if (n = S(c.width) || S(c.maxWidth) || r.width, a = S(c.height) || S(c.maxHeight) || r.height, o(l) && l > 0) {
            var d = 1 - 2 * l;
            n = Math.round(d * n), a = Math.round(d * a);
          }
        }
        var f = b.layoutAttributes.width.min,
          h = b.layoutAttributes.height.min;
        n < f && (n = f), a < h && (a = h);
        var p = !t.width && Math.abs(r.width - n) > 1,
          g = !t.height && Math.abs(r.height - a) > 1;
        (g || p) && (p && (r.width = n), g && (r.height = a)), e._initialAutoSize || (e._initialAutoSize = {
          width: n,
          height: a
        }), b.sanitizeMargins(r);
      }, b.supplyLayoutModuleDefaults = function (e, t, r, n) {
        var a,
          i,
          o,
          s = l.componentsRegistry,
          c = t._basePlotModules,
          d = l.subplotsRegistry.cartesian;
        for (a in s) (o = s[a]).includeBasePlot && o.includeBasePlot(e, t);
        for (var f in c.length || c.push(d), t._has("cartesian") && (l.getComponentMethod("grid", "contentDefaults")(e, t), d.finalizeSubplots(e, t)), t._subplots) t._subplots[f].sort(u.subplotSort);
        for (i = 0; i < c.length; i++) (o = c[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r);
        var h = t._modules;
        for (i = 0; i < h.length; i++) (o = h[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r);
        var p = t._transformModules;
        for (i = 0; i < p.length; i++) (o = p[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r, n);
        for (a in s) (o = s[a]).supplyLayoutDefaults && o.supplyLayoutDefaults(e, t, r);
      }, b.purge = function (e) {
        var t = e._fullLayout || {};
        void 0 !== t._glcontainer && (t._glcontainer.selectAll(".gl-canvas").remove(), t._glcontainer.remove(), t._glcanvas = null), t._modeBar && t._modeBar.destroy(), e._transitionData && (e._transitionData._interruptCallbacks && (e._transitionData._interruptCallbacks.length = 0), e._transitionData._animationRaf && window.cancelAnimationFrame(e._transitionData._animationRaf)), u.clearThrottle(), u.clearResponsive(e), delete e.data, delete e.layout, delete e._fullData, delete e._fullLayout, delete e.calcdata, delete e.empty, delete e.fid, delete e.undoqueue, delete e.undonum, delete e.autoplay, delete e.changed, delete e._promises, delete e._redrawTimer, delete e._hmlumcount, delete e._hmpixcount, delete e._transitionData, delete e._transitioning, delete e._initialAutoSize, delete e._transitioningWithDuration, delete e._dragging, delete e._dragged, delete e._dragdata, delete e._hoverdata, delete e._snapshotInProgress, delete e._editing, delete e._mouseDownTime, delete e._legendMouseDownTime, e.removeAllListeners && e.removeAllListeners();
      }, b.style = function (e) {
        var t,
          r = e._fullLayout._visibleModules,
          n = [];
        for (t = 0; t < r.length; t++) {
          var a = r[t];
          a.style && u.pushUnique(n, a.style);
        }
        for (t = 0; t < n.length; t++) n[t](e);
      }, b.sanitizeMargins = function (e) {
        if (e && e.margin) {
          var t,
            r = e.width,
            n = e.height,
            a = e.margin,
            i = r - (a.l + a.r),
            o = n - (a.t + a.b);
          i < 0 && (t = (r - 1) / (a.l + a.r), a.l = Math.floor(t * a.l), a.r = Math.floor(t * a.r)), o < 0 && (t = (n - 1) / (a.t + a.b), a.t = Math.floor(t * a.t), a.b = Math.floor(t * a.b));
        }
      }, b.clearAutoMarginIds = function (e) {
        e._fullLayout._pushmarginIds = {};
      }, b.allowAutoMargin = function (e, t) {
        e._fullLayout._pushmarginIds[t] = 1;
      };
      b.autoMargin = function (e, t, r) {
        var n = e._fullLayout,
          a = n.width,
          i = n.height,
          o = n.margin,
          l = u.constrain(a - o.l - o.r, 2, 64),
          s = u.constrain(i - o.t - o.b, 2, 64),
          c = Math.max(0, a - l),
          d = Math.max(0, i - s),
          f = n._pushmargin,
          h = n._pushmarginIds;
        if (!1 !== o.autoexpand) {
          if (r) {
            var p = r.pad;
            if (void 0 === p && (p = Math.min(12, o.l, o.r, o.t, o.b)), c) {
              var g = (r.l + r.r) / c;
              g > 1 && (r.l /= g, r.r /= g);
            }
            if (d) {
              var m = (r.t + r.b) / d;
              m > 1 && (r.t /= m, r.b /= m);
            }
            var y = void 0 !== r.xl ? r.xl : r.x,
              v = void 0 !== r.xr ? r.xr : r.x,
              x = void 0 !== r.yt ? r.yt : r.y,
              _ = void 0 !== r.yb ? r.yb : r.y;
            f[t] = {
              l: {
                val: y,
                size: r.l + p
              },
              r: {
                val: v,
                size: r.r + p
              },
              b: {
                val: _,
                size: r.b + p
              },
              t: {
                val: x,
                size: r.t + p
              }
            }, h[t] = 1;
          } else delete f[t], delete h[t];
          if (!n._replotting) return b.doAutoMargin(e);
        }
      }, b.doAutoMargin = function (e) {
        var t = e._fullLayout,
          r = t.width,
          n = t.height;
        t._size || (t._size = {}), C(t);
        var a = t._size,
          i = t.margin,
          s = u.extendFlat({}, a),
          c = i.l,
          d = i.r,
          f = i.t,
          p = i.b,
          g = t._pushmargin,
          m = t._pushmarginIds;
        if (!1 !== t.margin.autoexpand) {
          for (var y in g) m[y] || delete g[y];
          for (var v in g.base = {
            l: {
              val: 0,
              size: c
            },
            r: {
              val: 1,
              size: d
            },
            t: {
              val: 1,
              size: f
            },
            b: {
              val: 0,
              size: p
            }
          }, g) {
            var x = g[v].l || {},
              _ = g[v].b || {},
              w = x.val,
              M = x.size,
              T = _.val,
              k = _.size;
            for (var A in g) {
              if (o(M) && g[A].r) {
                var L = g[A].r.val,
                  D = g[A].r.size;
                if (L > w) {
                  var S = (M * L + (D - r) * w) / (L - w),
                    O = (D * (1 - w) + (M - r) * (1 - L)) / (L - w);
                  S + O > c + d && (c = S, d = O);
                }
              }
              if (o(k) && g[A].t) {
                var P = g[A].t.val,
                  I = g[A].t.size;
                if (P > T) {
                  var z = (k * P + (I - n) * T) / (P - T),
                    R = (I * (1 - T) + (k - n) * (1 - P)) / (P - T);
                  z + R > p + f && (p = z, f = R);
                }
              }
            }
          }
        }
        var N = u.constrain(r - i.l - i.r, 2, 64),
          F = u.constrain(n - i.t - i.b, 2, 64),
          E = Math.max(0, r - N),
          j = Math.max(0, n - F);
        if (E) {
          var H = (c + d) / E;
          H > 1 && (c /= H, d /= H);
        }
        if (j) {
          var B = (p + f) / j;
          B > 1 && (p /= B, f /= B);
        }
        if (a.l = Math.round(c), a.r = Math.round(d), a.t = Math.round(f), a.b = Math.round(p), a.p = Math.round(i.pad), a.w = Math.round(r) - a.l - a.r, a.h = Math.round(n) - a.t - a.b, !t._replotting && b.didMarginChange(s, a)) {
          "_redrawFromAutoMarginCount" in t ? t._redrawFromAutoMarginCount++ : t._redrawFromAutoMarginCount = 1;
          var Y = 3 * (1 + Object.keys(m).length);
          if (t._redrawFromAutoMarginCount < Y) return l.call("_doPlot", e);
          t._size = s, u.warn("Too many auto-margin redraws.");
        }
        !function (e) {
          var t = h.list(e, "", !0);
          ["_adjustTickLabelsOverflow", "_hideCounterAxisInsideTickLabels"].forEach(function (e) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r][e];
              n && n();
            }
          });
        }(e);
      };
      var O = ["l", "r", "t", "b", "p", "w", "h"];
      function P(e, t, r) {
        var n = !1;
        var a = [b.previousPromises, function () {
            if (e._transitionData) return e._transitioning = !1, function (e) {
              var t = Promise.resolve();
              if (!e) return t;
              for (; e.length;) t = t.then(e.shift());
              return t;
            }(e._transitionData._interruptCallbacks);
          }, r.prepareFn, b.rehover, function () {
            return e.emit("plotly_transitioning", []), new Promise(function (a) {
              e._transitioning = !0, t.duration > 0 && (e._transitioningWithDuration = !0), e._transitionData._interruptCallbacks.push(function () {
                n = !0;
              }), r.redraw && e._transitionData._interruptCallbacks.push(function () {
                return l.call("redraw", e);
              }), e._transitionData._interruptCallbacks.push(function () {
                e.emit("plotly_transitioninterrupted", []);
              });
              var i = 0,
                o = 0;
              function s() {
                return i++, function () {
                  o++, n || o !== i || function (t) {
                    if (!e._transitionData) return;
                    (function (e) {
                      if (e) for (; e.length;) e.shift();
                    })(e._transitionData._interruptCallbacks), Promise.resolve().then(function () {
                      if (r.redraw) return l.call("redraw", e);
                    }).then(function () {
                      e._transitioning = !1, e._transitioningWithDuration = !1, e.emit("plotly_transitioned", []);
                    }).then(t);
                  }(a);
                };
              }
              r.runFn(s), setTimeout(s());
            });
          }],
          i = u.syncOrAsync(a, e);
        return i && i.then || (i = Promise.resolve()), i.then(function () {
          return e;
        });
      }
      b.didMarginChange = function (e, t) {
        for (var r = 0; r < O.length; r++) {
          var n = O[r],
            a = e[n],
            i = t[n];
          if (!o(a) || Math.abs(i - a) > 1) return !0;
        }
        return !1;
      }, b.graphJson = function (e, t, r, n, a, i) {
        (a && t && !e._fullData || a && !t && !e._fullLayout) && b.supplyDefaults(e);
        var o = a ? e._fullData : e.data,
          l = a ? e._fullLayout : e.layout,
          s = (e._transitionData || {})._frames;
        function c(e, t) {
          if ("function" == typeof e) return t ? "_function_" : null;
          if (u.isPlainObject(e)) {
            var n,
              a = {};
            return Object.keys(e).sort().forEach(function (i) {
              if (-1 === ["_", "["].indexOf(i.charAt(0))) if ("function" != typeof e[i]) {
                if ("keepdata" === r) {
                  if ("src" === i.substr(i.length - 3)) return;
                } else if ("keepstream" === r) {
                  if ("string" == typeof (n = e[i + "src"]) && n.indexOf(":") > 0 && !u.isPlainObject(e.stream)) return;
                } else if ("keepall" !== r && "string" == typeof (n = e[i + "src"]) && n.indexOf(":") > 0) return;
                a[i] = c(e[i], t);
              } else t && (a[i] = "_function");
            }), a;
          }
          return Array.isArray(e) ? e.map(function (e) {
            return c(e, t);
          }) : u.isTypedArray(e) ? u.simpleMap(e, u.identity) : u.isJSDate(e) ? u.ms2DateTimeLocal(+e) : e;
        }
        var d = {
          data: (o || []).map(function (e) {
            var r = c(e);
            return t && delete r.fit, r;
          })
        };
        if (!t && (d.layout = c(l), a)) {
          var f = l._size;
          d.layout.computed = {
            margin: {
              b: f.b,
              l: f.l,
              r: f.r,
              t: f.t
            }
          };
        }
        return s && (d.frames = c(s)), i && (d.config = c(e._context, !0)), "object" === n ? d : JSON.stringify(d);
      }, b.modifyFrames = function (e, t) {
        var r,
          n,
          a,
          i = e._transitionData._frames,
          o = e._transitionData._frameHash;
        for (r = 0; r < t.length; r++) switch ((n = t[r]).type) {
          case "replace":
            a = n.value;
            var l = (i[n.index] || {}).name,
              s = a.name;
            i[n.index] = o[s] = a, s !== l && (delete o[l], o[s] = a);
            break;
          case "insert":
            o[(a = n.value).name] = a, i.splice(n.index, 0, a);
            break;
          case "delete":
            delete o[(a = i[n.index]).name], i.splice(n.index, 1);
        }
        return Promise.resolve();
      }, b.computeFrame = function (e, t) {
        var r,
          n,
          a,
          i,
          o = e._transitionData._frameHash;
        if (!t) throw new Error("computeFrame must be given a string frame name");
        var l = o[t.toString()];
        if (!l) return !1;
        for (var s = [l], c = [l.name]; l.baseframe && (l = o[l.baseframe.toString()]) && -1 === c.indexOf(l.name);) s.push(l), c.push(l.name);
        for (var u = {}; l = s.pop();) if (l.layout && (u.layout = b.extendLayout(u.layout, l.layout)), l.data) {
          if (u.data || (u.data = []), !(n = l.traces)) for (n = [], r = 0; r < l.data.length; r++) n[r] = r;
          for (u.traces || (u.traces = []), r = 0; r < l.data.length; r++) null != (a = n[r]) && (-1 === (i = u.traces.indexOf(a)) && (i = u.data.length, u.traces[i] = a), u.data[i] = b.extendTrace(u.data[i], l.data[r]));
        }
        return u;
      }, b.recomputeFrameHash = function (e) {
        for (var t = e._transitionData._frameHash = {}, r = e._transitionData._frames, n = 0; n < r.length; n++) {
          var a = r[n];
          a && a.name && (t[a.name] = a);
        }
      }, b.extendObjectWithContainers = function (e, t, r) {
        var n,
          a,
          i,
          o,
          l,
          s,
          c,
          d = u.extendDeepNoArrays({}, t || {}),
          f = u.expandObjectPaths(d),
          h = {};
        if (r && r.length) for (i = 0; i < r.length; i++) void 0 === (a = (n = u.nestedProperty(f, r[i])).get()) ? u.nestedProperty(h, r[i]).set(null) : (n.set(null), u.nestedProperty(h, r[i]).set(a));
        if (e = u.extendDeepNoArrays(e || {}, f), r && r.length) for (i = 0; i < r.length; i++) if (s = u.nestedProperty(h, r[i]).get()) {
          for (c = (l = u.nestedProperty(e, r[i])).get(), Array.isArray(c) || (c = [], l.set(c)), o = 0; o < s.length; o++) {
            var p = s[o];
            c[o] = null === p ? null : b.extendObjectWithContainers(c[o], p);
          }
          l.set(c);
        }
        return e;
      }, b.dataArrayContainers = ["transforms", "dimensions"], b.layoutArrayContainers = l.layoutArrayContainers, b.extendTrace = function (e, t) {
        return b.extendObjectWithContainers(e, t, b.dataArrayContainers);
      }, b.extendLayout = function (e, t) {
        return b.extendObjectWithContainers(e, t, b.layoutArrayContainers);
      }, b.transition = function (e, t, r, n, a, i) {
        var o = {
            redraw: a.redraw
          },
          l = {},
          s = [];
        return o.prepareFn = function () {
          for (var a = Array.isArray(t) ? t.length : 0, i = n.slice(0, a), o = 0; o < i.length; o++) {
            var c = i[o],
              d = e._fullData[c]._module;
            if (d) {
              if (d.animatable) {
                var f = d.basePlotModule.name;
                l[f] || (l[f] = []), l[f].push(c);
              }
              e.data[i[o]] = b.extendTrace(e.data[i[o]], t[o]);
            }
          }
          var h = u.expandObjectPaths(u.extendDeepNoArrays({}, r)),
            p = /^[xy]axis[0-9]*$/;
          for (var g in h) p.test(g) && delete h[g].range;
          b.extendLayout(e.layout, h), delete e.calcdata, b.supplyDefaults(e), b.doCalcdata(e);
          var m = u.expandObjectPaths(r);
          if (m) {
            var y = e._fullLayout._plots;
            for (var v in y) {
              var x = y[v],
                _ = x.xaxis,
                w = x.yaxis,
                M = _.range.slice(),
                T = w.range.slice(),
                k = null,
                A = null,
                L = null,
                D = null;
              Array.isArray(m[_._name + ".range"]) ? k = m[_._name + ".range"].slice() : Array.isArray((m[_._name] || {}).range) && (k = m[_._name].range.slice()), Array.isArray(m[w._name + ".range"]) ? A = m[w._name + ".range"].slice() : Array.isArray((m[w._name] || {}).range) && (A = m[w._name].range.slice()), M && k && (_.r2l(M[0]) !== _.r2l(k[0]) || _.r2l(M[1]) !== _.r2l(k[1])) && (L = {
                xr0: M,
                xr1: k
              }), T && A && (w.r2l(T[0]) !== w.r2l(A[0]) || w.r2l(T[1]) !== w.r2l(A[1])) && (D = {
                yr0: T,
                yr1: A
              }), (L || D) && s.push(u.extendFlat({
                plotinfo: x
              }, L, D));
            }
          }
          return Promise.resolve();
        }, o.runFn = function (t) {
          var n,
            a,
            o = e._fullLayout._basePlotModules,
            c = s.length;
          if (r) for (a = 0; a < o.length; a++) o[a].transitionAxes && o[a].transitionAxes(e, s, i, t);
          for (var d in c ? ((n = u.extendFlat({}, i)).duration = 0, delete l.cartesian) : n = i, l) {
            var f = l[d];
            e._fullData[f[0]]._module.basePlotModule.plot(e, f, n, t);
          }
        }, P(e, i, o);
      }, b.transitionFromReact = function (e, t, r, n) {
        var a = e._fullLayout,
          i = a.transition,
          o = {},
          l = [];
        return o.prepareFn = function () {
          var e = a._plots;
          for (var i in o.redraw = !1, "some" === t.anim && (o.redraw = !0), "some" === r.anim && (o.redraw = !0), e) {
            var s = e[i],
              c = s.xaxis,
              d = s.yaxis,
              f = n[c._name].range.slice(),
              h = n[d._name].range.slice(),
              p = c.range.slice(),
              g = d.range.slice();
            c.setScale(), d.setScale();
            var m = null,
              y = null;
            c.r2l(f[0]) === c.r2l(p[0]) && c.r2l(f[1]) === c.r2l(p[1]) || (m = {
              xr0: f,
              xr1: p
            }), d.r2l(h[0]) === d.r2l(g[0]) && d.r2l(h[1]) === d.r2l(g[1]) || (y = {
              yr0: h,
              yr1: g
            }), (m || y) && l.push(u.extendFlat({
              plotinfo: s
            }, m, y));
          }
          return Promise.resolve();
        }, o.runFn = function (r) {
          for (var n, a, o, s = e._fullData, c = e._fullLayout._basePlotModules, d = [], f = 0; f < s.length; f++) d.push(f);
          function h() {
            if (e._fullLayout) for (var t = 0; t < c.length; t++) c[t].transitionAxes && c[t].transitionAxes(e, l, n, r);
          }
          function p() {
            if (e._fullLayout) for (var t = 0; t < c.length; t++) c[t].plot(e, o, a, r);
          }
          l.length && t.anim ? "traces first" === i.ordering ? (n = u.extendFlat({}, i, {
            duration: 0
          }), o = d, a = i, setTimeout(h, i.duration), p()) : (n = i, o = null, a = u.extendFlat({}, i, {
            duration: 0
          }), setTimeout(p, n.duration), h()) : l.length ? (n = i, h()) : t.anim && (o = d, a = i, p());
        }, P(e, i, o);
      }, b.doCalcdata = function (e, t) {
        var r,
          n,
          a,
          i,
          o = h.list(e),
          c = e._fullData,
          d = e._fullLayout,
          p = new Array(c.length),
          g = (e.calcdata || []).slice();
        for (e.calcdata = p, d._numBoxes = 0, d._numViolins = 0, d._violinScaleGroupStats = {}, e._hmpixcount = 0, e._hmlumcount = 0, d._piecolormap = {}, d._sunburstcolormap = {}, d._treemapcolormap = {}, d._iciclecolormap = {}, d._funnelareacolormap = {}, a = 0; a < c.length; a++) Array.isArray(t) && -1 === t.indexOf(a) && (p[a] = g[a]);
        for (a = 0; a < c.length; a++) (r = c[a])._arrayAttrs = s.findArrayAttributes(r), r._extremes = {};
        var m = d._subplots.polar || [];
        for (a = 0; a < m.length; a++) o.push(d[m[a]].radialaxis, d[m[a]].angularaxis);
        for (var y in d._colorAxes) {
          var v = d[y];
          !1 !== v.cauto && (delete v.cmin, delete v.cmax);
        }
        var x = !1;
        function b(t) {
          if (r = c[t], n = r._module, !0 === r.visible && r.transforms) {
            if (n && n.calc) {
              var a = n.calc(e, r);
              a[0] && a[0].t && a[0].t._scene && delete a[0].t._scene.dirty;
            }
            for (i = 0; i < r.transforms.length; i++) {
              var o = r.transforms[i];
              (n = _[o.type]) && n.calcTransform && (r._hasCalcTransform = !0, x = !0, n.calcTransform(e, r, o));
            }
          }
        }
        function w(t, a) {
          if (r = c[t], !!(n = r._module).isContainer === a) {
            var o = [];
            if (!0 === r.visible && 0 !== r._length) {
              delete r._indexToPoints;
              var l = r.transforms || [];
              for (i = l.length - 1; i >= 0; i--) if (l[i].enabled) {
                r._indexToPoints = l[i]._indexToPoints;
                break;
              }
              n && n.calc && (o = n.calc(e, r));
            }
            Array.isArray(o) && o[0] || (o = [{
              x: f,
              y: f
            }]), o[0].t || (o[0].t = {}), o[0].trace = r, p[t] = o;
          }
        }
        for (z(o, c, d), a = 0; a < c.length; a++) w(a, !0);
        for (a = 0; a < c.length; a++) b(a);
        for (x && z(o, c, d), a = 0; a < c.length; a++) w(a, !0);
        for (a = 0; a < c.length; a++) w(a, !1);
        R(e);
        var M = function (e, t) {
          var r,
            n,
            a,
            i,
            o,
            s = [];
          function c(e, r, n) {
            var a = r._id.charAt(0);
            if ("histogram2dcontour" === e) {
              var i = r._counterAxes[0],
                o = h.getFromId(t, i),
                l = "x" === a || "x" === i && "category" === o.type,
                s = "y" === a || "y" === i && "category" === o.type;
              return function (e, t) {
                return 0 === e || 0 === t || l && e === n[t].length - 1 || s && t === n.length - 1 ? -1 : ("y" === a ? t : e) - 1;
              };
            }
            return function (e, t) {
              return "y" === a ? t : e;
            };
          }
          var d = {
            min: function min(e) {
              return u.aggNums(Math.min, null, e);
            },
            max: function max(e) {
              return u.aggNums(Math.max, null, e);
            },
            sum: function sum(e) {
              return u.aggNums(function (e, t) {
                return e + t;
              }, null, e);
            },
            total: function total(e) {
              return u.aggNums(function (e, t) {
                return e + t;
              }, null, e);
            },
            mean: function mean(e) {
              return u.mean(e);
            },
            median: function median(e) {
              return u.median(e);
            }
          };
          for (r = 0; r < e.length; r++) {
            var f = e[r];
            if ("category" === f.type) {
              var p = f.categoryorder.match(I);
              if (p) {
                var g = p[1],
                  m = p[2],
                  y = f._id.charAt(0),
                  v = "x" === y,
                  x = [];
                for (n = 0; n < f._categories.length; n++) x.push([f._categories[n], []]);
                for (n = 0; n < f._traceIndices.length; n++) {
                  var b = f._traceIndices[n],
                    _ = t._fullData[b];
                  if (!0 === _.visible) {
                    var w = _.type;
                    l.traceIs(_, "histogram") && (delete _._xautoBinFinished, delete _._yautoBinFinished);
                    var M = "splom" === w,
                      T = "scattergl" === w,
                      k = t.calcdata[b];
                    for (a = 0; a < k.length; a++) {
                      var A,
                        L,
                        D = k[a];
                      if (M) {
                        var S = _._axesDim[f._id];
                        if (!v) {
                          var C = _._diag[S][0];
                          C && (f = t._fullLayout[h.id2name(C)]);
                        }
                        var O = D.trace.dimensions[S].values;
                        for (i = 0; i < O.length; i++) for (A = f._categoriesMap[O[i]], o = 0; o < D.trace.dimensions.length; o++) if (o !== S) {
                          var P = D.trace.dimensions[o];
                          x[A][1].push(P.values[i]);
                        }
                      } else if (T) {
                        for (i = 0; i < D.t.x.length; i++) v ? (A = D.t.x[i], L = D.t.y[i]) : (A = D.t.y[i], L = D.t.x[i]), x[A][1].push(L);
                        D.t && D.t._scene && delete D.t._scene.dirty;
                      } else if (D.hasOwnProperty("z")) {
                        L = D.z;
                        var z = c(_.type, f, L);
                        for (i = 0; i < L.length; i++) for (o = 0; o < L[i].length; o++) (A = z(o, i)) + 1 && x[A][1].push(L[i][o]);
                      } else for (void 0 === (A = D.p) && (A = D[y]), void 0 === (L = D.s) && (L = D.v), void 0 === L && (L = v ? D.y : D.x), Array.isArray(L) || (L = void 0 === L ? [] : [L]), i = 0; i < L.length; i++) x[A][1].push(L[i]);
                    }
                  }
                }
                f._categoriesValue = x;
                var R = [];
                for (n = 0; n < x.length; n++) R.push([x[n][0], d[g](x[n][1])]);
                R.sort(function (e, t) {
                  return e[1] - t[1];
                }), f._categoriesAggregatedValue = R, f._initialCategories = R.map(function (e) {
                  return e[0];
                }), "descending" === m && f._initialCategories.reverse(), s = s.concat(f.sortByInitialCategories());
              }
            }
          }
          return s;
        }(o, e);
        if (M.length) {
          for (d._numBoxes = 0, d._numViolins = 0, a = 0; a < M.length; a++) w(M[a], !0);
          for (a = 0; a < M.length; a++) w(M[a], !1);
          R(e);
        }
        l.getComponentMethod("fx", "calc")(e), l.getComponentMethod("errorbars", "calc")(e);
      };
      var I = /(total|sum|min|max|mean|median) (ascending|descending)/;
      function z(e, t, r) {
        var n = {};
        function a(e) {
          e.clearCalc(), "multicategory" === e.type && e.setupMultiCategory(t), n[e._id] = 1;
        }
        u.simpleMap(e, a);
        for (var i = r._axisMatchGroups || [], o = 0; o < i.length; o++) for (var l in i[o]) n[l] || a(r[h.id2name(l)]);
      }
      function R(e) {
        var t,
          r,
          n,
          a = e._fullLayout,
          i = a._visibleModules,
          o = {};
        for (r = 0; r < i.length; r++) {
          var l = i[r],
            s = l.crossTraceCalc;
          if (s) {
            var c = l.basePlotModule.name;
            o[c] ? u.pushUnique(o[c], s) : o[c] = [s];
          }
        }
        for (n in o) {
          var d = o[n],
            f = a._subplots[n];
          if (Array.isArray(f)) for (t = 0; t < f.length; t++) {
            var h = f[t],
              p = "cartesian" === n ? a._plots[h] : a[h];
            for (r = 0; r < d.length; r++) d[r](e, p, h);
          } else for (r = 0; r < d.length; r++) d[r](e);
        }
      }
      b.rehover = function (e) {
        e._fullLayout._rehover && e._fullLayout._rehover();
      }, b.redrag = function (e) {
        e._fullLayout._redrag && e._fullLayout._redrag();
      }, b.generalUpdatePerTraceModule = function (e, t, r, n) {
        var a,
          i = t.traceHash,
          o = {};
        for (a = 0; a < r.length; a++) {
          var l = r[a],
            s = l[0].trace;
          s.visible && (o[s.type] = o[s.type] || [], o[s.type].push(l));
        }
        for (var c in i) if (!o[c]) {
          var d = i[c][0];
          d[0].trace.visible = !1, o[c] = [d];
        }
        for (var f in o) {
          var h = o[f];
          h[0][0].trace._module.plot(e, t, u.filterVisible(h), n);
        }
        t.traceHash = o;
      }, b.plotBasePlot = function (e, t, r, n, a) {
        var i = l.getModule(e),
          o = y(t.calcdata, i)[0];
        i.plot(t, o, n, a);
      }, b.cleanBasePlot = function (e, t, r, n, a) {
        var i = a._has && a._has(e),
          o = r._has && r._has(e);
        i && !o && a["_" + e + "layer"].selectAll("g.trace").remove();
      };
    }, {
      "../components/color": 96,
      "../constants/numerical": 205,
      "../lib": 225,
      "../plot_api/plot_schema": 260,
      "../plot_api/plot_template": 261,
      "../plots/get_data": 303,
      "../registry": 309,
      "./animation_attributes": 266,
      "./attributes": 268,
      "./cartesian/axis_ids": 276,
      "./cartesian/handle_outline": 283,
      "./command": 299,
      "./font_attributes": 301,
      "./frame_attributes": 302,
      "./layout_attributes": 305,
      "@plotly/d3": 6,
      "d3-format": 7,
      "d3-time-format": 8,
      "fast-isnumeric": 11
    }],
    308: [function (e, t, r) {
      "use strict";

      var n = e("../constants/docs");
      n.FORMAT_LINK, n.DATE_FORMAT_LINK;
      function a(e) {
        var t = e.description ? " " + e.description : "",
          r = e.keys || [];
        if (r.length > 0) {
          for (var n = [], a = 0; a < r.length; a++) n[a] = "`" + r[a] + "`";
          t += "Finally, the template string has access to ", t = 1 === r.length ? "variable " + n[0] : "variables " + n.slice(0, -1).join(", ") + " and " + n.slice(-1) + ".";
        }
        return t;
      }
      r.hovertemplateAttrs = function (e, t) {
        e = e || {};
        a(t = t || {});
        var r = {
          valType: "string",
          dflt: "",
          editType: e.editType || "none"
        };
        return !1 !== e.arrayOk && (r.arrayOk = !0), r;
      }, r.texttemplateAttrs = function (e, t) {
        e = e || {};
        a(t = t || {});
        var r = {
          valType: "string",
          dflt: "",
          editType: e.editType || "calc"
        };
        return !1 !== e.arrayOk && (r.arrayOk = !0), r;
      };
    }, {
      "../constants/docs": 203
    }],
    309: [function (e, t, r) {
      "use strict";

      var n = e("./lib/loggers"),
        a = e("./lib/noop"),
        i = e("./lib/push_unique"),
        o = e("./lib/is_plain_object"),
        l = e("./lib/dom").addStyleRule,
        s = e("./lib/extend"),
        c = e("./plots/attributes"),
        u = e("./plots/layout_attributes"),
        d = s.extendFlat,
        f = s.extendDeepAll;
      function h(e) {
        var t = e.name,
          a = e.categories,
          i = e.meta;
        if (r.modules[t]) n.log("Type " + t + " already registered");else {
          r.subplotsRegistry[e.basePlotModule.name] || function (e) {
            var t = e.name;
            if (r.subplotsRegistry[t]) return void n.log("Plot type " + t + " already registered.");
            for (var a in y(e), r.subplotsRegistry[t] = e, r.componentsRegistry) b(a, e.name);
          }(e.basePlotModule);
          for (var o = {}, s = 0; s < a.length; s++) o[a[s]] = !0, r.allCategories[a[s]] = !0;
          for (var c in r.modules[t] = {
            _module: e,
            categories: o
          }, i && Object.keys(i).length && (r.modules[t].meta = i), r.allTypes.push(t), r.componentsRegistry) v(c, t);
          e.layoutAttributes && d(r.traceLayoutAttributes, e.layoutAttributes);
          var u = e.basePlotModule,
            f = u.name;
          if ("mapbox" === f) {
            var h = u.constants.styleRules;
            for (var p in h) l(".js-plotly-plot .plotly .mapboxgl-" + p, h[p]);
          }
          "geo" !== f && "mapbox" !== f || void 0 === typeof window || void 0 !== window.PlotlyGeoAssets || (window.PlotlyGeoAssets = {
            topojson: {}
          });
        }
      }
      function p(e) {
        if ("string" != typeof e.name) throw new Error("Component module *name* must be a string.");
        var t = e.name;
        for (var n in r.componentsRegistry[t] = e, e.layoutAttributes && (e.layoutAttributes._isLinkedToArray && i(r.layoutArrayContainers, t), y(e)), r.modules) v(t, n);
        for (var a in r.subplotsRegistry) b(t, a);
        for (var o in r.transformsRegistry) x(t, o);
        e.schema && e.schema.layout && f(u, e.schema.layout);
      }
      function g(e) {
        if ("string" != typeof e.name) throw new Error("Transform module *name* must be a string.");
        var t = "Transform module " + e.name,
          a = "function" == typeof e.transform,
          i = "function" == typeof e.calcTransform;
        if (!a && !i) throw new Error(t + " is missing a *transform* or *calcTransform* method.");
        for (var l in a && i && n.log([t + " has both a *transform* and *calcTransform* methods.", "Please note that all *transform* methods are executed", "before all *calcTransform* methods."].join(" ")), o(e.attributes) || n.log(t + " registered without an *attributes* object."), "function" != typeof e.supplyDefaults && n.log(t + " registered without a *supplyDefaults* method."), r.transformsRegistry[e.name] = e, r.componentsRegistry) x(l, e.name);
      }
      function m(e) {
        var t = e.name,
          n = t.split("-")[0],
          a = e.dictionary,
          i = e.format,
          o = a && Object.keys(a).length,
          l = i && Object.keys(i).length,
          s = r.localeRegistry,
          c = s[t];
        if (c || (s[t] = c = {}), n !== t) {
          var u = s[n];
          u || (s[n] = u = {}), o && u.dictionary === c.dictionary && (u.dictionary = a), l && u.format === c.format && (u.format = i);
        }
        o && (c.dictionary = a), l && (c.format = i);
      }
      function y(e) {
        if (e.layoutAttributes) {
          var t = e.layoutAttributes._arrayAttrRegexps;
          if (t) for (var n = 0; n < t.length; n++) i(r.layoutArrayRegexes, t[n]);
        }
      }
      function v(e, t) {
        var n = r.componentsRegistry[e].schema;
        if (n && n.traces) {
          var a = n.traces[t];
          a && f(r.modules[t]._module.attributes, a);
        }
      }
      function x(e, t) {
        var n = r.componentsRegistry[e].schema;
        if (n && n.transforms) {
          var a = n.transforms[t];
          a && f(r.transformsRegistry[t].attributes, a);
        }
      }
      function b(e, t) {
        var n = r.componentsRegistry[e].schema;
        if (n && n.subplots) {
          var a = r.subplotsRegistry[t],
            i = a.layoutAttributes,
            o = "subplot" === a.attr ? a.name : a.attr;
          Array.isArray(o) && (o = o[0]);
          var l = n.subplots[o];
          i && l && f(i, l);
        }
      }
      function _(e) {
        return "object" == typeof e && (e = e.type), e;
      }
      r.modules = {}, r.allCategories = {}, r.allTypes = [], r.subplotsRegistry = {}, r.transformsRegistry = {}, r.componentsRegistry = {}, r.layoutArrayContainers = [], r.layoutArrayRegexes = [], r.traceLayoutAttributes = {}, r.localeRegistry = {}, r.apiMethodRegistry = {}, r.collectableSubplotTypes = null, r.register = function (e) {
        if (r.collectableSubplotTypes = null, !e) throw new Error("No argument passed to Plotly.register.");
        e && !Array.isArray(e) && (e = [e]);
        for (var t = 0; t < e.length; t++) {
          var n = e[t];
          if (!n) throw new Error("Invalid module was attempted to be registered!");
          switch (n.moduleType) {
            case "trace":
              h(n);
              break;
            case "transform":
              g(n);
              break;
            case "component":
              p(n);
              break;
            case "locale":
              m(n);
              break;
            case "apiMethod":
              var a = n.name;
              r.apiMethodRegistry[a] = n.fn;
              break;
            default:
              throw new Error("Invalid module was attempted to be registered!");
          }
        }
      }, r.getModule = function (e) {
        var t = r.modules[_(e)];
        return !!t && t._module;
      }, r.traceIs = function (e, t) {
        if ("various" === (e = _(e))) return !1;
        var a = r.modules[e];
        return a || (e && n.log("Unrecognized trace type " + e + "."), a = r.modules[c.type.dflt]), !!a.categories[t];
      }, r.getTransformIndices = function (e, t) {
        for (var r = [], n = e.transforms || [], a = 0; a < n.length; a++) n[a].type === t && r.push(a);
        return r;
      }, r.hasTransform = function (e, t) {
        for (var r = e.transforms || [], n = 0; n < r.length; n++) if (r[n].type === t) return !0;
        return !1;
      }, r.getComponentMethod = function (e, t) {
        var n = r.componentsRegistry[e];
        return n && n[t] || a;
      }, r.call = function () {
        var e = arguments[0],
          t = [].slice.call(arguments, 1);
        return r.apiMethodRegistry[e].apply(null, t);
      };
    }, {
      "./lib/dom": 217,
      "./lib/extend": 219,
      "./lib/is_plain_object": 226,
      "./lib/loggers": 229,
      "./lib/noop": 234,
      "./lib/push_unique": 239,
      "./plots/attributes": 268,
      "./plots/layout_attributes": 305
    }],
    310: [function (e, t, r) {
      "use strict";

      var n = e("../registry"),
        a = e("../lib"),
        i = a.extendFlat,
        o = a.extendDeep;
      function l(e) {
        var t;
        switch (e) {
          case "themes__thumb":
            t = {
              autosize: !0,
              width: 150,
              height: 150,
              title: {
                text: ""
              },
              showlegend: !1,
              margin: {
                l: 5,
                r: 5,
                t: 5,
                b: 5,
                pad: 0
              },
              annotations: []
            };
            break;
          case "thumbnail":
            t = {
              title: {
                text: ""
              },
              hidesources: !0,
              showlegend: !1,
              borderwidth: 0,
              bordercolor: "",
              margin: {
                l: 1,
                r: 1,
                t: 1,
                b: 1,
                pad: 0
              },
              annotations: []
            };
            break;
          default:
            t = {};
        }
        return t;
      }
      t.exports = function (e, t) {
        var r,
          a,
          s = e.data,
          c = e.layout,
          u = o([], s),
          d = o({}, c, l(t.tileClass)),
          f = e._context || {};
        if (t.width && (d.width = t.width), t.height && (d.height = t.height), "thumbnail" === t.tileClass || "themes__thumb" === t.tileClass) {
          d.annotations = [];
          var h = Object.keys(d);
          for (r = 0; r < h.length; r++) a = h[r], ["xaxis", "yaxis", "zaxis"].indexOf(a.slice(0, 5)) > -1 && (d[h[r]].title = {
            text: ""
          });
          for (r = 0; r < u.length; r++) {
            var p = u[r];
            p.showscale = !1, p.marker && (p.marker.showscale = !1), n.traceIs(p, "pie-like") && (p.textposition = "none");
          }
        }
        if (Array.isArray(t.annotations)) for (r = 0; r < t.annotations.length; r++) d.annotations.push(t.annotations[r]);
        var g = Object.keys(d).filter(function (e) {
          return e.match(/^scene\d*$/);
        });
        if (g.length) {
          var m = {};
          for ("thumbnail" === t.tileClass && (m = {
            title: {
              text: ""
            },
            showaxeslabels: !1,
            showticklabels: !1,
            linetickenable: !1
          }), r = 0; r < g.length; r++) {
            var y = d[g[r]];
            y.xaxis || (y.xaxis = {}), y.yaxis || (y.yaxis = {}), y.zaxis || (y.zaxis = {}), i(y.xaxis, m), i(y.yaxis, m), i(y.zaxis, m), y._scene = null;
          }
        }
        var v = document.createElement("div");
        t.tileClass && (v.className = t.tileClass);
        var x = {
          gd: v,
          td: v,
          layout: d,
          data: u,
          config: {
            staticPlot: void 0 === t.staticPlot || t.staticPlot,
            plotGlPixelRatio: void 0 === t.plotGlPixelRatio ? 2 : t.plotGlPixelRatio,
            displaylogo: t.displaylogo || !1,
            showLink: t.showLink || !1,
            showTips: t.showTips || !1,
            mapboxAccessToken: f.mapboxAccessToken
          }
        };
        return "transparent" !== t.setBackground && (x.config.setBackground = t.setBackground || "opaque"), x.gd.defaultLayout = l(t.tileClass), x;
      };
    }, {
      "../lib": 225,
      "../registry": 309
    }],
    311: [function (e, t, r) {
      "use strict";

      var n = e("../lib"),
        a = e("../plot_api/to_image"),
        i = e("./filesaver"),
        o = e("./helpers");
      t.exports = function (e, t) {
        var r;
        return n.isPlainObject(e) || (r = n.getGraphDiv(e)), (t = t || {}).format = t.format || "png", t.width = t.width || null, t.height = t.height || null, t.imageDataOnly = !0, new Promise(function (l, s) {
          r && r._snapshotInProgress && s(new Error("Snapshotting already in progress.")), n.isIE() && "svg" !== t.format && s(new Error(o.MSG_IE_BAD_FORMAT)), r && (r._snapshotInProgress = !0);
          var c = a(e, t),
            u = t.filename || e.fn || "newplot";
          u += "." + t.format.replace("-", "."), c.then(function (e) {
            return r && (r._snapshotInProgress = !1), i(e, u, t.format);
          }).then(function (e) {
            l(e);
          }).catch(function (e) {
            r && (r._snapshotInProgress = !1), s(e);
          });
        });
      };
    }, {
      "../lib": 225,
      "../plot_api/to_image": 264,
      "./filesaver": 312,
      "./helpers": 313
    }],
    312: [function (e, t, r) {
      "use strict";

      var n = e("../lib"),
        a = e("./helpers");
      t.exports = function (e, t, r) {
        var i = document.createElement("a"),
          o = "download" in i;
        return new Promise(function (l, s) {
          var c, u;
          if (n.isIE()) return c = a.createBlob(e, "svg"), window.navigator.msSaveBlob(c, t), c = null, l(t);
          if (o) return c = a.createBlob(e, r), u = a.createObjectURL(c), i.href = u, i.download = t, document.body.appendChild(i), i.click(), document.body.removeChild(i), a.revokeObjectURL(u), c = null, l(t);
          if (n.isSafari()) {
            var d = "svg" === r ? "," : ";base64,";
            return a.octetStream(d + encodeURIComponent(e)), l(t);
          }
          s(new Error("download error"));
        });
      };
    }, {
      "../lib": 225,
      "./helpers": 313
    }],
    313: [function (e, t, r) {
      "use strict";

      var n = e("../registry");
      r.getDelay = function (e) {
        return e._has && (e._has("gl3d") || e._has("gl2d") || e._has("mapbox")) ? 500 : 0;
      }, r.getRedrawFunc = function (e) {
        return function () {
          n.getComponentMethod("colorbar", "draw")(e);
        };
      }, r.encodeSVG = function (e) {
        return "data:image/svg+xml," + encodeURIComponent(e);
      }, r.encodeJSON = function (e) {
        return "data:application/json," + encodeURIComponent(e);
      };
      var a = window.URL || window.webkitURL;
      r.createObjectURL = function (e) {
        return a.createObjectURL(e);
      }, r.revokeObjectURL = function (e) {
        return a.revokeObjectURL(e);
      }, r.createBlob = function (e, t) {
        if ("svg" === t) return new window.Blob([e], {
          type: "image/svg+xml;charset=utf-8"
        });
        if ("full-json" === t) return new window.Blob([e], {
          type: "application/json;charset=utf-8"
        });
        var r = function (e) {
          for (var t = e.length, r = new ArrayBuffer(t), n = new Uint8Array(r), a = 0; a < t; a++) n[a] = e.charCodeAt(a);
          return r;
        }(window.atob(e));
        return new window.Blob([r], {
          type: "image/" + t
        });
      }, r.octetStream = function (e) {
        document.location.href = "data:application/octet-stream" + e;
      }, r.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/, r.MSG_IE_BAD_FORMAT = "Sorry IE does not support downloading from canvas. Try {format:'svg'} instead.";
    }, {
      "../registry": 309
    }],
    314: [function (e, t, r) {
      "use strict";

      var n = e("./helpers"),
        a = {
          getDelay: n.getDelay,
          getRedrawFunc: n.getRedrawFunc,
          clone: e("./cloneplot"),
          toSVG: e("./tosvg"),
          svgToImg: e("./svgtoimg"),
          toImage: e("./toimage"),
          downloadImage: e("./download")
        };
      t.exports = a;
    }, {
      "./cloneplot": 310,
      "./download": 311,
      "./helpers": 313,
      "./svgtoimg": 315,
      "./toimage": 316,
      "./tosvg": 317
    }],
    315: [function (e, t, r) {
      "use strict";

      var n = e("../lib"),
        a = e("events").EventEmitter,
        i = e("./helpers");
      t.exports = function (e) {
        var t = e.emitter || new a(),
          r = new Promise(function (a, o) {
            var l = window.Image,
              s = e.svg,
              c = e.format || "png";
            if (n.isIE() && "svg" !== c) {
              var u = new Error(i.MSG_IE_BAD_FORMAT);
              return o(u), e.promise ? r : t.emit("error", u);
            }
            var d,
              f,
              h = e.canvas,
              p = e.scale || 1,
              g = e.width || 300,
              m = e.height || 150,
              y = p * g,
              v = p * m,
              x = h.getContext("2d"),
              b = new l();
            "svg" === c || n.isSafari() ? f = i.encodeSVG(s) : (d = i.createBlob(s, "svg"), f = i.createObjectURL(d)), h.width = y, h.height = v, b.onload = function () {
              var r;
              switch (d = null, i.revokeObjectURL(f), "svg" !== c && x.drawImage(b, 0, 0, y, v), c) {
                case "jpeg":
                  r = h.toDataURL("image/jpeg");
                  break;
                case "png":
                  r = h.toDataURL("image/png");
                  break;
                case "webp":
                  r = h.toDataURL("image/webp");
                  break;
                case "svg":
                  r = f;
                  break;
                default:
                  var n = "Image format is not jpeg, png, svg or webp.";
                  if (o(new Error(n)), !e.promise) return t.emit("error", n);
              }
              a(r), e.promise || t.emit("success", r);
            }, b.onerror = function (r) {
              if (d = null, i.revokeObjectURL(f), o(r), !e.promise) return t.emit("error", r);
            }, b.src = f;
          });
        return e.promise ? r : t;
      };
    }, {
      "../lib": 225,
      "./helpers": 313,
      events: 10
    }],
    316: [function (e, t, r) {
      "use strict";

      var n = e("events").EventEmitter,
        a = e("../registry"),
        i = e("../lib"),
        o = e("./helpers"),
        l = e("./cloneplot"),
        s = e("./tosvg"),
        c = e("./svgtoimg");
      t.exports = function (e, t) {
        var r = new n(),
          u = l(e, {
            format: "png"
          }),
          d = u.gd;
        d.style.position = "absolute", d.style.left = "-5000px", document.body.appendChild(d);
        var f = o.getRedrawFunc(d);
        return a.call("_doPlot", d, u.data, u.layout, u.config).then(f).then(function () {
          var e = o.getDelay(d._fullLayout);
          setTimeout(function () {
            var e = s(d),
              n = document.createElement("canvas");
            n.id = i.randstr(), (r = c({
              format: t.format,
              width: d._fullLayout.width,
              height: d._fullLayout.height,
              canvas: n,
              emitter: r,
              svg: e
            })).clean = function () {
              d && document.body.removeChild(d);
            };
          }, e);
        }).catch(function (e) {
          r.emit("error", e);
        }), r;
      };
    }, {
      "../lib": 225,
      "../registry": 309,
      "./cloneplot": 310,
      "./helpers": 313,
      "./svgtoimg": 315,
      "./tosvg": 317,
      events: 10
    }],
    317: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../lib"),
        i = e("../components/drawing"),
        o = e("../components/color"),
        l = e("../constants/xmlns_namespaces"),
        s = /"/g,
        c = new RegExp('("TOBESTRIPPED)|(TOBESTRIPPED")', "g");
      t.exports = function (e, t, r) {
        var u,
          d,
          f = e._fullLayout,
          h = f._paper,
          p = f._toppaper,
          g = f.width,
          m = f.height;
        h.insert("rect", ":first-child").call(i.setRect, 0, 0, g, m).call(o.fill, f.paper_bgcolor);
        var y = f._basePlotModules || [];
        for (u = 0; u < y.length; u++) {
          var v = y[u];
          v.toSVG && v.toSVG(e);
        }
        if (p) {
          var x = p.node().childNodes,
            b = Array.prototype.slice.call(x);
          for (u = 0; u < b.length; u++) {
            var _ = b[u];
            _.childNodes.length && h.node().appendChild(_);
          }
        }
        f._draggers && f._draggers.remove(), h.node().style.background = "", h.selectAll("text").attr({
          "data-unformatted": null,
          "data-math": null
        }).each(function () {
          var e = n.select(this);
          if ("hidden" !== this.style.visibility && "none" !== this.style.display) {
            e.style({
              visibility: null,
              display: null
            });
            var t = this.style.fontFamily;
            t && -1 !== t.indexOf('"') && e.style("font-family", t.replace(s, "TOBESTRIPPED"));
          } else e.remove();
        });
        var w = [];
        if (f._gradientUrlQueryParts) for (d in f._gradientUrlQueryParts) w.push(d);
        if (f._patternUrlQueryParts) for (d in f._patternUrlQueryParts) w.push(d);
        w.length && h.selectAll(w.join(",")).each(function () {
          var e = n.select(this),
            t = this.style.fill;
          t && -1 !== t.indexOf("url(") && e.style("fill", t.replace(s, "TOBESTRIPPED"));
          var r = this.style.stroke;
          r && -1 !== r.indexOf("url(") && e.style("stroke", r.replace(s, "TOBESTRIPPED"));
        }), "pdf" !== t && "eps" !== t || h.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0), h.node().setAttributeNS(l.xmlns, "xmlns", l.svg), h.node().setAttributeNS(l.xmlns, "xmlns:xlink", l.xlink), "svg" === t && r && (h.attr("width", r * g), h.attr("height", r * m), h.attr("viewBox", "0 0 " + g + " " + m));
        var M = new window.XMLSerializer().serializeToString(h.node());
        return M = function (e) {
          var t = n.select("body").append("div").style({
              display: "none"
            }).html(""),
            r = e.replace(/(&[^;]*;)/gi, function (e) {
              return "&lt;" === e ? "&#60;" : "&rt;" === e ? "&#62;" : -1 !== e.indexOf("<") || -1 !== e.indexOf(">") ? "" : t.html(e).text();
            });
          return t.remove(), r;
        }(M), M = (M = M.replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;")).replace(c, "'"), a.isIE() && (M = (M = (M = M.replace(/"/gi, "'")).replace(/(\('#)([^']*)('\))/gi, '("#$2")')).replace(/(\\')/gi, '"')), M;
      };
    }, {
      "../components/color": 96,
      "../components/drawing": 118,
      "../constants/xmlns_namespaces": 206,
      "../lib": 225,
      "@plotly/d3": 6
    }],
    318: [function (e, t, r) {
      "use strict";

      var n = e("../../lib");
      t.exports = function (e, t) {
        for (var r = 0; r < e.length; r++) e[r].i = r;
        n.mergeArray(t.text, e, "tx"), n.mergeArray(t.hovertext, e, "htx");
        var a = t.marker;
        if (a) {
          n.mergeArray(a.opacity, e, "mo", !0), n.mergeArray(a.color, e, "mc");
          var i = a.line;
          i && (n.mergeArray(i.color, e, "mlc"), n.mergeArrayCastPositive(i.width, e, "mlw"));
        }
      };
    }, {
      "../../lib": 225
    }],
    319: [function (e, t, r) {
      "use strict";

      var n = e("../scatter/attributes"),
        a = e("../../plots/attributes"),
        i = e("../../plots/cartesian/axis_format_attributes").axisHoverFormat,
        o = e("../../plots/template_attributes").hovertemplateAttrs,
        l = e("../../components/colorscale/attributes"),
        s = e("../../lib/extend").extendFlat;
      t.exports = s({
        z: {
          valType: "data_array",
          editType: "calc"
        },
        x: s({}, n.x, {
          impliedEdits: {
            xtype: "array"
          }
        }),
        x0: s({}, n.x0, {
          impliedEdits: {
            xtype: "scaled"
          }
        }),
        dx: s({}, n.dx, {
          impliedEdits: {
            xtype: "scaled"
          }
        }),
        y: s({}, n.y, {
          impliedEdits: {
            ytype: "array"
          }
        }),
        y0: s({}, n.y0, {
          impliedEdits: {
            ytype: "scaled"
          }
        }),
        dy: s({}, n.dy, {
          impliedEdits: {
            ytype: "scaled"
          }
        }),
        xperiod: s({}, n.xperiod, {
          impliedEdits: {
            xtype: "scaled"
          }
        }),
        yperiod: s({}, n.yperiod, {
          impliedEdits: {
            ytype: "scaled"
          }
        }),
        xperiod0: s({}, n.xperiod0, {
          impliedEdits: {
            xtype: "scaled"
          }
        }),
        yperiod0: s({}, n.yperiod0, {
          impliedEdits: {
            ytype: "scaled"
          }
        }),
        xperiodalignment: s({}, n.xperiodalignment, {
          impliedEdits: {
            xtype: "scaled"
          }
        }),
        yperiodalignment: s({}, n.yperiodalignment, {
          impliedEdits: {
            ytype: "scaled"
          }
        }),
        text: {
          valType: "data_array",
          editType: "calc"
        },
        hovertext: {
          valType: "data_array",
          editType: "calc"
        },
        transpose: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        xtype: {
          valType: "enumerated",
          values: ["array", "scaled"],
          editType: "calc+clearAxisTypes"
        },
        ytype: {
          valType: "enumerated",
          values: ["array", "scaled"],
          editType: "calc+clearAxisTypes"
        },
        zsmooth: {
          valType: "enumerated",
          values: ["fast", "best", !1],
          dflt: !1,
          editType: "calc"
        },
        hoverongaps: {
          valType: "boolean",
          dflt: !0,
          editType: "none"
        },
        connectgaps: {
          valType: "boolean",
          editType: "calc"
        },
        xgap: {
          valType: "number",
          dflt: 0,
          min: 0,
          editType: "plot"
        },
        ygap: {
          valType: "number",
          dflt: 0,
          min: 0,
          editType: "plot"
        },
        xhoverformat: i("x"),
        yhoverformat: i("y"),
        zhoverformat: i("z", 1),
        hovertemplate: o(),
        showlegend: s({}, a.showlegend, {
          dflt: !1
        })
      }, {
        transforms: void 0
      }, l("", {
        cLetter: "z",
        autoColorDflt: !1
      }));
    }, {
      "../../components/colorscale/attributes": 103,
      "../../lib/extend": 219,
      "../../plots/attributes": 268,
      "../../plots/cartesian/axis_format_attributes": 275,
      "../../plots/template_attributes": 308,
      "../scatter/attributes": 343
    }],
    320: [function (e, t, r) {
      "use strict";

      var n = e("../../registry"),
        a = e("../../lib"),
        i = e("../../plots/cartesian/axes"),
        o = e("../../plots/cartesian/align_period"),
        l = e("../histogram2d/calc"),
        s = e("../../components/colorscale/calc"),
        c = e("./convert_column_xyz"),
        u = e("./clean_2d_array"),
        d = e("./interp2d"),
        f = e("./find_empties"),
        h = e("./make_bound_array"),
        p = e("../../constants/numerical").BADNUM;
      function g(e) {
        for (var t = [], r = e.length, n = 0; n < r; n++) {
          var a = e[n];
          a !== p && t.push(a);
        }
        return t;
      }
      t.exports = function (e, t) {
        var r,
          m,
          y,
          v,
          x,
          b,
          _,
          w,
          M,
          T,
          k,
          A = i.getFromId(e, t.xaxis || "x"),
          L = i.getFromId(e, t.yaxis || "y"),
          D = n.traceIs(t, "contour"),
          S = n.traceIs(t, "histogram"),
          C = n.traceIs(t, "gl2d"),
          O = D ? "best" : t.zsmooth;
        if (A._minDtick = 0, L._minDtick = 0, S) v = (k = l(e, t)).orig_x, r = k.x, m = k.x0, y = k.dx, w = k.orig_y, x = k.y, b = k.y0, _ = k.dy, M = k.z;else {
          var P = t.z;
          a.isArray1D(P) ? (c(t, A, L, "x", "y", ["z"]), r = t._x, x = t._y, P = t._z) : (v = t.x ? A.makeCalcdata(t, "x") : [], w = t.y ? L.makeCalcdata(t, "y") : [], r = o(t, A, "x", v).vals, x = o(t, L, "y", w).vals, t._x = r, t._y = x), m = t.x0, y = t.dx, b = t.y0, _ = t.dy, M = u(P, t, A, L);
        }
        function I(e) {
          O = t._input.zsmooth = t.zsmooth = !1, a.warn('cannot use zsmooth: "fast": ' + e);
        }
        if ((A.rangebreaks || L.rangebreaks) && (M = function (e, t, r) {
          for (var n = [], a = -1, i = 0; i < r.length; i++) if (t[i] !== p) {
            a++, n[a] = [];
            for (var o = 0; o < r[i].length; o++) e[o] !== p && n[a].push(r[i][o]);
          }
          return n;
        }(r, x, M), S || (r = g(r), x = g(x), t._x = r, t._y = x)), S || !D && !t.connectgaps || (t._emptypoints = f(M), d(M, t._emptypoints)), "fast" === O) if ("log" === A.type || "log" === L.type) I("log axis found");else if (!S) {
          if (r.length) {
            var z = (r[r.length - 1] - r[0]) / (r.length - 1),
              R = Math.abs(z / 100);
            for (T = 0; T < r.length - 1; T++) if (Math.abs(r[T + 1] - r[T] - z) > R) {
              I("x scale is not linear");
              break;
            }
          }
          if (x.length && "fast" === O) {
            var N = (x[x.length - 1] - x[0]) / (x.length - 1),
              F = Math.abs(N / 100);
            for (T = 0; T < x.length - 1; T++) if (Math.abs(x[T + 1] - x[T] - N) > F) {
              I("y scale is not linear");
              break;
            }
          }
        }
        var E = a.maxRowLength(M),
          j = "scaled" === t.xtype ? "" : r,
          H = h(t, j, m, y, E, A),
          B = "scaled" === t.ytype ? "" : x,
          Y = h(t, B, b, _, M.length, L);
        C || (t._extremes[A._id] = i.findExtremes(A, H), t._extremes[L._id] = i.findExtremes(L, Y));
        var U = {
          x: H,
          y: Y,
          z: M,
          text: t._text || t.text,
          hovertext: t._hovertext || t.hovertext
        };
        if (t.xperiodalignment && v && (U.orig_x = v), t.yperiodalignment && w && (U.orig_y = w), j && j.length === H.length - 1 && (U.xCenter = j), B && B.length === Y.length - 1 && (U.yCenter = B), S && (U.xRanges = k.xRanges, U.yRanges = k.yRanges, U.pts = k.pts), D || s(e, t, {
          vals: M,
          cLetter: "z"
        }), D && t.contours && "heatmap" === t.contours.coloring) {
          var V = {
            type: "contour" === t.type ? "heatmap" : "histogram2d",
            xcalendar: t.xcalendar,
            ycalendar: t.ycalendar
          };
          U.xfill = h(V, j, m, y, E, A), U.yfill = h(V, B, b, _, M.length, L);
        }
        return [U];
      };
    }, {
      "../../components/colorscale/calc": 104,
      "../../constants/numerical": 205,
      "../../lib": 225,
      "../../plots/cartesian/align_period": 269,
      "../../plots/cartesian/axes": 272,
      "../../registry": 309,
      "../histogram2d/calc": 339,
      "./clean_2d_array": 321,
      "./convert_column_xyz": 323,
      "./find_empties": 325,
      "./interp2d": 328,
      "./make_bound_array": 329
    }],
    321: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib"),
        i = e("../../constants/numerical").BADNUM;
      t.exports = function (e, t, r, o) {
        var l, s, c, u, d, f;
        function h(e) {
          if (n(e)) return +e;
        }
        if (t && t.transpose) {
          for (l = 0, d = 0; d < e.length; d++) l = Math.max(l, e[d].length);
          if (0 === l) return !1;
          c = function c(e) {
            return e.length;
          }, u = function u(e, t, r) {
            return (e[r] || [])[t];
          };
        } else l = e.length, c = function c(e, t) {
          return e[t].length;
        }, u = function u(e, t, r) {
          return (e[t] || [])[r];
        };
        var p = function p(e, t, r) {
          return t === i || r === i ? i : u(e, t, r);
        };
        function g(e) {
          if (t && "carpet" !== t.type && "contourcarpet" !== t.type && e && "category" === e.type && t["_" + e._id.charAt(0)].length) {
            var r = e._id.charAt(0),
              n = {},
              o = t["_" + r + "CategoryMap"] || t[r];
            for (d = 0; d < o.length; d++) n[o[d]] = d;
            return function (t) {
              var r = n[e._categories[t]];
              return r + 1 ? r : i;
            };
          }
          return a.identity;
        }
        var m = g(r),
          y = g(o);
        o && "category" === o.type && (l = o._categories.length);
        var v = new Array(l);
        for (d = 0; d < l; d++) for (s = r && "category" === r.type ? r._categories.length : c(e, d), v[d] = new Array(s), f = 0; f < s; f++) v[d][f] = h(p(e, y(d), m(f)));
        return v;
      };
    }, {
      "../../constants/numerical": 205,
      "../../lib": 225,
      "fast-isnumeric": 11
    }],
    322: [function (e, t, r) {
      "use strict";

      t.exports = {
        min: "zmin",
        max: "zmax"
      };
    }, {}],
    323: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../constants/numerical").BADNUM,
        i = e("../../plots/cartesian/align_period");
      t.exports = function (e, t, r, o, l, s) {
        var c = e._length,
          u = t.makeCalcdata(e, o),
          d = r.makeCalcdata(e, l);
        u = i(e, t, o, u).vals, d = i(e, r, l, d).vals;
        var f,
          h,
          p,
          g,
          m = e.text,
          y = void 0 !== m && n.isArray1D(m),
          v = e.hovertext,
          x = void 0 !== v && n.isArray1D(v),
          b = n.distinctVals(u),
          _ = b.vals,
          w = n.distinctVals(d),
          M = w.vals,
          T = [],
          k = M.length,
          A = _.length;
        for (f = 0; f < s.length; f++) T[f] = n.init2dArray(k, A);
        y && (p = n.init2dArray(k, A)), x && (g = n.init2dArray(k, A));
        var L = n.init2dArray(k, A);
        for (f = 0; f < c; f++) if (u[f] !== a && d[f] !== a) {
          var D = n.findBin(u[f] + b.minDiff / 2, _),
            S = n.findBin(d[f] + w.minDiff / 2, M);
          for (h = 0; h < s.length; h++) {
            var C = e[s[h]];
            T[h][S][D] = C[f], L[S][D] = f;
          }
          y && (p[S][D] = m[f]), x && (g[S][D] = v[f]);
        }
        for (e["_" + o] = _, e["_" + l] = M, h = 0; h < s.length; h++) e["_" + s[h]] = T[h];
        y && (e._text = p), x && (e._hovertext = g), t && "category" === t.type && (e["_" + o + "CategoryMap"] = _.map(function (e) {
          return t._categories[e];
        })), r && "category" === r.type && (e["_" + l + "CategoryMap"] = M.map(function (e) {
          return r._categories[e];
        })), e._after2before = L;
      };
    }, {
      "../../constants/numerical": 205,
      "../../lib": 225,
      "../../plots/cartesian/align_period": 269
    }],
    324: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("./xyz_defaults"),
        i = e("../scatter/period_defaults"),
        o = e("./style_defaults"),
        l = e("../../components/colorscale/defaults"),
        s = e("./attributes");
      t.exports = function (e, t, r, c) {
        function u(r, a) {
          return n.coerce(e, t, s, r, a);
        }
        a(e, t, u, c) ? (i(e, t, c, u), u("xhoverformat"), u("yhoverformat"), u("text"), u("hovertext"), u("hovertemplate"), o(e, t, u, c), u("hoverongaps"), u("connectgaps", n.isArray1D(t.z) && !1 !== t.zsmooth), l(e, t, c, u, {
          prefix: "",
          cLetter: "z"
        })) : t.visible = !1;
      };
    }, {
      "../../components/colorscale/defaults": 106,
      "../../lib": 225,
      "../scatter/period_defaults": 363,
      "./attributes": 319,
      "./style_defaults": 332,
      "./xyz_defaults": 333
    }],
    325: [function (e, t, r) {
      "use strict";

      var n = e("../../lib").maxRowLength;
      t.exports = function (e) {
        var t,
          r,
          a,
          i,
          o,
          l,
          s,
          c,
          u = [],
          d = {},
          f = [],
          h = e[0],
          p = [],
          g = [0, 0, 0],
          m = n(e);
        for (r = 0; r < e.length; r++) for (t = p, p = h, h = e[r + 1] || [], a = 0; a < m; a++) void 0 === p[a] && ((l = (void 0 !== p[a - 1] ? 1 : 0) + (void 0 !== p[a + 1] ? 1 : 0) + (void 0 !== t[a] ? 1 : 0) + (void 0 !== h[a] ? 1 : 0)) ? (0 === r && l++, 0 === a && l++, r === e.length - 1 && l++, a === p.length - 1 && l++, l < 4 && (d[[r, a]] = [r, a, l]), u.push([r, a, l])) : f.push([r, a]));
        for (; f.length;) {
          for (s = {}, c = !1, o = f.length - 1; o >= 0; o--) (l = ((d[[(r = (i = f[o])[0]) - 1, a = i[1]]] || g)[2] + (d[[r + 1, a]] || g)[2] + (d[[r, a - 1]] || g)[2] + (d[[r, a + 1]] || g)[2]) / 20) && (s[i] = [r, a, l], f.splice(o, 1), c = !0);
          if (!c) throw "findEmpties iterated with no new neighbors";
          for (i in s) d[i] = s[i], u.push(s[i]);
        }
        return u.sort(function (e, t) {
          return t[2] - e[2];
        });
      };
    }, {
      "../../lib": 225
    }],
    326: [function (e, t, r) {
      "use strict";

      var n = e("../../components/fx"),
        a = e("../../lib"),
        i = e("../../plots/cartesian/axes"),
        o = e("../../components/colorscale").extractOpts;
      t.exports = function (e, t, r, l, s) {
        s || (s = {});
        var c,
          u,
          d,
          f,
          h = s.isContour,
          p = e.cd[0],
          g = p.trace,
          m = e.xa,
          y = e.ya,
          v = p.x,
          x = p.y,
          b = p.z,
          _ = p.xCenter,
          w = p.yCenter,
          M = p.zmask,
          T = g.zhoverformat,
          k = v,
          A = x;
        if (!1 !== e.index) {
          try {
            d = Math.round(e.index[1]), f = Math.round(e.index[0]);
          } catch (t) {
            return void a.error("Error hovering on heatmap, pointNumber must be [row,col], found:", e.index);
          }
          if (d < 0 || d >= b[0].length || f < 0 || f > b.length) return;
        } else {
          if (n.inbox(t - v[0], t - v[v.length - 1], 0) > 0 || n.inbox(r - x[0], r - x[x.length - 1], 0) > 0) return;
          if (h) {
            var L;
            for (k = [2 * v[0] - v[1]], L = 1; L < v.length; L++) k.push((v[L] + v[L - 1]) / 2);
            for (k.push([2 * v[v.length - 1] - v[v.length - 2]]), A = [2 * x[0] - x[1]], L = 1; L < x.length; L++) A.push((x[L] + x[L - 1]) / 2);
            A.push([2 * x[x.length - 1] - x[x.length - 2]]);
          }
          d = Math.max(0, Math.min(k.length - 2, a.findBin(t, k))), f = Math.max(0, Math.min(A.length - 2, a.findBin(r, A)));
        }
        var D,
          S,
          C = m.c2p(v[d]),
          O = m.c2p(v[d + 1]),
          P = y.c2p(x[f]),
          I = y.c2p(x[f + 1]);
        h ? (D = p.orig_x || v, S = p.orig_y || x, O = C, c = D[d], I = P, u = S[f]) : (D = p.orig_x || _ || v, S = p.orig_y || w || x, c = _ ? D[d] : (D[d] + D[d + 1]) / 2, u = w ? S[f] : (S[f] + S[f + 1]) / 2, m && "category" === m.type && (c = v[d]), y && "category" === y.type && (u = x[f]), g.zsmooth && (C = O = m.c2p(c), P = I = y.c2p(u)));
        var z = b[f][d];
        if (M && !M[f][d] && (z = void 0), void 0 !== z || g.hoverongaps) {
          var R;
          Array.isArray(p.hovertext) && Array.isArray(p.hovertext[f]) ? R = p.hovertext[f][d] : Array.isArray(p.text) && Array.isArray(p.text[f]) && (R = p.text[f][d]);
          var N = o(g),
            F = {
              type: "linear",
              range: [N.min, N.max],
              hoverformat: T,
              _separators: m._separators,
              _numFormat: m._numFormat
            },
            E = i.tickText(F, z, "hover").text;
          return [a.extendFlat(e, {
            index: g._after2before ? g._after2before[f][d] : [f, d],
            distance: e.maxHoverDistance,
            spikeDistance: e.maxSpikeDistance,
            x0: C,
            x1: O,
            y0: P,
            y1: I,
            xLabelVal: c,
            yLabelVal: u,
            zLabelVal: z,
            zLabel: E,
            text: R
          })];
        }
      };
    }, {
      "../../components/colorscale": 108,
      "../../components/fx": 136,
      "../../lib": 225,
      "../../plots/cartesian/axes": 272
    }],
    327: [function (e, t, r) {
      "use strict";

      t.exports = {
        attributes: e("./attributes"),
        supplyDefaults: e("./defaults"),
        calc: e("./calc"),
        plot: e("./plot"),
        colorbar: e("./colorbar"),
        style: e("./style"),
        hoverPoints: e("./hover"),
        moduleType: "trace",
        name: "heatmap",
        basePlotModule: e("../../plots/cartesian"),
        categories: ["cartesian", "svg", "2dMap", "showLegend"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 286,
      "./attributes": 319,
      "./calc": 320,
      "./colorbar": 322,
      "./defaults": 324,
      "./hover": 326,
      "./plot": 330,
      "./style": 331
    }],
    328: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = [[-1, 0], [1, 0], [0, -1], [0, 1]];
      function i(e) {
        return .5 - .25 * Math.min(1, .5 * e);
      }
      function o(e, t, r) {
        var n,
          i,
          o,
          l,
          s,
          c,
          u,
          d,
          f,
          h,
          p,
          g,
          m,
          y = 0;
        for (l = 0; l < t.length; l++) {
          for (i = (n = t[l])[0], o = n[1], p = e[i][o], h = 0, f = 0, s = 0; s < 4; s++) (u = e[i + (c = a[s])[0]]) && void 0 !== (d = u[o + c[1]]) && (0 === h ? g = m = d : (g = Math.min(g, d), m = Math.max(m, d)), f++, h += d);
          if (0 === f) throw "iterateInterp2d order is wrong: no defined neighbors";
          e[i][o] = h / f, void 0 === p ? f < 4 && (y = 1) : (e[i][o] = (1 + r) * e[i][o] - r * p, m > g && (y = Math.max(y, Math.abs(e[i][o] - p) / (m - g))));
        }
        return y;
      }
      t.exports = function (e, t) {
        var r,
          a = 1;
        for (o(e, t), r = 0; r < t.length && !(t[r][2] < 4); r++);
        for (t = t.slice(r), r = 0; r < 100 && a > .01; r++) a = o(e, t, i(a));
        return a > .01 && n.log("interp2d didn't converge quickly", a), e;
      };
    }, {
      "../../lib": 225
    }],
    329: [function (e, t, r) {
      "use strict";

      var n = e("../../registry"),
        a = e("../../lib").isArrayOrTypedArray;
      t.exports = function (e, t, r, i, o, l) {
        var s,
          c,
          u,
          d = [],
          f = n.traceIs(e, "contour"),
          h = n.traceIs(e, "histogram"),
          p = n.traceIs(e, "gl2d");
        if (a(t) && t.length > 1 && !h && "category" !== l.type) {
          var g = t.length;
          if (!(g <= o)) return f ? t.slice(0, o) : t.slice(0, o + 1);
          if (f || p) d = t.slice(0, o);else if (1 === o) d = [t[0] - .5, t[0] + .5];else {
            for (d = [1.5 * t[0] - .5 * t[1]], u = 1; u < g; u++) d.push(.5 * (t[u - 1] + t[u]));
            d.push(1.5 * t[g - 1] - .5 * t[g - 2]);
          }
          if (g < o) {
            var m = d[d.length - 1],
              y = m - d[d.length - 2];
            for (u = g; u < o; u++) m += y, d.push(m);
          }
        } else {
          var v = e[l._id.charAt(0) + "calendar"];
          if (h) s = l.r2c(r, 0, v);else if (a(t) && 1 === t.length) s = t[0];else if (void 0 === r) s = 0;else {
            s = ("log" === l.type ? l.d2c : l.r2c)(r, 0, v);
          }
          for (c = i || 1, u = f || p ? 0 : -.5; u < o; u++) d.push(s + c * u);
        }
        return d;
      };
    }, {
      "../../lib": 225,
      "../../registry": 309
    }],
    330: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("tinycolor2"),
        i = e("../../registry"),
        o = e("../../lib"),
        l = e("../../components/colorscale").makeColorScaleFuncFromTrace,
        s = e("../../constants/xmlns_namespaces");
      function c(e, t) {
        var r = t.length - 2,
          n = o.constrain(o.findBin(e, t), 0, r),
          a = t[n],
          i = t[n + 1],
          l = o.constrain(n + (e - a) / (i - a) - .5, 0, r),
          s = Math.round(l),
          c = Math.abs(l - s);
        return l && l !== r && c ? {
          bin0: s,
          frac: c,
          bin1: Math.round(s + c / (l - s))
        } : {
          bin0: s,
          bin1: s,
          frac: 0
        };
      }
      function u(e, t) {
        var r = t.length - 1,
          n = o.constrain(o.findBin(e, t), 0, r),
          a = t[n],
          i = (e - a) / (t[n + 1] - a) || 0;
        return i <= 0 ? {
          bin0: n,
          bin1: n,
          frac: 0
        } : i < .5 ? {
          bin0: n,
          bin1: n + 1,
          frac: i
        } : {
          bin0: n + 1,
          bin1: n,
          frac: 1 - i
        };
      }
      function d(e, t, r) {
        e[t] = r[0], e[t + 1] = r[1], e[t + 2] = r[2], e[t + 3] = Math.round(255 * r[3]);
      }
      t.exports = function (e, t, r, f) {
        var h = t.xaxis,
          p = t.yaxis;
        o.makeTraceGroups(f, r, "hm").each(function (t) {
          var r,
            f,
            g,
            m,
            y,
            v,
            x = n.select(this),
            b = t[0],
            _ = b.trace,
            w = b.z,
            M = b.x,
            T = b.y,
            k = b.xCenter,
            A = b.yCenter,
            L = i.traceIs(_, "contour"),
            D = L ? "best" : _.zsmooth,
            S = w.length,
            C = o.maxRowLength(w),
            O = !1,
            P = !1;
          for (v = 0; void 0 === r && v < M.length - 1;) r = h.c2p(M[v]), v++;
          for (v = M.length - 1; void 0 === f && v > 0;) f = h.c2p(M[v]), v--;
          for (f < r && (g = f, f = r, r = g, O = !0), v = 0; void 0 === m && v < T.length - 1;) m = p.c2p(T[v]), v++;
          for (v = T.length - 1; void 0 === y && v > 0;) y = p.c2p(T[v]), v--;
          if (y < m && (g = m, m = y, y = g, P = !0), L && (k = M, A = T, M = b.xfill, T = b.yfill), "fast" !== D) {
            var I = "best" === D ? 0 : .5;
            r = Math.max(-I * h._length, r), f = Math.min((1 + I) * h._length, f), m = Math.max(-I * p._length, m), y = Math.min((1 + I) * p._length, y);
          }
          var z = Math.round(f - r),
            R = Math.round(y - m);
          if (z <= 0 || R <= 0) {
            x.selectAll("image").data([]).exit().remove();
          } else {
            var N, F;
            "fast" === D ? (N = C, F = S) : (N = z, F = R);
            var E = document.createElement("canvas");
            E.width = N, E.height = F;
            var j,
              H,
              B = E.getContext("2d"),
              Y = l(_, {
                noNumericCheck: !0,
                returnArray: !0
              });
            "fast" === D ? (j = O ? function (e) {
              return C - 1 - e;
            } : o.identity, H = P ? function (e) {
              return S - 1 - e;
            } : o.identity) : (j = function j(e) {
              return o.constrain(Math.round(h.c2p(M[e]) - r), 0, z);
            }, H = function H(e) {
              return o.constrain(Math.round(p.c2p(T[e]) - m), 0, R);
            });
            var U,
              V,
              q,
              G,
              Z,
              W = H(0),
              J = [W, W],
              X = O ? 0 : 1,
              Q = P ? 0 : 1,
              K = 0,
              $ = 0,
              ee = 0,
              te = 0;
            if (D) {
              var re,
                ne = 0;
              try {
                re = new Uint8Array(z * R * 4);
              } catch (e) {
                re = new Array(z * R * 4);
              }
              if ("best" === D) {
                var ae,
                  ie,
                  oe,
                  le = k || M,
                  se = A || T,
                  ce = new Array(le.length),
                  ue = new Array(se.length),
                  de = new Array(z),
                  fe = k ? u : c,
                  he = A ? u : c;
                for (v = 0; v < le.length; v++) ce[v] = Math.round(h.c2p(le[v]) - r);
                for (v = 0; v < se.length; v++) ue[v] = Math.round(p.c2p(se[v]) - m);
                for (v = 0; v < z; v++) de[v] = fe(v, ce);
                for (V = 0; V < R; V++) for (ie = w[(ae = he(V, ue)).bin0], oe = w[ae.bin1], v = 0; v < z; v++, ne += 4) d(re, ne, Z = Te(ie, oe, de[v], ae));
              } else for (V = 0; V < S; V++) for (G = w[V], J = H(V), v = 0; v < z; v++) Z = Me(G[v], 1), d(re, ne = 4 * (J * z + j(v)), Z);
              var pe = B.createImageData(z, R);
              try {
                pe.data.set(re);
              } catch (e) {
                var ge = pe.data,
                  me = ge.length;
                for (V = 0; V < me; V++) ge[V] = re[V];
              }
              B.putImageData(pe, 0, 0);
            } else {
              var ye = _.xgap,
                ve = _.ygap,
                xe = Math.floor(ye / 2),
                be = Math.floor(ve / 2);
              for (V = 0; V < S; V++) if (G = w[V], J.reverse(), J[Q] = H(V + 1), J[0] !== J[1] && void 0 !== J[0] && void 0 !== J[1]) for (U = [q = j(0), q], v = 0; v < C; v++) U.reverse(), U[X] = j(v + 1), U[0] !== U[1] && void 0 !== U[0] && void 0 !== U[1] && (Z = Me(G[v], (U[1] - U[0]) * (J[1] - J[0])), B.fillStyle = "rgba(" + Z.join(",") + ")", B.fillRect(U[0] + xe, J[0] + be, U[1] - U[0] - ye, J[1] - J[0] - ve));
            }
            $ = Math.round($ / K), ee = Math.round(ee / K), te = Math.round(te / K);
            var _e = a("rgb(" + $ + "," + ee + "," + te + ")");
            e._hmpixcount = (e._hmpixcount || 0) + K, e._hmlumcount = (e._hmlumcount || 0) + K * _e.getLuminance();
            var we = x.selectAll("image").data(t);
            we.enter().append("svg:image").attr({
              xmlns: s.svg,
              preserveAspectRatio: "none"
            }), we.attr({
              height: R,
              width: z,
              x: r,
              y: m,
              "xlink:href": E.toDataURL("image/png")
            });
          }
          function Me(e, t) {
            if (void 0 !== e) {
              var r = Y(e);
              return r[0] = Math.round(r[0]), r[1] = Math.round(r[1]), r[2] = Math.round(r[2]), K += t, $ += r[0] * t, ee += r[1] * t, te += r[2] * t, r;
            }
            return [0, 0, 0, 0];
          }
          function Te(e, t, r, n) {
            var a = e[r.bin0];
            if (void 0 === a) return Me(void 0, 1);
            var i,
              o = e[r.bin1],
              l = t[r.bin0],
              s = t[r.bin1],
              c = o - a || 0,
              u = l - a || 0;
            return i = void 0 === o ? void 0 === s ? 0 : void 0 === l ? 2 * (s - a) : 2 * (2 * s - l - a) / 3 : void 0 === s ? void 0 === l ? 0 : 2 * (2 * a - o - l) / 3 : void 0 === l ? 2 * (2 * s - o - a) / 3 : s + a - o - l, Me(a + r.frac * c + n.frac * (u + r.frac * i));
          }
        });
      };
    }, {
      "../../components/colorscale": 108,
      "../../constants/xmlns_namespaces": 206,
      "../../lib": 225,
      "../../registry": 309,
      "@plotly/d3": 6,
      tinycolor2: 61
    }],
    331: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3");
      t.exports = function (e) {
        n.select(e).selectAll(".hm image").style("opacity", function (e) {
          return e.trace.opacity;
        });
      };
    }, {
      "@plotly/d3": 6
    }],
    332: [function (e, t, r) {
      "use strict";

      t.exports = function (e, t, r) {
        !1 === r("zsmooth") && (r("xgap"), r("ygap")), r("zhoverformat");
      };
    }, {}],
    333: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib"),
        i = e("../../registry");
      function o(e, t) {
        var r = t(e);
        return "scaled" === (r ? t(e + "type", "array") : "scaled") && (t(e + "0"), t("d" + e)), r;
      }
      t.exports = function (e, t, r, l, s, c) {
        var u,
          d,
          f = r("z");
        if (s = s || "x", c = c || "y", void 0 === f || !f.length) return 0;
        if (a.isArray1D(e.z)) {
          u = r(s), d = r(c);
          var h = a.minRowLength(u),
            p = a.minRowLength(d);
          if (0 === h || 0 === p) return 0;
          t._length = Math.min(h, p, f.length);
        } else {
          if (u = o(s, r), d = o(c, r), !function (e) {
            for (var t, r = !0, i = !1, o = !1, l = 0; l < e.length; l++) {
              if (t = e[l], !a.isArrayOrTypedArray(t)) {
                r = !1;
                break;
              }
              t.length > 0 && (i = !0);
              for (var s = 0; s < t.length; s++) if (n(t[s])) {
                o = !0;
                break;
              }
            }
            return r && i && o;
          }(f)) return 0;
          r("transpose"), t._length = null;
        }
        return "heatmapgl" === e.type || i.getComponentMethod("calendars", "handleTraceDefaults")(e, t, [s, c], l), !0;
      };
    }, {
      "../../lib": 225,
      "../../registry": 309,
      "fast-isnumeric": 11
    }],
    334: [function (e, t, r) {
      "use strict";

      t.exports = function (e, t) {
        for (var r = e.length, n = 0, a = 0; a < r; a++) t[a] ? (e[a] /= t[a], n += e[a]) : e[a] = null;
        return n;
      };
    }, {}],
    335: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric");
      t.exports = {
        count: function count(e, t, r) {
          return r[e]++, 1;
        },
        sum: function sum(e, t, r, a) {
          var i = a[t];
          return n(i) ? (i = Number(i), r[e] += i, i) : 0;
        },
        avg: function avg(e, t, r, a, i) {
          var o = a[t];
          return n(o) && (o = Number(o), r[e] += o, i[e]++), 0;
        },
        min: function min(e, t, r, a) {
          var i = a[t];
          if (n(i)) {
            if (i = Number(i), !n(r[e])) return r[e] = i, i;
            if (r[e] > i) {
              var o = i - r[e];
              return r[e] = i, o;
            }
          }
          return 0;
        },
        max: function max(e, t, r, a) {
          var i = a[t];
          if (n(i)) {
            if (i = Number(i), !n(r[e])) return r[e] = i, i;
            if (r[e] < i) {
              var o = i - r[e];
              return r[e] = i, o;
            }
          }
          return 0;
        }
      };
    }, {
      "fast-isnumeric": 11
    }],
    336: [function (e, t, r) {
      "use strict";

      var n = e("../../constants/numerical"),
        a = n.ONEAVGYEAR,
        i = n.ONEAVGMONTH,
        o = n.ONEDAY,
        l = n.ONEHOUR,
        s = n.ONEMIN,
        c = n.ONESEC,
        u = e("../../plots/cartesian/axes").tickIncrement;
      function d(e, t, r, n) {
        if (e * t <= 0) return 1 / 0;
        for (var a = Math.abs(t - e), i = "date" === r.type, o = f(a, i), l = 0; l < 10; l++) {
          var s = f(80 * o, i);
          if (o === s) break;
          if (!h(s, e, t, i, r, n)) break;
          o = s;
        }
        return o;
      }
      function f(e, t) {
        return t && e > c ? e > o ? e > 1.1 * a ? a : e > 1.1 * i ? i : o : e > l ? l : e > s ? s : c : Math.pow(10, Math.floor(Math.log(e) / Math.LN10));
      }
      function h(e, t, r, n, i, l) {
        if (n && e > o) {
          var s = p(t, i, l),
            c = p(r, i, l),
            u = e === a ? 0 : 1;
          return s[u] !== c[u];
        }
        return Math.floor(r / e) - Math.floor(t / e) > .1;
      }
      function p(e, t, r) {
        var n = t.c2d(e, a, r).split("-");
        return "" === n[0] && (n.unshift(), n[0] = "-" + n[0]), n;
      }
      t.exports = function (e, t, r, n, i) {
        var l,
          s,
          c = -1.1 * t,
          f = -.1 * t,
          h = e - f,
          p = r[0],
          g = r[1],
          m = Math.min(d(p + f, p + h, n, i), d(g + f, g + h, n, i)),
          y = Math.min(d(p + c, p + f, n, i), d(g + c, g + f, n, i));
        if (m > y && y < Math.abs(g - p) / 4e3 ? (l = m, s = !1) : (l = Math.min(m, y), s = !0), "date" === n.type && l > o) {
          var v = l === a ? 1 : 6,
            x = l === a ? "M12" : "M1";
          return function (t, r) {
            var o = n.c2d(t, a, i),
              l = o.indexOf("-", v);
            l > 0 && (o = o.substr(0, l));
            var c = n.d2c(o, 0, i);
            if (c < t) {
              var d = u(c, x, !1, i);
              (c + d) / 2 < t + e && (c = d);
            }
            return r && s ? u(c, x, !0, i) : c;
          };
        }
        return function (t, r) {
          var n = l * Math.round(t / l);
          return n + l / 10 < t && n + .9 * l < t + e && (n += l), r && s && (n -= l), n;
        };
      };
    }, {
      "../../constants/numerical": 205,
      "../../plots/cartesian/axes": 272
    }],
    337: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib"),
        i = e("../../registry"),
        o = e("../../plots/cartesian/axes"),
        l = e("../bar/arrays_to_calcdata"),
        s = e("./bin_functions"),
        c = e("./norm_functions"),
        u = e("./average"),
        d = e("./bin_label_vals");
      function f(e, t, r, l, s) {
        var c,
          u,
          d,
          h,
          p,
          g,
          m,
          y = l + "bins",
          v = e._fullLayout,
          x = t["_" + l + "bingroup"],
          b = v._histogramBinOpts[x],
          _ = "overlay" === v.barmode,
          w = function w(e) {
            return r.r2c(e, 0, h);
          },
          M = function M(e) {
            return r.c2r(e, 0, h);
          },
          T = "date" === r.type ? function (e) {
            return e || 0 === e ? a.cleanDate(e, null, h) : null;
          } : function (e) {
            return n(e) ? Number(e) : null;
          };
        function k(e, t, r) {
          t[e + "Found"] ? (t[e] = T(t[e]), null === t[e] && (t[e] = r[e])) : (g[e] = t[e] = r[e], a.nestedProperty(u[0], y + "." + e).set(r[e]));
        }
        if (t["_" + l + "autoBinFinished"]) delete t["_" + l + "autoBinFinished"];else {
          u = b.traces;
          var A = [],
            L = !0,
            D = !1,
            S = !1;
          for (c = 0; c < u.length; c++) if ((d = u[c]).visible) {
            var C = b.dirs[c];
            p = d["_" + C + "pos0"] = r.makeCalcdata(d, C), A = a.concat(A, p), delete d["_" + l + "autoBinFinished"], !0 === t.visible && (L ? L = !1 : (delete d._autoBin, d["_" + l + "autoBinFinished"] = 1), i.traceIs(d, "2dMap") && (D = !0), "histogram2dcontour" === d.type && (S = !0));
          }
          h = u[0][l + "calendar"];
          var O = o.autoBin(A, r, b.nbins, D, h, b.sizeFound && b.size),
            P = u[0]._autoBin = {};
          if (g = P[b.dirs[0]] = {}, S && (b.size || (O.start = M(o.tickIncrement(w(O.start), O.size, !0, h))), void 0 === b.end && (O.end = M(o.tickIncrement(w(O.end), O.size, !1, h)))), _ && !i.traceIs(t, "2dMap") && 0 === O._dataSpan && "category" !== r.type && "multicategory" !== r.type) {
            if (s) return [O, p, !0];
            O = function (e, t, r, n, i) {
              var o,
                l,
                s,
                c = e._fullLayout,
                u = function (e, t) {
                  for (var r = t.xaxis, n = t.yaxis, a = t.orientation, i = [], o = e._fullData, l = 0; l < o.length; l++) {
                    var s = o[l];
                    "histogram" === s.type && !0 === s.visible && s.orientation === a && s.xaxis === r && s.yaxis === n && i.push(s);
                  }
                  return i;
                }(e, t),
                d = !1,
                h = 1 / 0,
                p = [t];
              for (o = 0; o < u.length; o++) if ((l = u[o]) === t) d = !0;else if (d) {
                var g = f(e, l, r, n, !0),
                  m = g[0],
                  y = g[2];
                l["_" + n + "autoBinFinished"] = 1, l["_" + n + "pos0"] = g[1], y ? p.push(l) : h = Math.min(h, m.size);
              } else s = c._histogramBinOpts[l["_" + n + "bingroup"]], h = Math.min(h, s.size || l[i].size);
              var v = new Array(p.length);
              for (o = 0; o < p.length; o++) for (var x = p[o]["_" + n + "pos0"], b = 0; b < x.length; b++) if (void 0 !== x[b]) {
                v[o] = x[b];
                break;
              }
              isFinite(h) || (h = a.distinctVals(v).minDiff);
              for (o = 0; o < p.length; o++) {
                var _ = (l = p[o])[n + "calendar"],
                  w = {
                    start: r.c2r(v[o] - h / 2, 0, _),
                    end: r.c2r(v[o] + h / 2, 0, _),
                    size: h
                  };
                l._input[i] = l[i] = w, (s = c._histogramBinOpts[l["_" + n + "bingroup"]]) && a.extendFlat(s, w);
              }
              return t[i];
            }(e, t, r, l, y);
          }
          (m = d.cumulative || {}).enabled && "include" !== m.currentbin && ("decreasing" === m.direction ? O.start = M(o.tickIncrement(w(O.start), O.size, !0, h)) : O.end = M(o.tickIncrement(w(O.end), O.size, !1, h))), b.size = O.size, b.sizeFound || (g.size = O.size, a.nestedProperty(u[0], y + ".size").set(O.size)), k("start", b, O), k("end", b, O);
        }
        p = t["_" + l + "pos0"], delete t["_" + l + "pos0"];
        var I = t._input[y] || {},
          z = a.extendFlat({}, b),
          R = b.start,
          N = r.r2l(I.start),
          F = void 0 !== N;
        if ((b.startFound || F) && N !== r.r2l(R)) {
          var E = F ? N : a.aggNums(Math.min, null, p),
            j = {
              type: "category" === r.type || "multicategory" === r.type ? "linear" : r.type,
              r2l: r.r2l,
              dtick: b.size,
              tick0: R,
              calendar: h,
              range: [E, o.tickIncrement(E, b.size, !1, h)].map(r.l2r)
            },
            H = o.tickFirst(j);
          H > r.r2l(E) && (H = o.tickIncrement(H, b.size, !0, h)), z.start = r.l2r(H), F || a.nestedProperty(t, y + ".start").set(z.start);
        }
        var B = b.end,
          Y = r.r2l(I.end),
          U = void 0 !== Y;
        if ((b.endFound || U) && Y !== r.r2l(B)) {
          var V = U ? Y : a.aggNums(Math.max, null, p);
          z.end = r.l2r(V), U || a.nestedProperty(t, y + ".start").set(z.end);
        }
        var q = "autobin" + l;
        return !1 === t._input[q] && (t._input[y] = a.extendFlat({}, t[y] || {}), delete t._input[q], delete t[q]), [z, p];
      }
      t.exports = {
        calc: function calc(e, t) {
          var r,
            i,
            h,
            p,
            g = [],
            m = [],
            y = o.getFromId(e, "h" === t.orientation ? t.yaxis : t.xaxis),
            v = "h" === t.orientation ? "y" : "x",
            x = {
              x: "y",
              y: "x"
            }[v],
            b = t[v + "calendar"],
            _ = t.cumulative,
            w = f(e, t, y, v),
            M = w[0],
            T = w[1],
            k = "string" == typeof M.size,
            A = [],
            L = k ? A : M,
            D = [],
            S = [],
            C = [],
            O = 0,
            P = t.histnorm,
            I = t.histfunc,
            z = -1 !== P.indexOf("density");
          _.enabled && z && (P = P.replace(/ ?density$/, ""), z = !1);
          var R,
            N = "max" === I || "min" === I ? null : 0,
            F = s.count,
            E = c[P],
            j = !1,
            H = function H(e) {
              return y.r2c(e, 0, b);
            };
          for (a.isArrayOrTypedArray(t[x]) && "count" !== I && (R = t[x], j = "avg" === I, F = s[I]), r = H(M.start), h = H(M.end) + (r - o.tickIncrement(r, M.size, !1, b)) / 1e6; r < h && g.length < 1e6 && (i = o.tickIncrement(r, M.size, !1, b), g.push((r + i) / 2), m.push(N), C.push([]), A.push(r), z && D.push(1 / (i - r)), j && S.push(0), !(i <= r));) r = i;
          A.push(r), k || "date" !== y.type || (L = {
            start: H(L.start),
            end: H(L.end),
            size: L.size
          }), e._fullLayout._roundFnOpts || (e._fullLayout._roundFnOpts = {});
          var B = t["_" + v + "bingroup"],
            Y = {
              leftGap: 1 / 0,
              rightGap: 1 / 0
            };
          B && (e._fullLayout._roundFnOpts[B] || (e._fullLayout._roundFnOpts[B] = Y), Y = e._fullLayout._roundFnOpts[B]);
          var U,
            V = m.length,
            q = !0,
            G = Y.leftGap,
            Z = Y.rightGap,
            W = {};
          for (r = 0; r < T.length; r++) {
            var J = T[r];
            (p = a.findBin(J, L)) >= 0 && p < V && (O += F(p, r, m, R, S), q && C[p].length && J !== T[C[p][0]] && (q = !1), C[p].push(r), W[r] = p, G = Math.min(G, J - A[p]), Z = Math.min(Z, A[p + 1] - J));
          }
          Y.leftGap = G, Y.rightGap = Z, q || (U = function U(t, r) {
            return function () {
              var n = e._fullLayout._roundFnOpts[B];
              return d(n.leftGap, n.rightGap, A, y, b)(t, r);
            };
          }), j && (O = u(m, S)), E && E(m, O, D), _.enabled && function (e, t, r) {
            var n, a, i;
            function o(t) {
              i = e[t], e[t] /= 2;
            }
            function l(t) {
              a = e[t], e[t] = i + a / 2, i += a;
            }
            if ("half" === r) {
              if ("increasing" === t) for (o(0), n = 1; n < e.length; n++) l(n);else for (o(e.length - 1), n = e.length - 2; n >= 0; n--) l(n);
            } else if ("increasing" === t) {
              for (n = 1; n < e.length; n++) e[n] += e[n - 1];
              "exclude" === r && (e.unshift(0), e.pop());
            } else {
              for (n = e.length - 2; n >= 0; n--) e[n] += e[n + 1];
              "exclude" === r && (e.push(0), e.shift());
            }
          }(m, _.direction, _.currentbin);
          var X = Math.min(g.length, m.length),
            Q = [],
            K = 0,
            $ = X - 1;
          for (r = 0; r < X; r++) if (m[r]) {
            K = r;
            break;
          }
          for (r = X - 1; r >= K; r--) if (m[r]) {
            $ = r;
            break;
          }
          for (r = K; r <= $; r++) if (n(g[r]) && n(m[r])) {
            var ee = {
              p: g[r],
              s: m[r],
              b: 0
            };
            _.enabled || (ee.pts = C[r], q ? ee.ph0 = ee.ph1 = C[r].length ? T[C[r][0]] : g[r] : (t._computePh = !0, ee.ph0 = U(A[r]), ee.ph1 = U(A[r + 1], !0))), Q.push(ee);
          }
          return 1 === Q.length && (Q[0].width1 = o.tickIncrement(Q[0].p, M.size, !1, b) - Q[0].p), l(Q, t), a.isArrayOrTypedArray(t.selectedpoints) && a.tagSelected(Q, t, W), Q;
        },
        calcAllAutoBins: f
      };
    }, {
      "../../lib": 225,
      "../../plots/cartesian/axes": 272,
      "../../registry": 309,
      "../bar/arrays_to_calcdata": 318,
      "./average": 334,
      "./bin_functions": 335,
      "./bin_label_vals": 336,
      "./norm_functions": 338,
      "fast-isnumeric": 11
    }],
    338: [function (e, t, r) {
      "use strict";

      t.exports = {
        percent: function percent(e, t) {
          for (var r = e.length, n = 100 / t, a = 0; a < r; a++) e[a] *= n;
        },
        probability: function probability(e, t) {
          for (var r = e.length, n = 0; n < r; n++) e[n] /= t;
        },
        density: function density(e, t, r, n) {
          var a = e.length;
          n = n || 1;
          for (var i = 0; i < a; i++) e[i] *= r[i] * n;
        },
        "probability density": function probability_density(e, t, r, n) {
          var a = e.length;
          n && (t /= n);
          for (var i = 0; i < a; i++) e[i] *= r[i] / t;
        }
      };
    }, {}],
    339: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../plots/cartesian/axes"),
        i = e("../histogram/bin_functions"),
        o = e("../histogram/norm_functions"),
        l = e("../histogram/average"),
        s = e("../histogram/bin_label_vals"),
        c = e("../histogram/calc").calcAllAutoBins;
      function u(e, t, r, n) {
        var a,
          i = new Array(e);
        if (n) for (a = 0; a < e; a++) i[a] = 1 / (t[a + 1] - t[a]);else {
          var o = 1 / r;
          for (a = 0; a < e; a++) i[a] = o;
        }
        return i;
      }
      function d(e, t) {
        return {
          start: e(t.start),
          end: e(t.end),
          size: t.size
        };
      }
      function f(e, t, r, n, a, i) {
        var o,
          l = e.length - 1,
          c = new Array(l),
          u = s(r, n, e, a, i);
        for (o = 0; o < l; o++) {
          var d = (t || [])[o];
          c[o] = void 0 === d ? [u(e[o]), u(e[o + 1], !0)] : [d, d];
        }
        return c;
      }
      t.exports = function (e, t) {
        var r,
          s,
          h,
          p,
          g = a.getFromId(e, t.xaxis),
          m = a.getFromId(e, t.yaxis),
          y = t.xcalendar,
          v = t.ycalendar,
          x = function x(e) {
            return g.r2c(e, 0, y);
          },
          b = function b(e) {
            return m.r2c(e, 0, v);
          },
          _ = c(e, t, g, "x"),
          w = _[0],
          M = _[1],
          T = c(e, t, m, "y"),
          k = T[0],
          A = T[1],
          L = t._length;
        M.length > L && M.splice(L, M.length - L), A.length > L && A.splice(L, A.length - L);
        var D = [],
          S = [],
          C = [],
          O = "string" == typeof w.size,
          P = "string" == typeof k.size,
          I = [],
          z = [],
          R = O ? I : w,
          N = P ? z : k,
          F = 0,
          E = [],
          j = [],
          H = t.histnorm,
          B = t.histfunc,
          Y = -1 !== H.indexOf("density"),
          U = "max" === B || "min" === B ? null : 0,
          V = i.count,
          q = o[H],
          G = !1,
          Z = [],
          W = [],
          J = "z" in t ? t.z : "marker" in t && Array.isArray(t.marker.color) ? t.marker.color : "";
        J && "count" !== B && (G = "avg" === B, V = i[B]);
        var X = w.size,
          Q = x(w.start),
          K = x(w.end) + (Q - a.tickIncrement(Q, X, !1, y)) / 1e6;
        for (r = Q; r < K; r = a.tickIncrement(r, X, !1, y)) S.push(U), I.push(r), G && C.push(0);
        I.push(r);
        var $,
          ee = S.length,
          te = (r - Q) / ee,
          re = ($ = Q + te / 2, g.c2r($, 0, y)),
          ne = k.size,
          ae = b(k.start),
          ie = b(k.end) + (ae - a.tickIncrement(ae, ne, !1, v)) / 1e6;
        for (r = ae; r < ie; r = a.tickIncrement(r, ne, !1, v)) {
          D.push(S.slice()), z.push(r);
          var oe = new Array(ee);
          for (s = 0; s < ee; s++) oe[s] = [];
          j.push(oe), G && E.push(C.slice());
        }
        z.push(r);
        var le = D.length,
          se = (r - ae) / le,
          ce = function (e) {
            return m.c2r(e, 0, v);
          }(ae + se / 2);
        Y && (Z = u(S.length, R, te, O), W = u(D.length, N, se, P)), O || "date" !== g.type || (R = d(x, R)), P || "date" !== m.type || (N = d(b, N));
        var ue = !0,
          de = !0,
          fe = new Array(ee),
          he = new Array(le),
          pe = 1 / 0,
          ge = 1 / 0,
          me = 1 / 0,
          ye = 1 / 0;
        for (r = 0; r < L; r++) {
          var ve = M[r],
            xe = A[r];
          h = n.findBin(ve, R), p = n.findBin(xe, N), h >= 0 && h < ee && p >= 0 && p < le && (F += V(h, r, D[p], J, E[p]), j[p][h].push(r), ue && (void 0 === fe[h] ? fe[h] = ve : fe[h] !== ve && (ue = !1)), de && (void 0 === he[p] ? he[p] = xe : he[p] !== xe && (de = !1)), pe = Math.min(pe, ve - I[h]), ge = Math.min(ge, I[h + 1] - ve), me = Math.min(me, xe - z[p]), ye = Math.min(ye, z[p + 1] - xe));
        }
        if (G) for (p = 0; p < le; p++) F += l(D[p], E[p]);
        if (q) for (p = 0; p < le; p++) q(D[p], F, Z, W[p]);
        return {
          x: M,
          xRanges: f(I, ue && fe, pe, ge, g, y),
          x0: re,
          dx: te,
          y: A,
          yRanges: f(z, de && he, me, ye, m, v),
          y0: ce,
          dy: se,
          z: D,
          pts: j
        };
      };
    }, {
      "../../lib": 225,
      "../../plots/cartesian/axes": 272,
      "../histogram/average": 334,
      "../histogram/bin_functions": 335,
      "../histogram/bin_label_vals": 336,
      "../histogram/calc": 337,
      "../histogram/norm_functions": 338
    }],
    340: [function (e, t, r) {
      "use strict";

      var n = e("../../lib");
      function a(e) {
        return -1 !== e.indexOf("e") ? e.replace(/[.]?0+e/, "e") : -1 !== e.indexOf(".") ? e.replace(/[.]?0+$/, "") : e;
      }
      r.formatPiePercent = function (e, t) {
        var r = a((100 * e).toPrecision(3));
        return n.numSeparate(r, t) + "%";
      }, r.formatPieValue = function (e, t) {
        var r = a(e.toPrecision(10));
        return n.numSeparate(r, t);
      }, r.getFirstFilled = function (e, t) {
        if (Array.isArray(e)) for (var r = 0; r < t.length; r++) {
          var n = e[t[r]];
          if (n || 0 === n || "" === n) return n;
        }
      }, r.castOption = function (e, t) {
        return Array.isArray(e) ? r.getFirstFilled(e, t) : e || void 0;
      }, r.getRotationAngle = function (e) {
        return ("auto" === e ? 0 : e) * Math.PI / 180;
      };
    }, {
      "../../lib": 225
    }],
    341: [function (e, t, r) {
      "use strict";

      var n = e("../../components/color"),
        a = e("./helpers").castOption;
      t.exports = function (e, t, r) {
        var i = r.marker.line,
          o = a(i.color, t.pts) || n.defaultLine,
          l = a(i.width, t.pts) || 0;
        e.style("stroke-width", l).call(n.fill, t.color).call(n.stroke, o);
      };
    }, {
      "../../components/color": 96,
      "./helpers": 340
    }],
    342: [function (e, t, r) {
      "use strict";

      var n = e("../../lib");
      t.exports = function (e, t) {
        for (var r = 0; r < e.length; r++) e[r].i = r;
        n.mergeArray(t.text, e, "tx"), n.mergeArray(t.texttemplate, e, "txt"), n.mergeArray(t.hovertext, e, "htx"), n.mergeArray(t.customdata, e, "data"), n.mergeArray(t.textposition, e, "tp"), t.textfont && (n.mergeArrayCastPositive(t.textfont.size, e, "ts"), n.mergeArray(t.textfont.color, e, "tc"), n.mergeArray(t.textfont.family, e, "tf"));
        var a = t.marker;
        if (a) {
          n.mergeArrayCastPositive(a.size, e, "ms"), n.mergeArrayCastPositive(a.opacity, e, "mo"), n.mergeArray(a.symbol, e, "mx"), n.mergeArray(a.color, e, "mc");
          var i = a.line;
          a.line && (n.mergeArray(i.color, e, "mlc"), n.mergeArrayCastPositive(i.width, e, "mlw"));
          var o = a.gradient;
          o && "none" !== o.type && (n.mergeArray(o.type, e, "mgt"), n.mergeArray(o.color, e, "mgc"));
        }
      };
    }, {
      "../../lib": 225
    }],
    343: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/cartesian/axis_format_attributes").axisHoverFormat,
        a = e("../../plots/template_attributes").texttemplateAttrs,
        i = e("../../plots/template_attributes").hovertemplateAttrs,
        o = e("../../components/colorscale/attributes"),
        l = e("../../plots/font_attributes"),
        s = e("../../components/drawing/attributes").dash,
        c = e("../../components/drawing"),
        u = e("./constants"),
        d = e("../../lib/extend").extendFlat;
      t.exports = {
        x: {
          valType: "data_array",
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        x0: {
          valType: "any",
          dflt: 0,
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        dx: {
          valType: "number",
          dflt: 1,
          editType: "calc",
          anim: !0
        },
        y: {
          valType: "data_array",
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        y0: {
          valType: "any",
          dflt: 0,
          editType: "calc+clearAxisTypes",
          anim: !0
        },
        dy: {
          valType: "number",
          dflt: 1,
          editType: "calc",
          anim: !0
        },
        xperiod: {
          valType: "any",
          dflt: 0,
          editType: "calc"
        },
        yperiod: {
          valType: "any",
          dflt: 0,
          editType: "calc"
        },
        xperiod0: {
          valType: "any",
          editType: "calc"
        },
        yperiod0: {
          valType: "any",
          editType: "calc"
        },
        xperiodalignment: {
          valType: "enumerated",
          values: ["start", "middle", "end"],
          dflt: "middle",
          editType: "calc"
        },
        yperiodalignment: {
          valType: "enumerated",
          values: ["start", "middle", "end"],
          dflt: "middle",
          editType: "calc"
        },
        xhoverformat: n("x"),
        yhoverformat: n("y"),
        stackgroup: {
          valType: "string",
          dflt: "",
          editType: "calc"
        },
        orientation: {
          valType: "enumerated",
          values: ["v", "h"],
          editType: "calc"
        },
        groupnorm: {
          valType: "enumerated",
          values: ["", "fraction", "percent"],
          dflt: "",
          editType: "calc"
        },
        stackgaps: {
          valType: "enumerated",
          values: ["infer zero", "interpolate"],
          dflt: "infer zero",
          editType: "calc"
        },
        text: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "calc"
        },
        texttemplate: a({}, {}),
        hovertext: {
          valType: "string",
          dflt: "",
          arrayOk: !0,
          editType: "style"
        },
        mode: {
          valType: "flaglist",
          flags: ["lines", "markers", "text"],
          extras: ["none"],
          editType: "calc"
        },
        hoveron: {
          valType: "flaglist",
          flags: ["points", "fills"],
          editType: "style"
        },
        hovertemplate: i({}, {
          keys: u.eventDataKeys
        }),
        line: {
          color: {
            valType: "color",
            editType: "style",
            anim: !0
          },
          width: {
            valType: "number",
            min: 0,
            dflt: 2,
            editType: "style",
            anim: !0
          },
          shape: {
            valType: "enumerated",
            values: ["linear", "spline", "hv", "vh", "hvh", "vhv"],
            dflt: "linear",
            editType: "plot"
          },
          smoothing: {
            valType: "number",
            min: 0,
            max: 1.3,
            dflt: 1,
            editType: "plot"
          },
          dash: d({}, s, {
            editType: "style"
          }),
          simplify: {
            valType: "boolean",
            dflt: !0,
            editType: "plot"
          },
          editType: "plot"
        },
        connectgaps: {
          valType: "boolean",
          dflt: !1,
          editType: "calc"
        },
        cliponaxis: {
          valType: "boolean",
          dflt: !0,
          editType: "plot"
        },
        fill: {
          valType: "enumerated",
          values: ["none", "tozeroy", "tozerox", "tonexty", "tonextx", "toself", "tonext"],
          editType: "calc"
        },
        fillcolor: {
          valType: "color",
          editType: "style",
          anim: !0
        },
        marker: d({
          symbol: {
            valType: "enumerated",
            values: c.symbolList,
            dflt: "circle",
            arrayOk: !0,
            editType: "style"
          },
          opacity: {
            valType: "number",
            min: 0,
            max: 1,
            arrayOk: !0,
            editType: "style",
            anim: !0
          },
          size: {
            valType: "number",
            min: 0,
            dflt: 6,
            arrayOk: !0,
            editType: "calc",
            anim: !0
          },
          maxdisplayed: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "plot"
          },
          sizeref: {
            valType: "number",
            dflt: 1,
            editType: "calc"
          },
          sizemin: {
            valType: "number",
            min: 0,
            dflt: 0,
            editType: "calc"
          },
          sizemode: {
            valType: "enumerated",
            values: ["diameter", "area"],
            dflt: "diameter",
            editType: "calc"
          },
          line: d({
            width: {
              valType: "number",
              min: 0,
              arrayOk: !0,
              editType: "style",
              anim: !0
            },
            editType: "calc"
          }, o("marker.line", {
            anim: !0
          })),
          gradient: {
            type: {
              valType: "enumerated",
              values: ["radial", "horizontal", "vertical", "none"],
              arrayOk: !0,
              dflt: "none",
              editType: "calc"
            },
            color: {
              valType: "color",
              arrayOk: !0,
              editType: "calc"
            },
            editType: "calc"
          },
          editType: "calc"
        }, o("marker", {
          anim: !0
        })),
        selected: {
          marker: {
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              editType: "style"
            },
            color: {
              valType: "color",
              editType: "style"
            },
            size: {
              valType: "number",
              min: 0,
              editType: "style"
            },
            editType: "style"
          },
          textfont: {
            color: {
              valType: "color",
              editType: "style"
            },
            editType: "style"
          },
          editType: "style"
        },
        unselected: {
          marker: {
            opacity: {
              valType: "number",
              min: 0,
              max: 1,
              editType: "style"
            },
            color: {
              valType: "color",
              editType: "style"
            },
            size: {
              valType: "number",
              min: 0,
              editType: "style"
            },
            editType: "style"
          },
          textfont: {
            color: {
              valType: "color",
              editType: "style"
            },
            editType: "style"
          },
          editType: "style"
        },
        textposition: {
          valType: "enumerated",
          values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right"],
          dflt: "middle center",
          arrayOk: !0,
          editType: "calc"
        },
        textfont: l({
          editType: "calc",
          colorEditType: "style",
          arrayOk: !0
        })
      };
    }, {
      "../../components/colorscale/attributes": 103,
      "../../components/drawing": 118,
      "../../components/drawing/attributes": 117,
      "../../lib/extend": 219,
      "../../plots/cartesian/axis_format_attributes": 275,
      "../../plots/font_attributes": 301,
      "../../plots/template_attributes": 308,
      "./constants": 347
    }],
    344: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric"),
        a = e("../../lib"),
        i = e("../../plots/cartesian/axes"),
        o = e("../../plots/cartesian/align_period"),
        l = e("../../constants/numerical").BADNUM,
        s = e("./subtypes"),
        c = e("./colorscale_calc"),
        u = e("./arrays_to_calcdata"),
        d = e("./calc_selection");
      function f(e, t, r, n, a, o, l) {
        var c = t._length,
          u = e._fullLayout,
          d = r._id,
          f = n._id,
          h = u._firstScatter[g(t)] === t.uid,
          p = (m(t, u, r, n) || {}).orientation,
          y = t.fill;
        r._minDtick = 0, n._minDtick = 0;
        var v = {
            padded: !0
          },
          x = {
            padded: !0
          };
        l && (v.ppad = x.ppad = l);
        var b = c < 2 || a[0] !== a[c - 1] || o[0] !== o[c - 1];
        b && ("tozerox" === y || "tonextx" === y && (h || "h" === p)) ? v.tozero = !0 : (t.error_y || {}).visible || "tonexty" !== y && "tozeroy" !== y && (s.hasMarkers(t) || s.hasText(t)) || (v.padded = !1, v.ppad = 0), b && ("tozeroy" === y || "tonexty" === y && (h || "v" === p)) ? x.tozero = !0 : "tonextx" !== y && "tozerox" !== y || (x.padded = !1), d && (t._extremes[d] = i.findExtremes(r, a, v)), f && (t._extremes[f] = i.findExtremes(n, o, x));
      }
      function h(e, t) {
        if (s.hasMarkers(e)) {
          var r,
            n = e.marker,
            o = 1.6 * (e.marker.sizeref || 1);
          if (r = "area" === e.marker.sizemode ? function (e) {
            return Math.max(Math.sqrt((e || 0) / o), 3);
          } : function (e) {
            return Math.max((e || 0) / o, 3);
          }, a.isArrayOrTypedArray(n.size)) {
            var l = {
              type: "linear"
            };
            i.setConvert(l);
            for (var c = l.makeCalcdata(e.marker, "size"), u = new Array(t), d = 0; d < t; d++) u[d] = r(c[d]);
            return u;
          }
          return r(n.size);
        }
      }
      function p(e, t) {
        var r = g(t),
          n = e._firstScatter;
        n[r] || (n[r] = t.uid);
      }
      function g(e) {
        var t = e.stackgroup;
        return e.xaxis + e.yaxis + e.type + (t ? "-" + t : "");
      }
      function m(e, t, r, n) {
        var a = e.stackgroup;
        if (a) {
          var i = t._scatterStackOpts[r._id + n._id][a],
            o = "v" === i.orientation ? n : r;
          return "linear" === o.type || "log" === o.type ? i : void 0;
        }
      }
      t.exports = {
        calc: function calc(e, t) {
          var r,
            s,
            g,
            y,
            v,
            x,
            b = e._fullLayout,
            _ = i.getFromId(e, t.xaxis || "x"),
            w = i.getFromId(e, t.yaxis || "y"),
            M = _.makeCalcdata(t, "x"),
            T = w.makeCalcdata(t, "y"),
            k = o(t, _, "x", M),
            A = o(t, w, "y", T),
            L = k.vals,
            D = A.vals,
            S = t._length,
            C = new Array(S),
            O = t.ids,
            P = m(t, b, _, w),
            I = !1;
          p(b, t);
          var z,
            R = "x",
            N = "y";
          P ? (a.pushUnique(P.traceIndices, t._expandedIndex), (r = "v" === P.orientation) ? (N = "s", z = "x") : (R = "s", z = "y"), v = "interpolate" === P.stackgaps) : f(e, t, _, w, L, D, h(t, S));
          var F = !!t.xperiodalignment,
            E = !!t.yperiodalignment;
          for (s = 0; s < S; s++) {
            var j = C[s] = {},
              H = n(L[s]),
              B = n(D[s]);
            H && B ? (j[R] = L[s], j[N] = D[s], F && (j.orig_x = M[s], j.xEnd = k.ends[s], j.xStart = k.starts[s]), E && (j.orig_y = T[s], j.yEnd = A.ends[s], j.yStart = A.starts[s])) : P && (r ? H : B) ? (j[z] = r ? L[s] : D[s], j.gap = !0, v ? (j.s = l, I = !0) : j.s = 0) : j[R] = j[N] = l, O && (j.id = String(O[s]));
          }
          if (u(C, t), c(e, t), d(C, t), P) {
            for (s = 0; s < C.length;) C[s][z] === l ? C.splice(s, 1) : s++;
            if (a.sort(C, function (e, t) {
              return e[z] - t[z] || e.i - t.i;
            }), I) {
              for (s = 0; s < C.length - 1 && C[s].gap;) s++;
              for ((x = C[s].s) || (x = C[s].s = 0), g = 0; g < s; g++) C[g].s = x;
              for (y = C.length - 1; y > s && C[y].gap;) y--;
              for (x = C[y].s, g = C.length - 1; g > y; g--) C[g].s = x;
              for (; s < y;) if (C[++s].gap) {
                for (g = s + 1; C[g].gap;) g++;
                for (var Y = C[s - 1][z], U = C[s - 1].s, V = (C[g].s - U) / (C[g][z] - Y); s < g;) C[s].s = U + (C[s][z] - Y) * V, s++;
              }
            }
          }
          return C;
        },
        calcMarkerSize: h,
        calcAxisExpansion: f,
        setFirstScatter: p,
        getStackOpts: m
      };
    }, {
      "../../constants/numerical": 205,
      "../../lib": 225,
      "../../plots/cartesian/align_period": 269,
      "../../plots/cartesian/axes": 272,
      "./arrays_to_calcdata": 342,
      "./calc_selection": 345,
      "./colorscale_calc": 346,
      "./subtypes": 368,
      "fast-isnumeric": 11
    }],
    345: [function (e, t, r) {
      "use strict";

      var n = e("../../lib");
      t.exports = function (e, t) {
        n.isArrayOrTypedArray(t.selectedpoints) && n.tagSelected(e, t);
      };
    }, {
      "../../lib": 225
    }],
    346: [function (e, t, r) {
      "use strict";

      var n = e("../../components/colorscale/helpers").hasColorscale,
        a = e("../../components/colorscale/calc"),
        i = e("./subtypes");
      t.exports = function (e, t) {
        i.hasLines(t) && n(t, "line") && a(e, t, {
          vals: t.line.color,
          containerStr: "line",
          cLetter: "c"
        }), i.hasMarkers(t) && (n(t, "marker") && a(e, t, {
          vals: t.marker.color,
          containerStr: "marker",
          cLetter: "c"
        }), n(t, "marker.line") && a(e, t, {
          vals: t.marker.line.color,
          containerStr: "marker.line",
          cLetter: "c"
        }));
      };
    }, {
      "../../components/colorscale/calc": 104,
      "../../components/colorscale/helpers": 107,
      "./subtypes": 368
    }],
    347: [function (e, t, r) {
      "use strict";

      t.exports = {
        PTS_LINESONLY: 20,
        minTolerance: .2,
        toleranceGrowth: 10,
        maxScreensAway: 20,
        eventDataKeys: []
      };
    }, {}],
    348: [function (e, t, r) {
      "use strict";

      var n = e("./calc");
      function a(e, t, r, n, a, i, o) {
        a[n] = !0;
        var l = {
          i: null,
          gap: !0,
          s: 0
        };
        if (l[o] = r, e.splice(t, 0, l), t && r === e[t - 1][o]) {
          var s = e[t - 1];
          l.s = s.s, l.i = s.i, l.gap = s.gap;
        } else i && (l.s = function (e, t, r, n) {
          var a = e[t - 1],
            i = e[t + 1];
          return i ? a ? a.s + (i.s - a.s) * (r - a[n]) / (i[n] - a[n]) : i.s : a.s;
        }(e, t, r, o));
        t || (e[0].t = e[1].t, e[0].trace = e[1].trace, delete e[1].t, delete e[1].trace);
      }
      t.exports = function (e, t) {
        var r = t.xaxis,
          i = t.yaxis,
          o = r._id + i._id,
          l = e._fullLayout._scatterStackOpts[o];
        if (l) {
          var s,
            c,
            u,
            d,
            f,
            h,
            p,
            g,
            m,
            y,
            v,
            x,
            b,
            _,
            w,
            M = e.calcdata;
          for (var T in l) {
            var k = (y = l[T]).traceIndices;
            if (k.length) {
              for (v = "interpolate" === y.stackgaps, x = y.groupnorm, "v" === y.orientation ? (b = "x", _ = "y") : (b = "y", _ = "x"), w = new Array(k.length), s = 0; s < w.length; s++) w[s] = !1;
              h = M[k[0]];
              var A = new Array(h.length);
              for (s = 0; s < h.length; s++) A[s] = h[s][b];
              for (s = 1; s < k.length; s++) {
                for (f = M[k[s]], c = u = 0; c < f.length; c++) {
                  for (p = f[c][b]; p > A[u] && u < A.length; u++) a(f, c, A[u], s, w, v, b), c++;
                  if (p !== A[u]) {
                    for (d = 0; d < s; d++) a(M[k[d]], u, p, d, w, v, b);
                    A.splice(u, 0, p);
                  }
                  u++;
                }
                for (; u < A.length; u++) a(f, c, A[u], s, w, v, b), c++;
              }
              var L = A.length;
              for (c = 0; c < h.length; c++) {
                for (g = h[c][_] = h[c].s, s = 1; s < k.length; s++) (f = M[k[s]])[0].trace._rawLength = f[0].trace._length, f[0].trace._length = L, g += f[c].s, f[c][_] = g;
                if (x) for (m = ("fraction" === x ? g : g / 100) || 1, s = 0; s < k.length; s++) {
                  var D = M[k[s]][c];
                  D[_] /= m, D.sNorm = D.s / m;
                }
              }
              for (s = 0; s < k.length; s++) {
                var S = (f = M[k[s]])[0].trace,
                  C = n.calcMarkerSize(S, S._rawLength),
                  O = Array.isArray(C);
                if (C && w[s] || O) {
                  var P = C;
                  for (C = new Array(L), c = 0; c < L; c++) C[c] = f[c].gap ? 0 : O ? P[f[c].i] : P;
                }
                var I = new Array(L),
                  z = new Array(L);
                for (c = 0; c < L; c++) I[c] = f[c].x, z[c] = f[c].y;
                n.calcAxisExpansion(e, S, r, i, I, z, C), f[0].t.orientation = y.orientation;
              }
            }
          }
        }
      };
    }, {
      "./calc": 344
    }],
    349: [function (e, t, r) {
      "use strict";

      t.exports = function (e) {
        for (var t = 0; t < e.length; t++) {
          var r = e[t];
          if ("scatter" === r.type) {
            var n = r.fill;
            if ("none" !== n && "toself" !== n && (r.opacity = void 0, "tonexty" === n || "tonextx" === n)) for (var a = t - 1; a >= 0; a--) {
              var i = e[a];
              if ("scatter" === i.type && i.xaxis === r.xaxis && i.yaxis === r.yaxis) {
                i.opacity = void 0;
                break;
              }
            }
          }
        }
      };
    }, {}],
    350: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../registry"),
        i = e("./attributes"),
        o = e("./constants"),
        l = e("./subtypes"),
        s = e("./xy_defaults"),
        c = e("./period_defaults"),
        u = e("./stack_defaults"),
        d = e("./marker_defaults"),
        f = e("./line_defaults"),
        h = e("./line_shape_defaults"),
        p = e("./text_defaults"),
        g = e("./fillcolor_defaults");
      t.exports = function (e, t, r, m) {
        function y(r, a) {
          return n.coerce(e, t, i, r, a);
        }
        var v = s(e, t, m, y);
        if (v || (t.visible = !1), t.visible) {
          c(e, t, m, y), y("xhoverformat"), y("yhoverformat");
          var x = u(e, t, m, y),
            b = !x && v < o.PTS_LINESONLY ? "lines+markers" : "lines";
          y("text"), y("hovertext"), y("mode", b), l.hasLines(t) && (f(e, t, r, m, y), h(e, t, y), y("connectgaps"), y("line.simplify")), l.hasMarkers(t) && d(e, t, r, m, y, {
            gradient: !0
          }), l.hasText(t) && (y("texttemplate"), p(e, t, m, y));
          var _ = [];
          (l.hasMarkers(t) || l.hasText(t)) && (y("cliponaxis"), y("marker.maxdisplayed"), _.push("points")), y("fill", x ? x.fillDflt : "none"), "none" !== t.fill && (g(e, t, r, y), l.hasLines(t) || h(e, t, y));
          var w = (t.line || {}).color,
            M = (t.marker || {}).color;
          "tonext" !== t.fill && "toself" !== t.fill || _.push("fills"), y("hoveron", _.join("+") || "points"), "fills" !== t.hoveron && y("hovertemplate");
          var T = a.getComponentMethod("errorbars", "supplyDefaults");
          T(e, t, w || M || r, {
            axis: "y"
          }), T(e, t, w || M || r, {
            axis: "x",
            inherit: "y"
          }), n.coerceSelectionMarkerOpacity(t, y);
        }
      };
    }, {
      "../../lib": 225,
      "../../registry": 309,
      "./attributes": 343,
      "./constants": 347,
      "./fillcolor_defaults": 351,
      "./line_defaults": 356,
      "./line_shape_defaults": 358,
      "./marker_defaults": 362,
      "./period_defaults": 363,
      "./stack_defaults": 366,
      "./subtypes": 368,
      "./text_defaults": 369,
      "./xy_defaults": 370
    }],
    351: [function (e, t, r) {
      "use strict";

      var n = e("../../components/color"),
        a = e("../../lib").isArrayOrTypedArray;
      t.exports = function (e, t, r, i) {
        var o = !1;
        if (t.marker) {
          var l = t.marker.color,
            s = (t.marker.line || {}).color;
          l && !a(l) ? o = l : s && !a(s) && (o = s);
        }
        i("fillcolor", n.addOpacity((t.line || {}).color || o || r, .5));
      };
    }, {
      "../../components/color": 96,
      "../../lib": 225
    }],
    352: [function (e, t, r) {
      "use strict";

      var n = e("../../plots/cartesian/axes");
      t.exports = function (e, t, r) {
        var a = {},
          i = {
            _fullLayout: r
          },
          o = n.getFromTrace(i, t, "x"),
          l = n.getFromTrace(i, t, "y");
        return a.xLabel = n.tickText(o, o.c2l(e.x), !0).text, a.yLabel = n.tickText(l, l.c2l(e.y), !0).text, a;
      };
    }, {
      "../../plots/cartesian/axes": 272
    }],
    353: [function (e, t, r) {
      "use strict";

      var n = e("../../components/color"),
        a = e("./subtypes");
      t.exports = function (e, t) {
        var r, i;
        if ("lines" === e.mode) return (r = e.line.color) && n.opacity(r) ? r : e.fillcolor;
        if ("none" === e.mode) return e.fill ? e.fillcolor : "";
        var o = t.mcc || (e.marker || {}).color,
          l = t.mlcc || ((e.marker || {}).line || {}).color;
        return (i = o && n.opacity(o) ? o : l && n.opacity(l) && (t.mlw || ((e.marker || {}).line || {}).width) ? l : "") ? n.opacity(i) < .3 ? n.addOpacity(i, .3) : i : (r = (e.line || {}).color) && n.opacity(r) && a.hasLines(e) && e.line.width ? r : e.fillcolor;
      };
    }, {
      "../../components/color": 96,
      "./subtypes": 368
    }],
    354: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../components/fx"),
        i = e("../../registry"),
        o = e("./get_trace_color"),
        l = e("../../components/color"),
        s = n.fillText;
      t.exports = function (e, t, r, c) {
        var u = e.cd,
          d = u[0].trace,
          f = e.xa,
          h = e.ya,
          p = f.c2p(t),
          g = h.c2p(r),
          m = [p, g],
          y = d.hoveron || "",
          v = -1 !== d.mode.indexOf("markers") ? 3 : .5,
          x = !!d.xperiodalignment,
          b = !!d.yperiodalignment;
        if (-1 !== y.indexOf("points")) {
          var _ = function _(e) {
              var t = Math.max(v, e.mrc || 0),
                r = f.c2p(e.x) - p,
                n = h.c2p(e.y) - g;
              return Math.max(Math.sqrt(r * r + n * n) - t, 1 - v / t);
            },
            w = a.getDistanceFunction(c, function (e) {
              if (x) {
                var t = f.c2p(e.xStart),
                  r = f.c2p(e.xEnd);
                return p >= Math.min(t, r) && p <= Math.max(t, r) ? 0 : 1 / 0;
              }
              var n = Math.max(3, e.mrc || 0),
                a = 1 - 1 / n,
                i = Math.abs(f.c2p(e.x) - p);
              return i < n ? a * i / n : i - n + a;
            }, function (e) {
              if (b) {
                var t = h.c2p(e.yStart),
                  r = h.c2p(e.yEnd);
                return g >= Math.min(t, r) && g <= Math.max(t, r) ? 0 : 1 / 0;
              }
              var n = Math.max(3, e.mrc || 0),
                a = 1 - 1 / n,
                i = Math.abs(h.c2p(e.y) - g);
              return i < n ? a * i / n : i - n + a;
            }, _);
          if (a.getClosest(u, w, e), !1 !== e.index) {
            var M = u[e.index],
              T = f.c2p(M.x, !0),
              k = h.c2p(M.y, !0),
              A = M.mrc || 1;
            e.index = M.i;
            var L = u[0].t.orientation,
              D = L && (M.sNorm || M.s),
              S = "h" === L ? D : void 0 !== M.orig_x ? M.orig_x : M.x,
              C = "v" === L ? D : void 0 !== M.orig_y ? M.orig_y : M.y;
            return n.extendFlat(e, {
              color: o(d, M),
              x0: T - A,
              x1: T + A,
              xLabelVal: S,
              y0: k - A,
              y1: k + A,
              yLabelVal: C,
              spikeDistance: _(M),
              hovertemplate: d.hovertemplate
            }), s(M, d, e), i.getComponentMethod("errorbars", "hoverInfo")(M, d, e), [e];
          }
        }
        if (-1 !== y.indexOf("fills") && d._polygons) {
          var O,
            P,
            I,
            z,
            R,
            N,
            F,
            E,
            j,
            H = d._polygons,
            B = [],
            Y = !1,
            U = 1 / 0,
            V = -1 / 0,
            q = 1 / 0,
            G = -1 / 0;
          for (O = 0; O < H.length; O++) (I = H[O]).contains(m) && (Y = !Y, B.push(I), q = Math.min(q, I.ymin), G = Math.max(G, I.ymax));
          if (Y) {
            var Z = ((q = Math.max(q, 0)) + (G = Math.min(G, h._length))) / 2;
            for (O = 0; O < B.length; O++) for (z = B[O].pts, P = 1; P < z.length; P++) (E = z[P - 1][1]) > Z != (j = z[P][1]) >= Z && (N = z[P - 1][0], F = z[P][0], j - E && (R = N + (F - N) * (Z - E) / (j - E), U = Math.min(U, R), V = Math.max(V, R)));
            U = Math.max(U, 0), V = Math.min(V, f._length);
            var W = l.defaultLine;
            return l.opacity(d.fillcolor) ? W = d.fillcolor : l.opacity((d.line || {}).color) && (W = d.line.color), n.extendFlat(e, {
              distance: e.maxHoverDistance,
              x0: U,
              x1: V,
              y0: Z,
              y1: Z,
              color: W,
              hovertemplate: !1
            }), delete e.index, d.text && !Array.isArray(d.text) ? e.text = String(d.text) : e.text = d.name, [e];
          }
        }
      };
    }, {
      "../../components/color": 96,
      "../../components/fx": 136,
      "../../lib": 225,
      "../../registry": 309,
      "./get_trace_color": 353
    }],
    355: [function (e, t, r) {
      "use strict";

      var n = e("./subtypes");
      t.exports = {
        hasLines: n.hasLines,
        hasMarkers: n.hasMarkers,
        hasText: n.hasText,
        isBubble: n.isBubble,
        attributes: e("./attributes"),
        supplyDefaults: e("./defaults"),
        crossTraceDefaults: e("./cross_trace_defaults"),
        calc: e("./calc").calc,
        crossTraceCalc: e("./cross_trace_calc"),
        arraysToCalcdata: e("./arrays_to_calcdata"),
        plot: e("./plot"),
        colorbar: e("./marker_colorbar"),
        formatLabels: e("./format_labels"),
        style: e("./style").style,
        styleOnSelect: e("./style").styleOnSelect,
        hoverPoints: e("./hover"),
        selectPoints: e("./select"),
        animatable: !0,
        moduleType: "trace",
        name: "scatter",
        basePlotModule: e("../../plots/cartesian"),
        categories: ["cartesian", "svg", "symbols", "errorBarsOK", "showLegend", "scatter-like", "zoomScale"],
        meta: {}
      };
    }, {
      "../../plots/cartesian": 286,
      "./arrays_to_calcdata": 342,
      "./attributes": 343,
      "./calc": 344,
      "./cross_trace_calc": 348,
      "./cross_trace_defaults": 349,
      "./defaults": 350,
      "./format_labels": 352,
      "./hover": 354,
      "./marker_colorbar": 361,
      "./plot": 364,
      "./select": 365,
      "./style": 367,
      "./subtypes": 368
    }],
    356: [function (e, t, r) {
      "use strict";

      var n = e("../../lib").isArrayOrTypedArray,
        a = e("../../components/colorscale/helpers").hasColorscale,
        i = e("../../components/colorscale/defaults");
      t.exports = function (e, t, r, o, l, s) {
        var c = (e.marker || {}).color;
        (l("line.color", r), a(e, "line")) ? i(e, t, o, l, {
          prefix: "line.",
          cLetter: "c"
        }) : l("line.color", !n(c) && c || r);
        l("line.width"), (s || {}).noDash || l("line.dash");
      };
    }, {
      "../../components/colorscale/defaults": 106,
      "../../components/colorscale/helpers": 107,
      "../../lib": 225
    }],
    357: [function (e, t, r) {
      "use strict";

      var n = e("../../constants/numerical"),
        a = n.BADNUM,
        i = n.LOG_CLIP,
        o = i + .5,
        l = i - .5,
        s = e("../../lib"),
        c = s.segmentsIntersect,
        u = s.constrain,
        d = e("./constants");
      t.exports = function (e, t) {
        var r,
          n,
          i,
          f,
          h,
          p,
          g,
          m,
          y,
          v,
          x,
          b,
          _,
          w,
          M,
          T,
          k,
          A,
          L = t.xaxis,
          D = t.yaxis,
          S = "log" === L.type,
          C = "log" === D.type,
          O = L._length,
          P = D._length,
          I = t.connectGaps,
          z = t.baseTolerance,
          R = t.shape,
          N = "linear" === R,
          F = t.fill && "none" !== t.fill,
          E = [],
          j = d.minTolerance,
          H = e.length,
          B = new Array(H),
          Y = 0;
        function U(r) {
          var n = e[r];
          if (!n) return !1;
          var i = t.linearized ? L.l2p(n.x) : L.c2p(n.x),
            s = t.linearized ? D.l2p(n.y) : D.c2p(n.y);
          if (i === a) {
            if (S && (i = L.c2p(n.x, !0)), i === a) return !1;
            C && s === a && (i *= Math.abs(L._m * P * (L._m > 0 ? o : l) / (D._m * O * (D._m > 0 ? o : l)))), i *= 1e3;
          }
          if (s === a) {
            if (C && (s = D.c2p(n.y, !0)), s === a) return !1;
            s *= 1e3;
          }
          return [i, s];
        }
        function V(e, t, r, n) {
          var a = r - e,
            i = n - t,
            o = .5 - e,
            l = .5 - t,
            s = a * a + i * i,
            c = a * o + i * l;
          if (c > 0 && c < s) {
            var u = o * i - l * a;
            if (u * u < s) return !0;
          }
        }
        function q(e, t) {
          var r = e[0] / O,
            n = e[1] / P,
            a = Math.max(0, -r, r - 1, -n, n - 1);
          return a && void 0 !== k && V(r, n, k, A) && (a = 0), a && t && V(r, n, t[0] / O, t[1] / P) && (a = 0), (1 + d.toleranceGrowth * a) * z;
        }
        function G(e, t) {
          var r = e[0] - t[0],
            n = e[1] - t[1];
          return Math.sqrt(r * r + n * n);
        }
        var Z,
          W,
          J,
          X,
          Q,
          K,
          $,
          ee = d.maxScreensAway,
          te = -O * ee,
          re = O * (1 + ee),
          ne = -P * ee,
          ae = P * (1 + ee),
          ie = [[te, ne, re, ne], [re, ne, re, ae], [re, ae, te, ae], [te, ae, te, ne]];
        function oe(e) {
          if (e[0] < te || e[0] > re || e[1] < ne || e[1] > ae) return [u(e[0], te, re), u(e[1], ne, ae)];
        }
        function le(e, t) {
          return e[0] === t[0] && (e[0] === te || e[0] === re) || e[1] === t[1] && (e[1] === ne || e[1] === ae) || void 0;
        }
        function se(e, t, r) {
          return function (n, a) {
            var i = oe(n),
              o = oe(a),
              l = [];
            if (i && o && le(i, o)) return l;
            i && l.push(i), o && l.push(o);
            var c = 2 * s.constrain((n[e] + a[e]) / 2, t, r) - ((i || n)[e] + (o || a)[e]);
            c && ((i && o ? c > 0 == i[e] > o[e] ? i : o : i || o)[e] += c);
            return l;
          };
        }
        function ce(e) {
          var t = e[0],
            r = e[1],
            n = t === B[Y - 1][0],
            a = r === B[Y - 1][1];
          if (!n || !a) if (Y > 1) {
            var i = t === B[Y - 2][0],
              o = r === B[Y - 2][1];
            n && (t === te || t === re) && i ? o ? Y-- : B[Y - 1] = e : a && (r === ne || r === ae) && o ? i ? Y-- : B[Y - 1] = e : B[Y++] = e;
          } else B[Y++] = e;
        }
        function ue(e) {
          B[Y - 1][0] !== e[0] && B[Y - 1][1] !== e[1] && ce([J, X]), ce(e), Q = null, J = X = 0;
        }
        function de(e) {
          if (k = e[0] / O, A = e[1] / P, Z = e[0] < te ? te : e[0] > re ? re : 0, W = e[1] < ne ? ne : e[1] > ae ? ae : 0, Z || W) {
            if (Y) {
              if (Q) {
                var t = $(Q, e);
                t.length > 1 && (ue(t[0]), B[Y++] = t[1]);
              } else K = $(B[Y - 1], e)[0], B[Y++] = K;
            } else B[Y++] = [Z || e[0], W || e[1]];
            var r = B[Y - 1];
            Z && W && (r[0] !== Z || r[1] !== W) ? (Q && (J !== Z && X !== W ? ce(J && X ? (n = Q, i = (a = e)[0] - n[0], o = (a[1] - n[1]) / i, (n[1] * a[0] - a[1] * n[0]) / i > 0 ? [o > 0 ? te : re, ae] : [o > 0 ? re : te, ne]) : [J || Z, X || W]) : J && X && ce([J, X])), ce([Z, W])) : J - Z && X - W && ce([Z || J, W || X]), Q = e, J = Z, X = W;
          } else Q && ue($(Q, e)[0]), B[Y++] = e;
          var n, a, i, o;
        }
        for ("linear" === R || "spline" === R ? $ = function $(e, t) {
          for (var r = [], n = 0, a = 0; a < 4; a++) {
            var i = ie[a],
              o = c(e[0], e[1], t[0], t[1], i[0], i[1], i[2], i[3]);
            o && (!n || Math.abs(o.x - r[0][0]) > 1 || Math.abs(o.y - r[0][1]) > 1) && (o = [o.x, o.y], n && G(o, e) < G(r[0], e) ? r.unshift(o) : r.push(o), n++);
          }
          return r;
        } : "hv" === R || "vh" === R ? $ = function $(e, t) {
          var r = [],
            n = oe(e),
            a = oe(t);
          return n && a && le(n, a) || (n && r.push(n), a && r.push(a)), r;
        } : "hvh" === R ? $ = se(0, te, re) : "vhv" === R && ($ = se(1, ne, ae)), r = 0; r < H; r++) if (n = U(r)) {
          for (Y = 0, Q = null, de(n), r++; r < H; r++) {
            if (!(f = U(r))) {
              if (I) continue;
              break;
            }
            if (N && t.simplify) {
              var fe = U(r + 1);
              if (v = G(f, n), F && (0 === Y || Y === H - 1) || !(v < q(f, fe) * j)) {
                for (m = [(f[0] - n[0]) / v, (f[1] - n[1]) / v], h = n, x = v, b = w = M = 0, g = !1, i = f, r++; r < e.length; r++) {
                  if (p = fe, fe = U(r + 1), !p) {
                    if (I) continue;
                    break;
                  }
                  if (T = (y = [p[0] - n[0], p[1] - n[1]])[0] * m[1] - y[1] * m[0], w = Math.min(w, T), (M = Math.max(M, T)) - w > q(p, fe)) break;
                  i = p, (_ = y[0] * m[0] + y[1] * m[1]) > x ? (x = _, f = p, g = !1) : _ < b && (b = _, h = p, g = !0);
                }
                if (g ? (de(f), i !== h && de(h)) : (h !== n && de(h), i !== f && de(f)), de(i), r >= e.length || !p) break;
                de(p), n = p;
              }
            } else de(f);
          }
          Q && ce([J || Q[0], X || Q[1]]), E.push(B.slice(0, Y));
        }
        return E;
      };
    }, {
      "../../constants/numerical": 205,
      "../../lib": 225,
      "./constants": 347
    }],
    358: [function (e, t, r) {
      "use strict";

      t.exports = function (e, t, r) {
        "spline" === r("line.shape") && r("line.smoothing");
      };
    }, {}],
    359: [function (e, t, r) {
      "use strict";

      var n = {
        tonextx: 1,
        tonexty: 1,
        tonext: 1
      };
      t.exports = function (e, t, r) {
        var a,
          i,
          o,
          l,
          s,
          c = {},
          u = !1,
          d = -1,
          f = 0,
          h = -1;
        for (i = 0; i < r.length; i++) (o = (a = r[i][0].trace).stackgroup || "") ? o in c ? s = c[o] : (s = c[o] = f, f++) : a.fill in n && h >= 0 ? s = h : (s = h = f, f++), s < d && (u = !0), a._groupIndex = d = s;
        var p = r.slice();
        u && p.sort(function (e, t) {
          var r = e[0].trace,
            n = t[0].trace;
          return r._groupIndex - n._groupIndex || r.index - n.index;
        });
        var g = {};
        for (i = 0; i < p.length; i++) o = (a = p[i][0].trace).stackgroup || "", !0 === a.visible ? (a._nexttrace = null, a.fill in n && (l = g[o], a._prevtrace = l || null, l && (l._nexttrace = a)), a._ownfill = a.fill && ("tozero" === a.fill.substr(0, 6) || "toself" === a.fill || "to" === a.fill.substr(0, 2) && !a._prevtrace), g[o] = a) : a._prevtrace = a._nexttrace = a._ownfill = null;
        return p;
      };
    }, {}],
    360: [function (e, t, r) {
      "use strict";

      var n = e("fast-isnumeric");
      t.exports = function (e, t) {
        t || (t = 2);
        var r = e.marker,
          a = r.sizeref || 1,
          i = r.sizemin || 0,
          o = "area" === r.sizemode ? function (e) {
            return Math.sqrt(e / a);
          } : function (e) {
            return e / a;
          };
        return function (e) {
          var r = o(e / t);
          return n(r) && r > 0 ? Math.max(r, i) : 0;
        };
      };
    }, {
      "fast-isnumeric": 11
    }],
    361: [function (e, t, r) {
      "use strict";

      t.exports = {
        container: "marker",
        min: "cmin",
        max: "cmax"
      };
    }, {}],
    362: [function (e, t, r) {
      "use strict";

      var n = e("../../components/color"),
        a = e("../../components/colorscale/helpers").hasColorscale,
        i = e("../../components/colorscale/defaults"),
        o = e("./subtypes");
      t.exports = function (e, t, r, l, s, c) {
        var u = o.isBubble(e),
          d = (e.line || {}).color;
        (c = c || {}, d && (r = d), s("marker.symbol"), s("marker.opacity", u ? .7 : 1), s("marker.size"), s("marker.color", r), a(e, "marker") && i(e, t, l, s, {
          prefix: "marker.",
          cLetter: "c"
        }), c.noSelect || (s("selected.marker.color"), s("unselected.marker.color"), s("selected.marker.size"), s("unselected.marker.size")), c.noLine || (s("marker.line.color", d && !Array.isArray(d) && t.marker.color !== d ? d : u ? n.background : n.defaultLine), a(e, "marker.line") && i(e, t, l, s, {
          prefix: "marker.line.",
          cLetter: "c"
        }), s("marker.line.width", u ? 1 : 0)), u && (s("marker.sizeref"), s("marker.sizemin"), s("marker.sizemode")), c.gradient) && "none" !== s("marker.gradient.type") && s("marker.gradient.color");
      };
    }, {
      "../../components/color": 96,
      "../../components/colorscale/defaults": 106,
      "../../components/colorscale/helpers": 107,
      "./subtypes": 368
    }],
    363: [function (e, t, r) {
      "use strict";

      var n = e("../../lib").dateTick0,
        a = e("../../constants/numerical").ONEWEEK;
      function i(e, t) {
        return n(t, e % a == 0 ? 1 : 0);
      }
      t.exports = function (e, t, r, n, a) {
        if (a || (a = {
          x: !0,
          y: !0
        }), a.x) {
          var o = n("xperiod");
          o && (n("xperiod0", i(o, t.xcalendar)), n("xperiodalignment"));
        }
        if (a.y) {
          var l = n("yperiod");
          l && (n("yperiod0", i(l, t.ycalendar)), n("yperiodalignment"));
        }
      };
    }, {
      "../../constants/numerical": 205,
      "../../lib": 225
    }],
    364: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../registry"),
        i = e("../../lib"),
        o = i.ensureSingle,
        l = i.identity,
        s = e("../../components/drawing"),
        c = e("./subtypes"),
        u = e("./line_points"),
        d = e("./link_traces"),
        f = e("../../lib/polygon").tester;
      function h(e, t, r, d, h, p, g) {
        var m;
        !function (e, t, r, a, o) {
          var l = r.xaxis,
            s = r.yaxis,
            u = n.extent(i.simpleMap(l.range, l.r2c)),
            d = n.extent(i.simpleMap(s.range, s.r2c)),
            f = a[0].trace;
          if (!c.hasMarkers(f)) return;
          var h = f.marker.maxdisplayed;
          if (0 === h) return;
          var p = a.filter(function (e) {
              return e.x >= u[0] && e.x <= u[1] && e.y >= d[0] && e.y <= d[1];
            }),
            g = Math.ceil(p.length / h),
            m = 0;
          o.forEach(function (e, r) {
            var n = e[0].trace;
            c.hasMarkers(n) && n.marker.maxdisplayed > 0 && r < t && m++;
          });
          var y = Math.round(m * g / 3 + Math.floor(m / 3) * g / 7.1);
          a.forEach(function (e) {
            delete e.vis;
          }), p.forEach(function (e, t) {
            0 === Math.round((t + y) % g) && (e.vis = !0);
          });
        }(0, t, r, d, h);
        var y = !!g && g.duration > 0;
        function v(e) {
          return y ? e.transition() : e;
        }
        var x = r.xaxis,
          b = r.yaxis,
          _ = d[0].trace,
          w = _.line,
          M = n.select(p),
          T = o(M, "g", "errorbars"),
          k = o(M, "g", "lines"),
          A = o(M, "g", "points"),
          L = o(M, "g", "text");
        if (a.getComponentMethod("errorbars", "plot")(e, T, r, g), !0 === _.visible) {
          var D, S;
          v(M).style("opacity", _.opacity);
          var C = _.fill.charAt(_.fill.length - 1);
          "x" !== C && "y" !== C && (C = ""), d[0][r.isRangePlot ? "nodeRangePlot3" : "node3"] = M;
          var O,
            P,
            I = "",
            z = [],
            R = _._prevtrace;
          R && (I = R._prevRevpath || "", S = R._nextFill, z = R._polygons);
          var N,
            F,
            E,
            j,
            H,
            B,
            Y,
            U = "",
            V = "",
            q = [],
            G = i.noop;
          if (D = _._ownFill, c.hasLines(_) || "none" !== _.fill) {
            for (S && S.datum(d), -1 !== ["hv", "vh", "hvh", "vhv"].indexOf(w.shape) ? (N = s.steps(w.shape), F = s.steps(w.shape.split("").reverse().join(""))) : N = F = "spline" === w.shape ? function (e) {
              var t = e[e.length - 1];
              return e.length > 1 && e[0][0] === t[0] && e[0][1] === t[1] ? s.smoothclosed(e.slice(1), w.smoothing) : s.smoothopen(e, w.smoothing);
            } : function (e) {
              return "M" + e.join("L");
            }, E = function E(e) {
              return F(e.reverse());
            }, q = u(d, {
              xaxis: x,
              yaxis: b,
              connectGaps: _.connectgaps,
              baseTolerance: Math.max(w.width || 1, 3) / 4,
              shape: w.shape,
              simplify: w.simplify,
              fill: _.fill
            }), Y = _._polygons = new Array(q.length), m = 0; m < q.length; m++) _._polygons[m] = f(q[m]);
            q.length && (j = q[0][0], B = (H = q[q.length - 1])[H.length - 1]), G = function G(e) {
              return function (t) {
                if (O = N(t), P = E(t), U ? C ? (U += "L" + O.substr(1), V = P + "L" + V.substr(1)) : (U += "Z" + O, V = P + "Z" + V) : (U = O, V = P), c.hasLines(_) && t.length > 1) {
                  var r = n.select(this);
                  if (r.datum(d), e) v(r.style("opacity", 0).attr("d", O).call(s.lineGroupStyle)).style("opacity", 1);else {
                    var a = v(r);
                    a.attr("d", O), s.singleLineStyle(d, a);
                  }
                }
              };
            };
          }
          var Z = k.selectAll(".js-line").data(q);
          v(Z.exit()).style("opacity", 0).remove(), Z.each(G(!1)), Z.enter().append("path").classed("js-line", !0).style("vector-effect", "non-scaling-stroke").call(s.lineGroupStyle).each(G(!0)), s.setClipUrl(Z, r.layerClipId, e), q.length ? (D ? (D.datum(d), j && B && (C ? ("y" === C ? j[1] = B[1] = b.c2p(0, !0) : "x" === C && (j[0] = B[0] = x.c2p(0, !0)), v(D).attr("d", "M" + B + "L" + j + "L" + U.substr(1)).call(s.singleFillStyle)) : v(D).attr("d", U + "Z").call(s.singleFillStyle))) : S && ("tonext" === _.fill.substr(0, 6) && U && I ? ("tonext" === _.fill ? v(S).attr("d", U + "Z" + I + "Z").call(s.singleFillStyle) : v(S).attr("d", U + "L" + I.substr(1) + "Z").call(s.singleFillStyle), _._polygons = _._polygons.concat(z)) : (J(S), _._polygons = null)), _._prevRevpath = V, _._prevPolygons = Y) : (D ? J(D) : S && J(S), _._polygons = _._prevRevpath = _._prevPolygons = null), A.datum(d), L.datum(d), function (t, a, i) {
            var o,
              u = i[0].trace,
              d = c.hasMarkers(u),
              f = c.hasText(u),
              h = ee(u),
              p = te,
              g = te;
            if (d || f) {
              var m = l,
                _ = u.stackgroup,
                w = _ && "infer zero" === e._fullLayout._scatterStackOpts[x._id + b._id][_].stackgaps;
              u.marker.maxdisplayed || u._needsCull ? m = w ? Q : X : _ && !w && (m = K), d && (p = m), f && (g = m);
            }
            var M,
              T = (o = t.selectAll("path.point").data(p, h)).enter().append("path").classed("point", !0);
            y && T.call(s.pointStyle, u, e).call(s.translatePoints, x, b).style("opacity", 0).transition().style("opacity", 1), o.order(), d && (M = s.makePointStyleFns(u)), o.each(function (t) {
              var a = n.select(this),
                i = v(a);
              s.translatePoint(t, i, x, b) ? (s.singlePointStyle(t, i, u, M, e), r.layerClipId && s.hideOutsideRangePoint(t, i, x, b, u.xcalendar, u.ycalendar), u.customdata && a.classed("plotly-customdata", null !== t.data && void 0 !== t.data)) : i.remove();
            }), y ? o.exit().transition().style("opacity", 0).remove() : o.exit().remove(), (o = a.selectAll("g").data(g, h)).enter().append("g").classed("textpoint", !0).append("text"), o.order(), o.each(function (e) {
              var t = n.select(this),
                a = v(t.select("text"));
              s.translatePoint(e, a, x, b) ? r.layerClipId && s.hideOutsideRangePoint(e, t, x, b, u.xcalendar, u.ycalendar) : t.remove();
            }), o.selectAll("text").call(s.textPointStyle, u, e).each(function (e) {
              var t = x.c2p(e.x),
                r = b.c2p(e.y);
              n.select(this).selectAll("tspan.line").each(function () {
                v(n.select(this)).attr({
                  x: t,
                  y: r
                });
              });
            }), o.exit().remove();
          }(A, L, d);
          var W = !1 === _.cliponaxis ? null : r.layerClipId;
          s.setClipUrl(A, W, e), s.setClipUrl(L, W, e);
        }
        function J(e) {
          v(e).attr("d", "M0,0Z");
        }
        function X(e) {
          return e.filter(function (e) {
            return !e.gap && e.vis;
          });
        }
        function Q(e) {
          return e.filter(function (e) {
            return e.vis;
          });
        }
        function K(e) {
          return e.filter(function (e) {
            return !e.gap;
          });
        }
        function $(e) {
          return e.id;
        }
        function ee(e) {
          if (e.ids) return $;
        }
        function te() {
          return !1;
        }
      }
      t.exports = function (e, t, r, a, i, c) {
        var u,
          f,
          p = !i,
          g = !!i && i.duration > 0,
          m = d(e, t, r);
        ((u = a.selectAll("g.trace").data(m, function (e) {
          return e[0].trace.uid;
        })).enter().append("g").attr("class", function (e) {
          return "trace scatter trace" + e[0].trace.uid;
        }).style("stroke-miterlimit", 2), u.order(), function (e, t, r) {
          t.each(function (t) {
            var a = o(n.select(this), "g", "fills");
            s.setClipUrl(a, r.layerClipId, e);
            var i = t[0].trace,
              c = [];
            i._ownfill && c.push("_ownFill"), i._nexttrace && c.push("_nextFill");
            var u = a.selectAll("g").data(c, l);
            u.enter().append("g"), u.exit().each(function (e) {
              i[e] = null;
            }).remove(), u.order().each(function (e) {
              i[e] = o(n.select(this), "path", "js-fill");
            });
          });
        }(e, u, t), g) ? (c && (f = c()), n.transition().duration(i.duration).ease(i.easing).each("end", function () {
          f && f();
        }).each("interrupt", function () {
          f && f();
        }).each(function () {
          a.selectAll("g.trace").each(function (r, n) {
            h(e, n, t, r, m, this, i);
          });
        })) : u.each(function (r, n) {
          h(e, n, t, r, m, this, i);
        });
        p && u.exit().remove(), a.selectAll("path:not([d])").remove();
      };
    }, {
      "../../components/drawing": 118,
      "../../lib": 225,
      "../../lib/polygon": 237,
      "../../registry": 309,
      "./line_points": 357,
      "./link_traces": 359,
      "./subtypes": 368,
      "@plotly/d3": 6
    }],
    365: [function (e, t, r) {
      "use strict";

      var n = e("./subtypes");
      t.exports = function (e, t) {
        var r,
          a,
          i,
          o,
          l = e.cd,
          s = e.xaxis,
          c = e.yaxis,
          u = [],
          d = l[0].trace;
        if (!n.hasMarkers(d) && !n.hasText(d)) return [];
        if (!1 === t) for (r = 0; r < l.length; r++) l[r].selected = 0;else for (r = 0; r < l.length; r++) a = l[r], i = s.c2p(a.x), o = c.c2p(a.y), null !== a.i && t.contains([i, o], !1, r, e) ? (u.push({
          pointNumber: a.i,
          x: s.c2d(a.x),
          y: c.c2d(a.y)
        }), a.selected = 1) : a.selected = 0;
        return u;
      };
    }, {
      "./subtypes": 368
    }],
    366: [function (e, t, r) {
      "use strict";

      var n = ["orientation", "groupnorm", "stackgaps"];
      t.exports = function (e, t, r, a) {
        var i = r._scatterStackOpts,
          o = a("stackgroup");
        if (o) {
          var l = t.xaxis + t.yaxis,
            s = i[l];
          s || (s = i[l] = {});
          var c = s[o],
            u = !1;
          c ? c.traces.push(t) : (c = s[o] = {
            traceIndices: [],
            traces: [t]
          }, u = !0);
          for (var d = {
              orientation: t.x && !t.y ? "h" : "v"
            }, f = 0; f < n.length; f++) {
            var h = n[f],
              p = h + "Found";
            if (!c[p]) {
              var g = void 0 !== e[h],
                m = "orientation" === h;
              if ((g || u) && (c[h] = a(h, d[h]), m && (c.fillDflt = "h" === c[h] ? "tonextx" : "tonexty"), g && (c[p] = !0, !u && (delete c.traces[0][h], m)))) for (var y = 0; y < c.traces.length - 1; y++) {
                var v = c.traces[y];
                v._input.fill !== v.fill && (v.fill = c.fillDflt);
              }
            }
          }
          return c;
        }
      };
    }, {}],
    367: [function (e, t, r) {
      "use strict";

      var n = e("@plotly/d3"),
        a = e("../../components/drawing"),
        i = e("../../registry");
      function o(e, t, r) {
        a.pointStyle(e.selectAll("path.point"), t, r);
      }
      function l(e, t, r) {
        a.textPointStyle(e.selectAll("text"), t, r);
      }
      t.exports = {
        style: function style(e) {
          var t = n.select(e).selectAll("g.trace.scatter");
          t.style("opacity", function (e) {
            return e[0].trace.opacity;
          }), t.selectAll("g.points").each(function (t) {
            o(n.select(this), t.trace || t[0].trace, e);
          }), t.selectAll("g.text").each(function (t) {
            l(n.select(this), t.trace || t[0].trace, e);
          }), t.selectAll("g.trace path.js-line").call(a.lineGroupStyle), t.selectAll("g.trace path.js-fill").call(a.fillGroupStyle), i.getComponentMethod("errorbars", "style")(t);
        },
        stylePoints: o,
        styleText: l,
        styleOnSelect: function styleOnSelect(e, t, r) {
          var n = t[0].trace;
          n.selectedpoints ? (a.selectedPointStyle(r.selectAll("path.point"), n), a.selectedTextStyle(r.selectAll("text"), n)) : (o(r, n, e), l(r, n, e));
        }
      };
    }, {
      "../../components/drawing": 118,
      "../../registry": 309,
      "@plotly/d3": 6
    }],
    368: [function (e, t, r) {
      "use strict";

      var n = e("../../lib");
      t.exports = {
        hasLines: function hasLines(e) {
          return e.visible && e.mode && -1 !== e.mode.indexOf("lines");
        },
        hasMarkers: function hasMarkers(e) {
          return e.visible && (e.mode && -1 !== e.mode.indexOf("markers") || "splom" === e.type);
        },
        hasText: function hasText(e) {
          return e.visible && e.mode && -1 !== e.mode.indexOf("text");
        },
        isBubble: function isBubble(e) {
          return n.isPlainObject(e.marker) && n.isArrayOrTypedArray(e.marker.size);
        }
      };
    }, {
      "../../lib": 225
    }],
    369: [function (e, t, r) {
      "use strict";

      var n = e("../../lib");
      t.exports = function (e, t, r, a, i) {
        i = i || {}, a("textposition"), n.coerceFont(a, "textfont", r.font), i.noSelect || (a("selected.textfont.color"), a("unselected.textfont.color"));
      };
    }, {
      "../../lib": 225
    }],
    370: [function (e, t, r) {
      "use strict";

      var n = e("../../lib"),
        a = e("../../registry");
      t.exports = function (e, t, r, i) {
        var o,
          l = i("x"),
          s = i("y");
        if (a.getComponentMethod("calendars", "handleTraceDefaults")(e, t, ["x", "y"], r), l) {
          var c = n.minRowLength(l);
          s ? o = Math.min(c, n.minRowLength(s)) : (o = c, i("y0"), i("dy"));
        } else {
          if (!s) return 0;
          o = n.minRowLength(s), i("x0"), i("dx");
        }
        return t._length = o, o;
      };
    }, {
      "../../lib": 225,
      "../../registry": 309
    }],
    371: [function (e, t, r) {
      "use strict";

      r.version = "2.5.1";
    }, {}]
  }, {}, [5])(5);
});